/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import { Util } from '@finley-technologies/finley-types'
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  FullDateStr: Util.FullDateStr;
  FullDateTimeStr: Util.FullDateTimeStr;
  JSDate: number;
  JSON: any;
  LuxonDate: number;
  Object: any;
  Primitive: any;
  SqlPrimitive: any;
  UUID: string;
  WebhookEventType: string;
};

export type AbstractAttributeValueGQLType = {
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
};

export type AccountActivityMetadataGQLType = {
  __typename?: 'AccountActivityMetadata';
  minDate: Scalars['FullDateStr'];
  maxDate: Scalars['FullDateStr'];
  accountTypes: Array<TAccountTypeGQLType>;
  accountTotals: Array<TAccountTotalAmountsGQLType>;
  totalCurrentLiabilities: Scalars['Float'];
};

export type AccountDetailsGQLType = {
  __typename?: 'AccountDetails';
  creditFacilityId: Scalars['String'];
  organizationId: Scalars['String'];
  tAccount: TAccountTypeGQLType;
  id: Scalars['String'];
};

export type AccountTypeGQLType =
  | 'capitalProviderFundingAccount'
  | 'collections'
  | 'otherReserveAccount'
  | 'parentOperatingAccount'
  | 'preFundingAccount'
  | 'permittedInvestmentsAccount'
  | 'accountIncludedInBorrowingBase';

export type AccountingAccountGQLType = {
  __typename?: 'AccountingAccount';
  tAccount: TAccountTypeGQLType;
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  organization: OrganizationGQLType;
};

export type AccountingAdjustmentResponseGQLType = {
  __typename?: 'AccountingAdjustmentResponse';
  success: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type AccruedInterestAndFeesAnnualAmountsGQLType = {
  __typename?: 'AccruedInterestAndFeesAnnualAmounts';
  year: Scalars['Int'];
  amount: Scalars['Float'];
};

export type AccruedInterestAndFeesSummaryGQLType = {
  __typename?: 'AccruedInterestAndFeesSummary';
  totalAmount: Scalars['Float'];
  annualAmounts: Array<Maybe<AccruedInterestAndFeesAnnualAmountsGQLType>>;
};

export type AcknowledgementDataGQLType = {
  __typename?: 'AcknowledgementData';
  acknowledgementId: Scalars['String'];
  acknowledgedOn: Scalars['JSDate'];
  acknowledgedBy: Scalars['String'];
  acknowledgedFor?: Maybe<Scalars['FullDateStr']>;
};

export type ActionParamVariableTypeGQLType =
  | 'string'
  | 'number'
  | 'stringArray';

export type ActorGQLType = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  actorType: ActorTypeGQLType;
};

export type ActorTypeGQLType =
  | 'apiKey'
  | 'finleyAutomated'
  | 'unknownActor'
  | 'user';

export type AdjustCurrentLiabilityTypesGQLType =
  | 'increaseCurrentLiability'
  | 'decreaseCurrentLiability';

export type AggregateBorrowingRiskInsightsGqlDataGQLType = {
  __typename?: 'AggregateBorrowingRiskInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  totalPerformingExposure: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  totalCollectionsAccountCash: Scalars['Float'];
  currentPrincipalBalance: Scalars['Float'];
  collateralCovenantLtv: Scalars['Float'];
  netOutstandingLtv: Scalars['Float'];
  performingLtv: Scalars['Float'];
  creditFacilityData: Array<CreditFacilityBorrowingRiskInsightsGqlDataGQLType>;
};

export type AggregatePrincipalInsightsGqlDataGQLType = {
  __typename?: 'AggregatePrincipalInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  currentPrincipalBalance: Scalars['Float'];
  commitmentAmount: Scalars['Float'];
  totalFacilityUtilization: Scalars['Float'];
  creditFacilityData: Array<CreditFacilityPrincipalInsightsGqlDataGQLType>;
};

export type AggregateReceivableExposureInsightsGqlDataGQLType = {
  __typename?: 'AggregateReceivableExposureInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  totalExposure: Scalars['Float'];
  totalPerformingExposure: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  totalReceivableBorrowingBase: Scalars['Float'];
  creditFacilityData: Array<CreditFacilityReceivableExposureInsightsGqlDataGQLType>;
};

export type AggregateReceivableRiskInsightsGqlDataGQLType = {
  __typename?: 'AggregateReceivableRiskInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  totalExposure: Scalars['Float'];
  totalNormalizedIsChargedOffExposure: Scalars['Float'];
  totalNormalizedIsDelinquentExposure: Scalars['Float'];
  chargedOffPercentageOfTotalExposure: Scalars['Float'];
  delinquentPercentageOfTotalExposure: Scalars['Float'];
  creditFacilityData: Array<CreditFacilityReceivableRiskInsightsGqlDataGQLType>;
};

export type AggregatedLimitedPartnerCommitmentDataGQLType = {
  __typename?: 'AggregatedLimitedPartnerCommitmentData';
  limitedPartnerName: Scalars['String'];
  limitedPartnerId: Scalars['UUID'];
  commitmentCount: Scalars['Int'];
  totalCommittedCapital: Scalars['Float'];
  percentageOfPortfolioCommittedCapital: Scalars['Float'];
  totalRecallableCapital: Scalars['Float'];
  totalUncalledCapital: Scalars['Float'];
  percentageOfPortfolioUncalledCapital: Scalars['Float'];
  eligibleUncalledCapital: Scalars['Float'];
  eligibleUncalledCapitalLessKickouts: Scalars['Float'];
  advanceRate: Scalars['Float'];
  netUncalledCapital: Scalars['Float'];
  percentageOfPortfolioNetUncalledCapital: Scalars['Float'];
};

export type ApiKeyWithOrganizationGQLType = ActorGQLType & {
  __typename?: 'ApiKeyWithOrganization';
  actorType: ActorTypeGQLType;
  id: Scalars['UUID'];
  key: Scalars['String'];
  secret: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  isActive: Scalars['Boolean'];
  userId?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  organizationSlug: Scalars['String'];
  name: Scalars['String'];
};

export type ArtifactInstanceDownloadObjectGQLType = {
  __typename?: 'ArtifactInstanceDownloadObject';
  object: Scalars['Object'];
  filename: Scalars['String'];
};

export type ArtifactInstanceDownloadUrlGQLType = {
  __typename?: 'ArtifactInstanceDownloadUrl';
  signedUrl: Scalars['String'];
  filename: Scalars['String'];
};

export type ArtifactInstanceInitiatorDetailsGQLType = {
  __typename?: 'ArtifactInstanceInitiatorDetails';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organizationName: Scalars['String'];
};

export type ArtifactInstanceRawRecordStatusGQLType =
  | 'success'
  | 'error'
  | 'initialized';

export type ArtifactInstanceStatusGQLType =
  | 'inProgress'
  | 'success'
  | 'error';

export type ArtifactTypeGQLType =
  | 'monthlyServicerReportXlsx'
  | 'monthlyStatement'
  | 'loanTape'
  | 'repaymentTape'
  | 'cashBalancesFeed'
  | 'portfolioCovenant'
  | 'financialCovenant'
  | 'orgProvidedInput'
  | 'supplementalTape'
  | 'financialStatement';

export type AssignedReceivableGQLType = {
  __typename?: 'AssignedReceivable';
  id: Scalars['String'];
  externalReceivableId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  loanProductId: Scalars['String'];
  creditFacilityId: Scalars['String'];
  creditFacility: CreditFacilityGQLType;
};

export type AssignmentBorrowingBaseReportGQLType = {
  __typename?: 'AssignmentBorrowingBaseReport';
  creditFacilityId: Scalars['String'];
  totalExposure: Scalars['Float'];
  totalBorrowingBaseAmount: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  effectiveReceivableAdvanceRate: Scalars['Float'];
  balanceSheetExposure: Scalars['Float'];
  concentrationLimitCalculations?: Maybe<Array<CreditAgreementConfigConcentrationLimitCalculationGQLType>>;
  eligibilityCriteriaCalculations?: Maybe<Array<CreditAgreementConfigEligibilityCriteriaCalculationGQLType>>;
};

export type AssignmentConfirmationJobGQLType = {
  __typename?: 'AssignmentConfirmationJob';
  id: Scalars['UUID'];
  implementationId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  status: AssignmentConfirmationJobStatusGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  completedAt?: Maybe<Scalars['JSDate']>;
  payloadS3Path: Scalars['String'];
  errorLogS3Path?: Maybe<Scalars['String']>;
  initiatedByUserId?: Maybe<Scalars['String']>;
  strategyName?: Maybe<Scalars['String']>;
  previewJobId?: Maybe<Scalars['String']>;
  jobType: AssignmentConfirmationJobTypeGQLType;
};

export type AssignmentConfirmationJobStatusGQLType =
  | 'inProgress'
  | 'success'
  | 'error';

export type AssignmentConfirmationJobTypeGQLType =
  | 'assignment'
  | 'repurchase'
  | 'transfer';

export type AssignmentExclusionGQLType =
  | 'none'
  | 'soft'
  | 'hard';

export type AssignmentFieldsGQLType = {
  __typename?: 'AssignmentFields';
  assignedAt: Scalars['String'];
  creditFacilityId: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};

export type AssignmentJobsGQLType = {
  __typename?: 'AssignmentJobs';
  previewJobs: Array<AssignmentPreviewJobGQLType>;
  latestConfirmationJob?: Maybe<AssignmentConfirmationJobGQLType>;
};

export type AssignmentMethodGQLType =
  | 'strategy'
  | 'csv'
  | 'assignNone';

export type AssignmentPipelineMetadataGQLType = {
  __typename?: 'AssignmentPipelineMetadata';
  status: AssignmentPipelineStatusEnumGQLType;
  implementationId: Scalars['String'];
  masterLoanTapeIds: Array<Scalars['String']>;
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};

export type AssignmentPipelineStatusEnumGQLType =
  | 'inProgress'
  | 'incomplete'
  | 'error'
  | 'success'
  | 'assigned'
  | 'noPipelineRun';

export type AssignmentPreviewJobGQLType = {
  __typename?: 'AssignmentPreviewJob';
  id: Scalars['UUID'];
  implementationId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  previewIdentifier?: Maybe<Scalars['String']>;
  assignmentMethod: AssignmentMethodGQLType;
  strategyId?: Maybe<Scalars['String']>;
  status: AssignmentPreviewJobStatusGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  completedAt?: Maybe<Scalars['JSDate']>;
  totalProposedExposure?: Maybe<Scalars['Float']>;
  newlyProposedExposure?: Maybe<Scalars['Float']>;
  proposedBorrowingBaseFromReceivables?: Maybe<Scalars['Float']>;
  balanceSheetExposure?: Maybe<Scalars['Float']>;
  s3Path?: Maybe<Scalars['String']>;
  initiatedByUserIdentifier: Scalars['String'];
  strategyName?: Maybe<Scalars['String']>;
};

export type AssignmentPreviewJobStatusGQLType =
  | 'inProgress'
  | 'completed'
  | 'error';

export type AssignmentReceivableGQLType = {
  __typename?: 'AssignmentReceivable';
  finleyReceivableId: Scalars['String'];
  externalReceivableId: Scalars['String'];
  baseFields: Array<BaseFieldGQLType>;
  dynamicIntermediateFields: Array<DynamicIntermediateFieldsForCreditFacilityGQLType>;
  requiredIntermediateFields: Array<RequiredIntermediateFieldsForCreditFacilityGQLType>;
  postProcessedFields: Array<PostProcessedFieldsForCreditFacilityGQLType>;
  loanProductId: Scalars['String'];
  isAssignable: Scalars['Boolean'];
  leaveUnassigned?: Maybe<Scalars['Boolean']>;
  assignableCreditFacilityIds: Array<Scalars['String']>;
  receivableResponseTapeProperties?: Maybe<ReceivableResponseTapePropertiesGQLType>;
};

export type AssignmentReceivablesAggregateTotalsGQLType = {
  __typename?: 'AssignmentReceivablesAggregateTotals';
  count: Scalars['Float'];
  exposure: Scalars['Float'];
};

export type AssignmentReceivablesAggregateTotalsByStatusGQLType = {
  __typename?: 'AssignmentReceivablesAggregateTotalsByStatus';
  proposed: AssignmentReceivablesAggregateTotalsGQLType;
  unassigned: AssignmentReceivablesAggregateTotalsGQLType;
  previouslyAssigned: AssignmentReceivablesAggregateTotalsGQLType;
};

export type AssignmentReceivablesAggregateTotalsByStatusWithMetadataGQLType = {
  __typename?: 'AssignmentReceivablesAggregateTotalsByStatusWithMetadata';
  assignmentReceivablesAggregateTotalsByStatus: AssignmentReceivablesAggregateTotalsByStatusGQLType;
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  previewIdentifier: Scalars['String'];
  borrowingBaseReports: Array<AssignmentBorrowingBaseReportGQLType>;
};

export type AssignmentReceivablesWithMetadataGQLType = {
  __typename?: 'AssignmentReceivablesWithMetadata';
  assignmentReceivables: Scalars['String'];
  borrowingBaseReports: Array<AssignmentBorrowingBaseReportGQLType>;
};

export type AssignmentServicerReportPreviewInputGQLType = {
  previewIdentifier: Scalars['String'];
  creditFacilityId: Scalars['UUID'];
  receivableResponseTapePreviewId?: Maybe<Scalars['UUID']>;
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  servicerReportPreviewType: ServicerReportPreviewTypeGQLType;
  cashReserveAmount?: Maybe<Scalars['Float']>;
  borrowingBaseReserveAmount?: Maybe<Scalars['Float']>;
  noUpload?: Maybe<Scalars['Boolean']>;
};

export type AssignmentServicerReportPreviewInputV1GQLType = {
  creditFacilityId: Scalars['String'];
  receivableResponseTapePreviewId?: Maybe<Scalars['String']>;
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  servicerReportPreviewType: ServicerReportPreviewTypeGQLType;
  cashReserveAmount?: Maybe<Scalars['Float']>;
  borrowingBaseReserveAmount?: Maybe<Scalars['Float']>;
  loanProductId?: Maybe<Scalars['String']>;
  extendedResponseTapePreview?: Maybe<Scalars['String']>;
  proposedExtendedResponseTapePreview?: Maybe<Scalars['String']>;
  noUpload?: Maybe<Scalars['Boolean']>;
};

export type AssignmentStrategiesByImplementationGQLType = {
  __typename?: 'AssignmentStrategiesByImplementation';
  implementationId: Scalars['String'];
  assignmentStrategies: Array<AssignmentStrategyGQLType>;
};

export type AssignmentStrategyGQLType = {
  __typename?: 'AssignmentStrategy';
  id: Scalars['String'];
  name: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  default: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  createdByUserId: Scalars['String'];
  updatedByUserId: Scalars['String'];
  implementationId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  createdByEmail: Scalars['String'];
  updatedByEmail: Scalars['String'];
  loanProductCriteria: Array<LoanProductCriteriaGQLType>;
  eligibilityExclusions: Array<EligibilityExclusionGQLType>;
  decisionHeuristic: Scalars['String'];
};

export type AssignmentSummaryGQLType = {
  __typename?: 'AssignmentSummary';
  initial: Scalars['String'];
  proposed: Scalars['String'];
};

export type AthenaQueryRecordGQLType = {
  __typename?: 'AthenaQueryRecord';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  parameterizedQuery: Scalars['Object'];
  isDeprecated: Scalars['Boolean'];
  organizationId: Scalars['String'];
};

export type AthenaQueryResponseGQLType = {
  __typename?: 'AthenaQueryResponse';
  Items: Array<Scalars['Object']>;
  NextToken?: Maybe<Scalars['String']>;
  QueryExecutionId: Scalars['String'];
};

export type AthenaRecurringQueryResponseGQLType = {
  __typename?: 'AthenaRecurringQueryResponse';
  items: Array<Scalars['Object']>;
  errors: Array<Scalars['String']>;
};

export type AthenaTableGQLType = {
  __typename?: 'AthenaTable';
  tableName: Scalars['String'];
  properties: Array<AthenaTablePropertyGQLType>;
};

export type AthenaTablePropertyGQLType = {
  __typename?: 'AthenaTableProperty';
  name: Scalars['String'];
  type: AthenaTablePropertyTypeGQLType;
};

export type AthenaTablePropertyTypeGQLType =
  | 'boolean'
  | 'tinyint'
  | 'smallint'
  | 'int'
  | 'integer'
  | 'bigint'
  | 'double'
  | 'float'
  | 'decimal'
  | 'char'
  | 'varchar'
  | 'string'
  | 'binary'
  | 'date'
  | 'timestamp'
  | 'array'
  | 'map'
  | 'struct';

export type AttributeGQLType = {
  __typename?: 'Attribute';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  type: AttributeTypeGQLType;
  validation: AttributeValidationGQLType;
  ownerOrganizationId: Scalars['UUID'];
  /** @deprecated Use attributeValues instead */
  attributeValue?: Maybe<AttributeValueGQLType>;
  attributeValues: Array<AttributeValueGQLType>;
};

export type AttributeEntityDomainGQLType =
  | 'creditFacility'
  | 'limitedPartner';

export type AttributeFloatDisplayInputGQLType = {
  displayType: AttributeValueFloatDisplayTypeGQLType;
  currencyCode: CurrencyGQLType;
};

export type AttributeInputValueGQLType = {
  attributeId: Scalars['UUID'];
  serializedValue: Scalars['String'];
};

export type AttributeListWithAttributeIdsGQLType = {
  __typename?: 'AttributeListWithAttributeIds';
  listName: Scalars['String'];
  attributeIds: Array<Scalars['UUID']>;
};

export type AttributeTypeGQLType =
  | 'string'
  | 'float'
  | 'integer'
  | 'boolean'
  | 'percentageRate'
  | 'fullDateStr'
  | 'stringArray';

export type AttributeValidationGQLType = {
  __typename?: 'AttributeValidation';
  type: AttributeTypeGQLType;
  allowedValues?: Maybe<Array<Scalars['String']>>;
  display?: Maybe<AttributeValueFloatDisplayGQLType>;
};

export type AttributeValidationInputGQLType = {
  type: AttributeTypeGQLType;
  allowedValues?: Maybe<Array<Scalars['String']>>;
  display?: Maybe<AttributeFloatDisplayInputGQLType>;
};

export type AttributeValueGQLType = StringAttributeValueGQLType | FloatAttributeValueGQLType | IntegerAttributeValueGQLType | BooleanAttributeValueGQLType | PercentageRateAttributeValueGQLType | FullDateStrAttributeValueGQLType | StringArrayAttributeValueGQLType;

export type AttributeValueBooleanValidationGQLType = {
  __typename?: 'AttributeValueBooleanValidation';
  type: AttributeTypeGQLType;
};

export type AttributeValueCurrencyDisplayGQLType = {
  __typename?: 'AttributeValueCurrencyDisplay';
  displayType: AttributeValueFloatDisplayTypeGQLType;
  currencyCode: CurrencyGQLType;
};

export type AttributeValueEntityDomainGQLType =
  | 'creditFacility';

export type AttributeValueFloatDisplayGQLType = AttributeValueCurrencyDisplayGQLType;

export type AttributeValueFloatDisplayTypeGQLType =
  | 'currency';

export type AttributeValueFloatValidationGQLType = {
  __typename?: 'AttributeValueFloatValidation';
  type: AttributeTypeGQLType;
  display?: Maybe<AttributeValueFloatDisplayGQLType>;
};

export type AttributeValueFullDateStrValidationGQLType = {
  __typename?: 'AttributeValueFullDateStrValidation';
  type: AttributeTypeGQLType;
};

export type AttributeValueInputGQLType = {
  type: AttributeTypeGQLType;
  stringValue?: Maybe<Scalars['String']>;
  intValue?: Maybe<Scalars['Int']>;
  floatValue?: Maybe<Scalars['Float']>;
  percentageRateValue?: Maybe<Scalars['Float']>;
  boolValue?: Maybe<Scalars['Boolean']>;
  fullDateStrValue?: Maybe<Scalars['String']>;
  stringArrayValue?: Maybe<Array<Scalars['String']>>;
};

export type AttributeValueIntegerValidationGQLType = {
  __typename?: 'AttributeValueIntegerValidation';
  type: AttributeTypeGQLType;
};

export type AttributeValuePercentageRateValidationGQLType = {
  __typename?: 'AttributeValuePercentageRateValidation';
  type: AttributeTypeGQLType;
};

export type AttributeValueStringArrayValidationGQLType = {
  __typename?: 'AttributeValueStringArrayValidation';
  type: AttributeTypeGQLType;
  allowedValues?: Maybe<Array<Scalars['String']>>;
};

export type AttributeValueStringValidationGQLType = {
  __typename?: 'AttributeValueStringValidation';
  type: AttributeTypeGQLType;
  allowedValues?: Maybe<Array<Scalars['String']>>;
};

export type AuthGQLType = {
  __typename?: 'Auth';
  id?: Maybe<Scalars['UUID']>;
  email?: Maybe<Scalars['String']>;
  userType?: Maybe<UserTypeGQLType>;
  token?: Maybe<Scalars['String']>;
};

export type BalanceSheetImpactCalculationsDataGQLType = {
  __typename?: 'BalanceSheetImpactCalculationsData';
  totalBalanceSheetExposure: Scalars['Float'];
  loanProductCalculations: Array<LoanProductCalculationGQLType>;
};

export type BankAccountCashBalanceGQLType = {
  __typename?: 'BankAccountCashBalance';
  bankAccountId: Scalars['String'];
  balance: Scalars['Float'];
  accountType: Scalars['String'];
  cashAdvanceRate?: Maybe<Scalars['Float']>;
  /** @deprecated use currencyCode instead */
  currency?: Maybe<CurrencyGQLType>;
  currencyCode: CurrencyGQLType;
  conversionRate: Scalars['Float'];
};

export type BankAccountDefaultValuesGQLType = {
  __typename?: 'BankAccountDefaultValues';
  organizationId: Scalars['String'];
  accountType: AccountTypeGQLType;
  accountName: Scalars['String'];
  tellerAccountId?: Maybe<Scalars['String']>;
  plaidAccountId?: Maybe<Scalars['String']>;
};

export type BankAccountWithInstitutionAndDesignationGQLType = {
  __typename?: 'BankAccountWithInstitutionAndDesignation';
  accountNumber: Scalars['String'];
  currencyCode: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
  institutionName: Scalars['String'];
  bankInstitutionKey: Scalars['String'];
  routingNumber: Scalars['String'];
  accountType: AccountTypeGQLType;
  creditFacilityId: Scalars['String'];
  organizationId: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type BankAccountWithInstitutionAndOwnerGQLType = {
  __typename?: 'BankAccountWithInstitutionAndOwner';
  id: Scalars['UUID'];
  accountNumber: Scalars['String'];
  currencyCode: Scalars['String'];
  name: Scalars['String'];
  bankInstitutionId: Scalars['String'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
  retrievedAt?: Maybe<Scalars['JSDate']>;
  current?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
  conversionRate: Scalars['Float'];
  routingNumber: Scalars['String'];
  institutionName: Scalars['String'];
  bankInstitutionKey: Scalars['String'];
  organizationId: Scalars['String'];
  ownerType: OrganizationTypeEnumGQLType;
  ownerName: Scalars['String'];
  connectionProviderName?: Maybe<Scalars['String']>;
  connectionProviderAccountMask?: Maybe<Scalars['String']>;
};

export type BankAccountWithInstitutionDesignationAndOwnerGQLType = {
  __typename?: 'BankAccountWithInstitutionDesignationAndOwner';
  id: Scalars['UUID'];
  accountNumber: Scalars['String'];
  currencyCode: Scalars['String'];
  name: Scalars['String'];
  bankInstitutionId: Scalars['String'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
  retrievedAt?: Maybe<Scalars['JSDate']>;
  current?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
  conversionRate: Scalars['Float'];
  routingNumber: Scalars['String'];
  institutionName: Scalars['String'];
  bankInstitutionKey: Scalars['String'];
  organizationId: Scalars['String'];
  ownerType: OrganizationTypeEnumGQLType;
  accountType: AccountTypeGQLType;
  creditFacilityId: Scalars['String'];
  ownerName: Scalars['String'];
  connectionProviderName?: Maybe<Scalars['String']>;
  connectionProviderAccountMask?: Maybe<Scalars['String']>;
};

export type BankDataProviderInstitutionGQLType = {
  __typename?: 'BankDataProviderInstitution';
  bankInstitutionId: Scalars['String'];
  name: Scalars['String'];
  bankInstitutionKey: Scalars['String'];
  dataProvider: BankDataProviderKeyGQLType;
  dataProviderInstitutionId: Scalars['String'];
  itemId: Scalars['String'];
  institutionUrl?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  needsUpdate: Scalars['Boolean'];
  externalItemId: Scalars['String'];
  bankAccounts: Array<BankDataProviderInstitutionAccountGQLType>;
};

export type BankDataProviderInstitutionAccountGQLType = {
  __typename?: 'BankDataProviderInstitutionAccount';
  dataProviderAccountId: Scalars['String'];
  bankInstitutionId: Scalars['String'];
  name: Scalars['String'];
  mask?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  retrievedAt: Scalars['JSDate'];
};

export type BankDataProviderKeyGQLType =
  | 'plaid'
  | 'teller'
  | 'manualDashboard'
  | 'manualS3Upload';

export type BankInstitutionGQLType = {
  __typename?: 'BankInstitution';
  id?: Maybe<Scalars['UUID']>;
  tellerInstitutionId?: Maybe<Scalars['String']>;
  plaidInstitutionId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  institutionUrl?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  bankInstitutionKey: Scalars['String'];
};

export type BaseFieldGQLType = {
  __typename?: 'BaseField';
  key: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
};

export type BaseFieldsTemplateGQLType =
  | 'incomeStatement'
  | 'balanceSheet';

export type BaseOrganizationGQLType = {
  __typename?: 'BaseOrganization';
  id: Scalars['UUID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type BaseReportTemplateGQLType = ReportTemplateGQLType & {
  __typename?: 'BaseReportTemplate';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['String'];
  templateName: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  reportType: ReportTemplateReportTypeGQLType;
  s3Path: Scalars['String'];
  baseOutputFilename: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type BaseThreadV2GQLType = {
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentV2GQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<ThreadLatestActionLogV2GQLType>;
};

export type BatchSettlementGQLType = {
  __typename?: 'BatchSettlement';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  capitalProviderId: Scalars['UUID'];
  capitalProviderName: Scalars['String'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  report?: Maybe<BatchSettlementReportGQLType>;
  loans: Array<LoanNameAndExternalIdGQLType>;
  created_at: Scalars['JSDate'];
};

export type BatchSettlementReportGQLType = {
  __typename?: 'BatchSettlementReport';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportType: DownloadableReportTypeGQLType;
  reportName: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  isPreview: Scalars['Boolean'];
  batchSettlementId: Scalars['UUID'];
};

export type BatchSettlementSubmissionResultGQLType = {
  __typename?: 'BatchSettlementSubmissionResult';
  batchSettlementId: Scalars['UUID'];
  workleaseId?: Maybe<Scalars['UUID']>;
};

export type BooleanAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'BooleanAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Scalars['Boolean']>;
  validation: AttributeValueBooleanValidationGQLType;
};

export type BorrowerAccountTypeGQLType =
  | 'collections'
  | 'otherReserveAccount'
  | 'parentOperatingAccount'
  | 'preFundingAccount'
  | 'permittedInvestmentsAccount';

export type BorrowerEntityGQLType = {
  __typename?: 'BorrowerEntity';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type BorrowingBaseFieldsGQLType = {
  __typename?: 'BorrowingBaseFields';
  borrowingBaseAmount: Scalars['Float'];
  advanceRate: Scalars['Float'];
};

export type BorrowingBaseMechanicsForLoanProductGQLType = {
  __typename?: 'BorrowingBaseMechanicsForLoanProduct';
  loanProductId: Scalars['String'];
  loanProductName: Scalars['String'];
  implementationId: Scalars['String'];
  creditFacilityId: Scalars['String'];
  baseFields: Scalars['String'];
  intermediateFields: Scalars['String'];
  eligibilityCriteria: Array<EligibilityCriteriaGQLType>;
};

export type BorrowingBasePipelineArtifactDocumentGQLType = {
  __typename?: 'BorrowingBasePipelineArtifactDocument';
  id: Scalars['String'];
  version: Scalars['Int'];
  isWip?: Maybe<Scalars['Boolean']>;
};

export type BorrowingBasePipelineArtifactDocumentInfoGQLType = {
  __typename?: 'BorrowingBasePipelineArtifactDocumentInfo';
  artifactDocumentVersion: Scalars['Int'];
  artifactDocumentId: Scalars['UUID'];
  artifactsDocumentString: Scalars['String'];
};

export type BorrowingBasePipelineArtifactInstanceGQLType = {
  __typename?: 'BorrowingBasePipelineArtifactInstance';
  id: Scalars['UUID'];
  artifactId: Scalars['UUID'];
  status: BorrowingBasePipelineInstanceStatusEnumGQLType;
  initiatorDetails?: Maybe<ArtifactInstanceInitiatorDetailsGQLType>;
  updated_at: Scalars['JSDate'];
  instanceRecordString: Scalars['String'];
  downloads: Array<UrlAndFilenameGQLType>;
  jsonRecords: Array<Scalars['String']>;
};

export type BorrowingBasePipelineArtifactsGQLType = {
  __typename?: 'BorrowingBasePipelineArtifacts';
  borrowerId: Scalars['UUID'];
  artifactsDocumentString: Scalars['String'];
  artifactDocumentId?: Maybe<Scalars['String']>;
  creditAgreementsUpdateNeeded: Scalars['Boolean'];
};

export type BorrowingBasePipelineInstanceStatusEnumGQLType =
  | 'initializing'
  | 'inProgress'
  | 'error'
  | 'success';

export type BorrowingBasePipelineProgressBreakdownGQLType = {
  __typename?: 'BorrowingBasePipelineProgressBreakdown';
  isRunning: Scalars['Boolean'];
  status: VerificationPipelineStatusGQLType;
  uploadProgressBreakdown: Array<BorrowingBasePipelineSingleProgressBreakdownGQLType>;
  progressBreakdown: Array<BorrowingBasePipelineSingleProgressBreakdownGQLType>;
  servicerReportDownload?: Maybe<UrlAndFilenameGQLType>;
  extendedResponseTapeDownloads?: Maybe<Array<DownloadWithLoanProductGQLType>>;
  initiatorDetails?: Maybe<ArtifactInstanceInitiatorDetailsGQLType>;
};

export type BorrowingBasePipelineSingleProgressBreakdownGQLType = {
  __typename?: 'BorrowingBasePipelineSingleProgressBreakdown';
  stepDescription: Scalars['String'];
  status: StepStatusGQLType;
};

export type BorrowingBasePipelineStatusGQLType = {
  __typename?: 'BorrowingBasePipelineStatus';
  borrowerId: Scalars['UUID'];
  latestArtifactDocumentVersion?: Maybe<Scalars['Int']>;
  latestArtifactDocumentId?: Maybe<Scalars['UUID']>;
  wipNeedsCommit: Scalars['Boolean'];
  creditAgreementsNeedLink: Scalars['Boolean'];
  artifactDocumentWipId: Scalars['UUID'];
};

export type BorrowingBaseReportGQLType = {
  __typename?: 'BorrowingBaseReport';
  assetValuation: Scalars['Float'];
  effectiveReceivableValuationRate: Scalars['Float'];
  borrowerId: Scalars['ID'];
  cashAdvanceRate: Scalars['Float'];
  creditFacilitySlug: Scalars['String'];
  creditAgreementVersion: Scalars['String'];
  creditFacilityId: Scalars['String'];
  creditAgreementId: Scalars['UUID'];
  fileVersion: Scalars['Float'];
  id: Scalars['UUID'];
  borrowingBaseAmountAssets: Scalars['Float'];
  totalCash: Scalars['Float'];
  isBorrowingBaseReservePositiveExcessCollectionsOverReserve: Scalars['Boolean'];
  totalBorrowingBaseAmount: Scalars['Float'];
  borrowingBaseReserveAmount?: Maybe<Scalars['Float']>;
  maxReceivableAdvanceAmount: Scalars['Float'];
  maxCashAdvanceAmount: Scalars['Float'];
  commitmentAmount: Scalars['Float'];
  currentPrincipalBalance: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
  totalEligibleExposure: Scalars['Float'];
  totalReceivableExposure: Scalars['Float'];
  totalEligibilityKickout: Scalars['Float'];
  totalConcentrationKickout: Scalars['Float'];
  totalFacilityUtilization?: Maybe<Scalars['Float']>;
  totalMaxAdvanceAmount: Scalars['Float'];
  borrowingBaseUtilization: Scalars['Float'];
  weightedAverageReceivableAdvanceRate: Scalars['Float'];
  totalEligibleBorrowingBaseAccountCash: Scalars['Float'];
  totalAssets: Scalars['Float'];
  effectiveAdvanceRate: Scalars['Float'];
  effectiveReceivableAdvanceRate: Scalars['Float'];
  totalCollectionsAccountCash?: Maybe<Scalars['Float']>;
  totalPreAdvanceCashContribution?: Maybe<Scalars['Float']>;
  totalCashBorrowingBaseAmount?: Maybe<Scalars['Float']>;
  effectiveCashAdvanceRate?: Maybe<Scalars['Float']>;
  maximumAvailableAmount?: Maybe<Scalars['Float']>;
  borrowingBaseAvailability?: Maybe<Scalars['Float']>;
  borrowingBaseAvailabilityRate?: Maybe<Scalars['Float']>;
  assignedEligibleExposureSinceLastApprovedFundingRequest?: Maybe<Scalars['Float']>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  concentrationLimitCalculations?: Maybe<Array<ConcentrationLimitCalculationGQLType>>;
  eligibilityCriteriaCalculations?: Maybe<Array<EligibilityCriteriaCalculationGQLType>>;
  bankAccountCashBalances?: Maybe<Array<BankAccountCashBalanceGQLType>>;
  loanProductCalculations?: Maybe<Array<BorrowingBaseReportLoanProductCalculationGQLType>>;
};

export type BorrowingBaseReportLoanProductCalculationGQLType = {
  __typename?: 'BorrowingBaseReportLoanProductCalculation';
  id: Scalars['UUID'];
  borrowingBaseReportId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  totalReceivableExposure: Scalars['Float'];
  totalEligibilityKickout: Scalars['Float'];
  totalEligibleExposure: Scalars['Float'];
  totalConcentrationKickout: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  weightedAverageReceivableAdvanceRate: Scalars['Float'];
  totalReceivableBorrowingBaseAmount: Scalars['Float'];
  effectiveReceivableAdvanceRate: Scalars['Float'];
  effectiveReceivableValuationRate: Scalars['Float'];
};

export type BorrowingBaseReportMetadataGQLType = {
  __typename?: 'BorrowingBaseReportMetadata';
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};

export type BorrowingBaseTestTypeGQLType =
  | 'eligibility'
  | 'concentration';

export type CdqResultItemGQLType = {
  __typename?: 'CDQResultItem';
  finleyReceivableId: Scalars['UUID'];
  currentReportingDate: Scalars['FullDateStr'];
  previousReportingDate: Scalars['FullDateStr'];
  /** @deprecated use acknowledgementData instead */
  acknowledgementId?: Maybe<Scalars['String']>;
  acknowledgementData?: Maybe<AcknowledgementDataGQLType>;
  otherFields: Scalars['String'];
};

export type CalculatedLoanStatusGQLType =
  | 'pending'
  | 'canceled'
  | 'initiated'
  | 'funded'
  | 'overdue'
  | 'pendingEdit'
  | 'overriddenFromEdit'
  | 'canceledEdit';

export type CapitalProviderAccountTypeGQLType =
  | 'capitalProviderFundingAccount';

export type CashBalanceArtifactTypeGQLType =
  | 'rawCashBalanceFeed';

export type CashBalancePreferenceEnumGQLType =
  | 'current'
  | 'available';

export type CashBalancesFeedConfigGQLType = {
  __typename?: 'CashBalancesFeedConfig';
  artifactType: ArtifactTypeGQLType;
};

export type CategorySpecificPropertiesGQLType = FundingRequestTaskSpecificPropertiesGQLType | InvoiceTaskSpecificPropertiesGQLType | ConsolidatedDisbursementTaskPropertiesGQLType | LenderSharesTaskSpecificPropertiesGQLType;

export type CloneEntityInputGQLType = {
  sourceSlug: Scalars['String'];
  makeNew: Scalars['Boolean'];
  targetSlug: Scalars['String'];
  targetName?: Maybe<Scalars['String']>;
};

export type CloneParametersInputGQLType = {
  sourceId: Scalars['UUID'];
  targetName: Scalars['String'];
  owner: CloneEntityInputGQLType;
  loanProducts: Array<CloneEntityInputGQLType>;
  creditFacilities: Array<CloneEntityInputGQLType>;
  borrowers: Array<CloneEntityInputGQLType>;
  lenders: Array<CloneEntityInputGQLType>;
};

export type ColumnConfigurationGQLType = {
  __typename?: 'ColumnConfiguration';
  columnKey: Scalars['String'];
  isVisible: Scalars['Boolean'];
  isFixed: Scalars['Boolean'];
};

export type ColumnConfigurationInputGQLType = {
  columnKey: Scalars['String'];
  isVisible: Scalars['Boolean'];
  isFixed: Scalars['Boolean'];
};

export type ColumnInfoGQLType = {
  __typename?: 'ColumnInfo';
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: Scalars['String'];
  description: Scalars['String'];
  examples: Array<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  sheetName?: Maybe<Scalars['String']>;
  cellAddress?: Maybe<Scalars['String']>;
};

export type CommentGQLType = {
  __typename?: 'Comment';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  comment: Scalars['String'];
  author: ThreadActorGQLType;
};

export type CommentV2GQLType = {
  __typename?: 'CommentV2';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  comment: Scalars['String'];
  author: EventLogActorGQLType;
};

export type CommitWipToSandboxResponseGQLType = {
  __typename?: 'CommitWipToSandboxResponse';
  errors: Array<Scalars['String']>;
};

export type CompleteFinalOutputDeliverableArtifactInstanceResultGQLType = {
  __typename?: 'CompleteFinalOutputDeliverableArtifactInstanceResult';
  instance: DeliverableArtifactInstanceGQLType;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ComplianceReportCfScopedGQLType = {
  __typename?: 'ComplianceReportCfScoped';
  id: Scalars['UUID'];
  creditAgreementId?: Maybe<Scalars['UUID']>;
  creditFacilityId: Scalars['UUID'];
  reportName: Scalars['String'];
  reportType: ComplianceReportCfTypeGQLType;
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  isPreview: Scalars['Boolean'];
  database?: Maybe<DatabaseGQLType>;
  namespace?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  entityRecords: ReportingEntityRecordsMapGQLType;
};

export type ComplianceReportCfTypeGQLType =
  | 'monthlyServicerReport';

export type ConcentrationLimitAggregateInsightsGqlDataGQLType = {
  __typename?: 'ConcentrationLimitAggregateInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  totalConcentrationLimitKickout: Scalars['Float'];
  concentrationLimitsData: Array<ConcentrationLimitInsightsGqlDataGQLType>;
};

export type ConcentrationLimitCalculationGQLType = {
  __typename?: 'ConcentrationLimitCalculation';
  id: Scalars['UUID'];
  borrowingBaseReportId: Scalars['UUID'];
  concentrationLimitKey: Scalars['String'];
  concentrationLimit: Scalars['Float'];
  concentrationAmount?: Maybe<Scalars['Float']>;
  totalEligibleExposure: Scalars['Float'];
  concentration: Scalars['Float'];
  borrowingBaseReduction: Scalars['Float'];
  complianceStatus: Scalars['String'];
  created_at: Scalars['JSDate'];
};

export type ConcentrationLimitFieldsGQLType = {
  __typename?: 'ConcentrationLimitFields';
  eligibleExposureLessConcentrationLimitKickouts: Scalars['Float'];
};

export type ConcentrationLimitInsightsGqlDataGQLType = {
  __typename?: 'ConcentrationLimitInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  propertyKey: Scalars['String'];
  valueType: ConcentrationLimitValueTypeGQLType;
  concentrationAmount?: Maybe<Scalars['Float']>;
  concentrationLimit: Scalars['Float'];
  concentration: Scalars['Float'];
  totalConcentrationLimitKickout: Scalars['Float'];
};

export type ConcentrationLimitReasonGQLType = {
  __typename?: 'ConcentrationLimitReason';
  propertyKey: Scalars['String'];
  concentrationLimitKickout: Scalars['Float'];
};

export type ConcentrationLimitValueTypeGQLType =
  | 'currency'
  | 'number'
  | 'percentage';

export type ConcentrationLimitWaiverGQLType = {
  __typename?: 'ConcentrationLimitWaiver';
  propertyKey: Scalars['String'];
  waiveReason: Scalars['String'];
};

export type ConfigStoreEntityTypeGQLType =
  | 'organization'
  | 'creditFacility'
  | 'implementation';

export type ConfigTypeGQLType = {
  __typename?: 'ConfigType';
  entityType: ConfigStoreEntityTypeGQLType;
  configType: Scalars['String'];
};

export type ConfiguredCdqGQLType = {
  __typename?: 'ConfiguredCDQ';
  id: Scalars['UUID'];
  name: Scalars['String'];
  decodedQuery: Scalars['String'];
};

export type ConsolidatedDisbursementTaskPropertiesGQLType = {
  __typename?: 'ConsolidatedDisbursementTaskProperties';
  category: TaskCategoryGQLType;
  consolidatedDisbursementId: Scalars['UUID'];
  invoiceLoanIds: Array<Scalars['UUID']>;
};

export type ContainerPeriodGQLType =
  | 'calendarDay'
  | 'calendarWeek'
  | 'calendarMonth'
  | 'calendarQuarter'
  | 'calendarYear';

export type ContainerTypeGQLType =
  | 'settlementReport'
  | 'borrowingBaseCertificate'
  | 'complianceCertificate'
  | 'financials'
  | 'budgetsAndProjections'
  | 'other';

export type CoreBorrowingBaseInsightsGqlDataGQLType = {
  __typename?: 'CoreBorrowingBaseInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  totalReceivableExposure: Scalars['Float'];
  totalEligibleExposure: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  totalReceivableBorrowingBaseAmount: Scalars['Float'];
  effectiveReceivableAdvanceRate: Scalars['Float'];
  totalEligibleBorrowingBaseAccountCash: Scalars['Float'];
  totalCollectionsAccountCash: Scalars['Float'];
  totalPreAdvanceCashContribution: Scalars['Float'];
  totalCashBorrowingBaseAmount: Scalars['Float'];
  effectiveCashAdvanceRate: Scalars['Float'];
  totalBorrowingBaseAmount: Scalars['Float'];
  effectiveAdvanceRate?: Maybe<Scalars['Float']>;
  totalAssets: Scalars['Float'];
  commitmentAmount: Scalars['Float'];
  currentPrincipalBalance: Scalars['Float'];
  totalFacilityUtilization?: Maybe<Scalars['Float']>;
};

export type CreateAttributeInputGQLType = {
  organizationId: Scalars['UUID'];
  name: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  type: AttributeTypeGQLType;
  validation: AttributeValidationInputGQLType;
};

export type CreateCdqResponseGQLType = {
  __typename?: 'CreateCDQResponse';
  id?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateCloneResponseGQLType = {
  __typename?: 'CreateCloneResponse';
  implementationId?: Maybe<Scalars['UUID']>;
  ownerOrganizationId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateConfigResponseGQLType = {
  __typename?: 'CreateConfigResponse';
  id?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateExploPlacementIntegrationParamsGQLType = {
  exploPlacement: ExploPlacementOptionsGQLType;
  exploArtifactType: ExploArtifactTypeGQLType;
  exploEmbedId: Scalars['String'];
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
};

export type CreateFinStatementLineItemInputGQLType = {
  finStatementId: Scalars['UUID'];
  ledgerName: Scalars['String'];
  section: FinancialSectionTypesGQLType;
  value: Scalars['Float'];
};

export type CreateInvoiceResponseGQLType = {
  __typename?: 'CreateInvoiceResponse';
  invoiceId: Scalars['UUID'];
  invoiceWorkleaseId?: Maybe<Scalars['UUID']>;
  disbursementWorkleaseIds?: Maybe<Array<Scalars['UUID']>>;
  paymentInKindWorkleaseIds?: Maybe<Array<Scalars['UUID']>>;
};

export type CreateOrUpdateLatestAttributeValueInputGQLType = {
  attributeId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  entityDomain: AttributeEntityDomainGQLType;
  entityIdentifier: Scalars['UUID'];
  stringValue?: Maybe<Scalars['String']>;
  intValue?: Maybe<Scalars['Int']>;
  floatValue?: Maybe<Scalars['Float']>;
  percentageRateValue?: Maybe<Scalars['Float']>;
  boolValue?: Maybe<Scalars['Boolean']>;
  fullDateStrValue?: Maybe<Scalars['String']>;
  stringArrayValue?: Maybe<Array<Scalars['String']>>;
};

export type CreateOrUpdateLimitedPartnerLatestAttributeValueInputGQLType = {
  attributeId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  stringValue?: Maybe<Scalars['String']>;
  intValue?: Maybe<Scalars['Int']>;
  floatValue?: Maybe<Scalars['Float']>;
  percentageRateValue?: Maybe<Scalars['Float']>;
  boolValue?: Maybe<Scalars['Boolean']>;
  fullDateStrValue?: Maybe<Scalars['String']>;
  stringArrayValue?: Maybe<Array<Scalars['String']>>;
};

export type CreateUserGQLType = {
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organizationId: Scalars['UUID'];
  roleType: RoleTypeGQLType;
};

export type CreditAgreementArtifactGQLType = {
  __typename?: 'CreditAgreementArtifact';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreement: Scalars['String'];
};

export type CreditAgreementArtifactDocumentIdUpdateStatusGQLType = {
  __typename?: 'CreditAgreementArtifactDocumentIdUpdateStatus';
  creditAgreementId: Scalars['UUID'];
  success: Scalars['Boolean'];
  message: Scalars['String'];
};

export type CreditAgreementArtifactDocumentIdUpdateStatusesGQLType = {
  __typename?: 'CreditAgreementArtifactDocumentIdUpdateStatuses';
  results: Array<CreditAgreementArtifactDocumentIdUpdateStatusGQLType>;
  message: Scalars['String'];
};

export type CreditAgreementConfigConcentrationLimitCalculationGQLType = {
  __typename?: 'CreditAgreementConfigConcentrationLimitCalculation';
  concentrationLimitKey: Scalars['String'];
  concentrationLimit: Scalars['Float'];
  concentrationAmount?: Maybe<Scalars['Float']>;
  totalEligibleExposure: Scalars['Float'];
  concentration: Scalars['Float'];
  borrowingBaseReduction: Scalars['Float'];
  complianceStatus: Scalars['String'];
};

export type CreditAgreementConfigEligibilityCriteriaCalculationGQLType = {
  __typename?: 'CreditAgreementConfigEligibilityCriteriaCalculation';
  eligibilityCriteriaKey: Scalars['String'];
  eligibilityReduction: Scalars['Float'];
};

export type CreditAgreementDocumentGQLType = {
  __typename?: 'CreditAgreementDocument';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreement: Scalars['String'];
};

export type CreditAgreementDownloadGQLType = {
  __typename?: 'CreditAgreementDownload';
  downloadUrl: Scalars['String'];
  fileName: Scalars['String'];
};

export type CreditAgreementFullArtifactGQLType = {
  __typename?: 'CreditAgreementFullArtifact';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreement: Scalars['String'];
};

export type CreditAgreementFullArtifactInputGQLType = {
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreement: Scalars['String'];
};

export type CreditAgreementFullArtifactWipResponseGQLType = {
  __typename?: 'CreditAgreementFullArtifactWipResponse';
  wip: CreditAgreementFullArtifactGQLType;
  errors: Array<Scalars['String']>;
};

export type CreditAgreementMetadataGQLType = {
  __typename?: 'CreditAgreementMetadata';
  id: Scalars['UUID'];
  facilityType: FacilityTypeGQLType;
  creditFacilityId: Scalars['UUID'];
  version: Scalars['String'];
  effectiveFrom: Scalars['Float'];
  effectiveTo: Scalars['Float'];
  _schemaVersion_: Scalars['String'];
  s3Path?: Maybe<Scalars['String']>;
  _note_?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
};

export type CreditAgreementStatusGQLType =
  | 'latestDraft'
  | 'latestPublished'
  | 'published';

export type CreditAgreementValidationErrorGQLType = {
  __typename?: 'CreditAgreementValidationError';
  type: CreditAgreementValidationErrorTypeGQLType;
  message: Scalars['String'];
};

export type CreditAgreementValidationErrorTypeGQLType =
  | 'party'
  | 'facility'
  | 'commitment'
  | 'pricingOption'
  | 'expense';

export type CreditFacilityGQLType = {
  __typename?: 'CreditFacility';
  id: Scalars['UUID'];
  slug: Scalars['String'];
  borrowerId: Scalars['UUID'];
  implementationId: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  type: FacilityTypeGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  docxReportTemplateTypes: Array<Scalars['String']>;
  name: Scalars['String'];
  borrower: OrganizationGQLType;
  borrowerEntityName: Scalars['String'];
  borrowerOrganizationName: Scalars['String'];
  loanProducts: Array<LoanProductGQLType>;
  borrowingBaseMechanicsForLoanProducts: Array<BorrowingBaseMechanicsForLoanProductGQLType>;
  latestCreditAgreementId?: Maybe<Scalars['UUID']>;
  currentCreditAgreement?: Maybe<CreditAgreementFullArtifactGQLType>;
  liabilityAccounts: Array<AccountingAccountGQLType>;
  capitalProviderRepresentativeOrganization?: Maybe<OrganizationGQLType>;
  externalFacilityId?: Maybe<Scalars['String']>;
  closingDate?: Maybe<Scalars['FullDateStr']>;
  loanRecords: Array<LoanRecordGQLType>;
  loans: Array<ResolvedLoanGQLType>;
  uploadedDocuments: Array<CreditFacilityUploadedDocumentRecordGQLType>;
  knowledgeBaseDocumentId?: Maybe<Scalars['String']>;
};


export type CreditFacilityLoanProductsArgsGQLType = {
  useWip?: Maybe<Scalars['Boolean']>;
};


export type CreditFacilityBorrowingBaseMechanicsForLoanProductsArgsGQLType = {
  isWip?: Maybe<Scalars['Boolean']>;
};

export type CreditFacilityAccrualObjectGQLType = {
  __typename?: 'CreditFacilityAccrualObject';
  account: TAccountGQLType;
  totalAccruedAmount: Scalars['Float'];
};

export type CreditFacilityBorrowingRiskInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityBorrowingRiskInsightsGqlData';
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  totalPerformingExposure: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  totalCollectionsAccountCash: Scalars['Float'];
  currentPrincipalBalance: Scalars['Float'];
  collateralCovenantLtv: Scalars['Float'];
  netOutstandingLtv: Scalars['Float'];
  performingLtv: Scalars['Float'];
};

export type CreditFacilityInsightsParamInputGQLType = {
  creditFacilityId: Scalars['UUID'];
  reportingDateStart: Scalars['FullDateStr'];
  reportingDateEnd: Scalars['FullDateStr'];
  limit?: Maybe<Scalars['Int']>;
};

export type CreditFacilityLenderShareRecordGQLType = {
  __typename?: 'CreditFacilityLenderShareRecord';
  id: Scalars['UUID'];
  borrowerId: Scalars['UUID'];
  capitalProviderId: Scalars['UUID'];
  loanId: Scalars['UUID'];
};

export type CreditFacilityMetricsResponseGQLType = {
  __typename?: 'CreditFacilityMetricsResponse';
  borrower: BaseOrganizationGQLType;
  commitmentAmount: Scalars['Float'];
  externalFacilityId?: Maybe<Scalars['String']>;
  outstandingPrincipalBalance: Scalars['Float'];
  utilization: Scalars['Float'];
  totalAccruedInterest: Scalars['Float'];
  totalAccruedServiceFees: Scalars['Float'];
};

export type CreditFacilityPrincipalInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityPrincipalInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  currentPrincipalBalance: Scalars['Float'];
  commitmentAmount: Scalars['Float'];
  totalFacilityUtilization: Scalars['Float'];
};

export type CreditFacilityProfitFullVintageInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityProfitFullVintageInsightsGqlData';
  profitVintageInputData: Array<CreditFacilityProfitVintageInputInsightsGqlDataGQLType>;
};

export type CreditFacilityProfitOverviewInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityProfitOverviewInsightsGqlData';
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  totalExposure: Scalars['Float'];
  totalNormalizedIsChargedOffExposure: Scalars['Float'];
  totalNormalizedIsDelinquentExposure: Scalars['Float'];
  totalExposureDaysPastDue0: Scalars['Float'];
  totalExposureDaysPastDue1to30: Scalars['Float'];
  totalExposureDaysPastDue31to60: Scalars['Float'];
  totalExposureDaysPastDue61to90: Scalars['Float'];
  totalExposureDaysPastDue91to120: Scalars['Float'];
  totalExposureDaysPastDue121plus: Scalars['Float'];
  chargedOffPercentageOfTotalExposure: Scalars['Float'];
  delinquentPercentageOfTotalExposure: Scalars['Float'];
  percentExposureDaysPastDue0: Scalars['Float'];
  percentExposureDaysPastDue1to30: Scalars['Float'];
  percentExposureDaysPastDue31to60: Scalars['Float'];
  percentExposureDaysPastDue61to90: Scalars['Float'];
  percentExposureDaysPastDue91to120: Scalars['Float'];
  percentExposureDaysPastDue121plus: Scalars['Float'];
};

export type CreditFacilityProfitVintageInputInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityProfitVintageInputInsightsGqlData';
  cohortBaseDate: Scalars['FullDateStr'];
  cohortSeriesDate: Scalars['FullDateStr'];
  totalVintageCalcValue: Scalars['Float'];
  totalNormalizedIsChargedOffVintageCalcValue: Scalars['Float'];
  totalNormalizedIsDelinquentVintageCalcValue: Scalars['Float'];
};

export type CreditFacilityPropertiesGQLType = {
  __typename?: 'CreditFacilityProperties';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type CreditFacilityReceivableExposureInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityReceivableExposureInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  totalExposure: Scalars['Float'];
  totalPerformingExposure: Scalars['Float'];
  totalEligibleExposureLessConcentrationKickouts: Scalars['Float'];
  totalReceivableBorrowingBase: Scalars['Float'];
};

export type CreditFacilityReceivableOriginationSummaryInfoGQLType = {
  __typename?: 'CreditFacilityReceivableOriginationSummaryInfo';
  originationDate: Scalars['FullDateStr'];
  originatedReceivablesCount: Scalars['Int'];
  totalInitialBalanceOfOriginatedReceivables?: Maybe<Scalars['Float']>;
};

export type CreditFacilityReceivableRiskInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityReceivableRiskInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  totalExposure: Scalars['Float'];
  totalNormalizedIsChargedOffExposure: Scalars['Float'];
  totalNormalizedIsDelinquentExposure: Scalars['Float'];
  chargedOffPercentageOfTotalExposure: Scalars['Float'];
  delinquentPercentageOfTotalExposure: Scalars['Float'];
};

export type CreditFacilityRepaymentInsightsParamInputGQLType = {
  creditFacilityId: Scalars['UUID'];
  repaymentDateStart: Scalars['FullDateStr'];
  repaymentDateEnd: Scalars['FullDateStr'];
  limit?: Maybe<Scalars['Int']>;
};

export type CreditFacilityRepaymentVintageInputInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityRepaymentVintageInputInsightsGqlData';
  cohortBaseDate: Scalars['FullDateStr'];
  cohortSeriesDate: Scalars['FullDateStr'];
  cumulativeRepayments: Scalars['Float'];
};

export type CreditFacilityRepaymentVintageInsightsGqlDataGQLType = {
  __typename?: 'CreditFacilityRepaymentVintageInsightsGqlData';
  repaymentVintageInputData: Array<CreditFacilityRepaymentVintageInputInsightsGqlDataGQLType>;
  receivableOriginationSummaryInfo: Array<CreditFacilityReceivableOriginationSummaryInfoGQLType>;
};

export type CreditFacilitySummaryGQLType = {
  __typename?: 'CreditFacilitySummary';
  id: Scalars['UUID'];
  slug: Scalars['String'];
  isActive: Scalars['Boolean'];
  currentFundingRequest?: Maybe<FundingRequestWithFullDetailsGQLType>;
};

export type CreditFacilityUploadedDocumentRecordGQLType = {
  __typename?: 'CreditFacilityUploadedDocumentRecord';
  id: Scalars['UUID'];
  documentType: UploadedDocumentTypeGQLType;
  capitalProvider?: Maybe<BaseOrganizationGQLType>;
  documentName: Scalars['String'];
  status: UploadedDocumentStatusGQLType;
  uploadedAt: Scalars['JSDate'];
};

export type CreditFacilityWithInstitutionsAndConnectionsGQLType = {
  __typename?: 'CreditFacilityWithInstitutionsAndConnections';
  creditFacilityId: Scalars['String'];
  creditFacilitySlug: Scalars['String'];
  creditFacilityName: Scalars['String'];
  organizations: Array<OrganizationGQLType>;
  tellerBankInstitutionId?: Maybe<Scalars['String']>;
  tellerBankInstitutionName?: Maybe<Scalars['String']>;
  tellerBankInstitutionKey?: Maybe<Scalars['String']>;
  tellerItemId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
  tellerAccountName?: Maybe<Scalars['String']>;
  tellerAccountMask?: Maybe<Scalars['String']>;
  plaidBankInstitutionId?: Maybe<Scalars['String']>;
  plaidBankInstitutionName?: Maybe<Scalars['String']>;
  plaidBankInstitutionKey?: Maybe<Scalars['String']>;
  plaidItemId?: Maybe<Scalars['String']>;
  plaidAccountId?: Maybe<Scalars['String']>;
  plaidAccountName?: Maybe<Scalars['String']>;
  plaidAccountMask?: Maybe<Scalars['String']>;
};

export type CsvVirtualSheetCsvDetailsGQLType = {
  sheetName: Scalars['String'];
  s3Bucket: Scalars['String'];
  s3Path: Scalars['String'];
};

export type CurrencyGQLType =
  | 'USD'
  | 'CAD'
  | 'MXN'
  | 'EUR'
  | 'GBP';

export type CustomerProvidedGQLType = {
  __typename?: 'CustomerProvided';
  escrow?: Maybe<CustomerProvidedEscrowGQLType>;
  status?: Maybe<CustomerProvidedStatusGQLType>;
  servicer?: Maybe<CustomerProvidedServicerGQLType>;
};

export type CustomerProvidedEscrowGQLType = {
  __typename?: 'CustomerProvidedEscrow';
  amount: Scalars['Float'];
};

export type CustomerProvidedServicerGQLType = {
  __typename?: 'CustomerProvidedServicer';
  name: Scalars['String'];
};

export type CustomerProvidedStatusGQLType = {
  __typename?: 'CustomerProvidedStatus';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type DailyAccountActivityGQLType = {
  __typename?: 'DailyAccountActivity';
  postingDate: Scalars['FullDateStr'];
  tAccount: TAccountTypeGQLType;
  aggregateAmount: Scalars['Float'];
};

export type DailyAccountActivityResponseGQLType = {
  __typename?: 'DailyAccountActivityResponse';
  accountData: Array<DailyAccountActivityGQLType>;
  metadata?: Maybe<AccountActivityMetadataGQLType>;
};

export type DataPipelineStatusForCreditFacilityGQLType = {
  __typename?: 'DataPipelineStatusForCreditFacility';
  borrowerId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  latestArtifactDocumentVersion?: Maybe<Scalars['Int']>;
  latestArtifactDocumentId?: Maybe<Scalars['UUID']>;
  latestArtifactInstance?: Maybe<ReportingDateAndVersionGQLType>;
};

export type DataValidationErrorsMapGQLType = {
  __typename?: 'DataValidationErrorsMap';
  artifactInstanceId: Scalars['String'];
  progressBreakdown: Array<BorrowingBasePipelineSingleProgressBreakdownGQLType>;
};

export type DatabaseGQLType =
  | 'pg'
  | 's3';

export type DateRangeInputGQLType = {
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};

export type DeactivateCdqConfigResponseGQLType = {
  __typename?: 'DeactivateCdqConfigResponse';
  id?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type DefaultTableColumnConfigurationInputGQLType = {
  tableKey: Scalars['String'];
  columns: Array<ColumnConfigurationInputGQLType>;
};

export type DeliverableActionKeyGQLType =
  | 'insertDeliverableItem'
  | 'updateDeliverableItemStatus'
  | 'insertedDeliverable'
  | 'updatedDeliverableStatus'
  | 'submittedDeliverableSubmission';

export type DeliverableArtifactGQLType = {
  __typename?: 'DeliverableArtifact';
  id: Scalars['UUID'];
  containerId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  reportingPeriod: Scalars['String'];
  configKey: Scalars['String'];
  inputType: InputTypeGQLType;
  instances: Array<DeliverableArtifactInstanceGQLType>;
  config: DeliverableArtifactConfigGQLType;
};

export type DeliverableArtifactConfigGQLType = CashBalancesFeedConfigGQLType | SupplementalTapeConfigGQLType | LoanTapeConfigGQLType | RepaymentTapeConfigGQLType | PortfolioCovenantConfigGQLType | FinancialCovenantConfigGQLType | OrgProvidedInputConfigGQLType | MonthlyServicerReportConfigGQLType | MonthlyStatementConfigGQLType | FinancialStatementConfigGQLType;

export type DeliverableArtifactInstanceGQLType = {
  __typename?: 'DeliverableArtifactInstance';
  id: Scalars['UUID'];
  deliverableArtifactId: Scalars['UUID'];
  version: Scalars['Int'];
  active?: Maybe<Scalars['Boolean']>;
  status: ArtifactInstanceStatusGQLType;
  rawDatabase?: Maybe<DeliverableDatabaseGQLType>;
  rawNamespace?: Maybe<DeliverableRawNamespaceGQLType>;
  rawIdentifier?: Maybe<Scalars['String']>;
  completedObject?: Maybe<ArtifactInstanceDownloadObjectGQLType>;
};

export type DeliverableArtifactInstanceDownloadGQLType = ArtifactInstanceDownloadUrlGQLType | ArtifactInstanceDownloadObjectGQLType;

export type DeliverableContainerGQLType = {
  __typename?: 'DeliverableContainer';
  id: Scalars['UUID'];
  configKey: Scalars['String'];
  configName: Scalars['String'];
  creditAgreementId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  creditFacilityName: Scalars['String'];
  dueDate: Scalars['FullDateStr'];
  type: ContainerTypeGQLType;
  period: ContainerPeriodGQLType;
  daysOffset: Scalars['Int'];
  totalDependencies: Scalars['Int'];
  completedDependencies: Scalars['Int'];
  totalFinalArtifacts: Scalars['Int'];
  completedFinalArtifacts: Scalars['Int'];
  borrowerId: Scalars['UUID'];
  borrowerSlug: Scalars['String'];
  borrowerName: Scalars['String'];
  capitalProviderEntities: Array<CapitalProviderEntitiesGQLType>;
  latestReceiptId?: Maybe<Scalars['UUID']>;
  mostRecentActionType?: Maybe<DeliverableContainerReceiptActionTypeGQLType>;
  approvedDate?: Maybe<Scalars['JSDate']>;
  latestGenerateReceiptRecord?: Maybe<DeliverableContainerGenerateReceiptRecordGQLType>;
};

export type DeliverableContainerGenerateReceiptRecordGQLType = {
  __typename?: 'DeliverableContainerGenerateReceiptRecord';
  id: Scalars['UUID'];
  deliverableContainerId: Scalars['UUID'];
  successfulReceiptId?: Maybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  status: DeliverableContainerGenerateReceiptStatusGQLType;
};

export type DeliverableContainerGenerateReceiptStatusGQLType =
  | 'initialized'
  | 'inProgress'
  | 'success'
  | 'error';

export type DeliverableContainerOutputLenderViewGQLType = {
  __typename?: 'DeliverableContainerOutputLenderView';
  id: Scalars['UUID'];
  configName: Scalars['String'];
  configKey: Scalars['String'];
  creditAgreementId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  creditFacilityName: Scalars['String'];
  dueDate: Scalars['FullDateStr'];
  dueDateDescription?: Maybe<Scalars['String']>;
  type: ContainerTypeGQLType;
  borrower: BorrowerEntityGQLType;
  latestReceiptId?: Maybe<Scalars['UUID']>;
  mostRecentActionType?: Maybe<ReceiptActionTypePostCreationGQLType>;
  approvedDate?: Maybe<Scalars['JSDate']>;
};

export type DeliverableContainerReceiptActionTypeGQLType =
  | 'generated'
  | 'submitted'
  | 'approved'
  | 'requestRemediation';

export type DeliverableContainerReceiptActionsGQLType = {
  __typename?: 'DeliverableContainerReceiptActions';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  action: DeliverableContainerReceiptActionTypeGQLType;
  receiptId: Scalars['UUID'];
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  organizationName: Scalars['String'];
};

export type DeliverableContainerReceiptRecordGQLType = {
  __typename?: 'DeliverableContainerReceiptRecord';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  version: Scalars['Int'];
  expired: Scalars['Boolean'];
  deliverableContainerId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  creditFacilityName: Scalars['String'];
  containerDueDate: Scalars['FullDateStr'];
  containerName: Scalars['String'];
  containerType: ContainerTypeGQLType;
  borrowerId: Scalars['UUID'];
  borrowerSlug: Scalars['String'];
  borrowerName: Scalars['String'];
  capitalProviderEntities: Array<CapitalProviderEntitiesGQLType>;
  dependenciesInstances: Array<ReceiptInstancesGQLType>;
  finalArtifactsInstances: Array<ReceiptInstancesGQLType>;
  actionsLog: Array<DeliverableContainerReceiptActionsGQLType>;
};

export type DeliverableDatabaseGQLType =
  | 'pg';

export type DeliverableDependencyPayloadGQLType = {
  __typename?: 'DeliverableDependencyPayload';
  deliverableId: Scalars['UUID'];
  parentDeliverableId: Scalars['UUID'];
  updated_at: Scalars['JSDate'];
  created_at: Scalars['JSDate'];
};

export type DeliverableEntityMetaGQLType = {
  __typename?: 'DeliverableEntityMeta';
  id: Scalars['String'];
  configName: Scalars['String'];
  dueDate: Scalars['FullDateStr'];
  creditFacilityId: Scalars['String'];
  creditFacilityName: Scalars['String'];
  latestReceiptId?: Maybe<Scalars['String']>;
};

export type DeliverableExternalNamespaceGQLType =
  | 'borrowing_base_pipeline_artifact_instances'
  | 'assigned_loan_tapes'
  | 'internal_repayment_tapes'
  | 'portfolio_covenants'
  | 'org_provided_values'
  | 'cash_response_tapes'
  | 'compliance_reports_cf'
  | 'financial_covenants';

export type DeliverableItemGQLType = {
  __typename?: 'DeliverableItem';
  id: Scalars['UUID'];
  name: Scalars['String'];
  type: DeliverableItemPropertyTypeGQLType;
  borrowerKey: Scalars['String'];
  creditFacilityId: Scalars['UUID'];
  creditFacilityName?: Maybe<Scalars['String']>;
  categoryKey: Scalars['String'];
  deliveryCadence: Scalars['String'];
  description: Scalars['String'];
  dueDate: Scalars['FullDateStr'];
  section: Scalars['String'];
  reportingDeliverablesKey: Scalars['String'];
  status: DeliverableStatusKeyGQLType;
  isDeleted: Scalars['Boolean'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type DeliverableItemPropertyTypeGQLType =
  | 'RecurringDeliverableProperty'
  | 'RecurringWithOffsetDeliverableProperty'
  | 'SingleDeliverableProperty';

export type DeliverablePayloadGQLType = {
  __typename?: 'DeliverablePayload';
  id: Scalars['UUID'];
  configKey: Scalars['String'];
  creditFacilityId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  dueDate: Scalars['FullDateStr'];
  status: DeliverableProgressStatusGQLType;
  section?: Maybe<Scalars['String']>;
  creditAgreementDocumentId: Scalars['String'];
  updated_at: Scalars['JSDate'];
  created_at: Scalars['JSDate'];
  creditFacilityName: Scalars['String'];
};

export type DeliverableProgressStatusGQLType =
  | 'notSubmitted'
  | 'submitted'
  | 'resubmit'
  | 'waived';

export type DeliverableRawNamespaceGQLType =
  | 'borrowing_base_pipeline_artifact_instances'
  | 'reporting_generate_worklease_status'
  | 'portfolio_covenants'
  | 'financial_covenants';

export type DeliverableResponsiblePartyPayloadGQLType = {
  __typename?: 'DeliverableResponsiblePartyPayload';
  deliverableId: Scalars['UUID'];
  responsiblePartyId: Scalars['UUID'];
  updated_at: Scalars['JSDate'];
  created_at: Scalars['JSDate'];
};

export type DeliverableStatusKeyGQLType =
  | 'notStarted'
  | 'upcoming'
  | 'dueSoon'
  | 'overdue'
  | 'expired'
  | 'waived'
  | 'completed';

export type DeliverableSubmissionPayloadGQLType = {
  __typename?: 'DeliverableSubmissionPayload';
  id: Scalars['UUID'];
  deliverableId: Scalars['UUID'];
  value: Scalars['String'];
  valueType: DeliverableValueTypeGQLType;
  updated_at: Scalars['JSDate'];
  created_at: Scalars['JSDate'];
};

export type DeliverableThreadGQLType = BaseThreadV2GQLType & {
  __typename?: 'DeliverableThread';
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentV2GQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<ThreadLatestActionLogV2GQLType>;
  entityMetadata: DeliverableEntityMetaGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
};

export type DeliverableThreadCreateEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'DeliverableThreadCreateEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: DeliverableEntityMetaGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  current: ThreadCreatedEventSnapshotGQLType;
};

export type DeliverableValueTypeGQLType =
  | 'file'
  | 'string'
  | 'number'
  | 'boolean'
  | 'noSubmission';

export type DeliverablesPayloadGQLType = {
  __typename?: 'DeliverablesPayload';
  creditFacilityId: Scalars['UUID'];
  deliverableItem: DeliverableItemGQLType;
};

export type DomainPropertiesGQLType = {
  __typename?: 'DomainProperties';
  creditFacility: CreditFacilityPropertiesGQLType;
  amount: Scalars['Float'];
  party: PartyPropertiesGQLType;
  categorySpecificProperties: CategorySpecificPropertiesGQLType;
};

export type DownloadWithLoanProductGQLType = {
  __typename?: 'DownloadWithLoanProduct';
  download: UrlAndFilenameGQLType;
  loanProductId: Scalars['String'];
  loanProduct?: Maybe<LoanProductGQLType>;
};

export type DownloadableReportGQLType = {
  __typename?: 'DownloadableReport';
  id: Scalars['UUID'];
  reportName: Scalars['String'];
  reportType: DownloadableReportTypeGQLType;
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  isPreview: Scalars['Boolean'];
};

export type DownloadableReportTypeGQLType =
  | 'assetVerification'
  | 'borrowingBaseCertificate'
  | 'borrowingBaseServicerReport'
  | 'fundingRequestServicerReport'
  | 'monthlyServicerReport'
  | 'noticeOfBorrowing'
  | 'noticeOfPrepayment'
  | 'receivablesSaleAgreement'
  | 'receivableResponseTapePreviewServicerReport'
  | 'releaseNotice'
  | 'fundingNotice'
  | 'invoice'
  | 'disbursementNotice'
  | 'paymentInKindNotice'
  | 'batchSettlement'
  | 'facilityTrialBalance'
  | 'loanTrialBalance';

export type DynamicIntermediateFieldsForCreditFacilityGQLType = {
  __typename?: 'DynamicIntermediateFieldsForCreditFacility';
  creditFacilityId: Scalars['String'];
  dynamicIntermediateFields: Array<BaseFieldGQLType>;
};

export type EditFundingComponentChangesetGQLType = {
  originalFundingRequestComponentId: Scalars['UUID'];
  capitalProviderId: Scalars['UUID'];
  type: FundingRequestComponentTypeEnumGQLType;
  amount: Scalars['Float'];
  targetFundingDate: Scalars['FullDateStr'];
  fundTransferDate?: Maybe<Scalars['FullDateStr']>;
  postingDate?: Maybe<Scalars['FullDateStr']>;
};

export type EditFundingRequestChangesetGQLType = {
  originalFundingRequestId: Scalars['UUID'];
  fundingRequestComponents: Array<EditFundingComponentChangesetGQLType>;
};

export type EditLoanAttributesGQLType = {
  maturityDate: Scalars['FullDateStr'];
  externalLoanId?: Maybe<Scalars['String']>;
};

export type ElementByDateGQLType = {
  __typename?: 'ElementByDate';
  date: Scalars['FullDateStr'];
  value: Scalars['Float'];
};

export type EligibilityAggregateInsightsGqlDataGQLType = {
  __typename?: 'EligibilityAggregateInsightsGqlData';
  reportingDate: Scalars['FullDateStr'];
  totalEligibleExposure: Scalars['Float'];
  totalNetEligibilityKickout: Scalars['Float'];
  totalGrossEligibilityKickout: Scalars['Float'];
  eligibilityPropertiesData: Array<EligibilityPropertyInsightsGqlDataGQLType>;
};

export type EligibilityCriteriaGQLType = {
  __typename?: 'EligibilityCriteria';
  eligibilityCriteriaKey: Scalars['String'];
  eligibilityConfigDetail: Scalars['String'];
};

export type EligibilityCriteriaCalculationGQLType = {
  __typename?: 'EligibilityCriteriaCalculation';
  id: Scalars['UUID'];
  borrowingBaseReportId: Scalars['UUID'];
  eligibilityCriteriaKey: Scalars['String'];
  eligibilityReduction: Scalars['Float'];
  created_at: Scalars['JSDate'];
};

export type EligibilityExclusionGQLType = {
  __typename?: 'EligibilityExclusion';
  id: Scalars['String'];
  assignmentStrategyId: Scalars['String'];
  creditFacilityId: Scalars['String'];
  loanProductId: Scalars['String'];
  eligibilityCriteriaKey: Scalars['String'];
};

export type EligibilityExclusionInputGQLType = {
  creditFacilityId: Scalars['String'];
  loanProductId: Scalars['String'];
  eligibilityCriteriaKey: Scalars['String'];
};

export type EligibilityFieldsGQLType = {
  __typename?: 'EligibilityFields';
  eligibleExposure: Scalars['Float'];
  isEligible: Scalars['Boolean'];
  eligibilityKickout: Scalars['Float'];
};

export type EligibilityPropertyInsightsGqlDataGQLType = {
  __typename?: 'EligibilityPropertyInsightsGqlData';
  propertyKey: Scalars['String'];
  totalEligibilityKickout: Scalars['Float'];
};

export type EligibilityStatusGQLType =
  | 'ELIGIBLE'
  | 'INELIGIBLE'
  | 'INELIGIBLE_WAIVED';

export type EligibilityStatusContainerGQLType = {
  __typename?: 'EligibilityStatusContainer';
  eligibilityCriteriaKey: Scalars['String'];
  eligibilityStatus: EligibilityStatusGQLType;
};

export type EligibleExposureForCreditFacilityGQLType = {
  __typename?: 'EligibleExposureForCreditFacility';
  creditFacility: CreditFacilityGQLType;
  eligibleExposure?: Maybe<Scalars['Float']>;
};

export type EmailSubscriptionGQLType = {
  __typename?: 'EmailSubscription';
  id: Scalars['String'];
  emailType: EmailTypeGQLType;
  userId: Scalars['String'];
  filter: SubscriptionFilterGQLType;
};

export type EmailSubscriptionResponseGQLType = {
  __typename?: 'EmailSubscriptionResponse';
  response: Scalars['String'];
  emailSubscription?: Maybe<EmailSubscriptionGQLType>;
};

export type EmailTypeGQLType =
  | 'assignmentEmail'
  | 'digestEmail'
  | 'fundingRequestEmail'
  | 'fundingRequestSubmittedBorrowerEmail'
  | 'fundingRequestSubmittedCapitalProviderEmail'
  | 'fundingRequestApproval'
  | 'deliverablesDueSoon'
  | 'deliverablesNewComment'
  | 'deliverablesReportLenderReviewResult'
  | 'deliverablesReportReadyForReview'
  | 'deliverablesReportGeneratedResult'
  | 'upcomingDeliverableEmail'
  | 'servicerReportPreviewEmail'
  | 'servicerReportFailureEmail'
  | 'missingPipelineInputs'
  | 'dataTapeIngestionErrors'
  | 'deliverablesResponsiblePartyReminder'
  | 'deliverablesResponsiblePartySubmitSubmission'
  | 'deliverablesResponsiblePartyStatusUpdate'
  | 'borrowingBaseReportGenerated'
  | 'invoiceCalculationComparison'
  | 'metricAlert'
  | 'masterTrustPortfolioOverview'
  | 'receivablesSaleAgreementGenerated'
  | 'successfulIbsTransactionIngest'
  | 'remediationRequestedBorrowerAction'
  | 'remediationRequestedCapitalProviderReceipt'
  | 'verificationReportAdjudicationAction'
  | 'verificationReportCreatedBorrower'
  | 'verificationReportReadyForReviewBorrower'
  | 'verificationReportReadyForReviewCapitalProvider'
  | 'workflowGenericNotifyApproval';

export type EntityFilterInputGQLType = {
  entityDomain: AttributeValueEntityDomainGQLType;
  entityIdentifiers?: Maybe<Array<Scalars['String']>>;
};

export type EntityIdAndNameGQLType = {
  __typename?: 'EntityIdAndName';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ErrorCreateWorkflowTemplateResponseGQLType = {
  __typename?: 'ErrorCreateWorkflowTemplateResponse';
  status: ValidateAndCreateWorkflowTemplateResponseStatusGQLType;
  errors: Array<Scalars['String']>;
};

export type ErrorPortfolioCovenantGQLType = {
  __typename?: 'ErrorPortfolioCovenant';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  triggerDate: Scalars['FullDateStr'];
  status: PortfolioCovenantStatusGQLType;
  metadata?: Maybe<PortfolioCovenantMetadataGQLType>;
  created_at?: Maybe<Scalars['JSDate']>;
  updated_at?: Maybe<Scalars['JSDate']>;
};

export type EvaluateFinancialCovenantsResponseGQLType = {
  __typename?: 'EvaluateFinancialCovenantsResponse';
  response: Scalars['String'];
};

export type EvaluatePortfolioCovenantsDevResponseGQLType = {
  __typename?: 'EvaluatePortfolioCovenantsDevResponse';
  response: Scalars['String'];
};

export type EvaluatePortfolioCovenantsRequestGQLType = {
  creditAgreementId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  covenantKeys: Array<Scalars['String']>;
  triggerDate: Scalars['FullDateStr'];
  mode: PortfolioCovenantWorkleaseModeGQLType;
};

export type EvaluatePortfolioCovenantsResponseGQLType = {
  __typename?: 'EvaluatePortfolioCovenantsResponse';
  response: Scalars['String'];
  portfolioCovenantIds: Array<Scalars['String']>;
};

export type EvaluatedReportingInputConfigGQLType = {
  __typename?: 'EvaluatedReportingInputConfig';
  variables: Array<ReportingVariableGQLType>;
  errors: Array<Scalars['String']>;
};

export type EventConnectionGQLType = {
  __typename?: 'EventConnection';
  totalCount: Scalars['Int'];
  nodes: Array<EventWithActorGQLType>;
  pageInfo: PageInfoGQLType;
};

export type EventLogGQLType = ThreadCreatedEventGQLType | DeliverableThreadCreateEventGQLType | FundingRequestCreatedEventGQLType | FundingRequestStatusChangeEventGQLType | FundingRequestThreadCreateEventGQLType | LimitedPartnerCreatedEventGQLType | LimitedPartnerMappingMatchEventGQLType | LimitedPartnerMappingUnmatchEventGQLType | LimitedPartnerThreadCreateEventGQLType | LimitedPartnerUpdatedEventGQLType | ValleyBankLoanAccountThreadCreateEventGQLType | InvoiceCreatedEventGQLType | InvoiceThreadCreateEventGQLType | InvoiceUpdatedEventGQLType;

export type EventLogActorGQLType = {
  __typename?: 'EventLogActor';
  id: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organization: BaseOrganizationGQLType;
};

export type EventLogBaseEventGQLType = {
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
};

export type EventLogCreditFacilityGQLType = {
  __typename?: 'EventLogCreditFacility';
  id: Scalars['UUID'];
  name: Scalars['String'];
  externalFacilityId?: Maybe<Scalars['String']>;
};

export type EventLogPaginatedFeedGQLType = {
  __typename?: 'EventLogPaginatedFeed';
  hasMore: Scalars['Boolean'];
  items: Array<EventLogGQLType>;
};

export type EventLogPaginatedFeedParamsGQLType = {
  version?: Maybe<Scalars['Int']>;
  eventLogTypes: Array<EventLogTypeGQLType>;
  entityIds?: Maybe<Array<Scalars['String']>>;
  organizationIds?: Maybe<Array<Scalars['UUID']>>;
  implementationIds?: Maybe<Array<Scalars['UUID']>>;
  creditFacilityIds?: Maybe<Array<Scalars['UUID']>>;
  actorIds?: Maybe<Array<Scalars['UUID']>>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<EventLogPaginatedFeedSortByGQLType>;
  sortDirection?: Maybe<EventLogPaginatedFeedSortDirectionGQLType>;
};

export type EventLogPaginatedFeedSortByGQLType =
  | 'created_at';

export type EventLogPaginatedFeedSortDirectionGQLType =
  | 'asc'
  | 'desc';

export type EventLogTypeGQLType =
  | 'deliverable_container_thread_create'
  | 'fundingRequest_request_approved'
  | 'fundingRequest_request_canceled'
  | 'fundingRequest_request_expired'
  | 'fundingRequest_request_pending'
  | 'fundingRequest_request_rejected'
  | 'fundingRequest_request_submitted'
  | 'fundingRequest_request_thread_create'
  | 'fundingRequest_request_unsubmitted'
  | 'limitedPartner_create'
  | 'limitedPartner_mapping_match'
  | 'limitedPartner_mapping_unmatch'
  | 'limitedPartner_thread_create'
  | 'limitedPartner_update'
  | 'valleyBank_loanAccount_thread_create'
  | 'invoice_cancel'
  | 'invoice_create'
  | 'invoice_editDueDate'
  | 'invoice_paid'
  | 'invoice_thread_create'
  | 'invoice_undoPayment';

export type EventWithActorGQLType = {
  __typename?: 'EventWithActor';
  id: Scalars['UUID'];
  actor: ActorGQLType;
  eventKey: Scalars['String'];
  organizationId: Scalars['UUID'];
  payload: PayloadGQLType;
  payloadVersion: Scalars['Int'];
  created_at: Scalars['JSDate'];
  domainKey: Scalars['String'];
  actionKey: Scalars['String'];
  actorName: Scalars['String'];
  creditFacilityId: Scalars['UUID'];
  targetName: Scalars['String'];
  isCapitalProvider: Scalars['Boolean'];
};

export type ExploArtifactTypeGQLType =
  | 'dashboard'
  | 'reportBuilder';

export type ExploDashboardGQLType = {
  __typename?: 'ExploDashboard';
  name: Scalars['String'];
  embedId: Scalars['String'];
};

export type ExploPlacementIntegrationGQLType = {
  __typename?: 'ExploPlacementIntegration';
  id: Scalars['UUID'];
  exploPlacement: ExploPlacementOptionsGQLType;
  exploArtifactType: ExploArtifactTypeGQLType;
  exploEmbedId: Scalars['String'];
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
};

export type ExploPlacementOptionsGQLType =
  | 'lenderFacilitiesTab'
  | 'borrowerStratsPage'
  | 'lenderPortfolioTab'
  | 'limitedPartnersDashboard';

export type ExploReportBuilderGQLType = {
  __typename?: 'ExploReportBuilder';
  name: Scalars['String'];
  embedId: Scalars['String'];
};

export type ExploTokenResponseGQLType = {
  __typename?: 'ExploTokenResponse';
  isIntegrationAvailable: Scalars['Boolean'];
  jwt: Scalars['String'];
  error: Scalars['String'];
};

export type ExploVisualArtifactsGQLType = {
  __typename?: 'ExploVisualArtifacts';
  dashboards: Array<ExploDashboardGQLType>;
  reportBuilders: Array<ExploReportBuilderGQLType>;
};

export type ExternalFacilityDataGQLType = {
  __typename?: 'ExternalFacilityData';
  creditFacilityId: Scalars['UUID'];
  externalFacilityId?: Maybe<Scalars['String']>;
};

export type FacilityInterestRateGQLType = {
  __typename?: 'FacilityInterestRate';
  id: Scalars['UUID'];
  creditAgreementId?: Maybe<Scalars['UUID']>;
  configEnabled: Scalars['Boolean'];
  creditFacilityId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  effectiveDate: Scalars['FullDateStr'];
  determinationDate: Scalars['FullDateStr'];
  rate: Scalars['Float'];
  benchmark: InterestRateBenchmarkGQLType;
  interestRateDataSource: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  capitalProviderName?: Maybe<Scalars['String']>;
};

export type FacilityTypeGQLType =
  | 'creditFacility'
  | 'securitization'
  | 'forwardFlow'
  | 'capitalCallLine';

export type FieldConfigGQLType = {
  __typename?: 'FieldConfig';
  fieldName: Scalars['String'];
  fieldType: FieldTypeGQLType;
};

export type FieldTypeGQLType =
  | 'boolean'
  | 'currency'
  | 'date'
  | 'dateTime'
  | 'float'
  | 'integer'
  | 'optionalBoolean'
  | 'optionalCurrency'
  | 'optionalDate'
  | 'optionalDateTime'
  | 'optionalFloat'
  | 'optionalInteger'
  | 'optionalPercentage'
  | 'optionalString'
  | 'percentage'
  | 'string';

export type FilterFieldRangeGQLType = {
  min?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
};

export type FinalOutputDeliverableArtifactInstanceGQLType = {
  __typename?: 'FinalOutputDeliverableArtifactInstance';
  id: Scalars['UUID'];
  deliverableArtifactId: Scalars['UUID'];
  status: ArtifactInstanceStatusGQLType;
  rawRecordStatus?: Maybe<ArtifactInstanceRawRecordStatusGQLType>;
};

export type FinancialCovenantConfigGQLType = {
  __typename?: 'FinancialCovenantConfig';
  artifactType: ArtifactTypeGQLType;
  covenantKey: Scalars['String'];
};

export type FinancialCovenantConfigPropertyGQLType = {
  __typename?: 'FinancialCovenantConfigProperty';
  name: Scalars['String'];
  key: Scalars['String'];
  valueType: FinancialCovenantValueTypeGQLType;
  limitType: FinancialCovenantLimitTypeGQLType;
  limitValue: Scalars['Float'];
};

export type FinancialCovenantInputWorkleaseGQLType = {
  creditAgreementId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  mode: FinancialCovenantWorkleaseModeGQLType;
  triggerDate: Scalars['FullDateStr'];
  covenantKeys: Array<Scalars['String']>;
};

export type FinancialCovenantKeyToIdMapGQLType = {
  __typename?: 'FinancialCovenantKeyToIdMap';
  covenantKey: Scalars['String'];
  financialCovenantRecordId: Scalars['String'];
};

export type FinancialCovenantLimitTypeGQLType =
  | 'min'
  | 'max';

export type FinancialCovenantResultGQLType =
  | 'PASS'
  | 'FAIL'
  | 'LEVEL_1_FAIL'
  | 'LEVEL_2_FAIL'
  | 'LEVEL_3_FAIL'
  | 'LEVEL_4_FAIL'
  | 'LEVEL_5_FAIL'
  | 'LEVEL_6_FAIL'
  | 'LEVEL_7_FAIL'
  | 'LEVEL_8_FAIL'
  | 'LEVEL_9_FAIL'
  | 'LEVEL_10_FAIL';

export type FinancialCovenantStatusGQLType =
  | 'initialized'
  | 'success'
  | 'error';

export type FinancialCovenantValueTypeGQLType =
  | 'currency'
  | 'ratio'
  | 'percentage';

export type FinancialCovenantVariableGQLType = {
  __typename?: 'FinancialCovenantVariable';
  name: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
};

export type FinancialCovenantWorkleaseModeGQLType =
  | 'QA'
  | 'RESULT';

export type FinancialCovenantsCalculationGQLType = {
  __typename?: 'FinancialCovenantsCalculation';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  covenantKey: Scalars['String'];
  covenantType: Scalars['String'];
  limitValue: Scalars['Float'];
  limitType: FinancialCovenantLimitTypeGQLType;
  value: Scalars['Float'];
};

export type FinancialCovenantsInsightsGQLType = {
  __typename?: 'FinancialCovenantsInsights';
  config: Array<FinancialCovenantConfigPropertyGQLType>;
  financialCovenantsCalculations: Array<FinancialCovenantsCalculationGQLType>;
};

export type FinancialCovenantsInsightsForCovenantKeyGQLType = {
  __typename?: 'FinancialCovenantsInsightsForCovenantKey';
  financialCovenantsCalculations: Array<FinancialCovenantsCalculationGQLType>;
};

export type FinancialDataSourceKeyEnumGQLType =
  | 'plaid'
  | 'teller'
  | 'manualDashboard'
  | 'manualS3Upload';

export type FinancialDisplayFormatGQLType =
  | 'K'
  | 'M'
  | 'B'
  | 'full';

export type FinancialFormattingGQLType = {
  __typename?: 'FinancialFormatting';
  displayFormat: FinancialDisplayFormatGQLType;
};

export type FinancialSectionTotalsGQLType = {
  __typename?: 'FinancialSectionTotals';
  cadenceDelta?: Maybe<Scalars['Float']>;
  endOfPeriodDate: Scalars['FullDateStr'];
  value?: Maybe<Scalars['Float']>;
};

export type FinancialSectionTypesGQLType =
  | 'assets'
  | 'liabilities'
  | 'equity'
  | 'income'
  | 'expenses';

export type FinancialStatementAdHocCalculationsGQLType = {
  __typename?: 'FinancialStatementAdHocCalculations';
  adHocKey: AdHocKeyTypeGQLType;
  totals: Array<FinancialSectionTotalsGQLType>;
};

export type FinancialStatementConfigGQLType = {
  __typename?: 'FinancialStatementConfig';
  artifactType: ArtifactTypeGQLType;
  artifactSlug: Scalars['String'];
  financialDataArtifactSlug: Scalars['String'];
};

export type FinancialStatementConfigStoreGQLType = {
  __typename?: 'FinancialStatementConfigStore';
  financialFormatting: FinancialFormattingGQLType;
};

export type FinancialStatementInstanceTypeGQLType = {
  __typename?: 'FinancialStatementInstanceType';
  currency: CurrencyGQLType;
  finleyStatementKey: FinancialStatementTypeGQLType;
  reportFrequency: ReportFrequencyGQLType;
  metadata: FinancialStatementMetadataGQLType;
  adHocCalculations: Array<FinancialStatementAdHocCalculationsGQLType>;
  sectionKeysToLineItems: Array<FinancialStatementSectionKeysToLineItemsGQLType>;
};

export type FinancialStatementLineItemsToValuesTypesGQLType = {
  __typename?: 'FinancialStatementLineItemsToValuesTypes';
  lineItemDescription: Scalars['String'];
  values: Array<FinancialStatementValueTypesGQLType>;
};

export type FinancialStatementMetadataGQLType = {
  __typename?: 'FinancialStatementMetadata';
  sortedEndOfPeriodDates: Array<Scalars['FullDateStr']>;
};

export type FinancialStatementSectionKeysToLineItemsGQLType = {
  __typename?: 'FinancialStatementSectionKeysToLineItems';
  finleySectionKey: FinancialSectionTypesGQLType;
  totals: Array<FinancialSectionTotalsGQLType>;
  lineItemsToValues: Array<FinancialStatementLineItemsToValuesTypesGQLType>;
};

export type FinancialStatementTypeGQLType =
  | 'balanceSheet'
  | 'incomeStatement';

export type FinancialStatementValueTypesGQLType = {
  __typename?: 'FinancialStatementValueTypes';
  cadenceDelta?: Maybe<Scalars['Float']>;
  endOfPeriodDate: Scalars['FullDateStr'];
  value?: Maybe<Scalars['Float']>;
  finStatementLineItemId?: Maybe<Scalars['UUID']>;
  finStatementId: Scalars['UUID'];
};

export type FinleyAiKnowledgeBaseDocumentGQLType = {
  __typename?: 'FinleyAiKnowledgeBaseDocument';
  id: Scalars['UUID'];
  documentName: Scalars['String'];
  s3Bucket: Scalars['String'];
  s3Path: Scalars['String'];
  documentType: FinleyAiKnowledgeBaseDocumentDocumentTypeGQLType;
  tags: Array<Scalars['String']>;
  organizationId: Scalars['UUID'];
  userId: Scalars['UUID'];
  embeddedChunksS3Bucket: Scalars['String'];
  embeddedChunksS3Path: Scalars['String'];
};

export type FinleyAiKnowledgeBaseDocumentDocumentTypeGQLType =
  | 'creditAgreement'
  | 'userProvided';

export type FinleyAiKnowledgeBaseDocumentsGQLType = {
  __typename?: 'FinleyAiKnowledgeBaseDocuments';
  knowledgeBaseDocuments: Array<FinleyAiKnowledgeBaseDocumentGQLType>;
};

export type FinleyAiPromptReponseGQLType = {
  __typename?: 'FinleyAiPromptReponse';
  promptResponse: Scalars['Object'];
};

export type FinleyAiRequestGQLType = {
  request: Scalars['Object'];
};

export type FinleyAiResponseGQLType = {
  __typename?: 'FinleyAiResponse';
  thread: Scalars['Object'];
};

export type FinleyAiThreadWithPromptReponsesGQLType = {
  __typename?: 'FinleyAiThreadWithPromptReponses';
  threadWithPromptResponses: Scalars['Object'];
};

export type FinleyAiThreadsGQLType = {
  __typename?: 'FinleyAiThreads';
  threads: Array<Scalars['Object']>;
};

export type FinleyAiThreadsWithPromptReponsesGQLType = {
  __typename?: 'FinleyAiThreadsWithPromptReponses';
  threadsWithPromptResponses: Array<Scalars['Object']>;
};

export type FinleyAutomatedGQLType = ActorGQLType & {
  __typename?: 'FinleyAutomated';
  id: Scalars['UUID'];
  name: Scalars['String'];
  actorType: ActorTypeGQLType;
};

export type FloatAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'FloatAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
  validation: AttributeValueFloatValidationGQLType;
};

export type FloatingInterestRateGQLType = {
  __typename?: 'FloatingInterestRate';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  effectiveDate: Scalars['FullDateStr'];
  determinationDate: Scalars['FullDateStr'];
  rate: Scalars['Float'];
  benchmark: InterestRateBenchmarkGQLType;
  interestRateDataSource: InterestRateDataSourceGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  capitalProviderName?: Maybe<Scalars['String']>;
};

export type FloatingInterestRateInputsGQLType = {
  id?: Maybe<Scalars['UUID']>;
  creditFacilityId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  effectiveDate: Scalars['FullDateStr'];
  determinationDate: Scalars['FullDateStr'];
  rate: Scalars['Float'];
  benchmark: InterestRateBenchmarkGQLType;
  interestRateDataSource: InterestRateDataSourceGQLType;
};

export type FormattedMultiFacilityStatementGQLType = {
  __typename?: 'FormattedMultiFacilityStatement';
  creditFacilityIds: Array<Maybe<Scalars['String']>>;
  period: FormattedStatementPeriodGQLType;
  paymentDate: Scalars['FullDateStr'];
  summary: FormattedStatementSummaryGQLType;
  columns: Array<FormattedStatementColumnGQLType>;
  rows: Array<Array<Maybe<Scalars['Primitive']>>>;
};

export type FormattedStatementGQLType = {
  __typename?: 'FormattedStatement';
  creditFacilityId: Scalars['String'];
  period: FormattedStatementPeriodGQLType;
  paymentDate: Scalars['FullDateStr'];
  summary: FormattedStatementSummaryGQLType;
  columns: Array<FormattedStatementColumnGQLType>;
  rows: Array<Array<Maybe<Scalars['Primitive']>>>;
};

export type FormattedStatementColumnGQLType = {
  __typename?: 'FormattedStatementColumn';
  name: Scalars['String'];
  format: FormattedStatementColumnFormatGQLType;
};

export type FormattedStatementColumnFormatGQLType = {
  __typename?: 'FormattedStatementColumnFormat';
  type: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
};

export type FormattedStatementPeriodGQLType = {
  __typename?: 'FormattedStatementPeriod';
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  cutoffTime?: Maybe<Scalars['JSDate']>;
};

export type FormattedStatementSummaryGQLType = {
  __typename?: 'FormattedStatementSummary';
  balances: Array<SummaryBalanceGQLType>;
  totalBalance: Scalars['Float'];
};


export type FullDateStrAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'FullDateStrAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Scalars['FullDateStr']>;
  validation: AttributeValueFullDateStrValidationGQLType;
};

export type FullDateStrDateRangeInputGQLType = {
  dateStart: Scalars['FullDateStr'];
  dateEnd: Scalars['FullDateStr'];
};


export type FundingLenderSharesGQLType = {
  __typename?: 'FundingLenderShares';
  lenderShareId: Scalars['UUID'];
  lenderOrganization: BaseOrganizationGQLType;
  allocationPercent: Scalars['Float'];
  initialFundingAmount: Scalars['Float'];
  outstandingBalance?: Maybe<Scalars['Float']>;
  totalAccruedInterest: Scalars['Float'];
  projectedInterest: Scalars['Float'];
};

export type FundingMechanicsGQLType = {
  __typename?: 'FundingMechanics';
  fundingRequestId: Scalars['String'];
  commitments: Array<FundingMechanicsCommitmentGQLType>;
  draw: FundingMechanicsDrawConfigurationGQLType;
  recycles: Array<FundingMechanicsRecycleConfigurationV2GQLType>;
  requestRoutings: Array<FundingMechanicsRequestRoutingGQLType>;
};

export type FundingMechanicsCommitmentGQLType = {
  __typename?: 'FundingMechanicsCommitment';
  key: Scalars['String'];
  label: Scalars['String'];
  amount: Scalars['Float'];
  attachmentRate: Scalars['Float'];
  shares: Array<FundingMechanicsCommitmentShareGQLType>;
};

export type FundingMechanicsCommitmentShareGQLType = {
  __typename?: 'FundingMechanicsCommitmentShare';
  lenderId: Scalars['String'];
  lenderName: Scalars['String'];
  amount: Scalars['Float'];
  fundingRequestComponentId: Scalars['String'];
  routing: FundingMechanicsRoutingGQLType;
  applicableMargin: Scalars['Float'];
};

export type FundingMechanicsCommitmentShareRoutingDetailsGQLType = {
  __typename?: 'FundingMechanicsCommitmentShareRoutingDetails';
  bankAccountId: Scalars['String'];
  label: Scalars['String'];
};

export type FundingMechanicsConditionConstraintGQLType = {
  __typename?: 'FundingMechanicsConditionConstraint';
  type: FundingMechanicsConstraintTypeGQLType;
  label: Scalars['String'];
  value: Scalars['Float'];
  condition: Scalars['String'];
};

export type FundingMechanicsConstraintGQLType = FundingMechanicsNonConditionConstraintGQLType | FundingMechanicsConditionConstraintGQLType;

export type FundingMechanicsConstraintTypeGQLType =
  | 'minimum'
  | 'maximum'
  | 'increment'
  | 'condition';

export type FundingMechanicsDrawConfigurationGQLType = {
  __typename?: 'FundingMechanicsDrawConfiguration';
  allocation?: Maybe<FundingMechanicsDrawConfigurationAllocationGQLType>;
  constraints: Array<FundingMechanicsConstraintGQLType>;
  pricingOptions: Array<PricingOptionGQLType>;
  targetFundingDate: Scalars['FullDateStr'];
};

export type FundingMechanicsDrawConfigurationAllocationGQLType = {
  __typename?: 'FundingMechanicsDrawConfigurationAllocation';
  strategy?: Maybe<FundingMechanicsDrawConfigurationAllocationStrategyGQLType>;
  strict: Scalars['Boolean'];
};

export type FundingMechanicsDrawConfigurationAllocationStrategyGQLType =
  | 'cascade'
  | 'proportion';

export type FundingMechanicsNonConditionConstraintGQLType = {
  __typename?: 'FundingMechanicsNonConditionConstraint';
  type: FundingMechanicsConstraintTypeGQLType;
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type FundingMechanicsRecycleConfigurationV2GQLType = {
  __typename?: 'FundingMechanicsRecycleConfigurationV2';
  fundingRequestComponentId: Scalars['String'];
  targetFundingDate: Scalars['FullDateStr'];
  constraints?: Maybe<Array<FundingMechanicsConstraintGQLType>>;
  routing?: Maybe<FundingMechanicsRoutingGQLType>;
};

export type FundingMechanicsRequestRoutingGQLType = {
  __typename?: 'FundingMechanicsRequestRouting';
  type: FundingRequestComponentTypeEnumGQLType;
  source: FundingMechanicsRoutingBankAccountWithOwnerGQLType;
  destination: FundingMechanicsRoutingBankAccountWithOwnerGQLType;
};

export type FundingMechanicsRoutingGQLType = {
  __typename?: 'FundingMechanicsRouting';
  source: FundingMechanicsCommitmentShareRoutingDetailsGQLType;
  destination: FundingMechanicsCommitmentShareRoutingDetailsGQLType;
};

export type FundingMechanicsRoutingBankAccountWithOwnerGQLType = {
  __typename?: 'FundingMechanicsRoutingBankAccountWithOwner';
  accountId: Scalars['String'];
  accountName: Scalars['String'];
  accountType: Scalars['String'];
  organizationId: Scalars['String'];
};

export type FundingNoticeGQLType = {
  __typename?: 'FundingNotice';
  reportName: Scalars['String'];
  fundingRequestComponents: Array<FundingRequestComponentTypeEnumGQLType>;
};

export type FundingRequestGQLType = {
  __typename?: 'FundingRequest';
  creditFacilityId: Scalars['UUID'];
  creditFacility: CreditFacilityGQLType;
  /** @deprecated Use creditFacility field */
  creditFacilityName: Scalars['String'];
  curePaydownTotalAmount: Scalars['Float'];
  drawRequestTotalAmount: Scalars['Float'];
  collectionsRecycleTotalAmount: Scalars['Float'];
  collectionsPaydownTotalAmount: Scalars['Float'];
  id: Scalars['UUID'];
  expire: Scalars['JSDate'];
  status: FundingRequestStatusEnumGQLType;
  isCurrent?: Maybe<Scalars['Boolean']>;
  borrowingBaseReportId?: Maybe<Scalars['UUID']>;
  fundingRequestConstraintId?: Maybe<Scalars['UUID']>;
  type: FundingRequestTypeEnumGQLType;
  comment?: Maybe<Scalars['String']>;
  loans: Array<LoanRecordGQLType>;
  resolvedLoans: Array<ResolvedLoanGQLType>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  submittedAt?: Maybe<Scalars['JSDate']>;
};

export type FundingRequestActionKeyGQLType =
  | 'requestPending'
  | 'requestUnsubmitted'
  | 'requestSubmitted'
  | 'requestCanceled'
  | 'requestApproved'
  | 'requestRejected'
  | 'requestExpired'
  | 'componentSettled';

export type FundingRequestAllocationsGQLType = {
  __typename?: 'FundingRequestAllocations';
  fundingRequestComponentTotalAmounts: FundingRequestComponentTotalAmountsGQLType;
  fundingRequestComponents: Array<FundingRequestComponentChangesetGQLType>;
};

export type FundingRequestCanBeCreatedErrorCodeEnumGQLType =
  | 'bankAccountsAreNotConfiguredProperly'
  | 'classAllocationMethodNotConfigured'
  | 'collectionsPaydownIsAllowedNotConfigured'
  | 'collectionsRecycleIsAllowedNotConfigured'
  | 'currentFundingRequestAlreadyInProgress'
  | 'expireDaysOffsetNotConfigured'
  | 'fundingRequestComponentSubmissionNoticePeriodsNotConfigured'
  | 'isStopDrawEnforcedNotConfigured'
  | 'latestBorrowingBaseReportIsTooOld'
  | 'maximumBorrowingBaseReportDaysOldNotConfigured'
  | 'noCurrentFundingRequestConstraint'
  | 'servicerReportTemplateNotConfigured';

export type FundingRequestCanBeCreatedResponseGQLType = {
  __typename?: 'FundingRequestCanBeCreatedResponse';
  canCreate: Scalars['Boolean'];
  errorCode?: Maybe<FundingRequestCanBeCreatedErrorCodeEnumGQLType>;
};

export type FundingRequestComponentGQLType = {
  __typename?: 'FundingRequestComponent';
  id: Scalars['UUID'];
  fundingRequestId: Scalars['UUID'];
  commitmentKey?: Maybe<Scalars['String']>;
  type: FundingRequestComponentTypeEnumGQLType;
  amount: Scalars['Float'];
  sourceBankAccountId: Scalars['String'];
  sourceBankAccountType: AccountTypeGQLType;
  destinationBankAccountId: Scalars['String'];
  destinationBankAccountType: AccountTypeGQLType;
  targetFundingDate?: Maybe<Scalars['FullDateStr']>;
  postingDate?: Maybe<Scalars['FullDateStr']>;
  borrowerVerifiedTransactionId?: Maybe<Scalars['String']>;
  borrowerFinancialDataSourceKey?: Maybe<FinancialDataSourceKeyEnumGQLType>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type FundingRequestComponentChangesetGQLType = {
  __typename?: 'FundingRequestComponentChangeset';
  id: Scalars['UUID'];
  type: FundingRequestComponentTypeEnumGQLType;
  amount: Scalars['Float'];
  sourceBankAccountId: Scalars['String'];
  destinationBankAccountId: Scalars['String'];
  targetFundingDate?: Maybe<Scalars['FullDateStr']>;
};

export type FundingRequestComponentPayloadGQLType = {
  __typename?: 'FundingRequestComponentPayload';
  creditFacilityId: Scalars['UUID'];
  fundingRequest: FundingRequestGQLType;
  fundingRequestComponent: FundingRequestComponentGQLType;
};

export type FundingRequestComponentTotalAmountsGQLType = {
  __typename?: 'FundingRequestComponentTotalAmounts';
  drawRequestTotalAmount: Scalars['Float'];
  collectionsRecycleTotalAmount: Scalars['Float'];
  collectionsPaydownTotalAmount: Scalars['Float'];
  curePaydownTotalAmount: Scalars['Float'];
};

export type FundingRequestComponentTypeEnumGQLType =
  | 'collectionsPaydown'
  | 'collectionsRecycle'
  | 'curePaydown'
  | 'drawRequest';

export type FundingRequestConstraintGQLType = {
  __typename?: 'FundingRequestConstraint';
  borrowingBaseReportId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  collectionsRecycleContributesToBorrowingBase: Scalars['Boolean'];
  collectionsRecycleMax: Scalars['Float'];
  collectionsPaydownMax: Scalars['Float'];
  drawRequestIncrementAmount?: Maybe<Scalars['Float']>;
  drawRequestContributesToBorrowingBase: Scalars['Boolean'];
  id: Scalars['UUID'];
  isCurrent?: Maybe<Scalars['Boolean']>;
  isCollectionsRecycleEnabled: Scalars['Boolean'];
  isStopDrawEnforced: Scalars['Boolean'];
  isVoluntaryPaydownAllowed: Scalars['Boolean'];
  maxFundingRequestAmount: Scalars['Float'];
  maxDrawRequestAmount?: Maybe<Scalars['Float']>;
  maxCollectionsRecycleAmount: Scalars['Float'];
  minimumDrawRequestAmount: Scalars['Float'];
  minimumRepaymentAmount: Scalars['Float'];
  preAdvanceCashContributionToBorrowingBase: Scalars['Float'];
  targetCurePaydownAmount: Scalars['Float'];
  targetDrawRequestAmount: Scalars['Float'];
  targetCollectionsRecycleAmount: Scalars['Float'];
  targetCollectionsPaydownAmount: Scalars['Float'];
};

export type FundingRequestCreatedEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'FundingRequestCreatedEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: FundingRequestEntityMetaGQLType;
  current: FundingRequestStatusEventsCommonSnapshotGQLType;
};

export type FundingRequestEntitiesGQLType = {
  __typename?: 'FundingRequestEntities';
  fundingRequestId: Scalars['UUID'];
  fundingRequestStatus: FundingRequestStatusEnumGQLType;
  fundingRequestType: FundingRequestTypeEnumGQLType;
  fundingRequestCreatedAt: Scalars['JSDate'];
  totalRequestedAmount: Scalars['Float'];
  originationDate: Scalars['FullDateStr'];
  fundingComponents: Array<ShareFundingComponentGQLType>;
};

export type FundingRequestEntityMetaGQLType = {
  __typename?: 'FundingRequestEntityMeta';
  id: Scalars['UUID'];
  expire: Scalars['JSDate'];
  status: FundingRequestStatusEnumGQLType;
  creditFacilityId: Scalars['String'];
  creditFacilityName: Scalars['String'];
  loanNames: Array<Scalars['String']>;
  externalLoanIds: Array<Scalars['String']>;
};

export type FundingRequestPayloadGQLType = {
  __typename?: 'FundingRequestPayload';
  creditFacilityId: Scalars['UUID'];
  fundingRequest: FundingRequestGQLType;
  fundingRequestComponents: Array<FundingRequestComponentGQLType>;
};

export type FundingRequestReportGQLType = {
  __typename?: 'FundingRequestReport';
  id: Scalars['String'];
  s3Path: Scalars['String'];
  reportType: ReportTypeGQLType;
  isDomainReport: Scalars['Boolean'];
};

export type FundingRequestResponseGQLType = {
  __typename?: 'FundingRequestResponse';
  fundingRequestId: Scalars['UUID'];
  response: Scalars['String'];
};

export type FundingRequestStatusChangeEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'FundingRequestStatusChangeEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: FundingRequestEntityMetaGQLType;
  previous: FundingRequestStatusEventsCommonSnapshotGQLType;
  current: FundingRequestStatusEventsCommonSnapshotGQLType;
};

export type FundingRequestStatusEnumGQLType =
  | 'approved'
  | 'canceled'
  | 'expired'
  | 'pending'
  | 'rejected'
  | 'submitted'
  | 'unsubmitted'
  | 'pendingLoanEdit'
  | 'overriddenFromLoanEdit'
  | 'canceledLoanEdit';

export type FundingRequestStatusEventsCommonSnapshotGQLType = {
  __typename?: 'FundingRequestStatusEventsCommonSnapshot';
  status: Scalars['String'];
  creditFacilityId: Scalars['UUID'];
  drawRequestTotalAmount: Scalars['Float'];
  collectionsPaydownTotalAmount: Scalars['Float'];
  collectionsRecycleTotalAmount: Scalars['Float'];
  curePaydownTotalAmount: Scalars['Float'];
};

export type FundingRequestTaskSpecificPropertiesGQLType = {
  __typename?: 'FundingRequestTaskSpecificProperties';
  category: TaskCategoryGQLType;
  fundingRequestId: Scalars['UUID'];
  loanIds: Array<Scalars['UUID']>;
  fundingRequestDueDate: Scalars['JSDate'];
};

export type FundingRequestTemplateModeGQLType =
  | 'create'
  | 'get'
  | 'upsize'
  | 'edit';

export type FundingRequestTemplateResponseGQLType = {
  __typename?: 'FundingRequestTemplateResponse';
  creditAgreementId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  fundingMechanics?: Maybe<FundingMechanicsGQLType>;
  fundingMechanicsV2Serialized?: Maybe<Scalars['String']>;
  reportingMechanics: ReportingMechanicsGQLType;
  borrowingBaseReport: PartialBorrowingBaseReportGQLType;
  cashBalances: Array<BankAccountCashBalanceGQLType>;
  outstandingBalances: Array<OutstandingBalanceGQLType>;
  loanBalances: Array<LoanBalanceGQLType>;
  pendingRequests: Array<FundingRequestComponentGQLType>;
  currentFundingRequestComponents: Array<FundingRequestComponentGQLType>;
  borrowingBaseReportMetadataForLastApprovedFundingRequest?: Maybe<BorrowingBaseReportMetadataGQLType>;
  loans?: Maybe<Array<ResolvedLoanGQLType>>;
  fundingRequestToDuplicate?: Maybe<FundingRequestWithFullDetailsGQLType>;
};

export type FundingRequestThreadGQLType = BaseThreadV2GQLType & {
  __typename?: 'FundingRequestThread';
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentV2GQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<ThreadLatestActionLogV2GQLType>;
  creditFacility: EventLogCreditFacilityGQLType;
  entityMetadata: FundingRequestEntityMetaGQLType;
};

export type FundingRequestThreadCreateEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'FundingRequestThreadCreateEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: FundingRequestEntityMetaGQLType;
  current: ThreadCreatedEventSnapshotGQLType;
};

export type FundingRequestTypeEnumGQLType =
  | 'origination'
  | 'upsizing';

export type FundingRequestVerificationReceivableEligibilityGQLType = {
  __typename?: 'FundingRequestVerificationReceivableEligibility';
  reportingDate: Scalars['FullDateStr'];
  verificationEligibilityReceivables: Array<VerificationEligibilityReceivableGQLType>;
};

export type FundingRequestVerificationReportGQLType = {
  __typename?: 'FundingRequestVerificationReport';
  verificationReportId: Scalars['UUID'];
  verificationReport: Scalars['String'];
  borrowingBaseReportId: Scalars['UUID'];
  approvalReportNote?: Maybe<Scalars['String']>;
  remediationRequested?: Maybe<Scalars['Boolean']>;
  remediationNote?: Maybe<Scalars['String']>;
  artifactDocumentId: Scalars['String'];
};

export type FundingRequestWithFullDetailsGQLType = {
  __typename?: 'FundingRequestWithFullDetails';
  creditFacilityId: Scalars['UUID'];
  creditFacility: CreditFacilityGQLType;
  /** @deprecated Use creditFacility field */
  creditFacilityName: Scalars['String'];
  curePaydownTotalAmount: Scalars['Float'];
  drawRequestTotalAmount: Scalars['Float'];
  collectionsRecycleTotalAmount: Scalars['Float'];
  collectionsPaydownTotalAmount: Scalars['Float'];
  id: Scalars['UUID'];
  fundingRequestConstraintId: Scalars['UUID'];
  fundingRequestReports?: Maybe<Array<FundingRequestReportGQLType>>;
  expire: Scalars['JSDate'];
  status: FundingRequestStatusEnumGQLType;
  isCurrent?: Maybe<Scalars['Boolean']>;
  borrowingBaseReportId: Scalars['UUID'];
  comment?: Maybe<Scalars['String']>;
  type: FundingRequestTypeEnumGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  submittedAt?: Maybe<Scalars['JSDate']>;
  borrower: OrganizationGQLType;
  bankAccounts: Array<BankAccountWithInstitutionAndDesignationGQLType>;
  fundingRequestComponents: Array<FundingRequestComponentGQLType>;
  fundingRequestEvents: Array<EventWithActorGQLType>;
  reportingDate: Scalars['FullDateStr'];
  loans: Array<LoanRecordGQLType>;
  resolvedLoans: Array<ResolvedLoanGQLType>;
  adjustedPrincipalBalance: Scalars['Float'];
  borrowingBaseReport: PartialBorrowingBaseReportGQLType;
  verificationReport?: Maybe<FundingRequestVerificationReportGQLType>;
  verificationReportEvents?: Maybe<Array<EventWithActorGQLType>>;
};

export type FundingRequestsConnectionGQLType = {
  __typename?: 'FundingRequestsConnection';
  totalCount: Scalars['Int'];
  nodes: Array<FundingRequestWithFullDetailsGQLType>;
  pageInfo: PageInfoGQLType;
};

export type FundingVerificationPipelineRunGQLType = {
  __typename?: 'FundingVerificationPipelineRun';
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  goalArtifactIds: Array<Scalars['String']>;
  status: VerificationPipelineStatusGQLType;
  initiatorDetails?: Maybe<ArtifactInstanceInitiatorDetailsGQLType>;
};

export type GetAttributeValuesByParamsInputGQLType = {
  organizationId: Scalars['UUID'];
  attributeIds?: Maybe<Array<Scalars['UUID']>>;
  attributeNames?: Maybe<Array<Scalars['String']>>;
  attributeDisplayNames?: Maybe<Array<Scalars['String']>>;
  types?: Maybe<Array<AttributeTypeGQLType>>;
  attributeValueIds?: Maybe<Array<Scalars['UUID']>>;
  entities?: Maybe<Array<EntityFilterInputGQLType>>;
  values?: Maybe<Array<Scalars['String']>>;
  reportingDate?: Maybe<Scalars['FullDateStr']>;
  latestOnly?: Maybe<Scalars['Boolean']>;
};

export type GetQuickSightEmbedUrlParamsGQLType = {
  organizationId: Scalars['String'];
  organizationType: OrganizationTypeEnumGQLType;
  loanProductId?: Maybe<Scalars['String']>;
  creditFacilityId?: Maybe<Scalars['String']>;
  dataType: QuickSightDataTypeEnumGQLType;
  latest: Scalars['Boolean'];
};

export type HistoricalAssetVerificationDataGQLType = {
  __typename?: 'HistoricalAssetVerificationData';
  assignedAtDate: Scalars['FullDateStr'];
  totalAssignedAtExposure: Scalars['Float'];
  totalUntestedAssignedAtExposure: Scalars['Float'];
  totalUnverifiedFailureAssignedAtExposure: Scalars['Float'];
  totalVerifiedFailureAssignedAtExposure: Scalars['Float'];
  totalVerifiedPassAssignedAtExposure: Scalars['Float'];
  totalReceivableCount: Scalars['Int'];
  verifiedPassReceivableCount: Scalars['Int'];
  verifiedFailureReceivableCount: Scalars['Int'];
  unverifiedFailureReceivableCount: Scalars['Int'];
  untestedReceivableCount: Scalars['Int'];
};

export type IbsActionGQLType =
  | 'addParticipantToNote'
  | 'increaseParticipantNoteBalance'
  | 'increaseNoteBalance';

export type IbsStatusGQLType =
  | 'pending'
  | 'executed'
  | 'error'
  | 'canceled';

export type ImplementationGQLType = {
  __typename?: 'Implementation';
  id: Scalars['UUID'];
  slug: Scalars['String'];
  name: Scalars['String'];
  ownerOrganization: BaseOrganizationGQLType;
  borrowerOrganization: OrganizationGQLType;
  loanProducts: Array<LoanProductGQLType>;
  creditFacilities: Array<CreditFacilityGQLType>;
  borrowerPipelineDefinitionId?: Maybe<Scalars['String']>;
  bankAccountsWithInstitutionAndOwner: Array<BankAccountWithInstitutionAndOwnerGQLType>;
};


export type ImplementationCreditFacilitiesArgsGQLType = {
  includeInactive?: Maybe<Scalars['Boolean']>;
};


export type ImplementationBankAccountsWithInstitutionAndOwnerArgsGQLType = {
  maskSensitiveInfo?: Maybe<Scalars['Boolean']>;
};

export type ImplementationEntityGQLType = {
  __typename?: 'ImplementationEntity';
  id: Scalars['UUID'];
  slug: Scalars['String'];
  name: Scalars['String'];
};

export type ImplementationInfoGQLType = {
  __typename?: 'ImplementationInfo';
  implementation: ImplementationEntityGQLType;
  owner: ImplementationEntityGQLType;
  loanProducts: Array<ImplementationEntityGQLType>;
  creditFacilities: Array<ImplementationEntityGQLType>;
  borrowers: Array<ImplementationEntityGQLType>;
  lenders: Array<ImplementationEntityGQLType>;
};

export type ImplementationUploadedDocumentRecordGQLType = {
  __typename?: 'ImplementationUploadedDocumentRecord';
  id: Scalars['UUID'];
  documentType: UploadedDocumentTypeGQLType;
  documentName: Scalars['String'];
  capitalProvider?: Maybe<BaseOrganizationGQLType>;
  status: UploadedDocumentStatusGQLType;
  uploadedAt: Scalars['JSDate'];
};

export type IngestionActionKeyGQLType =
  | 'success'
  | 'failed';

export type IngestionPayloadGQLType = {
  __typename?: 'IngestionPayload';
  origin: Array<Scalars['String']>;
  successOps: Scalars['Int'];
  failedOps: Scalars['Int'];
  messages: Array<Scalars['String']>;
};

export type InputTypeGQLType =
  | 'input'
  | 'output';

export type InsertedDeliverablePayloadGQLType = {
  __typename?: 'InsertedDeliverablePayload';
  creditFacilityId: Scalars['UUID'];
  deliverable: DeliverablePayloadGQLType;
  responsibleParties: Array<DeliverableResponsiblePartyPayloadGQLType>;
};

export type IntegerAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'IntegerAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
  validation: AttributeValueIntegerValidationGQLType;
};

export type InterestRateGQLType = {
  __typename?: 'InterestRate';
  benchmarkSlug: Scalars['String'];
  effectiveDate: Scalars['FullDateStr'];
  providerSlug: Scalars['String'];
  value: Scalars['Float'];
};

export type InterestRateBenchmarkGQLType =
  | 'SOFR'
  | 'SOFR30DAvg'
  | 'SOFR90DAvg'
  | 'SOFRTerm1M'
  | 'SOFRTerm3M'
  | 'SOFRTerm6M'
  | 'LIBOR1M'
  | 'LIBOR3M'
  | 'EURIBOR1M'
  | 'EURIBOR3M'
  | 'CDOR1M'
  | 'CDOR3M'
  | 'PRIME'
  | 'TIIE30DAvg'
  | 'CMT3Y'
  | 'CMT5Y'
  | 'CMT7Y'
  | 'CMT10Y'
  | 'SONIA';

export type InterestRateDataSourceGQLType =
  | 'manual'
  | 'bloomberg'
  | 'wsj'
  | 'ice';

export type InvoiceGQLType = {
  __typename?: 'Invoice';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  finleyLoanId?: Maybe<Scalars['UUID']>;
  originatingInvoiceId?: Maybe<Scalars['UUID']>;
  paymentSourceOrganizationId: Scalars['UUID'];
  paymentDestinationOrganizationId: Scalars['UUID'];
  sourceBankAccountId?: Maybe<Scalars['UUID']>;
  destinationBankAccountId?: Maybe<Scalars['UUID']>;
  invoiceType: InvoiceTypeGQLType;
  status: InvoiceStatusGQLType;
  totalAmount: Scalars['Float'];
  autoSettle: Scalars['Boolean'];
  memo?: Maybe<Scalars['String']>;
  accrualStartDate: Scalars['FullDateStr'];
  accrualEndDate: Scalars['FullDateStr'];
  targetInvoiceDate?: Maybe<Scalars['FullDateStr']>;
  dueDate: Scalars['FullDateStr'];
  paymentDate?: Maybe<Scalars['FullDateStr']>;
  createdByType: InvoiceCreatedByTypeGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  invoiceComponentsWithInvoiceItems: Array<InvoiceComponentWithInvoiceItemsGQLType>;
  creditFacility: CreditFacilityGQLType;
  paymentSourceOrganization: EntityIdAndNameGQLType;
  paymentDestinationOrganization: EntityIdAndNameGQLType;
  loan?: Maybe<ResolvedLoanGQLType>;
  destinationBankAccount?: Maybe<BankAccountWithInstitutionAndOwnerGQLType>;
  invoiceReports?: Maybe<Array<InvoiceReportGQLType>>;
  invoiceCalculationComparisons: Array<InvoiceCalculationComparisonGQLType>;
};

export type InvoiceAggregatesGQLType = {
  __typename?: 'InvoiceAggregates';
  dueSoon: InvoiceStatusAggregateGQLType;
  overdue: InvoiceStatusAggregateGQLType;
  paid: InvoiceStatusAggregateGQLType;
  totalCount: Scalars['Int'];
};

export type InvoiceCalculationComparisonGQLType = {
  __typename?: 'InvoiceCalculationComparison';
  loanId: Scalars['UUID'];
  loanName: Scalars['String'];
  externalLoanId?: Maybe<Scalars['String']>;
  invoiceComponentDifferences: Array<InvoiceComponentDifferenceGQLType>;
  invoiceDisbursementItemDifferences: InvoiceDisbursementItemDifferencesGQLType;
};

export type InvoiceComponentGQLType = {
  __typename?: 'InvoiceComponent';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  finleyLoanId?: Maybe<Scalars['UUID']>;
  invoiceComponentType: InvoiceComponentTypeGQLType;
  totalAmount: Scalars['Float'];
  accrualStartDate: Scalars['FullDateStr'];
  accrualEndDate: Scalars['FullDateStr'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type InvoiceComponentDifferenceGQLType = {
  __typename?: 'InvoiceComponentDifference';
  inputAmount: Scalars['Float'];
  finleyAmount: Scalars['Float'];
  difference: Scalars['Float'];
};

export type InvoiceComponentInputGQLType = {
  invoiceComponentType: InvoiceComponentTypeGQLType;
  finleyLoanId?: Maybe<Scalars['UUID']>;
  totalAmount: Scalars['Float'];
  accrualStartDate: Scalars['FullDateStr'];
  accrualEndDate: Scalars['FullDateStr'];
};

export type InvoiceComponentTypeGQLType =
  | 'creditFacility'
  | 'loan';

export type InvoiceComponentWithInvoiceItemsGQLType = {
  __typename?: 'InvoiceComponentWithInvoiceItems';
  invoiceComponent: InvoiceComponentGQLType;
  invoiceItems: Array<InvoiceItemGQLType>;
};

export type InvoiceComponentWithInvoiceItemsInputGQLType = {
  invoiceComponent: InvoiceComponentInputGQLType;
  invoiceItems: Array<InvoiceItemInputGQLType>;
};

export type InvoiceConsolidatedDisbursementGQLType = {
  __typename?: 'InvoiceConsolidatedDisbursement';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  capitalProviderOrganizationId: Scalars['UUID'];
  totalCashDisbursementAmount: Scalars['Float'];
  totalCashServiceFeeAmount: Scalars['Float'];
  totalPostServiceFeeCashDisbursementAmount: Scalars['Float'];
  totalInterestCapitalizationAmount: Scalars['Float'];
  totalInterestCapitalizationServiceFeeAmount: Scalars['Float'];
  totalPostServiceFeeInterestCapitalizationAmount: Scalars['Float'];
  status: InvoiceConsolidatedDisbursementStatusGQLType;
  paymentDate?: Maybe<Scalars['FullDateStr']>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  capitalProviderOrganization: EntityIdAndNameGQLType;
  capitalProviderProRataForFacility: Scalars['Float'];
};

export type InvoiceConsolidatedDisbursementStatusGQLType =
  | 'created'
  | 'paid'
  | 'canceled';

export type InvoiceCreatedByTypeGQLType =
  | 'user'
  | 'ibs'
  | 'onboardingReference';

export type InvoiceCreatedEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'InvoiceCreatedEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: InvoiceEntityMetaGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  current: InvoiceStatusEventsCommonSnapshotGQLType;
};

export type InvoiceDisbursementGQLType = {
  __typename?: 'InvoiceDisbursement';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  invoiceComponentId: Scalars['UUID'];
  capitalProviderOrganizationId: Scalars['UUID'];
  totalAmount: Scalars['Float'];
  autoSettle: Scalars['Boolean'];
  status: InvoiceDisbursementStatusGQLType;
  dueDate?: Maybe<Scalars['FullDateStr']>;
  paymentDate?: Maybe<Scalars['FullDateStr']>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  invoiceDisbursementItems: Array<InvoiceDisbursementItemGQLType>;
  capitalProviderOrganization: EntityIdAndNameGQLType;
  capitalProviderProRata?: Maybe<Scalars['Float']>;
  serviceFeeTotals?: Maybe<InvoiceDisbursementServiceFeeTotalsGQLType>;
};

export type InvoiceDisbursementItemGQLType = {
  __typename?: 'InvoiceDisbursementItem';
  id: Scalars['UUID'];
  invoiceDisbursementId: Scalars['UUID'];
  accountingAccountId: Scalars['UUID'];
  accountingTransactionId?: Maybe<Scalars['UUID']>;
  amount: Scalars['Float'];
  serviceFeeAmount: Scalars['Float'];
  postServiceFeeTotalAmount: Scalars['Float'];
  accountingAccount: TAccountGQLType;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type InvoiceDisbursementItemDifferenceGQLType = {
  __typename?: 'InvoiceDisbursementItemDifference';
  capitalProviderId: Scalars['UUID'];
  capitalProviderName: Scalars['String'];
  tAccountType: TAccountTypeGQLType;
  inputAmount: Scalars['Float'];
  finleyAmount: Scalars['Float'];
  difference: Scalars['Float'];
  inputProRataShare: Scalars['Float'];
  finleyProRataShare: Scalars['Float'];
};

export type InvoiceDisbursementItemDifferencesGQLType = {
  __typename?: 'InvoiceDisbursementItemDifferences';
  interest: Array<InvoiceDisbursementItemDifferenceGQLType>;
  principal: Array<InvoiceDisbursementItemDifferenceGQLType>;
};

export type InvoiceDisbursementServiceFeeTotalsGQLType = {
  __typename?: 'InvoiceDisbursementServiceFeeTotals';
  serviceFeeAmount: Scalars['Float'];
  postServiceFeeTotalAmount: Scalars['Float'];
};

export type InvoiceDisbursementStatusGQLType =
  | 'created'
  | 'paid'
  | 'canceled';

export type InvoiceEntityMetaGQLType = {
  __typename?: 'InvoiceEntityMeta';
  id: Scalars['UUID'];
  dueDate: Scalars['FullDateStr'];
  status: InvoiceStatusGQLType;
  totalAmount: Scalars['Float'];
};

export type InvoiceIdResponseGQLType = {
  __typename?: 'InvoiceIdResponse';
  invoiceId: Scalars['UUID'];
};

export type InvoiceInputGQLType = {
  creditFacilityId: Scalars['UUID'];
  finleyLoanId?: Maybe<Scalars['UUID']>;
  originatingInvoiceId?: Maybe<Scalars['UUID']>;
  paymentSourceOrganizationId: Scalars['UUID'];
  paymentDestinationOrganizationId: Scalars['UUID'];
  sourceBankAccountId?: Maybe<Scalars['UUID']>;
  destinationBankAccountId?: Maybe<Scalars['UUID']>;
  invoiceType: InvoiceTypeGQLType;
  status: InvoiceStatusGQLType;
  totalAmount: Scalars['Float'];
  autoSettle: Scalars['Boolean'];
  memo?: Maybe<Scalars['String']>;
  accrualStartDate: Scalars['FullDateStr'];
  accrualEndDate: Scalars['FullDateStr'];
  targetInvoiceDate?: Maybe<Scalars['FullDateStr']>;
  dueDate: Scalars['FullDateStr'];
  paymentDate?: Maybe<Scalars['FullDateStr']>;
};

export type InvoiceItemGQLType = {
  __typename?: 'InvoiceItem';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  accountingAccountId: Scalars['UUID'];
  amount: Scalars['Float'];
  status?: Maybe<InvoiceItemStatusGQLType>;
  capitalizedLoanId?: Maybe<Scalars['UUID']>;
  finleyAccruedAmount?: Maybe<Scalars['Float']>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  accountingAccount: TAccountGQLType;
};

export type InvoiceItemInputGQLType = {
  accountingAccountId: Scalars['UUID'];
  amount: Scalars['Float'];
  status: InvoiceItemStatusGQLType;
  capitalizedLoanId?: Maybe<Scalars['UUID']>;
  finleyAccruedAmount?: Maybe<Scalars['Float']>;
  accountingAccount: TAccountInputGQLType;
};

export type InvoiceItemStatusGQLType =
  | 'created'
  | 'paid'
  | 'canceled';

export type InvoiceMechanicsGQLType = {
  __typename?: 'InvoiceMechanics';
  single: Array<InvoiceMechanicsOptionGQLType>;
  recurring: Array<InvoiceMechanicsOptionGQLType>;
};

export type InvoiceMechanicsOptionGQLType = {
  __typename?: 'InvoiceMechanicsOption';
  key: Scalars['String'];
  name: Scalars['String'];
};

export type InvoicePaymentInKindItemGQLType = {
  __typename?: 'InvoicePaymentInKindItem';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  invoiceItemId: Scalars['UUID'];
  capitalizedLenderShareId: Scalars['UUID'];
  capitalizedLoanId: Scalars['UUID'];
  totalAmount: Scalars['Float'];
  serviceFeeAmount: Scalars['Float'];
  postServiceFeeTotalAmount: Scalars['Float'];
  status: InvoicePaymentInKindItemStatusGQLType;
  dueDate?: Maybe<Scalars['FullDateStr']>;
  notifiedDate?: Maybe<Scalars['FullDateStr']>;
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  capitalProviderOrganization: EntityIdAndNameGQLType;
  capitalProviderProRata?: Maybe<Scalars['Float']>;
};

export type InvoicePaymentInKindItemStatusGQLType =
  | 'created'
  | 'notified'
  | 'canceled';

export type InvoicePaymentInKindItemsWithMetadataGQLType = {
  __typename?: 'InvoicePaymentInKindItemsWithMetadata';
  invoiceItemId: Scalars['UUID'];
  capitalizedLoanId: Scalars['UUID'];
  capitalizedLoanName: Scalars['String'];
  invoicePaymentInKindItems: Array<InvoicePaymentInKindItemGQLType>;
};

export type InvoiceReportGQLType = {
  __typename?: 'InvoiceReport';
  id: Scalars['UUID'];
  reportType: DownloadableReportTypeGQLType;
  reportName: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  isPreview: Scalars['Boolean'];
  invoiceId?: Maybe<Scalars['UUID']>;
  capitalProviderId?: Maybe<Scalars['UUID']>;
  paymentInKindItemId?: Maybe<Scalars['UUID']>;
  capitalProviderName?: Maybe<Scalars['String']>;
};

export type InvoiceSortFieldGQLType =
  | 'dueDate'
  | 'created_at'
  | 'totalAmount'
  | 'status';

export type InvoiceStatusGQLType =
  | 'created'
  | 'paid'
  | 'canceled';

export type InvoiceStatusAggregateGQLType = {
  __typename?: 'InvoiceStatusAggregate';
  status: Scalars['String'];
  totalAmount: Scalars['Float'];
  count: Scalars['Int'];
};

export type InvoiceStatusEventsCommonSnapshotGQLType = {
  __typename?: 'InvoiceStatusEventsCommonSnapshot';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  originatingInvoiceId?: Maybe<Scalars['UUID']>;
  paymentSourceOrganizationId: Scalars['UUID'];
  paymentDestinationOrganizationId: Scalars['UUID'];
  sourceBankAccountId?: Maybe<Scalars['UUID']>;
  destinationBankAccountId?: Maybe<Scalars['UUID']>;
  status: InvoiceStatusGQLType;
  totalAmount: Scalars['Float'];
  autoSettle: Scalars['Boolean'];
  memo?: Maybe<Scalars['String']>;
  targetInvoiceDate?: Maybe<Scalars['FullDateStr']>;
  dueDate: Scalars['FullDateStr'];
  paymentDate?: Maybe<Scalars['FullDateStr']>;
};

export type InvoiceTaskSpecificPropertiesGQLType = {
  __typename?: 'InvoiceTaskSpecificProperties';
  category: TaskCategoryGQLType;
  invoiceId: Scalars['UUID'];
  invoiceLoanIds: Array<Scalars['UUID']>;
  invoiceDueDate: Scalars['JSDate'];
};

export type InvoiceThreadGQLType = BaseThreadV2GQLType & {
  __typename?: 'InvoiceThread';
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentV2GQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<ThreadLatestActionLogV2GQLType>;
  creditFacility: EventLogCreditFacilityGQLType;
  entityMetadata: InvoiceEntityMetaGQLType;
};

export type InvoiceThreadCreateEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'InvoiceThreadCreateEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: InvoiceEntityMetaGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  current: ThreadCreatedEventSnapshotGQLType;
};

export type InvoiceTypeGQLType =
  | 'creditFacility'
  | 'loan';

export type InvoiceUpdatedEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'InvoiceUpdatedEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: InvoiceEntityMetaGQLType;
  creditFacility: EventLogCreditFacilityGQLType;
  previous: InvoiceStatusEventsCommonSnapshotGQLType;
  current: InvoiceStatusEventsCommonSnapshotGQLType;
};

export type InvoicesConnectionGQLType = {
  __typename?: 'InvoicesConnection';
  nodes: Array<InvoiceGQLType>;
  totalCount: Scalars['Int'];
  pageInfo: PageInfoGQLType;
};

export type InvoicesPaginationInputGQLType = {
  limit: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type IsValidContainerGQLType = {
  __typename?: 'IsValidContainer';
  isValid: Scalars['Boolean'];
  errors?: Maybe<Array<IsValidContainerErrorGQLType>>;
};

export type IsValidContainerErrorGQLType = {
  __typename?: 'IsValidContainerError';
  message: Scalars['String'];
  testReceivableId: Scalars['String'];
};



export type LpFieldConfigGQLType = {
  __typename?: 'LPFieldConfig';
  requiredFields: Array<FieldConfigGQLType>;
};

export type LatestThreadActionLogGQLType = {
  __typename?: 'LatestThreadActionLog';
  user: ThreadActorGQLType;
  actionType: ThreadActionTypeGQLType;
};

export type LedgerAccountGroupGQLType =
  | 'outstandingLedger'
  | 'expensesFees';

export type LedgerBalanceGQLType = {
  __typename?: 'LedgerBalance';
  creditFacilityId: Scalars['UUID'];
  ledgerBalance: Scalars['Float'];
  normalBalance: NormalBalanceTypeGQLType;
};

export type LedgerTransactionGQLType = {
  __typename?: 'LedgerTransaction';
  organizationId: Scalars['UUID'];
  transactionType: TransactionTypeGQLType;
  amount: Scalars['Float'];
  normalizedAmount: Scalars['Float'];
  type: TAccountTypeEnumGQLType;
  accountType: TAccountTypeGQLType;
  postingDate: Scalars['FullDateStr'];
  balance: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
};

export type LedgerTransactionWithCreditFacilityIdGQLType = {
  __typename?: 'LedgerTransactionWithCreditFacilityId';
  creditFacilityId: Scalars['UUID'];
  ledger: LedgerTransactionGQLType;
};

export type LenderShareReportGQLType = {
  __typename?: 'LenderShareReport';
  id: Scalars['String'];
  creditFacilityId: Scalars['String'];
  lenderShareId?: Maybe<Scalars['String']>;
  fundingRequestComponentId?: Maybe<Scalars['String']>;
  reportName: Scalars['String'];
  reportType: DownloadableReportTypeGQLType;
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  isPreview: Scalars['Boolean'];
  capitalProviderName?: Maybe<Scalars['String']>;
};

export type LenderSharesTaskSpecificPropertiesGQLType = {
  __typename?: 'LenderSharesTaskSpecificProperties';
  category: TaskCategoryGQLType;
  lenderSharesId: Scalars['UUID'];
  lenderSharesLoanId: Scalars['UUID'];
  lenderSharesDueDate?: Maybe<Scalars['JSDate']>;
  fundingComponentId: Scalars['UUID'];
};

export type LimitedPartnerGQLType = {
  __typename?: 'LimitedPartner';
  id: Scalars['UUID'];
  name: Scalars['String'];
  alternateAliases: Array<Scalars['String']>;
  ownerOrganizationId: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type LimitedPartnerCapitalTrendDataGQLType = {
  __typename?: 'LimitedPartnerCapitalTrendData';
  finleyReceivableId: Scalars['UUID'];
  committedCapital: Scalars['Float'];
  uncalledCapital: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
};

export type LimitedPartnerCommitmentGQLType = {
  __typename?: 'LimitedPartnerCommitment';
  limitedPartnerAlias: Scalars['String'];
  finleyReceivableId: Scalars['UUID'];
  limitedPartnerId?: Maybe<Scalars['UUID']>;
  limitedPartnerName?: Maybe<Scalars['String']>;
  creditFacilityId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
  borrowerSlug: Scalars['String'];
  borrowerName: Scalars['String'];
  committedCapital: Scalars['Float'];
  uncalledCapital: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
};

export type LimitedPartnerCommitmentDetailGQLType = {
  __typename?: 'LimitedPartnerCommitmentDetail';
  limitedPartnerAlias: Scalars['String'];
  finleyReceivableId: Scalars['UUID'];
  limitedPartnerId?: Maybe<Scalars['UUID']>;
  limitedPartnerName?: Maybe<Scalars['String']>;
  creditFacilityId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
  borrowerSlug: Scalars['String'];
  borrowerName: Scalars['String'];
  committedCapital: Scalars['Float'];
  uncalledCapital: Scalars['Float'];
  recallableCapital: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
  eligibleUncalledCapitalLessKickouts: Scalars['Float'];
  netUncalledCapital: Scalars['Float'];
  percentageOfNetUncalledCapital: Scalars['Float'];
  mappingId: Scalars['UUID'];
  matchedByUserName?: Maybe<Scalars['String']>;
  matchedByUserEmail?: Maybe<Scalars['String']>;
  matchedAt: Scalars['JSDate'];
};

export type LimitedPartnerCreatedEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'LimitedPartnerCreatedEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: LimitedPartnerEntityMetaGQLType;
  /** @deprecated Use entityMetadata field */
  limitedPartner?: Maybe<LimitedPartnerEntityMetaGQLType>;
  current: LimitedPartnerStatusEventsCommonSnapshotGQLType;
};

export type LimitedPartnerEntityMetaGQLType = {
  __typename?: 'LimitedPartnerEntityMeta';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type LimitedPartnerFiltersGQLType = {
  committedCapitalRange: FilterFieldRangeGQLType;
  uncalledCapitalRange: FilterFieldRangeGQLType;
  netUncalledCapitalRange: FilterFieldRangeGQLType;
};

export type LimitedPartnerMappingForAliasingGQLType = {
  __typename?: 'LimitedPartnerMappingForAliasing';
  mappingId: Scalars['UUID'];
  limitedPartnerId?: Maybe<Scalars['UUID']>;
  limitedPartnerName?: Maybe<Scalars['String']>;
  matchedByUserName?: Maybe<Scalars['String']>;
  matchedByUserEmail?: Maybe<Scalars['String']>;
  externalReceivableId: Scalars['String'];
  limitedPartnerAlias: Scalars['String'];
  committedCapital: Scalars['Float'];
  loanProductId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  ownerOrganizationId: Scalars['UUID'];
  matchMetadataId: Scalars['UUID'];
};

export type LimitedPartnerMappingMatchEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'LimitedPartnerMappingMatchEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: LimitedPartnerEntityMetaGQLType;
  /** @deprecated Use entityMetadata field */
  limitedPartner?: Maybe<LimitedPartnerEntityMetaGQLType>;
  current: LimitedPartnerMatchEventsCommonSnapshotGQLType;
};

export type LimitedPartnerMappingUnmatchEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'LimitedPartnerMappingUnmatchEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: LimitedPartnerEntityMetaGQLType;
  /** @deprecated Use entityMetadata field */
  limitedPartner?: Maybe<LimitedPartnerEntityMetaGQLType>;
  previous: LimitedPartnerMatchEventsCommonSnapshotGQLType;
};

export type LimitedPartnerMappingsByCreditFacilityGQLType = {
  __typename?: 'LimitedPartnerMappingsByCreditFacility';
  creditFacilityId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
  mappings: Array<LimitedPartnerMappingForAliasingGQLType>;
};

export type LimitedPartnerMatchEventsCommonSnapshotGQLType = {
  __typename?: 'LimitedPartnerMatchEventsCommonSnapshot';
  matchMetadataId: Scalars['UUID'];
  mappingId: Scalars['UUID'];
  limitedPartnerId: Scalars['UUID'];
};

export type LimitedPartnerPortfolioOverviewGraphDataGQLType = {
  __typename?: 'LimitedPartnerPortfolioOverviewGraphData';
  totalPrincipalBalance: Scalars['Float'];
  totalUncalledCapital: Scalars['Float'];
  totalCommittedCapital: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
};

export type LimitedPartnerPortfolioSummaryGQLType = {
  __typename?: 'LimitedPartnerPortfolioSummary';
  totalCommittedCapital: Scalars['Float'];
  totalUncalledCapital: Scalars['Float'];
  limitedPartnerCount: Scalars['Int'];
  commitmentCount: Scalars['Int'];
};

export type LimitedPartnerStatusEventsCommonSnapshotGQLType = {
  __typename?: 'LimitedPartnerStatusEventsCommonSnapshot';
  id: Scalars['UUID'];
  name: Scalars['String'];
  otherNames?: Maybe<Array<Scalars['String']>>;
  ownerOrganizationId: Scalars['UUID'];
  parentEntityId?: Maybe<Scalars['String']>;
};

export type LimitedPartnerThreadGQLType = BaseThreadV2GQLType & {
  __typename?: 'LimitedPartnerThread';
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentV2GQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<ThreadLatestActionLogV2GQLType>;
  entityMetadata: LimitedPartnerEntityMetaGQLType;
};

export type LimitedPartnerThreadCreateEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'LimitedPartnerThreadCreateEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: LimitedPartnerEntityMetaGQLType;
  current: ThreadCreatedEventSnapshotGQLType;
};

export type LimitedPartnerUpdatedEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'LimitedPartnerUpdatedEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: LimitedPartnerEntityMetaGQLType;
  /** @deprecated Use entityMetadata field */
  limitedPartner?: Maybe<LimitedPartnerEntityMetaGQLType>;
  previous: LimitedPartnerStatusEventsCommonSnapshotGQLType;
  current: LimitedPartnerStatusEventsCommonSnapshotGQLType;
};

export type LinkTokenGQLType = {
  __typename?: 'LinkToken';
  token: Scalars['String'];
  needsUpdate: Scalars['Boolean'];
  institutionName?: Maybe<Scalars['String']>;
  plaidItemId?: Maybe<Scalars['UUID']>;
};

export type LoanAccountAccrualObjectGQLType = {
  __typename?: 'LoanAccountAccrualObject';
  tAccount: TAccountGQLType;
  actualAccruedAmount: Scalars['Float'];
  projectedAccruedAmount: Scalars['Float'];
  totalAccruedAmount: Scalars['Float'];
};

export type LoanAccrualCadenceGQLType = {
  __typename?: 'LoanAccrualCadence';
  type: Scalars['String'];
};

export type LoanActionGQLType =
  | 'edit';

export type LoanActionRecordGQLType = {
  __typename?: 'LoanActionRecord';
  id: Scalars['UUID'];
  action: LoanActionGQLType;
  status: LoanActionStatusGQLType;
  submittedUserId?: Maybe<Scalars['UUID']>;
  approvedUserId?: Maybe<Scalars['UUID']>;
  creditFacilityId: Scalars['UUID'];
  metadata?: Maybe<Scalars['Object']>;
};

export type LoanActionStatusGQLType =
  | 'submitted'
  | 'executed'
  | 'canceled'
  | 'approved'
  | 'rejected';

export type LoanAggregateMetadataGQLType = {
  __typename?: 'LoanAggregateMetadata';
  totalOutstandingBalance: Scalars['Float'];
  totalAccruedInterest: Scalars['Float'];
  totalAccruedServiceFees: Scalars['Float'];
};

export type LoanBalanceGQLType = {
  __typename?: 'LoanBalance';
  loanId: Scalars['String'];
  commitmentKey: Scalars['String'];
  amount: Scalars['Float'];
};

export type LoanDatesDataGQLType = {
  __typename?: 'LoanDatesData';
  originationDate: Scalars['FullDateStr'];
  targetFundingDate: Scalars['FullDateStr'];
  settledDate?: Maybe<Scalars['FullDateStr']>;
  maturityDate: Scalars['FullDateStr'];
};

export type LoanEditDataGQLType = {
  __typename?: 'LoanEditData';
  source?: Maybe<LoanEditSourceDataGQLType>;
  destination?: Maybe<LoanEditDestinationDataGQLType>;
};

export type LoanEditDestinationDataGQLType = {
  __typename?: 'LoanEditDestinationData';
  loanId: Scalars['UUID'];
  loanAction: LoanActionRecordGQLType;
};

export type LoanEditSourceDataGQLType = {
  __typename?: 'LoanEditSourceData';
  loanId: Scalars['UUID'];
  loanAction: LoanActionRecordGQLType;
};

export type LoanFacilityDataGQLType = {
  __typename?: 'LoanFacilityData';
  commitmentAmount: Scalars['Float'];
  creditFacilityId: Scalars['String'];
  creditFacilityName: Scalars['String'];
  externalFacilityId?: Maybe<Scalars['String']>;
  loanMechanics: Scalars['Object'];
};

export type LoanFeesGQLType = {
  __typename?: 'LoanFees';
  accruedInterest: AccruedInterestAndFeesSummaryGQLType;
  projectedInterest: Scalars['Float'];
  accruedServiceFees: AccruedInterestAndFeesSummaryGQLType;
  projectedServiceFees: Scalars['Float'];
  totalAccruedInterestAndFees: AccruedInterestAndFeesSummaryGQLType;
};

export type LoanFundingDataGQLType = {
  __typename?: 'LoanFundingData';
  commitmentKey: Scalars['String'];
  initialFundingAmount: Scalars['Float'];
  totalOutstandingBalance?: Maybe<Scalars['Float']>;
  lenderShares: Array<FundingLenderSharesGQLType>;
  requests: Array<FundingRequestEntitiesGQLType>;
};

export type LoanInterestRateBaseConfigurationGQLType = {
  __typename?: 'LoanInterestRateBaseConfiguration';
  type: Scalars['String'];
  name: Scalars['String'];
  determinationDate: Scalars['FullDateStr'];
  publishedDate: Scalars['FullDateStr'];
  publishedRate: Scalars['Float'];
  adjustedRate: Scalars['Float'];
  ceiling?: Maybe<Scalars['Float']>;
  floor?: Maybe<Scalars['Float']>;
  spread?: Maybe<Scalars['Float']>;
};

export type LoanInterestRateConfigurationGQLType = {
  __typename?: 'LoanInterestRateConfiguration';
  effectiveDate: Scalars['FullDateStr'];
  allInRate: Scalars['Float'];
  baseRate: LoanInterestRateBaseConfigurationGQLType;
  weightedAverageMarginRate: Scalars['Float'];
};

export type LoanInvoiceGQLType = {
  __typename?: 'LoanInvoice';
  nextInvoiceId?: Maybe<Scalars['String']>;
  nextPaymentDate?: Maybe<Scalars['FullDateStr']>;
  mostRecentPaymentDate?: Maybe<Scalars['FullDateStr']>;
  mostRecentInterestPaymentDate?: Maybe<Scalars['FullDateStr']>;
  mostRecentAccrualEndDate?: Maybe<Scalars['FullDateStr']>;
};

export type LoanMetadataFilterParamsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  capitalProviderIds?: Maybe<Array<Scalars['UUID']>>;
  calculatedLoanStatuses?: Maybe<Array<CalculatedLoanStatusGQLType>>;
  maturityDates?: Maybe<StartEndOptionalDateStrMapGQLType>;
  createdAtDates?: Maybe<StartEndOptionalDateStrMapGQLType>;
  isFinal?: Maybe<Scalars['Boolean']>;
};

export type LoanMetricsForInvoiceGQLType = {
  __typename?: 'LoanMetricsForInvoice';
  latestFundTransferDate?: Maybe<Scalars['FullDateStr']>;
  hasPrincipalPayment: Scalars['Boolean'];
};

export type LoanNameAndExternalIdGQLType = {
  __typename?: 'LoanNameAndExternalId';
  loanName: Scalars['String'];
  loanId: Scalars['String'];
  externalLoanId?: Maybe<Scalars['String']>;
};

export type LoanPartiesDataGQLType = {
  __typename?: 'LoanPartiesData';
  borrowerOrganization: BaseOrganizationGQLType;
  adminAgentOrganization?: Maybe<BaseOrganizationGQLType>;
  lenderOrganizations: Array<BaseOrganizationGQLType>;
};

export type LoanPricingGQLType = {
  __typename?: 'LoanPricing';
  key: Scalars['String'];
  name: Scalars['String'];
  accrual: LoanPricingAccrualGQLType;
  current: LoanInterestRateConfigurationGQLType;
  history: Array<LoanInterestRateConfigurationGQLType>;
  margins: Array<LoanShareMarginGQLType>;
};

export type LoanPricingAccrualGQLType = {
  __typename?: 'LoanPricingAccrual';
  basis: Scalars['String'];
  cadence: LoanAccrualCadenceGQLType;
};

export type LoanProductGQLType = {
  __typename?: 'LoanProduct';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  implementationId: Scalars['String'];
  currentMasterLoanTape?: Maybe<MasterLoanTapeMetadataGQLType>;
  currentCreditFacilities?: Maybe<Array<CreditFacilityGQLType>>;
};

export type LoanProductCalculationGQLType = {
  __typename?: 'LoanProductCalculation';
  loanProductId: Scalars['String'];
  loanProductName: Scalars['String'];
  balanceSheetExposure?: Maybe<Scalars['Float']>;
  eligibleExposureForCreditFacilities: Array<EligibleExposureForCreditFacilityGQLType>;
};

export type LoanProductCriteriaGQLType = {
  __typename?: 'LoanProductCriteria';
  id: Scalars['String'];
  assignmentStrategyId: Scalars['String'];
  creditFacilityId: Scalars['String'];
  loanProductId: Scalars['String'];
  exclusionSqlClause: Scalars['String'];
};

export type LoanProductCriteriaInputGQLType = {
  creditFacilityId: Scalars['String'];
  loanProductId: Scalars['String'];
  exclusionSqlClause: Scalars['String'];
};

export type LoanRecordGQLType = {
  __typename?: 'LoanRecord';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  borrowerOrganizationId: Scalars['UUID'];
  externalLoanId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  loanStatus: LoanStatusGQLType;
  loanType: LoanTypeGQLType;
  isFinal: Scalars['Boolean'];
  maturityDate: Scalars['FullDateStr'];
};

export type LoanShareMarginGQLType = {
  __typename?: 'LoanShareMargin';
  organizationId: Scalars['String'];
  rate: Scalars['Float'];
  /** @deprecated Use skimFee instead */
  serviceFee?: Maybe<Scalars['Float']>;
  skimFee?: Maybe<SkimFeeGQLType>;
};

export type LoanStatusGQLType =
  | 'pending'
  | 'canceled'
  | 'initiated'
  | 'funded'
  | 'pendingEdit'
  | 'overriddenFromEdit'
  | 'canceledEdit';

export type LoanTapeConfigGQLType = {
  __typename?: 'LoanTapeConfig';
  artifactType: ArtifactTypeGQLType;
  loanProductSlug: Scalars['String'];
};

export type LoanTapeMetadataGQLType = {
  __typename?: 'LoanTapeMetadata';
  commitmentAmount?: Maybe<Scalars['Float']>;
  principalBalance?: Maybe<Scalars['Float']>;
  drawRequestAmountForCalendarMonth?: Maybe<Scalars['Float']>;
  lastApprovedOrSubmittedFundingRequestDate?: Maybe<Scalars['FullDateStr']>;
  reportingDate?: Maybe<Scalars['FullDateStr']>;
  fileVersion?: Maybe<Scalars['Int']>;
  configuredActiveWaivers?: Maybe<Array<ReceivableWaiverTestKeyStringsGQLType>>;
  portfolioCovenants?: Maybe<Array<Scalars['Object']>>;
  customerProvidedValues?: Maybe<Array<Scalars['Object']>>;
};

export type LoanTapeSanitizeConfigGQLType = {
  __typename?: 'LoanTapeSanitizeConfig';
  loanProductSlug: Scalars['String'];
  sanitizeArtifactSlug: Scalars['String'];
  rawExternalReceivableIdField: Scalars['String'];
  baseFields: Scalars['String'];
};

export type LoanTapeSanitizeConfigInputGQLType = {
  loanProductSlug: Scalars['String'];
  sanitizeArtifactSlug: Scalars['String'];
  rawExternalReceivableIdField: Scalars['String'];
  baseFields: Scalars['String'];
};

export type LoanTapeTypeGQLType =
  | 'preassignedLoanTape'
  | 'masterLoanTape'
  | 'preassignedMasterLoanTape';

export type LoanTypeGQLType =
  | 'origination'
  | 'extension'
  | 'rollover';

export type LoanWithExternalLoanIdGQLType = {
  __typename?: 'LoanWithExternalLoanId';
  id: Scalars['String'];
  externalLoanId?: Maybe<Scalars['String']>;
};

export type LocalizedLabelGQLType = {
  __typename?: 'LocalizedLabel';
  labelKey: Scalars['String'];
  localizedValue: Scalars['String'];
};

export type LocalizedLabelsGQLType = {
  __typename?: 'LocalizedLabels';
  scope: Scalars['String'];
  labels: Array<LocalizedLabelGQLType>;
};

export type LpCfReassignmentInputGQLType = {
  creditFacilityId?: Maybe<Scalars['String']>;
  loanProductId: Scalars['String'];
};

export type LpToCfEntityGroupingGQLType = {
  __typename?: 'LpToCfEntityGrouping';
  implementationId: Scalars['String'];
  loanProducts: Array<LoanProductGQLType>;
  creditFacilities: Array<CreditFacilityGQLType>;
  pipelineInfo: PipelineInfoForGroupingGQLType;
};


export type MarkInvoiceAsPaidResponseGQLType = {
  __typename?: 'MarkInvoiceAsPaidResponse';
  invoiceId: Scalars['UUID'];
};

export type MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType = {
  __typename?: 'MarkInvoiceConsolidatedDisbursementAsPaidResponse';
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
};

export type MarkInvoiceDisbursementAsPaidResponseGQLType = {
  __typename?: 'MarkInvoiceDisbursementAsPaidResponse';
  invoiceDisbursementId: Scalars['UUID'];
};

export type MarkInvoicePaymentInKindItemAsNotifiedResponseGQLType = {
  __typename?: 'MarkInvoicePaymentInKindItemAsNotifiedResponse';
  invoicePaymentInKindItemId: Scalars['UUID'];
};

export type MasterLoanTapeIdGQLType = {
  __typename?: 'MasterLoanTapeId';
  masterLoanTapeId: Scalars['String'];
};

export type MasterLoanTapeMetadataGQLType = {
  __typename?: 'MasterLoanTapeMetadata';
  id: Scalars['String'];
  fileVersion: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
};

export type MaterializedViewConfigurationGQLType = {
  __typename?: 'MaterializedViewConfiguration';
  viewTableName: Scalars['String'];
  dataConfigString: Scalars['String'];
  refreshConfigString: Scalars['String'];
  statusDetails: StatusDetailsGQLType;
  lastRefreshedAt?: Maybe<Scalars['JSDate']>;
  lastRefreshedSource?: Maybe<RefreshSourceGQLType>;
  deletedAt?: Maybe<Scalars['JSDate']>;
  organizationId: Scalars['UUID'];
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type MaterializedViewEvaluateAccessorResponseGQLType = {
  __typename?: 'MaterializedViewEvaluateAccessorResponse';
  schemaItems: Array<SchemaItemGQLType>;
  accessorResults: Array<Scalars['Object']>;
  errors: Array<Scalars['String']>;
};

export type MaterializedViewEvaluateWorkleaseGQLType = {
  materializedViewConfigId: Scalars['UUID'];
  type: MaterializedViewWorkleaseTypeGQLType;
  configString?: Maybe<Scalars['String']>;
};

export type MaterializedViewResponseGQLType = {
  __typename?: 'MaterializedViewResponse';
  status: MaterializedViewResponseStatusGQLType;
  type: MaterializedViewWorkleaseTypeGQLType;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type MaterializedViewResponseStatusGQLType =
  | 'success'
  | 'failed';

export type MaterializedViewWorkleaseTypeGQLType =
  | 'create'
  | 'refresh'
  | 'delete';

export type MaximumDrawRequestFrequencyMetadataGQLType = {
  __typename?: 'MaximumDrawRequestFrequencyMetadata';
  limitReached: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type MeshRunMetadataGQLType = {
  __typename?: 'MeshRunMetadata';
  meshRunId: Scalars['String'];
  meshDocumentId: Scalars['String'];
  borrowerOrganizationId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};

export type MeshRunParamsGQLType = {
  meshDocumentId: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};

export type MonthlyServicerReportConfigGQLType = {
  __typename?: 'MonthlyServicerReportConfig';
  artifactType: ArtifactTypeGQLType;
  reportName: Scalars['String'];
};

export type MonthlyStatementConfigGQLType = {
  __typename?: 'MonthlyStatementConfig';
  artifactType: ArtifactTypeGQLType;
  reportingPeriodStartDateFormula: Scalars['String'];
  reportingPeriodEndDateFormula: Scalars['String'];
};

export type MutationGQLType = {
  __typename?: 'Mutation';
  acknowledgeForAllDates: Array<Scalars['String']>;
  acknowledgeForSpecificDates: Array<Scalars['String']>;
  addAttributeToList: Scalars['Boolean'];
  addBankAccount: ResponseWithStringGQLType;
  adjudicateFundingRequestVerificationReport: ResponseWithStringGQLType;
  adjustCurrentLiability: AccountingAdjustmentResponseGQLType;
  allocateFundingRequestTargetAmounts: FundingRequestAllocationsGQLType;
  approveAndExecuteLoanEdit: Scalars['Boolean'];
  approveFundingRequest: FundingRequestResponseGQLType;
  bulkReassignTasks: Array<TaskEntityGQLType>;
  cancelFundingRequest: FundingRequestResponseGQLType;
  cancelLoanEdit: Scalars['Boolean'];
  commitArtifactDocumentAndCreditAgreements: SuccessesAndErrorsGQLType;
  commitCreditAgreementWipToSandbox: CommitWipToSandboxResponseGQLType;
  completeFinalOutputDeliverableArtifactInstance: CompleteFinalOutputDeliverableArtifactInstanceResultGQLType;
  connectPlaidItem: BankDataProviderInstitutionGQLType;
  connectTellerAccountsForInstitution: BankDataProviderInstitutionGQLType;
  createAssetVerificationDocument: ResponseWithStringGQLType;
  createAssetVerificationRecord: ResponseWithStringGQLType;
  createAssignmentServicerReportPreview: ResponseWithStringGQLType;
  createAssignmentServicerReportPreviewV1: ResponseWithStringGQLType;
  createAthenaQueryRecord: AthenaQueryRecordGQLType;
  createAttribute: AttributeGQLType;
  createBatchSettlement: Array<BatchSettlementSubmissionResultGQLType>;
  createCDQ: CreateCdqResponseGQLType;
  createClone: CreateCloneResponseGQLType;
  createComment: Scalars['UUID'];
  createCreditFacility?: Maybe<CreditFacilityGQLType>;
  createDeliverableArtifactInstance: DeliverableArtifactInstanceGQLType;
  createExploPlacementIntegration: ExploPlacementIntegrationGQLType;
  createFinStatementLineItem: ResponseWithStringGQLType;
  createFundingRequest: FundingRequestResponseGQLType;
  createImplementation: ImplementationGQLType;
  createInvoiceWithInvoiceItems: CreateInvoiceResponseGQLType;
  createLimitedPartner: LimitedPartnerGQLType;
  createLoanProduct: LoanProductGQLType;
  createMaterializedViewConfigRecord: MaterializedViewConfigurationGQLType;
  createMaterializedViewTableDevOnly: MaterializedViewResponseGQLType;
  createOrUpdateAssignmentStrategy: AssignmentStrategyGQLType;
  createOrUpdateConfig: CreateConfigResponseGQLType;
  createOrUpdateCustomerProvidedValue: ResponseWithStringGQLType;
  createOrUpdateLatestAttributeValue: ResponseWithStringGQLType;
  createOrgProvidedInput: OrgProvidedInputGQLType;
  createOrgProvidedInputs: Array<OrgProvidedInputGQLType>;
  createOrgProvidedValue: OrgProvidedValueGQLType;
  createPreassignedInternalLoanTapesFromManualAssignment: Scalars['String'];
  createPreassignedInternalLoanTapesFromPreviewMetadata: Scalars['String'];
  createRailzIntegration: RailzIntegrationGQLType;
  createReceivableResponseTapePreviewsFromAssignmentStrategy: Scalars['String'];
  createReceivableResponseTapePreviewsFromPayload: ResponseWithStringGQLType;
  createServicerReportPreview: ResponseWithStringGQLType;
  createServicerReportPreviewFromFundingRequest: ResponseWithStringGQLType;
  createSingleFacilityImplementation: ImplementationGQLType;
  createThread: ThreadGQLType;
  createThreadAction: ThreadGQLType;
  createThreadActionV2: ThreadV2GQLType;
  createThreadV2: ThreadV2GQLType;
  createUser?: Maybe<UserObjectGQLType>;
  createWorkflowTemplate: ValidateAndCreateWorkflowTemplateResponseGQLType;
  deactivateBankAccount: ResponseWithStringGQLType;
  deactivateCdqConfig: DeactivateCdqConfigResponseGQLType;
  deactivateSlackInstallationForChannel?: Maybe<ResponseWithStringGQLType>;
  deactivateSlackInstallationsForOrganization?: Maybe<ResponseWithStringGQLType>;
  deleteAssignmentStrategy: AssignmentStrategyGQLType;
  deleteAttribute: Scalars['Boolean'];
  deleteBorrowingBasePipelineArtifactDocumentWip: ResponseWithStringGQLType;
  deleteDeliverableRecordsForContainerId: Scalars['String'];
  deleteExploPlacementIntegration: Scalars['Boolean'];
  deleteFinStatement?: Maybe<ResponseWithStringGQLType>;
  deleteFinStatementLineItem: ResponseWithStringGQLType;
  deleteMaterializedViewTableAndConfigDevOnly: MaterializedViewResponseGQLType;
  deleteReceivableWaivers: ResponseWithStringGQLType;
  deliverableContainerReceipt: Scalars['UUID'];
  deliverableContainerReceiptAction: Scalars['UUID'];
  disconnectPlaidItem: PlaidResponseGQLType;
  disconnectRailzIntegration: RailzIntegrationGQLType;
  disconnectTellerInstitution: TellerDisconnectInstitutionPayloadGQLType;
  editBankAccount: ResponseWithStringGQLType;
  evaluateDevFinCovWorklease: EvaluateFinancialCovenantsResponseGQLType;
  evaluateDevPortfolioCovenantWorklease: EvaluatePortfolioCovenantsDevResponseGQLType;
  evaluatePortfolioCovenants: EvaluatePortfolioCovenantsResponseGQLType;
  executeValleyIbsApiRecord: ValleyIbsApiRecordGQLType;
  failedDeliverableArtifactInstance: DeliverableArtifactInstanceGQLType;
  fetchAndUploadFinancialDataFromRailz: Scalars['Int'];
  generateReceiptForDeliverableContainer: Scalars['String'];
  generateReportingOutputFileDevOnly: ReportingGenerateResponseGQLType;
  importOrgProvidedValues: ResponseWithStringGQLType;
  initiateReceivableReassignmentFromAthenaQuery: ReassignmentConfirmationJobInfoGQLType;
  initiateReceivableReassignmentFromDataPipeline: ReassignmentConfirmationJobInfoGQLType;
  login?: Maybe<AuthGQLType>;
  manuallyCreateDeliverableByDueDate: DeliverableContainerGQLType;
  markInvoiceAsCanceled?: Maybe<InvoiceIdResponseGQLType>;
  markInvoiceAsPaid: MarkInvoiceAsPaidResponseGQLType;
  markInvoiceConsolidatedDisbursementAsPaid: MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType;
  markInvoiceDisbursementAsPaid: MarkInvoiceDisbursementAsPaidResponseGQLType;
  markInvoicePaymentInKindItemAsNotified: MarkInvoicePaymentInKindItemAsNotifiedResponseGQLType;
  markLenderShareComponentFundTransferDate: Scalars['Boolean'];
  notifyNewCommentForDeliverableContainer: Scalars['String'];
  notifyVerificationReportReadyForReview: ResponseWithStringGQLType;
  produceFinancialCovenantWorkleaseMessage: ProduceFinancialCovenantWorkleaseResponseGQLType;
  produceFinleyAiWorklease: FinleyAiResponseGQLType;
  produceMvEvaluateWorkleaseQueueMessage: MaterializedViewResponseGQLType;
  produceReportingGenerateMessage: ReportingGenerateResponseGQLType;
  produceReportingGenerateMessages: Array<ReportingGenerateResponseGQLType>;
  reUploadLoanTape: ResponseWithStringGQLType;
  reactivateSlackInstallationForChannel?: Maybe<ResponseWithStringGQLType>;
  reconnectPlaidItem: PlaidResponseGQLType;
  reconnectTellerInstitution: BankDataProviderInstitutionGQLType;
  refreshDeliverable: RefreshDeliverableResponseGQLType;
  refreshMaterializedViewDataDevOnly: MaterializedViewResponseGQLType;
  refreshPlaidInstitutionAccounts: BankDataProviderInstitutionGQLType;
  refreshTellerInstitution: BankDataProviderInstitutionGQLType;
  rejectFundingRequest: FundingRequestResponseGQLType;
  removeAttributeFromList: Scalars['Boolean'];
  removeCreditAgreementFullArtifactWip: ResponseWithStringGQLType;
  removeUser: Scalars['UUID'];
  requestApprovalForFundingRequest: FundingRequestResponseGQLType;
  restoreValleyBankReportingDate: Scalars['String'];
  retryValleyIbsApiRecord: ValleyIbsApiRecordGQLType;
  reverseInvoicePayment?: Maybe<UpdateInvoiceResponseGQLType>;
  saveBorrowingBasePipelineArtifactDocumentWip: ResponseWithStringGQLType;
  setLoanTapeSanitizeConfigs: ResponseWithStringGQLType;
  setNodePositions: Scalars['String'];
  signup?: Maybe<AuthGQLType>;
  submitFundingRequest: FundingRequestWithFullDetailsGQLType;
  submitLoanEditRequest: Scalars['Boolean'];
  submitMonthlyStatementDeliverable: DeliverableArtifactInstanceGQLType;
  submitValleyBankAssignmentQueue: Array<Scalars['String']>;
  subscribeToEmailType?: Maybe<EmailSubscriptionResponseGQLType>;
  unAcknowledge: Scalars['Boolean'];
  undoMarkInvoiceConsolidatedDisbursementAsPaid: MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType;
  undoPipelineRun: ResponseWithStringGQLType;
  unsubscribeToEmailType?: Maybe<EmailSubscriptionResponseGQLType>;
  updateAssignmentStrategiesDefault: AssignmentStrategyGQLType;
  updateAthenaQueryRecord: AthenaQueryRecordGQLType;
  updateAttribute: AttributeGQLType;
  updateClientCreditAgreementFullArtifactImplementationPortalWip: ResponseWithStringGQLType;
  updateClientCreditAgreementFullArtifactWip: ResponseWithStringGQLType;
  updateCreditAgreementDisplayName: ResponseWithStringGQLType;
  updateCreditAgreementFullArtifactWip: ResponseWithStringGQLType;
  updateCreditFacilityIsActive: ResponseWithStringGQLType;
  updateCreditFacilityName: CreditFacilityGQLType;
  updateDocumentName: ResponseWithStringGQLType;
  updateDocumentToLatestPublished: ResponseWithStringGQLType;
  updateExploPlacementIntegration: ExploPlacementIntegrationGQLType;
  updateFinStatementLineItem: ResponseWithStringGQLType;
  updateFundingVerificationReceivableEligibility: ResponseWithStringGQLType;
  updateImplementationName: ImplementationGQLType;
  updateInvoiceDueDate?: Maybe<UpdateInvoiceResponseGQLType>;
  updateLimitedPartner: LimitedPartnerGQLType;
  updateLimitedPartnerMapping: UpdateLimitedPartnerMappingResponseGQLType;
  updateLoanExternalLoanId: LoanRecordGQLType;
  updateLoanProductName: LoanProductGQLType;
  updateReceivableWaivers: ResponseWithStringGQLType;
  updateSubscriptionToEmailType?: Maybe<ResponseWithStringGQLType>;
  updateTaskProperties: TaskEntityGQLType;
  updateUserSettings?: Maybe<ResponseWithStringGQLType>;
  updateUserSettingsWithRole?: Maybe<UserObjectGQLType>;
  uploadCreditAgreementToKnowledgeBase: ResponseWithStringGQLType;
  upsertImplementationPortalBankAccount: BankAccountWithInstitutionAndOwnerGQLType;
  upsertUserTablePreference: TablePreferenceGQLType;
  userApprovalActionForFundingRequestWorkflowInstance: FundingRequestResponseGQLType;
  valleyBankAddToAssignmentsQueue: Array<Scalars['String']>;
  valleyBankDeleteFromAssignmentQueue: Scalars['String'];
};


export type MutationAcknowledgeForAllDatesArgsGQLType = {
  cdqId: Scalars['UUID'];
  receivableIds: Array<Scalars['UUID']>;
};


export type MutationAcknowledgeForSpecificDatesArgsGQLType = {
  cdqId: Scalars['UUID'];
  acknowledgements: Array<SpecificDateAcknowledgementGQLType>;
};


export type MutationAddAttributeToListArgsGQLType = {
  attributeId: Scalars['UUID'];
  listName: Scalars['String'];
};


export type MutationAddBankAccountArgsGQLType = {
  bankInstitutionId: Scalars['UUID'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
  routingNumber: Scalars['String'];
  implementationId: Scalars['UUID'];
  ownerId: Scalars['UUID'];
};


export type MutationAdjudicateFundingRequestVerificationReportArgsGQLType = {
  verificationReportId: Scalars['UUID'];
  action: VerificationReportAdjudicationActionGQLType;
  note?: Maybe<Scalars['String']>;
};


export type MutationAdjustCurrentLiabilityArgsGQLType = {
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  counterpartyOrganizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  currentLiabilityAccount: Scalars['String'];
  date: Scalars['FullDateStr'];
  type: AdjustCurrentLiabilityTypesGQLType;
};


export type MutationAllocateFundingRequestTargetAmountsArgsGQLType = {
  fundingRequestTotalAmountsChangeset: UpdateFundingRequestTotalAmountsGQLType;
};


export type MutationApproveAndExecuteLoanEditArgsGQLType = {
  originalLoanId: Scalars['UUID'];
  newLoanId: Scalars['UUID'];
  loanActionId: Scalars['UUID'];
  approvedUserId: Scalars['UUID'];
};


export type MutationApproveFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type MutationBulkReassignTasksArgsGQLType = {
  taskIds: Array<Scalars['UUID']>;
  newAssignedUserId: Scalars['UUID'];
};


export type MutationCancelFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type MutationCancelLoanEditArgsGQLType = {
  loanActionId: Scalars['UUID'];
};


export type MutationCommitArtifactDocumentAndCreditAgreementsArgsGQLType = {
  borrowerId?: Maybe<Scalars['UUID']>;
  pipelineDefinitionId?: Maybe<Scalars['UUID']>;
  creditFacilityId?: Maybe<Scalars['UUID']>;
};


export type MutationCommitCreditAgreementWipToSandboxArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type MutationCompleteFinalOutputDeliverableArtifactInstanceArgsGQLType = {
  artifactInstanceId: Scalars['UUID'];
};


export type MutationConnectPlaidItemArgsGQLType = {
  publicToken: Scalars['String'];
  plaidInstitutionId: Scalars['String'];
};


export type MutationConnectTellerAccountsForInstitutionArgsGQLType = {
  accessToken: Scalars['String'];
};


export type MutationCreateAssetVerificationDocumentArgsGQLType = {
  receivableDocumentationRawId: Scalars['UUID'];
  assetVerificationDocument: Scalars['String'];
  note: Scalars['String'];
};


export type MutationCreateAssetVerificationRecordArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  artifactDocumentId: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
};


export type MutationCreateAssignmentServicerReportPreviewArgsGQLType = {
  assignmentServicerReportPreviewInput: AssignmentServicerReportPreviewInputGQLType;
};


export type MutationCreateAssignmentServicerReportPreviewV1ArgsGQLType = {
  assignmentServicerReportPreviewInput: AssignmentServicerReportPreviewInputV1GQLType;
};


export type MutationCreateAthenaQueryRecordArgsGQLType = {
  organizationId: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  parameterizedQuery: Scalars['Object'];
};


export type MutationCreateAttributeArgsGQLType = {
  input: CreateAttributeInputGQLType;
};


export type MutationCreateBatchSettlementArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  lenderIds: Array<Scalars['UUID']>;
  loanIds: Array<Scalars['UUID']>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type MutationCreateCdqArgsGQLType = {
  name: Scalars['String'];
  decodedQuery: Scalars['String'];
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
};


export type MutationCreateCloneArgsGQLType = {
  input: CloneParametersInputGQLType;
};


export type MutationCreateCommentArgsGQLType = {
  threadId: Scalars['UUID'];
  comment: Scalars['String'];
};


export type MutationCreateCreditFacilityArgsGQLType = {
  slug: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  implementationId: Scalars['UUID'];
  capitalProviderIds: Array<Scalars['UUID']>;
  capitalProviderRepresentativeIds: Array<Scalars['UUID']>;
  type: FacilityTypeGQLType;
};


export type MutationCreateDeliverableArtifactInstanceArgsGQLType = {
  deliverableArtifactId: Scalars['UUID'];
  active?: Maybe<Scalars['Boolean']>;
  status: ArtifactInstanceStatusGQLType;
  rawDatabase?: Maybe<DeliverableDatabaseGQLType>;
  rawNamespace?: Maybe<DeliverableRawNamespaceGQLType>;
  rawIdentifier?: Maybe<Scalars['String']>;
  completedDatabase?: Maybe<DeliverableDatabaseGQLType>;
  completedNamespace?: Maybe<DeliverableExternalNamespaceGQLType>;
  completedIdentifier?: Maybe<Scalars['String']>;
};


export type MutationCreateExploPlacementIntegrationArgsGQLType = {
  createParams: CreateExploPlacementIntegrationParamsGQLType;
};


export type MutationCreateFinStatementLineItemArgsGQLType = {
  finStatementLineItem: CreateFinStatementLineItemInputGQLType;
};


export type MutationCreateFundingRequestArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type MutationCreateImplementationArgsGQLType = {
  ownerOrganizationId: Scalars['UUID'];
  implementationName: Scalars['String'];
  borrowerId: Scalars['UUID'];
};


export type MutationCreateInvoiceWithInvoiceItemsArgsGQLType = {
  invoice: InvoiceInputGQLType;
  invoiceComponentsWithInvoiceItems: Array<InvoiceComponentWithInvoiceItemsInputGQLType>;
};


export type MutationCreateLimitedPartnerArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
  name: Scalars['String'];
  attributeValues?: Maybe<Array<CreateOrUpdateLimitedPartnerLatestAttributeValueInputGQLType>>;
};


export type MutationCreateLoanProductArgsGQLType = {
  name: Scalars['String'];
  slug: Scalars['String'];
  implementationId: Scalars['UUID'];
};


export type MutationCreateMaterializedViewConfigRecordArgsGQLType = {
  viewTableName: Scalars['String'];
  dataConfigString: Scalars['String'];
  refreshConfigString: Scalars['String'];
  organizationId: Scalars['UUID'];
};


export type MutationCreateMaterializedViewTableDevOnlyArgsGQLType = {
  materializedViewConfigId: Scalars['UUID'];
};


export type MutationCreateOrUpdateAssignmentStrategyArgsGQLType = {
  strategyName: Scalars['String'];
  description: Scalars['String'];
  implementationId: Scalars['UUID'];
  strategyId?: Maybe<Scalars['UUID']>;
  loanProductCriteria: Array<LoanProductCriteriaInputGQLType>;
  loanProductCriteriaIdsToDelete: Array<Scalars['String']>;
  eligibilityExclusions: Array<EligibilityExclusionInputGQLType>;
  eligibilityExclusionIdsToDelete: Array<Scalars['String']>;
  decisionHeuristicConfig: Scalars['String'];
};


export type MutationCreateOrUpdateConfigArgsGQLType = {
  entitySlug: Scalars['String'];
  configType: Scalars['String'];
  config: Scalars['String'];
};


export type MutationCreateOrUpdateCustomerProvidedValueArgsGQLType = {
  attributeId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  value: AttributeValueInputGQLType;
};


export type MutationCreateOrUpdateLatestAttributeValueArgsGQLType = {
  input: CreateOrUpdateLatestAttributeValueInputGQLType;
};


export type MutationCreateOrgProvidedInputArgsGQLType = {
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  type: OrgProvidedInputTypeGQLType;
  nullable: Scalars['Boolean'];
};


export type MutationCreateOrgProvidedInputsArgsGQLType = {
  orgProvidedInputs: Array<OrgProvidedInputInputGQLType>;
};


export type MutationCreateOrgProvidedValueArgsGQLType = {
  orgProvidedInputId: Scalars['UUID'];
  value?: Maybe<Scalars['Primitive']>;
  reportingDate: Scalars['FullDateStr'];
  supplementalS3Path?: Maybe<Scalars['String']>;
};


export type MutationCreatePreassignedInternalLoanTapesFromManualAssignmentArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
  signaledAssignments: Array<SignaledAssignmentsInputGQLType>;
};


export type MutationCreatePreassignedInternalLoanTapesFromPreviewMetadataArgsGQLType = {
  implementationId: Scalars['String'];
  previewIdentifier: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  receivableResponseTapePreviewJobId: Scalars['String'];
};


export type MutationCreateRailzIntegrationArgsGQLType = {
  organizationId: Scalars['UUID'];
  railzBusinessId: Scalars['String'];
  railzConnectionId: Scalars['String'];
  railzServiceName: RailzAccountingServiceNamesGQLType;
};


export type MutationCreateReceivableResponseTapePreviewsFromAssignmentStrategyArgsGQLType = {
  implementationId: Scalars['UUID'];
  strategyId: Scalars['UUID'];
};


export type MutationCreateReceivableResponseTapePreviewsFromPayloadArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
  signaledAssignments: Array<SignaledAssignmentsInputGQLType>;
};


export type MutationCreateServicerReportPreviewArgsGQLType = {
  fundingRequestChangeset: UpdateFundingRequestChangesetGQLType;
};


export type MutationCreateServicerReportPreviewFromFundingRequestArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type MutationCreateSingleFacilityImplementationArgsGQLType = {
  ownerOrganizationId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
  creditFacilityParties: Array<PartyInputGQLType>;
};


export type MutationCreateThreadArgsGQLType = {
  comment: Scalars['String'];
  isPinned?: Maybe<Scalars['Boolean']>;
  participatingOrganizationIds: Array<Scalars['UUID']>;
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
};


export type MutationCreateThreadActionArgsGQLType = {
  threadId: Scalars['UUID'];
  action: ThreadActionGQLType;
};


export type MutationCreateThreadActionV2ArgsGQLType = {
  threadId: Scalars['UUID'];
  action: ThreadActionGQLType;
};


export type MutationCreateThreadV2ArgsGQLType = {
  comment: Scalars['String'];
  isPinned?: Maybe<Scalars['Boolean']>;
  participatingOrganizationIds: Array<Scalars['UUID']>;
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
};


export type MutationCreateUserArgsGQLType = {
  userData: CreateUserGQLType;
};


export type MutationCreateWorkflowTemplateArgsGQLType = {
  workflowId: Scalars['UUID'];
  workflowType: WorkflowTypeGQLType;
  workflow: WorkflowGraphObjectInputGQLType;
  name: Scalars['String'];
  organizationId: Scalars['UUID'];
  authorUserId: Scalars['UUID'];
};


export type MutationDeactivateBankAccountArgsGQLType = {
  bankAccountId: Scalars['UUID'];
};


export type MutationDeactivateCdqConfigArgsGQLType = {
  id: Scalars['UUID'];
};


export type MutationDeactivateSlackInstallationForChannelArgsGQLType = {
  teamId: Scalars['String'];
  incomingWebhookChannelId: Scalars['String'];
  organizationId: Scalars['UUID'];
};


export type MutationDeleteAssignmentStrategyArgsGQLType = {
  assignmentStrategyId: Scalars['UUID'];
};


export type MutationDeleteAttributeArgsGQLType = {
  attributeId: Scalars['UUID'];
};


export type MutationDeleteBorrowingBasePipelineArtifactDocumentWipArgsGQLType = {
  pipelineDefinitionId: Scalars['UUID'];
  artifactDocumentId: Scalars['UUID'];
};


export type MutationDeleteDeliverableRecordsForContainerIdArgsGQLType = {
  containerId: Scalars['UUID'];
};


export type MutationDeleteExploPlacementIntegrationArgsGQLType = {
  exploPlacementIntegrationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};


export type MutationDeleteFinStatementArgsGQLType = {
  finStatementId: Scalars['UUID'];
};


export type MutationDeleteFinStatementLineItemArgsGQLType = {
  finStatementLineItemId: Scalars['UUID'];
};


export type MutationDeleteMaterializedViewTableAndConfigDevOnlyArgsGQLType = {
  materializedViewConfigId: Scalars['UUID'];
};


export type MutationDeleteReceivableWaiversArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  receivableWaivers: Array<ReceivableBorrowingBaseTestWaiverInputGQLType>;
};


export type MutationDeliverableContainerReceiptArgsGQLType = {
  containerId: Scalars['UUID'];
  receipt: ReceiptColumnInputGQLType;
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
};


export type MutationDeliverableContainerReceiptActionArgsGQLType = {
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  receiptId: Scalars['UUID'];
  action: ReceiptActionTypePostCreationGQLType;
  commentId?: Maybe<Scalars['UUID']>;
};


export type MutationDisconnectPlaidItemArgsGQLType = {
  plaidItemId: Scalars['UUID'];
};


export type MutationDisconnectRailzIntegrationArgsGQLType = {
  railzIntegrationId: Scalars['UUID'];
};


export type MutationDisconnectTellerInstitutionArgsGQLType = {
  tellerItemId: Scalars['String'];
};


export type MutationEditBankAccountArgsGQLType = {
  bankAccountId: Scalars['UUID'];
  accountName: Scalars['String'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
  ownerId: Scalars['UUID'];
};


export type MutationEvaluateDevFinCovWorkleaseArgsGQLType = {
  worklease: FinancialCovenantInputWorkleaseGQLType;
};


export type MutationEvaluateDevPortfolioCovenantWorkleaseArgsGQLType = {
  worklease: EvaluatePortfolioCovenantsRequestGQLType;
};


export type MutationEvaluatePortfolioCovenantsArgsGQLType = {
  evaluatePortfolioCovenantsRequest: EvaluatePortfolioCovenantsRequestGQLType;
};


export type MutationExecuteValleyIbsApiRecordArgsGQLType = {
  ibsApiRecordId: Scalars['UUID'];
  loanId?: Maybe<Scalars['UUID']>;
};


export type MutationFailedDeliverableArtifactInstanceArgsGQLType = {
  instanceId: Scalars['UUID'];
};


export type MutationFetchAndUploadFinancialDataFromRailzArgsGQLType = {
  railzIntegrationId: Scalars['UUID'];
  queryParamInputs: RailzFinancialApiQueryParamsGQLType;
};


export type MutationGenerateReceiptForDeliverableContainerArgsGQLType = {
  containerId: Scalars['UUID'];
  fixedInputDependencies: Array<Scalars['UUID']>;
  userId: Scalars['UUID'];
};


export type MutationGenerateReportingOutputFileDevOnlyArgsGQLType = {
  worklease: ReportingGenerateWorkleaseGQLType;
  parameters?: Maybe<Scalars['Object']>;
};


export type MutationImportOrgProvidedValuesArgsGQLType = {
  orgProvidedValues: Array<OrgProvidedValueImportInputGQLType>;
};


export type MutationInitiateReceivableReassignmentFromAthenaQueryArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId?: Maybe<Scalars['UUID']>;
  reportingDatesRange?: Maybe<FullDateStrDateRangeInputGQLType>;
  queryFilters?: Maybe<Scalars['String']>;
  finleyReceivableIdsToInclude: Array<Scalars['UUID']>;
  finleyReceivableIdsToExclude: Array<Scalars['UUID']>;
  allQueryRowsSelected: Scalars['Boolean'];
  reassignmentInfo: Array<LpCfReassignmentInputGQLType>;
};


export type MutationInitiateReceivableReassignmentFromDataPipelineArgsGQLType = {
  loanProductSlug: Scalars['String'];
  implementationId: Scalars['UUID'];
  externalReceivableIds: Array<Scalars['String']>;
  creditFacilitySlug?: Maybe<Scalars['String']>;
};


export type MutationLoginArgsGQLType = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationManuallyCreateDeliverableByDueDateArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  configKey: Scalars['String'];
  dueDate: Scalars['FullDateStr'];
};


export type MutationMarkInvoiceAsCanceledArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type MutationMarkInvoiceAsPaidArgsGQLType = {
  invoiceId: Scalars['UUID'];
  invoicePaymentDate: Scalars['FullDateStr'];
};


export type MutationMarkInvoiceConsolidatedDisbursementAsPaidArgsGQLType = {
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
  paymentDate: Scalars['FullDateStr'];
};


export type MutationMarkInvoiceDisbursementAsPaidArgsGQLType = {
  invoiceDisbursementId: Scalars['UUID'];
  disbursementDate: Scalars['FullDateStr'];
};


export type MutationMarkInvoicePaymentInKindItemAsNotifiedArgsGQLType = {
  invoicePaymentInKindItemId: Scalars['UUID'];
  notifiedDate: Scalars['FullDateStr'];
};


export type MutationMarkLenderShareComponentFundTransferDateArgsGQLType = {
  lenderShareId: Scalars['UUID'];
  fundingRequestComponentId: Scalars['UUID'];
  fundTransferDate?: Maybe<Scalars['FullDateStr']>;
};


export type MutationNotifyNewCommentForDeliverableContainerArgsGQLType = {
  commentId: Scalars['UUID'];
  containerId: Scalars['UUID'];
  receiptId?: Maybe<Scalars['UUID']>;
};


export type MutationNotifyVerificationReportReadyForReviewArgsGQLType = {
  verificationReportId: Scalars['UUID'];
};


export type MutationProduceFinancialCovenantWorkleaseMessageArgsGQLType = {
  worklease: FinancialCovenantInputWorkleaseGQLType;
};


export type MutationProduceFinleyAiWorkleaseArgsGQLType = {
  params: FinleyAiRequestGQLType;
};


export type MutationProduceMvEvaluateWorkleaseQueueMessageArgsGQLType = {
  worklease: MaterializedViewEvaluateWorkleaseGQLType;
};


export type MutationProduceReportingGenerateMessageArgsGQLType = {
  worklease: ReportingGenerateWorkleaseGQLType;
  parameters?: Maybe<Scalars['Object']>;
};


export type MutationProduceReportingGenerateMessagesArgsGQLType = {
  workleases: Array<ReportingGenerateWorkleaseGQLType>;
};


export type MutationReUploadLoanTapeArgsGQLType = {
  implementationId: Scalars['UUID'];
  artifactId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  currentArtifactInstanceId: Scalars['UUID'];
};


export type MutationReactivateSlackInstallationForChannelArgsGQLType = {
  teamId: Scalars['String'];
  incomingWebhookChannelId: Scalars['String'];
  organizationId: Scalars['UUID'];
};


export type MutationReconnectPlaidItemArgsGQLType = {
  plaidItemId: Scalars['UUID'];
};


export type MutationReconnectTellerInstitutionArgsGQLType = {
  tellerItemId: Scalars['String'];
};


export type MutationRefreshDeliverableArgsGQLType = {
  deliverableContainerId: Scalars['UUID'];
};


export type MutationRefreshMaterializedViewDataDevOnlyArgsGQLType = {
  materializedViewConfigId: Scalars['UUID'];
  refreshSource: RefreshSourceGQLType;
};


export type MutationRefreshPlaidInstitutionAccountsArgsGQLType = {
  plaidItemId: Scalars['UUID'];
};


export type MutationRefreshTellerInstitutionArgsGQLType = {
  tellerItemId: Scalars['String'];
};


export type MutationRejectFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type MutationRemoveAttributeFromListArgsGQLType = {
  attributeId: Scalars['UUID'];
  listName: Scalars['String'];
};


export type MutationRemoveCreditAgreementFullArtifactWipArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type MutationRemoveUserArgsGQLType = {
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};


export type MutationRequestApprovalForFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
  workflowInstanceId: Scalars['UUID'];
  approverUserId: Scalars['UUID'];
};


export type MutationRestoreValleyBankReportingDateArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
};


export type MutationRetryValleyIbsApiRecordArgsGQLType = {
  existingIbsApiRecordId: Scalars['UUID'];
  loanId?: Maybe<Scalars['UUID']>;
};


export type MutationReverseInvoicePaymentArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type MutationSaveBorrowingBasePipelineArtifactDocumentWipArgsGQLType = {
  pipelineDefinitionId: Scalars['UUID'];
  artifactsDocumentString: Scalars['String'];
};


export type MutationSetLoanTapeSanitizeConfigsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  sanitizeConfigs: Array<LoanTapeSanitizeConfigInputGQLType>;
};


export type MutationSetNodePositionsArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  purpose: NodePositionPurposeGQLType;
  positions: Array<NodePositionInputGQLType>;
};


export type MutationSignupArgsGQLType = {
  email: Scalars['String'];
  userType: UserTypeGQLType;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationSubmitFundingRequestArgsGQLType = {
  fundingRequestChangeset: UpdateFundingRequestChangesetGQLType;
};


export type MutationSubmitLoanEditRequestArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  originalLoanId: Scalars['UUID'];
  proposedUserId: Scalars['UUID'];
  loanAttributes: EditLoanAttributesGQLType;
  fundingRequestChangesets: Array<EditFundingRequestChangesetGQLType>;
};


export type MutationSubmitMonthlyStatementDeliverableArgsGQLType = {
  deliverableArtifactId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingPeriodStartDate: Scalars['FullDateStr'];
  reportingPeriodEndDate: Scalars['FullDateStr'];
  asOfTimestamp: Scalars['JSDate'];
  deliverableArtifactInstanceId?: Maybe<Scalars['UUID']>;
};


export type MutationSubscribeToEmailTypeArgsGQLType = {
  userId: Scalars['UUID'];
  emailType: EmailTypeGQLType;
  creditFacilitySlugs: Array<Scalars['String']>;
};


export type MutationUnAcknowledgeArgsGQLType = {
  cdqId: Scalars['UUID'];
  receivableIds: Array<Scalars['UUID']>;
};


export type MutationUndoMarkInvoiceConsolidatedDisbursementAsPaidArgsGQLType = {
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
};


export type MutationUndoPipelineRunArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};


export type MutationUnsubscribeToEmailTypeArgsGQLType = {
  userId: Scalars['UUID'];
  emailSubscriptionId: Scalars['UUID'];
};


export type MutationUpdateAssignmentStrategiesDefaultArgsGQLType = {
  assignmentStrategyId: Scalars['UUID'];
  isDefault: Scalars['Boolean'];
};


export type MutationUpdateAthenaQueryRecordArgsGQLType = {
  id: Scalars['String'];
  description: Scalars['String'];
  parameterizedQuery: Scalars['Object'];
};


export type MutationUpdateAttributeArgsGQLType = {
  attributeId: Scalars['UUID'];
  input: UpdateAttributeInputGQLType;
};


export type MutationUpdateClientCreditAgreementFullArtifactImplementationPortalWipArgsGQLType = {
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactInputGQLType;
};


export type MutationUpdateClientCreditAgreementFullArtifactWipArgsGQLType = {
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactInputGQLType;
};


export type MutationUpdateCreditAgreementDisplayNameArgsGQLType = {
  displayName: Scalars['String'];
  creditAgreementId: Scalars['UUID'];
};


export type MutationUpdateCreditAgreementFullArtifactWipArgsGQLType = {
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactInputGQLType;
};


export type MutationUpdateCreditFacilityIsActiveArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  isActive: Scalars['Boolean'];
};


export type MutationUpdateCreditFacilityNameArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationUpdateDocumentNameArgsGQLType = {
  documentId: Scalars['UUID'];
  newDocumentName: Scalars['String'];
};


export type MutationUpdateDocumentToLatestPublishedArgsGQLType = {
  documentId: Scalars['UUID'];
};


export type MutationUpdateExploPlacementIntegrationArgsGQLType = {
  exploPlacementIntegrationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  updateParams: UpdateExploPlacementIntegrationParamsGQLType;
};


export type MutationUpdateFinStatementLineItemArgsGQLType = {
  updateInput: UpdateFinStatementLineItemInputGQLType;
};


export type MutationUpdateFundingVerificationReceivableEligibilityArgsGQLType = {
  receivableEligibility: Array<UpdateFundingVerificationReceivableEligibilityChangesetGQLType>;
};


export type MutationUpdateImplementationNameArgsGQLType = {
  implementationId: Scalars['UUID'];
  name: Scalars['String'];
};


export type MutationUpdateInvoiceDueDateArgsGQLType = {
  invoiceId: Scalars['UUID'];
  newDueDate: Scalars['FullDateStr'];
};


export type MutationUpdateLimitedPartnerArgsGQLType = {
  limitedPartnerId: Scalars['UUID'];
  updates: UpdateLimitedPartnerGQLType;
};


export type MutationUpdateLimitedPartnerMappingArgsGQLType = {
  limitedPartnerMappingId: Scalars['UUID'];
  limitedPartnerId?: Maybe<Scalars['UUID']>;
};


export type MutationUpdateLoanExternalLoanIdArgsGQLType = {
  loanId: Scalars['UUID'];
  newExternalLoanId?: Maybe<Scalars['String']>;
};


export type MutationUpdateLoanProductNameArgsGQLType = {
  id: Scalars['UUID'];
  newName: Scalars['String'];
};


export type MutationUpdateReceivableWaiversArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  receivableWaivers: Array<ReceivableBorrowingBaseTestWaiverInputGQLType>;
};


export type MutationUpdateSubscriptionToEmailTypeArgsGQLType = {
  userId: Scalars['UUID'];
  emailType: EmailTypeGQLType;
  creditFacilitySlugs: Array<Scalars['String']>;
};


export type MutationUpdateTaskPropertiesArgsGQLType = {
  taskId: Scalars['UUID'];
  newDueDate?: Maybe<Scalars['FullDateStr']>;
  newAssignedUserId?: Maybe<Scalars['UUID']>;
};


export type MutationUpdateUserSettingsArgsGQLType = {
  id: Scalars['UUID'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationUpdateUserSettingsWithRoleArgsGQLType = {
  settings: UpdateUserSettingsGQLType;
};


export type MutationUploadCreditAgreementToKnowledgeBaseArgsGQLType = {
  creditFacilityDocumentId: Scalars['UUID'];
};


export type MutationUpsertImplementationPortalBankAccountArgsGQLType = {
  implementationId: Scalars['UUID'];
  ownerId: Scalars['UUID'];
  accountType: AccountTypeGQLType;
};


export type MutationUpsertUserTablePreferenceArgsGQLType = {
  tablePreference: TablePreferenceInputGQLType;
  defaultTableColumnConfiguration: DefaultTableColumnConfigurationInputGQLType;
};


export type MutationUserApprovalActionForFundingRequestWorkflowInstanceArgsGQLType = {
  action: UserApprovalActionGQLType;
  userId: Scalars['UUID'];
  fundingRequestId: Scalars['UUID'];
  workflowInstanceId: Scalars['UUID'];
};


export type MutationValleyBankAddToAssignmentsQueueArgsGQLType = {
  records: Array<ValleyBankAddToAssignmentQueueGQLType>;
};


export type MutationValleyBankDeleteFromAssignmentQueueArgsGQLType = {
  assignmentQueueId: Scalars['String'];
};

export type NewThreadWithCommentInputGQLType = {
  organizationIds: Array<Scalars['UUID']>;
  comment: Scalars['String'];
  isPinned?: Maybe<Scalars['Boolean']>;
};

export type NodePositionGQLType = {
  __typename?: 'NodePosition';
  artifactIdentifier: Scalars['String'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type NodePositionInputGQLType = {
  artifactIdentifier: Scalars['String'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type NodePositionPurposeGQLType =
  | 'tapeBuilderEdit'
  | 'dataPipeline';

export type NormalBalanceTypeGQLType =
  | 'debit'
  | 'credit';

export type NotificationTypeGQLType =
  | 'borrowingBaseReportGenerated'
  | 'dataTapeIngestionErrors'
  | 'deliverablesDueSoon'
  | 'deliverablesNewComment'
  | 'deliverablesReportLenderReviewResult'
  | 'deliverablesReportReadyForReview'
  | 'deliverablesReportGeneratedResult'
  | 'deliverablesResponsiblePartyReminder'
  | 'deliverablesResponsiblePartySubmitSubmission'
  | 'deliverablesResponsiblePartyStatusUpdate'
  | 'fundingRequestApproval'
  | 'fundingRequestAutoGenerated'
  | 'fundingRequestExpired'
  | 'fundingRequestPostSubmit'
  | 'invoiceCalculationComparison'
  | 'portfolioCovenantQaResult'
  | 'metricAlert'
  | 'masterTrustPortfolioOverview'
  | 'missingPipelineInputs'
  | 'monthlyServicerReportResult'
  | 'verificationReportCreatedBorrower'
  | 'verificationReportReadyForReviewBorrower'
  | 'verificationReportReadyForReviewCapitalProvider'
  | 'receivablesSaleAgreementGenerated'
  | 'successfulIbsTransactionIngest'
  | 'remediationRequestedBorrowerAction'
  | 'remediationRequestedCapitalProviderReceipt'
  | 'verificationReportAdjudicationAction'
  | 'deliverableStatusUpdate'
  | 'workflowGenericNotifyApproval';

export type NumberOptionsGQLType = {
  __typename?: 'NumberOptions';
  label: Scalars['String'];
  numberValue: Scalars['Int'];
};

export type NumberRuntimeVariableTemplateGQLType = {
  __typename?: 'NumberRuntimeVariableTemplate';
  name: Scalars['String'];
  returnType: RuntimeVariableReturnTypeGQLType;
  options: Array<NumberOptionsGQLType>;
};

export type NumberStaticParamTemplateGQLType = {
  __typename?: 'NumberStaticParamTemplate';
  variableName: Scalars['String'];
  variableType: ActionParamVariableTypeGQLType;
  options: Array<NumberOptionsGQLType>;
};


export type OffsetInfoGQLType = {
  __typename?: 'OffsetInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  offset: Scalars['Int'];
};

export type OrgPreferencesGQLType = {
  __typename?: 'OrgPreferences';
  cashBalancePreference?: Maybe<CashBalancePreferenceEnumGQLType>;
};

export type OrgProvidedInputGQLType = {
  __typename?: 'OrgProvidedInput';
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  type: OrgProvidedInputTypeGQLType;
  nullable: Scalars['Boolean'];
};

export type OrgProvidedInputByReportingDateGQLType = {
  __typename?: 'OrgProvidedInputByReportingDate';
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Float'];
  orgProvidedInputValue: Scalars['Primitive'];
};

export type OrgProvidedInputConfigGQLType = {
  __typename?: 'OrgProvidedInputConfig';
  artifactType: ArtifactTypeGQLType;
  key: Scalars['String'];
  bbplArtifactSlug?: Maybe<Scalars['String']>;
};

export type OrgProvidedInputInputGQLType = {
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  type: OrgProvidedInputTypeGQLType;
  nullable: Scalars['Boolean'];
};

export type OrgProvidedInputInputValuesGQLType = {
  __typename?: 'OrgProvidedInputInputValues';
  type: PostgresQueryTypeGQLType;
  inputValues: Array<OrgProvidedInputByReportingDateGQLType>;
};

export type OrgProvidedInputTypeGQLType =
  | 'string'
  | 'number'
  | 'boolean'
  | 'fullDateStr';

export type OrgProvidedValueGQLType = {
  __typename?: 'OrgProvidedValue';
  id: Scalars['UUID'];
  orgProvidedInputId: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  supplementalS3Path?: Maybe<Scalars['String']>;
};

export type OrgProvidedValueImportInputGQLType = {
  orgProvidedInputId: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  supplementalS3Path?: Maybe<Scalars['String']>;
};

export type OrganizationGQLType = {
  __typename?: 'Organization';
  id: Scalars['UUID'];
  name: Scalars['String'];
  type: OrganizationTypeEnumGQLType;
  slug: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  users: Array<UserGQLType>;
  visibleOrganizations: Array<BaseOrganizationGQLType>;
  implementations: Array<ImplementationGQLType>;
  /** @deprecated use implementations */
  implementationsAsBorrower: Array<ImplementationGQLType>;
  loanProducts: Array<LoanProductGQLType>;
  creditFacilities: Array<CreditFacilityGQLType>;
  loanProductCreditFacilityGroupsForAssignment: Array<LpToCfEntityGroupingGQLType>;
  /** @deprecated use implementations resolver */
  inactiveCreditFacilities: Array<CreditFacilityGQLType>;
  currentCreditAgreementArtifacts: Array<CreditAgreementArtifactGQLType>;
  orgPreferences?: Maybe<OrgPreferencesGQLType>;
};

export type OrganizationInsightsParamInputGQLType = {
  organizationId: Scalars['UUID'];
  reportingDateStart: Scalars['FullDateStr'];
  reportingDateEnd: Scalars['FullDateStr'];
  limit?: Maybe<Scalars['Int']>;
};

export type OrganizationTypeEnumGQLType =
  | 'adminAgent'
  | 'backupServicer'
  | 'borrower'
  | 'capitalProvider'
  | 'capitalProviderRepresentative'
  | 'collectionAccountBank'
  | 'payingAgent'
  | 'servicer'
  | 'special'
  | 'verificationAgent';

export type OutstandingBalanceGQLType = {
  __typename?: 'OutstandingBalance';
  organizationId: Scalars['String'];
  amount: Scalars['Float'];
};

export type PageInfoGQLType = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export type PaginatedResultsWithCountsGQLType = {
  __typename?: 'PaginatedResultsWithCounts';
  Items: Array<CdqResultItemGQLType>;
  NextToken?: Maybe<Scalars['String']>;
  QueryExecutionId: Scalars['String'];
  totalUnAcknowledgedIssueCount: Scalars['Int'];
  totalAcknowledgedIssueCount: Scalars['Int'];
};

export type PaginationInfoGQLType = {
  __typename?: 'PaginationInfo';
  totalCount: Scalars['Int'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export type PaginationOptionsGQLType = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type PartialBorrowingBaseReportGQLType = {
  __typename?: 'PartialBorrowingBaseReport';
  id: Scalars['UUID'];
  borrowingBaseAvailability?: Maybe<Scalars['Float']>;
  cashAdvanceRate: Scalars['Float'];
  commitmentAmount: Scalars['Float'];
  effectiveAdvanceRate?: Maybe<Scalars['Float']>;
  currentPrincipalBalance: Scalars['Float'];
  totalCash: Scalars['Float'];
  borrowingBaseAmountAssets: Scalars['Float'];
  totalBorrowingBaseAmount: Scalars['Float'];
  totalMaxAdvanceAmount: Scalars['Float'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  maxReceivableAdvanceAmount: Scalars['Float'];
  cashReserveAmount?: Maybe<Scalars['Float']>;
  borrowingBaseReserveAmount?: Maybe<Scalars['Float']>;
  borrowingBaseUtilization: Scalars['Float'];
  weightedAverageReceivableAdvanceRate: Scalars['Float'];
  totalEligibleBorrowingBaseAccountCash: Scalars['Float'];
  totalAssets: Scalars['Float'];
  totalCollectionsAccountCash?: Maybe<Scalars['Float']>;
  totalCashBorrowingBaseAmount?: Maybe<Scalars['Float']>;
  borrowingBaseAvailabilityRate?: Maybe<Scalars['Float']>;
  maximumAvailableAmount?: Maybe<Scalars['Float']>;
  assignedEligibleExposureSinceLastApprovedFundingRequest?: Maybe<Scalars['Float']>;
};

export type PartyInputGQLType = {
  organizationId: Scalars['UUID'];
  partyType: PartyTypeGQLType;
};

export type PartyPropertiesGQLType = {
  __typename?: 'PartyProperties';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type PartyTypeGQLType =
  | 'adminAgent'
  | 'backupServicer'
  | 'borrower'
  | 'capitalProvider'
  | 'capitalProviderRepresentative'
  | 'collectionAccountBank'
  | 'payingAgent'
  | 'servicer'
  | 'verificationAgent';

export type PayloadGQLType = FundingRequestPayloadGQLType | FundingRequestComponentPayloadGQLType | DeliverablesPayloadGQLType | IngestionPayloadGQLType | InsertedDeliverablePayloadGQLType | UpdatedDeliverableStatusPayloadGQLType | SubmittedDeliverableSubmissionPayloadGQLType | VerificationPayloadGQLType;

export type PaymentInKindServicingFeeDetailsGQLType = {
  __typename?: 'PaymentInKindServicingFeeDetails';
  creditFacilityId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
  capitalProviderId: Scalars['UUID'];
  capitalProviderName: Scalars['String'];
  originatingLoanId: Scalars['UUID'];
  originatingLoanName: Scalars['String'];
  originatingExternalLoanId?: Maybe<Scalars['String']>;
  capitalizedLoanId: Scalars['UUID'];
  capitalizedLoanName: Scalars['String'];
  capitalizedExternalLoanId?: Maybe<Scalars['String']>;
  serviceFeeAmount: Scalars['Float'];
  invoicePaymentDate: Scalars['FullDateStr'];
  invoiceUpdatedAt: Scalars['JSDate'];
  report?: Maybe<InvoiceReportGQLType>;
  runningBalance: Scalars['Float'];
};

export type PdfAnalysisParamsGQLType = {
  buffer: Scalars['String'];
  questions: Array<PdfQuestionGQLType>;
};

export type PdfAnalysisResponseGQLType = {
  __typename?: 'PdfAnalysisResponse';
  answers: Array<PdfAnswerGQLType>;
  rawResponse: Scalars['JSON'];
};

export type PdfAnswerGQLType = {
  __typename?: 'PdfAnswer';
  value?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  confidence: Scalars['Float'];
  pageNumber: Scalars['Int'];
};

export type PdfQuestionGQLType = {
  question: Scalars['String'];
  pageNumbers: Array<Scalars['Int']>;
};

export type PendingLoanEditsResponseGQLType = {
  __typename?: 'PendingLoanEditsResponse';
  loanAction: LoanActionRecordGQLType;
  sourceLoan: LoanRecordGQLType;
  destinationLoan: LoanRecordGQLType;
};

export type PercentageRateAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'PercentageRateAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
  validation: AttributeValuePercentageRateValidationGQLType;
};

export type PipelineInfoForGroupingGQLType = {
  __typename?: 'PipelineInfoForGrouping';
  status?: Maybe<AssignmentPipelineStatusEnumGQLType>;
  latestCompletedPreviewJob?: Maybe<AssignmentPreviewJobGQLType>;
};

export type PipelineInstancesGQLType = {
  __typename?: 'PipelineInstances';
  artifactDocumentId?: Maybe<Scalars['UUID']>;
  artifactInstances: Array<BorrowingBasePipelineArtifactInstanceGQLType>;
};

export type PipelineRunGQLType = {
  __typename?: 'PipelineRun';
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  pipelineRunId: Scalars['UUID'];
  artifactDocumentId: Scalars['UUID'];
};

export type PipelineRunWithArtifactIdsGQLType = {
  __typename?: 'PipelineRunWithArtifactIds';
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  uploadedArtifactIds: Array<Scalars['UUID']>;
};

export type PlaidResponseGQLType = {
  __typename?: 'PlaidResponse';
  plaidResponse: Scalars['String'];
};

export type PortfolioCovenantConfigGQLType = {
  __typename?: 'PortfolioCovenantConfig';
  artifactType: ArtifactTypeGQLType;
  covenantKey: Scalars['String'];
};

export type PortfolioCovenantMetadataGQLType = {
  __typename?: 'PortfolioCovenantMetadata';
  errors: Array<Scalars['String']>;
};

export type PortfolioCovenantResultResultGQLType =
  | 'PASS'
  | 'FAIL'
  | 'LEVEL_1_FAIL'
  | 'LEVEL_2_FAIL'
  | 'LEVEL_3_FAIL'
  | 'LEVEL_4_FAIL'
  | 'LEVEL_5_FAIL'
  | 'LEVEL_6_FAIL'
  | 'LEVEL_7_FAIL'
  | 'LEVEL_8_FAIL'
  | 'LEVEL_9_FAIL'
  | 'LEVEL_10_FAIL';

export type PortfolioCovenantStatusGQLType =
  | 'initialized'
  | 'success'
  | 'error';

export type PortfolioCovenantVariableGQLType = {
  __typename?: 'PortfolioCovenantVariable';
  name: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
};

export type PortfolioCovenantWorkleaseModeGQLType =
  | 'QA'
  | 'RESULT';

export type PostProcessedFieldsGQLType = {
  __typename?: 'PostProcessedFields';
  originalOwnerId: Scalars['String'];
  normalizedExposure: Scalars['Float'];
  preassignmentCreditFacilityId?: Maybe<Scalars['String']>;
  performingExposure?: Maybe<Scalars['Float']>;
};

export type PostProcessedFieldsForCreditFacilityGQLType = {
  __typename?: 'PostProcessedFieldsForCreditFacility';
  creditFacilityId: Scalars['String'];
  postProcessedFields: PostProcessedFieldsGQLType;
};

export type PostgresQueryGQLType = {
  name: Scalars['String'];
  variables: Array<QueryVariableGQLType>;
  type: PostgresQueryTypeGQLType;
  resultType: ResultTypeGQLType;
  parameterConfig: Scalars['Object'];
};

export type PostgresQueryInputValuesGQLType = PrincipalBalanceDailyAverageInputValuesGQLType | TAccountsSumInputValuesGQLType | OrgProvidedInputInputValuesGQLType;

export type PostgresQueryResultWithWarningsAndInputsGQLType = {
  __typename?: 'PostgresQueryResultWithWarningsAndInputs';
  result: QueryResultGQLType;
  warnings: Array<Scalars['String']>;
  inputs?: Maybe<PostgresQueryInputValuesGQLType>;
};

export type PostgresQueryTypeGQLType =
  | 'principalBalanceDailyAverage'
  | 'principalBalancePointInTime'
  | 'tAccountsSum'
  | 'orgProvidedInput';

export type PresignedPostGQLType = {
  __typename?: 'PresignedPost';
  url: Scalars['String'];
  s3RequestFields: Scalars['JSON'];
  queryResponseFields: Scalars['JSON'];
};

export type PricingOptionGQLType = {
  __typename?: 'PricingOption';
  key: Scalars['String'];
  name: Scalars['String'];
  lookbackDays: Scalars['Int'];
  invoiceMechanics: InvoiceMechanicsGQLType;
};


export type PrincipalBalanceDailyAverageInputValuesGQLType = {
  __typename?: 'PrincipalBalanceDailyAverageInputValues';
  type: PostgresQueryTypeGQLType;
  inputValues: Array<ElementByDateGQLType>;
};

export type PrincipalPaymentMetricsGQLType = {
  __typename?: 'PrincipalPaymentMetrics';
  latestExpectedDate?: Maybe<Scalars['FullDateStr']>;
  latestPaymentDate?: Maybe<Scalars['FullDateStr']>;
  loanHasPayment: Scalars['Boolean'];
};

export type ProduceFinancialCovenantWorkleaseResponseGQLType = {
  __typename?: 'ProduceFinancialCovenantWorkleaseResponse';
  response: Scalars['String'];
  financialCovenantKeyToIdMap: Array<FinancialCovenantKeyToIdMapGQLType>;
};

export type PyCsvVirtualSheetExtractionParamsGQLType = {
  csvDetails: Array<CsvVirtualSheetCsvDetailsGQLType>;
  virtualSheet: Array<Array<Maybe<Scalars['SqlPrimitive']>>>;
};

export type PyXlxs2CsvExtractionParamsGQLType = {
  sheetName: Scalars['String'];
  columns?: Maybe<Scalars['String']>;
  headerRow?: Maybe<Scalars['Int']>;
  numRows?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<PythonXlsx2CsvValueGQLType>>;
};

export type PyXlxsVirtualSheet2CsvExtractionParamsGQLType = {
  sheets: Array<SheetInputGQLType>;
  virtualSheet: Array<Array<Maybe<Scalars['SqlPrimitive']>>>;
};

export type PythonXlsx2CsvValueGQLType = {
  name: Scalars['String'];
  rowIndex: Scalars['Int'];
  columnIndex: Scalars['Int'];
};

export type QueryGQLType = {
  __typename?: 'Query';
  actionableFundingVerificationPipelineRuns: Array<FundingVerificationPipelineRunGQLType>;
  activeSlackInstallations: Array<SlackInstallationGQLType>;
  aggregatedAssignmentSummaryPreview?: Maybe<Scalars['String']>;
  allBankInstitutions: Array<BankInstitutionGQLType>;
  allPlaidInstitutionAccounts: Array<BankDataProviderInstitutionGQLType>;
  allTellerInstitutionAccounts: Array<BankDataProviderInstitutionGQLType>;
  allValleyBankLoanAccounts: ValleyBankLoanAccountConnectionGQLType;
  areDeliverablesReceiptsZipFilesAvailableForDownload: ReceiptZipFileDownloadAvailableGQLType;
  areMasterLoanTapesAssigned: Scalars['Boolean'];
  artifactSlugs: Array<Scalars['String']>;
  assetVerificationDocumentByRawId?: Maybe<Scalars['String']>;
  assetVerificationDocumentSignedUrl: UrlAndFilenameGQLType;
  assetVerificationReceivableHistory: Array<HistoricalAssetVerificationDataGQLType>;
  assetVerificationReportByMetadata?: Maybe<Scalars['String']>;
  assetVerificationReportByMetadataStored?: Maybe<Scalars['String']>;
  assignedReceivable: AssignedReceivableGQLType;
  assignedReceivablesForLoanProduct: Array<AssignedReceivableGQLType>;
  assignmentJobs: AssignmentJobsGQLType;
  assignmentReceivablesAggregateTotalsWithMetadata?: Maybe<AssignmentReceivablesAggregateTotalsByStatusWithMetadataGQLType>;
  assignmentReceivablesWithMetadata?: Maybe<AssignmentReceivablesWithMetadataGQLType>;
  assignmentStrategiesForImplementation: Array<AssignmentStrategyGQLType>;
  assignmentStrategiesForOrganization: Array<AssignmentStrategiesByImplementationGQLType>;
  assignmentStrategy: AssignmentStrategyGQLType;
  assignmentSummary?: Maybe<Scalars['String']>;
  asyncOperationStatus: ResponseWithStringGQLType;
  balanceSheetImpactCalculations: BalanceSheetImpactCalculationsDataGQLType;
  bankAccountDefaultValues: BankAccountDefaultValuesGQLType;
  bankAccountsWithDesignationAndOwner: Array<BankAccountWithInstitutionDesignationAndOwnerGQLType>;
  borrowingBasePipelineArtifactDocumentInfo: BorrowingBasePipelineArtifactDocumentInfoGQLType;
  borrowingBasePipelineArtifactDocuments: Array<BorrowingBasePipelineArtifactDocumentGQLType>;
  borrowingBasePipelineDataValidationErrors: Array<DataValidationErrorsMapGQLType>;
  borrowingBasePipelineStatus: BorrowingBasePipelineStatusGQLType;
  borrowingBaseReport: BorrowingBaseReportGQLType;
  borrowingBaseReports: Array<BorrowingBaseReportGQLType>;
  canFundingRequestBeCreated: FundingRequestCanBeCreatedResponseGQLType;
  canServicingReportPreviewBeCreated: FundingRequestCanBeCreatedResponseGQLType;
  capitalProviders: Array<OrganizationGQLType>;
  checkIfAnyFacilitiesHaveBorrowingBase: Scalars['Boolean'];
  completedReceivableResponseTapePreviewId: Scalars['String'];
  convertCreditAgreementFullArtifactIds: CreditAgreementFullArtifactGQLType;
  convertOrgProvidedInputsWithNewIds: Array<OrgProvidedInputGQLType>;
  convertOrgProvidedValuesWithNewIds: Array<OrgProvidedValueGQLType>;
  convertReceivableBorrowingBaseWaiversWithNewIds: Array<ReceivableBorrowingBaseTestWaiverGQLType>;
  creditAgreementArtifact: CreditAgreementArtifactGQLType;
  creditAgreementBorrowerEntityName: Scalars['String'];
  creditAgreementCapitalProviderOrganizations: Array<EntityIdAndNameGQLType>;
  creditAgreementDocumentsMetadata: Array<CreditAgreementMetadataGQLType>;
  creditAgreementEligibilityTestsBaseFields: Array<Scalars['String']>;
  creditAgreementFullArtifact: CreditAgreementFullArtifactGQLType;
  creditAgreementFullArtifactImplementationPortalWip: CreditAgreementFullArtifactWipResponseGQLType;
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactWipResponseGQLType;
  creditFacilities: Array<CreditFacilityGQLType>;
  creditFacilitiesForAssignmentGrouping: Array<CreditFacilityGQLType>;
  creditFacility: CreditFacilityGQLType;
  creditFacilitySummaries: Array<CreditFacilitySummaryGQLType>;
  creditFacilitySummariesNew: Array<CreditFacilitySummaryGQLType>;
  currentCreditAgreementFullArtifact?: Maybe<CreditAgreementFullArtifactGQLType>;
  currentCreditAgreementFullArtifacts: Array<CreditAgreementFullArtifactGQLType>;
  currentFundingRequest?: Maybe<FundingRequestGQLType>;
  currentFundingRequestConstraint?: Maybe<FundingRequestConstraintGQLType>;
  dataPipelineStatusForCreditFacility: DataPipelineStatusForCreditFacilityGQLType;
  deliverableArtifactInstance: DeliverableArtifactInstanceGQLType;
  deliverableArtifactInstanceDownload: Array<DeliverableArtifactInstanceDownloadGQLType>;
  deliverableContainer: DeliverableContainerGQLType;
  deliverableContainerReceipts: Array<DeliverableContainerReceiptRecordGQLType>;
  deliverablesContainerReceiptZipFilesDownloadUrl: Scalars['String'];
  deliverablesContainersLenderView: Array<DeliverableContainerOutputLenderViewGQLType>;
  doesCreditAgreementWipExist: Scalars['Boolean'];
  doesFinancialsAthenaTableExist?: Maybe<Scalars['Boolean']>;
  evaluateMvAccessorsAndFetchSchema: MaterializedViewEvaluateAccessorResponseGQLType;
  evaluatePortfolioCovenantPostgresQuery: PostgresQueryResultWithWarningsAndInputsGQLType;
  eventLogs: EventLogPaginatedFeedGQLType;
  events: EventConnectionGQLType;
  executeAthenaRecurringQueryByRaw: AthenaRecurringQueryResponseGQLType;
  extractAi2Csv: Scalars['String'];
  extractAsset2Json: Scalars['String'];
  extractPyCsvVirtualSheet: Scalars['String'];
  extractPyXlsx2Csv2: Scalars['String'];
  extractPyXlsxVirtualSheet2Csv: Scalars['String'];
  finalOutputDeliverableArtifactInstance: FinalOutputDeliverableArtifactInstanceGQLType;
  financialCovenantCalculations?: Maybe<FinancialCovenantsInsightsGQLType>;
  financialCovenantCalculationsForCovenantKey?: Maybe<FinancialCovenantsInsightsForCovenantKeyGQLType>;
  fundingRequestConstraint: FundingRequestConstraintGQLType;
  fundingRequestVerificationReceivableEligibility?: Maybe<FundingRequestVerificationReceivableEligibilityGQLType>;
  fundingRequestVerificationReportByMetadata?: Maybe<FundingRequestVerificationReportGQLType>;
  fundingRequestWithFullDetails: FundingRequestWithFullDetailsGQLType;
  fundingRequests: FundingRequestsConnectionGQLType;
  fundingVerificationPipelineRuns: Array<FundingVerificationPipelineRunGQLType>;
  generateExploApiJwt: ExploTokenResponseGQLType;
  generateMultiFacilityStatement: FormattedMultiFacilityStatementGQLType;
  generateStatement: FormattedStatementGQLType;
  generateSummaryPeriodStatement: Array<SummaryPeriodStatementGQLType>;
  getAcknowledgedItems: PaginatedResultsWithCountsGQLType;
  getActiveCdqConfigs?: Maybe<Array<ConfiguredCdqGQLType>>;
  getActiveEditLoanEntitiesForLoan: LoanEditDataGQLType;
  getActiveRailzConnectionsByOrgId: Array<RailzIntegrationGQLType>;
  getAggregateLoansMetadata: LoanAggregateMetadataGQLType;
  getAggregatedLimitedPartnerCommitmentDataForLender: Array<AggregatedLimitedPartnerCommitmentDataGQLType>;
  getAllOrganizationMaterializedViews: Array<MaterializedViewConfigurationGQLType>;
  getAllQueryRecordsByOrganizationId: Array<AthenaQueryRecordGQLType>;
  getArtifactInstancesForPipelineRun?: Maybe<PipelineInstancesGQLType>;
  getAthenaQueryResponseByParams: AthenaQueryResponseGQLType;
  getAthenaQueryResponseByRaw: AthenaQueryResponseGQLType;
  getAthenaTablesForOrganization: Array<AthenaTableGQLType>;
  getAttributeById: AttributeGQLType;
  getAttributeListByEntity: Array<AttributeGQLType>;
  getAttributeListByName: Array<AttributeGQLType>;
  getAttributeListItemsByOrganization: Array<AttributeListWithAttributeIdsGQLType>;
  getAttributeListNames: Array<Scalars['String']>;
  getAttributeListNamesForAttribute: Array<Scalars['String']>;
  getAttributeValuesByParams: Array<AttributeValueGQLType>;
  getAttributes: Array<AttributeGQLType>;
  getBatchSettlementsForCreditFacility: Array<BatchSettlementGQLType>;
  getCloneParameters: ImplementationInfoGQLType;
  getCommitmentsForLimitedPartner: Array<LimitedPartnerCommitmentDetailGQLType>;
  getCompleteMeshRunRecordIfAvailable?: Maybe<Scalars['String']>;
  getConfig?: Maybe<Scalars['String']>;
  getConfigSchema: Scalars['String'];
  getConfigTypes: Array<ConfigTypeGQLType>;
  getCountOfUnmatchedLimitedPartnerMappings: Scalars['Int'];
  getCreditAgreementS3Path?: Maybe<CreditAgreementDownloadGQLType>;
  getCreditAgreementValidationErrors: Array<CreditAgreementValidationErrorGQLType>;
  getCreditFacilityKnowledgeBaseDocumentId?: Maybe<Scalars['String']>;
  getCreditFacilityMetrics?: Maybe<CreditFacilityMetricsResponseGQLType>;
  getCurrentLiabilityAccountsAndAccrualsForLoan: Array<LoanAccountAccrualObjectGQLType>;
  getCustomerProvidedVariablesAndValues: Array<AttributeGQLType>;
  getDailyAccountActivity?: Maybe<DailyAccountActivityResponseGQLType>;
  getDailyConcentrationInsights: Array<ConcentrationLimitAggregateInsightsGqlDataGQLType>;
  getDailyCoreBorrowingBaseInsights: Array<CoreBorrowingBaseInsightsGqlDataGQLType>;
  getDailyEligibilityInsights: Array<EligibilityAggregateInsightsGqlDataGQLType>;
  getDailyPrincipalInsights: Array<AggregatePrincipalInsightsGqlDataGQLType>;
  getDailyReceivableExposureInsights: Array<AggregateReceivableExposureInsightsGqlDataGQLType>;
  getDailyResolvedAggregateLineItemEntries: Array<ResolvedAggregateLineItemEntryGQLType>;
  getDailyTotalRiskInsights: TotalRiskInsightsOutputDataGQLType;
  getDatesForCurrentLiabilityTransactions?: Maybe<TransactionDateRangeGQLType>;
  getDeliverableArtifactsByContainerId: Array<DeliverableArtifactGQLType>;
  getDeliverableContainers: Array<DeliverableContainerGQLType>;
  getEarliestAndLatestTransactionDates?: Maybe<TransactionDateRangeGQLType>;
  getEarliestOriginationDateForLoans?: Maybe<Scalars['FullDateStr']>;
  getEvaluatedReportingInputConfigByCreditAgreementId: EvaluatedReportingInputConfigGQLType;
  getExploDashboardsAndReportBuilders: ExploVisualArtifactsGQLType;
  getExtendedResponseTapeDownloadUrl: Scalars['String'];
  getFinancialStatementConfig?: Maybe<FinancialStatementConfigStoreGQLType>;
  getFinancialStatementDataByDateRange?: Maybe<FinancialStatementInstanceTypeGQLType>;
  getFinleyAiAthenaSqlGenerationPromptResultPreview?: Maybe<Array<Scalars['Object']>>;
  getFinleyAiPromptResponse?: Maybe<FinleyAiPromptReponseGQLType>;
  getFinleyAiThreadWithPromptResponses?: Maybe<FinleyAiThreadWithPromptReponsesGQLType>;
  getFinleyAiThreads?: Maybe<FinleyAiThreadsGQLType>;
  getGeneratedAssignedLoanTapeDownloadUrl: Scalars['String'];
  getImplementationDetails: ImplementationGQLType;
  getIncompleteTasksCount: Scalars['Int'];
  getInvoiceAggregatesByOrganizationId: InvoiceAggregatesGQLType;
  getInvoiceById: InvoiceGQLType;
  getInvoiceConsolidatedDisbursementById: InvoiceConsolidatedDisbursementGQLType;
  getInvoiceConsolidatedDisbursementsByInvoiceId: Array<InvoiceConsolidatedDisbursementGQLType>;
  getInvoiceDisbursementById: InvoiceDisbursementGQLType;
  getInvoiceDisbursementsByInvoiceId: Array<InvoiceDisbursementGQLType>;
  getInvoiceFacilityFeeBalances: Array<CreditFacilityAccrualObjectGQLType>;
  getInvoicePaymentInKindItemById: InvoicePaymentInKindItemGQLType;
  getInvoicePaymentInKindItemsByInvoiceId: Array<InvoicePaymentInKindItemsWithMetadataGQLType>;
  getInvoicesByLoanId: Array<InvoiceGQLType>;
  getInvoicesByOrganizationId: Array<InvoiceGQLType>;
  getInvoicesByOrganizationIdPaginated: InvoicesConnectionGQLType;
  getKnowledgeBaseDocumentsByOrganizationId: FinleyAiKnowledgeBaseDocumentsGQLType;
  getLatestInvoiceFacilityFeeAccrualEndDate?: Maybe<Scalars['FullDateStr']>;
  getLatestMeshDocuments: Array<Scalars['String']>;
  getLatestMeshRun?: Maybe<Scalars['String']>;
  getLenderShareReports: Array<LenderShareReportGQLType>;
  getLenderShareReportsForLoan: Array<LenderShareReportGQLType>;
  getLimitedPartnerById: LimitedPartnerGQLType;
  getLimitedPartnerCapitalTrendData: Array<LimitedPartnerCapitalTrendDataGQLType>;
  getLimitedPartnerCommitmentsForLender: Array<LimitedPartnerCommitmentGQLType>;
  getLimitedPartnerMappingsForLenderCapitalCallLineFacilities: Array<LimitedPartnerMappingsByCreditFacilityGQLType>;
  getLimitedPartnerPortfolioOverviewGraphData: Array<LimitedPartnerPortfolioOverviewGraphDataGQLType>;
  getLimitedPartnerPortfolioSummary: LimitedPartnerPortfolioSummaryGQLType;
  getLimitedPartnersForOrganization: Array<LimitedPartnerGQLType>;
  getLoanMetricsForInvoiceId: LoanMetricsForInvoiceGQLType;
  getLoanRecordByFundingRequestAndCommitmentKey?: Maybe<LoanRecordGQLType>;
  getLoanRecordById: LoanRecordGQLType;
  getLoanRecordsByFundingRequest: Array<LoanRecordGQLType>;
  getLoanRecordsByMetadata: Array<LoanRecordGQLType>;
  getLoanTapeSanitizeConfigs: Array<LoanTapeSanitizeConfigGQLType>;
  getLocalizedLabels?: Maybe<LocalizedLabelsGQLType>;
  getMeshDocument: Scalars['String'];
  getMultipleExternalFacilityIds: Array<ExternalFacilityDataGQLType>;
  getNodePositions: Array<NodePositionGQLType>;
  getNoteIncreaseValleyIbsApiRecordsForFundingRequest: Array<ValleyIbsApiRecordGQLType>;
  getOrCreateFundingRequestTemplate: FundingRequestTemplateResponseGQLType;
  getOrgExploPlacementIntegrations: Array<ExploPlacementIntegrationGQLType>;
  getOrgProvidedInputById: OrgProvidedInputGQLType;
  getOrgProvidedInputByKey: OrgProvidedInputGQLType;
  getOrgProvidedInputsByOrgId: Array<OrgProvidedInputGQLType>;
  getOrgProvidedValueById: OrgProvidedValueGQLType;
  getOrgProvidedValueByReportingPeriod?: Maybe<OrgProvidedValueGQLType>;
  getOrgProvidedValuesByKey: Array<OrgProvidedValueGQLType>;
  getOrgProvidedValuesByKeys: Array<OrgProvidedValueGQLType>;
  getParticipantValleyIbsApiRecordsForFundingRequest: Array<ValleyIbsApiRecordGQLType>;
  getPaymentInKindServicingFeeDetailsForCreditFacilities: Array<PaymentInKindServicingFeeDetailsGQLType>;
  getPipelineRunById: PipelineRunGQLType;
  getPipelineRuns: Array<PipelineRunGQLType>;
  getPipelineRunsWithArtifactIds: Array<PipelineRunWithArtifactIdsGQLType>;
  getPortfolioCovenantById?: Maybe<SuccessOrErrorPortfolioCovenantGQLType>;
  getPrincipalPaymentMetricsByLoanId: PrincipalPaymentMetricsGQLType;
  getProfitOverviewInsights: Array<CreditFacilityProfitOverviewInsightsGqlDataGQLType>;
  getProfitVintageInsights: CreditFacilityProfitFullVintageInsightsGqlDataGQLType;
  getQuickSightConsoleEmbedUrl: QuickSightEmbedUrlResponseGQLType;
  getQuickSightDashboardEmbedUrl: QuickSightEmbedUrlResponseGQLType;
  getReceivableResponseTapePreviewCsvDownloadUrl: Scalars['String'];
  getRecentMeshRuns: Array<Scalars['String']>;
  getRepaymentVintageInsights: CreditFacilityRepaymentVintageInsightsGqlDataGQLType;
  getReportS3DownloadUrl?: Maybe<Scalars['String']>;
  getReportS3DownloadUrlByReportingWorkleaseRecordId: S3DownloadUrlByWorkleaseGQLType;
  getReportS3DownloadUrlsByReportingWorkleaseRecordIds: Array<S3DownloadUrlByWorkleaseGQLType>;
  getReportingTemplateDownloadUrl?: Maybe<Scalars['String']>;
  getReportsByCreditFacilityId: Array<DownloadableReportGQLType>;
  getReportsS3DownloadUrls: Array<ReportS3DownloadUrlWithFilenameGQLType>;
  getRequiredDataTapes: RequiredDataTapesGQLType;
  getRequiredDataTapesForVerification: RequiredDataTapesGQLType;
  getResolvedDetailedEntriesForFacilities: Array<ResolvedDetailedEntryItemGQLType>;
  getResolvedLoanByFundingRequestAndCommitmentKey?: Maybe<ResolvedLoanGQLType>;
  getResolvedLoanById: ResolvedLoanGQLType;
  getResolvedLoansByFundingRequest: Array<ResolvedLoanGQLType>;
  getSampleConfig: Scalars['String'];
  getSignedDownloadUrls: Array<UrlAndFilenameGQLType>;
  getSignedUploadUrl: PresignedPostGQLType;
  getSuccessFinancialCovenantsByCreditFacilityId: Array<SuccessFinancialCovenantGQLType>;
  getSuccessFinancialCovenantsByCreditFacilityIds: Array<SuccessFinancialCovenantGQLType>;
  getSuccessFinancialCovenantsByKey: Array<SuccessFinancialCovenantGQLType>;
  getSuccessPortfolioCovenantById?: Maybe<SuccessPortfolioCovenantGQLType>;
  getSuccessPortfolioCovenantsByCreditFacilityId: Array<SuccessPortfolioCovenantGQLType>;
  getSuccessPortfolioCovenantsByCreditFacilityIds: Array<SuccessPortfolioCovenantGQLType>;
  getSuccessPortfolioCovenantsByKey: Array<SuccessPortfolioCovenantGQLType>;
  getSuccessPortfolioCovenantsByKeyAndCreditAgreementId: Array<SuccessPortfolioCovenantGQLType>;
  getSummarizedLoans: Array<SummarizedLoanGQLType>;
  getTAccounts: Array<TAccountGQLType>;
  getTaskById: TaskGQLType;
  getTasks: TaskResultGQLType;
  getTasksBySection: Array<TaskGQLType>;
  getTasksInitialFilters: TaskFilterStateGQLType;
  getUnAcknowledgedItems: PaginatedResultsWithCountsGQLType;
  /** @deprecated use userApprovalGroupsForFundingRequest */
  getUserApprovalsForFundingRequest: Array<UserApprovalForDomainGQLType>;
  getUserTablePreference?: Maybe<TablePreferenceGQLType>;
  getWellKnownAttributeListNames: Array<Scalars['String']>;
  getWorkflowInstanceIdForFundingRequest?: Maybe<Scalars['String']>;
  /** @deprecated use userApprovalGroupsForFundingRequest */
  getWorkflowInstanceWithState: WorkflowGraphObjectWithStateGQLType;
  getWorkflowTemplate: WorkflowTemplateGQLType;
  getWorkflowTemplateConstructor: WorkflowTemplateConstructorGQLType;
  getWorkflowTemplates: Array<WorkflowTemplateGQLType>;
  historicalRecordsForReceivable: Scalars['String'];
  implementation: ImplementationGQLType;
  implementationByPipelineDefinitionId: ImplementationGQLType;
  initialConditionAssignmentReceivablesAggregateTotalsWithMetadata?: Maybe<AssignmentReceivablesAggregateTotalsByStatusWithMetadataGQLType>;
  initialConditionAssignmentReceivablesWithMetadata?: Maybe<AssignmentReceivablesWithMetadataGQLType>;
  institutionAndConnectionDetailsForBorrower: Array<CreditFacilityWithInstitutionsAndConnectionsGQLType>;
  institutionAndConnectionDetailsForImplementation: Array<CreditFacilityWithInstitutionsAndConnectionsGQLType>;
  isAssetVerificationRequired: Scalars['Boolean'];
  lastOutputDeliverableArtifactInstanceFromReceiptId: ComplianceReportCfScopedGQLType;
  latestAssignmentPipelineRunStatusForImplementation?: Maybe<AssignmentPipelineMetadataGQLType>;
  latestAssignmentReceivables?: Maybe<Scalars['String']>;
  latestAssignmentReceivablesAggregateTotalsWithMetadata?: Maybe<AssignmentReceivablesAggregateTotalsByStatusWithMetadataGQLType>;
  latestAssignmentReceivablesWithMetadata?: Maybe<AssignmentReceivablesWithMetadataGQLType>;
  latestAssignmentSummaries?: Maybe<Scalars['String']>;
  latestAssignmentSummary?: Maybe<Scalars['String']>;
  latestBorrowingBaseReport?: Maybe<BorrowingBaseReportGQLType>;
  latestBorrowingBaseReports: Array<Maybe<BorrowingBaseReportGQLType>>;
  latestCompletedReceivableResponseTapePreviewIds?: Maybe<Array<Scalars['String']>>;
  latestCovenantCalculations: Array<FinancialCovenantsCalculationGQLType>;
  latestHistoricalReceivableResponseTapeValues?: Maybe<ReceivableResponseTapeAthenaPaginatedResponseGQLType>;
  latestHistoricalReceivableResponseTapeValuesCount: Scalars['Int'];
  latestLedgersForCreditFacilities: Array<LedgerTransactionWithCreditFacilityIdGQLType>;
  ledger: Array<LedgerTransactionGQLType>;
  ledgerAccounts: Array<AccountDetailsGQLType>;
  ledgerBalanceForCreditFacilities: Array<LedgerBalanceGQLType>;
  lenderVerificationCreditFacilities: Array<CreditFacilityGQLType>;
  lenderVerificationProgressBreakdown?: Maybe<BorrowingBasePipelineProgressBreakdownGQLType>;
  loanMechanicsSerialized?: Maybe<Scalars['String']>;
  loanTapeMetadata: LoanTapeMetadataGQLType;
  maximumDrawRequestFrequencyMetadata: MaximumDrawRequestFrequencyMetadataGQLType;
  organization: OrganizationGQLType;
  organizationsByIds: Array<OrganizationGQLType>;
  partiesByTypeAndCreditFacilityIds: Array<OrganizationGQLType>;
  pdfAnalysis: PdfAnalysisResponseGQLType;
  plaidLinkToken: LinkTokenGQLType;
  receivableWaiversForCreditFacilityWithOrganization: Array<ReceivableBorrowingBaseTestWaiverGQLType>;
  receivableWaiversForReceivableIds: Array<ReceivableBorrowingBaseTestWaiverGQLType>;
  repaymentDataForAssignedReceivable?: Maybe<Array<ReceivableRepaymentsHistoryGQLType>>;
  reportDownloadUrl?: Maybe<Scalars['String']>;
  reportTemplateDownloadUrl?: Maybe<Scalars['String']>;
  reports: ReportsConnectionGQLType;
  repurchaseAndTransferJobs: Array<AssignmentConfirmationJobGQLType>;
  slsCreditAgreementsPropertiesForCapitalProvider: Array<SlsCreditAgreementPropertiesGQLType>;
  thread: ThreadGQLType;
  threadCountsByDomain: ThreadCountsGQLType;
  threadV2: ThreadV2GQLType;
  threads: Array<ThreadGQLType>;
  threadsByDomainIdentifier: Array<ThreadGQLType>;
  threadsByDomainIdentifierV2: Array<ThreadV2GQLType>;
  threadsByDomainMapping: Array<ThreadWithDomainIdentifierGQLType>;
  threadsByDomainMappingV2: Array<ThreadV2GQLType>;
  threadsV2: Array<ThreadV2GQLType>;
  user?: Maybe<UserGQLType>;
  userApprovalGroupsForFundingRequest: Array<UserApprovalGroupGQLType>;
  valleyBankArrangementGroup?: Maybe<Scalars['String']>;
  valleyBankAssignmentDeviations: ValleyBankAssignmentDeviationGQLType;
  valleyBankAssignmentEventLog: Array<ValleyBankAssignmentEventLogWithNameGQLType>;
  valleyBankAssignmentPreviewRRT: Scalars['String'];
  valleyBankAssignmentQueue: Array<ValleyBankAssignmentQueueWithNameGQLType>;
  valleyBankAssociatedLoanAccountsByCifNums: Scalars['String'];
  valleyBankCustomer?: Maybe<ValleyBankCustomerGQLType>;
  valleyBankCustomers: ValleyBankCustomerConnectionGQLType;
  valleyBankDownloadLinks: ValleyBankDownloadsGQLType;
  valleyBankLatestPinnedCommentForLoanAccounts: Array<ValleyBankLoanAccountLatestPinnedCommentGQLType>;
  valleyBankLatestPinnedCommentForLoanAccountsV2: Array<ValleyBankLoanAccountLatestPinnedCommentV2GQLType>;
  valleyBankLoanAccount?: Maybe<ValleyBankLoanAccountGQLType>;
  valleyBankLoanAccountByAccountNums: Scalars['String'];
  valleyBankLoanAccountsByCifNums: Scalars['String'];
  valleyBankPipelineStatusMetadata?: Maybe<Scalars['String']>;
  valleyBankUnderMarginLoanAccounts: Scalars['String'];
  verificationBorrowingBaseWaiverImpact?: Maybe<Scalars['String']>;
  webhookSubscriptionsForUser: Array<WebhookSubscriptionGQLType>;
};


export type QueryActionableFundingVerificationPipelineRunsArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryAggregatedAssignmentSummaryPreviewArgsGQLType = {
  receivableResponseTapePreviewJobId: Scalars['UUID'];
};


export type QueryAllValleyBankLoanAccountsArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  paginationOptions: PaginationOptionsGQLType;
  queryParams?: Maybe<ValleyBankLoanAccountQueryParamsGQLType>;
  orderByParam?: Maybe<ValleyBankLoanAccountOrderByParamGQLType>;
};


export type QueryAreDeliverablesReceiptsZipFilesAvailableForDownloadArgsGQLType = {
  receiptId: Scalars['UUID'];
};


export type QueryAreMasterLoanTapesAssignedArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
};


export type QueryArtifactSlugsArgsGQLType = {
  artifactDocumentId?: Maybe<Scalars['UUID']>;
};


export type QueryAssetVerificationDocumentByRawIdArgsGQLType = {
  receivableDocumentationRawId: Scalars['UUID'];
};


export type QueryAssetVerificationDocumentSignedUrlArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  receivableDocumentationRawId: Scalars['UUID'];
};


export type QueryAssetVerificationReceivableHistoryArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  loanProductId?: Maybe<Scalars['UUID']>;
};


export type QueryAssetVerificationReportByMetadataArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  loanProductId?: Maybe<Scalars['UUID']>;
};


export type QueryAssetVerificationReportByMetadataStoredArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  loanProductId?: Maybe<Scalars['UUID']>;
};


export type QueryAssignedReceivableArgsGQLType = {
  finleyReceivableId: Scalars['UUID'];
};


export type QueryAssignedReceivablesForLoanProductArgsGQLType = {
  externalReceivableIds: Array<Scalars['String']>;
  loanProductSlug: Scalars['String'];
};


export type QueryAssignmentJobsArgsGQLType = {
  implementationId: Scalars['String'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
  fileVersion?: Maybe<Scalars['Int']>;
};


export type QueryAssignmentReceivablesAggregateTotalsWithMetadataArgsGQLType = {
  previewIdentifier: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};


export type QueryAssignmentReceivablesWithMetadataArgsGQLType = {
  previewIdentifier: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};


export type QueryAssignmentStrategiesForImplementationArgsGQLType = {
  implementationId: Scalars['String'];
};


export type QueryAssignmentStrategiesForOrganizationArgsGQLType = {
  organizationId: Scalars['String'];
};


export type QueryAssignmentStrategyArgsGQLType = {
  strategyId: Scalars['UUID'];
  implementationId?: Maybe<Scalars['UUID']>;
};


export type QueryAssignmentSummaryArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  isInitialPreview: Scalars['Boolean'];
  previewIdentifier?: Maybe<Scalars['String']>;
};


export type QueryAsyncOperationStatusArgsGQLType = {
  operationId: Scalars['UUID'];
};


export type QueryBalanceSheetImpactCalculationsArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryBankAccountDefaultValuesArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  bankInstitutionId: Scalars['UUID'];
  routingNumber: Scalars['String'];
  accountNumber: Scalars['String'];
};


export type QueryBankAccountsWithDesignationAndOwnerArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  maskSensitiveInfo?: Maybe<Scalars['Boolean']>;
};


export type QueryBorrowingBasePipelineArtifactDocumentInfoArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  dbView: Scalars['Boolean'];
};


export type QueryBorrowingBasePipelineArtifactDocumentsArgsGQLType = {
  pipelineDefinitionId: Scalars['UUID'];
};


export type QueryBorrowingBasePipelineDataValidationErrorsArgsGQLType = {
  rawArtifactInstanceIds: Array<Scalars['UUID']>;
};


export type QueryBorrowingBasePipelineStatusArgsGQLType = {
  pipelineDefinitionId: Scalars['UUID'];
};


export type QueryBorrowingBaseReportArgsGQLType = {
  borrowingBaseReportId: Scalars['UUID'];
};


export type QueryBorrowingBaseReportsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  startReportingDate?: Maybe<Scalars['String']>;
  endReportingDate?: Maybe<Scalars['String']>;
};


export type QueryCanFundingRequestBeCreatedArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCanServicingReportPreviewBeCreatedArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCapitalProvidersArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCheckIfAnyFacilitiesHaveBorrowingBaseArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']>>;
};


export type QueryCompletedReceivableResponseTapePreviewIdArgsGQLType = {
  creditFacilityId: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  previewIdentifier: Scalars['String'];
};


export type QueryConvertCreditAgreementFullArtifactIdsArgsGQLType = {
  creditAgreementFullArtifact: CreditAgreementFullArtifactInputGQLType;
};


export type QueryConvertOrgProvidedInputsWithNewIdsArgsGQLType = {
  orgProvidedInputsWithEntityJson: Scalars['String'];
};


export type QueryConvertOrgProvidedValuesWithNewIdsArgsGQLType = {
  orgProvidedValuesWithEntitiesJson: Scalars['String'];
};


export type QueryConvertReceivableBorrowingBaseWaiversWithNewIdsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  waiversWithEntitiesJson: Scalars['String'];
};


export type QueryCreditAgreementArtifactArgsGQLType = {
  creditAgreementId: Scalars['UUID'];
};


export type QueryCreditAgreementBorrowerEntityNameArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCreditAgreementCapitalProviderOrganizationsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
};


export type QueryCreditAgreementDocumentsMetadataArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCreditAgreementEligibilityTestsBaseFieldsArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryCreditAgreementFullArtifactArgsGQLType = {
  creditAgreementId: Scalars['UUID'];
};


export type QueryCreditAgreementFullArtifactImplementationPortalWipArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCreditAgreementFullArtifactWipArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCreditFacilitiesArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryCreditFacilitiesForAssignmentGroupingArgsGQLType = {
  implementationId: Scalars['UUID'];
};


export type QueryCreditFacilityArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCreditFacilitySummariesNewArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
};


export type QueryCurrentCreditAgreementFullArtifactArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCurrentCreditAgreementFullArtifactsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
};


export type QueryCurrentFundingRequestArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryCurrentFundingRequestConstraintArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryDataPipelineStatusForCreditFacilityArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryDeliverableArtifactInstanceArgsGQLType = {
  artifactInstanceId: Scalars['UUID'];
};


export type QueryDeliverableArtifactInstanceDownloadArgsGQLType = {
  artifactInstanceId: Scalars['UUID'];
};


export type QueryDeliverableContainerArgsGQLType = {
  containerId: Scalars['UUID'];
};


export type QueryDeliverableContainerReceiptsArgsGQLType = {
  containerId: Scalars['UUID'];
};


export type QueryDeliverablesContainerReceiptZipFilesDownloadUrlArgsGQLType = {
  receiptId: Scalars['UUID'];
  type: InputTypeGQLType;
};


export type QueryDeliverablesContainersLenderViewArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  includeFutureDays?: Maybe<Scalars['Int']>;
};


export type QueryDoesCreditAgreementWipExistArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryDoesFinancialsAthenaTableExistArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryEvaluateMvAccessorsAndFetchSchemaArgsGQLType = {
  organizationId: Scalars['UUID'];
  dataAccessorsString: Scalars['String'];
};


export type QueryEvaluatePortfolioCovenantPostgresQueryArgsGQLType = {
  postgresQuery: PostgresQueryGQLType;
  creditAgreementId: Scalars['UUID'];
};


export type QueryEventLogsArgsGQLType = {
  params: EventLogPaginatedFeedParamsGQLType;
};


export type QueryEventsArgsGQLType = {
  organizationId: Scalars['String'];
  limit: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
};


export type QueryExecuteAthenaRecurringQueryByRawArgsGQLType = {
  organizationId: Scalars['String'];
  globalRecurringDateConfigsString: Scalars['String'];
  globalRecurringDateConfigFields: Array<Scalars['String']>;
  supplementalVariables: Array<QueryVariableGQLType>;
  variables: Array<QueryVariableGQLType>;
  bindings: Array<Scalars['String']>;
  queryString: Scalars['String'];
  queryName: Scalars['String'];
  creditFacilityId?: Maybe<Scalars['String']>;
};


export type QueryExtractAi2CsvArgsGQLType = {
  pipelineDefinitionId: Scalars['String'];
  documentsStr: Scalars['String'];
  prompt: Scalars['String'];
  tool: Scalars['Object'];
  baseFieldsTemplate?: Maybe<BaseFieldsTemplateGQLType>;
};


export type QueryExtractAsset2JsonArgsGQLType = {
  params: Scalars['String'];
  pipelineDefinitionId: Scalars['UUID'];
};


export type QueryExtractPyCsvVirtualSheetArgsGQLType = {
  pipelineDefinitionId: Scalars['String'];
  extractionParams: PyCsvVirtualSheetExtractionParamsGQLType;
};


export type QueryExtractPyXlsx2Csv2ArgsGQLType = {
  pipelineDefinitionId: Scalars['String'];
  extractionParams: PyXlxs2CsvExtractionParamsGQLType;
  xlsxS3Bucket: Scalars['String'];
  xlsxS3Key: Scalars['String'];
};


export type QueryExtractPyXlsxVirtualSheet2CsvArgsGQLType = {
  pipelineDefinitionId: Scalars['String'];
  extractionParams: PyXlxsVirtualSheet2CsvExtractionParamsGQLType;
  xlsxS3Bucket: Scalars['String'];
  xlsxS3Key: Scalars['String'];
};


export type QueryFinalOutputDeliverableArtifactInstanceArgsGQLType = {
  artifactInstanceId: Scalars['UUID'];
};


export type QueryFinancialCovenantCalculationsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['JSDate'];
  endDate: Scalars['JSDate'];
};


export type QueryFinancialCovenantCalculationsForCovenantKeyArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  reportingDateStart: Scalars['FullDateStr'];
  reportingDateEnd: Scalars['FullDateStr'];
};


export type QueryFundingRequestConstraintArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryFundingRequestVerificationReceivableEligibilityArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  verificationReportId: Scalars['UUID'];
};


export type QueryFundingRequestVerificationReportByMetadataArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};


export type QueryFundingRequestWithFullDetailsArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryFundingRequestsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  statuses?: Maybe<Array<FundingRequestStatusEnumGQLType>>;
};


export type QueryFundingVerificationPipelineRunsArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGenerateExploApiJwtArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
  exploArtifactType: ExploArtifactTypeGQLType;
  exploPlacement: ExploPlacementOptionsGQLType;
};


export type QueryGenerateMultiFacilityStatementArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  transactionAggregation: StatementTransactionAggregationLevelGQLType;
};


export type QueryGenerateStatementArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  cutoffTime?: Maybe<Scalars['JSDate']>;
};


export type QueryGenerateSummaryPeriodStatementArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  cadence: SummaryStatementCadenceGQLType;
  cutoffCreatedDate?: Maybe<Scalars['JSDate']>;
};


export type QueryGetAcknowledgedItemsArgsGQLType = {
  cdqId: Scalars['UUID'];
  NextToken?: Maybe<Scalars['String']>;
  QueryExecutionId?: Maybe<Scalars['String']>;
};


export type QueryGetActiveCdqConfigsArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
};


export type QueryGetActiveEditLoanEntitiesForLoanArgsGQLType = {
  loanId: Scalars['UUID'];
};


export type QueryGetActiveRailzConnectionsByOrgIdArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetAggregateLoansMetadataArgsGQLType = {
  filterParams: LoanMetadataFilterParamsGQLType;
};


export type QueryGetAggregatedLimitedPartnerCommitmentDataForLenderArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
  filters: LimitedPartnerFiltersGQLType;
};


export type QueryGetAllOrganizationMaterializedViewsArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetAllQueryRecordsByOrganizationIdArgsGQLType = {
  organizationId: Scalars['String'];
};


export type QueryGetArtifactInstancesForPipelineRunArgsGQLType = {
  pipelineRunId: Scalars['UUID'];
};


export type QueryGetAthenaQueryResponseByParamsArgsGQLType = {
  organizationId: Scalars['String'];
  queryParams: Scalars['Object'];
};


export type QueryGetAthenaQueryResponseByRawArgsGQLType = {
  organizationId: Scalars['String'];
  query: Scalars['String'];
  bindings: Array<Scalars['String']>;
  variables: Array<QueryVariableGQLType>;
  creditFacilityId?: Maybe<Scalars['String']>;
};


export type QueryGetAthenaTablesForOrganizationArgsGQLType = {
  organizationId: Scalars['String'];
  creditFacilityIds?: Maybe<Array<Scalars['String']>>;
  tablePrefixes?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetAttributeByIdArgsGQLType = {
  attributeId: Scalars['UUID'];
};


export type QueryGetAttributeListByEntityArgsGQLType = {
  organizationId: Scalars['UUID'];
  listName: Scalars['String'];
  entityDomain: AttributeEntityDomainGQLType;
  entityIdentifier?: Maybe<Scalars['UUID']>;
  includeHistorical?: Maybe<Scalars['Boolean']>;
};


export type QueryGetAttributeListByNameArgsGQLType = {
  organizationId: Scalars['UUID'];
  listName: Scalars['String'];
};


export type QueryGetAttributeListItemsByOrganizationArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetAttributeListNamesArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetAttributeListNamesForAttributeArgsGQLType = {
  attributeId: Scalars['UUID'];
};


export type QueryGetAttributeValuesByParamsArgsGQLType = {
  getAttributeValuesParams: GetAttributeValuesByParamsInputGQLType;
};


export type QueryGetAttributesArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetBatchSettlementsForCreditFacilityArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  lenderIds?: Maybe<Array<Scalars['UUID']>>;
  loanIds?: Maybe<Array<Scalars['UUID']>>;
};


export type QueryGetCloneParametersArgsGQLType = {
  implementationId: Scalars['UUID'];
};


export type QueryGetCommitmentsForLimitedPartnerArgsGQLType = {
  limitedPartnerId: Scalars['UUID'];
};


export type QueryGetCompleteMeshRunRecordIfAvailableArgsGQLType = {
  meshRunId?: Maybe<Scalars['String']>;
  meshRunParams?: Maybe<MeshRunParamsGQLType>;
};


export type QueryGetConfigArgsGQLType = {
  entitySlug: Scalars['String'];
  configType: Scalars['String'];
};


export type QueryGetConfigSchemaArgsGQLType = {
  configType: Scalars['String'];
};


export type QueryGetCountOfUnmatchedLimitedPartnerMappingsArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
};


export type QueryGetCreditAgreementS3PathArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetCreditAgreementValidationErrorsArgsGQLType = {
  creditAgreementId: Scalars['UUID'];
};


export type QueryGetCreditFacilityKnowledgeBaseDocumentIdArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};


export type QueryGetCreditFacilityMetricsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  postingDate: Scalars['FullDateStr'];
};


export type QueryGetCurrentLiabilityAccountsAndAccrualsForLoanArgsGQLType = {
  loanId: Scalars['UUID'];
  accrualStartDate: Scalars['FullDateStr'];
  accrualEndDate: Scalars['FullDateStr'];
  inclusiveOfAccrualEndDate: Scalars['Boolean'];
};


export type QueryGetCustomerProvidedVariablesAndValuesArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetDailyAccountActivityArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  loanIds?: Maybe<Array<Scalars['UUID']>>;
  accountTypes?: Maybe<Array<TAccountTypeGQLType>>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type QueryGetDailyConcentrationInsightsArgsGQLType = {
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
};


export type QueryGetDailyCoreBorrowingBaseInsightsArgsGQLType = {
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
};


export type QueryGetDailyEligibilityInsightsArgsGQLType = {
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
};


export type QueryGetDailyPrincipalInsightsArgsGQLType = {
  organizationParams: OrganizationInsightsParamInputGQLType;
};


export type QueryGetDailyReceivableExposureInsightsArgsGQLType = {
  organizationParams: OrganizationInsightsParamInputGQLType;
};


export type QueryGetDailyResolvedAggregateLineItemEntriesArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  loanIds?: Maybe<Array<Scalars['UUID']>>;
  accountTypes?: Maybe<Array<TAccountTypeGQLType>>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type QueryGetDailyTotalRiskInsightsArgsGQLType = {
  organizationParams: OrganizationInsightsParamInputGQLType;
};


export type QueryGetDatesForCurrentLiabilityTransactionsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetDeliverableArtifactsByContainerIdArgsGQLType = {
  containerId: Scalars['UUID'];
};


export type QueryGetDeliverableContainersArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetEarliestAndLatestTransactionDatesArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetEarliestOriginationDateForLoansArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  loanIds: Array<Scalars['UUID']>;
};


export type QueryGetEvaluatedReportingInputConfigByCreditAgreementIdArgsGQLType = {
  worklease: ReportingGenerateWorkleaseGQLType;
};


export type QueryGetExtendedResponseTapeDownloadUrlArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};


export type QueryGetFinancialStatementConfigArgsGQLType = {
  organizationSlug: Scalars['String'];
};


export type QueryGetFinancialStatementDataByDateRangeArgsGQLType = {
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  financialStatement: FinancialStatementTypeGQLType;
  reportFrequency: ReportFrequencyGQLType;
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetFinleyAiAthenaSqlGenerationPromptResultPreviewArgsGQLType = {
  finleyAiPromptResponseId: Scalars['UUID'];
  numberOfPreviewRows?: Maybe<Scalars['Int']>;
};


export type QueryGetFinleyAiPromptResponseArgsGQLType = {
  finleyAiPromptResponseId: Scalars['UUID'];
};


export type QueryGetFinleyAiThreadWithPromptResponsesArgsGQLType = {
  finleyAiThreadId: Scalars['UUID'];
};


export type QueryGetFinleyAiThreadsArgsGQLType = {
  userId: Scalars['UUID'];
};


export type QueryGetGeneratedAssignedLoanTapeDownloadUrlArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};


export type QueryGetImplementationDetailsArgsGQLType = {
  implementationId: Scalars['UUID'];
};


export type QueryGetInvoiceAggregatesByOrganizationIdArgsGQLType = {
  organizationId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  creditFacilityIds?: Maybe<Array<Scalars['UUID']>>;
};


export type QueryGetInvoiceByIdArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type QueryGetInvoiceConsolidatedDisbursementByIdArgsGQLType = {
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
};


export type QueryGetInvoiceConsolidatedDisbursementsByInvoiceIdArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type QueryGetInvoiceDisbursementByIdArgsGQLType = {
  invoiceDisbursementId: Scalars['UUID'];
};


export type QueryGetInvoiceDisbursementsByInvoiceIdArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type QueryGetInvoiceFacilityFeeBalancesArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type QueryGetInvoicePaymentInKindItemByIdArgsGQLType = {
  invoicePaymentInKindItemId: Scalars['UUID'];
};


export type QueryGetInvoicePaymentInKindItemsByInvoiceIdArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type QueryGetInvoicesByLoanIdArgsGQLType = {
  loanId: Scalars['UUID'];
};


export type QueryGetInvoicesByOrganizationIdArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetInvoicesByOrganizationIdPaginatedArgsGQLType = {
  organizationId: Scalars['UUID'];
  pagination: InvoicesPaginationInputGQLType;
  creditFacilityIds?: Maybe<Array<Scalars['UUID']>>;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  sortBy?: Maybe<InvoiceSortFieldGQLType>;
  sortDirection?: Maybe<SortDirectionGQLType>;
};


export type QueryGetKnowledgeBaseDocumentsByOrganizationIdArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetLatestInvoiceFacilityFeeAccrualEndDateArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetLatestMeshDocumentsArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetLatestMeshRunArgsGQLType = {
  implementationId: Scalars['UUID'];
};


export type QueryGetLenderShareReportsArgsGQLType = {
  lenderShareId: Scalars['UUID'];
  fundingRequestComponentId: Scalars['UUID'];
};


export type QueryGetLenderShareReportsForLoanArgsGQLType = {
  loanId: Scalars['UUID'];
  fundingRequestId: Scalars['UUID'];
};


export type QueryGetLimitedPartnerByIdArgsGQLType = {
  limitedPartnerId: Scalars['UUID'];
};


export type QueryGetLimitedPartnerCapitalTrendDataArgsGQLType = {
  limitedPartnerId: Scalars['UUID'];
};


export type QueryGetLimitedPartnerCommitmentsForLenderArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
};


export type QueryGetLimitedPartnerMappingsForLenderCapitalCallLineFacilitiesArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
  queryString?: Maybe<Scalars['String']>;
};


export type QueryGetLimitedPartnerPortfolioOverviewGraphDataArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
};


export type QueryGetLimitedPartnerPortfolioSummaryArgsGQLType = {
  lenderOrganizationId: Scalars['UUID'];
  filters: LimitedPartnerFiltersGQLType;
};


export type QueryGetLimitedPartnersForOrganizationArgsGQLType = {
  organizationId: Scalars['UUID'];
  queryString?: Maybe<Scalars['String']>;
};


export type QueryGetLoanMetricsForInvoiceIdArgsGQLType = {
  invoiceId: Scalars['UUID'];
};


export type QueryGetLoanRecordByFundingRequestAndCommitmentKeyArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
  commitmentKey: Scalars['String'];
};


export type QueryGetLoanRecordByIdArgsGQLType = {
  loanId?: Maybe<Scalars['UUID']>;
  externalLoanId?: Maybe<Scalars['UUID']>;
  creditFacilityId?: Maybe<Scalars['UUID']>;
};


export type QueryGetLoanRecordsByFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryGetLoanRecordsByMetadataArgsGQLType = {
  filterParams: LoanMetadataFilterParamsGQLType;
};


export type QueryGetLoanTapeSanitizeConfigsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetLocalizedLabelsArgsGQLType = {
  scope: Scalars['String'];
};


export type QueryGetMeshDocumentArgsGQLType = {
  meshDocumentId: Scalars['String'];
};


export type QueryGetMultipleExternalFacilityIdsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetNodePositionsArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  purpose: NodePositionPurposeGQLType;
};


export type QueryGetNoteIncreaseValleyIbsApiRecordsForFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryGetOrCreateFundingRequestTemplateArgsGQLType = {
  mode: FundingRequestTemplateModeGQLType;
  creditFacilityId: Scalars['UUID'];
  fundingRequestId?: Maybe<Scalars['UUID']>;
  loanId?: Maybe<Scalars['UUID']>;
  fundingRequestIdToDuplicate?: Maybe<Scalars['UUID']>;
};


export type QueryGetOrgExploPlacementIntegrationsArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetOrgProvidedInputByIdArgsGQLType = {
  orgProvidedInputId: Scalars['UUID'];
};


export type QueryGetOrgProvidedInputByKeyArgsGQLType = {
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
};


export type QueryGetOrgProvidedInputsByOrgIdArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryGetOrgProvidedValueByIdArgsGQLType = {
  orgProvidedValueId: Scalars['UUID'];
};


export type QueryGetOrgProvidedValueByReportingPeriodArgsGQLType = {
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  reportingPeriod: Scalars['String'];
};


export type QueryGetOrgProvidedValuesByKeyArgsGQLType = {
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type QueryGetOrgProvidedValuesByKeysArgsGQLType = {
  organizationId: Scalars['UUID'];
  keys: Array<Scalars['String']>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type QueryGetParticipantValleyIbsApiRecordsForFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryGetPaymentInKindServicingFeeDetailsForCreditFacilitiesArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  invoicePaymentStartDate: Scalars['FullDateStr'];
  invoicePaymentEndDate: Scalars['FullDateStr'];
  capitalizedLoanIds?: Maybe<Array<Scalars['UUID']>>;
  capitalProviderOrganizationIds?: Maybe<Array<Scalars['UUID']>>;
};


export type QueryGetPipelineRunByIdArgsGQLType = {
  pipelineRunId: Scalars['UUID'];
};


export type QueryGetPipelineRunsArgsGQLType = {
  organizationId?: Maybe<Scalars['UUID']>;
  pipelineDefinitionId?: Maybe<Scalars['UUID']>;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetPipelineRunsWithArtifactIdsArgsGQLType = {
  organizationId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
};


export type QueryGetPortfolioCovenantByIdArgsGQLType = {
  portfolioCovenantId: Scalars['UUID'];
};


export type QueryGetPrincipalPaymentMetricsByLoanIdArgsGQLType = {
  loanId: Scalars['UUID'];
};


export type QueryGetProfitOverviewInsightsArgsGQLType = {
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
};


export type QueryGetProfitVintageInsightsArgsGQLType = {
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
};


export type QueryGetQuickSightConsoleEmbedUrlArgsGQLType = {
  getConsoleParams?: Maybe<GetQuickSightEmbedUrlParamsGQLType>;
};


export type QueryGetQuickSightDashboardEmbedUrlArgsGQLType = {
  getDashboardParams: GetQuickSightEmbedUrlParamsGQLType;
};


export type QueryGetReceivableResponseTapePreviewCsvDownloadUrlArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  type: ReceivableResponseTapePreviewAttachmentTypeGQLType;
  previewIdentifier: Scalars['String'];
};


export type QueryGetRecentMeshRunsArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']>>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetRepaymentVintageInsightsArgsGQLType = {
  creditFacilityParams: CreditFacilityRepaymentInsightsParamInputGQLType;
};


export type QueryGetReportS3DownloadUrlArgsGQLType = {
  reportId: Scalars['UUID'];
  reportConfigType: ReportConfigTypeGQLType;
};


export type QueryGetReportS3DownloadUrlByReportingWorkleaseRecordIdArgsGQLType = {
  reportingWorkleaseRecordId: Scalars['UUID'];
  reportConfigType: ReportConfigTypeGQLType;
};


export type QueryGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsArgsGQLType = {
  reportingWorkleaseRecordIds: Array<Scalars['UUID']>;
  reportConfigType: ReportConfigTypeGQLType;
};


export type QueryGetReportingTemplateDownloadUrlArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  reportName: Scalars['String'];
};


export type QueryGetReportsByCreditFacilityIdArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetReportsS3DownloadUrlsArgsGQLType = {
  reportIdsWithFilename: Array<ReportIdWithFilenameInputGQLType>;
  reportConfigType: ReportConfigTypeGQLType;
};


export type QueryGetRequiredDataTapesArgsGQLType = {
  organizationId: Scalars['UUID'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
  omitOrgProvidedInputGraphs: Scalars['Boolean'];
};


export type QueryGetRequiredDataTapesForVerificationArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetResolvedDetailedEntriesForFacilitiesArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  loanIds?: Maybe<Array<Scalars['UUID']>>;
  accountTypes?: Maybe<Array<TAccountTypeGQLType>>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};


export type QueryGetResolvedLoanByFundingRequestAndCommitmentKeyArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
  commitmentKey: Scalars['String'];
};


export type QueryGetResolvedLoanByIdArgsGQLType = {
  loanId: Scalars['UUID'];
};


export type QueryGetResolvedLoansByFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryGetSampleConfigArgsGQLType = {
  entitySlug: Scalars['String'];
  configType: Scalars['String'];
};


export type QueryGetSignedDownloadUrlsArgsGQLType = {
  feature: Scalars['String'];
  serializedParams: Scalars['String'];
};


export type QueryGetSignedUploadUrlArgsGQLType = {
  feature: Scalars['String'];
  serializedParams: Scalars['String'];
};


export type QueryGetSuccessFinancialCovenantsByCreditFacilityIdArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  mode: FinancialCovenantWorkleaseModeGQLType;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
};


export type QueryGetSuccessFinancialCovenantsByCreditFacilityIdsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  mode: FinancialCovenantWorkleaseModeGQLType;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
};


export type QueryGetSuccessFinancialCovenantsByKeyArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  mode: FinancialCovenantWorkleaseModeGQLType;
};


export type QueryGetSuccessPortfolioCovenantByIdArgsGQLType = {
  portfolioCovenantId: Scalars['UUID'];
};


export type QueryGetSuccessPortfolioCovenantsByCreditFacilityIdArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
};


export type QueryGetSuccessPortfolioCovenantsByCreditFacilityIdsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
};


export type QueryGetSuccessPortfolioCovenantsByKeyArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  start?: Maybe<Scalars['FullDateStr']>;
  end?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
};


export type QueryGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  start?: Maybe<Scalars['FullDateStr']>;
  end?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
};


export type QueryGetSummarizedLoansArgsGQLType = {
  filterParams: LoanMetadataFilterParamsGQLType;
};


export type QueryGetTAccountsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryGetTaskByIdArgsGQLType = {
  taskId: Scalars['UUID'];
};


export type QueryGetTasksArgsGQLType = {
  filters?: Maybe<TaskFilterInputGQLType>;
};


export type QueryGetTasksBySectionArgsGQLType = {
  section: TaskSectionParamInputGQLType;
  filters?: Maybe<TaskFilterInputGQLType>;
};


export type QueryGetUnAcknowledgedItemsArgsGQLType = {
  cdqId: Scalars['UUID'];
  NextToken?: Maybe<Scalars['String']>;
  QueryExecutionId?: Maybe<Scalars['String']>;
};


export type QueryGetUserApprovalsForFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryGetUserTablePreferenceArgsGQLType = {
  tableKey: Scalars['String'];
  defaultTableColumnConfiguration: DefaultTableColumnConfigurationInputGQLType;
};


export type QueryGetWorkflowInstanceIdForFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};


export type QueryGetWorkflowInstanceWithStateArgsGQLType = {
  workflowInstanceId: Scalars['UUID'];
};


export type QueryGetWorkflowTemplateArgsGQLType = {
  workflowTemplateId: Scalars['UUID'];
};


export type QueryGetWorkflowTemplateConstructorArgsGQLType = {
  workflowType: WorkflowTypeGQLType;
  organizationId: Scalars['UUID'];
};


export type QueryGetWorkflowTemplatesArgsGQLType = {
  workflowType: WorkflowTypeGQLType;
  organizationId: Scalars['UUID'];
};


export type QueryHistoricalRecordsForReceivableArgsGQLType = {
  organizationId: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDateParams?: Maybe<DateRangeInputGQLType>;
};


export type QueryImplementationArgsGQLType = {
  implementationId: Scalars['UUID'];
};


export type QueryImplementationByPipelineDefinitionIdArgsGQLType = {
  pipelineDefinitionId: Scalars['UUID'];
};


export type QueryInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
};


export type QueryInitialConditionAssignmentReceivablesWithMetadataArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
};


export type QueryInstitutionAndConnectionDetailsForBorrowerArgsGQLType = {
  borrowerId: Scalars['UUID'];
};


export type QueryInstitutionAndConnectionDetailsForImplementationArgsGQLType = {
  implementationId: Scalars['UUID'];
};


export type QueryIsAssetVerificationRequiredArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
};


export type QueryLastOutputDeliverableArtifactInstanceFromReceiptIdArgsGQLType = {
  receiptId: Scalars['UUID'];
};


export type QueryLatestAssignmentPipelineRunStatusForImplementationArgsGQLType = {
  implementationId: Scalars['String'];
};


export type QueryLatestAssignmentReceivablesArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
  loanProductId: Scalars['UUID'];
  type: ReceivableResponseTapePreviewAttachmentTypeGQLType;
  creditFacilityId: Scalars['UUID'];
};


export type QueryLatestAssignmentReceivablesAggregateTotalsWithMetadataArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
};


export type QueryLatestAssignmentReceivablesWithMetadataArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
};


export type QueryLatestAssignmentSummariesArgsGQLType = {
  masterLoanTapeIds: Array<Scalars['String']>;
  creditFacilityIds: Array<Scalars['UUID']>;
  includeInitialCondition: Scalars['Boolean'];
};


export type QueryLatestAssignmentSummaryArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  implementationId: Scalars['UUID'];
};


export type QueryLatestBorrowingBaseReportArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryLatestBorrowingBaseReportsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
};


export type QueryLatestCompletedReceivableResponseTapePreviewIdsArgsGQLType = {
  creditFacilityIds: Array<Scalars['String']>;
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
};


export type QueryLatestCovenantCalculationsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
};


export type QueryLatestHistoricalReceivableResponseTapeValuesArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId?: Maybe<Scalars['UUID']>;
  reportingDatesRange?: Maybe<FullDateStrDateRangeInputGQLType>;
  queryFilters?: Maybe<Scalars['String']>;
  queryPageNumber: Scalars['Int'];
  queryPageBoundaryReceivableIds: Array<Maybe<Scalars['String']>>;
};


export type QueryLatestHistoricalReceivableResponseTapeValuesCountArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId?: Maybe<Scalars['UUID']>;
  reportingDatesRange?: Maybe<FullDateStrDateRangeInputGQLType>;
  queryFilters?: Maybe<Scalars['String']>;
};


export type QueryLatestLedgersForCreditFacilitiesArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  countersignerOrganizationIds?: Maybe<Array<Scalars['UUID']>>;
  ledgerAccountGroup: LedgerAccountGroupGQLType;
};


export type QueryLedgerArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  organizationIds: Array<Scalars['UUID']>;
  accountTypes: Array<TAccountTypeGQLType>;
  selectedTransactionTypes?: Maybe<Array<TransactionTypeGQLType>>;
  startDate?: Maybe<Scalars['LuxonDate']>;
  endDate?: Maybe<Scalars['LuxonDate']>;
};


export type QueryLedgerAccountsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  ledgerAccountGroup: LedgerAccountGroupGQLType;
};


export type QueryLedgerBalanceForCreditFacilitiesArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  countersignerOrganizationIds?: Maybe<Array<Scalars['UUID']>>;
  ledgerAccountGroup: LedgerAccountGroupGQLType;
};


export type QueryLenderVerificationCreditFacilitiesArgsGQLType = {
  organizationId: Scalars['UUID'];
};


export type QueryLenderVerificationProgressBreakdownArgsGQLType = {
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};


export type QueryLoanMechanicsSerializedArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
};


export type QueryLoanTapeMetadataArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};


export type QueryMaximumDrawRequestFrequencyMetadataArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
};


export type QueryOrganizationArgsGQLType = {
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']>>;
};


export type QueryOrganizationsByIdsArgsGQLType = {
  organizationIds: Array<Scalars['UUID']>;
};


export type QueryPartiesByTypeAndCreditFacilityIdsArgsGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  partyType: PartyTypeGQLType;
};


export type QueryPdfAnalysisArgsGQLType = {
  input: PdfAnalysisParamsGQLType;
};


export type QueryReceivableWaiversForCreditFacilityWithOrganizationArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
};


export type QueryReceivableWaiversForReceivableIdsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  receivableIds: Array<Scalars['UUID']>;
  reportingDate?: Maybe<Scalars['FullDateStr']>;
};


export type QueryRepaymentDataForAssignedReceivableArgsGQLType = {
  organizationId: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
  repaymentDateParams?: Maybe<DateRangeInputGQLType>;
};


export type QueryReportDownloadUrlArgsGQLType = {
  reportId: Scalars['UUID'];
  isDomainReport: Scalars['Boolean'];
};


export type QueryReportTemplateDownloadUrlArgsGQLType = {
  reportTemplateId: Scalars['UUID'];
};


export type QueryReportsArgsGQLType = {
  creditFacilityId: Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
  reportTypes?: Maybe<Array<ReportTypeGQLType>>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  isPreview?: Maybe<Scalars['Boolean']>;
};


export type QueryRepurchaseAndTransferJobsArgsGQLType = {
  implementationId: Scalars['String'];
};


export type QuerySlsCreditAgreementsPropertiesForCapitalProviderArgsGQLType = {
  capitalProviderOrganizationId: Scalars['UUID'];
};


export type QueryThreadArgsGQLType = {
  threadId: Scalars['UUID'];
};


export type QueryThreadCountsByDomainArgsGQLType = {
  domain: ThreadDomainGQLType;
  domainIdentifier?: Maybe<Scalars['String']>;
};


export type QueryThreadV2ArgsGQLType = {
  threadId: Scalars['UUID'];
};


export type QueryThreadsArgsGQLType = {
  threadIds: Array<Scalars['UUID']>;
};


export type QueryThreadsByDomainIdentifierArgsGQLType = {
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryThreadsByDomainIdentifierV2ArgsGQLType = {
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryThreadsByDomainMappingArgsGQLType = {
  domain: ThreadDomainGQLType;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryThreadsByDomainMappingV2ArgsGQLType = {
  domain: ThreadDomainGQLType;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryThreadsV2ArgsGQLType = {
  threadIds: Array<Scalars['UUID']>;
};


export type QueryUserArgsGQLType = {
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']>>;
};


export type QueryUserApprovalGroupsForFundingRequestArgsGQLType = {
  fundingRequestId: Scalars['UUID'];
};


export type QueryValleyBankArrangementGroupArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  arrangementGroupNumber: Scalars['String'];
};


export type QueryValleyBankAssignmentPreviewRrtArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  previewLoanAccountNum: Scalars['String'];
  assignmentsToPreview: Array<ValleyBankSubmitAssignmentInputGQLType>;
};


export type QueryValleyBankAssociatedLoanAccountsByCifNumsArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  cifNums: Array<Scalars['String']>;
};


export type QueryValleyBankCustomerArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  cifNumber: Scalars['String'];
};


export type QueryValleyBankCustomersArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  paginationOptions: PaginationOptionsGQLType;
  queryParams?: Maybe<ValleyBankCustomerQueryParamsGQLType>;
};


export type QueryValleyBankDownloadLinksArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
};


export type QueryValleyBankLatestPinnedCommentForLoanAccountsArgsGQLType = {
  loanAccountNums: Array<Scalars['String']>;
  reportingDate: Scalars['FullDateStr'];
  isHistorical: Scalars['Boolean'];
};


export type QueryValleyBankLatestPinnedCommentForLoanAccountsV2ArgsGQLType = {
  loanAccountNums: Array<Scalars['String']>;
  reportingDate: Scalars['FullDateStr'];
  isHistorical: Scalars['Boolean'];
};


export type QueryValleyBankLoanAccountArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  loanAccountNumber: Scalars['String'];
  selectedFinleyReceivableIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryValleyBankLoanAccountByAccountNumsArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  loanAccountNumbers: Array<Scalars['String']>;
};


export type QueryValleyBankLoanAccountsByCifNumsArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  cifNums: Array<Scalars['String']>;
};


export type QueryValleyBankPipelineStatusMetadataArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
};


export type QueryValleyBankUnderMarginLoanAccountsArgsGQLType = {
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
};


export type QueryVerificationBorrowingBaseWaiverImpactArgsGQLType = {
  verificationReportId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
};

export type QueryResultGQLType = {
  __typename?: 'QueryResult';
  name: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
};

export type QueryVariableGQLType = {
  name: Scalars['String'];
  value: Scalars['String'];
  parseNumber: Scalars['Boolean'];
};

export type QuickSightDataTypeEnumGQLType =
  | 'masterLoanTape'
  | 'assignedLoanTape'
  | 'receivableResponseTape'
  | 'portfolioReceivableResponseTape';

export type QuickSightEmbedUrlResponseGQLType = {
  __typename?: 'QuickSightEmbedUrlResponse';
  embedUrl?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
};

export type RailzAccountingMethodGQLType =
  | 'accrual'
  | 'cash';

export type RailzAccountingServiceNamesGQLType =
  | 'freshbooks'
  | 'dynamicsBusinessCentral'
  | 'oracleNetsuite'
  | 'quickbooksDesktop'
  | 'quickbooks'
  | 'sageBusinessCloud'
  | 'sageIntacct'
  | 'xero'
  | 'wave'
  | 'zohoBooks';

export type RailzFinancialApiQueryParamsGQLType = {
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  reportFrequency: RailzReportFrequencyGQLType;
  accountingMethod: RailzAccountingMethodGQLType;
};

export type RailzIntegrationGQLType = {
  __typename?: 'RailzIntegration';
  id: Scalars['UUID'];
  railzBusinessId: Scalars['String'];
  railzConnectionId: Scalars['String'];
  railzServiceName: Scalars['String'];
  organizationId: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  deletedAt?: Maybe<Scalars['JSDate']>;
};

export type RailzReportFrequencyGQLType =
  | 'month'
  | 'quarter'
  | 'year';

export type ReassignmentConfirmationJobInfoGQLType = {
  __typename?: 'ReassignmentConfirmationJobInfo';
  jobId: Scalars['String'];
  receivableCount: Scalars['Int'];
};

export type ReceiptActionTypePostCreationGQLType =
  | 'submitted'
  | 'approved'
  | 'requestRemediation';

export type ReceiptColumnInputGQLType = {
  dependenciesInstanceIds: Array<Scalars['UUID']>;
  finalArtifactsInstanceIds: Array<Scalars['UUID']>;
};

export type ReceiptInstancesGQLType = {
  __typename?: 'ReceiptInstances';
  receiptInstanceId: Scalars['UUID'];
  artifactType: ArtifactTypeGQLType;
  artifactConfigKey: Scalars['String'];
  artifactReportingDate: Scalars['FullDateStr'];
};

export type ReceiptZipFileDownloadAvailableGQLType = {
  __typename?: 'ReceiptZipFileDownloadAvailable';
  canDownloadInput: Scalars['Boolean'];
  canDownloadOutput: Scalars['Boolean'];
};

export type ReceivableBorrowingBaseTestWaiverGQLType = {
  __typename?: 'ReceivableBorrowingBaseTestWaiver';
  id: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
  externalReceivableId: Scalars['String'];
  loanProductId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  borrowingBaseTestType: BorrowingBaseTestTypeGQLType;
  borrowingBaseTestKey: Scalars['String'];
  waiverStartReportingDate?: Maybe<Scalars['FullDateStr']>;
  waiverExpirationReportingDate?: Maybe<Scalars['FullDateStr']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastUpdatedUserId: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  lastUpdatedOrganizationName: Scalars['String'];
};

export type ReceivableBorrowingBaseTestWaiverInputGQLType = {
  finleyReceivableId: Scalars['UUID'];
  externalReceivableId: Scalars['String'];
  loanProductId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  borrowingBaseTestType: BorrowingBaseTestTypeGQLType;
  borrowingBaseTestKey: Scalars['String'];
  waiverStartReportingDate?: Maybe<Scalars['FullDateStr']>;
  waiverExpirationReportingDate?: Maybe<Scalars['FullDateStr']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastUpdatedUserId?: Maybe<Scalars['UUID']>;
  lastUpdatedOrganizationName?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['JSDate']>;
  updated_at?: Maybe<Scalars['JSDate']>;
};

export type ReceivableIdGroupWithLoanProductGQLType = {
  __typename?: 'ReceivableIdGroupWithLoanProduct';
  externalReceivableId: Scalars['String'];
  finleyReceivableId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
};

export type ReceivablePaginationMetadataGQLType = {
  __typename?: 'ReceivablePaginationMetadata';
  hasNextPage: Scalars['Boolean'];
  queryPageBoundaryReceivableIds: Array<Maybe<Scalars['String']>>;
  queryPageNumber: Scalars['Int'];
};

export type ReceivableRepaymentsHistoryGQLType = {
  __typename?: 'ReceivableRepaymentsHistory';
  normalizedRepaymentAmount: Scalars['Float'];
  finleyRepaymentDate: Scalars['FullDateStr'];
};

export type ReceivableResponseTapeAthenaPaginatedResponseGQLType = {
  __typename?: 'ReceivableResponseTapeAthenaPaginatedResponse';
  paginationMetadata: ReceivablePaginationMetadataGQLType;
  receivables: Scalars['String'];
};

export type ReceivableResponseTapePreviewAttachmentTypeGQLType =
  | 'extendedResponseTapePreview'
  | 'proposedExtendedResponseTapePreview'
  | 'assignmentReceivablesCSV'
  | 'proposedAssignmentReceivables'
  | 'unassignedAssignmentReceivables'
  | 'assignmentSummaryPreview';

export type ReceivableResponseTapePropertiesGQLType = {
  __typename?: 'ReceivableResponseTapeProperties';
  creditFacilityId: Scalars['String'];
  valuationFields: ValuationFieldsGQLType;
  eligibilityFields: EligibilityFieldsGQLType;
  concentrationLimitFields: ConcentrationLimitFieldsGQLType;
  borrowingBaseFields: BorrowingBaseFieldsGQLType;
  concentrationLimitReasons: Array<ConcentrationLimitReasonGQLType>;
  concentrationLimitWaivers: Array<ConcentrationLimitWaiverGQLType>;
  eligibilityStatuses: Array<EligibilityStatusContainerGQLType>;
  assignmentFields?: Maybe<AssignmentFieldsGQLType>;
};

export type ReceivableWaiverTestKeyStringsGQLType = {
  __typename?: 'ReceivableWaiverTestKeyStrings';
  externalReceivableId: Scalars['String'];
  borrowingBaseTestKeys: Scalars['String'];
};

export type RefreshDeliverableResponseGQLType = {
  __typename?: 'RefreshDeliverableResponse';
  status: RefreshDeliverableStatusGQLType;
};

export type RefreshDeliverableStatusGQLType =
  | 'success'
  | 'failed';

export type RefreshSourceGQLType =
  | 'glueCompletion'
  | 'manual';

export type RefreshStatusGQLType =
  | 'initializedConfig'
  | 'initializedTable'
  | 'refreshInProgress'
  | 'refreshComplete'
  | 'deleted'
  | 'errorCreateTable'
  | 'errorRefreshData'
  | 'errorDeleteTableAndConfig';

export type RepaymentTapeConfigGQLType = {
  __typename?: 'RepaymentTapeConfig';
  artifactType: ArtifactTypeGQLType;
  loanProductSlug: Scalars['String'];
};

export type ReportGQLType = {
  __typename?: 'Report';
  id: Scalars['UUID'];
  reportType: ReportTypeGQLType;
  s3Path: Scalars['String'];
  borrowerId?: Maybe<Scalars['ID']>;
  isPreview: Scalars['Boolean'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type ReportConfigTypeGQLType =
  | 'assetVerification'
  | 'borrowingBaseCertificate'
  | 'borrowingBaseServicerReport'
  | 'fundingRequestServicerReport'
  | 'monthlyServicerReport'
  | 'noticeOfBorrowing'
  | 'noticeOfPrepayment'
  | 'receivableResponseTapePreviewServicerReport'
  | 'receivablesSaleAgreement'
  | 'releaseNotice'
  | 'fundingNotice'
  | 'invoice'
  | 'disbursementNotice'
  | 'paymentInKindNotice'
  | 'batchSettlement'
  | 'facilityTrialBalance'
  | 'loanTrialBalance';

export type ReportFrequencyGQLType =
  | 'month'
  | 'quarter'
  | 'year';

export type ReportIdWithFilenameInputGQLType = {
  reportId: Scalars['UUID'];
  filename: Scalars['String'];
};

export type ReportS3DownloadUrlWithFilenameGQLType = {
  __typename?: 'ReportS3DownloadUrlWithFilename';
  s3DownloadUrl: Scalars['String'];
  filename: Scalars['String'];
};

export type ReportTemplateGQLType = {
  id: Scalars['UUID'];
  creditFacilityId: Scalars['String'];
  templateName: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  reportType: ReportTemplateReportTypeGQLType;
  s3Path: Scalars['String'];
  baseOutputFilename: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type ReportTemplateFileTypeGQLType =
  | 'docx'
  | 'xlsx'
  | 'digital';

export type ReportTemplateReportTypeGQLType =
  | 'assetVerification'
  | 'borrowingBaseServicerReport'
  | 'fundingRequestServicerReport'
  | 'servicerReport'
  | 'borrowingBaseCertificate'
  | 'noticeOfBorrowing'
  | 'noticeOfPrepayment'
  | 'releaseNotice'
  | 'receivablesSaleAgreement'
  | 'receivableResponseTapePreviewServicerReport'
  | 'monthlyServicerReport'
  | 'fundingNotice'
  | 'invoice'
  | 'disbursementNotice'
  | 'paymentInKindNotice'
  | 'batchSettlement';

export type ReportTypeGQLType =
  | 'assetVerification'
  | 'responseTape'
  | 'extendedResponseTape'
  | 'newlyAssignedExtendedResponseTape'
  | 'rawAssignedLoanTape'
  | 'cashBalancesFeed'
  | 'monthlyServicerReport'
  | 'servicerReport'
  | 'servicerReportPdf'
  | 'borrowingBaseCertificate'
  | 'borrowerSubmittedServicerReport'
  | 'noticeOfBorrowing'
  | 'noticeOfPrepayment'
  | 'releaseNotice'
  | 'placeholderReportType'
  | 'receivablesSaleAgreement'
  | 'fundingRequestServicerReport'
  | 'fundingNotice'
  | 'invoice'
  | 'disbursementNotice'
  | 'paymentInKindNotice'
  | 'batchSettlement';

export type ReportingAccessorDomainTypeGQLType =
  | 'borrowingBaseReport'
  | 'fundingRequest'
  | 'orgProvidedValue'
  | 'portfolioCovenant'
  | 'financialCovenant';

export type ReportingAccessorEntityAttributesGQLType = {
  __typename?: 'ReportingAccessorEntityAttributes';
  domain: ReportingAccessorDomainTypeGQLType;
  database: Scalars['String'];
  namespace: ReportingEntityDbNamespaceTypeGQLType;
  identifier: Scalars['String'];
  accessorName: Scalars['String'];
  supplementalEntityKey?: Maybe<Scalars['String']>;
};

export type ReportingDateAndVersionGQLType = {
  __typename?: 'ReportingDateAndVersion';
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
};

export type ReportingEntityDbNamespaceTypeGQLType =
  | 'borrowing_base_reports'
  | 'funding_requests'
  | 'org_provided_values'
  | 'portfolio_covenants'
  | 'financial_covenants';

export type ReportingEntityRecordsMapGQLType = {
  __typename?: 'ReportingEntityRecordsMap';
  accessorEntityAttributes: Array<ReportingAccessorEntityAttributesGQLType>;
};

export type ReportingGenerateResponseGQLType = {
  __typename?: 'ReportingGenerateResponse';
  status: ReportingGenerateStatusGQLType;
  recordId: Scalars['UUID'];
};

export type ReportingGenerateStatusGQLType =
  | 'success'
  | 'error';

export type ReportingGenerateWorkleaseGQLType = {
  creditAgreementId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  initiatingOrganizationId: Scalars['UUID'];
  reportName: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  mode: WorkleaseModeGQLType;
  reportTemplateFileType: ReportTemplateFileTypeGQLType;
  reportConfigType: ReportConfigTypeGQLType;
  config?: Maybe<Scalars['Object']>;
};

export type ReportingMechanicsGQLType = {
  __typename?: 'ReportingMechanics';
  fundingNotices: Array<FundingNoticeGQLType>;
};

export type ReportingVariableGQLType = {
  __typename?: 'ReportingVariable';
  name: Scalars['String'];
  value?: Maybe<Scalars['Primitive']>;
};

export type ReportingWorkleaseStatusGQLType =
  | 'initialized'
  | 'error'
  | 'success';

export type ReportsConnectionGQLType = {
  __typename?: 'ReportsConnection';
  nodes: Array<ReportGQLType>;
  pageInfo: PageInfoGQLType;
  totalCount: Scalars['Int'];
};

export type RequestedUserApprovalForDomainGQLType = {
  __typename?: 'RequestedUserApprovalForDomain';
  user: UserObjectGQLType;
  state?: Maybe<UserApprovalStateGQLType>;
};

export type RequiredCashBalanceGQLType = {
  __typename?: 'RequiredCashBalance';
  externalFilename: Scalars['String'];
  artifactType: CashBalanceArtifactTypeGQLType;
  creditFacilityId: Scalars['String'];
  artifactSlug: Scalars['String'];
  artifactId: Scalars['UUID'];
  currentReportingDate?: Maybe<Scalars['FullDateStr']>;
  currentFileVersion?: Maybe<Scalars['Int']>;
  columns: Array<ColumnInfoGQLType>;
  accountTypesWithConnectionProvider: Array<Scalars['String']>;
  fileExtension: Scalars['String'];
};

export type RequiredDataTapeGQLType = {
  __typename?: 'RequiredDataTape';
  externalFilename: Scalars['String'];
  artifactType: TapeArtifactTypeGQLType;
  artifactSlug: Scalars['String'];
  artifactId: Scalars['UUID'];
  loanProductSlug?: Maybe<Scalars['String']>;
  validCreditFacilityIds: Array<Scalars['UUID']>;
  currentReportingDate?: Maybe<Scalars['FullDateStr']>;
  currentFileVersion?: Maybe<Scalars['Int']>;
  columns: Array<ColumnInfoGQLType>;
  progressSummary?: Maybe<Scalars['Object']>;
  fileExtension: Scalars['String'];
};

export type RequiredDataTapeGroupingGQLType = {
  __typename?: 'RequiredDataTapeGrouping';
  latestReportingDate?: Maybe<Scalars['FullDateStr']>;
  requiredDataTapes: Array<RequiredDataTapeGQLType>;
  requiredCashBalances: Array<RequiredCashBalanceGQLType>;
  requiredXlsxTapes: Array<RequiredXlsxTapeGQLType>;
};

export type RequiredDataTapesGQLType = {
  __typename?: 'RequiredDataTapes';
  requiredDataTapesGroupings: Array<RequiredDataTapeGroupingGQLType>;
};

export type RequiredIntermediateFieldsGQLType = {
  __typename?: 'RequiredIntermediateFields';
  assignmentExclusion: AssignmentExclusionGQLType;
  exposure: Scalars['Float'];
  waiveAllEligibility: Scalars['Boolean'];
  waiveAllConcentration: Scalars['Boolean'];
  includeInConcentrationLimitDenominatorIfWaived: Scalars['Boolean'];
  originalOwnerSlug: Scalars['String'];
  normalizedDaysPastDue?: Maybe<Scalars['Float']>;
  normalizedDurationDays?: Maybe<Scalars['Float']>;
  normalizedisChargedOff?: Maybe<Scalars['Boolean']>;
  normalizedisDelinquent?: Maybe<Scalars['Boolean']>;
  normalizedOriginationDate?: Maybe<Scalars['String']>;
  normalizedInitialBalance?: Maybe<Scalars['Float']>;
};

export type RequiredIntermediateFieldsForCreditFacilityGQLType = {
  __typename?: 'RequiredIntermediateFieldsForCreditFacility';
  creditFacilityId: Scalars['String'];
  requiredIntermediateFields: RequiredIntermediateFieldsGQLType;
};

export type RequiredXlsxTapeGQLType = {
  __typename?: 'RequiredXlsxTape';
  externalFilename: Scalars['String'];
  artifactType: TapeArtifactTypeGQLType;
  artifactSlug: Scalars['String'];
  artifactId: Scalars['UUID'];
  loanProductSlug?: Maybe<Scalars['String']>;
  validCreditFacilityIds: Array<Scalars['UUID']>;
  currentReportingDate?: Maybe<Scalars['FullDateStr']>;
  currentFileVersion?: Maybe<Scalars['Int']>;
  valueFieldGroups: Array<XlsxValueFieldGroupGQLType>;
  tapeFieldGroups: Array<XlsxTapeFieldGroupGQLType>;
  progressSummary?: Maybe<Scalars['Object']>;
  fileExtension: Scalars['String'];
};

export type ResolvedAggregateLineItemEntryGQLType = {
  __typename?: 'ResolvedAggregateLineItemEntry';
  postingDate: Scalars['FullDateStr'];
  aggregateAmount: Scalars['Float'];
  tAccount: TAccountTypeGQLType;
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  creditFacilityName: Scalars['String'];
  organizationId: Scalars['UUID'];
  organizationSlug: Scalars['String'];
  organizationName: Scalars['String'];
  loanId?: Maybe<Scalars['String']>;
  loanName?: Maybe<Scalars['String']>;
  externalLoanId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};

export type ResolvedDetailedEntryItemGQLType = {
  __typename?: 'ResolvedDetailedEntryItem';
  postingDate: Scalars['FullDateStr'];
  transactionType: TransactionTypeGQLType;
  transactionCreatedAt: Scalars['JSDate'];
  comment?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  tAccount: TAccountTypeGQLType;
  creditFacilityId: Scalars['UUID'];
  creditFacilitySlug: Scalars['String'];
  creditFacilityName: Scalars['String'];
  organizationId: Scalars['UUID'];
  organizationSlug: Scalars['String'];
  organizationName: Scalars['String'];
  loanId?: Maybe<Scalars['String']>;
  loanName?: Maybe<Scalars['String']>;
  externalLoanId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
};

export type ResolvedLoanGQLType = {
  __typename?: 'ResolvedLoan';
  id: Scalars['String'];
  externalLoanId?: Maybe<Scalars['String']>;
  commitmentKey: Scalars['String'];
  name: Scalars['String'];
  classLabel?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  calculatedLoanStatus: CalculatedLoanStatusGQLType;
  loanType: LoanTypeGQLType;
  edits: LoanEditDataGQLType;
  dates: LoanDatesDataGQLType;
  facility: LoanFacilityDataGQLType;
  parties: LoanPartiesDataGQLType;
  funding: LoanFundingDataGQLType;
  pricing: LoanPricingGQLType;
  invoiceMechanics?: Maybe<Scalars['Object']>;
  fees: LoanFeesGQLType;
  invoices?: Maybe<LoanInvoiceGQLType>;
  customerProvided?: Maybe<CustomerProvidedGQLType>;
};

export type ResponseWithStringGQLType = {
  __typename?: 'ResponseWithString';
  response: Scalars['String'];
};

export type ResultTypeGQLType =
  | 'primitive';

export type RoleTypeGQLType =
  | 'ADMIN'
  | 'MEMBER'
  | 'CONTRIBUTOR';

export type RuntimeVariableReturnTypeGQLType =
  | 'string'
  | 'stringArray'
  | 'number';

export type S3DownloadUrlByWorkleaseGQLType = {
  __typename?: 'S3DownloadUrlByWorklease';
  workleaseStatus: ReportingWorkleaseStatusGQLType;
  s3DownloadUrl?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type SchemaItemGQLType = {
  __typename?: 'SchemaItem';
  columnName: Scalars['String'];
  type: SchemaItemTypeGQLType;
};

export type SchemaItemTypeGQLType =
  | 'string'
  | 'number'
  | 'boolean';

export type ServicerReportPreviewTypeGQLType =
  | 'assignmentServicerReportPreview'
  | 'calcAgentQAServicerReportPreview'
  | 'fundingRequestServicerReportPreview';

export type ShareFundingComponentGQLType = {
  __typename?: 'ShareFundingComponent';
  fundingRequestComponentId: Scalars['UUID'];
  type: FundingRequestComponentTypeEnumGQLType;
  requestedAmount: Scalars['Float'];
  targetFundingDate: Scalars['FullDateStr'];
  postingDate?: Maybe<Scalars['FullDateStr']>;
  fundTransferDate?: Maybe<Scalars['FullDateStr']>;
  lenderShareId: Scalars['UUID'];
  lenderOrganizationId: Scalars['UUID'];
  projectedInterest: Scalars['Float'];
};

export type SheetInputGQLType = {
  sheetName: Scalars['String'];
  rows: Scalars['Int'];
  endColumn?: Maybe<Scalars['String']>;
};

export type SignaledAssignmentsInputGQLType = {
  creditFacilityId: Scalars['String'];
  finleyReceivableId: Scalars['String'];
};

export type SkimFeeGQLType = {
  __typename?: 'SkimFee';
  type: Scalars['String'];
  rate: Scalars['Float'];
};

export type SlackInstallationGQLType = {
  __typename?: 'SlackInstallation';
  id: Scalars['String'];
  botToken: Scalars['String'];
  botId: Scalars['String'];
  botUserId: Scalars['String'];
  botScopes: Scalars['String'];
  userId: Scalars['String'];
  incomingWebhookUrl: Scalars['String'];
  incomingWebhookChannelId: Scalars['String'];
  incomingWebhookChannelName: Scalars['String'];
  incomingWebhookConfigurationUrl: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  isActive: Scalars['Boolean'];
  organizationId: Scalars['String'];
  teamId?: Maybe<Scalars['String']>;
  teamName?: Maybe<Scalars['String']>;
  enterpriseId?: Maybe<Scalars['String']>;
  enterpriseName?: Maybe<Scalars['String']>;
  userToken?: Maybe<Scalars['String']>;
  userScopes?: Maybe<Scalars['String']>;
};

export type SlackSubscriptionGQLType = {
  __typename?: 'SlackSubscription';
  id: Scalars['String'];
  notificationType: NotificationTypeGQLType;
  slackInstallationId: Scalars['String'];
  filter: SubscriptionFilterGQLType;
};

export type SlackSubscriptionResponseGQLType = {
  __typename?: 'SlackSubscriptionResponse';
  response: Scalars['String'];
  subscription: SlackSubscriptionGQLType;
};

export type SlsCreditAgreementPropertiesGQLType = {
  __typename?: 'SlsCreditAgreementProperties';
  creditFacilityId: Scalars['UUID'];
  externalFacilityId?: Maybe<Scalars['String']>;
  maturityDate: Scalars['FullDateStr'];
  closingDate: Scalars['FullDateStr'];
  revolvingPeriodEndDate?: Maybe<Scalars['FullDateStr']>;
  globalCommitmentAmount: Scalars['Float'];
  capitalProviderCommitmentAmount: Scalars['Float'];
  interestRatesDisplay: Scalars['String'];
  unusedFeesDisplay?: Maybe<Scalars['String']>;
  upfrontFeesDisplay?: Maybe<Scalars['String']>;
};

export type SortDirectionGQLType =
  | 'asc'
  | 'desc';

export type SpecificDateAcknowledgementGQLType = {
  reportingDate: Scalars['FullDateStr'];
  receivableId: Scalars['UUID'];
};


export type StartEndOptionalDateStrMapGQLType = {
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
};

export type StatementTransactionAggregationLevelGQLType =
  | 'daily'
  | 'none';

export type StatusDetailsGQLType = {
  __typename?: 'StatusDetails';
  status: RefreshStatusGQLType;
  message?: Maybe<Scalars['String']>;
};

export type StepStatusGQLType = {
  __typename?: 'StepStatus';
  status: StepStatusEnumGQLType;
  errors?: Maybe<Array<Scalars['Object']>>;
};

export type StepStatusEnumGQLType =
  | 'notStarted'
  | 'inProgress'
  | 'success'
  | 'error'
  | 'remediationRequested';

export type StringArrayAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'StringArrayAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Array<Scalars['String']>>;
  validation: AttributeValueStringArrayValidationGQLType;
};

export type StringArrayRuntimeVariableTemplateGQLType = {
  __typename?: 'StringArrayRuntimeVariableTemplate';
  name: Scalars['String'];
  returnType: RuntimeVariableReturnTypeGQLType;
  options: Array<StringOptionsGQLType>;
};

export type StringArrayStaticParamTemplateGQLType = {
  __typename?: 'StringArrayStaticParamTemplate';
  variableName: Scalars['String'];
  variableType: ActionParamVariableTypeGQLType;
  options: Array<StringOptionsGQLType>;
};

export type StringAttributeValueGQLType = AbstractAttributeValueGQLType & {
  __typename?: 'StringAttributeValue';
  attributeId: Scalars['UUID'];
  name: Scalars['String'];
  ownerOrganizationId: Scalars['UUID'];
  type: AttributeTypeGQLType;
  attributeValueId: Scalars['UUID'];
  entityIdentifier: Scalars['String'];
  entityDomain: Scalars['String'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  displayName: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  validation: AttributeValueStringValidationGQLType;
};

export type StringOptionsGQLType = {
  __typename?: 'StringOptions';
  label: Scalars['String'];
  stringValue: Scalars['String'];
};

export type StringRuntimeVariableTemplateGQLType = {
  __typename?: 'StringRuntimeVariableTemplate';
  name: Scalars['String'];
  returnType: RuntimeVariableReturnTypeGQLType;
  options: Array<StringOptionsGQLType>;
};

export type StringStaticParamTemplateGQLType = {
  __typename?: 'StringStaticParamTemplate';
  variableName: Scalars['String'];
  variableType: ActionParamVariableTypeGQLType;
  options: Array<StringOptionsGQLType>;
};

export type SubmittedDeliverableSubmissionPayloadGQLType = {
  __typename?: 'SubmittedDeliverableSubmissionPayload';
  creditFacilityId: Scalars['UUID'];
  deliverable: DeliverablePayloadGQLType;
  responsibleParties: Array<DeliverableResponsiblePartyPayloadGQLType>;
  deliverableSubmission: DeliverableSubmissionPayloadGQLType;
};

export type SubscriptionFilterGQLType = {
  __typename?: 'SubscriptionFilter';
  creditFacilitySlugs: Array<Scalars['String']>;
};

export type SuccessCreateWorkflowTemplateResponseGQLType = {
  __typename?: 'SuccessCreateWorkflowTemplateResponse';
  status: ValidateAndCreateWorkflowTemplateResponseStatusGQLType;
  template: WorkflowTemplateGQLType;
};

export type SuccessFinancialCovenantGQLType = {
  __typename?: 'SuccessFinancialCovenant';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreementId?: Maybe<Scalars['UUID']>;
  covenantKey: Scalars['String'];
  triggerDate: Scalars['FullDateStr'];
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  status: FinancialCovenantStatusGQLType;
  result: FinancialCovenantResultGQLType;
  value: Scalars['Float'];
  variables: Array<FinancialCovenantVariableGQLType>;
  errors: Array<Scalars['String']>;
};

export type SuccessOrErrorPortfolioCovenantGQLType = SuccessPortfolioCovenantGQLType | ErrorPortfolioCovenantGQLType;

export type SuccessPortfolioCovenantGQLType = {
  __typename?: 'SuccessPortfolioCovenant';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  version: Scalars['Int'];
  triggerDate: Scalars['FullDateStr'];
  result: PortfolioCovenantResultResultGQLType;
  value?: Maybe<Scalars['Float']>;
  variables: Array<PortfolioCovenantVariableGQLType>;
  warnings: Array<Scalars['String']>;
  status: PortfolioCovenantStatusGQLType;
  metadata?: Maybe<PortfolioCovenantMetadataGQLType>;
  created_at?: Maybe<Scalars['JSDate']>;
  updated_at?: Maybe<Scalars['JSDate']>;
};

export type SuccessesAndErrorsGQLType = {
  __typename?: 'SuccessesAndErrors';
  successes: Array<Scalars['String']>;
  errors: Array<Scalars['String']>;
};

export type SummarizedLoanGQLType = {
  __typename?: 'SummarizedLoan';
  id: Scalars['String'];
  externalLoanId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  loanStatus: LoanStatusGQLType;
  calculatedLoanStatus: CalculatedLoanStatusGQLType;
  loanType: LoanTypeGQLType;
  isFinal: Scalars['Boolean'];
  originationDate: Scalars['FullDateStr'];
  nextPaymentDate?: Maybe<Scalars['FullDateStr']>;
  maturityDate: Scalars['FullDateStr'];
  creditFacilityId: Scalars['String'];
  creditFacilityName: Scalars['String'];
  externalFacilityId?: Maybe<Scalars['String']>;
  borrowerOrganization: BaseOrganizationGQLType;
  lenderOrganizations: Array<BaseOrganizationGQLType>;
  edits: LoanEditDataGQLType;
};

export type SummaryAccountBalanceGQLType = {
  __typename?: 'SummaryAccountBalance';
  tAccount: TAccountTypeGQLType;
  startingBalance: Scalars['Float'];
  endingBalance: Scalars['Float'];
};

export type SummaryBalanceGQLType = {
  __typename?: 'SummaryBalance';
  description: Scalars['String'];
  accounts: Array<SummaryBalanceAccountGQLType>;
  balance: Scalars['Float'];
};

export type SummaryBalanceAccountGQLType = {
  __typename?: 'SummaryBalanceAccount';
  organizationId: Scalars['String'];
  account: Scalars['String'];
  balance: Scalars['Float'];
};

export type SummaryPeriodStatementGQLType = {
  __typename?: 'SummaryPeriodStatement';
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  accountBalances: Array<SummaryAccountBalanceGQLType>;
  totalStartingBalance: Scalars['Float'];
  totalEndingBalance: Scalars['Float'];
};

export type SummaryStatementCadenceGQLType =
  | 'month';

export type SupplementalTapeConfigGQLType = {
  __typename?: 'SupplementalTapeConfig';
  artifactType: ArtifactTypeGQLType;
  artifactSlug: Scalars['String'];
};

export type TAccountGQLType = {
  __typename?: 'TAccount';
  id: Scalars['UUID'];
  creditFacilityId: Scalars['String'];
  organizationId: Scalars['String'];
  tAccount: TAccountTypeGQLType;
};

export type TAccountInputGQLType = {
  id: Scalars['UUID'];
  tAccount: TAccountTypeGQLType;
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
};

export type TAccountTotalAmountsGQLType = {
  __typename?: 'TAccountTotalAmounts';
  tAccount: TAccountTypeGQLType;
  totalAmount: Scalars['Float'];
};

export type TAccountTypeGQLType =
  | 'longTermDebt'
  | 'accruedAccountBankFee'
  | 'accruedAdminAgentFee'
  | 'accruedAdminFee'
  | 'accruedAdminAgentSkimFee'
  | 'accruedBackupServicingFee'
  | 'accruedCollateralAgentFee'
  | 'accruedCollateralManagementFee'
  | 'accruedCollectionAccountFee'
  | 'accruedCommitmentFee'
  | 'accruedCustodianFee'
  | 'accruedDrawFee'
  | 'accruedInterest'
  | 'accruedIndentureTrusteeFee'
  | 'accruedOriginationFee'
  | 'accruedOtherFee'
  | 'accruedPayingAgentFee'
  | 'accruedServicingFee'
  | 'accruedTrustAccountFee'
  | 'accruedUnusedInterest'
  | 'accruedUtilizationAdditionalInterest'
  | 'accruedVerificationAgentFee'
  | 'cash'
  | 'shareholdersEquity'
  | 'accountBankFeeExpense'
  | 'adminAgentFeeExpense'
  | 'adminFeeExpense'
  | 'adminAgentSkimFeeExpense'
  | 'backupServicingFeeExpense'
  | 'collateralAgentFeeExpense'
  | 'collateralManagementFeeExpense'
  | 'collectionAccountFeeExpense'
  | 'commitmentFeeExpense'
  | 'custodianFeeExpense'
  | 'drawFeeExpense'
  | 'interestExpense'
  | 'indentureTrusteeFeeExpense'
  | 'originationFeeExpense'
  | 'otherFeeExpense'
  | 'payingAgentFeeExpense'
  | 'servicingFeeExpense'
  | 'trustAccountFeeExpense'
  | 'unusedInterestExpense'
  | 'utilizationAdditionalInterestExpense'
  | 'verificationAgentFeeExpense'
  | 'adminAgentPrincipalReceivable'
  | 'adminAgentPrincipalPayable';

export type TAccountTypeEnumGQLType =
  | 'credit'
  | 'debit';

export type TAccountsSumInputGQLType = {
  __typename?: 'TAccountsSumInput';
  tAccount: Scalars['String'];
  counterpartySlug: Scalars['String'];
  value: Scalars['Float'];
};

export type TAccountsSumInputValuesGQLType = {
  __typename?: 'TAccountsSumInputValues';
  type: PostgresQueryTypeGQLType;
  inputValues: Array<TAccountsSumInputGQLType>;
};

export type TablePreferenceGQLType = {
  __typename?: 'TablePreference';
  id: Scalars['UUID'];
  tableKey: Scalars['String'];
  config: TablePreferenceConfigGQLType;
  userId: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type TablePreferenceConfigGQLType = {
  __typename?: 'TablePreferenceConfig';
  columns: Array<ColumnConfigurationGQLType>;
};

export type TablePreferenceConfigInputGQLType = {
  columns: Array<ColumnConfigurationInputGQLType>;
};

export type TablePreferenceInputGQLType = {
  tableKey: Scalars['String'];
  config: TablePreferenceConfigInputGQLType;
};

export type TapeArtifactTypeGQLType =
  | 'rawLoanTape'
  | 'rawRepaymentTape'
  | 'rawSupplementalTape';

export type TaskGQLType = {
  __typename?: 'Task';
  domainProperties: DomainPropertiesGQLType;
  taskEntity: TaskEntityGQLType;
};

export type TaskCategoryGQLType =
  | 'fundingRequest'
  | 'invoice'
  | 'disbursement'
  | 'lenderShares';

export type TaskDateRangeFilterGQLType = {
  __typename?: 'TaskDateRangeFilter';
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};

export type TaskDateRangeFilterInputGQLType = {
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
};

export type TaskEntityGQLType = {
  __typename?: 'TaskEntity';
  id: Scalars['UUID'];
  status: TaskStatusGQLType;
  dueDate: Scalars['FullDateStr'];
  assignedUser?: Maybe<UserObjectGQLType>;
};

export type TaskFilterGQLType = {
  __typename?: 'TaskFilter';
  creditFacilityIds: Array<Scalars['UUID']>;
  loanIds?: Maybe<Array<Scalars['UUID']>>;
  statuses: Array<TaskStatusGQLType>;
  categories: Array<TaskCategoryGQLType>;
  dateRange?: Maybe<TaskDateRangeFilterGQLType>;
};

export type TaskFilterInputGQLType = {
  creditFacilityIds: Array<Scalars['UUID']>;
  loanIds?: Maybe<Array<Scalars['UUID']>>;
  statuses: Array<TaskStatusGQLType>;
  categories: Array<TaskCategoryGQLType>;
  dateRange?: Maybe<TaskDateRangeFilterInputGQLType>;
};

export type TaskFilterStateGQLType = {
  __typename?: 'TaskFilterState';
  currentFilters: TaskFilterGQLType;
  allLoanIds: Array<Scalars['UUID']>;
};

export type TaskResultGQLType = {
  __typename?: 'TaskResult';
  tasks: Array<TaskGQLType>;
  filterState?: Maybe<TaskFilterStateGQLType>;
};

export type TaskSectionParamInputGQLType = {
  type: TaskSectionParamInputTypeGQLType;
  assignedUserId?: Maybe<Scalars['UUID']>;
  status?: Maybe<TaskStatusGQLType>;
};

export type TaskSectionParamInputTypeGQLType =
  | 'user'
  | 'status';

export type TaskStatusGQLType =
  | 'archived'
  | 'overdue'
  | 'dueSoon'
  | 'completed';

export type TellerAccountBalancesGQLType = {
  __typename?: 'TellerAccountBalances';
  ledger: Scalars['String'];
  available: Scalars['String'];
};

export type TellerAccountDetailsGQLType = {
  __typename?: 'TellerAccountDetails';
  account_number: Scalars['String'];
};

export type TellerAccountInstitutionGQLType = {
  __typename?: 'TellerAccountInstitution';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TellerAccountStatusEnumGQLType =
  | 'open'
  | 'closed';

export type TellerAccountTransactionGQLType = {
  __typename?: 'TellerAccountTransaction';
  id: Scalars['UUID'];
  amount: Scalars['String'];
  type: Scalars['String'];
  status: Scalars['String'];
  date: Scalars['FullDateStr'];
  description: Scalars['String'];
  details: TellerTransactionDetailsGQLType;
  running_balance?: Maybe<Scalars['String']>;
};

export type TellerDisconnectInstitutionPayloadGQLType = {
  __typename?: 'TellerDisconnectInstitutionPayload';
  disconnectedItemId: Scalars['String'];
};

export type TellerTransactionCounterpartyGQLType = {
  __typename?: 'TellerTransactionCounterparty';
  name: Scalars['String'];
  type: Scalars['String'];
};

export type TellerTransactionDetailsGQLType = {
  __typename?: 'TellerTransactionDetails';
  processing_status: Scalars['String'];
  category: Scalars['String'];
  counterparty?: Maybe<TellerTransactionCounterpartyGQLType>;
};

export type ThreadGQLType = {
  __typename?: 'Thread';
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentGQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<LatestThreadActionLogGQLType>;
};

export type ThreadActionGQLType =
  | 'pin'
  | 'unpin'
  | 'resolve'
  | 'open';

export type ThreadActionTypeGQLType =
  | 'pin'
  | 'resolve';

export type ThreadActorGQLType = {
  __typename?: 'ThreadActor';
  id: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organization: BaseOrganizationGQLType;
};

export type ThreadCountsGQLType = {
  __typename?: 'ThreadCounts';
  total: Scalars['Int'];
  pinned: Scalars['Int'];
  resolved: Scalars['Int'];
};

export type ThreadCreatedEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'ThreadCreatedEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  current: ThreadCreatedEventSnapshotGQLType;
};

export type ThreadCreatedEventSnapshotGQLType = {
  __typename?: 'ThreadCreatedEventSnapshot';
  id: Scalars['UUID'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
};

export type ThreadDomainGQLType =
  | 'fundingRequest_request'
  | 'valleyBank_loanAccountNumber'
  | 'deliverables_container'
  | 'limitedPartner'
  | 'invoice';

export type ThreadLatestActionLogV2GQLType = {
  __typename?: 'ThreadLatestActionLogV2';
  user: EventLogActorGQLType;
  actionType: ThreadActionTypeGQLType;
};

export type ThreadV2GQLType = DeliverableThreadGQLType | FundingRequestThreadGQLType | LimitedPartnerThreadGQLType | ValleyBankLoanAccountThreadGQLType | InvoiceThreadGQLType;

export type ThreadWithDomainIdentifierGQLType = {
  __typename?: 'ThreadWithDomainIdentifier';
  thread: ThreadGQLType;
};

export type TotalRiskInsightsOutputDataGQLType = {
  __typename?: 'TotalRiskInsightsOutputData';
  borrowingBaseRisk: Array<AggregateBorrowingRiskInsightsGqlDataGQLType>;
  receivableRisk: Array<AggregateReceivableRiskInsightsGqlDataGQLType>;
};

export type TransactionDateRangeGQLType = {
  __typename?: 'TransactionDateRange';
  earliestDate: Scalars['FullDateStr'];
  latestDate: Scalars['FullDateStr'];
};

export type TransactionTypeGQLType =
  | 'drawRequest'
  | 'collectionsRecycle'
  | 'collectionsPaydown'
  | 'curePaydown'
  | 'expensePayment'
  | 'increaseCurrentLiability'
  | 'decreaseCurrentLiability'
  | 'decreaseExpensePayment'
  | 'increaseExpensePayment'
  | 'increaseOutstandingLoanBalance'
  | 'decreaseOutstandingLoanBalance'
  | 'dailyAccrual'
  | 'reverseInterestAccrual'
  | 'reconciliationAdjustment'
  | 'zeroCurrentLiabilities'
  | 'invoiceLoanPayment'
  | 'reverseInvoiceLoanPayment'
  | 'interestCapitalization'
  | 'reverseInterestCapitalization'
  | 'invoiceFacilityPayment'
  | 'reverseInvoiceFacilityPayment'
  | 'transferPrincipalBalance'
  | 'adminAgentPrincipalLending'
  | 'adminAgentPrincipalPaydown'
  | 'reverseAdminAgentPrincipalPaydown';


export type UnknownActorGQLType = ActorGQLType & {
  __typename?: 'UnknownActor';
  id: Scalars['UUID'];
  actorType: ActorTypeGQLType;
  originalActorType: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateAttributeInputGQLType = {
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<AttributeTypeGQLType>;
  validation?: Maybe<AttributeValidationInputGQLType>;
};

export type UpdateExploPlacementIntegrationParamsGQLType = {
  exploEmbedId: Scalars['String'];
};

export type UpdateFinStatementLineItemInputGQLType = {
  finStatementLineItemId: Scalars['String'];
  props: UpdateFinStatementLineItemPropsGQLType;
};

export type UpdateFinStatementLineItemPropsGQLType = {
  groups?: Maybe<Array<Scalars['String']>>;
  ledgerName?: Maybe<Scalars['String']>;
  section?: Maybe<FinancialSectionTypesGQLType>;
  value?: Maybe<Scalars['Float']>;
};

export type UpdateFundingRequestChangesetGQLType = {
  id: Scalars['UUID'];
  loanRequests?: Maybe<Array<UpdateFundingRequestLoansChangesetGQLType>>;
  fundingRequestComponents: Array<UpdateFundingRequestComponentChangesetGQLType>;
  apiVersion?: Maybe<Scalars['Int']>;
  commentProps?: Maybe<NewThreadWithCommentInputGQLType>;
};

export type UpdateFundingRequestComponentChangesetGQLType = {
  id: Scalars['UUID'];
  type: FundingRequestComponentTypeEnumGQLType;
  amount: Scalars['Float'];
  sourceBankAccountId: Scalars['String'];
  destinationBankAccountId: Scalars['String'];
  targetFundingDate?: Maybe<Scalars['FullDateStr']>;
  applicableMargin?: Maybe<Scalars['Float']>;
};

export type UpdateFundingRequestComponentTotalAmountsGQLType = {
  drawRequestTotalAmount: Scalars['Float'];
  collectionsRecycleTotalAmount: Scalars['Float'];
  collectionsPaydownTotalAmount: Scalars['Float'];
  curePaydownTotalAmount: Scalars['Float'];
};

export type UpdateFundingRequestLoansChangesetGQLType = {
  externalLoanId?: Maybe<Scalars['String']>;
  maturityDate: Scalars['FullDateStr'];
  loanType: LoanTypeGQLType;
  pricingOptionKey: Scalars['String'];
  loanKey: Scalars['String'];
  commitmentKey: Scalars['String'];
  invoiceMechanicsKey?: Maybe<Scalars['String']>;
  initialDeterminationDate?: Maybe<Scalars['FullDateStr']>;
};

export type UpdateFundingRequestTotalAmountsGQLType = {
  id: Scalars['UUID'];
  fundingRequestComponentTotalAmounts: UpdateFundingRequestComponentTotalAmountsGQLType;
};

export type UpdateFundingVerificationReceivableEligibilityChangesetGQLType = {
  id: Scalars['UUID'];
  waived: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  fundingVerificationReportId: Scalars['UUID'];
};

export type UpdateInvoiceResponseGQLType = {
  __typename?: 'UpdateInvoiceResponse';
  invoiceId: Scalars['UUID'];
};

export type UpdateLimitedPartnerGQLType = {
  name?: Maybe<Scalars['String']>;
  alternateAliases?: Maybe<Array<Scalars['String']>>;
};

export type UpdateLimitedPartnerMappingResponseGQLType = {
  __typename?: 'UpdateLimitedPartnerMappingResponse';
  limitedPartnerMappingId: Scalars['UUID'];
  limitedPartnerName: Scalars['String'];
  limitedPartnerAlias: Scalars['String'];
  limitedPartnerId?: Maybe<Scalars['UUID']>;
};

export type UpdateUserSettingsGQLType = {
  id: Scalars['UUID'];
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  roleType?: Maybe<RoleTypeGQLType>;
};

export type UpdatedDeliverableStatusPayloadGQLType = {
  __typename?: 'UpdatedDeliverableStatusPayload';
  creditFacilityId: Scalars['UUID'];
  deliverable: DeliverablePayloadGQLType;
  responsibleParties: Array<DeliverableResponsiblePartyPayloadGQLType>;
  previousStatus: DeliverableProgressStatusGQLType;
};

export type UploadedDocumentStatusGQLType =
  | 'latestPublished'
  | 'published';

export type UploadedDocumentTypeGQLType =
  | 'participationAgreement'
  | 'creditAgreement';

export type UrlAndFilenameGQLType = {
  __typename?: 'UrlAndFilename';
  url: Scalars['String'];
  filename: Scalars['String'];
};

export type UserGQLType = {
  __typename?: 'User';
  id: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  roleType: Scalars['String'];
  userType: UserTypeGQLType;
  organizationId: Scalars['UUID'];
  organization: OrganizationGQLType;
  emailSubscriptions: Array<EmailSubscriptionGQLType>;
};

export type UserActorGQLType = ActorGQLType & {
  __typename?: 'UserActor';
  actorType: ActorTypeGQLType;
  id: Scalars['UUID'];
  email: Scalars['String'];
  userType: UserTypeGQLType;
  organizationId: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  roleType: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  name: Scalars['String'];
};

export type UserApprovalActionGQLType =
  | 'approve'
  | 'reject';

export type UserApprovalForDomainGQLType = {
  __typename?: 'UserApprovalForDomain';
  user: UserObjectGQLType;
  approvalStatusAt: Scalars['JSDate'];
  approvalStatus: UserApprovalStatusForDomainGQLType;
};

export type UserApprovalGroupGQLType = {
  __typename?: 'UserApprovalGroup';
  id: Scalars['UUID'];
  comparator: WorkflowStringArrayComparatorGQLType;
  requestedApprovals: Array<RequestedUserApprovalForDomainGQLType>;
  groupState?: Maybe<UserApprovalStateGQLType>;
};

export type UserApprovalStateGQLType = {
  __typename?: 'UserApprovalState';
  status: UserApprovalStatusForDomainGQLType;
  statusAt: Scalars['JSDate'];
};

export type UserApprovalStatusForDomainGQLType =
  | 'requested'
  | 'approved'
  | 'rejected';

export type UserObjectGQLType = {
  __typename?: 'UserObject';
  id: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  userType: UserTypeGQLType;
  isActive?: Maybe<Scalars['Boolean']>;
  roleType: RoleTypeGQLType;
};

export type UserTypeGQLType =
  | 'BORROWER'
  | 'CAPITAL_PROVIDER'
  | 'SUPER_USER';

export type ValidateAndCreateWorkflowTemplateResponseGQLType = ErrorCreateWorkflowTemplateResponseGQLType | SuccessCreateWorkflowTemplateResponseGQLType;

export type ValidateAndCreateWorkflowTemplateResponseStatusGQLType =
  | 'success'
  | 'error';

export type ValleyBankAccountCollateralTypeGQLType =
  | 'IBS'
  | 'OPICS'
  | 'PSPLUS';

export type ValleyBankAddToAssignmentQueueGQLType = {
  collateralAccountNumber: Scalars['String'];
  loanAccountNumber: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  action: ValleyBankAssignmentActionTypeGQLType;
  userId: Scalars['UUID'];
};

export type ValleyBankAllLoanTapeDetailsGQLType = {
  __typename?: 'ValleyBankAllLoanTapeDetails';
  loanProductSlug: Scalars['String'];
  loanProductId: Scalars['String'];
  loanTapeDetails: ValleyBankGeneratedLoanTapeDetailsGQLType;
};

export type ValleyBankAssignmentActionTypeGQLType =
  | 'assign'
  | 'unassign';

export type ValleyBankAssignmentDetailGQLType = {
  __typename?: 'ValleyBankAssignmentDetail';
  collateralAccountNum: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  cifNum: Scalars['String'];
  fullName: Scalars['String'];
  arrangmentGroup?: Maybe<Scalars['String']>;
  assignedLoanAccountNums: Array<Scalars['String']>;
};

export type ValleyBankAssignmentDeviationGQLType = {
  __typename?: 'ValleyBankAssignmentDeviation';
  collateralAccountsNoLongerPledged: Array<ValleyBankCollateralToLoanAccountMappingGQLType>;
  collateralAccountsAssignedToNonExistentLoanAccountNum: Array<ValleyBankCollateralToLoanAccountMappingGQLType>;
  collateralAccounts: Array<ValleyBankAssignmentDetailGQLType>;
  reportingDate: Scalars['FullDateStr'];
};

export type ValleyBankAssignmentEventLogWithNameGQLType = {
  __typename?: 'ValleyBankAssignmentEventLogWithName';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  collateralAccountNumber: Scalars['String'];
  loanAccountNumber: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  action: ValleyBankAssignmentActionTypeGQLType;
  userId: Scalars['UUID'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
};

export type ValleyBankAssignmentQueueGQLType = {
  __typename?: 'ValleyBankAssignmentQueue';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  collateralAccountNumber: Scalars['String'];
  loanAccountNumber: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  action: ValleyBankAssignmentActionTypeGQLType;
  userId: Scalars['UUID'];
};

export type ValleyBankAssignmentQueueWithNameGQLType = {
  __typename?: 'ValleyBankAssignmentQueueWithName';
  id: Scalars['UUID'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  collateralAccountNumber: Scalars['String'];
  loanAccountNumber: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  action: ValleyBankAssignmentActionTypeGQLType;
  userId: Scalars['UUID'];
  userFirstName: Scalars['String'];
  userLastName: Scalars['String'];
};

export type ValleyBankCollateralToLoanAccountMappingGQLType = {
  __typename?: 'ValleyBankCollateralToLoanAccountMapping';
  loanAccountNum: Scalars['String'];
  collateralAccountNum: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  reportingDate: Scalars['FullDateStr'];
};

export type ValleyBankCustomerGQLType = {
  __typename?: 'ValleyBankCustomer';
  customer: Scalars['String'];
  errors: Scalars['String'];
};

export type ValleyBankCustomerConnectionGQLType = {
  __typename?: 'ValleyBankCustomerConnection';
  paginationInfo: PaginationInfoGQLType;
  customers: Scalars['String'];
  errors: Scalars['String'];
};

export type ValleyBankCustomerQueryParamsGQLType = {
  cifNum?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
};

export type ValleyBankDownloadsGQLType = {
  __typename?: 'ValleyBankDownloads';
  ingestionLogs?: Maybe<UrlAndFilenameGQLType>;
  securitiesExtendedResponseTape?: Maybe<UrlAndFilenameGQLType>;
  depositsExtendedResponseTape?: Maybe<UrlAndFilenameGQLType>;
  loanAccountDetails?: Maybe<UrlAndFilenameGQLType>;
  collateralAssignments?: Maybe<UrlAndFilenameGQLType>;
};

export type ValleyBankEntityEnumGQLType =
  | 'collateralAccount'
  | 'customer'
  | 'loanAccount'
  | 'arrangementGroup';

export type ValleyBankGeneratedLoanTapeDetailsGQLType = {
  __typename?: 'ValleyBankGeneratedLoanTapeDetails';
  loanTape: Scalars['String'];
  loanTapeMetadata: Scalars['String'];
};

export type ValleyBankLoanAccountGQLType = {
  __typename?: 'ValleyBankLoanAccount';
  loanAccount: Scalars['String'];
  errors: Scalars['String'];
};

export type ValleyBankLoanAccountConnectionGQLType = {
  __typename?: 'ValleyBankLoanAccountConnection';
  paginationInfo: PaginationInfoGQLType;
  loanAccounts: Scalars['String'];
  errors: Scalars['String'];
};

export type ValleyBankLoanAccountLatestPinnedCommentGQLType = {
  __typename?: 'ValleyBankLoanAccountLatestPinnedComment';
  loanAccountNum: Scalars['String'];
  pinnedComment: CommentGQLType;
};

export type ValleyBankLoanAccountLatestPinnedCommentV2GQLType = {
  __typename?: 'ValleyBankLoanAccountLatestPinnedCommentV2';
  loanAccountNum: Scalars['String'];
  pinnedComment: CommentV2GQLType;
};

export type ValleyBankLoanAccountOrderByParamGQLType = {
  columnName: Scalars['String'];
  desc: Scalars['Boolean'];
};

export type ValleyBankLoanAccountQueryParamsGQLType = {
  loanAccountNumber?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
};

export type ValleyBankLoanAccountThreadGQLType = BaseThreadV2GQLType & {
  __typename?: 'ValleyBankLoanAccountThread';
  threadId: Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
  pinned: Scalars['Boolean'];
  resolved: Scalars['Boolean'];
  comments: Array<CommentV2GQLType>;
  participatingOrganizations: Array<BaseOrganizationGQLType>;
  latestActionLog?: Maybe<ThreadLatestActionLogV2GQLType>;
  entityMetadata: ValleySblLoanAccountEntityMetaGQLType;
};

export type ValleyBankLoanAccountThreadCreateEventGQLType = EventLogBaseEventGQLType & {
  __typename?: 'ValleyBankLoanAccountThreadCreateEvent';
  eventId: Scalars['UUID'];
  eventLogType: EventLogTypeGQLType;
  eventMessage: Scalars['String'];
  actor: EventLogActorGQLType;
  createdAt: Scalars['JSDate'];
  updatedAt: Scalars['JSDate'];
  entityId: Scalars['String'];
  entityMetadata: ValleySblLoanAccountEntityMetaGQLType;
  current: ThreadCreatedEventSnapshotGQLType;
};

export type ValleyBankSubmitAssignmentInputGQLType = {
  loanAccountNum: Scalars['String'];
  collateralAccountNum: Scalars['String'];
  collateralAccountType: ValleyBankAccountCollateralTypeGQLType;
  action: ValleyBankAssignmentActionTypeGQLType;
};

export type ValleyIbsApiRecordGQLType = {
  __typename?: 'ValleyIbsApiRecord';
  id: Scalars['UUID'];
  action: IbsActionGQLType;
  status: IbsStatusGQLType;
  version: Scalars['Int'];
  externalDomainTable: Scalars['String'];
  externalDomainId: Scalars['String'];
  executorUserId?: Maybe<Scalars['UUID']>;
  executedAt?: Maybe<Scalars['JSDate']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValleySblLoanAccountEntityMetaGQLType = {
  __typename?: 'ValleySBLLoanAccountEntityMeta';
  id: Scalars['String'];
};

export type VallyBankPledgedIndicatorEnumGQLType =
  | 'Y'
  | 'N';

export type ValuationFieldsGQLType = {
  __typename?: 'ValuationFields';
  valuation: Scalars['Float'];
  valuationRate: Scalars['Float'];
};

export type VerificationActionKeyGQLType =
  | 'verificationReportApproved'
  | 'verificationReportRejected';

export type VerificationBorrowerLoanProductCalculationGQLType = {
  __typename?: 'VerificationBorrowerLoanProductCalculation';
  borrowingBaseReportId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  totalReceivableExposure?: Maybe<Scalars['Float']>;
  totalEligibilityKickout?: Maybe<Scalars['Float']>;
  totalEligibleExposure?: Maybe<Scalars['Float']>;
  totalConcentrationKickout?: Maybe<Scalars['Float']>;
  totalEligibleExposureLessConcentrationKickouts?: Maybe<Scalars['Float']>;
  weightedAverageReceivableAdvanceRate?: Maybe<Scalars['Float']>;
  totalReceivableBorrowingBaseAmount?: Maybe<Scalars['Float']>;
  effectiveReceivableAdvanceRate?: Maybe<Scalars['Float']>;
  effectiveReceivableValuationRate?: Maybe<Scalars['Float']>;
};

export type VerificationBorrowerParsedBorrowingBaseReportGQLType = {
  __typename?: 'VerificationBorrowerParsedBorrowingBaseReport';
  commitmentAmount?: Maybe<Scalars['Float']>;
  currentPrincipalBalance?: Maybe<Scalars['Float']>;
  totalReceivableExposure?: Maybe<Scalars['Float']>;
  totalEligibilityKickout?: Maybe<Scalars['Float']>;
  totalEligibleExposure?: Maybe<Scalars['Float']>;
  totalConcentrationKickout?: Maybe<Scalars['Float']>;
  borrowingBaseAmountAssets?: Maybe<Scalars['Float']>;
  weightedAverageReceivableAdvanceRate?: Maybe<Scalars['Float']>;
  maxReceivableAdvanceAmount?: Maybe<Scalars['Float']>;
  effectiveReceivableAdvanceRate?: Maybe<Scalars['Float']>;
  totalPreAdvanceCashContribution?: Maybe<Scalars['Float']>;
  effectiveCashAdvanceRate?: Maybe<Scalars['Float']>;
  totalCashBorrowingBaseAmount?: Maybe<Scalars['Float']>;
  totalBorrowingBaseAmount?: Maybe<Scalars['Float']>;
  totalAssets?: Maybe<Scalars['Float']>;
  effectiveAdvanceRate?: Maybe<Scalars['Float']>;
  borrowingBaseReserveAmount?: Maybe<Scalars['Float']>;
  totalCollectionsAccountCash?: Maybe<Scalars['Float']>;
  maximumAvailableAmount?: Maybe<Scalars['Float']>;
  borrowingBaseAvailability?: Maybe<Scalars['Float']>;
  borrowingBaseAvailabilityRate?: Maybe<Scalars['Float']>;
  eligibilityCriteriaCalculations?: Maybe<Array<EligibilityCriteriaCalculationGQLType>>;
  concentrationLimitCalculations?: Maybe<Array<ConcentrationLimitCalculationGQLType>>;
  loanProductCalculations?: Maybe<Array<VerificationBorrowerLoanProductCalculationGQLType>>;
  bankAccountCashBalances?: Maybe<Array<BankAccountCashBalanceGQLType>>;
};

export type VerificationConcentrationWaiverImpactAggregateGQLType = {
  __typename?: 'VerificationConcentrationWaiverImpactAggregate';
  concentrationPropertyKey: Scalars['String'];
  concentrationAmountWaived: Scalars['Float'];
  concentrationAmountNotWaived?: Maybe<Scalars['Float']>;
  concentrationPreWaivers?: Maybe<Scalars['Float']>;
  concentrationPostWaivers: Scalars['Float'];
  totalEligibleExposure: Scalars['Float'];
};

export type VerificationEligibilityReceivableGQLType = {
  __typename?: 'VerificationEligibilityReceivable';
  id: Scalars['UUID'];
  fundingVerificationReportId: Scalars['UUID'];
  externalReceivableId: Scalars['String'];
  finleyReceivableId: Scalars['UUID'];
  eligibilityCriteriaKey: Scalars['String'];
  exposure: Scalars['Float'];
  borrowerEligible: Scalars['Boolean'];
  finleyEligibilityStatus: EligibilityStatusGQLType;
  loanProductId: Scalars['UUID'];
  borrowerFormula?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  waived: Scalars['Boolean'];
  eligibleExposure: Scalars['Float'];
  baseFields: Scalars['Object'];
};

export type VerificationPayloadGQLType = {
  __typename?: 'VerificationPayload';
  creditFacilityId: Scalars['UUID'];
  verificationReportId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
};

export type VerificationPipelineStatusGQLType =
  | 'notStarted'
  | 'inProgress'
  | 'error'
  | 'awaitingApproval'
  | 'superseded'
  | 'complete'
  | 'remediationRequested';

export type VerificationReportAdjudicationActionGQLType =
  | 'approve'
  | 'reject'
  | 'requestRemediation';

export type VerificationWaiverImpactTotalsGQLType = {
  __typename?: 'VerificationWaiverImpactTotals';
  totalEligibilityWaived: Scalars['Float'];
  totalConcentrationWaived: Array<VerificationConcentrationWaiverImpactAggregateGQLType>;
};


export type WebhookSubscriptionGQLType = {
  __typename?: 'WebhookSubscription';
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  eventTypes: Array<Scalars['String']>;
  endpoint: Scalars['String'];
  svixApplicationId: Scalars['String'];
  isValid: Scalars['Boolean'];
  svixDashboardUrl: Scalars['String'];
  created_at: Scalars['JSDate'];
  updated_at: Scalars['JSDate'];
};

export type WorkflowActionGraphNodeGQLType = {
  __typename?: 'WorkflowActionGraphNode';
  id: Scalars['UUID'];
  actionFunctionName: Scalars['String'];
  actionParams: Array<WorkflowActionGraphNodeParamsGQLType>;
};

export type WorkflowActionGraphNodeInputGQLType = {
  id: Scalars['UUID'];
  actionFunctionName: Scalars['String'];
  actionParams: Array<WorkflowActionGraphNodeParamsInputGQLType>;
};

export type WorkflowActionGraphNodeParamsGQLType = {
  __typename?: 'WorkflowActionGraphNodeParams';
  variableName: Scalars['String'];
  variableBinding: WorkflowActionGraphNodeVariableBindingGQLType;
};

export type WorkflowActionGraphNodeParamsInputGQLType = {
  variableName: Scalars['String'];
  variableBinding: WorkflowActionGraphNodeVariableBindingInputGQLType;
};

export type WorkflowActionGraphNodeVariableBindingGQLType = {
  __typename?: 'WorkflowActionGraphNodeVariableBinding';
  stringVariableBinding?: Maybe<Scalars['String']>;
  numberVariableBinding?: Maybe<Scalars['Int']>;
  stringArrayVariableBinding?: Maybe<Array<Scalars['String']>>;
};

export type WorkflowActionGraphNodeVariableBindingInputGQLType = {
  stringVariableBinding?: Maybe<Scalars['String']>;
  numberVariableBinding?: Maybe<Scalars['Int']>;
  stringArrayVariableBinding?: Maybe<Array<Scalars['String']>>;
};

export type WorkflowActionGraphNodeWithStateGQLType = {
  __typename?: 'WorkflowActionGraphNodeWithState';
  node: WorkflowActionGraphNodeGQLType;
  state: WorkflowGraphNodeStateGQLType;
};

export type WorkflowActionStaticParamTemplateTypeGQLType = StringStaticParamTemplateGQLType | NumberStaticParamTemplateGQLType | StringArrayStaticParamTemplateGQLType;

export type WorkflowActionTypeTemplateGQLType = {
  __typename?: 'WorkflowActionTypeTemplate';
  functionName: Scalars['String'];
  params: Array<WorkflowActionStaticParamTemplateTypeGQLType>;
};

export type WorkflowConditionalElseConfigGQLType = {
  __typename?: 'WorkflowConditionalElseConfig';
  id: Scalars['UUID'];
};

export type WorkflowConditionalElseConfigInputGQLType = {
  id: Scalars['UUID'];
};

export type WorkflowConditionalElseConfigWithStateGQLType = {
  __typename?: 'WorkflowConditionalElseConfigWithState';
  id: Scalars['UUID'];
  state: WorkflowGraphNodeStateGQLType;
};

export type WorkflowConditionalGraphNodeGQLType = {
  __typename?: 'WorkflowConditionalGraphNode';
  if: WorkflowConditionalGraphNodeConfigGQLType;
  elif: Array<WorkflowConditionalGraphNodeConfigGQLType>;
  else: WorkflowConditionalElseConfigGQLType;
};

export type WorkflowConditionalGraphNodeConfigGQLType = {
  __typename?: 'WorkflowConditionalGraphNodeConfig';
  id: Scalars['UUID'];
  comparator: WorkflowSimpleComparatorGQLType;
  runtimeVariableName: Scalars['String'];
  rightOperandStringArray?: Maybe<Array<Scalars['String']>>;
  rightOperandNumber?: Maybe<Scalars['Int']>;
};

export type WorkflowConditionalGraphNodeConfigInputGQLType = {
  id: Scalars['UUID'];
  comparator: WorkflowSimpleComparatorGQLType;
  runtimeVariableName: Scalars['String'];
  rightOperandStringArray?: Maybe<Array<Scalars['String']>>;
  rightOperandNumber?: Maybe<Scalars['Int']>;
};

export type WorkflowConditionalGraphNodeConfigWithStateGQLType = {
  __typename?: 'WorkflowConditionalGraphNodeConfigWithState';
  id: Scalars['UUID'];
  comparator: WorkflowSimpleComparatorGQLType;
  runtimeVariableName: Scalars['String'];
  rightOperandStringArray?: Maybe<Array<Scalars['String']>>;
  rightOperandNumber?: Maybe<Scalars['Int']>;
  state: WorkflowGraphNodeStateGQLType;
};

export type WorkflowConditionalGraphNodeInputGQLType = {
  if: WorkflowConditionalGraphNodeConfigInputGQLType;
  elif: Array<WorkflowConditionalGraphNodeConfigInputGQLType>;
  else: WorkflowConditionalElseConfigInputGQLType;
};

export type WorkflowConditionalGraphNodeWithStateGQLType = {
  __typename?: 'WorkflowConditionalGraphNodeWithState';
  if: WorkflowConditionalGraphNodeConfigWithStateGQLType;
  elif: Array<WorkflowConditionalGraphNodeConfigWithStateGQLType>;
  else: WorkflowConditionalElseConfigWithStateGQLType;
};

export type WorkflowGraphEdgesGQLType = {
  __typename?: 'WorkflowGraphEdges';
  from: Scalars['UUID'];
  to: Scalars['UUID'];
};

export type WorkflowGraphEdgesInputGQLType = {
  from: Scalars['UUID'];
  to: Scalars['UUID'];
};

export type WorkflowGraphNodeStateGQLType = {
  __typename?: 'WorkflowGraphNodeState';
  visitedTimestamp?: Maybe<Scalars['JSDate']>;
};

export type WorkflowGraphObjectGQLType = {
  __typename?: 'WorkflowGraphObject';
  userApprovalNodes: Array<WorkflowUserApprovalGraphNodeGQLType>;
  actionNodes: Array<WorkflowActionGraphNodeGQLType>;
  conditionalNodes: Array<WorkflowConditionalGraphNodeGQLType>;
  edges: Array<WorkflowGraphEdgesGQLType>;
};

export type WorkflowGraphObjectInputGQLType = {
  userApprovalNodes: Array<WorkflowUserApprovalGraphNodeInputGQLType>;
  actionNodes: Array<WorkflowActionGraphNodeInputGQLType>;
  conditionalNodes: Array<WorkflowConditionalGraphNodeInputGQLType>;
  edges: Array<WorkflowGraphEdgesInputGQLType>;
};

export type WorkflowGraphObjectWithStateGQLType = {
  __typename?: 'WorkflowGraphObjectWithState';
  userApprovalNodes: Array<WorkflowUserApprovalGraphNodeWithStateGQLType>;
  actionNodes: Array<WorkflowActionGraphNodeWithStateGQLType>;
  conditionalNodes: Array<WorkflowConditionalGraphNodeWithStateGQLType>;
  edges: Array<WorkflowGraphEdgesGQLType>;
};

export type WorkflowNestedComparatorGQLType =
  | 'AND'
  | 'OR'
  | 'NOT';

export type WorkflowRuntimeVariableTemplateGQLType = StringRuntimeVariableTemplateGQLType | StringArrayRuntimeVariableTemplateGQLType | NumberRuntimeVariableTemplateGQLType;

export type WorkflowSimpleComparatorGQLType =
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL'
  | 'CONTAINS_ALL_OF'
  | 'CONTAINS_ANY_OF'
  | 'IS_IN'
  | 'IS_NOT_IN';

export type WorkflowStringArrayComparatorGQLType =
  | 'CONTAINS_ANY_OF'
  | 'CONTAINS_ALL_OF';

export type WorkflowTemplateGQLType = {
  __typename?: 'WorkflowTemplate';
  id: Scalars['UUID'];
  workflowId: Scalars['UUID'];
  version: Scalars['Int'];
  workflowType: WorkflowTypeGQLType;
  workflow: WorkflowGraphObjectGQLType;
  name: Scalars['String'];
  organizationId: Scalars['UUID'];
  authorUserId: Scalars['UUID'];
};

export type WorkflowTemplateConstructorGQLType = {
  __typename?: 'WorkflowTemplateConstructor';
  title: Scalars['String'];
  finalAction?: Maybe<WorkflowTemplateFinalActionGQLType>;
  optionsExposedToUsers: WorkflowTemplateOptionsExposedToUsersGQLType;
};

export type WorkflowTemplateDomainSpecificRuntimeVariableGQLType = {
  __typename?: 'WorkflowTemplateDomainSpecificRuntimeVariable';
  usersApprovalRuntimeVariable: StringArrayRuntimeVariableTemplateGQLType;
};

export type WorkflowTemplateFinalActionGQLType = {
  __typename?: 'WorkflowTemplateFinalAction';
  title: Scalars['String'];
  functionName: Scalars['String'];
};

export type WorkflowTemplateOptionsExposedToUsersGQLType = {
  __typename?: 'WorkflowTemplateOptionsExposedToUsers';
  runtimeVariables: Array<WorkflowRuntimeVariableTemplateGQLType>;
  domainSpecificRuntimeVariable?: Maybe<WorkflowTemplateDomainSpecificRuntimeVariableGQLType>;
  actions: Array<WorkflowActionTypeTemplateGQLType>;
};

export type WorkflowTypeGQLType =
  | 'deliverables_container_receipts'
  | 'funding_requests';

export type WorkflowUserApprovalGraphNodeGQLType = {
  __typename?: 'WorkflowUserApprovalGraphNode';
  id: Scalars['UUID'];
  comparator: WorkflowStringArrayComparatorGQLType;
  userIds: Array<Scalars['UUID']>;
};

export type WorkflowUserApprovalGraphNodeInputGQLType = {
  id: Scalars['UUID'];
  comparator: WorkflowStringArrayComparatorGQLType;
  userIds: Array<Scalars['UUID']>;
};

export type WorkflowUserApprovalGraphNodeWithStateGQLType = {
  __typename?: 'WorkflowUserApprovalGraphNodeWithState';
  node: WorkflowUserApprovalGraphNodeGQLType;
  state: WorkflowGraphNodeStateGQLType;
};

export type WorkleaseModeGQLType =
  | 'QA'
  | 'Live';

export type XlsxTapeFieldGroupGQLType = {
  __typename?: 'XlsxTapeFieldGroup';
  dataTapeSlug: Scalars['String'];
  sheetName: Scalars['String'];
  headerRange?: Maybe<Scalars['String']>;
  columns: Array<ColumnInfoGQLType>;
};

export type XlsxValueFieldGroupGQLType = {
  __typename?: 'XlsxValueFieldGroup';
  dataTapeSlug: Scalars['String'];
  columns: Array<ColumnInfoGQLType>;
};

export type AdHocKeyTypeGQLType =
  | 'netIncome';

export type CapitalProviderEntitiesGQLType = {
  __typename?: 'capitalProviderEntities';
  id: Scalars['UUID'];
  slug: Scalars['String'];
  name: Scalars['String'];
};

export type FundingRequestWithComponentsAndBankAccountsFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & Pick<FundingRequestWithFullDetailsGQLType, 'id' | 'status'>
  & { bankAccounts: Array<(
    { __typename?: 'BankAccountWithInstitutionAndDesignation' }
    & BankAccountWithInstitutionAndDesignationFragmentGQLType
  )>, fundingRequestComponents: Array<(
    { __typename?: 'FundingRequestComponent' }
    & FundingRequestComponentFieldsFragmentGQLType
  )> }
);

export type CancelFundingRequestMutationVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type CancelFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { cancelFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type CreateFundingRequestMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type CreateFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type CreateServicerReportPreviewMutationVariablesGQLType = Exact<{
  fundingRequestChangeset: UpdateFundingRequestChangesetGQLType;
}>;


export type CreateServicerReportPreviewMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createServicerReportPreview: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateAssetVerificationDocumentMutationVariablesGQLType = Exact<{
  receivableDocumentationRawId: Scalars['UUID'];
  assetVerificationDocument: Scalars['String'];
  note: Scalars['String'];
}>;


export type CreateAssetVerificationDocumentMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createAssetVerificationDocument: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type SubmitFundingRequestMutationVariablesGQLType = Exact<{
  fundingRequestChangeset: UpdateFundingRequestChangesetGQLType;
}>;


export type SubmitFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { submitFundingRequest: (
    { __typename?: 'FundingRequestWithFullDetails' }
    & FundingRequestWithFullDetailsFragmentGQLType
  ) }
);

export type GetCreditFacilitySummariesQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetCreditFacilitySummariesQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilitySummaries: Array<(
    { __typename?: 'CreditFacilitySummary' }
    & Pick<CreditFacilitySummaryGQLType, 'id' | 'isActive'>
    & { currentFundingRequest?: Maybe<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & FundingRequestWithComponentsAndBankAccountsFragmentGQLType
    )> }
  )> }
);

export type GetCreditFacilitySummariesNewQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetCreditFacilitySummariesNewQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilitySummariesNew: Array<(
    { __typename?: 'CreditFacilitySummary' }
    & Pick<CreditFacilitySummaryGQLType, 'id' | 'isActive'>
    & { currentFundingRequest?: Maybe<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & FundingRequestWithComponentsAndBankAccountsFragmentGQLType
    )> }
  )> }
);

export type ApproveFundingRequestMutationVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type ApproveFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { approveFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type RejectFundingRequestMutationVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type RejectFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { rejectFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType = Exact<{
  action: UserApprovalActionGQLType;
  userId: Scalars['UUID'];
  fundingRequestId: Scalars['UUID'];
  workflowInstanceId: Scalars['UUID'];
}>;


export type UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType = (
  { __typename?: 'Mutation' }
  & { userApprovalActionForFundingRequestWorkflowInstance: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
}>;


export type GetWorkflowInstanceIdForFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getWorkflowInstanceIdForFundingRequest'>
);

export type UserApprovalGroupsForFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type UserApprovalGroupsForFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { userApprovalGroupsForFundingRequest: Array<(
    { __typename?: 'UserApprovalGroup' }
    & Pick<UserApprovalGroupGQLType, 'id' | 'comparator'>
    & { requestedApprovals: Array<(
      { __typename?: 'RequestedUserApprovalForDomain' }
      & { user: (
        { __typename?: 'UserObject' }
        & Pick<UserObjectGQLType, 'id' | 'email' | 'firstName' | 'lastName' | 'userType' | 'roleType'>
      ), state?: Maybe<(
        { __typename?: 'UserApprovalState' }
        & Pick<UserApprovalStateGQLType, 'status' | 'statusAt'>
      )> }
    )>, groupState?: Maybe<(
      { __typename?: 'UserApprovalState' }
      & Pick<UserApprovalStateGQLType, 'status' | 'statusAt'>
    )> }
  )> }
);

export type GetUserWithCreditFacilitiesCountQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetUserWithCreditFacilitiesCountQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<UserGQLType, 'id' | 'email' | 'userType' | 'isActive' | 'organizationId' | 'roleType' | 'firstName' | 'lastName'>
    & { organization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
    ) }
  )> }
);

export type GetLoanTapeSanitizeConfigsQueryQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetLoanTapeSanitizeConfigsQueryQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'borrowerId'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'slug'>
    )> }
  ), getLoanTapeSanitizeConfigs: Array<(
    { __typename?: 'LoanTapeSanitizeConfig' }
    & Pick<LoanTapeSanitizeConfigGQLType, 'loanProductSlug' | 'sanitizeArtifactSlug' | 'rawExternalReceivableIdField' | 'baseFields'>
  )> }
);

export type SetLoanTapeSanitizeConfigsMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  configs: Array<LoanTapeSanitizeConfigInputGQLType> | LoanTapeSanitizeConfigInputGQLType;
}>;


export type SetLoanTapeSanitizeConfigsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { setLoanTapeSanitizeConfigs: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CommitCreditAgreementWipToSandboxMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type CommitCreditAgreementWipToSandboxMutationGQLType = (
  { __typename?: 'Mutation' }
  & { commitCreditAgreementWipToSandbox: (
    { __typename?: 'CommitWipToSandboxResponse' }
    & Pick<CommitWipToSandboxResponseGQLType, 'errors'>
  ) }
);

export type GetCreditFacilitiesByOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCreditFacilitiesByOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id'>
    & { creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'borrowerId' | 'name' | 'isActive' | 'slug' | 'type' | 'implementationId'>
    )> }
  ) }
);

export type GetUserQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetUserQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<UserGQLType, 'id' | 'email' | 'userType' | 'isActive' | 'organizationId' | 'roleType' | 'firstName' | 'lastName'>
    & { organization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
      & { orgPreferences?: Maybe<(
        { __typename?: 'OrgPreferences' }
        & Pick<OrgPreferencesGQLType, 'cashBalancePreference'>
      )> }
    ) }
  )> }
);

export type CreateCdqMutationVariablesGQLType = Exact<{
  name: Scalars['String'];
  organizationId: Scalars['UUID'];
  decodedQuery: Scalars['String'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
}>;


export type CreateCdqMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createCDQ: (
    { __typename?: 'CreateCDQResponse' }
    & Pick<CreateCdqResponseGQLType, 'id' | 'errors'>
  ) }
);

export type GetActiveCdqConfigsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
}>;


export type GetActiveCdqConfigsQueryGQLType = (
  { __typename?: 'Query' }
  & { getActiveCdqConfigs?: Maybe<Array<(
    { __typename?: 'ConfiguredCDQ' }
    & Pick<ConfiguredCdqGQLType, 'id' | 'name' | 'decodedQuery'>
  )>> }
);

export type DeactivateCdqConfigMutationVariablesGQLType = Exact<{
  id: Scalars['UUID'];
}>;


export type DeactivateCdqConfigMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deactivateCdqConfig: (
    { __typename?: 'DeactivateCdqConfigResponse' }
    & Pick<DeactivateCdqConfigResponseGQLType, 'id' | 'errors'>
  ) }
);

export type FetchAcknowledgedCdqResultsQueryVariablesGQLType = Exact<{
  cdqId: Scalars['UUID'];
}>;


export type FetchAcknowledgedCdqResultsQueryGQLType = (
  { __typename?: 'Query' }
  & { acknowledgedCdqResults: (
    { __typename?: 'PaginatedResultsWithCounts' }
    & Pick<PaginatedResultsWithCountsGQLType, 'NextToken' | 'QueryExecutionId' | 'totalUnAcknowledgedIssueCount' | 'totalAcknowledgedIssueCount'>
    & { Items: Array<(
      { __typename?: 'CDQResultItem' }
      & Pick<CdqResultItemGQLType, 'finleyReceivableId' | 'currentReportingDate' | 'previousReportingDate' | 'otherFields'>
      & { acknowledgementData?: Maybe<(
        { __typename?: 'AcknowledgementData' }
        & Pick<AcknowledgementDataGQLType, 'acknowledgementId' | 'acknowledgedOn' | 'acknowledgedBy' | 'acknowledgedFor'>
      )> }
    )> }
  ) }
);

export type FetchCdqResultsQueryVariablesGQLType = Exact<{
  cdqId: Scalars['UUID'];
}>;


export type FetchCdqResultsQueryGQLType = (
  { __typename?: 'Query' }
  & { unacknowledged: (
    { __typename?: 'PaginatedResultsWithCounts' }
    & Pick<PaginatedResultsWithCountsGQLType, 'NextToken' | 'QueryExecutionId' | 'totalUnAcknowledgedIssueCount' | 'totalAcknowledgedIssueCount'>
    & { Items: Array<(
      { __typename?: 'CDQResultItem' }
      & Pick<CdqResultItemGQLType, 'finleyReceivableId' | 'currentReportingDate' | 'previousReportingDate' | 'otherFields'>
      & { acknowledgementData?: Maybe<(
        { __typename?: 'AcknowledgementData' }
        & Pick<AcknowledgementDataGQLType, 'acknowledgementId' | 'acknowledgedOn' | 'acknowledgedBy' | 'acknowledgedFor'>
      )> }
    )> }
  ), acknowledged: (
    { __typename?: 'PaginatedResultsWithCounts' }
    & Pick<PaginatedResultsWithCountsGQLType, 'NextToken' | 'QueryExecutionId' | 'totalUnAcknowledgedIssueCount' | 'totalAcknowledgedIssueCount'>
    & { Items: Array<(
      { __typename?: 'CDQResultItem' }
      & Pick<CdqResultItemGQLType, 'finleyReceivableId' | 'currentReportingDate' | 'previousReportingDate' | 'otherFields'>
      & { acknowledgementData?: Maybe<(
        { __typename?: 'AcknowledgementData' }
        & Pick<AcknowledgementDataGQLType, 'acknowledgementId' | 'acknowledgedOn' | 'acknowledgedBy' | 'acknowledgedFor'>
      )> }
    )> }
  ) }
);

export type FetchUnacknowledgedCdqResultsQueryVariablesGQLType = Exact<{
  cdqId: Scalars['UUID'];
}>;


export type FetchUnacknowledgedCdqResultsQueryGQLType = (
  { __typename?: 'Query' }
  & { unacknowledgedCdqResults: (
    { __typename?: 'PaginatedResultsWithCounts' }
    & Pick<PaginatedResultsWithCountsGQLType, 'NextToken' | 'QueryExecutionId' | 'totalUnAcknowledgedIssueCount' | 'totalAcknowledgedIssueCount'>
    & { Items: Array<(
      { __typename?: 'CDQResultItem' }
      & Pick<CdqResultItemGQLType, 'finleyReceivableId' | 'currentReportingDate' | 'previousReportingDate' | 'otherFields'>
    )> }
  ) }
);

export type AcknowledgeForAllDatesMutationVariablesGQLType = Exact<{
  cdqId: Scalars['UUID'];
  receivableIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type AcknowledgeForAllDatesMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'acknowledgeForAllDates'>
);

export type AcknowledgeForSpecificDatesMutationVariablesGQLType = Exact<{
  cdqId: Scalars['UUID'];
  acknowledgements: Array<SpecificDateAcknowledgementGQLType> | SpecificDateAcknowledgementGQLType;
}>;


export type AcknowledgeForSpecificDatesMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'acknowledgeForSpecificDates'>
);

export type UnAcknowledgeMutationVariablesGQLType = Exact<{
  cdqId: Scalars['UUID'];
  receivableIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type UnAcknowledgeMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'unAcknowledge'>
);

export type GetBalanceSheetExposureDataQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetBalanceSheetExposureDataQueryGQLType = (
  { __typename?: 'Query' }
  & { balanceSheetImpactCalculations: (
    { __typename?: 'BalanceSheetImpactCalculationsData' }
    & Pick<BalanceSheetImpactCalculationsDataGQLType, 'totalBalanceSheetExposure'>
    & { loanProductCalculations: Array<(
      { __typename?: 'LoanProductCalculation' }
      & Pick<LoanProductCalculationGQLType, 'loanProductId' | 'loanProductName' | 'balanceSheetExposure'>
      & { eligibleExposureForCreditFacilities: Array<(
        { __typename?: 'EligibleExposureForCreditFacility' }
        & Pick<EligibleExposureForCreditFacilityGQLType, 'eligibleExposure'>
        & { creditFacility: (
          { __typename?: 'CreditFacility' }
          & Pick<CreditFacilityGQLType, 'id' | 'name'>
        ) }
      )> }
    )> }
  ) }
);

export type GetFacilitiesTableDataQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide: Array<Scalars['String']> | Scalars['String'];
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  startDateStr?: Maybe<Scalars['FullDateStr']>;
  endDateStr?: Maybe<Scalars['FullDateStr']>;
  getAttributeValuesParams: GetAttributeValuesByParamsInputGQLType;
}>;


export type GetFacilitiesTableDataQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & { currentCreditAgreementArtifacts: Array<(
      { __typename?: 'CreditAgreementArtifact' }
      & Pick<CreditAgreementArtifactGQLType, 'id' | 'creditAgreement'>
    )> }
  ), fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & Pick<FundingRequestWithFullDetailsGQLType, 'id' | 'creditFacilityId' | 'created_at'>
    )> }
  ), expensesFeesLedgerForAllCountersigners: Array<(
    { __typename?: 'LedgerBalance' }
    & Pick<LedgerBalanceGQLType, 'creditFacilityId' | 'ledgerBalance'>
  )>, outstandingLedgerForAllCountersigners: Array<(
    { __typename?: 'LedgerBalance' }
    & Pick<LedgerBalanceGQLType, 'creditFacilityId' | 'ledgerBalance'>
  )>, outstandingLedgerForCapitalProvider: Array<(
    { __typename?: 'LedgerBalance' }
    & Pick<LedgerBalanceGQLType, 'creditFacilityId' | 'ledgerBalance'>
  )>, getSuccessPortfolioCovenantsByCreditFacilityIds: Array<(
    { __typename?: 'SuccessPortfolioCovenant' }
    & SuccessPortfolioCovenantFragmentGQLType
  )>, getSuccessFinancialCovenantsByCreditFacilityIds: Array<(
    { __typename?: 'SuccessFinancialCovenant' }
    & SuccessFinancialCovenantFragmentGQLType
  )>, latestBorrowingBaseReports: Array<Maybe<(
    { __typename?: 'BorrowingBaseReport' }
    & Pick<BorrowingBaseReportGQLType, 'creditFacilityId' | 'maxReceivableAdvanceAmount' | 'commitmentAmount' | 'totalCollectionsAccountCash' | 'totalCashBorrowingBaseAmount' | 'totalFacilityUtilization' | 'currentPrincipalBalance' | 'borrowingBaseReserveAmount'>
  )>>, getAttributeValuesByParams: Array<(
    { __typename?: 'StringAttributeValue' }
    & AttributeValueFragment_StringAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'FloatAttributeValue' }
    & AttributeValueFragment_FloatAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'IntegerAttributeValue' }
    & AttributeValueFragment_IntegerAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'BooleanAttributeValue' }
    & AttributeValueFragment_BooleanAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'PercentageRateAttributeValue' }
    & AttributeValueFragment_PercentageRateAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'FullDateStrAttributeValue' }
    & AttributeValueFragment_FullDateStrAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'StringArrayAttributeValue' }
    & AttributeValueFragment_StringArrayAttributeValue_FragmentGQLType
  )> }
);

export type GetFacilitiesTableLimitedDataQueryVariablesGQLType = Exact<{
  capitalProviderOrganizationId: Scalars['UUID'];
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
}>;


export type GetFacilitiesTableLimitedDataQueryGQLType = (
  { __typename?: 'Query' }
  & { slsCreditAgreementsPropertiesForCapitalProvider: Array<(
    { __typename?: 'SlsCreditAgreementProperties' }
    & Pick<SlsCreditAgreementPropertiesGQLType, 'creditFacilityId' | 'externalFacilityId' | 'maturityDate' | 'closingDate' | 'revolvingPeriodEndDate' | 'globalCommitmentAmount' | 'capitalProviderCommitmentAmount' | 'interestRatesDisplay' | 'unusedFeesDisplay' | 'upfrontFeesDisplay'>
  )>, fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & Pick<FundingRequestWithFullDetailsGQLType, 'id' | 'creditFacilityId' | 'created_at'>
    )> }
  ), expensesFeesLedgerForAllCountersigners: Array<(
    { __typename?: 'LedgerBalance' }
    & Pick<LedgerBalanceGQLType, 'creditFacilityId' | 'ledgerBalance'>
  )>, outstandingLedgerForAllCountersigners: Array<(
    { __typename?: 'LedgerBalance' }
    & Pick<LedgerBalanceGQLType, 'creditFacilityId' | 'ledgerBalance'>
  )>, outstandingLedgerForCapitalProvider: Array<(
    { __typename?: 'LedgerBalance' }
    & Pick<LedgerBalanceGQLType, 'creditFacilityId' | 'ledgerBalance'>
  )> }
);

export type CreateDeliverableContainerReceiptActionMutationVariablesGQLType = Exact<{
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  receiptId: Scalars['UUID'];
  action: ReceiptActionTypePostCreationGQLType;
  commentId?: Maybe<Scalars['UUID']>;
}>;


export type CreateDeliverableContainerReceiptActionMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'deliverableContainerReceiptAction'>
);

export type CompleteFinalOutputDeliverableArtifactInstanceMutationVariablesGQLType = Exact<{
  artifactInstanceId: Scalars['UUID'];
}>;


export type CompleteFinalOutputDeliverableArtifactInstanceMutationGQLType = (
  { __typename?: 'Mutation' }
  & { completeFinalOutputDeliverableArtifactInstance: (
    { __typename?: 'CompleteFinalOutputDeliverableArtifactInstanceResult' }
    & Pick<CompleteFinalOutputDeliverableArtifactInstanceResultGQLType, 'errors'>
    & { instance: (
      { __typename?: 'DeliverableArtifactInstance' }
      & Pick<DeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'version' | 'active' | 'status'>
    ) }
  ) }
);

export type CreateDeliverableArtifactInstanceMutationVariablesGQLType = Exact<{
  deliverableArtifactId: Scalars['UUID'];
  active?: Maybe<Scalars['Boolean']>;
  status: ArtifactInstanceStatusGQLType;
  rawDatabase?: Maybe<DeliverableDatabaseGQLType>;
  rawNamespace?: Maybe<DeliverableRawNamespaceGQLType>;
  rawIdentifier?: Maybe<Scalars['String']>;
  completedDatabase?: Maybe<DeliverableDatabaseGQLType>;
  completedNamespace?: Maybe<DeliverableExternalNamespaceGQLType>;
  completedIdentifier?: Maybe<Scalars['String']>;
}>;


export type CreateDeliverableArtifactInstanceMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createDeliverableArtifactInstance: (
    { __typename?: 'DeliverableArtifactInstance' }
    & Pick<DeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'version' | 'active' | 'status'>
  ) }
);

export type CreateDeliverableContainerReceiptMutationVariablesGQLType = Exact<{
  containerId: Scalars['UUID'];
  receipt: ReceiptColumnInputGQLType;
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
}>;


export type CreateDeliverableContainerReceiptMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'deliverableContainerReceipt'>
);

export type GenerateReceiptForDeliverableContainerMutationVariablesGQLType = Exact<{
  containerId: Scalars['UUID'];
  fixedInputDependencies: Array<Scalars['UUID']> | Scalars['UUID'];
  userId: Scalars['UUID'];
}>;


export type GenerateReceiptForDeliverableContainerMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'generateReceiptForDeliverableContainer'>
);

export type NotifyNewCommentForDeliverableContainerMutationVariablesGQLType = Exact<{
  commentId: Scalars['UUID'];
  containerId: Scalars['UUID'];
  receiptId?: Maybe<Scalars['UUID']>;
}>;


export type NotifyNewCommentForDeliverableContainerMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'notifyNewCommentForDeliverableContainer'>
);

export type RefreshDeliverableMutationVariablesGQLType = Exact<{
  deliverableContainerId: Scalars['UUID'];
}>;


export type RefreshDeliverableMutationGQLType = (
  { __typename?: 'Mutation' }
  & { refreshDeliverable: (
    { __typename?: 'RefreshDeliverableResponse' }
    & Pick<RefreshDeliverableResponseGQLType, 'status'>
  ) }
);

export type SubmitMonthlyStatementDeliverableMutationVariablesGQLType = Exact<{
  deliverableArtifactId: Scalars['UUID'];
  deliverableArtifactInstanceId?: Maybe<Scalars['UUID']>;
  creditFacilityId: Scalars['UUID'];
  reportingPeriodStartDate: Scalars['FullDateStr'];
  reportingPeriodEndDate: Scalars['FullDateStr'];
  asOfTimestamp: Scalars['JSDate'];
}>;


export type SubmitMonthlyStatementDeliverableMutationGQLType = (
  { __typename?: 'Mutation' }
  & { submitMonthlyStatementDeliverable: (
    { __typename?: 'DeliverableArtifactInstance' }
    & Pick<DeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'version' | 'active' | 'status'>
  ) }
);

export type UpdateFailedDeliverableArtifactInstanceMutationVariablesGQLType = Exact<{
  instanceId: Scalars['UUID'];
}>;


export type UpdateFailedDeliverableArtifactInstanceMutationGQLType = (
  { __typename?: 'Mutation' }
  & { failedDeliverableArtifactInstance: (
    { __typename?: 'DeliverableArtifactInstance' }
    & Pick<DeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'version' | 'active' | 'status'>
  ) }
);

export type GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryVariablesGQLType = Exact<{
  receiptId: Scalars['UUID'];
}>;


export type GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryGQLType = (
  { __typename?: 'Query' }
  & { areDeliverablesReceiptsZipFilesAvailableForDownload: (
    { __typename?: 'ReceiptZipFileDownloadAvailable' }
    & Pick<ReceiptZipFileDownloadAvailableGQLType, 'canDownloadInput' | 'canDownloadOutput'>
  ) }
);

export type GetBorrowingBasePipelineArtifactInstancesErrorsQueryVariablesGQLType = Exact<{
  rawArtifactInstanceIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetBorrowingBasePipelineArtifactInstancesErrorsQueryGQLType = (
  { __typename?: 'Query' }
  & { borrowingBasePipelineDataValidationErrors: Array<(
    { __typename?: 'DataValidationErrorsMap' }
    & Pick<DataValidationErrorsMapGQLType, 'artifactInstanceId'>
    & { progressBreakdown: Array<(
      { __typename?: 'BorrowingBasePipelineSingleProgressBreakdown' }
      & { status: (
        { __typename?: 'StepStatus' }
        & Pick<StepStatusGQLType, 'status' | 'errors'>
      ) }
    )> }
  )> }
);

export type GetDeliverableArtifactInstanceQueryVariablesGQLType = Exact<{
  artifactInstanceId: Scalars['UUID'];
}>;


export type GetDeliverableArtifactInstanceQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverableArtifactInstance: (
    { __typename?: 'DeliverableArtifactInstance' }
    & Pick<DeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'version' | 'active' | 'status' | 'rawDatabase' | 'rawNamespace' | 'rawIdentifier'>
    & { completedObject?: Maybe<(
      { __typename?: 'ArtifactInstanceDownloadObject' }
      & Pick<ArtifactInstanceDownloadObjectGQLType, 'object' | 'filename'>
    )> }
  ) }
);

export type GetDeliverableArtifactInstanceDownloadQueryVariablesGQLType = Exact<{
  artifactInstanceId: Scalars['UUID'];
}>;


export type GetDeliverableArtifactInstanceDownloadQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverableArtifactInstanceDownload: Array<(
    { __typename: 'ArtifactInstanceDownloadUrl' }
    & Pick<ArtifactInstanceDownloadUrlGQLType, 'signedUrl' | 'filename'>
  ) | (
    { __typename: 'ArtifactInstanceDownloadObject' }
    & Pick<ArtifactInstanceDownloadObjectGQLType, 'object' | 'filename'>
  )> }
);

export type GetDeliverableArtifactsByContainerIdQueryVariablesGQLType = Exact<{
  containerId: Scalars['UUID'];
}>;


export type GetDeliverableArtifactsByContainerIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getDeliverableArtifactsByContainerId: Array<(
    { __typename?: 'DeliverableArtifact' }
    & Pick<DeliverableArtifactGQLType, 'id' | 'containerId' | 'reportingDate' | 'reportingPeriod' | 'configKey' | 'inputType'>
    & { instances: Array<(
      { __typename?: 'DeliverableArtifactInstance' }
      & Pick<DeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'version' | 'active' | 'status' | 'rawDatabase' | 'rawNamespace' | 'rawIdentifier'>
      & { completedObject?: Maybe<(
        { __typename?: 'ArtifactInstanceDownloadObject' }
        & Pick<ArtifactInstanceDownloadObjectGQLType, 'object' | 'filename'>
      )> }
    )>, config: (
      { __typename: 'CashBalancesFeedConfig' }
      & Pick<CashBalancesFeedConfigGQLType, 'artifactType'>
    ) | (
      { __typename: 'SupplementalTapeConfig' }
      & Pick<SupplementalTapeConfigGQLType, 'artifactType' | 'artifactSlug'>
    ) | (
      { __typename: 'LoanTapeConfig' }
      & Pick<LoanTapeConfigGQLType, 'artifactType' | 'loanProductSlug'>
    ) | (
      { __typename: 'RepaymentTapeConfig' }
      & Pick<RepaymentTapeConfigGQLType, 'artifactType' | 'loanProductSlug'>
    ) | (
      { __typename: 'PortfolioCovenantConfig' }
      & Pick<PortfolioCovenantConfigGQLType, 'artifactType' | 'covenantKey'>
    ) | (
      { __typename: 'FinancialCovenantConfig' }
      & Pick<FinancialCovenantConfigGQLType, 'artifactType' | 'covenantKey'>
    ) | (
      { __typename: 'OrgProvidedInputConfig' }
      & Pick<OrgProvidedInputConfigGQLType, 'artifactType' | 'key' | 'bbplArtifactSlug'>
    ) | (
      { __typename: 'MonthlyServicerReportConfig' }
      & Pick<MonthlyServicerReportConfigGQLType, 'artifactType' | 'reportName'>
    ) | (
      { __typename: 'MonthlyStatementConfig' }
      & Pick<MonthlyStatementConfigGQLType, 'artifactType' | 'reportingPeriodStartDateFormula' | 'reportingPeriodEndDateFormula'>
    ) | (
      { __typename: 'FinancialStatementConfig' }
      & Pick<FinancialStatementConfigGQLType, 'artifactType' | 'artifactSlug' | 'financialDataArtifactSlug'>
    ) }
  )> }
);

export type GetDeliverableContainerByIdQueryVariablesGQLType = Exact<{
  containerId: Scalars['UUID'];
}>;


export type GetDeliverableContainerByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverableContainer: (
    { __typename?: 'DeliverableContainer' }
    & Pick<DeliverableContainerGQLType, 'id' | 'configKey' | 'configName' | 'creditAgreementId' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'dueDate' | 'type' | 'period' | 'daysOffset' | 'totalDependencies' | 'completedDependencies' | 'totalFinalArtifacts' | 'completedFinalArtifacts' | 'borrowerId' | 'borrowerSlug' | 'borrowerName' | 'latestReceiptId' | 'mostRecentActionType' | 'approvedDate'>
    & { capitalProviderEntities: Array<(
      { __typename?: 'capitalProviderEntities' }
      & Pick<CapitalProviderEntitiesGQLType, 'id' | 'slug' | 'name'>
    )>, latestGenerateReceiptRecord?: Maybe<(
      { __typename?: 'DeliverableContainerGenerateReceiptRecord' }
      & Pick<DeliverableContainerGenerateReceiptRecordGQLType, 'id' | 'deliverableContainerId' | 'successfulReceiptId' | 'userId' | 'status'>
    )> }
  ) }
);

export type GetDeliverableContainerReceiptsQueryVariablesGQLType = Exact<{
  containerId: Scalars['UUID'];
}>;


export type GetDeliverableContainerReceiptsQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverableContainerReceipts: Array<(
    { __typename?: 'DeliverableContainerReceiptRecord' }
    & Pick<DeliverableContainerReceiptRecordGQLType, 'id' | 'created_at' | 'updated_at' | 'version' | 'expired' | 'deliverableContainerId' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'containerDueDate' | 'containerName' | 'containerType' | 'borrowerId' | 'borrowerSlug' | 'borrowerName'>
    & { capitalProviderEntities: Array<(
      { __typename?: 'capitalProviderEntities' }
      & Pick<CapitalProviderEntitiesGQLType, 'id' | 'slug' | 'name'>
    )>, dependenciesInstances: Array<(
      { __typename?: 'ReceiptInstances' }
      & Pick<ReceiptInstancesGQLType, 'receiptInstanceId' | 'artifactType' | 'artifactConfigKey' | 'artifactReportingDate'>
    )>, finalArtifactsInstances: Array<(
      { __typename?: 'ReceiptInstances' }
      & Pick<ReceiptInstancesGQLType, 'receiptInstanceId' | 'artifactType' | 'artifactConfigKey' | 'artifactReportingDate'>
    )>, actionsLog: Array<(
      { __typename?: 'DeliverableContainerReceiptActions' }
      & Pick<DeliverableContainerReceiptActionsGQLType, 'id' | 'created_at' | 'updated_at' | 'action' | 'receiptId' | 'userId' | 'organizationId' | 'userFirstName' | 'userLastName' | 'organizationName'>
    )> }
  )> }
);

export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType = Exact<{
  receiptId: Scalars['UUID'];
  type: InputTypeGQLType;
}>;


export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'deliverablesContainerReceiptZipFilesDownloadUrl'>
);

export type GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType = Exact<{
  artifactInstanceId: Scalars['UUID'];
}>;


export type GetFinalOutputDeliverableArtifactInstanceQueryGQLType = (
  { __typename?: 'Query' }
  & { finalOutputDeliverableArtifactInstance: (
    { __typename?: 'FinalOutputDeliverableArtifactInstance' }
    & Pick<FinalOutputDeliverableArtifactInstanceGQLType, 'id' | 'deliverableArtifactId' | 'status' | 'rawRecordStatus'>
  ) }
);

export type GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryVariablesGQLType = Exact<{
  receiptId: Scalars['UUID'];
}>;


export type GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryGQLType = (
  { __typename?: 'Query' }
  & { lastOutputDeliverableArtifactInstanceFromReceiptId: (
    { __typename?: 'ComplianceReportCfScoped' }
    & Pick<ComplianceReportCfScopedGQLType, 'id' | 'creditAgreementId' | 'creditFacilityId' | 'reportName' | 'reportType' | 'reportingDate' | 'version' | 'isPreview' | 'database' | 'namespace' | 'identifier'>
    & { entityRecords: (
      { __typename?: 'ReportingEntityRecordsMap' }
      & { accessorEntityAttributes: Array<(
        { __typename?: 'ReportingAccessorEntityAttributes' }
        & Pick<ReportingAccessorEntityAttributesGQLType, 'domain' | 'database' | 'namespace' | 'identifier' | 'accessorName' | 'supplementalEntityKey'>
      )> }
    ) }
  ) }
);

export type CreateDeliverableMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  configKey: Scalars['String'];
  dueDate: Scalars['FullDateStr'];
}>;


export type CreateDeliverableMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deliverable: (
    { __typename?: 'DeliverableContainer' }
    & Pick<DeliverableContainerGQLType, 'id' | 'configKey' | 'configName' | 'creditAgreementId' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'dueDate' | 'type' | 'period' | 'daysOffset' | 'totalDependencies' | 'completedDependencies' | 'totalFinalArtifacts' | 'completedFinalArtifacts' | 'borrowerId' | 'borrowerSlug' | 'borrowerName'>
    & { capitalProviderEntities: Array<(
      { __typename?: 'capitalProviderEntities' }
      & Pick<CapitalProviderEntitiesGQLType, 'id' | 'slug' | 'name'>
    )> }
  ) }
);

export type DeleteDeliverablesRecordsForContainerMutationVariablesGQLType = Exact<{
  containerId: Scalars['UUID'];
}>;


export type DeleteDeliverablesRecordsForContainerMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'deleteDeliverableRecordsForContainerId'>
);

export type GetDeliverableContainersQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetDeliverableContainersQueryGQLType = (
  { __typename?: 'Query' }
  & { getDeliverableContainers: Array<(
    { __typename?: 'DeliverableContainer' }
    & Pick<DeliverableContainerGQLType, 'id' | 'configKey' | 'configName' | 'creditAgreementId' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'dueDate' | 'type' | 'period' | 'daysOffset' | 'totalDependencies' | 'completedDependencies' | 'totalFinalArtifacts' | 'completedFinalArtifacts' | 'borrowerId' | 'borrowerSlug' | 'borrowerName' | 'latestReceiptId' | 'mostRecentActionType' | 'approvedDate'>
    & { capitalProviderEntities: Array<(
      { __typename?: 'capitalProviderEntities' }
      & Pick<CapitalProviderEntitiesGQLType, 'id' | 'slug' | 'name'>
    )> }
  )> }
);

export type GetDeliverablesContainersLenderViewQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  includeFutureDays?: Maybe<Scalars['Int']>;
}>;


export type GetDeliverablesContainersLenderViewQueryGQLType = (
  { __typename?: 'Query' }
  & { deliverablesContainersLenderView: Array<(
    { __typename?: 'DeliverableContainerOutputLenderView' }
    & Pick<DeliverableContainerOutputLenderViewGQLType, 'id' | 'configKey' | 'configName' | 'creditAgreementId' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'dueDate' | 'dueDateDescription' | 'type' | 'latestReceiptId' | 'mostRecentActionType' | 'approvedDate'>
    & { borrower: (
      { __typename?: 'BorrowerEntity' }
      & Pick<BorrowerEntityGQLType, 'id' | 'name'>
    ) }
  )> }
);

export type ApiKeyWithOrganizationFragmentGQLType = (
  { __typename?: 'ApiKeyWithOrganization' }
  & Pick<ApiKeyWithOrganizationGQLType, 'actorType' | 'id' | 'key' | 'secret' | 'description' | 'created_at' | 'updated_at' | 'isActive' | 'userId' | 'organizationId' | 'organizationName' | 'organizationSlug'>
);

export type FinleyAutomatedFragmentGQLType = (
  { __typename?: 'FinleyAutomated' }
  & Pick<FinleyAutomatedGQLType, 'actorType' | 'id' | 'name'>
);

export type UnknownActorFragmentGQLType = (
  { __typename?: 'UnknownActor' }
  & Pick<UnknownActorGQLType, 'actorType' | 'id' | 'originalActorType' | 'name'>
);

export type UserActorFragmentGQLType = (
  { __typename?: 'UserActor' }
  & Pick<UserActorGQLType, 'actorType' | 'id' | 'email' | 'userType' | 'organizationId' | 'isActive' | 'roleType' | 'firstName' | 'lastName'>
);

export type FundingRequestPayloadFragmentGQLType = (
  { __typename?: 'FundingRequestPayload' }
  & { fundingRequest: (
    { __typename?: 'FundingRequest' }
    & Pick<FundingRequestGQLType, 'id' | 'creditFacilityName'>
  ) }
);

export type FundingRequestComponentPayloadFragmentGQLType = (
  { __typename?: 'FundingRequestComponentPayload' }
  & { fundingRequest: (
    { __typename?: 'FundingRequest' }
    & Pick<FundingRequestGQLType, 'id' | 'creditFacilityName'>
  ), fundingRequestComponent: (
    { __typename?: 'FundingRequestComponent' }
    & Pick<FundingRequestComponentGQLType, 'amount' | 'type'>
  ) }
);

export type DeliverablesPayloadFragmentGQLType = (
  { __typename?: 'DeliverablesPayload' }
  & { deliverableItem: (
    { __typename?: 'DeliverableItem' }
    & Pick<DeliverableItemGQLType, 'creditFacilityName' | 'status'>
  ) }
);

export type InsertedDeliverablePayloadFragmentGQLType = (
  { __typename?: 'InsertedDeliverablePayload' }
  & { deliverable: (
    { __typename?: 'DeliverablePayload' }
    & Pick<DeliverablePayloadGQLType, 'id' | 'creditFacilityName' | 'status' | 'updated_at'>
  ) }
);

export type UpdatedDeliverableStatusPayloadFragmentGQLType = (
  { __typename?: 'UpdatedDeliverableStatusPayload' }
  & { deliverable: (
    { __typename?: 'DeliverablePayload' }
    & Pick<DeliverablePayloadGQLType, 'id' | 'creditFacilityName' | 'status' | 'updated_at'>
  ) }
);

export type SubmittedDeliverableSubmissionPayloadFragmentGQLType = (
  { __typename?: 'SubmittedDeliverableSubmissionPayload' }
  & { deliverable: (
    { __typename?: 'DeliverablePayload' }
    & Pick<DeliverablePayloadGQLType, 'id' | 'creditFacilityName' | 'status' | 'updated_at'>
  ) }
);

export type IngestionPayloadFragmentGQLType = (
  { __typename?: 'IngestionPayload' }
  & Pick<IngestionPayloadGQLType, 'origin' | 'failedOps' | 'successOps' | 'messages'>
);

export type VerificationPayloadFragmentGQLType = (
  { __typename?: 'VerificationPayload' }
  & Pick<VerificationPayloadGQLType, 'verificationReportId' | 'creditFacilityName'>
);

export type EventForRenderFragmentGQLType = (
  { __typename?: 'EventWithActor' }
  & Pick<EventWithActorGQLType, 'id' | 'domainKey' | 'actionKey' | 'actorName' | 'targetName' | 'created_at' | 'isCapitalProvider'>
  & { payload: (
    { __typename?: 'FundingRequestPayload' }
    & FundingRequestPayloadFragmentGQLType
  ) | (
    { __typename?: 'FundingRequestComponentPayload' }
    & FundingRequestComponentPayloadFragmentGQLType
  ) | (
    { __typename?: 'DeliverablesPayload' }
    & DeliverablesPayloadFragmentGQLType
  ) | (
    { __typename?: 'IngestionPayload' }
    & IngestionPayloadFragmentGQLType
  ) | (
    { __typename?: 'InsertedDeliverablePayload' }
    & InsertedDeliverablePayloadFragmentGQLType
  ) | (
    { __typename?: 'UpdatedDeliverableStatusPayload' }
    & UpdatedDeliverableStatusPayloadFragmentGQLType
  ) | (
    { __typename?: 'SubmittedDeliverableSubmissionPayload' }
    & SubmittedDeliverableSubmissionPayloadFragmentGQLType
  ) | (
    { __typename?: 'VerificationPayload' }
    & VerificationPayloadFragmentGQLType
  ) }
);

export type GetEventsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['String'];
  limit: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetEventsQueryGQLType = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<EventConnectionGQLType, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), nodes: Array<(
      { __typename?: 'EventWithActor' }
      & EventForRenderFragmentGQLType
    )> }
  ) }
);

export type FundingRequestWithThreadMetadataFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & Pick<FundingRequestWithFullDetailsGQLType, 'id' | 'status'>
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
  ), loans: Array<(
    { __typename?: 'LoanRecord' }
    & Pick<LoanRecordGQLType, 'id' | 'externalLoanId' | 'maturityDate' | 'loanStatus'>
  )> }
);

export type GetFundingRequestsWithThreadMetadataQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetFundingRequestsWithThreadMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & FundingRequestWithThreadMetadataFragmentGQLType
    )> }
  ) }
);

export type BankInstitutionFragmentGQLType = (
  { __typename?: 'BankInstitution' }
  & Pick<BankInstitutionGQLType, 'tellerInstitutionId' | 'plaidInstitutionId' | 'name' | 'institutionUrl' | 'primaryColor' | 'logoUrl' | 'bankInstitutionKey'>
);

export type BankDataProviderInstitutionAccountFieldsFragmentGQLType = (
  { __typename?: 'BankDataProviderInstitutionAccount' }
  & Pick<BankDataProviderInstitutionAccountGQLType, 'dataProviderAccountId' | 'bankInstitutionId' | 'name' | 'mask' | 'type' | 'current' | 'available' | 'currency' | 'retrievedAt'>
);

export type BankDataProviderInstitutionFieldsFragmentGQLType = (
  { __typename?: 'BankDataProviderInstitution' }
  & Pick<BankDataProviderInstitutionGQLType, 'bankInstitutionId' | 'name' | 'bankInstitutionKey' | 'dataProvider' | 'dataProviderInstitutionId' | 'itemId' | 'institutionUrl' | 'primaryColor' | 'logoUrl' | 'externalItemId' | 'needsUpdate'>
  & { bankAccounts: Array<(
    { __typename?: 'BankDataProviderInstitutionAccount' }
    & BankDataProviderInstitutionAccountFieldsFragmentGQLType
  )> }
);

export type GetUserOrgCashBalancePreferenceQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetUserOrgCashBalancePreferenceQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<UserGQLType, 'id'>
    & { organization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug'>
      & { orgPreferences?: Maybe<(
        { __typename?: 'OrgPreferences' }
        & Pick<OrgPreferencesGQLType, 'cashBalancePreference'>
      )> }
    ) }
  )> }
);

export type ConnectPlaidItemMutationVariablesGQLType = Exact<{
  publicToken: Scalars['String'];
  plaidInstitutionId: Scalars['String'];
}>;


export type ConnectPlaidItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { connectPlaidItem: (
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  ) }
);

export type RefreshPlaidInstitutionAccountsMutationVariablesGQLType = Exact<{
  plaidItemId: Scalars['UUID'];
}>;


export type RefreshPlaidInstitutionAccountsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { refreshPlaidInstitutionAccounts: (
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  ) }
);

export type InvalidatePlaidItemMutationVariablesGQLType = Exact<{
  plaidItemId: Scalars['UUID'];
}>;


export type InvalidatePlaidItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { disconnectPlaidItem: (
    { __typename?: 'PlaidResponse' }
    & Pick<PlaidResponseGQLType, 'plaidResponse'>
  ) }
);

export type ReconnectPlaidItemMutationVariablesGQLType = Exact<{
  plaidItemId: Scalars['UUID'];
}>;


export type ReconnectPlaidItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reconnectPlaidItem: (
    { __typename?: 'PlaidResponse' }
    & Pick<PlaidResponseGQLType, 'plaidResponse'>
  ) }
);

export type GetPlaidLinkTokenQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetPlaidLinkTokenQueryGQLType = (
  { __typename?: 'Query' }
  & { plaidLinkToken: (
    { __typename?: 'LinkToken' }
    & Pick<LinkTokenGQLType, 'token' | 'needsUpdate' | 'institutionName' | 'plaidItemId'>
  ) }
);

export type GetAllPlaidInstitutionAccountsQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetAllPlaidInstitutionAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { allPlaidInstitutionAccounts: Array<(
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  )> }
);

export type ConnectTellerAccountsForInstitutionMutationVariablesGQLType = Exact<{
  accessToken: Scalars['String'];
}>;


export type ConnectTellerAccountsForInstitutionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { connectTellerAccountsForInstitution: (
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  ) }
);

export type ReconnectTellerInstitutionMutationVariablesGQLType = Exact<{
  tellerItemId: Scalars['String'];
}>;


export type ReconnectTellerInstitutionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reconnectTellerInstitution: (
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  ) }
);

export type DisconnectTellerInstitutionMutationVariablesGQLType = Exact<{
  tellerItemId: Scalars['String'];
}>;


export type DisconnectTellerInstitutionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { disconnectTellerInstitution: (
    { __typename?: 'TellerDisconnectInstitutionPayload' }
    & Pick<TellerDisconnectInstitutionPayloadGQLType, 'disconnectedItemId'>
  ) }
);

export type RefreshTellerInstitutionMutationVariablesGQLType = Exact<{
  tellerItemId: Scalars['String'];
}>;


export type RefreshTellerInstitutionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { refreshTellerInstitution: (
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  ) }
);

export type GetAllTellerInstitutionAccountsQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetAllTellerInstitutionAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { allTellerInstitutionAccounts: Array<(
    { __typename?: 'BankDataProviderInstitution' }
    & BankDataProviderInstitutionFieldsFragmentGQLType
  )> }
);

export type UpsertImplementationPortalBankAccountMutationVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
  ownerId: Scalars['UUID'];
  accountType: AccountTypeGQLType;
}>;


export type UpsertImplementationPortalBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { upsertImplementationPortalBankAccount: (
    { __typename?: 'BankAccountWithInstitutionAndOwner' }
    & Pick<BankAccountWithInstitutionAndOwnerGQLType, 'id' | 'name'>
  ) }
);

export type GetCreditAgreementValidationErrorsQueryVariablesGQLType = Exact<{
  creditAgreementId: Scalars['UUID'];
}>;


export type GetCreditAgreementValidationErrorsQueryGQLType = (
  { __typename?: 'Query' }
  & { getCreditAgreementValidationErrors: Array<(
    { __typename?: 'CreditAgreementValidationError' }
    & Pick<CreditAgreementValidationErrorGQLType, 'type' | 'message'>
  )> }
);

export type ImplementationDetailsQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type ImplementationDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { implementation: (
    { __typename?: 'Implementation' }
    & Pick<ImplementationGQLType, 'id' | 'name'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'slug' | 'name'>
    )>, creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name' | 'borrowerOrganizationName'>
    )> }
  ) }
);

export type UpdateImplementationNameMutationVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateImplementationNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateImplementationName: (
    { __typename?: 'Implementation' }
    & Pick<ImplementationGQLType, 'id' | 'name'>
  ) }
);

export type CreditAgreementDocumentMetadataFieldsFragmentGQLType = (
  { __typename?: 'CreditAgreementMetadata' }
  & Pick<CreditAgreementMetadataGQLType, 'id' | 'facilityType' | 'creditFacilityId' | 'effectiveFrom' | 'effectiveTo' | 'version' | '_schemaVersion_' | 's3Path' | '_note_' | 'displayName'>
);

export type CreditAgreementFullArtifactFieldsFragmentGQLType = (
  { __typename?: 'CreditAgreementFullArtifact' }
  & Pick<CreditAgreementFullArtifactGQLType, 'id' | 'creditAgreement'>
);

export type ImplementationsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type ImplementationsQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & { implementations: Array<(
      { __typename?: 'Implementation' }
      & Pick<ImplementationGQLType, 'id' | 'name'>
      & { creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id'>
      )> }
    )> }
  ) }
);

export type GetCreditAgreementDocumentsMetadataQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditAgreementDocumentsMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { creditAgreementDocumentsMetadata: Array<(
    { __typename?: 'CreditAgreementMetadata' }
    & CreditAgreementDocumentMetadataFieldsFragmentGQLType
  )> }
);

export type GetCreditAgreementFullArtifactQueryVariablesGQLType = Exact<{
  creditAgreementId: Scalars['UUID'];
}>;


export type GetCreditAgreementFullArtifactQueryGQLType = (
  { __typename?: 'Query' }
  & { creditAgreementFullArtifact: (
    { __typename?: 'CreditAgreementFullArtifact' }
    & CreditAgreementFullArtifactFieldsFragmentGQLType
  ) }
);

export type CreateImplementationMutationVariablesGQLType = Exact<{
  ownerOrganizationId: Scalars['UUID'];
  implementationName: Scalars['String'];
  borrowerId: Scalars['UUID'];
}>;


export type CreateImplementationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createImplementation: (
    { __typename?: 'Implementation' }
    & Pick<ImplementationGQLType, 'id'>
  ) }
);

export type CreateSingleFacilityImplementationMutationVariablesGQLType = Exact<{
  ownerOrganizationId: Scalars['UUID'];
  creditFacilityName: Scalars['String'];
  creditFacilityParties: Array<PartyInputGQLType> | PartyInputGQLType;
}>;


export type CreateSingleFacilityImplementationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createSingleFacilityImplementation: (
    { __typename?: 'Implementation' }
    & Pick<ImplementationGQLType, 'id'>
  ) }
);

export type VisibleOrganizationsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type VisibleOrganizationsQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & { visibleOrganizations: Array<(
      { __typename?: 'BaseOrganization' }
      & Pick<BaseOrganizationGQLType, 'id' | 'slug' | 'name'>
    )> }
  ) }
);

export type GetCreditAgreementFullArtifactImplementationPortalWipQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditAgreementFullArtifactImplementationPortalWipQueryGQLType = (
  { __typename?: 'Query' }
  & { creditAgreementFullArtifactWip: (
    { __typename?: 'CreditAgreementFullArtifactWipResponse' }
    & Pick<CreditAgreementFullArtifactWipResponseGQLType, 'errors'>
    & { wip: (
      { __typename?: 'CreditAgreementFullArtifact' }
      & CreditAgreementFullArtifactFieldsFragmentGQLType
    ) }
  ) }
);

export type UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationVariablesGQLType = Exact<{
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactInputGQLType;
}>;


export type UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateClientCreditAgreementFullArtifactImplementationPortalWip: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CommitArtifactDocumentAndCreditAgreementsMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type CommitArtifactDocumentAndCreditAgreementsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { commitArtifactDocumentAndCreditAgreements: (
    { __typename?: 'SuccessesAndErrors' }
    & Pick<SuccessesAndErrorsGQLType, 'successes' | 'errors'>
  ) }
);

export type UpdateCreditAgreementDisplayNameMutationVariablesGQLType = Exact<{
  creditAgreementId: Scalars['UUID'];
  displayName: Scalars['String'];
}>;


export type UpdateCreditAgreementDisplayNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateCreditAgreementDisplayName: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateUserSettingsMutationVariablesGQLType = Exact<{
  id: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type UpdateUserSettingsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateUserSettings?: Maybe<(
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  )> }
);

export type GetActiveSlackInstallationsQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetActiveSlackInstallationsQueryGQLType = (
  { __typename?: 'Query' }
  & { activeSlackInstallations: Array<(
    { __typename?: 'SlackInstallation' }
    & Pick<SlackInstallationGQLType, 'id' | 'botToken' | 'botId' | 'botUserId' | 'botScopes' | 'userId' | 'incomingWebhookUrl' | 'incomingWebhookChannelId' | 'incomingWebhookChannelName' | 'incomingWebhookConfigurationUrl' | 'created_at' | 'updated_at' | 'isActive' | 'organizationId' | 'teamId' | 'teamName' | 'enterpriseId' | 'enterpriseName' | 'userToken' | 'userScopes'>
  )> }
);

export type DeactivateSlackInstallationForChannelMutationVariablesGQLType = Exact<{
  teamId: Scalars['String'];
  incomingWebhookChannelId: Scalars['String'];
  organizationId: Scalars['UUID'];
}>;


export type DeactivateSlackInstallationForChannelMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deactivateSlackInstallationForChannel?: Maybe<(
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  )> }
);

export type DeactivateSlackInstallationsForOrganizationMutationVariablesGQLType = Exact<{ [key: string]: never; }>;


export type DeactivateSlackInstallationsForOrganizationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deactivateSlackInstallationsForOrganization?: Maybe<(
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  )> }
);

export type ReactivateSlackInstallationForChannelMutationVariablesGQLType = Exact<{
  teamId: Scalars['String'];
  incomingWebhookChannelId: Scalars['String'];
  organizationId: Scalars['UUID'];
}>;


export type ReactivateSlackInstallationForChannelMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reactivateSlackInstallationForChannel?: Maybe<(
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  )> }
);

export type GetWebhookSubscriptionsForUserQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetWebhookSubscriptionsForUserQueryGQLType = (
  { __typename?: 'Query' }
  & { webhookSubscriptionsForUser: Array<(
    { __typename?: 'WebhookSubscription' }
    & Pick<WebhookSubscriptionGQLType, 'endpoint' | 'eventTypes' | 'svixApplicationId' | 'svixDashboardUrl'>
  )> }
);

export type GetAthenaTablesForOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['String'];
  creditFacilityIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  tablePrefixes?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetAthenaTablesForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaTables: Array<(
    { __typename?: 'AthenaTable' }
    & Pick<AthenaTableGQLType, 'tableName'>
    & { properties: Array<(
      { __typename?: 'AthenaTableProperty' }
      & Pick<AthenaTablePropertyGQLType, 'name' | 'type'>
    )> }
  )> }
);

export type GetAthenaQueryResponseByRawQueryVariablesGQLType = Exact<{
  organizationId: Scalars['String'];
  query: Scalars['String'];
  bindings: Array<Scalars['String']> | Scalars['String'];
  variables: Array<QueryVariableGQLType> | QueryVariableGQLType;
}>;


export type GetAthenaQueryResponseByRawQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaQueryResponse: (
    { __typename?: 'AthenaQueryResponse' }
    & Pick<AthenaQueryResponseGQLType, 'Items' | 'NextToken' | 'QueryExecutionId'>
  ) }
);

export type ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType = Exact<{
  organizationId: Scalars['String'];
  globalRecurringDateConfigsString: Scalars['String'];
  globalRecurringDateConfigFields: Array<Scalars['String']> | Scalars['String'];
  supplementalVariables: Array<QueryVariableGQLType> | QueryVariableGQLType;
  variables: Array<QueryVariableGQLType> | QueryVariableGQLType;
  bindings: Array<Scalars['String']> | Scalars['String'];
  queryString: Scalars['String'];
  queryName: Scalars['String'];
}>;


export type ExecuteAthenaRecurringQueryByRawQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaRecurringQueryResponse: (
    { __typename?: 'AthenaRecurringQueryResponse' }
    & Pick<AthenaRecurringQueryResponseGQLType, 'items' | 'errors'>
  ) }
);

type CommonAttributeValueFields_BooleanAttributeValue_FragmentGQLType = (
  { __typename?: 'BooleanAttributeValue' }
  & Pick<BooleanAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

type CommonAttributeValueFields_FloatAttributeValue_FragmentGQLType = (
  { __typename?: 'FloatAttributeValue' }
  & Pick<FloatAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

type CommonAttributeValueFields_FullDateStrAttributeValue_FragmentGQLType = (
  { __typename?: 'FullDateStrAttributeValue' }
  & Pick<FullDateStrAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

type CommonAttributeValueFields_IntegerAttributeValue_FragmentGQLType = (
  { __typename?: 'IntegerAttributeValue' }
  & Pick<IntegerAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

type CommonAttributeValueFields_PercentageRateAttributeValue_FragmentGQLType = (
  { __typename?: 'PercentageRateAttributeValue' }
  & Pick<PercentageRateAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

type CommonAttributeValueFields_StringArrayAttributeValue_FragmentGQLType = (
  { __typename?: 'StringArrayAttributeValue' }
  & Pick<StringArrayAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

type CommonAttributeValueFields_StringAttributeValue_FragmentGQLType = (
  { __typename?: 'StringAttributeValue' }
  & Pick<StringAttributeValueGQLType, 'attributeId' | 'name' | 'ownerOrganizationId' | 'type' | 'attributeValueId' | 'entityIdentifier' | 'entityDomain' | 'effectiveFromReportingDate' | 'displayName'>
);

export type CommonAttributeValueFieldsFragmentGQLType = CommonAttributeValueFields_BooleanAttributeValue_FragmentGQLType | CommonAttributeValueFields_FloatAttributeValue_FragmentGQLType | CommonAttributeValueFields_FullDateStrAttributeValue_FragmentGQLType | CommonAttributeValueFields_IntegerAttributeValue_FragmentGQLType | CommonAttributeValueFields_PercentageRateAttributeValue_FragmentGQLType | CommonAttributeValueFields_StringArrayAttributeValue_FragmentGQLType | CommonAttributeValueFields_StringAttributeValue_FragmentGQLType;

type AttributeValueFragment_StringAttributeValue_FragmentGQLType = (
  { __typename: 'StringAttributeValue' }
  & { stringValue: StringAttributeValueGQLType['value'] }
  & { stringValidation: (
    { __typename?: 'AttributeValueStringValidation' }
    & Pick<AttributeValueStringValidationGQLType, 'type' | 'allowedValues'>
  ) }
  & CommonAttributeValueFields_StringAttributeValue_FragmentGQLType
);

type AttributeValueFragment_FloatAttributeValue_FragmentGQLType = (
  { __typename: 'FloatAttributeValue' }
  & { floatValue: FloatAttributeValueGQLType['value'] }
  & { floatValidation: (
    { __typename?: 'AttributeValueFloatValidation' }
    & Pick<AttributeValueFloatValidationGQLType, 'type'>
    & { display?: Maybe<(
      { __typename?: 'AttributeValueCurrencyDisplay' }
      & Pick<AttributeValueCurrencyDisplayGQLType, 'displayType' | 'currencyCode'>
    )> }
  ) }
  & CommonAttributeValueFields_FloatAttributeValue_FragmentGQLType
);

type AttributeValueFragment_IntegerAttributeValue_FragmentGQLType = (
  { __typename: 'IntegerAttributeValue' }
  & { integerValue: IntegerAttributeValueGQLType['value'] }
  & { integerValidation: (
    { __typename?: 'AttributeValueIntegerValidation' }
    & Pick<AttributeValueIntegerValidationGQLType, 'type'>
  ) }
  & CommonAttributeValueFields_IntegerAttributeValue_FragmentGQLType
);

type AttributeValueFragment_BooleanAttributeValue_FragmentGQLType = (
  { __typename: 'BooleanAttributeValue' }
  & { booleanValue: BooleanAttributeValueGQLType['value'] }
  & { booleanValidation: (
    { __typename?: 'AttributeValueBooleanValidation' }
    & Pick<AttributeValueBooleanValidationGQLType, 'type'>
  ) }
  & CommonAttributeValueFields_BooleanAttributeValue_FragmentGQLType
);

type AttributeValueFragment_PercentageRateAttributeValue_FragmentGQLType = (
  { __typename: 'PercentageRateAttributeValue' }
  & { percentageRateValue: PercentageRateAttributeValueGQLType['value'] }
  & { percentageRateValidation: (
    { __typename?: 'AttributeValuePercentageRateValidation' }
    & Pick<AttributeValuePercentageRateValidationGQLType, 'type'>
  ) }
  & CommonAttributeValueFields_PercentageRateAttributeValue_FragmentGQLType
);

type AttributeValueFragment_FullDateStrAttributeValue_FragmentGQLType = (
  { __typename: 'FullDateStrAttributeValue' }
  & { fullDateStrValue: FullDateStrAttributeValueGQLType['value'] }
  & { fullDateStrValidation: (
    { __typename?: 'AttributeValueFullDateStrValidation' }
    & Pick<AttributeValueFullDateStrValidationGQLType, 'type'>
  ) }
  & CommonAttributeValueFields_FullDateStrAttributeValue_FragmentGQLType
);

type AttributeValueFragment_StringArrayAttributeValue_FragmentGQLType = (
  { __typename: 'StringArrayAttributeValue' }
  & { stringArrayValue: StringArrayAttributeValueGQLType['value'] }
  & { stringArrayValidation: (
    { __typename?: 'AttributeValueStringArrayValidation' }
    & Pick<AttributeValueStringArrayValidationGQLType, 'type' | 'allowedValues'>
  ) }
  & CommonAttributeValueFields_StringArrayAttributeValue_FragmentGQLType
);

export type AttributeValueFragmentFragmentGQLType = AttributeValueFragment_StringAttributeValue_FragmentGQLType | AttributeValueFragment_FloatAttributeValue_FragmentGQLType | AttributeValueFragment_IntegerAttributeValue_FragmentGQLType | AttributeValueFragment_BooleanAttributeValue_FragmentGQLType | AttributeValueFragment_PercentageRateAttributeValue_FragmentGQLType | AttributeValueFragment_FullDateStrAttributeValue_FragmentGQLType | AttributeValueFragment_StringArrayAttributeValue_FragmentGQLType;

export type AttributeFragmentFragmentGQLType = (
  { __typename?: 'Attribute' }
  & Pick<AttributeGQLType, 'attributeId' | 'displayName' | 'type'>
  & { validation: (
    { __typename?: 'AttributeValidation' }
    & Pick<AttributeValidationGQLType, 'type' | 'allowedValues'>
    & { display?: Maybe<(
      { __typename?: 'AttributeValueCurrencyDisplay' }
      & Pick<AttributeValueCurrencyDisplayGQLType, 'displayType' | 'currencyCode'>
    )> }
  ), attributeValue?: Maybe<(
    { __typename?: 'StringAttributeValue' }
    & AttributeValueFragment_StringAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'FloatAttributeValue' }
    & AttributeValueFragment_FloatAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'IntegerAttributeValue' }
    & AttributeValueFragment_IntegerAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'BooleanAttributeValue' }
    & AttributeValueFragment_BooleanAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'PercentageRateAttributeValue' }
    & AttributeValueFragment_PercentageRateAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'FullDateStrAttributeValue' }
    & AttributeValueFragment_FullDateStrAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'StringArrayAttributeValue' }
    & AttributeValueFragment_StringArrayAttributeValue_FragmentGQLType
  )>, attributeValues: Array<(
    { __typename?: 'StringAttributeValue' }
    & AttributeValueFragment_StringAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'FloatAttributeValue' }
    & AttributeValueFragment_FloatAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'IntegerAttributeValue' }
    & AttributeValueFragment_IntegerAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'BooleanAttributeValue' }
    & AttributeValueFragment_BooleanAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'PercentageRateAttributeValue' }
    & AttributeValueFragment_PercentageRateAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'FullDateStrAttributeValue' }
    & AttributeValueFragment_FullDateStrAttributeValue_FragmentGQLType
  ) | (
    { __typename?: 'StringArrayAttributeValue' }
    & AttributeValueFragment_StringArrayAttributeValue_FragmentGQLType
  )> }
);

export type GetAttributeListByEntityQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  listName: Scalars['String'];
  entityDomain: AttributeEntityDomainGQLType;
  entityIdentifier?: Maybe<Scalars['UUID']>;
}>;


export type GetAttributeListByEntityQueryGQLType = (
  { __typename?: 'Query' }
  & { attributes: Array<(
    { __typename?: 'Attribute' }
    & AttributeFragmentFragmentGQLType
  )> }
);

export type CreateOrUpdateLatestAttributeValueMutationVariablesGQLType = Exact<{
  input: CreateOrUpdateLatestAttributeValueInputGQLType;
}>;


export type CreateOrUpdateLatestAttributeValueMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrUpdateLatestAttributeValue: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type BankAccountWithInstitutionAndOwnerFragmentGQLType = (
  { __typename?: 'BankAccountWithInstitutionAndOwner' }
  & Pick<BankAccountWithInstitutionAndOwnerGQLType, 'id' | 'accountNumber' | 'currencyCode' | 'name' | 'bankInstitutionId' | 'plaidAccountId' | 'tellerAccountId' | 'retrievedAt' | 'current' | 'available' | 'conversionRate' | 'routingNumber' | 'institutionName' | 'bankInstitutionKey' | 'organizationId' | 'ownerType' | 'ownerName' | 'connectionProviderName' | 'connectionProviderAccountMask'>
);

export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType = Exact<{
  borrowerId: Scalars['UUID'];
}>;


export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType = (
  { __typename?: 'Query' }
  & { institutionAndConnectionDetailsForBorrower: Array<(
    { __typename?: 'CreditFacilityWithInstitutionsAndConnections' }
    & Pick<CreditFacilityWithInstitutionsAndConnectionsGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'tellerBankInstitutionId' | 'tellerBankInstitutionName' | 'tellerBankInstitutionKey' | 'tellerItemId' | 'tellerAccountId' | 'tellerAccountName' | 'tellerAccountMask' | 'plaidBankInstitutionId' | 'plaidBankInstitutionName' | 'plaidBankInstitutionKey' | 'plaidItemId' | 'plaidAccountId' | 'plaidAccountName' | 'plaidAccountMask'>
    & { organizations: Array<(
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug' | 'type'>
    )> }
  )> }
);

export type GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { institutionAndConnectionDetailsForImplementation: Array<(
    { __typename?: 'CreditFacilityWithInstitutionsAndConnections' }
    & Pick<CreditFacilityWithInstitutionsAndConnectionsGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'tellerBankInstitutionId' | 'tellerBankInstitutionName' | 'tellerBankInstitutionKey' | 'tellerItemId' | 'tellerAccountId' | 'tellerAccountName' | 'tellerAccountMask' | 'plaidBankInstitutionId' | 'plaidBankInstitutionName' | 'plaidBankInstitutionKey' | 'plaidItemId' | 'plaidAccountId' | 'plaidAccountName' | 'plaidAccountMask'>
    & { organizations: Array<(
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug' | 'type'>
    )> }
  )> }
);

export type GetBankAccountsByCreditFacilityIdQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
}>;


export type GetBankAccountsByCreditFacilityIdQueryGQLType = (
  { __typename?: 'Query' }
  & { bankAccountsWithDesignationAndOwner: Array<(
    { __typename?: 'BankAccountWithInstitutionDesignationAndOwner' }
    & Pick<BankAccountWithInstitutionDesignationAndOwnerGQLType, 'id' | 'accountNumber' | 'currencyCode' | 'name' | 'bankInstitutionId' | 'plaidAccountId' | 'tellerAccountId' | 'retrievedAt' | 'current' | 'available' | 'conversionRate' | 'routingNumber' | 'institutionName' | 'bankInstitutionKey' | 'organizationId' | 'ownerType' | 'accountType' | 'creditFacilityId' | 'ownerName' | 'connectionProviderName' | 'connectionProviderAccountMask'>
  )> }
);

export type GetAllBankInstitutionsQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetAllBankInstitutionsQueryGQLType = (
  { __typename?: 'Query' }
  & { allBankInstitutions: Array<(
    { __typename?: 'BankInstitution' }
    & Pick<BankInstitutionGQLType, 'id' | 'name' | 'bankInstitutionKey' | 'tellerInstitutionId' | 'plaidInstitutionId'>
  )> }
);

export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
  maskSensitiveInfo?: Maybe<Scalars['Boolean']>;
}>;


export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { implementation: (
    { __typename?: 'Implementation' }
    & { bankAccountsWithInstitutionAndOwner: Array<(
      { __typename?: 'BankAccountWithInstitutionAndOwner' }
      & BankAccountWithInstitutionAndOwnerFragmentGQLType
    )> }
  ) }
);

export type AddBankAccountMutationVariablesGQLType = Exact<{
  bankInstitutionId: Scalars['UUID'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  routingNumber: Scalars['String'];
  implementationId: Scalars['UUID'];
  ownerId: Scalars['UUID'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
}>;


export type AddBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { addBankAccount: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type EditBankAccountMutationVariablesGQLType = Exact<{
  bankAccountId: Scalars['UUID'];
  accountName: Scalars['String'];
  ownerId: Scalars['UUID'];
  plaidAccountId?: Maybe<Scalars['String']>;
  tellerAccountId?: Maybe<Scalars['String']>;
}>;


export type EditBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { editBankAccount: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeactivateBankAccountMutationVariablesGQLType = Exact<{
  bankAccountId: Scalars['UUID'];
}>;


export type DeactivateBankAccountMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deactivateBankAccount: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type BorrowingBaseReportFragmentGQLType = (
  { __typename?: 'BorrowingBaseReport' }
  & Pick<BorrowingBaseReportGQLType, 'id' | 'assetValuation' | 'effectiveReceivableValuationRate' | 'borrowerId' | 'cashAdvanceRate' | 'creditFacilitySlug' | 'creditAgreementId' | 'creditAgreementVersion' | 'creditFacilityId' | 'fileVersion' | 'borrowingBaseAmountAssets' | 'totalCash' | 'totalBorrowingBaseAmount' | 'borrowingBaseReserveAmount' | 'isBorrowingBaseReservePositiveExcessCollectionsOverReserve' | 'maxReceivableAdvanceAmount' | 'maxCashAdvanceAmount' | 'commitmentAmount' | 'currentPrincipalBalance' | 'reportingDate' | 'totalEligibleExposure' | 'totalReceivableExposure' | 'totalEligibilityKickout' | 'totalConcentrationKickout' | 'totalFacilityUtilization' | 'totalMaxAdvanceAmount' | 'borrowingBaseUtilization' | 'weightedAverageReceivableAdvanceRate' | 'totalEligibleBorrowingBaseAccountCash' | 'totalAssets' | 'effectiveAdvanceRate' | 'effectiveReceivableAdvanceRate' | 'totalCollectionsAccountCash' | 'totalPreAdvanceCashContribution' | 'totalCashBorrowingBaseAmount' | 'effectiveCashAdvanceRate' | 'maximumAvailableAmount' | 'borrowingBaseAvailability' | 'borrowingBaseAvailabilityRate' | 'assignedEligibleExposureSinceLastApprovedFundingRequest' | 'created_at' | 'updated_at'>
);

export type BorrowingBaseReportLoanProductCalculationFragmentGQLType = (
  { __typename?: 'BorrowingBaseReportLoanProductCalculation' }
  & Pick<BorrowingBaseReportLoanProductCalculationGQLType, 'id' | 'borrowingBaseReportId' | 'creditFacilityId' | 'loanProductId' | 'created_at' | 'updated_at' | 'totalReceivableExposure' | 'totalEligibilityKickout' | 'totalEligibleExposure' | 'totalConcentrationKickout' | 'totalEligibleExposureLessConcentrationKickouts' | 'weightedAverageReceivableAdvanceRate' | 'totalReceivableBorrowingBaseAmount' | 'effectiveReceivableAdvanceRate' | 'effectiveReceivableValuationRate'>
);

export type ConcentrationLimitCalculationFragmentGQLType = (
  { __typename?: 'ConcentrationLimitCalculation' }
  & Pick<ConcentrationLimitCalculationGQLType, 'id' | 'borrowingBaseReportId' | 'concentrationLimitKey' | 'concentrationLimit' | 'concentrationAmount' | 'totalEligibleExposure' | 'concentration' | 'borrowingBaseReduction' | 'complianceStatus' | 'created_at'>
);

export type EligibilityCriteriaCalculationFragmentGQLType = (
  { __typename?: 'EligibilityCriteriaCalculation' }
  & Pick<EligibilityCriteriaCalculationGQLType, 'id' | 'borrowingBaseReportId' | 'eligibilityCriteriaKey' | 'eligibilityReduction' | 'created_at'>
);

export type BankAccountCashBalanceFragmentGQLType = (
  { __typename?: 'BankAccountCashBalance' }
  & Pick<BankAccountCashBalanceGQLType, 'bankAccountId' | 'balance' | 'accountType' | 'cashAdvanceRate' | 'currencyCode' | 'conversionRate'>
);

export type ReceivableBorrowingBaseTestWaiverFragmentGQLType = (
  { __typename?: 'ReceivableBorrowingBaseTestWaiver' }
  & Pick<ReceivableBorrowingBaseTestWaiverGQLType, 'id' | 'finleyReceivableId' | 'externalReceivableId' | 'loanProductId' | 'creditFacilityId' | 'borrowingBaseTestType' | 'borrowingBaseTestKey' | 'waiverStartReportingDate' | 'waiverExpirationReportingDate' | 'isActive' | 'lastUpdatedUserId' | 'lastUpdatedOrganizationName' | 'created_at' | 'updated_at'>
);

export type GetLatestBorrowingBaseReportQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetLatestBorrowingBaseReportQueryGQLType = (
  { __typename?: 'Query' }
  & { latestBorrowingBaseReport?: Maybe<(
    { __typename?: 'BorrowingBaseReport' }
    & { concentrationLimitCalculations?: Maybe<Array<(
      { __typename?: 'ConcentrationLimitCalculation' }
      & Pick<ConcentrationLimitCalculationGQLType, 'id' | 'borrowingBaseReportId' | 'concentrationLimitKey' | 'concentrationLimit' | 'concentrationAmount' | 'totalEligibleExposure' | 'concentration' | 'borrowingBaseReduction' | 'complianceStatus' | 'created_at'>
    )>> }
    & BorrowingBaseReportFragmentGQLType
  )> }
);

export type GetLatestBorrowingBaseReportsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetLatestBorrowingBaseReportsQueryGQLType = (
  { __typename?: 'Query' }
  & { latestBorrowingBaseReports: Array<Maybe<(
    { __typename?: 'BorrowingBaseReport' }
    & BorrowingBaseReportFragmentGQLType
  )>> }
);

export type GetBorrowingBaseReportsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  startReportingDate?: Maybe<Scalars['String']>;
  endReportingDate?: Maybe<Scalars['String']>;
}>;


export type GetBorrowingBaseReportsQueryGQLType = (
  { __typename?: 'Query' }
  & { borrowingBaseReports: Array<(
    { __typename?: 'BorrowingBaseReport' }
    & { concentrationLimitCalculations?: Maybe<Array<(
      { __typename?: 'ConcentrationLimitCalculation' }
      & ConcentrationLimitCalculationFragmentGQLType
    )>>, eligibilityCriteriaCalculations?: Maybe<Array<(
      { __typename?: 'EligibilityCriteriaCalculation' }
      & EligibilityCriteriaCalculationFragmentGQLType
    )>>, bankAccountCashBalances?: Maybe<Array<(
      { __typename?: 'BankAccountCashBalance' }
      & BankAccountCashBalanceFragmentGQLType
    )>>, loanProductCalculations?: Maybe<Array<(
      { __typename?: 'BorrowingBaseReportLoanProductCalculation' }
      & BorrowingBaseReportLoanProductCalculationFragmentGQLType
    )>> }
    & BorrowingBaseReportFragmentGQLType
  )> }
);

export type GetBorrowingBaseReportQueryVariablesGQLType = Exact<{
  borrowingBaseReportId: Scalars['UUID'];
}>;


export type GetBorrowingBaseReportQueryGQLType = (
  { __typename?: 'Query' }
  & { borrowingBaseReport: (
    { __typename?: 'BorrowingBaseReport' }
    & { concentrationLimitCalculations?: Maybe<Array<(
      { __typename?: 'ConcentrationLimitCalculation' }
      & ConcentrationLimitCalculationFragmentGQLType
    )>>, eligibilityCriteriaCalculations?: Maybe<Array<(
      { __typename?: 'EligibilityCriteriaCalculation' }
      & EligibilityCriteriaCalculationFragmentGQLType
    )>>, bankAccountCashBalances?: Maybe<Array<(
      { __typename?: 'BankAccountCashBalance' }
      & BankAccountCashBalanceFragmentGQLType
    )>>, loanProductCalculations?: Maybe<Array<(
      { __typename?: 'BorrowingBaseReportLoanProductCalculation' }
      & BorrowingBaseReportLoanProductCalculationFragmentGQLType
    )>> }
    & BorrowingBaseReportFragmentGQLType
  ) }
);

export type GetExtendedResponseTapeDownloadUrlQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  loanProductId: Scalars['UUID'];
}>;


export type GetExtendedResponseTapeDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getExtendedResponseTapeDownloadUrl'>
);

export type GetReceivableWaiversForReceivableIdsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
  receivableIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetReceivableWaiversForReceivableIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { receivableWaiversForReceivableIds: Array<(
    { __typename?: 'ReceivableBorrowingBaseTestWaiver' }
    & ReceivableBorrowingBaseTestWaiverFragmentGQLType
  )> }
);

export type GetReceivableWaiversForCreditFacilityWithOrganizationQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetReceivableWaiversForCreditFacilityWithOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { receivableWaiversForCreditFacilityWithOrganization: Array<(
    { __typename?: 'ReceivableBorrowingBaseTestWaiver' }
    & ReceivableBorrowingBaseTestWaiverFragmentGQLType
  )> }
);

export type UpdateReceivableWaiversMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  receivableWaivers: Array<ReceivableBorrowingBaseTestWaiverInputGQLType> | ReceivableBorrowingBaseTestWaiverInputGQLType;
}>;


export type UpdateReceivableWaiversMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateReceivableWaivers: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeleteReceivableWaiversMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  receivableWaivers: Array<ReceivableBorrowingBaseTestWaiverInputGQLType> | ReceivableBorrowingBaseTestWaiverInputGQLType;
}>;


export type DeleteReceivableWaiversMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteReceivableWaivers: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type GetFinancialCovenantCalculationsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['JSDate'];
  endDate: Scalars['JSDate'];
}>;


export type GetFinancialCovenantCalculationsQueryGQLType = (
  { __typename?: 'Query' }
  & { financialCovenantCalculations?: Maybe<(
    { __typename?: 'FinancialCovenantsInsights' }
    & { config: Array<(
      { __typename?: 'FinancialCovenantConfigProperty' }
      & Pick<FinancialCovenantConfigPropertyGQLType, 'name' | 'key' | 'valueType' | 'limitType' | 'limitValue'>
    )>, financialCovenantsCalculations: Array<(
      { __typename?: 'FinancialCovenantsCalculation' }
      & Pick<FinancialCovenantsCalculationGQLType, 'id' | 'creditFacilityId' | 'reportingDate' | 'covenantKey' | 'covenantType' | 'limitValue' | 'limitType' | 'value'>
    )> }
  )> }
);

export type SuccessPortfolioCovenantFragmentGQLType = (
  { __typename?: 'SuccessPortfolioCovenant' }
  & Pick<SuccessPortfolioCovenantGQLType, 'id' | 'creditFacilityId' | 'creditAgreementId' | 'covenantKey' | 'reportingDate' | 'version' | 'triggerDate' | 'result' | 'value' | 'warnings' | 'status' | 'created_at' | 'updated_at'>
  & { variables: Array<(
    { __typename?: 'PortfolioCovenantVariable' }
    & Pick<PortfolioCovenantVariableGQLType, 'name' | 'value'>
  )>, metadata?: Maybe<(
    { __typename?: 'PortfolioCovenantMetadata' }
    & Pick<PortfolioCovenantMetadataGQLType, 'errors'>
  )> }
);

export type GetSuccessPortfolioCovenantsByCreditFacilityIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
}>;


export type GetSuccessPortfolioCovenantsByCreditFacilityIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getSuccessPortfolioCovenantsByCreditFacilityId: Array<(
    { __typename?: 'SuccessPortfolioCovenant' }
    & SuccessPortfolioCovenantFragmentGQLType
  )> }
);

export type GetSuccessPortfolioCovenantsByKeyQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  start?: Maybe<Scalars['FullDateStr']>;
  end?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
}>;


export type GetSuccessPortfolioCovenantsByKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { getSuccessPortfolioCovenantsByKey: Array<(
    { __typename?: 'SuccessPortfolioCovenant' }
    & SuccessPortfolioCovenantFragmentGQLType
  )> }
);

export type GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  covenantKey: Scalars['String'];
  start?: Maybe<Scalars['FullDateStr']>;
  end?: Maybe<Scalars['FullDateStr']>;
  mode: PortfolioCovenantWorkleaseModeGQLType;
}>;


export type GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getSuccessPortfolioCovenantsByKeyAndCreditAgreementId: Array<(
    { __typename?: 'SuccessPortfolioCovenant' }
    & SuccessPortfolioCovenantFragmentGQLType
  )> }
);

export type GetSuccessPortfolioCovenantByIdQueryVariablesGQLType = Exact<{
  portfolioCovenantId: Scalars['UUID'];
}>;


export type GetSuccessPortfolioCovenantByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getSuccessPortfolioCovenantById?: Maybe<(
    { __typename?: 'SuccessPortfolioCovenant' }
    & SuccessPortfolioCovenantFragmentGQLType
  )> }
);

export type GetPortfolioCovenantByIdQueryVariablesGQLType = Exact<{
  portfolioCovenantId: Scalars['UUID'];
}>;


export type GetPortfolioCovenantByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getPortfolioCovenantById?: Maybe<(
    { __typename?: 'SuccessPortfolioCovenant' }
    & SuccessPortfolioCovenantFragmentGQLType
  ) | (
    { __typename?: 'ErrorPortfolioCovenant' }
    & Pick<ErrorPortfolioCovenantGQLType, 'id' | 'creditFacilityId' | 'creditAgreementId' | 'covenantKey' | 'triggerDate' | 'status' | 'created_at' | 'updated_at'>
    & { metadata?: Maybe<(
      { __typename?: 'PortfolioCovenantMetadata' }
      & Pick<PortfolioCovenantMetadataGQLType, 'errors'>
    )> }
  )> }
);

export type CreateCommentMutationVariablesGQLType = Exact<{
  threadId: Scalars['UUID'];
  comment: Scalars['String'];
}>;


export type CreateCommentMutationGQLType = (
  { __typename?: 'Mutation' }
  & { commentId: MutationGQLType['createComment'] }
);

export type CreateThreadActionMutationVariablesGQLType = Exact<{
  threadId: Scalars['UUID'];
  action: ThreadActionGQLType;
}>;


export type CreateThreadActionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createThreadAction: (
    { __typename?: 'Thread' }
    & BaseThreadFragmentFragmentGQLType
  ) }
);

export type CreateThreadWithCommentMutationVariablesGQLType = Exact<{
  comment: Scalars['String'];
  isPinned?: Maybe<Scalars['Boolean']>;
  participatingOrganizationIds: Array<Scalars['UUID']> | Scalars['UUID'];
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
}>;


export type CreateThreadWithCommentMutationGQLType = (
  { __typename?: 'Mutation' }
  & { thread: (
    { __typename?: 'Thread' }
    & BaseThreadFragmentFragmentGQLType
  ) }
);

export type ThreadActorFragmentFragmentGQLType = (
  { __typename?: 'ThreadActor' }
  & Pick<ThreadActorGQLType, 'id' | 'firstName' | 'lastName'>
  & { organization: (
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  ) }
);

export type CommentFragmentFragmentGQLType = (
  { __typename?: 'Comment' }
  & Pick<CommentGQLType, 'id' | 'created_at' | 'updated_at' | 'comment'>
  & { author: (
    { __typename?: 'ThreadActor' }
    & ThreadActorFragmentFragmentGQLType
  ) }
);

export type LatestThreadActionLogFragmentFragmentGQLType = (
  { __typename?: 'LatestThreadActionLog' }
  & Pick<LatestThreadActionLogGQLType, 'actionType'>
  & { user: (
    { __typename?: 'ThreadActor' }
    & ThreadActorFragmentFragmentGQLType
  ) }
);

export type BaseThreadFragmentFragmentGQLType = (
  { __typename?: 'Thread' }
  & Pick<ThreadGQLType, 'threadId' | 'domain' | 'domainIdentifier' | 'resolved' | 'pinned' | 'created_at' | 'updated_at'>
  & { latestActionLog?: Maybe<(
    { __typename?: 'LatestThreadActionLog' }
    & LatestThreadActionLogFragmentFragmentGQLType
  )>, participatingOrganizations: Array<(
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  )>, comments: Array<(
    { __typename?: 'Comment' }
    & CommentFragmentFragmentGQLType
  )> }
);

export type GetThreadByIdQueryVariablesGQLType = Exact<{
  threadId: Scalars['UUID'];
}>;


export type GetThreadByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { thread: (
    { __typename?: 'Thread' }
    & BaseThreadFragmentFragmentGQLType
  ) }
);

export type GetThreadCountsByDomainQueryVariablesGQLType = Exact<{
  domain: ThreadDomainGQLType;
  domainIdentifier?: Maybe<Scalars['String']>;
}>;


export type GetThreadCountsByDomainQueryGQLType = (
  { __typename?: 'Query' }
  & { threadCountsByDomain: (
    { __typename?: 'ThreadCounts' }
    & Pick<ThreadCountsGQLType, 'total' | 'pinned' | 'resolved'>
  ) }
);

export type GetThreadsByDomainIdentifierQueryVariablesGQLType = Exact<{
  domain: ThreadDomainGQLType;
  domainIdentifier: Scalars['String'];
}>;


export type GetThreadsByDomainIdentifierQueryGQLType = (
  { __typename?: 'Query' }
  & { threads: Array<(
    { __typename?: 'Thread' }
    & BaseThreadFragmentFragmentGQLType
  )> }
);

export type GetThreadsByDomainMappingQueryVariablesGQLType = Exact<{
  domain: ThreadDomainGQLType;
}>;


export type GetThreadsByDomainMappingQueryGQLType = (
  { __typename?: 'Query' }
  & { threadsByDomainMapping: Array<(
    { __typename?: 'ThreadWithDomainIdentifier' }
    & { thread: (
      { __typename?: 'Thread' }
      & BaseThreadFragmentFragmentGQLType
    ) }
  )> }
);

export type SuccessFinancialCovenantFragmentGQLType = (
  { __typename?: 'SuccessFinancialCovenant' }
  & Pick<SuccessFinancialCovenantGQLType, 'id' | 'creditFacilityId' | 'creditAgreementId' | 'covenantKey' | 'triggerDate' | 'reportingDate' | 'version' | 'result' | 'value' | 'errors' | 'status'>
  & { variables: Array<(
    { __typename?: 'FinancialCovenantVariable' }
    & Pick<FinancialCovenantVariableGQLType, 'name' | 'value'>
  )> }
);

export type GetSuccessFinancialCovenantsByCreditFacilityIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  mode: FinancialCovenantWorkleaseModeGQLType;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetSuccessFinancialCovenantsByCreditFacilityIdQueryGQLType = (
  { __typename?: 'Query' }
  & { successFinCovs: Array<(
    { __typename?: 'SuccessFinancialCovenant' }
    & SuccessFinancialCovenantFragmentGQLType
  )> }
);

export type GetSuccessFinancialCovenantsByKeyQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  mode: FinancialCovenantWorkleaseModeGQLType;
  covenantKey: Scalars['String'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetSuccessFinancialCovenantsByKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { successFinCovsByKey: Array<(
    { __typename?: 'SuccessFinancialCovenant' }
    & SuccessFinancialCovenantFragmentGQLType
  )> }
);

export type ProduceFinancialCovenantWorkleaseMessageMutationVariablesGQLType = Exact<{
  worklease: FinancialCovenantInputWorkleaseGQLType;
}>;


export type ProduceFinancialCovenantWorkleaseMessageMutationGQLType = (
  { __typename?: 'Mutation' }
  & { produceFinancialCovenantWorkleaseMessage: (
    { __typename?: 'ProduceFinancialCovenantWorkleaseResponse' }
    & Pick<ProduceFinancialCovenantWorkleaseResponseGQLType, 'response'>
    & { financialCovenantKeyToIdMap: Array<(
      { __typename?: 'FinancialCovenantKeyToIdMap' }
      & Pick<FinancialCovenantKeyToIdMapGQLType, 'covenantKey' | 'financialCovenantRecordId'>
    )> }
  ) }
);

export type EvaluateDevFinCovWorkleaseMutationVariablesGQLType = Exact<{
  worklease: FinancialCovenantInputWorkleaseGQLType;
}>;


export type EvaluateDevFinCovWorkleaseMutationGQLType = (
  { __typename?: 'Mutation' }
  & { evaluateDevFinCovWorklease: (
    { __typename?: 'EvaluateFinancialCovenantsResponse' }
    & Pick<EvaluateFinancialCovenantsResponseGQLType, 'response'>
  ) }
);

export type GetCreditFacilityQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'isActive' | 'borrowerId' | 'name' | 'type' | 'implementationId' | 'externalFacilityId'>
    & { capitalProviderRepresentativeOrganization?: Maybe<(
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name'>
    )>, loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'name' | 'slug' | 'implementationId'>
    )> }
  ) }
);

export type GetCreditFacilityCapitalProviderRepresentativeQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityCapitalProviderRepresentativeQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & { capitalProviderRepresentativeOrganization?: Maybe<(
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug' | 'name'>
    )> }
  ) }
);

export type GetCreditFacilityBorrowerEntityNameQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityBorrowerEntityNameQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'borrowerEntityName'>
  ) }
);

export type GetCreditFacilityExternalFacilityIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityExternalFacilityIdQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'externalFacilityId'>
  ) }
);

export type GetMultipleExternalFacilityIdsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetMultipleExternalFacilityIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { result: Array<(
    { __typename?: 'ExternalFacilityData' }
    & Pick<ExternalFacilityDataGQLType, 'creditFacilityId' | 'externalFacilityId'>
  )> }
);

export type CheckIfAnyFacilitiesHaveBorrowingBaseQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CheckIfAnyFacilitiesHaveBorrowingBaseQueryGQLType = (
  { __typename?: 'Query' }
  & { hasBorrowingBase: QueryGQLType['checkIfAnyFacilitiesHaveBorrowingBase'] }
);

export type GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name' | 'implementationId'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'name' | 'slug'>
      & { currentCreditFacilities?: Maybe<Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
      )>> }
    )> }
  ) }
);

export type GetCreditFacilityWithCurrentCreditAgreementQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityWithCurrentCreditAgreementQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'isActive' | 'borrowerId' | 'name' | 'type'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'name' | 'slug'>
    )>, currentCreditAgreement?: Maybe<(
      { __typename?: 'CreditAgreementFullArtifact' }
      & Pick<CreditAgreementFullArtifactGQLType, 'id' | 'creditAgreement'>
    )> }
  ) }
);

export type GetCreditFacilitiesQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name' | 'isActive' | 'borrowerId' | 'borrowerEntityName' | 'type' | 'implementationId'>
  )> }
);

export type GetCreditFacilitiesForAssignmentGroupingQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesForAssignmentGroupingQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilitiesForAssignmentGrouping: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name' | 'isActive' | 'borrowerId' | 'borrowerEntityName' | 'type'>
  )> }
);

export type GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilitiesForAssignmentGrouping: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'name'>
    )> }
  )> }
);

export type GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilitiesForAssignmentGrouping: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name' | 'slug' | 'implementationId'>
    & { borrowingBaseMechanicsForLoanProducts: Array<(
      { __typename?: 'BorrowingBaseMechanicsForLoanProduct' }
      & Pick<BorrowingBaseMechanicsForLoanProductGQLType, 'loanProductId' | 'loanProductName' | 'implementationId' | 'baseFields'>
      & { eligibilityCriteria: Array<(
        { __typename?: 'EligibilityCriteria' }
        & Pick<EligibilityCriteriaGQLType, 'eligibilityCriteriaKey' | 'eligibilityConfigDetail'>
      )> }
    )> }
  )> }
);

export type GetCreditFacilityLiabilityAccountsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityLiabilityAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id'>
    & { liabilityAccounts: Array<(
      { __typename?: 'AccountingAccount' }
      & Pick<AccountingAccountGQLType, 'tAccount'>
      & { organization: (
        { __typename?: 'Organization' }
        & Pick<OrganizationGQLType, 'id' | 'name'>
      ) }
    )> }
  ) }
);

export type GetCreditFacilitiesLiabilityAccountsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesLiabilityAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id'>
    & { liabilityAccounts: Array<(
      { __typename?: 'AccountingAccount' }
      & Pick<AccountingAccountGQLType, 'tAccount'>
    )> }
  )> }
);

export type UpdateCreditFacilityIsActiveMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  isActive: Scalars['Boolean'];
}>;


export type UpdateCreditFacilityIsActiveMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateCreditFacilityIsActive: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateCreditFacilityNameMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateCreditFacilityNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateCreditFacilityName: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
  ) }
);

export type GetUploadedDocumentsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetUploadedDocumentsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & { uploadedDocuments: Array<(
      { __typename?: 'CreditFacilityUploadedDocumentRecord' }
      & Pick<CreditFacilityUploadedDocumentRecordGQLType, 'id' | 'documentType' | 'documentName' | 'status' | 'uploadedAt'>
      & { capitalProvider?: Maybe<(
        { __typename?: 'BaseOrganization' }
        & Pick<BaseOrganizationGQLType, 'id' | 'name'>
      )> }
    )> }
  ) }
);

export type GetCreditFacilityKnowledgeBaseDocumentIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityKnowledgeBaseDocumentIdQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'knowledgeBaseDocumentId'>
  ) }
);

export type GetDocumentUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetDocumentUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetDocumentDownloadDestinationQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetDocumentDownloadDestinationQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type UpdateDocumentToLatestPublishedMutationVariablesGQLType = Exact<{
  documentId: Scalars['UUID'];
}>;


export type UpdateDocumentToLatestPublishedMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateDocumentToLatestPublished: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateDocumentNameMutationVariablesGQLType = Exact<{
  documentId: Scalars['UUID'];
  newDocumentName: Scalars['String'];
}>;


export type UpdateDocumentNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateDocumentName: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UploadCreditAgreementToKnowledgeBaseMutationVariablesGQLType = Exact<{
  creditFacilityDocumentId: Scalars['UUID'];
}>;


export type UploadCreditAgreementToKnowledgeBaseMutationGQLType = (
  { __typename?: 'Mutation' }
  & { uploadCreditAgreementToKnowledgeBase: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateCreditFacilityMutationVariablesGQLType = Exact<{
  slug: Scalars['String'];
  name: Scalars['String'];
  implementationId: Scalars['UUID'];
  capitalProviderIds: Array<Scalars['UUID']> | Scalars['UUID'];
  capitalProviderRepresentativeIds: Array<Scalars['UUID']> | Scalars['UUID'];
  type: FacilityTypeGQLType;
}>;


export type CreateCreditFacilityMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createCreditFacility?: Maybe<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id'>
  )> }
);

export type CreditAgreementArtifactFieldsFragmentGQLType = (
  { __typename?: 'CreditAgreementArtifact' }
  & Pick<CreditAgreementArtifactGQLType, 'id' | 'creditAgreement'>
);

export type GetCreditAgreementFullArtifactWipQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditAgreementFullArtifactWipQueryGQLType = (
  { __typename?: 'Query' }
  & { creditAgreementFullArtifactWip: (
    { __typename?: 'CreditAgreementFullArtifactWipResponse' }
    & Pick<CreditAgreementFullArtifactWipResponseGQLType, 'errors'>
    & { wip: (
      { __typename?: 'CreditAgreementFullArtifact' }
      & CreditAgreementFullArtifactFieldsFragmentGQLType
    ) }
  ) }
);

export type GetCreditAgreementArtifactQueryVariablesGQLType = Exact<{
  creditAgreementId: Scalars['UUID'];
}>;


export type GetCreditAgreementArtifactQueryGQLType = (
  { __typename?: 'Query' }
  & { creditAgreementArtifact: (
    { __typename?: 'CreditAgreementArtifact' }
    & CreditAgreementArtifactFieldsFragmentGQLType
  ) }
);

export type GetCurrentCreditAgreementFullArtifactQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCurrentCreditAgreementFullArtifactQueryGQLType = (
  { __typename?: 'Query' }
  & { currentCreditAgreementFullArtifact?: Maybe<(
    { __typename?: 'CreditAgreementFullArtifact' }
    & CreditAgreementFullArtifactFieldsFragmentGQLType
  )> }
);

export type GetCurrentCreditAgreementFullArtifactsForOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCurrentCreditAgreementFullArtifactsForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & { currentCreditAgreementArtifacts: Array<(
      { __typename?: 'CreditAgreementArtifact' }
      & CreditAgreementArtifactFieldsFragmentGQLType
    )> }
  ) }
);

export type GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { currentCreditAgreementFullArtifacts: Array<(
    { __typename?: 'CreditAgreementFullArtifact' }
    & Pick<CreditAgreementFullArtifactGQLType, 'id' | 'creditAgreement' | 'creditFacilityId'>
  )> }
);

export type DoesCreditAgreementWipExistQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type DoesCreditAgreementWipExistQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'doesCreditAgreementWipExist'>
);

export type GetCreditAgreementDownloadUrlQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditAgreementDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getCreditAgreementS3Path?: Maybe<(
    { __typename?: 'CreditAgreementDownload' }
    & Pick<CreditAgreementDownloadGQLType, 'downloadUrl' | 'fileName'>
  )> }
);

export type GetCreditAgreementBorrowerEntityNameQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditAgreementBorrowerEntityNameQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'creditAgreementBorrowerEntityName'>
);

export type GetCreditAgreementEglibilityTestsBaseFieldsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetCreditAgreementEglibilityTestsBaseFieldsQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'creditAgreementEligibilityTestsBaseFields'>
);

export type GetCreditAgreementCapitalProviderOrganizationsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetCreditAgreementCapitalProviderOrganizationsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditAgreementCapitalProviderOrganizations: Array<(
    { __typename?: 'EntityIdAndName' }
    & Pick<EntityIdAndNameGQLType, 'id' | 'name'>
  )> }
);

export type ConvertCreditAgreementFullArtifactIdsQueryVariablesGQLType = Exact<{
  creditAgreementFullArtifact: CreditAgreementFullArtifactInputGQLType;
}>;


export type ConvertCreditAgreementFullArtifactIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { convertCreditAgreementFullArtifactIds: (
    { __typename?: 'CreditAgreementFullArtifact' }
    & Pick<CreditAgreementFullArtifactGQLType, 'creditAgreement'>
  ) }
);

export type EvaluatePortfolioCovenantPostgresQueryQueryVariablesGQLType = Exact<{
  creditAgreementId: Scalars['UUID'];
  postgresQuery: PostgresQueryGQLType;
}>;


export type EvaluatePortfolioCovenantPostgresQueryQueryGQLType = (
  { __typename?: 'Query' }
  & { evaluatePortfolioCovenantPostgresQuery: (
    { __typename?: 'PostgresQueryResultWithWarningsAndInputs' }
    & Pick<PostgresQueryResultWithWarningsAndInputsGQLType, 'warnings'>
    & { result: (
      { __typename?: 'QueryResult' }
      & Pick<QueryResultGQLType, 'name' | 'value'>
    ), inputs?: Maybe<(
      { __typename?: 'PrincipalBalanceDailyAverageInputValues' }
      & Pick<PrincipalBalanceDailyAverageInputValuesGQLType, 'type'>
      & { inputValues: Array<(
        { __typename?: 'ElementByDate' }
        & Pick<ElementByDateGQLType, 'date' | 'value'>
      )> }
    ) | (
      { __typename?: 'TAccountsSumInputValues' }
      & Pick<TAccountsSumInputValuesGQLType, 'type'>
      & { inputValues: Array<(
        { __typename?: 'TAccountsSumInput' }
        & Pick<TAccountsSumInputGQLType, 'tAccount' | 'counterpartySlug' | 'value'>
      )> }
    ) | (
      { __typename?: 'OrgProvidedInputInputValues' }
      & Pick<OrgProvidedInputInputValuesGQLType, 'type'>
      & { inputValues: Array<(
        { __typename?: 'OrgProvidedInputByReportingDate' }
        & Pick<OrgProvidedInputByReportingDateGQLType, 'reportingDate' | 'version' | 'orgProvidedInputValue'>
      )> }
    )> }
  ) }
);

export type GetLoanMechanicsSerializedQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetLoanMechanicsSerializedQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'loanMechanicsSerialized'>
);

export type RemoveCreditAgreementFullArtifactWipMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type RemoveCreditAgreementFullArtifactWipMutationGQLType = (
  { __typename?: 'Mutation' }
  & { removeCreditAgreementFullArtifactWip: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateCreditAgreementFullArtifactWipMutationVariablesGQLType = Exact<{
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactInputGQLType;
}>;


export type UpdateCreditAgreementFullArtifactWipMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateCreditAgreementFullArtifactWip: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateClientCreditAgreementFullArtifactWipMutationVariablesGQLType = Exact<{
  creditAgreementFullArtifactWip: CreditAgreementFullArtifactInputGQLType;
}>;


export type UpdateClientCreditAgreementFullArtifactWipMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateClientCreditAgreementFullArtifactWip: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type EvaluatePortfolioCovenantsMutationVariablesGQLType = Exact<{
  evaluatePortfolioCovenantsRequest: EvaluatePortfolioCovenantsRequestGQLType;
}>;


export type EvaluatePortfolioCovenantsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { evaluatePortfolioCovenants: (
    { __typename?: 'EvaluatePortfolioCovenantsResponse' }
    & Pick<EvaluatePortfolioCovenantsResponseGQLType, 'response' | 'portfolioCovenantIds'>
  ) }
);

export type EvaluateDevPortfolioCovenantWorkleaseMutationVariablesGQLType = Exact<{
  worklease: EvaluatePortfolioCovenantsRequestGQLType;
}>;


export type EvaluateDevPortfolioCovenantWorkleaseMutationGQLType = (
  { __typename?: 'Mutation' }
  & { result: (
    { __typename?: 'EvaluatePortfolioCovenantsDevResponse' }
    & Pick<EvaluatePortfolioCovenantsDevResponseGQLType, 'response'>
  ) }
);

export type CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
}>;


export type CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationGQLType = (
  { __typename?: 'Mutation' }
  & { commitArtifactDocumentAndCreditAgreements: (
    { __typename?: 'SuccessesAndErrors' }
    & Pick<SuccessesAndErrorsGQLType, 'successes' | 'errors'>
  ) }
);

export type GetRecentMeshRunsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']> | Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
}>;


export type GetRecentMeshRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { meshRuns: QueryGQLType['getRecentMeshRuns'] }
);

export type GetLatestMeshRunQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type GetLatestMeshRunQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getLatestMeshRun'>
);

export type GetBorrowerPipelineRunsQueryVariablesGQLType = Exact<{
  borrowerOrganizationId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetBorrowerPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRuns: Array<(
    { __typename?: 'PipelineRun' }
    & Pick<PipelineRunGQLType, 'reportingDate' | 'fileVersion'>
  )> }
);

export type GetPipelineRunsWithArtifactIdsQueryVariablesGQLType = Exact<{
  borrowerOrganizationId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetPipelineRunsWithArtifactIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRunsWithArtifactIds: Array<(
    { __typename?: 'PipelineRunWithArtifactIds' }
    & Pick<PipelineRunWithArtifactIdsGQLType, 'reportingDate' | 'fileVersion' | 'uploadedArtifactIds'>
  )> }
);

export type GetMaybeCompleteMeshRunRecordQueryVariablesGQLType = Exact<{
  meshRunId?: Maybe<Scalars['String']>;
  meshRunParams?: Maybe<MeshRunParamsGQLType>;
}>;


export type GetMaybeCompleteMeshRunRecordQueryGQLType = (
  { __typename?: 'Query' }
  & { maybeCompleteMeshRunRecord: QueryGQLType['getCompleteMeshRunRecordIfAvailable'] }
);

export type GetLatestMeshDocumentsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilitySlugsToHide?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetLatestMeshDocumentsQueryGQLType = (
  { __typename?: 'Query' }
  & { latestMeshDocuments: QueryGQLType['getLatestMeshDocuments'] }
);

export type GetDataPipelineDownloadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetDataPipelineDownloadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetDataPipelineUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetDataPipelineUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type ReUploadLoanTapeMutationVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
  artifactId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  currentArtifactInstanceId: Scalars['UUID'];
}>;


export type ReUploadLoanTapeMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reUploadLoanTape: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type BaseOrganizationFragmentFragmentGQLType = (
  { __typename?: 'BaseOrganization' }
  & Pick<BaseOrganizationGQLType, 'id' | 'name'>
);

export type EventLogActorFragmentFragmentGQLType = (
  { __typename?: 'EventLogActor' }
  & Pick<EventLogActorGQLType, 'id' | 'firstName' | 'lastName'>
  & { organization: (
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_DeliverableThreadCreateEvent_FragmentGQLType = (
  { __typename?: 'DeliverableThreadCreateEvent' }
  & Pick<DeliverableThreadCreateEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_FundingRequestCreatedEvent_FragmentGQLType = (
  { __typename?: 'FundingRequestCreatedEvent' }
  & Pick<FundingRequestCreatedEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_FundingRequestStatusChangeEvent_FragmentGQLType = (
  { __typename?: 'FundingRequestStatusChangeEvent' }
  & Pick<FundingRequestStatusChangeEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_FundingRequestThreadCreateEvent_FragmentGQLType = (
  { __typename?: 'FundingRequestThreadCreateEvent' }
  & Pick<FundingRequestThreadCreateEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_InvoiceCreatedEvent_FragmentGQLType = (
  { __typename?: 'InvoiceCreatedEvent' }
  & Pick<InvoiceCreatedEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_InvoiceThreadCreateEvent_FragmentGQLType = (
  { __typename?: 'InvoiceThreadCreateEvent' }
  & Pick<InvoiceThreadCreateEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_InvoiceUpdatedEvent_FragmentGQLType = (
  { __typename?: 'InvoiceUpdatedEvent' }
  & Pick<InvoiceUpdatedEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_LimitedPartnerCreatedEvent_FragmentGQLType = (
  { __typename?: 'LimitedPartnerCreatedEvent' }
  & Pick<LimitedPartnerCreatedEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_LimitedPartnerMappingMatchEvent_FragmentGQLType = (
  { __typename?: 'LimitedPartnerMappingMatchEvent' }
  & Pick<LimitedPartnerMappingMatchEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_LimitedPartnerMappingUnmatchEvent_FragmentGQLType = (
  { __typename?: 'LimitedPartnerMappingUnmatchEvent' }
  & Pick<LimitedPartnerMappingUnmatchEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_LimitedPartnerThreadCreateEvent_FragmentGQLType = (
  { __typename?: 'LimitedPartnerThreadCreateEvent' }
  & Pick<LimitedPartnerThreadCreateEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_LimitedPartnerUpdatedEvent_FragmentGQLType = (
  { __typename?: 'LimitedPartnerUpdatedEvent' }
  & Pick<LimitedPartnerUpdatedEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_ThreadCreatedEvent_FragmentGQLType = (
  { __typename?: 'ThreadCreatedEvent' }
  & Pick<ThreadCreatedEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

type EventLogBaseEventFragment_ValleyBankLoanAccountThreadCreateEvent_FragmentGQLType = (
  { __typename?: 'ValleyBankLoanAccountThreadCreateEvent' }
  & Pick<ValleyBankLoanAccountThreadCreateEventGQLType, 'eventId' | 'eventLogType' | 'eventMessage' | 'entityId' | 'createdAt' | 'updatedAt'>
  & { actor: (
    { __typename?: 'EventLogActor' }
    & EventLogActorFragmentFragmentGQLType
  ) }
);

export type EventLogBaseEventFragmentFragmentGQLType = EventLogBaseEventFragment_DeliverableThreadCreateEvent_FragmentGQLType | EventLogBaseEventFragment_FundingRequestCreatedEvent_FragmentGQLType | EventLogBaseEventFragment_FundingRequestStatusChangeEvent_FragmentGQLType | EventLogBaseEventFragment_FundingRequestThreadCreateEvent_FragmentGQLType | EventLogBaseEventFragment_InvoiceCreatedEvent_FragmentGQLType | EventLogBaseEventFragment_InvoiceThreadCreateEvent_FragmentGQLType | EventLogBaseEventFragment_InvoiceUpdatedEvent_FragmentGQLType | EventLogBaseEventFragment_LimitedPartnerCreatedEvent_FragmentGQLType | EventLogBaseEventFragment_LimitedPartnerMappingMatchEvent_FragmentGQLType | EventLogBaseEventFragment_LimitedPartnerMappingUnmatchEvent_FragmentGQLType | EventLogBaseEventFragment_LimitedPartnerThreadCreateEvent_FragmentGQLType | EventLogBaseEventFragment_LimitedPartnerUpdatedEvent_FragmentGQLType | EventLogBaseEventFragment_ThreadCreatedEvent_FragmentGQLType | EventLogBaseEventFragment_ValleyBankLoanAccountThreadCreateEvent_FragmentGQLType;

export type CreditFacilityEntityMetaFragmentFragmentGQLType = (
  { __typename?: 'EventLogCreditFacility' }
  & Pick<EventLogCreditFacilityGQLType, 'id' | 'name' | 'externalFacilityId'>
);

export type ThreadCreatedEventSnapshotFragmentFragmentGQLType = (
  { __typename?: 'ThreadCreatedEventSnapshot' }
  & Pick<ThreadCreatedEventSnapshotGQLType, 'id' | 'pinned' | 'resolved'>
);

export type DeliverableEntityMetaFragmentFragmentGQLType = (
  { __typename?: 'DeliverableEntityMeta' }
  & Pick<DeliverableEntityMetaGQLType, 'configName' | 'dueDate' | 'creditFacilityId' | 'creditFacilityName' | 'latestReceiptId'>
  & { deliverableId: DeliverableEntityMetaGQLType['id'] }
);

export type DeliverableThreadCreateEventFragmentFragmentGQLType = (
  { __typename?: 'DeliverableThreadCreateEvent' }
  & { current: (
    { __typename?: 'ThreadCreatedEventSnapshot' }
    & ThreadCreatedEventSnapshotFragmentFragmentGQLType
  ), entityMetadata: (
    { __typename?: 'DeliverableEntityMeta' }
    & DeliverableEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_DeliverableThreadCreateEvent_FragmentGQLType
);

export type FundingRequestEntityMetaFragmentFragmentGQLType = (
  { __typename?: 'FundingRequestEntityMeta' }
  & Pick<FundingRequestEntityMetaGQLType, 'expire' | 'status' | 'creditFacilityId' | 'creditFacilityName' | 'loanNames' | 'externalLoanIds'>
  & { fundingRequestId: FundingRequestEntityMetaGQLType['id'] }
);

export type FundingRequestStatusEventsCommonSnapshotFragmentFragmentGQLType = (
  { __typename?: 'FundingRequestStatusEventsCommonSnapshot' }
  & Pick<FundingRequestStatusEventsCommonSnapshotGQLType, 'status' | 'creditFacilityId' | 'drawRequestTotalAmount' | 'collectionsPaydownTotalAmount' | 'collectionsRecycleTotalAmount' | 'curePaydownTotalAmount'>
);

export type FundingRequestThreadCreateEventFragmentFragmentGQLType = (
  { __typename?: 'FundingRequestThreadCreateEvent' }
  & { current: (
    { __typename?: 'ThreadCreatedEventSnapshot' }
    & ThreadCreatedEventSnapshotFragmentFragmentGQLType
  ), entityMetadata: (
    { __typename?: 'FundingRequestEntityMeta' }
    & FundingRequestEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_FundingRequestThreadCreateEvent_FragmentGQLType
);

export type FundingRequestCreatedEventFragmentFragmentGQLType = (
  { __typename?: 'FundingRequestCreatedEvent' }
  & { entityMetadata: (
    { __typename?: 'FundingRequestEntityMeta' }
    & FundingRequestEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'FundingRequestStatusEventsCommonSnapshot' }
    & FundingRequestStatusEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_FundingRequestCreatedEvent_FragmentGQLType
);

export type FundingRequestStatusChangeEventFragmentFragmentGQLType = (
  { __typename?: 'FundingRequestStatusChangeEvent' }
  & { entityMetadata: (
    { __typename?: 'FundingRequestEntityMeta' }
    & FundingRequestEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'FundingRequestStatusEventsCommonSnapshot' }
    & FundingRequestStatusEventsCommonSnapshotFragmentFragmentGQLType
  ), previous: (
    { __typename?: 'FundingRequestStatusEventsCommonSnapshot' }
    & FundingRequestStatusEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_FundingRequestStatusChangeEvent_FragmentGQLType
);

export type InvoiceEntityMetaFragmentFragmentGQLType = (
  { __typename?: 'InvoiceEntityMeta' }
  & Pick<InvoiceEntityMetaGQLType, 'dueDate' | 'totalAmount'>
  & { invoiceId: InvoiceEntityMetaGQLType['id'], invoiceStatus: InvoiceEntityMetaGQLType['status'] }
);

export type InvoiceStatusEventsCommonSnapshotFragmentFragmentGQLType = (
  { __typename?: 'InvoiceStatusEventsCommonSnapshot' }
  & Pick<InvoiceStatusEventsCommonSnapshotGQLType, 'dueDate' | 'totalAmount'>
  & { invoiceStatus: InvoiceStatusEventsCommonSnapshotGQLType['status'] }
);

export type InvoiceThreadCreateEventFragmentFragmentGQLType = (
  { __typename?: 'InvoiceThreadCreateEvent' }
  & { entityMetadata: (
    { __typename?: 'InvoiceEntityMeta' }
    & InvoiceEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'ThreadCreatedEventSnapshot' }
    & ThreadCreatedEventSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_InvoiceThreadCreateEvent_FragmentGQLType
);

export type InvoiceCreatedEventFragmentFragmentGQLType = (
  { __typename?: 'InvoiceCreatedEvent' }
  & { entityMetadata: (
    { __typename?: 'InvoiceEntityMeta' }
    & InvoiceEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'InvoiceStatusEventsCommonSnapshot' }
    & InvoiceStatusEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_InvoiceCreatedEvent_FragmentGQLType
);

export type InvoiceUpdatedEventFragmentFragmentGQLType = (
  { __typename?: 'InvoiceUpdatedEvent' }
  & { entityMetadata: (
    { __typename?: 'InvoiceEntityMeta' }
    & InvoiceEntityMetaFragmentFragmentGQLType
  ), creditFacility: (
    { __typename?: 'EventLogCreditFacility' }
    & CreditFacilityEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'InvoiceStatusEventsCommonSnapshot' }
    & InvoiceStatusEventsCommonSnapshotFragmentFragmentGQLType
  ), previous: (
    { __typename?: 'InvoiceStatusEventsCommonSnapshot' }
    & InvoiceStatusEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_InvoiceUpdatedEvent_FragmentGQLType
);

export type LimitedPartnerEntityMetaFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerEntityMeta' }
  & Pick<LimitedPartnerEntityMetaGQLType, 'name'>
  & { limitedPartnerId: LimitedPartnerEntityMetaGQLType['id'] }
);

export type LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerStatusEventsCommonSnapshot' }
  & Pick<LimitedPartnerStatusEventsCommonSnapshotGQLType, 'id' | 'name' | 'otherNames' | 'ownerOrganizationId' | 'parentEntityId'>
);

export type LimitedPartnerMatchEventsCommonSnapshotFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerMatchEventsCommonSnapshot' }
  & Pick<LimitedPartnerMatchEventsCommonSnapshotGQLType, 'matchMetadataId' | 'mappingId' | 'limitedPartnerId'>
);

export type LimitedPartnerThreadCreateEventFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerThreadCreateEvent' }
  & { entityMetadata: (
    { __typename?: 'LimitedPartnerEntityMeta' }
    & LimitedPartnerEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'ThreadCreatedEventSnapshot' }
    & ThreadCreatedEventSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_LimitedPartnerThreadCreateEvent_FragmentGQLType
);

export type LimitedPartnerCreatedEventFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerCreatedEvent' }
  & { entityMetadata: (
    { __typename?: 'LimitedPartnerEntityMeta' }
    & LimitedPartnerEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'LimitedPartnerStatusEventsCommonSnapshot' }
    & LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_LimitedPartnerCreatedEvent_FragmentGQLType
);

export type LimitedPartnerUpdatedEventFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerUpdatedEvent' }
  & { entityMetadata: (
    { __typename?: 'LimitedPartnerEntityMeta' }
    & LimitedPartnerEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'LimitedPartnerStatusEventsCommonSnapshot' }
    & LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentGQLType
  ), previous: (
    { __typename?: 'LimitedPartnerStatusEventsCommonSnapshot' }
    & LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_LimitedPartnerUpdatedEvent_FragmentGQLType
);

export type LimitedPartnerMappingMatchEventFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerMappingMatchEvent' }
  & { entityMetadata: (
    { __typename?: 'LimitedPartnerEntityMeta' }
    & LimitedPartnerEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'LimitedPartnerMatchEventsCommonSnapshot' }
    & LimitedPartnerMatchEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_LimitedPartnerMappingMatchEvent_FragmentGQLType
);

export type LimitedPartnerMappingUnmatchEventFragmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerMappingUnmatchEvent' }
  & { entityMetadata: (
    { __typename?: 'LimitedPartnerEntityMeta' }
    & LimitedPartnerEntityMetaFragmentFragmentGQLType
  ), previous: (
    { __typename?: 'LimitedPartnerMatchEventsCommonSnapshot' }
    & LimitedPartnerMatchEventsCommonSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_LimitedPartnerMappingUnmatchEvent_FragmentGQLType
);

export type ValleyBankLoanAccountEntityMetaFragmentFragmentGQLType = (
  { __typename?: 'ValleySBLLoanAccountEntityMeta' }
  & { loanAccountId: ValleySblLoanAccountEntityMetaGQLType['id'] }
);

export type ValleyBankLoanAccountThreadCreateEventFragmentFragmentGQLType = (
  { __typename?: 'ValleyBankLoanAccountThreadCreateEvent' }
  & { entityMetadata: (
    { __typename?: 'ValleySBLLoanAccountEntityMeta' }
    & ValleyBankLoanAccountEntityMetaFragmentFragmentGQLType
  ), current: (
    { __typename?: 'ThreadCreatedEventSnapshot' }
    & ThreadCreatedEventSnapshotFragmentFragmentGQLType
  ) }
  & EventLogBaseEventFragment_ValleyBankLoanAccountThreadCreateEvent_FragmentGQLType
);

export type GetEventLogsQueryVariablesGQLType = Exact<{
  params: EventLogPaginatedFeedParamsGQLType;
}>;


export type GetEventLogsQueryGQLType = (
  { __typename?: 'Query' }
  & { eventLogs: (
    { __typename?: 'EventLogPaginatedFeed' }
    & Pick<EventLogPaginatedFeedGQLType, 'hasMore'>
    & { items: Array<(
      { __typename?: 'ThreadCreatedEvent' }
      & EventLogBaseEventFragment_ThreadCreatedEvent_FragmentGQLType
    ) | (
      { __typename?: 'DeliverableThreadCreateEvent' }
      & EventLogBaseEventFragment_DeliverableThreadCreateEvent_FragmentGQLType
      & DeliverableThreadCreateEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'FundingRequestCreatedEvent' }
      & EventLogBaseEventFragment_FundingRequestCreatedEvent_FragmentGQLType
      & FundingRequestCreatedEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'FundingRequestStatusChangeEvent' }
      & EventLogBaseEventFragment_FundingRequestStatusChangeEvent_FragmentGQLType
      & FundingRequestStatusChangeEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'FundingRequestThreadCreateEvent' }
      & EventLogBaseEventFragment_FundingRequestThreadCreateEvent_FragmentGQLType
      & FundingRequestThreadCreateEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'LimitedPartnerCreatedEvent' }
      & EventLogBaseEventFragment_LimitedPartnerCreatedEvent_FragmentGQLType
      & LimitedPartnerCreatedEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'LimitedPartnerMappingMatchEvent' }
      & EventLogBaseEventFragment_LimitedPartnerMappingMatchEvent_FragmentGQLType
      & LimitedPartnerMappingMatchEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'LimitedPartnerMappingUnmatchEvent' }
      & EventLogBaseEventFragment_LimitedPartnerMappingUnmatchEvent_FragmentGQLType
      & LimitedPartnerMappingUnmatchEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'LimitedPartnerThreadCreateEvent' }
      & EventLogBaseEventFragment_LimitedPartnerThreadCreateEvent_FragmentGQLType
      & LimitedPartnerThreadCreateEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'LimitedPartnerUpdatedEvent' }
      & EventLogBaseEventFragment_LimitedPartnerUpdatedEvent_FragmentGQLType
      & LimitedPartnerUpdatedEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'ValleyBankLoanAccountThreadCreateEvent' }
      & EventLogBaseEventFragment_ValleyBankLoanAccountThreadCreateEvent_FragmentGQLType
      & ValleyBankLoanAccountThreadCreateEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'InvoiceCreatedEvent' }
      & EventLogBaseEventFragment_InvoiceCreatedEvent_FragmentGQLType
      & InvoiceCreatedEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'InvoiceThreadCreateEvent' }
      & EventLogBaseEventFragment_InvoiceThreadCreateEvent_FragmentGQLType
      & InvoiceThreadCreateEventFragmentFragmentGQLType
    ) | (
      { __typename?: 'InvoiceUpdatedEvent' }
      & EventLogBaseEventFragment_InvoiceUpdatedEvent_FragmentGQLType
      & InvoiceUpdatedEventFragmentFragmentGQLType
    )> }
  ) }
);

export type GetActorFiltersQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetActorFiltersQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<UserGQLType, 'id'>
    & { organization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
      & { users: Array<(
        { __typename?: 'User' }
        & Pick<UserGQLType, 'id' | 'firstName' | 'lastName'>
      )> }
    ) }
  )> }
);

export type GetDeliverableFiltersQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetDeliverableFiltersQueryGQLType = (
  { __typename?: 'Query' }
  & { items: Array<(
    { __typename?: 'DeliverableContainer' }
    & Pick<DeliverableContainerGQLType, 'configName' | 'dueDate' | 'creditFacilityId' | 'creditFacilityName' | 'latestReceiptId'>
    & { deliverableId: DeliverableContainerGQLType['id'] }
  )> }
);

export type GetFundingRequestFiltersQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate?: Maybe<Scalars['JSDate']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetFundingRequestFiltersQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { items: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & Pick<FundingRequestWithFullDetailsGQLType, 'expire' | 'status' | 'created_at'>
      & { fundingRequestId: FundingRequestWithFullDetailsGQLType['id'] }
      & { creditFacility: (
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'name'>
      ) }
    )> }
  ) }
);

export type GetLimitedPartnerFiltersQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  queryString?: Maybe<Scalars['String']>;
}>;


export type GetLimitedPartnerFiltersQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartners: Array<(
    { __typename?: 'LimitedPartner' }
    & Pick<LimitedPartnerGQLType, 'id' | 'name' | 'alternateAliases'>
  )> }
);

export type GetInvoiceFiltersQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetInvoiceFiltersQueryGQLType = (
  { __typename?: 'Query' }
  & { invoices: Array<(
    { __typename?: 'Invoice' }
    & Pick<InvoiceGQLType, 'id' | 'dueDate' | 'totalAmount'>
    & { invoiceStatus: InvoiceGQLType['status'] }
  )> }
);

export type ExploPlacementIntegrationFragmentGQLType = (
  { __typename?: 'ExploPlacementIntegration' }
  & Pick<ExploPlacementIntegrationGQLType, 'id' | 'exploPlacement' | 'exploArtifactType' | 'exploEmbedId' | 'organizationId' | 'creditFacilityId'>
);

export type GetOrgExploPlacementIntegrationsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrgExploPlacementIntegrationsQueryGQLType = (
  { __typename?: 'Query' }
  & { integrations: Array<(
    { __typename?: 'ExploPlacementIntegration' }
    & ExploPlacementIntegrationFragmentGQLType
  )> }
);

export type GetExploDashboardsAndReportBuildersQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetExploDashboardsAndReportBuildersQueryGQLType = (
  { __typename?: 'Query' }
  & { response: (
    { __typename?: 'ExploVisualArtifacts' }
    & { dashboards: Array<(
      { __typename?: 'ExploDashboard' }
      & Pick<ExploDashboardGQLType, 'name' | 'embedId'>
    )>, reportBuilders: Array<(
      { __typename?: 'ExploReportBuilder' }
      & Pick<ExploReportBuilderGQLType, 'name' | 'embedId'>
    )> }
  ) }
);

export type GenerateExploApiJwtQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilityId?: Maybe<Scalars['UUID']>;
  exploArtifactType: ExploArtifactTypeGQLType;
  exploPlacement: ExploPlacementOptionsGQLType;
}>;


export type GenerateExploApiJwtQueryGQLType = (
  { __typename?: 'Query' }
  & { tokenResponse: (
    { __typename?: 'ExploTokenResponse' }
    & Pick<ExploTokenResponseGQLType, 'isIntegrationAvailable' | 'jwt' | 'error'>
  ) }
);

export type CreateExploPlacementIntegrationMutationVariablesGQLType = Exact<{
  createParams: CreateExploPlacementIntegrationParamsGQLType;
}>;


export type CreateExploPlacementIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { integration: (
    { __typename?: 'ExploPlacementIntegration' }
    & ExploPlacementIntegrationFragmentGQLType
  ) }
);

export type DeleteExploPlacementIntegrationMutationVariablesGQLType = Exact<{
  exploPlacementIntegrationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
}>;


export type DeleteExploPlacementIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { response: MutationGQLType['deleteExploPlacementIntegration'] }
);

export type UpdateExploPlacementIntegrationMutationVariablesGQLType = Exact<{
  exploPlacementIntegrationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  updateParams: UpdateExploPlacementIntegrationParamsGQLType;
}>;


export type UpdateExploPlacementIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { response: (
    { __typename?: 'ExploPlacementIntegration' }
    & ExploPlacementIntegrationFragmentGQLType
  ) }
);

export type GetDeliverableSubmissionSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetDeliverableSubmissionSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetReportingTemplateUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetReportingTemplateUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetReceivableDocumentationUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetReceivableDocumentationUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetOrgProvidedValuesUploadDestinationQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetOrgProvidedValuesUploadDestinationQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type RailzIntegrationFragmentGQLType = (
  { __typename?: 'RailzIntegration' }
  & Pick<RailzIntegrationGQLType, 'id' | 'railzBusinessId' | 'railzConnectionId' | 'railzServiceName' | 'organizationId' | 'created_at' | 'deletedAt'>
);

export type GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetActiveRailzConnectionsByOrgIdQueryGQLType = (
  { __typename?: 'Query' }
  & { connections: Array<(
    { __typename?: 'RailzIntegration' }
    & RailzIntegrationFragmentGQLType
  )> }
);

export type GetFinancialStatementDataByDateRangeQueryVariablesGQLType = Exact<{
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  financialStatement: FinancialStatementTypeGQLType;
  reportFrequency: ReportFrequencyGQLType;
  creditFacilityId: Scalars['UUID'];
}>;


export type GetFinancialStatementDataByDateRangeQueryGQLType = (
  { __typename?: 'Query' }
  & { getFinancialStatementDataByDateRange?: Maybe<(
    { __typename?: 'FinancialStatementInstanceType' }
    & Pick<FinancialStatementInstanceTypeGQLType, 'currency' | 'finleyStatementKey' | 'reportFrequency'>
    & { metadata: (
      { __typename?: 'FinancialStatementMetadata' }
      & Pick<FinancialStatementMetadataGQLType, 'sortedEndOfPeriodDates'>
    ), adHocCalculations: Array<(
      { __typename?: 'FinancialStatementAdHocCalculations' }
      & Pick<FinancialStatementAdHocCalculationsGQLType, 'adHocKey'>
      & { totals: Array<(
        { __typename?: 'FinancialSectionTotals' }
        & Pick<FinancialSectionTotalsGQLType, 'cadenceDelta' | 'endOfPeriodDate' | 'value'>
      )> }
    )>, sectionKeysToLineItems: Array<(
      { __typename?: 'FinancialStatementSectionKeysToLineItems' }
      & Pick<FinancialStatementSectionKeysToLineItemsGQLType, 'finleySectionKey'>
      & { totals: Array<(
        { __typename?: 'FinancialSectionTotals' }
        & Pick<FinancialSectionTotalsGQLType, 'cadenceDelta' | 'endOfPeriodDate' | 'value'>
      )>, lineItemsToValues: Array<(
        { __typename?: 'FinancialStatementLineItemsToValuesTypes' }
        & Pick<FinancialStatementLineItemsToValuesTypesGQLType, 'lineItemDescription'>
        & { values: Array<(
          { __typename?: 'FinancialStatementValueTypes' }
          & Pick<FinancialStatementValueTypesGQLType, 'cadenceDelta' | 'endOfPeriodDate' | 'value' | 'finStatementLineItemId' | 'finStatementId'>
        )> }
      )> }
    )> }
  )> }
);

export type DoesFinancialsAthenaTableExistQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type DoesFinancialsAthenaTableExistQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'doesFinancialsAthenaTableExist'>
);

export type CreateRailzIntegrationMutationVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  railzBusinessId: Scalars['String'];
  railzConnectionId: Scalars['String'];
  railzServiceName: RailzAccountingServiceNamesGQLType;
}>;


export type CreateRailzIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { connection: (
    { __typename?: 'RailzIntegration' }
    & RailzIntegrationFragmentGQLType
  ) }
);

export type DisconnectRailzIntegrationMutationVariablesGQLType = Exact<{
  railzIntegrationId: Scalars['UUID'];
}>;


export type DisconnectRailzIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { connection: (
    { __typename?: 'RailzIntegration' }
    & RailzIntegrationFragmentGQLType
  ) }
);

export type FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType = Exact<{
  railzIntegrationId: Scalars['UUID'];
  queryParamInputs: RailzFinancialApiQueryParamsGQLType;
}>;


export type FetchAndUploadFinancialDataFromRailzMutationGQLType = (
  { __typename?: 'Mutation' }
  & { dataCount: MutationGQLType['fetchAndUploadFinancialDataFromRailz'] }
);

export type UpdateFinStatementLineItemMutationVariablesGQLType = Exact<{
  updateInput: UpdateFinStatementLineItemInputGQLType;
}>;


export type UpdateFinStatementLineItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateFinStatementLineItem: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateFinStatementLineItemMutationVariablesGQLType = Exact<{
  finStatementLineItem: CreateFinStatementLineItemInputGQLType;
}>;


export type CreateFinStatementLineItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createFinStatementLineItem: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeleteFinStatementLineItemMutationVariablesGQLType = Exact<{
  finStatementLineItemId: Scalars['UUID'];
}>;


export type DeleteFinStatementLineItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteFinStatementLineItem: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeleteFinStatementMutationVariablesGQLType = Exact<{
  finStatementId: Scalars['UUID'];
}>;


export type DeleteFinStatementMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteFinStatement?: Maybe<(
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  )> }
);

export type GetFinancialStatementConfigQueryVariablesGQLType = Exact<{
  organizationSlug: Scalars['String'];
}>;


export type GetFinancialStatementConfigQueryGQLType = (
  { __typename?: 'Query' }
  & { getFinancialStatementConfig?: Maybe<(
    { __typename?: 'FinancialStatementConfigStore' }
    & { financialFormatting: (
      { __typename?: 'FinancialFormatting' }
      & Pick<FinancialFormattingGQLType, 'displayFormat'>
    ) }
  )> }
);

export type GetFinleyAiThreadsQueryVariablesGQLType = Exact<{
  userId: Scalars['UUID'];
}>;


export type GetFinleyAiThreadsQueryGQLType = (
  { __typename?: 'Query' }
  & { getFinleyAiThreads?: Maybe<(
    { __typename?: 'FinleyAiThreads' }
    & Pick<FinleyAiThreadsGQLType, 'threads'>
  )> }
);

export type GetFinleyAiThreadWithPromptResponsesQueryVariablesGQLType = Exact<{
  finleyAiThreadId: Scalars['UUID'];
}>;


export type GetFinleyAiThreadWithPromptResponsesQueryGQLType = (
  { __typename?: 'Query' }
  & { getFinleyAiThreadWithPromptResponses?: Maybe<(
    { __typename?: 'FinleyAiThreadWithPromptReponses' }
    & Pick<FinleyAiThreadWithPromptReponsesGQLType, 'threadWithPromptResponses'>
  )> }
);

export type GetKnowledgeBaseDocumentsByOrganizationIdQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetKnowledgeBaseDocumentsByOrganizationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getKnowledgeBaseDocumentsByOrganizationId: (
    { __typename?: 'FinleyAiKnowledgeBaseDocuments' }
    & { knowledgeBaseDocuments: Array<(
      { __typename?: 'FinleyAiKnowledgeBaseDocument' }
      & Pick<FinleyAiKnowledgeBaseDocumentGQLType, 'id' | 'documentName' | 's3Bucket' | 's3Path' | 'documentType' | 'tags' | 'organizationId' | 'userId' | 'embeddedChunksS3Bucket' | 'embeddedChunksS3Path'>
    )> }
  ) }
);

export type GetFinleyAiPromptResponseQueryVariablesGQLType = Exact<{
  finleyAiPromptResponseId: Scalars['UUID'];
}>;


export type GetFinleyAiPromptResponseQueryGQLType = (
  { __typename?: 'Query' }
  & { getFinleyAiPromptResponse?: Maybe<(
    { __typename?: 'FinleyAiPromptReponse' }
    & Pick<FinleyAiPromptReponseGQLType, 'promptResponse'>
  )> }
);

export type ProduceFinleyAiWorkleaseMutationVariablesGQLType = Exact<{
  params: FinleyAiRequestGQLType;
}>;


export type ProduceFinleyAiWorkleaseMutationGQLType = (
  { __typename?: 'Mutation' }
  & { produceFinleyAiWorklease: (
    { __typename?: 'FinleyAiResponse' }
    & Pick<FinleyAiResponseGQLType, 'thread'>
  ) }
);

export type GetAthenaSqlGenerationSignedUrlsQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetAthenaSqlGenerationSignedUrlsQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedDownloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetKnowledgeBaseDocumentSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetKnowledgeBaseDocumentSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedDownloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryVariablesGQLType = Exact<{
  finleyAiPromptResponseId: Scalars['UUID'];
  numberOfPreviewRows?: Maybe<Scalars['Int']>;
}>;


export type GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getFinleyAiAthenaSqlGenerationPromptResultPreview'>
);

export type GetFinleyAiExtractValuesUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetFinleyAiExtractValuesUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetFinleyAiVirtualSheetUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetFinleyAiVirtualSheetUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetFinleyAiTransformUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetFinleyAiTransformUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetFinleyAiVirtualSheetSignedUrlsQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetFinleyAiVirtualSheetSignedUrlsQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedDownloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetFinleyAiTransformSignedUrlsQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetFinleyAiTransformSignedUrlsQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedDownloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetFinleyAiDocumentAmaUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetFinleyAiDocumentAmaUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type FundingRequestFieldsFragmentGQLType = (
  { __typename?: 'FundingRequest' }
  & Pick<FundingRequestGQLType, 'comment' | 'borrowingBaseReportId' | 'creditFacilityId' | 'curePaydownTotalAmount' | 'drawRequestTotalAmount' | 'collectionsRecycleTotalAmount' | 'collectionsPaydownTotalAmount' | 'id' | 'fundingRequestConstraintId' | 'isCurrent' | 'expire' | 'status' | 'type' | 'created_at' | 'updated_at'>
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
    & { borrower: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug' | 'name'>
    ) }
  ), loans: Array<(
    { __typename?: 'LoanRecord' }
    & Pick<LoanRecordGQLType, 'id' | 'externalLoanId' | 'maturityDate' | 'loanStatus'>
  )> }
);

export type FundingRequestWithFullDetailsFieldsFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & Pick<FundingRequestWithFullDetailsGQLType, 'comment' | 'borrowingBaseReportId' | 'creditFacilityId' | 'curePaydownTotalAmount' | 'drawRequestTotalAmount' | 'collectionsRecycleTotalAmount' | 'collectionsPaydownTotalAmount' | 'id' | 'fundingRequestConstraintId' | 'isCurrent' | 'type' | 'expire' | 'status' | 'reportingDate' | 'created_at' | 'updated_at' | 'submittedAt'>
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name' | 'closingDate'>
    & { borrower: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug' | 'name'>
    ) }
  ), loans: Array<(
    { __typename?: 'LoanRecord' }
    & Pick<LoanRecordGQLType, 'id' | 'externalLoanId' | 'maturityDate' | 'loanStatus'>
  )> }
);

export type FundingRequestWithBorrowingBaseFieldsFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & Pick<FundingRequestWithFullDetailsGQLType, 'comment' | 'borrowingBaseReportId' | 'creditFacilityId' | 'curePaydownTotalAmount' | 'drawRequestTotalAmount' | 'collectionsRecycleTotalAmount' | 'collectionsPaydownTotalAmount' | 'id' | 'fundingRequestConstraintId' | 'isCurrent' | 'expire' | 'status' | 'reportingDate' | 'type' | 'created_at' | 'updated_at'>
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
    & { borrower: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug' | 'name'>
    ) }
  ), borrower: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'name'>
  ), borrowingBaseReport: (
    { __typename?: 'PartialBorrowingBaseReport' }
    & Pick<PartialBorrowingBaseReportGQLType, 'id' | 'borrowingBaseAvailability' | 'cashAdvanceRate' | 'commitmentAmount' | 'effectiveAdvanceRate' | 'currentPrincipalBalance' | 'totalCash' | 'borrowingBaseAmountAssets' | 'totalBorrowingBaseAmount' | 'reportingDate' | 'fileVersion' | 'maxReceivableAdvanceAmount' | 'totalMaxAdvanceAmount' | 'cashReserveAmount' | 'borrowingBaseReserveAmount' | 'borrowingBaseUtilization' | 'weightedAverageReceivableAdvanceRate' | 'totalEligibleBorrowingBaseAccountCash' | 'totalAssets' | 'totalCollectionsAccountCash' | 'borrowingBaseAvailabilityRate' | 'maximumAvailableAmount'>
  ) }
);

export type FundingRequestComponentFieldsFragmentGQLType = (
  { __typename?: 'FundingRequestComponent' }
  & Pick<FundingRequestComponentGQLType, 'id' | 'fundingRequestId' | 'commitmentKey' | 'type' | 'amount' | 'sourceBankAccountId' | 'sourceBankAccountType' | 'destinationBankAccountId' | 'destinationBankAccountType' | 'targetFundingDate' | 'postingDate' | 'borrowerVerifiedTransactionId' | 'borrowerFinancialDataSourceKey' | 'created_at' | 'updated_at'>
);

export type BankAccountWithInstitutionAndDesignationFragmentGQLType = (
  { __typename?: 'BankAccountWithInstitutionAndDesignation' }
  & Pick<BankAccountWithInstitutionAndDesignationGQLType, 'accountNumber' | 'currencyCode' | 'id' | 'name' | 'institutionName' | 'organizationId' | 'isActive' | 'bankInstitutionKey' | 'routingNumber' | 'accountType' | 'creditFacilityId'>
);

export type FundingRequestEventForRenderFragmentGQLType = (
  { __typename?: 'EventWithActor' }
  & Pick<EventWithActorGQLType, 'id' | 'domainKey' | 'actionKey' | 'actorName' | 'targetName' | 'created_at'>
  & { payload: (
    { __typename?: 'FundingRequestPayload' }
    & { fundingRequest: (
      { __typename?: 'FundingRequest' }
      & Pick<FundingRequestGQLType, 'creditFacilityName'>
    ) }
  ) | (
    { __typename?: 'FundingRequestComponentPayload' }
    & { fundingRequestComponent: (
      { __typename?: 'FundingRequestComponent' }
      & Pick<FundingRequestComponentGQLType, 'amount' | 'destinationBankAccountId' | 'type'>
    ) }
  ) | { __typename?: 'DeliverablesPayload' } | { __typename?: 'IngestionPayload' } | { __typename?: 'InsertedDeliverablePayload' } | { __typename?: 'UpdatedDeliverableStatusPayload' } | { __typename?: 'SubmittedDeliverableSubmissionPayload' } | { __typename?: 'VerificationPayload' } }
);

export type VerificationEventForRenderFragmentGQLType = (
  { __typename?: 'EventWithActor' }
  & Pick<EventWithActorGQLType, 'id' | 'domainKey' | 'actionKey' | 'actorName' | 'targetName' | 'created_at'>
  & { payload: { __typename?: 'FundingRequestPayload' } | { __typename?: 'FundingRequestComponentPayload' } | { __typename?: 'DeliverablesPayload' } | { __typename?: 'IngestionPayload' } | { __typename?: 'InsertedDeliverablePayload' } | { __typename?: 'UpdatedDeliverableStatusPayload' } | { __typename?: 'SubmittedDeliverableSubmissionPayload' } | (
    { __typename?: 'VerificationPayload' }
    & Pick<VerificationPayloadGQLType, 'creditFacilityName' | 'verificationReportId'>
  ) }
);

export type FundingRequestComponentTotalAmountsFieldsFragmentGQLType = (
  { __typename?: 'FundingRequestComponentTotalAmounts' }
  & Pick<FundingRequestComponentTotalAmountsGQLType, 'drawRequestTotalAmount' | 'collectionsRecycleTotalAmount' | 'collectionsPaydownTotalAmount' | 'curePaydownTotalAmount'>
);

export type FundingRequestComponentChangesetFieldsFragmentGQLType = (
  { __typename?: 'FundingRequestComponentChangeset' }
  & Pick<FundingRequestComponentChangesetGQLType, 'id' | 'type' | 'amount' | 'sourceBankAccountId' | 'destinationBankAccountId' | 'targetFundingDate'>
);

export type FundingRequestWithBaseDetailsFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
    & { borrower: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug' | 'name'>
    ) }
  ), bankAccounts: Array<(
    { __typename?: 'BankAccountWithInstitutionAndDesignation' }
    & BankAccountWithInstitutionAndDesignationFragmentGQLType
  )>, fundingRequestComponents: Array<(
    { __typename?: 'FundingRequestComponent' }
    & FundingRequestComponentFieldsFragmentGQLType
  )>, fundingRequestEvents: Array<(
    { __typename?: 'EventWithActor' }
    & FundingRequestEventForRenderFragmentGQLType
  )>, fundingRequestReports?: Maybe<Array<(
    { __typename?: 'FundingRequestReport' }
    & Pick<FundingRequestReportGQLType, 'id' | 'reportType' | 's3Path'>
  )>>, verificationReport?: Maybe<(
    { __typename?: 'FundingRequestVerificationReport' }
    & Pick<FundingRequestVerificationReportGQLType, 'verificationReport' | 'verificationReportId' | 'borrowingBaseReportId' | 'approvalReportNote' | 'remediationRequested' | 'remediationNote' | 'artifactDocumentId'>
  )>, verificationReportEvents?: Maybe<Array<(
    { __typename?: 'EventWithActor' }
    & VerificationEventForRenderFragmentGQLType
  )>> }
  & FundingRequestWithFullDetailsFieldsFragmentGQLType
);

export type FundingRequestWithBaseDetailsAndBorrowingBaseFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
    & { borrower: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug' | 'name'>
    ) }
  ), bankAccounts: Array<(
    { __typename?: 'BankAccountWithInstitutionAndDesignation' }
    & BankAccountWithInstitutionAndDesignationFragmentGQLType
  )>, fundingRequestComponents: Array<(
    { __typename?: 'FundingRequestComponent' }
    & FundingRequestComponentFieldsFragmentGQLType
  )>, fundingRequestEvents: Array<(
    { __typename?: 'EventWithActor' }
    & FundingRequestEventForRenderFragmentGQLType
  )>, fundingRequestReports?: Maybe<Array<(
    { __typename?: 'FundingRequestReport' }
    & Pick<FundingRequestReportGQLType, 'id' | 'reportType' | 's3Path' | 'isDomainReport'>
  )>>, verificationReport?: Maybe<(
    { __typename?: 'FundingRequestVerificationReport' }
    & Pick<FundingRequestVerificationReportGQLType, 'verificationReport' | 'verificationReportId' | 'borrowingBaseReportId' | 'approvalReportNote' | 'remediationRequested' | 'remediationNote' | 'artifactDocumentId'>
  )>, verificationReportEvents?: Maybe<Array<(
    { __typename?: 'EventWithActor' }
    & VerificationEventForRenderFragmentGQLType
  )>> }
  & FundingRequestWithBorrowingBaseFieldsFragmentGQLType
);

export type CanFundingRequestBeCreatedQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type CanFundingRequestBeCreatedQueryGQLType = (
  { __typename?: 'Query' }
  & { canFundingRequestBeCreated: (
    { __typename?: 'FundingRequestCanBeCreatedResponse' }
    & Pick<FundingRequestCanBeCreatedResponseGQLType, 'canCreate' | 'errorCode'>
  ) }
);

export type AllocateFundingRequestTargetAmountsMutationVariablesGQLType = Exact<{
  fundingRequestTotalAmountsChangeset: UpdateFundingRequestTotalAmountsGQLType;
}>;


export type AllocateFundingRequestTargetAmountsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { allocateFundingRequestTargetAmounts: (
    { __typename?: 'FundingRequestAllocations' }
    & { fundingRequestComponentTotalAmounts: (
      { __typename?: 'FundingRequestComponentTotalAmounts' }
      & FundingRequestComponentTotalAmountsFieldsFragmentGQLType
    ), fundingRequestComponents: Array<(
      { __typename?: 'FundingRequestComponentChangeset' }
      & FundingRequestComponentChangesetFieldsFragmentGQLType
    )> }
  ) }
);

export type FundingRequestConstraintFieldsFragmentGQLType = (
  { __typename?: 'FundingRequestConstraint' }
  & Pick<FundingRequestConstraintGQLType, 'borrowingBaseReportId' | 'creditAgreementId' | 'collectionsRecycleMax' | 'collectionsPaydownMax' | 'drawRequestIncrementAmount' | 'id' | 'isCollectionsRecycleEnabled' | 'isStopDrawEnforced' | 'isVoluntaryPaydownAllowed' | 'maxFundingRequestAmount' | 'maxDrawRequestAmount' | 'maxCollectionsRecycleAmount' | 'minimumDrawRequestAmount' | 'minimumRepaymentAmount' | 'preAdvanceCashContributionToBorrowingBase' | 'targetCurePaydownAmount' | 'targetDrawRequestAmount' | 'targetCollectionsRecycleAmount' | 'targetCollectionsPaydownAmount' | 'collectionsRecycleContributesToBorrowingBase'>
);

export type FundingRequestWithFullDetailsFragmentGQLType = (
  { __typename?: 'FundingRequestWithFullDetails' }
  & Pick<FundingRequestWithFullDetailsGQLType, 'adjustedPrincipalBalance'>
  & { bankAccounts: Array<(
    { __typename?: 'BankAccountWithInstitutionAndDesignation' }
    & BankAccountWithInstitutionAndDesignationFragmentGQLType
  )>, fundingRequestComponents: Array<(
    { __typename?: 'FundingRequestComponent' }
    & FundingRequestComponentFieldsFragmentGQLType
  )>, fundingRequestEvents: Array<(
    { __typename?: 'EventWithActor' }
    & FundingRequestEventForRenderFragmentGQLType
  )>, fundingRequestReports?: Maybe<Array<(
    { __typename?: 'FundingRequestReport' }
    & Pick<FundingRequestReportGQLType, 'id' | 'reportType' | 's3Path' | 'isDomainReport'>
  )>>, borrowingBaseReport: (
    { __typename?: 'PartialBorrowingBaseReport' }
    & Pick<PartialBorrowingBaseReportGQLType, 'id' | 'cashAdvanceRate' | 'commitmentAmount' | 'effectiveAdvanceRate' | 'currentPrincipalBalance' | 'totalCash' | 'borrowingBaseAmountAssets' | 'totalBorrowingBaseAmount' | 'reportingDate' | 'fileVersion' | 'maxReceivableAdvanceAmount' | 'totalMaxAdvanceAmount' | 'cashReserveAmount' | 'borrowingBaseReserveAmount' | 'borrowingBaseUtilization' | 'weightedAverageReceivableAdvanceRate' | 'totalEligibleBorrowingBaseAccountCash' | 'totalAssets' | 'borrowingBaseAvailability' | 'totalCollectionsAccountCash' | 'totalCashBorrowingBaseAmount' | 'borrowingBaseAvailabilityRate' | 'maximumAvailableAmount'>
  ), borrower: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'name'>
  ) }
  & FundingRequestWithFullDetailsFieldsFragmentGQLType
);

export type GetMaximumDrawRequestFrequencyMetadataQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
}>;


export type GetMaximumDrawRequestFrequencyMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { maximumDrawRequestFrequencyMetadata: (
    { __typename?: 'MaximumDrawRequestFrequencyMetadata' }
    & Pick<MaximumDrawRequestFrequencyMetadataGQLType, 'limitReached' | 'message'>
  ) }
);

export type CanServicingReportPreviewBeCreatedQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type CanServicingReportPreviewBeCreatedQueryGQLType = (
  { __typename?: 'Query' }
  & { canServicingReportPreviewBeCreated: (
    { __typename?: 'FundingRequestCanBeCreatedResponse' }
    & Pick<FundingRequestCanBeCreatedResponseGQLType, 'canCreate' | 'errorCode'>
  ) }
);

export type GetFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestWithFullDetails: (
    { __typename?: 'FundingRequestWithFullDetails' }
    & { fundingRequestReports?: Maybe<Array<(
      { __typename?: 'FundingRequestReport' }
      & Pick<FundingRequestReportGQLType, 'id' | 'reportType' | 's3Path' | 'isDomainReport'>
    )>> }
    & FundingRequestWithFullDetailsFieldsFragmentGQLType
  ) }
);

export type GetFundingRequestWithBaseDetailsQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetFundingRequestWithBaseDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestWithFullDetails: (
    { __typename?: 'FundingRequestWithFullDetails' }
    & FundingRequestWithBaseDetailsFragmentGQLType
  ) }
);

export type GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestWithFullDetails: (
    { __typename?: 'FundingRequestWithFullDetails' }
    & FundingRequestWithBaseDetailsAndBorrowingBaseFragmentGQLType
  ) }
);

export type GetFundingRequestsWithBaseDetailsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  statuses?: Maybe<Array<FundingRequestStatusEnumGQLType> | FundingRequestStatusEnumGQLType>;
}>;


export type GetFundingRequestsWithBaseDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & FundingRequestWithFullDetailsFieldsFragmentGQLType
    )> }
  ) }
);

export type GetFundingRequestsWithEventDetailsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  statuses?: Maybe<Array<FundingRequestStatusEnumGQLType> | FundingRequestStatusEnumGQLType>;
}>;


export type GetFundingRequestsWithEventDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & { fundingRequestEvents: Array<(
        { __typename?: 'EventWithActor' }
        & FundingRequestEventForRenderFragmentGQLType
      )> }
      & FundingRequestWithBorrowingBaseFieldsFragmentGQLType
    )> }
  ) }
);

export type GetFundingRequestsForCreditFacilitiesQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetFundingRequestsForCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & FundingRequestWithBaseDetailsFragmentGQLType
    )> }
  ) }
);

export type GetFundingRequestConstraintQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetFundingRequestConstraintQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestConstraint: (
    { __typename?: 'FundingRequestConstraint' }
    & FundingRequestConstraintFieldsFragmentGQLType
  ) }
);

export type GetCurrentFundingRequestConstraintForCreditFacilityQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCurrentFundingRequestConstraintForCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { currentFundingRequestConstraint?: Maybe<(
    { __typename?: 'FundingRequestConstraint' }
    & FundingRequestConstraintFieldsFragmentGQLType
  )> }
);

export type GetFundingRequestWithFullDetailsAndConstraintQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetFundingRequestWithFullDetailsAndConstraintQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestConstraint: (
    { __typename?: 'FundingRequestConstraint' }
    & Pick<FundingRequestConstraintGQLType, 'borrowingBaseReportId' | 'collectionsRecycleContributesToBorrowingBase' | 'collectionsRecycleMax' | 'collectionsPaydownMax' | 'creditAgreementId' | 'drawRequestContributesToBorrowingBase' | 'drawRequestIncrementAmount' | 'id' | 'isCollectionsRecycleEnabled' | 'isStopDrawEnforced' | 'isVoluntaryPaydownAllowed' | 'maxFundingRequestAmount' | 'maxDrawRequestAmount' | 'maxCollectionsRecycleAmount' | 'minimumDrawRequestAmount' | 'minimumRepaymentAmount' | 'preAdvanceCashContributionToBorrowingBase' | 'targetCurePaydownAmount' | 'targetDrawRequestAmount' | 'targetCollectionsRecycleAmount' | 'targetCollectionsPaydownAmount'>
  ), fundingRequestWithFullDetails: (
    { __typename?: 'FundingRequestWithFullDetails' }
    & FundingRequestWithFullDetailsFragmentGQLType
  ) }
);

export type GetFundingRequestsWithComponentDetailsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  statuses?: Maybe<Array<FundingRequestStatusEnumGQLType> | FundingRequestStatusEnumGQLType>;
}>;


export type GetFundingRequestsWithComponentDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & { fundingRequestComponents: Array<(
        { __typename?: 'FundingRequestComponent' }
        & FundingRequestComponentFieldsFragmentGQLType
      )>, fundingRequestEvents: Array<(
        { __typename?: 'EventWithActor' }
        & FundingRequestEventForRenderFragmentGQLType
      )>, bankAccounts: Array<(
        { __typename?: 'BankAccountWithInstitutionAndDesignation' }
        & BankAccountWithInstitutionAndDesignationFragmentGQLType
      )> }
      & FundingRequestWithFullDetailsFieldsFragmentGQLType
    )> }
  ) }
);

export type GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
}>;


export type GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequests: (
    { __typename?: 'FundingRequestsConnection' }
    & { nodes: Array<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & Pick<FundingRequestWithFullDetailsGQLType, 'id' | 'creditFacilityId' | 'drawRequestTotalAmount' | 'collectionsRecycleTotalAmount' | 'collectionsPaydownTotalAmount' | 'curePaydownTotalAmount' | 'created_at' | 'reportingDate'>
    )> }
  ) }
);

export type GetOrCreateFundingRequestTemplateQueryVariablesGQLType = Exact<{
  mode: FundingRequestTemplateModeGQLType;
  creditFacilityId: Scalars['UUID'];
  fundingRequestId?: Maybe<Scalars['UUID']>;
  loanId?: Maybe<Scalars['UUID']>;
  fundingRequestIdToDuplicate?: Maybe<Scalars['UUID']>;
}>;


export type GetOrCreateFundingRequestTemplateQueryGQLType = (
  { __typename?: 'Query' }
  & { template: (
    { __typename?: 'FundingRequestTemplateResponse' }
    & Pick<FundingRequestTemplateResponseGQLType, 'creditAgreementId' | 'creditFacilityId' | 'fundingMechanicsV2Serialized'>
    & { reportingMechanics: (
      { __typename?: 'ReportingMechanics' }
      & { fundingNotices: Array<(
        { __typename?: 'FundingNotice' }
        & Pick<FundingNoticeGQLType, 'reportName' | 'fundingRequestComponents'>
      )> }
    ), fundingMechanics?: Maybe<(
      { __typename?: 'FundingMechanics' }
      & Pick<FundingMechanicsGQLType, 'fundingRequestId'>
      & { commitments: Array<(
        { __typename?: 'FundingMechanicsCommitment' }
        & Pick<FundingMechanicsCommitmentGQLType, 'key' | 'label' | 'amount' | 'attachmentRate'>
        & { shares: Array<(
          { __typename?: 'FundingMechanicsCommitmentShare' }
          & Pick<FundingMechanicsCommitmentShareGQLType, 'lenderId' | 'lenderName' | 'amount' | 'applicableMargin' | 'fundingRequestComponentId'>
          & { routing: (
            { __typename?: 'FundingMechanicsRouting' }
            & { source: (
              { __typename?: 'FundingMechanicsCommitmentShareRoutingDetails' }
              & Pick<FundingMechanicsCommitmentShareRoutingDetailsGQLType, 'bankAccountId' | 'label'>
            ), destination: (
              { __typename?: 'FundingMechanicsCommitmentShareRoutingDetails' }
              & Pick<FundingMechanicsCommitmentShareRoutingDetailsGQLType, 'bankAccountId' | 'label'>
            ) }
          ) }
        )> }
      )>, draw: (
        { __typename?: 'FundingMechanicsDrawConfiguration' }
        & Pick<FundingMechanicsDrawConfigurationGQLType, 'targetFundingDate'>
        & { allocation?: Maybe<(
          { __typename?: 'FundingMechanicsDrawConfigurationAllocation' }
          & Pick<FundingMechanicsDrawConfigurationAllocationGQLType, 'strategy' | 'strict'>
        )>, constraints: Array<(
          { __typename?: 'FundingMechanicsNonConditionConstraint' }
          & Pick<FundingMechanicsNonConditionConstraintGQLType, 'type' | 'label' | 'value'>
        ) | (
          { __typename?: 'FundingMechanicsConditionConstraint' }
          & Pick<FundingMechanicsConditionConstraintGQLType, 'type' | 'label' | 'value' | 'condition'>
        )>, pricingOptions: Array<(
          { __typename?: 'PricingOption' }
          & Pick<PricingOptionGQLType, 'key' | 'name' | 'lookbackDays'>
          & { invoiceMechanics: (
            { __typename?: 'InvoiceMechanics' }
            & { single: Array<(
              { __typename?: 'InvoiceMechanicsOption' }
              & Pick<InvoiceMechanicsOptionGQLType, 'key' | 'name'>
            )>, recurring: Array<(
              { __typename?: 'InvoiceMechanicsOption' }
              & Pick<InvoiceMechanicsOptionGQLType, 'key' | 'name'>
            )> }
          ) }
        )> }
      ), recycles: Array<(
        { __typename?: 'FundingMechanicsRecycleConfigurationV2' }
        & Pick<FundingMechanicsRecycleConfigurationV2GQLType, 'fundingRequestComponentId' | 'targetFundingDate'>
        & { constraints?: Maybe<Array<(
          { __typename?: 'FundingMechanicsNonConditionConstraint' }
          & Pick<FundingMechanicsNonConditionConstraintGQLType, 'type' | 'label' | 'value'>
        ) | (
          { __typename?: 'FundingMechanicsConditionConstraint' }
          & Pick<FundingMechanicsConditionConstraintGQLType, 'type' | 'label' | 'value' | 'condition'>
        )>>, routing?: Maybe<(
          { __typename?: 'FundingMechanicsRouting' }
          & { source: (
            { __typename?: 'FundingMechanicsCommitmentShareRoutingDetails' }
            & Pick<FundingMechanicsCommitmentShareRoutingDetailsGQLType, 'bankAccountId' | 'label'>
          ), destination: (
            { __typename?: 'FundingMechanicsCommitmentShareRoutingDetails' }
            & Pick<FundingMechanicsCommitmentShareRoutingDetailsGQLType, 'bankAccountId' | 'label'>
          ) }
        )> }
      )>, requestRoutings: Array<(
        { __typename?: 'FundingMechanicsRequestRouting' }
        & Pick<FundingMechanicsRequestRoutingGQLType, 'type'>
        & { source: (
          { __typename?: 'FundingMechanicsRoutingBankAccountWithOwner' }
          & Pick<FundingMechanicsRoutingBankAccountWithOwnerGQLType, 'accountId' | 'accountName' | 'accountType' | 'organizationId'>
        ), destination: (
          { __typename?: 'FundingMechanicsRoutingBankAccountWithOwner' }
          & Pick<FundingMechanicsRoutingBankAccountWithOwnerGQLType, 'accountId' | 'accountName' | 'accountType' | 'organizationId'>
        ) }
      )> }
    )>, borrowingBaseReport: (
      { __typename?: 'PartialBorrowingBaseReport' }
      & Pick<PartialBorrowingBaseReportGQLType, 'id' | 'borrowingBaseAvailability' | 'cashAdvanceRate' | 'commitmentAmount' | 'effectiveAdvanceRate' | 'currentPrincipalBalance' | 'totalCash' | 'borrowingBaseAmountAssets' | 'totalBorrowingBaseAmount' | 'reportingDate' | 'fileVersion' | 'maxReceivableAdvanceAmount' | 'totalMaxAdvanceAmount' | 'cashReserveAmount' | 'borrowingBaseReserveAmount' | 'borrowingBaseUtilization' | 'weightedAverageReceivableAdvanceRate' | 'totalEligibleBorrowingBaseAccountCash' | 'totalAssets' | 'totalCollectionsAccountCash' | 'borrowingBaseAvailabilityRate' | 'maximumAvailableAmount' | 'totalCashBorrowingBaseAmount' | 'assignedEligibleExposureSinceLastApprovedFundingRequest'>
    ), cashBalances: Array<(
      { __typename?: 'BankAccountCashBalance' }
      & BankAccountCashBalanceFragmentGQLType
    )>, outstandingBalances: Array<(
      { __typename?: 'OutstandingBalance' }
      & Pick<OutstandingBalanceGQLType, 'organizationId' | 'amount'>
    )>, loanBalances: Array<(
      { __typename?: 'LoanBalance' }
      & Pick<LoanBalanceGQLType, 'loanId' | 'commitmentKey' | 'amount'>
    )>, pendingRequests: Array<(
      { __typename?: 'FundingRequestComponent' }
      & FundingRequestComponentFieldsFragmentGQLType
    )>, currentFundingRequestComponents: Array<(
      { __typename?: 'FundingRequestComponent' }
      & FundingRequestComponentFieldsFragmentGQLType
    )>, borrowingBaseReportMetadataForLastApprovedFundingRequest?: Maybe<(
      { __typename?: 'BorrowingBaseReportMetadata' }
      & Pick<BorrowingBaseReportMetadataGQLType, 'reportingDate' | 'fileVersion'>
    )>, loans?: Maybe<Array<(
      { __typename?: 'ResolvedLoan' }
      & ResolvedLoanFragmentGQLType
    )>>, fundingRequestToDuplicate?: Maybe<(
      { __typename?: 'FundingRequestWithFullDetails' }
      & Pick<FundingRequestWithFullDetailsGQLType, 'id' | 'creditFacilityId' | 'borrowingBaseReportId' | 'drawRequestTotalAmount' | 'collectionsRecycleTotalAmount' | 'collectionsPaydownTotalAmount' | 'curePaydownTotalAmount' | 'status' | 'type' | 'expire' | 'reportingDate' | 'created_at' | 'updated_at'>
      & { fundingRequestComponents: Array<(
        { __typename?: 'FundingRequestComponent' }
        & FundingRequestComponentFieldsFragmentGQLType
      )>, resolvedLoans: Array<(
        { __typename?: 'ResolvedLoan' }
        & ResolvedLoanFragmentGQLType
      )> }
    )> }
  ) }
);

export type GetCurrentFundingRequestQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCurrentFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { currentFundingRequest?: Maybe<(
    { __typename?: 'FundingRequest' }
    & FundingRequestFieldsFragmentGQLType
  )> }
);

export type GetOrganizationImplementationsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationImplementationsQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & { implementations: Array<(
      { __typename?: 'Implementation' }
      & Pick<ImplementationGQLType, 'id' | 'name'>
      & { creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'name'>
      )> }
    )> }
  ) }
);

export type GetOrganizationImplementationsDetailsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationImplementationsDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & { implementations: Array<(
      { __typename?: 'Implementation' }
      & Pick<ImplementationGQLType, 'id' | 'name' | 'slug'>
      & { ownerOrganization: (
        { __typename?: 'BaseOrganization' }
        & Pick<BaseOrganizationGQLType, 'id' | 'name' | 'slug'>
      ), borrowerOrganization: (
        { __typename?: 'Organization' }
        & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
      ), loanProducts: Array<(
        { __typename?: 'LoanProduct' }
        & Pick<LoanProductGQLType, 'id' | 'name' | 'slug'>
      )>, creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'name' | 'slug' | 'isActive' | 'borrowerEntityName' | 'type'>
      )> }
    )> }
  ) }
);

export type InvoiceItemFragmentGQLType = (
  { __typename?: 'InvoiceItem' }
  & Pick<InvoiceItemGQLType, 'id' | 'invoiceId' | 'accountingAccountId' | 'amount' | 'status' | 'capitalizedLoanId' | 'finleyAccruedAmount' | 'created_at' | 'updated_at'>
  & { accountingAccount: (
    { __typename?: 'TAccount' }
    & Pick<TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
  ) }
);

export type InvoiceComponentWithInvoiceItemsFragmentGQLType = (
  { __typename?: 'InvoiceComponentWithInvoiceItems' }
  & { invoiceComponent: (
    { __typename?: 'InvoiceComponent' }
    & Pick<InvoiceComponentGQLType, 'id' | 'invoiceId' | 'finleyLoanId' | 'invoiceComponentType' | 'totalAmount' | 'accrualStartDate' | 'accrualEndDate' | 'created_at' | 'updated_at'>
  ), invoiceItems: Array<(
    { __typename?: 'InvoiceItem' }
    & InvoiceItemFragmentGQLType
  )> }
);

export type InvoiceReportFragmentGQLType = (
  { __typename?: 'InvoiceReport' }
  & Pick<InvoiceReportGQLType, 'id' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview' | 'capitalProviderId' | 'capitalProviderName' | 'invoiceId' | 'paymentInKindItemId'>
);

export type InvoiceDisbursementItemDifferenceFragmentGQLType = (
  { __typename?: 'InvoiceDisbursementItemDifference' }
  & Pick<InvoiceDisbursementItemDifferenceGQLType, 'capitalProviderId' | 'capitalProviderName' | 'tAccountType' | 'inputAmount' | 'finleyAmount' | 'difference' | 'inputProRataShare' | 'finleyProRataShare'>
);

export type InvoiceCalculationComparisonFragmentGQLType = (
  { __typename?: 'InvoiceCalculationComparison' }
  & Pick<InvoiceCalculationComparisonGQLType, 'loanId' | 'loanName' | 'externalLoanId'>
  & { invoiceComponentDifferences: Array<(
    { __typename?: 'InvoiceComponentDifference' }
    & Pick<InvoiceComponentDifferenceGQLType, 'inputAmount' | 'finleyAmount' | 'difference'>
  )>, invoiceDisbursementItemDifferences: (
    { __typename?: 'InvoiceDisbursementItemDifferences' }
    & { interest: Array<(
      { __typename?: 'InvoiceDisbursementItemDifference' }
      & InvoiceDisbursementItemDifferenceFragmentGQLType
    )>, principal: Array<(
      { __typename?: 'InvoiceDisbursementItemDifference' }
      & InvoiceDisbursementItemDifferenceFragmentGQLType
    )> }
  ) }
);

export type InvoiceFragmentGQLType = (
  { __typename?: 'Invoice' }
  & Pick<InvoiceGQLType, 'id' | 'creditFacilityId' | 'originatingInvoiceId' | 'paymentSourceOrganizationId' | 'paymentDestinationOrganizationId' | 'sourceBankAccountId' | 'destinationBankAccountId' | 'status' | 'totalAmount' | 'autoSettle' | 'memo' | 'createdByType' | 'targetInvoiceDate' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at'>
  & { invoiceComponentsWithInvoiceItems: Array<(
    { __typename?: 'InvoiceComponentWithInvoiceItems' }
    & InvoiceComponentWithInvoiceItemsFragmentGQLType
  )>, creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name' | 'externalFacilityId'>
  ), paymentSourceOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<EntityIdAndNameGQLType, 'id' | 'name'>
  ), paymentDestinationOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<EntityIdAndNameGQLType, 'id' | 'name'>
  ), destinationBankAccount?: Maybe<(
    { __typename?: 'BankAccountWithInstitutionAndOwner' }
    & BankAccountWithInstitutionAndOwnerFragmentGQLType
  )>, invoiceReports?: Maybe<Array<(
    { __typename?: 'InvoiceReport' }
    & Pick<InvoiceReportGQLType, 'id' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview' | 'capitalProviderId' | 'capitalProviderName' | 'invoiceId' | 'paymentInKindItemId'>
  )>>, invoiceCalculationComparisons: Array<(
    { __typename?: 'InvoiceCalculationComparison' }
    & InvoiceCalculationComparisonFragmentGQLType
  )> }
);

export type InvoiceSummaryFragmentGQLType = (
  { __typename?: 'Invoice' }
  & Pick<InvoiceGQLType, 'id' | 'creditFacilityId' | 'originatingInvoiceId' | 'paymentSourceOrganizationId' | 'paymentDestinationOrganizationId' | 'sourceBankAccountId' | 'destinationBankAccountId' | 'status' | 'totalAmount' | 'autoSettle' | 'memo' | 'createdByType' | 'targetInvoiceDate' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at'>
  & { invoiceComponentsWithInvoiceItems: Array<(
    { __typename?: 'InvoiceComponentWithInvoiceItems' }
    & InvoiceComponentWithInvoiceItemsFragmentGQLType
  )>, creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name' | 'externalFacilityId'>
  ), invoiceReports?: Maybe<Array<(
    { __typename?: 'InvoiceReport' }
    & InvoiceReportFragmentGQLType
  )>>, invoiceCalculationComparisons: Array<(
    { __typename?: 'InvoiceCalculationComparison' }
    & InvoiceCalculationComparisonFragmentGQLType
  )> }
);

export type InvoiceListItemFragmentGQLType = (
  { __typename?: 'Invoice' }
  & Pick<InvoiceGQLType, 'id' | 'creditFacilityId' | 'originatingInvoiceId' | 'paymentSourceOrganizationId' | 'paymentDestinationOrganizationId' | 'status' | 'totalAmount' | 'autoSettle' | 'memo' | 'createdByType' | 'targetInvoiceDate' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at'>
  & { invoiceComponentsWithInvoiceItems: Array<(
    { __typename?: 'InvoiceComponentWithInvoiceItems' }
    & { invoiceComponent: (
      { __typename?: 'InvoiceComponent' }
      & Pick<InvoiceComponentGQLType, 'id' | 'invoiceId' | 'finleyLoanId' | 'invoiceComponentType' | 'totalAmount' | 'accrualStartDate' | 'accrualEndDate' | 'created_at' | 'updated_at'>
    ), invoiceItems: Array<(
      { __typename?: 'InvoiceItem' }
      & Pick<InvoiceItemGQLType, 'id' | 'invoiceId' | 'accountingAccountId' | 'amount' | 'status' | 'capitalizedLoanId' | 'finleyAccruedAmount' | 'created_at' | 'updated_at'>
      & { accountingAccount: (
        { __typename?: 'TAccount' }
        & Pick<TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
      ) }
    )> }
  )>, creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
  ) }
);

export type InvoiceDisbursementItemFragmentGQLType = (
  { __typename?: 'InvoiceDisbursementItem' }
  & Pick<InvoiceDisbursementItemGQLType, 'id' | 'invoiceDisbursementId' | 'accountingAccountId' | 'accountingTransactionId' | 'amount' | 'serviceFeeAmount' | 'postServiceFeeTotalAmount' | 'created_at' | 'updated_at'>
  & { accountingAccount: (
    { __typename?: 'TAccount' }
    & Pick<TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
  ) }
);

export type InvoiceDisbursementFragmentGQLType = (
  { __typename?: 'InvoiceDisbursement' }
  & Pick<InvoiceDisbursementGQLType, 'id' | 'invoiceId' | 'invoiceComponentId' | 'capitalProviderOrganizationId' | 'totalAmount' | 'autoSettle' | 'status' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at' | 'capitalProviderProRata'>
  & { invoiceDisbursementItems: Array<(
    { __typename?: 'InvoiceDisbursementItem' }
    & InvoiceDisbursementItemFragmentGQLType
  )>, capitalProviderOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<EntityIdAndNameGQLType, 'id' | 'name'>
  ), serviceFeeTotals?: Maybe<(
    { __typename?: 'InvoiceDisbursementServiceFeeTotals' }
    & Pick<InvoiceDisbursementServiceFeeTotalsGQLType, 'serviceFeeAmount' | 'postServiceFeeTotalAmount'>
  )> }
);

export type InvoicePaymentInKindItemFragmentGQLType = (
  { __typename?: 'InvoicePaymentInKindItem' }
  & Pick<InvoicePaymentInKindItemGQLType, 'id' | 'invoiceId' | 'invoiceItemId' | 'capitalizedLenderShareId' | 'capitalizedLoanId' | 'totalAmount' | 'serviceFeeAmount' | 'postServiceFeeTotalAmount' | 'status' | 'dueDate' | 'notifiedDate' | 'created_at' | 'updated_at' | 'capitalProviderProRata'>
  & { capitalProviderOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<EntityIdAndNameGQLType, 'id' | 'name'>
  ) }
);

export type InvoiceConsolidatedDisbursementFragmentGQLType = (
  { __typename?: 'InvoiceConsolidatedDisbursement' }
  & Pick<InvoiceConsolidatedDisbursementGQLType, 'id' | 'invoiceId' | 'capitalProviderOrganizationId' | 'totalCashDisbursementAmount' | 'totalCashServiceFeeAmount' | 'totalPostServiceFeeCashDisbursementAmount' | 'totalInterestCapitalizationAmount' | 'totalInterestCapitalizationServiceFeeAmount' | 'totalPostServiceFeeInterestCapitalizationAmount' | 'status' | 'paymentDate' | 'created_at' | 'updated_at' | 'capitalProviderProRataForFacility'>
  & { capitalProviderOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<EntityIdAndNameGQLType, 'id' | 'name'>
  ) }
);

export type GetInvoicesByOrganizationIdQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetInvoicesByOrganizationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicesByOrganizationId: Array<(
    { __typename?: 'Invoice' }
    & InvoiceListItemFragmentGQLType
  )> }
);

export type GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  pagination: InvoicesPaginationInputGQLType;
  creditFacilityIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  sortBy?: Maybe<InvoiceSortFieldGQLType>;
  sortDirection?: Maybe<SortDirectionGQLType>;
}>;


export type GetInvoicesByOrganizationIdPaginatedQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicesByOrganizationIdPaginated: (
    { __typename?: 'InvoicesConnection' }
    & Pick<InvoicesConnectionGQLType, 'totalCount'>
    & { nodes: Array<(
      { __typename?: 'Invoice' }
      & InvoiceListItemFragmentGQLType
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
  creditFacilityIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type GetInvoiceAggregatesByOrganizationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceAggregatesByOrganizationId: (
    { __typename?: 'InvoiceAggregates' }
    & Pick<InvoiceAggregatesGQLType, 'totalCount'>
    & { dueSoon: (
      { __typename?: 'InvoiceStatusAggregate' }
      & Pick<InvoiceStatusAggregateGQLType, 'status' | 'totalAmount' | 'count'>
    ), overdue: (
      { __typename?: 'InvoiceStatusAggregate' }
      & Pick<InvoiceStatusAggregateGQLType, 'status' | 'totalAmount' | 'count'>
    ), paid: (
      { __typename?: 'InvoiceStatusAggregate' }
      & Pick<InvoiceStatusAggregateGQLType, 'status' | 'totalAmount' | 'count'>
    ) }
  ) }
);

export type GetInvoicesByLoanIdQueryVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
}>;


export type GetInvoicesByLoanIdQueryGQLType = (
  { __typename?: 'Query' }
  & { invoices: Array<(
    { __typename?: 'Invoice' }
    & InvoiceSummaryFragmentGQLType
  )> }
);

export type GetInvoiceByIdQueryVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type GetInvoiceByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceById: (
    { __typename?: 'Invoice' }
    & InvoiceFragmentGQLType
  ) }
);

export type GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type GetInvoiceDisbursementsByInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceDisbursementsByInvoiceId: Array<(
    { __typename?: 'InvoiceDisbursement' }
    & InvoiceDisbursementFragmentGQLType
  )> }
);

export type GetInvoiceDisbursementByIdQueryVariablesGQLType = Exact<{
  invoiceDisbursementId: Scalars['UUID'];
}>;


export type GetInvoiceDisbursementByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceDisbursementById: (
    { __typename?: 'InvoiceDisbursement' }
    & InvoiceDisbursementFragmentGQLType
  ) }
);

export type GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicePaymentInKindItemsByInvoiceId: Array<(
    { __typename?: 'InvoicePaymentInKindItemsWithMetadata' }
    & Pick<InvoicePaymentInKindItemsWithMetadataGQLType, 'invoiceItemId' | 'capitalizedLoanId' | 'capitalizedLoanName'>
    & { invoicePaymentInKindItems: Array<(
      { __typename?: 'InvoicePaymentInKindItem' }
      & InvoicePaymentInKindItemFragmentGQLType
    )> }
  )> }
);

export type GetInvoicePaymentInKindItemByIdQueryVariablesGQLType = Exact<{
  invoicePaymentInKindItemId: Scalars['UUID'];
}>;


export type GetInvoicePaymentInKindItemByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicePaymentInKindItemById: (
    { __typename?: 'InvoicePaymentInKindItem' }
    & InvoicePaymentInKindItemFragmentGQLType
  ) }
);

export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceConsolidatedDisbursementsByInvoiceId: Array<(
    { __typename?: 'InvoiceConsolidatedDisbursement' }
    & InvoiceConsolidatedDisbursementFragmentGQLType
  )> }
);

export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getLatestInvoiceFacilityFeeAccrualEndDate'>
);

export type GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType = Exact<{
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
}>;


export type GetInvoiceConsolidatedDisbursementByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceConsolidatedDisbursementById: (
    { __typename?: 'InvoiceConsolidatedDisbursement' }
    & InvoiceConsolidatedDisbursementFragmentGQLType
  ) }
);

export type GetInvoiceFacilityFeeBalancesQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetInvoiceFacilityFeeBalancesQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceFacilityFeeBalances: Array<(
    { __typename?: 'CreditFacilityAccrualObject' }
    & Pick<CreditFacilityAccrualObjectGQLType, 'totalAccruedAmount'>
    & { account: (
      { __typename?: 'TAccount' }
      & Pick<TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
    ) }
  )> }
);

export type GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
}>;


export type GetPrincipalPaymentMetricsByLoanIdQueryGQLType = (
  { __typename?: 'Query' }
  & { result: (
    { __typename?: 'PrincipalPaymentMetrics' }
    & Pick<PrincipalPaymentMetricsGQLType, 'latestPaymentDate' | 'loanHasPayment'>
  ) }
);

export type GetLoanMetricsForInvoiceIdQueryVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type GetLoanMetricsForInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { result: (
    { __typename?: 'LoanMetricsForInvoice' }
    & Pick<LoanMetricsForInvoiceGQLType, 'latestFundTransferDate' | 'hasPrincipalPayment'>
  ) }
);

export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  invoicePaymentStartDate: Scalars['FullDateStr'];
  invoicePaymentEndDate: Scalars['FullDateStr'];
  capitalizedLoanIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  capitalProviderOrganizationIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { servicingFeeDetails: Array<(
    { __typename?: 'PaymentInKindServicingFeeDetails' }
    & Pick<PaymentInKindServicingFeeDetailsGQLType, 'creditFacilityId' | 'creditFacilityName' | 'capitalProviderId' | 'capitalProviderName' | 'capitalizedLoanId' | 'capitalizedLoanName' | 'capitalizedExternalLoanId' | 'originatingLoanId' | 'originatingLoanName' | 'originatingExternalLoanId' | 'serviceFeeAmount' | 'invoicePaymentDate' | 'invoiceUpdatedAt' | 'runningBalance'>
    & { report?: Maybe<(
      { __typename?: 'InvoiceReport' }
      & InvoiceReportFragmentGQLType
    )> }
  )> }
);

export type CreateInvoiceWithInvoiceItemsMutationVariablesGQLType = Exact<{
  invoice: InvoiceInputGQLType;
  invoiceComponentsWithInvoiceItems: Array<InvoiceComponentWithInvoiceItemsInputGQLType> | InvoiceComponentWithInvoiceItemsInputGQLType;
}>;


export type CreateInvoiceWithInvoiceItemsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createInvoiceWithInvoiceItems: (
    { __typename?: 'CreateInvoiceResponse' }
    & Pick<CreateInvoiceResponseGQLType, 'invoiceId' | 'invoiceWorkleaseId' | 'disbursementWorkleaseIds'>
  ) }
);

export type MarkInvoiceAsPaidMutationVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
  invoicePaymentDate: Scalars['FullDateStr'];
}>;


export type MarkInvoiceAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceAsPaid: (
    { __typename?: 'MarkInvoiceAsPaidResponse' }
    & Pick<MarkInvoiceAsPaidResponseGQLType, 'invoiceId'>
  ) }
);

export type MarkInvoiceAsCanceledMutationVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type MarkInvoiceAsCanceledMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceAsCanceled?: Maybe<(
    { __typename?: 'InvoiceIdResponse' }
    & Pick<InvoiceIdResponseGQLType, 'invoiceId'>
  )> }
);

export type MarkInvoiceDisbursementAsPaidMutationVariablesGQLType = Exact<{
  invoiceDisbursementId: Scalars['UUID'];
  disbursementDate: Scalars['FullDateStr'];
}>;


export type MarkInvoiceDisbursementAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceDisbursementAsPaid: (
    { __typename?: 'MarkInvoiceDisbursementAsPaidResponse' }
    & Pick<MarkInvoiceDisbursementAsPaidResponseGQLType, 'invoiceDisbursementId'>
  ) }
);

export type MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType = Exact<{
  invoicePaymentInKindItemId: Scalars['UUID'];
  notifiedDate: Scalars['FullDateStr'];
}>;


export type MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoicePaymentInKindItemAsNotified: (
    { __typename?: 'MarkInvoicePaymentInKindItemAsNotifiedResponse' }
    & Pick<MarkInvoicePaymentInKindItemAsNotifiedResponseGQLType, 'invoicePaymentInKindItemId'>
  ) }
);

export type UpdateInvoiceDueDateMutationVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
  newDueDate: Scalars['FullDateStr'];
}>;


export type UpdateInvoiceDueDateMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateInvoiceDueDate?: Maybe<(
    { __typename?: 'UpdateInvoiceResponse' }
    & Pick<UpdateInvoiceResponseGQLType, 'invoiceId'>
  )> }
);

export type ReverseInvoicePaymentMutationVariablesGQLType = Exact<{
  invoiceId: Scalars['UUID'];
}>;


export type ReverseInvoicePaymentMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reverseInvoicePayment?: Maybe<(
    { __typename?: 'UpdateInvoiceResponse' }
    & Pick<UpdateInvoiceResponseGQLType, 'invoiceId'>
  )> }
);

export type MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType = Exact<{
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
  paymentDate: Scalars['FullDateStr'];
}>;


export type MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceConsolidatedDisbursementAsPaid: (
    { __typename?: 'MarkInvoiceConsolidatedDisbursementAsPaidResponse' }
    & Pick<MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType, 'invoiceConsolidatedDisbursementId'>
  ) }
);

export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType = Exact<{
  invoiceConsolidatedDisbursementId: Scalars['UUID'];
}>;


export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { undoMarkInvoiceConsolidatedDisbursementAsPaid: (
    { __typename?: 'MarkInvoiceConsolidatedDisbursementAsPaidResponse' }
    & Pick<MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType, 'invoiceConsolidatedDisbursementId'>
  ) }
);

export type LimitedPartnerMappingForAliasingFragmentGQLType = (
  { __typename?: 'LimitedPartnerMappingForAliasing' }
  & Pick<LimitedPartnerMappingForAliasingGQLType, 'mappingId' | 'limitedPartnerId' | 'limitedPartnerName' | 'matchedByUserName' | 'matchedByUserEmail' | 'externalReceivableId' | 'limitedPartnerAlias' | 'committedCapital' | 'loanProductId' | 'creditFacilityId' | 'reportingDate' | 'fileVersion' | 'ownerOrganizationId' | 'matchMetadataId'>
);

export type LimitedPartnerCommitmentFragmentGQLType = (
  { __typename?: 'LimitedPartnerCommitment' }
  & Pick<LimitedPartnerCommitmentGQLType, 'limitedPartnerAlias' | 'finleyReceivableId' | 'limitedPartnerId' | 'limitedPartnerName' | 'creditFacilityId' | 'creditFacilityName' | 'borrowerSlug' | 'borrowerName' | 'committedCapital' | 'uncalledCapital' | 'reportingDate'>
);

export type LimitedPartnerCommitmentDetailFragmentGQLType = (
  { __typename?: 'LimitedPartnerCommitmentDetail' }
  & Pick<LimitedPartnerCommitmentDetailGQLType, 'limitedPartnerAlias' | 'finleyReceivableId' | 'limitedPartnerId' | 'limitedPartnerName' | 'creditFacilityId' | 'creditFacilityName' | 'borrowerSlug' | 'borrowerName' | 'committedCapital' | 'uncalledCapital' | 'recallableCapital' | 'reportingDate' | 'eligibleUncalledCapitalLessKickouts' | 'netUncalledCapital' | 'percentageOfNetUncalledCapital' | 'mappingId' | 'matchedByUserName' | 'matchedByUserEmail' | 'matchedAt'>
);

export type AggregatedLimitedPartnerCommitmentDataFragmentGQLType = (
  { __typename?: 'AggregatedLimitedPartnerCommitmentData' }
  & Pick<AggregatedLimitedPartnerCommitmentDataGQLType, 'limitedPartnerName' | 'limitedPartnerId' | 'commitmentCount' | 'totalCommittedCapital' | 'totalRecallableCapital' | 'percentageOfPortfolioCommittedCapital' | 'totalUncalledCapital' | 'percentageOfPortfolioUncalledCapital' | 'eligibleUncalledCapital' | 'eligibleUncalledCapitalLessKickouts' | 'advanceRate' | 'netUncalledCapital' | 'percentageOfPortfolioNetUncalledCapital'>
);

export type LimitedPartnerCapitalTrendDataFragmentGQLType = (
  { __typename?: 'LimitedPartnerCapitalTrendData' }
  & Pick<LimitedPartnerCapitalTrendDataGQLType, 'finleyReceivableId' | 'committedCapital' | 'uncalledCapital' | 'reportingDate'>
);

export type LimitedPartnerPortfolioOverviewGraphDataFragmentGQLType = (
  { __typename?: 'LimitedPartnerPortfolioOverviewGraphData' }
  & Pick<LimitedPartnerPortfolioOverviewGraphDataGQLType, 'totalUncalledCapital' | 'totalCommittedCapital' | 'totalPrincipalBalance' | 'reportingDate'>
);

export type GetLimitedPartnerMappingsForAliasingQueryVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
  queryString?: Maybe<Scalars['String']>;
}>;


export type GetLimitedPartnerMappingsForAliasingQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartnerMappingsByFacility: Array<(
    { __typename?: 'LimitedPartnerMappingsByCreditFacility' }
    & Pick<LimitedPartnerMappingsByCreditFacilityGQLType, 'creditFacilityId' | 'creditFacilityName'>
    & { mappings: Array<(
      { __typename?: 'LimitedPartnerMappingForAliasing' }
      & LimitedPartnerMappingForAliasingFragmentGQLType
    )> }
  )> }
);

export type GetCountOfUnmatchedLimitedPartnerMappingsQueryVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
}>;


export type GetCountOfUnmatchedLimitedPartnerMappingsQueryGQLType = (
  { __typename?: 'Query' }
  & { unmatchedLimitedPartnerMappingsCount: QueryGQLType['getCountOfUnmatchedLimitedPartnerMappings'] }
);

export type GetLimitedPartnerByIdQueryVariablesGQLType = Exact<{
  limitedPartnerId: Scalars['UUID'];
}>;


export type GetLimitedPartnerByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartner: (
    { __typename?: 'LimitedPartner' }
    & Pick<LimitedPartnerGQLType, 'id' | 'name' | 'alternateAliases'>
  ) }
);

export type GetLimitedPartnerDetailsQueryVariablesGQLType = Exact<{
  limitedPartnerId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
}>;


export type GetLimitedPartnerDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartner: (
    { __typename?: 'LimitedPartner' }
    & Pick<LimitedPartnerGQLType, 'id' | 'name' | 'alternateAliases'>
  ), attributes: Array<(
    { __typename?: 'Attribute' }
    & AttributeFragmentFragmentGQLType
  )> }
);

export type GetLimitedPartnersForOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  queryString?: Maybe<Scalars['String']>;
}>;


export type GetLimitedPartnersForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartners: Array<(
    { __typename?: 'LimitedPartner' }
    & Pick<LimitedPartnerGQLType, 'id' | 'name' | 'alternateAliases'>
  )> }
);

export type GetAggregatedLimitedPartnerCommitmentDataForLenderQueryVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
  filters: LimitedPartnerFiltersGQLType;
}>;


export type GetAggregatedLimitedPartnerCommitmentDataForLenderQueryGQLType = (
  { __typename?: 'Query' }
  & { aggregatedLimitedPartnerCommitmentData: Array<(
    { __typename?: 'AggregatedLimitedPartnerCommitmentData' }
    & AggregatedLimitedPartnerCommitmentDataFragmentGQLType
  )> }
);

export type GetLimitedPartnerCommitmentsForLenderQueryVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
}>;


export type GetLimitedPartnerCommitmentsForLenderQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartnerCommitments: Array<(
    { __typename?: 'LimitedPartnerCommitment' }
    & LimitedPartnerCommitmentFragmentGQLType
  )> }
);

export type GetCommitmentsForLimitedPartnerQueryVariablesGQLType = Exact<{
  limitedPartnerId: Scalars['UUID'];
}>;


export type GetCommitmentsForLimitedPartnerQueryGQLType = (
  { __typename?: 'Query' }
  & { limitedPartnerCommitments: Array<(
    { __typename?: 'LimitedPartnerCommitmentDetail' }
    & LimitedPartnerCommitmentDetailFragmentGQLType
  )> }
);

export type GetLimitedPartnerCapitalTrendDataQueryVariablesGQLType = Exact<{
  limitedPartnerId: Scalars['UUID'];
}>;


export type GetLimitedPartnerCapitalTrendDataQueryGQLType = (
  { __typename?: 'Query' }
  & { capitalTrendData: Array<(
    { __typename?: 'LimitedPartnerCapitalTrendData' }
    & LimitedPartnerCapitalTrendDataFragmentGQLType
  )> }
);

export type GetLimitedPartnerPortfolioOverviewGraphDataQueryVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
}>;


export type GetLimitedPartnerPortfolioOverviewGraphDataQueryGQLType = (
  { __typename?: 'Query' }
  & { portfolioOverviewGraphData: Array<(
    { __typename?: 'LimitedPartnerPortfolioOverviewGraphData' }
    & LimitedPartnerPortfolioOverviewGraphDataFragmentGQLType
  )> }
);

export type GetLimitedPartnerPortfolioSummaryQueryVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
  filters: LimitedPartnerFiltersGQLType;
}>;


export type GetLimitedPartnerPortfolioSummaryQueryGQLType = (
  { __typename?: 'Query' }
  & { portfolioSummary: (
    { __typename?: 'LimitedPartnerPortfolioSummary' }
    & Pick<LimitedPartnerPortfolioSummaryGQLType, 'totalCommittedCapital' | 'totalUncalledCapital' | 'limitedPartnerCount' | 'commitmentCount'>
  ) }
);

export type CreateLimitedPartnerMutationVariablesGQLType = Exact<{
  lenderOrganizationId: Scalars['UUID'];
  name: Scalars['String'];
  attributeValues: Array<CreateOrUpdateLimitedPartnerLatestAttributeValueInputGQLType> | CreateOrUpdateLimitedPartnerLatestAttributeValueInputGQLType;
}>;


export type CreateLimitedPartnerMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createLimitedPartner: (
    { __typename?: 'LimitedPartner' }
    & Pick<LimitedPartnerGQLType, 'id' | 'name' | 'alternateAliases'>
  ) }
);

export type UpdateLimitedPartnerMutationVariablesGQLType = Exact<{
  limitedPartnerId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  alternateAliases?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UpdateLimitedPartnerMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateLimitedPartner: (
    { __typename?: 'LimitedPartner' }
    & Pick<LimitedPartnerGQLType, 'id' | 'name' | 'alternateAliases'>
  ) }
);

export type UpdateLimitedPartnerMappingMutationVariablesGQLType = Exact<{
  limitedPartnerMappingId: Scalars['UUID'];
  limitedPartnerId?: Maybe<Scalars['UUID']>;
}>;


export type UpdateLimitedPartnerMappingMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateLimitedPartnerMapping: (
    { __typename?: 'UpdateLimitedPartnerMappingResponse' }
    & Pick<UpdateLimitedPartnerMappingResponseGQLType, 'limitedPartnerMappingId' | 'limitedPartnerName' | 'limitedPartnerAlias' | 'limitedPartnerId'>
  ) }
);

export type GetLimitedPartnerAttributeListQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  entityIdentifier?: Maybe<Scalars['UUID']>;
}>;


export type GetLimitedPartnerAttributeListQueryGQLType = (
  { __typename?: 'Query' }
  & { attributes: Array<(
    { __typename?: 'Attribute' }
    & AttributeFragmentFragmentGQLType
  )> }
);

export type CreateOrUpdateLimitedPartnerAttributeValueMutationVariablesGQLType = Exact<{
  input: CreateOrUpdateLatestAttributeValueInputGQLType;
}>;


export type CreateOrUpdateLimitedPartnerAttributeValueMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrUpdateLatestAttributeValue: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type AssignmentPreviewJobFragmentGQLType = (
  { __typename?: 'AssignmentPreviewJob' }
  & Pick<AssignmentPreviewJobGQLType, 'id' | 'implementationId' | 'assignmentMethod' | 'strategyId' | 'previewIdentifier' | 'status' | 'created_at' | 'updated_at' | 'strategyName' | 'completedAt' | 'initiatedByUserIdentifier' | 'totalProposedExposure' | 'newlyProposedExposure' | 'proposedBorrowingBaseFromReceivables' | 'balanceSheetExposure' | 's3Path'>
);

export type AssignmentConfirmationJobFragmentGQLType = (
  { __typename?: 'AssignmentConfirmationJob' }
  & Pick<AssignmentConfirmationJobGQLType, 'id' | 'implementationId' | 'status' | 'fileVersion' | 'reportingDate' | 'previewJobId' | 'created_at' | 'updated_at' | 'completedAt' | 'initiatedByUserId' | 'errorLogS3Path' | 'payloadS3Path' | 'jobType'>
);

export type AssignmentReceivableFragmentGQLType = (
  { __typename?: 'AssignmentReceivable' }
  & Pick<AssignmentReceivableGQLType, 'finleyReceivableId' | 'externalReceivableId' | 'loanProductId' | 'isAssignable' | 'leaveUnassigned' | 'assignableCreditFacilityIds'>
  & { baseFields: Array<(
    { __typename?: 'BaseField' }
    & Pick<BaseFieldGQLType, 'key' | 'value'>
  )>, dynamicIntermediateFields: Array<(
    { __typename?: 'DynamicIntermediateFieldsForCreditFacility' }
    & Pick<DynamicIntermediateFieldsForCreditFacilityGQLType, 'creditFacilityId'>
    & { dynamicIntermediateFields: Array<(
      { __typename?: 'BaseField' }
      & Pick<BaseFieldGQLType, 'key' | 'value'>
    )> }
  )>, requiredIntermediateFields: Array<(
    { __typename?: 'RequiredIntermediateFieldsForCreditFacility' }
    & Pick<RequiredIntermediateFieldsForCreditFacilityGQLType, 'creditFacilityId'>
    & { requiredIntermediateFields: (
      { __typename?: 'RequiredIntermediateFields' }
      & Pick<RequiredIntermediateFieldsGQLType, 'assignmentExclusion' | 'exposure' | 'waiveAllEligibility' | 'waiveAllConcentration' | 'includeInConcentrationLimitDenominatorIfWaived' | 'originalOwnerSlug' | 'normalizedDaysPastDue' | 'normalizedDurationDays' | 'normalizedisChargedOff' | 'normalizedisDelinquent' | 'normalizedOriginationDate' | 'normalizedInitialBalance'>
    ) }
  )>, postProcessedFields: Array<(
    { __typename?: 'PostProcessedFieldsForCreditFacility' }
    & Pick<PostProcessedFieldsForCreditFacilityGQLType, 'creditFacilityId'>
    & { postProcessedFields: (
      { __typename?: 'PostProcessedFields' }
      & Pick<PostProcessedFieldsGQLType, 'originalOwnerId' | 'performingExposure'>
    ) }
  )>, receivableResponseTapeProperties?: Maybe<(
    { __typename?: 'ReceivableResponseTapeProperties' }
    & Pick<ReceivableResponseTapePropertiesGQLType, 'creditFacilityId'>
    & { valuationFields: (
      { __typename?: 'ValuationFields' }
      & Pick<ValuationFieldsGQLType, 'valuation' | 'valuationRate'>
    ), eligibilityFields: (
      { __typename?: 'EligibilityFields' }
      & Pick<EligibilityFieldsGQLType, 'eligibleExposure' | 'isEligible' | 'eligibilityKickout'>
    ), concentrationLimitFields: (
      { __typename?: 'ConcentrationLimitFields' }
      & Pick<ConcentrationLimitFieldsGQLType, 'eligibleExposureLessConcentrationLimitKickouts'>
    ), borrowingBaseFields: (
      { __typename?: 'BorrowingBaseFields' }
      & Pick<BorrowingBaseFieldsGQLType, 'borrowingBaseAmount' | 'advanceRate'>
    ), concentrationLimitReasons: Array<(
      { __typename?: 'ConcentrationLimitReason' }
      & Pick<ConcentrationLimitReasonGQLType, 'propertyKey' | 'concentrationLimitKickout'>
    )>, concentrationLimitWaivers: Array<(
      { __typename?: 'ConcentrationLimitWaiver' }
      & Pick<ConcentrationLimitWaiverGQLType, 'propertyKey' | 'waiveReason'>
    )>, eligibilityStatuses: Array<(
      { __typename?: 'EligibilityStatusContainer' }
      & Pick<EligibilityStatusContainerGQLType, 'eligibilityCriteriaKey' | 'eligibilityStatus'>
    )> }
  )> }
);

export type AssignmentBorrowingBaseReportFragmentGQLType = (
  { __typename?: 'AssignmentBorrowingBaseReport' }
  & Pick<AssignmentBorrowingBaseReportGQLType, 'creditFacilityId' | 'totalExposure' | 'totalBorrowingBaseAmount' | 'totalEligibleExposureLessConcentrationKickouts' | 'effectiveReceivableAdvanceRate' | 'balanceSheetExposure'>
  & { concentrationLimitCalculations?: Maybe<Array<(
    { __typename?: 'CreditAgreementConfigConcentrationLimitCalculation' }
    & Pick<CreditAgreementConfigConcentrationLimitCalculationGQLType, 'concentrationLimitKey' | 'concentrationLimit' | 'concentrationAmount' | 'totalEligibleExposure' | 'concentration' | 'borrowingBaseReduction' | 'complianceStatus'>
  )>>, eligibilityCriteriaCalculations?: Maybe<Array<(
    { __typename?: 'CreditAgreementConfigEligibilityCriteriaCalculation' }
    & Pick<CreditAgreementConfigEligibilityCriteriaCalculationGQLType, 'eligibilityCriteriaKey' | 'eligibilityReduction'>
  )>> }
);

export type AssignmentReceivablesAggregateTotalsByStatusFragmentGQLType = (
  { __typename?: 'AssignmentReceivablesAggregateTotalsByStatus' }
  & { proposed: (
    { __typename?: 'AssignmentReceivablesAggregateTotals' }
    & Pick<AssignmentReceivablesAggregateTotalsGQLType, 'count' | 'exposure'>
  ), unassigned: (
    { __typename?: 'AssignmentReceivablesAggregateTotals' }
    & Pick<AssignmentReceivablesAggregateTotalsGQLType, 'count' | 'exposure'>
  ), previouslyAssigned: (
    { __typename?: 'AssignmentReceivablesAggregateTotals' }
    & Pick<AssignmentReceivablesAggregateTotalsGQLType, 'count' | 'exposure'>
  ) }
);

export type AssignmentStrategyFragmentGQLType = (
  { __typename?: 'AssignmentStrategy' }
  & Pick<AssignmentStrategyGQLType, 'id' | 'name' | 'default' | 'description' | 'createdByUserId' | 'updatedByUserId' | 'decisionHeuristic'>
);

export type LoanProductCriteriaFragmentGQLType = (
  { __typename?: 'LoanProductCriteria' }
  & Pick<LoanProductCriteriaGQLType, 'id' | 'creditFacilityId' | 'assignmentStrategyId' | 'loanProductId' | 'exclusionSqlClause'>
);

export type EligibilityExclusionFragmentGQLType = (
  { __typename?: 'EligibilityExclusion' }
  & Pick<EligibilityExclusionGQLType, 'id' | 'creditFacilityId' | 'assignmentStrategyId' | 'loanProductId' | 'eligibilityCriteriaKey'>
);

export type ReceivablePaginationMetadataFragmentGQLType = (
  { __typename?: 'ReceivablePaginationMetadata' }
  & Pick<ReceivablePaginationMetadataGQLType, 'hasNextPage' | 'queryPageBoundaryReceivableIds' | 'queryPageNumber'>
);

export type GetAssignedReceivableQueryVariablesGQLType = Exact<{
  finleyReceivableId: Scalars['UUID'];
}>;


export type GetAssignedReceivableQueryGQLType = (
  { __typename?: 'Query' }
  & { assignedReceivable: (
    { __typename?: 'AssignedReceivable' }
    & Pick<AssignedReceivableGQLType, 'id' | 'externalReceivableId' | 'status' | 'loanProductId'>
    & { creditFacility: (
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'name' | 'slug' | 'borrowerOrganizationName'>
    ) }
  ) }
);

export type GetAssignedReceivablesForLoanProductQueryVariablesGQLType = Exact<{
  externalReceivableIds: Array<Scalars['String']> | Scalars['String'];
  loanProductSlug: Scalars['String'];
}>;


export type GetAssignedReceivablesForLoanProductQueryGQLType = (
  { __typename?: 'Query' }
  & { assignedReceivablesForLoanProduct: Array<(
    { __typename?: 'AssignedReceivable' }
    & Pick<AssignedReceivableGQLType, 'id' | 'externalReceivableId' | 'status' | 'loanProductId'>
    & { creditFacility: (
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'name' | 'slug'>
    ) }
  )> }
);

export type GetAssignmentReceivablesQueryVariablesGQLType = Exact<{
  previewIdentifier: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
}>;


export type GetAssignmentReceivablesQueryGQLType = (
  { __typename?: 'Query' }
  & { assignmentReceivablesWithMetadata?: Maybe<(
    { __typename?: 'AssignmentReceivablesWithMetadata' }
    & Pick<AssignmentReceivablesWithMetadataGQLType, 'assignmentReceivables'>
    & { borrowingBaseReports: Array<(
      { __typename?: 'AssignmentBorrowingBaseReport' }
      & AssignmentBorrowingBaseReportFragmentGQLType
    )> }
  )> }
);

export type GetInitialConditionAssignmentReceivablesQueryVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetInitialConditionAssignmentReceivablesQueryGQLType = (
  { __typename?: 'Query' }
  & { initialConditionAssignmentReceivablesWithMetadata?: Maybe<(
    { __typename?: 'AssignmentReceivablesWithMetadata' }
    & Pick<AssignmentReceivablesWithMetadataGQLType, 'assignmentReceivables'>
    & { borrowingBaseReports: Array<(
      { __typename?: 'AssignmentBorrowingBaseReport' }
      & AssignmentBorrowingBaseReportFragmentGQLType
    )> }
  )> }
);

export type GetLatestAssignmentReceivablesQueryVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetLatestAssignmentReceivablesQueryGQLType = (
  { __typename?: 'Query' }
  & { latestAssignmentReceivablesWithMetadata?: Maybe<(
    { __typename?: 'AssignmentReceivablesWithMetadata' }
    & Pick<AssignmentReceivablesWithMetadataGQLType, 'assignmentReceivables'>
    & { borrowingBaseReports: Array<(
      { __typename?: 'AssignmentBorrowingBaseReport' }
      & AssignmentBorrowingBaseReportFragmentGQLType
    )> }
  )> }
);

export type GetLatestInitialAssignmentSummaryQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  implementationId: Scalars['UUID'];
}>;


export type GetLatestInitialAssignmentSummaryQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'latestAssignmentSummary'>
);

export type GetAssignmentSummaryQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  previewIdentifier?: Maybe<Scalars['String']>;
}>;


export type GetAssignmentSummaryQueryGQLType = (
  { __typename?: 'Query' }
  & { initial: QueryGQLType['assignmentSummary'], proposed: QueryGQLType['assignmentSummary'] }
);

export type GetAggregatedAssignmentSummaryPreviewQueryVariablesGQLType = Exact<{
  initialPreviewJobId: Scalars['UUID'];
  proposedPreviewJobId: Scalars['UUID'];
}>;


export type GetAggregatedAssignmentSummaryPreviewQueryGQLType = (
  { __typename?: 'Query' }
  & { initial: QueryGQLType['aggregatedAssignmentSummaryPreview'], proposed: QueryGQLType['aggregatedAssignmentSummaryPreview'] }
);

export type GetLatestAssignmentSummariesQueryVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  includeInitialCondition: Scalars['Boolean'];
}>;


export type GetLatestAssignmentSummariesQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'latestAssignmentSummaries'>
);

export type GetLatestAssignmentPipelineRunStatusForImplementationQueryVariablesGQLType = Exact<{
  implementationId: Scalars['String'];
}>;


export type GetLatestAssignmentPipelineRunStatusForImplementationQueryGQLType = (
  { __typename?: 'Query' }
  & { latestAssignmentPipelineRunStatusForImplementation?: Maybe<(
    { __typename?: 'AssignmentPipelineMetadata' }
    & Pick<AssignmentPipelineMetadataGQLType, 'status' | 'fileVersion' | 'reportingDate' | 'implementationId' | 'masterLoanTapeIds'>
  )> }
);

export type GetAreMasterLoanTapesAssignedQueryVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAreMasterLoanTapesAssignedQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'areMasterLoanTapesAssigned'>
);

export type GetLatestCompletedReceivableResponseTapePreviewIdsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['String']> | Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
}>;


export type GetLatestCompletedReceivableResponseTapePreviewIdsQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'latestCompletedReceivableResponseTapePreviewIds'>
);

export type GetCompletedReceivableResponseTapePreviewIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  previewIdentifier: Scalars['String'];
}>;


export type GetCompletedReceivableResponseTapePreviewIdQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'completedReceivableResponseTapePreviewId'>
);

export type GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { initialConditionAssignmentReceivablesAggregateTotalsWithMetadata?: Maybe<(
    { __typename?: 'AssignmentReceivablesAggregateTotalsByStatusWithMetadata' }
    & Pick<AssignmentReceivablesAggregateTotalsByStatusWithMetadataGQLType, 'reportingDate' | 'fileVersion' | 'previewIdentifier'>
    & { assignmentReceivablesAggregateTotalsByStatus: (
      { __typename?: 'AssignmentReceivablesAggregateTotalsByStatus' }
      & AssignmentReceivablesAggregateTotalsByStatusFragmentGQLType
    ), borrowingBaseReports: Array<(
      { __typename?: 'AssignmentBorrowingBaseReport' }
      & AssignmentBorrowingBaseReportFragmentGQLType
    )> }
  )> }
);

export type GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { latestAssignmentReceivablesAggregateTotalsWithMetadata?: Maybe<(
    { __typename?: 'AssignmentReceivablesAggregateTotalsByStatusWithMetadata' }
    & Pick<AssignmentReceivablesAggregateTotalsByStatusWithMetadataGQLType, 'reportingDate' | 'fileVersion' | 'previewIdentifier'>
    & { assignmentReceivablesAggregateTotalsByStatus: (
      { __typename?: 'AssignmentReceivablesAggregateTotalsByStatus' }
      & AssignmentReceivablesAggregateTotalsByStatusFragmentGQLType
    ), borrowingBaseReports: Array<(
      { __typename?: 'AssignmentBorrowingBaseReport' }
      & AssignmentBorrowingBaseReportFragmentGQLType
    )> }
  )> }
);

export type GetAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType = Exact<{
  previewIdentifier: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
}>;


export type GetAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { assignmentReceivablesAggregateTotalsWithMetadata?: Maybe<(
    { __typename?: 'AssignmentReceivablesAggregateTotalsByStatusWithMetadata' }
    & { assignmentReceivablesAggregateTotalsByStatus: (
      { __typename?: 'AssignmentReceivablesAggregateTotalsByStatus' }
      & AssignmentReceivablesAggregateTotalsByStatusFragmentGQLType
    ), borrowingBaseReports: Array<(
      { __typename?: 'AssignmentBorrowingBaseReport' }
      & AssignmentBorrowingBaseReportFragmentGQLType
    )> }
  )> }
);

export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug'>
    & { loanProductCreditFacilityGroupsForAssignment: Array<(
      { __typename?: 'LpToCfEntityGrouping' }
      & Pick<LpToCfEntityGroupingGQLType, 'implementationId'>
      & { creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'name' | 'slug' | 'borrowerEntityName'>
      )>, loanProducts: Array<(
        { __typename?: 'LoanProduct' }
        & Pick<LoanProductGQLType, 'id' | 'name' | 'slug'>
      )> }
    )> }
  ) }
);

export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug'>
    & { loanProductCreditFacilityGroupsForAssignment: Array<(
      { __typename?: 'LpToCfEntityGrouping' }
      & Pick<LpToCfEntityGroupingGQLType, 'implementationId'>
      & { creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'name' | 'slug' | 'borrowerEntityName'>
      )>, loanProducts: Array<(
        { __typename?: 'LoanProduct' }
        & Pick<LoanProductGQLType, 'id' | 'name' | 'slug'>
      )>, pipelineInfo: (
        { __typename?: 'PipelineInfoForGrouping' }
        & Pick<PipelineInfoForGroupingGQLType, 'status'>
        & { latestCompletedPreviewJob?: Maybe<(
          { __typename?: 'AssignmentPreviewJob' }
          & Pick<AssignmentPreviewJobGQLType, 'id' | 'assignmentMethod' | 'status' | 'strategyId' | 'strategyName'>
        )> }
      ) }
    )> }
  ) }
);

export type GetAssignmentStrategiesForImplementationQueryVariablesGQLType = Exact<{
  implementationId: Scalars['String'];
}>;


export type GetAssignmentStrategiesForImplementationQueryGQLType = (
  { __typename?: 'Query' }
  & { assignmentStrategiesForImplementation: Array<(
    { __typename?: 'AssignmentStrategy' }
    & Pick<AssignmentStrategyGQLType, 'id' | 'name' | 'created_at' | 'updated_at' | 'createdByEmail' | 'updatedByEmail' | 'description' | 'default'>
  )> }
);

export type GetAssignmentStrategiesForOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetAssignmentStrategiesForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { assignmentStrategiesForOrganization: Array<(
    { __typename?: 'AssignmentStrategiesByImplementation' }
    & Pick<AssignmentStrategiesByImplementationGQLType, 'implementationId'>
    & { assignmentStrategies: Array<(
      { __typename?: 'AssignmentStrategy' }
      & Pick<AssignmentStrategyGQLType, 'id' | 'name' | 'created_at' | 'updated_at' | 'createdByEmail' | 'updatedByEmail' | 'description' | 'default'>
    )> }
  )> }
);

export type GetAssignmentStrategyQueryVariablesGQLType = Exact<{
  strategyId: Scalars['UUID'];
  implementationId?: Maybe<Scalars['UUID']>;
}>;


export type GetAssignmentStrategyQueryGQLType = (
  { __typename?: 'Query' }
  & { assignmentStrategy: (
    { __typename?: 'AssignmentStrategy' }
    & Pick<AssignmentStrategyGQLType, 'id' | 'name' | 'created_at' | 'updated_at' | 'createdByEmail' | 'updatedByEmail' | 'description' | 'default' | 'implementationId' | 'decisionHeuristic'>
    & { loanProductCriteria: Array<(
      { __typename?: 'LoanProductCriteria' }
      & LoanProductCriteriaFragmentGQLType
    )>, eligibilityExclusions: Array<(
      { __typename?: 'EligibilityExclusion' }
      & EligibilityExclusionFragmentGQLType
    )> }
  ) }
);

export type GetLoanProductsForCreditFacilityQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  useWip: Scalars['Boolean'];
}>;


export type GetLoanProductsForCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'slug' | 'name' | 'implementationId'>
    )> }
  ) }
);

export type GetReceivableResponseTapePreviewCsvDownloadUrlQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  type: ReceivableResponseTapePreviewAttachmentTypeGQLType;
  loanProductId: Scalars['UUID'];
  previewIdentifier: Scalars['String'];
}>;


export type GetReceivableResponseTapePreviewCsvDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getReceivableResponseTapePreviewCsvDownloadUrl'>
);

export type GetGeneratedAssignedLoanTapeDownloadUrlQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  loanProductId: Scalars['UUID'];
}>;


export type GetGeneratedAssignedLoanTapeDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getGeneratedAssignedLoanTapeDownloadUrl'>
);

export type GetAssignmentJobsQueryVariablesGQLType = Exact<{
  implementationId: Scalars['String'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
  fileVersion?: Maybe<Scalars['Int']>;
}>;


export type GetAssignmentJobsQueryGQLType = (
  { __typename?: 'Query' }
  & { assignmentJobs: (
    { __typename?: 'AssignmentJobs' }
    & { previewJobs: Array<(
      { __typename?: 'AssignmentPreviewJob' }
      & AssignmentPreviewJobFragmentGQLType
    )>, latestConfirmationJob?: Maybe<(
      { __typename?: 'AssignmentConfirmationJob' }
      & AssignmentConfirmationJobFragmentGQLType
    )> }
  ) }
);

export type GetRepurchaseAndTransferJobsQueryVariablesGQLType = Exact<{
  implementationId: Scalars['String'];
}>;


export type GetRepurchaseAndTransferJobsQueryGQLType = (
  { __typename?: 'Query' }
  & { repurchaseAndTransferJobs: Array<(
    { __typename?: 'AssignmentConfirmationJob' }
    & AssignmentConfirmationJobFragmentGQLType
  )> }
);

export type GetLatestHistoricalReceivableResponseTapeValuesQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId?: Maybe<Scalars['UUID']>;
  reportingDatesRange?: Maybe<FullDateStrDateRangeInputGQLType>;
  queryFilters?: Maybe<Scalars['String']>;
  queryPageNumber: Scalars['Int'];
  queryPageBoundaryReceivableIds: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
}>;


export type GetLatestHistoricalReceivableResponseTapeValuesQueryGQLType = (
  { __typename?: 'Query' }
  & { latestHistoricalReceivableResponseTapeValues?: Maybe<(
    { __typename?: 'ReceivableResponseTapeAthenaPaginatedResponse' }
    & Pick<ReceivableResponseTapeAthenaPaginatedResponseGQLType, 'receivables'>
    & { paginationMetadata: (
      { __typename?: 'ReceivablePaginationMetadata' }
      & ReceivablePaginationMetadataFragmentGQLType
    ) }
  )> }
);

export type GetLatestHistoricalReceivableResponseTapeValuesCountQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId?: Maybe<Scalars['UUID']>;
  reportingDatesRange?: Maybe<FullDateStrDateRangeInputGQLType>;
  queryFilters?: Maybe<Scalars['String']>;
}>;


export type GetLatestHistoricalReceivableResponseTapeValuesCountQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'latestHistoricalReceivableResponseTapeValuesCount'>
);

export type InitiateReceivableReassignmentFromAthenaQueryMutationVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  loanProductId?: Maybe<Scalars['UUID']>;
  reportingDatesRange?: Maybe<FullDateStrDateRangeInputGQLType>;
  queryFilters?: Maybe<Scalars['String']>;
  allQueryRowsSelected: Scalars['Boolean'];
  finleyReceivableIdsToInclude: Array<Scalars['UUID']> | Scalars['UUID'];
  finleyReceivableIdsToExclude: Array<Scalars['UUID']> | Scalars['UUID'];
  reassignmentInfo: Array<LpCfReassignmentInputGQLType> | LpCfReassignmentInputGQLType;
}>;


export type InitiateReceivableReassignmentFromAthenaQueryMutationGQLType = (
  { __typename?: 'Mutation' }
  & { initiateReceivableReassignmentFromAthenaQuery: (
    { __typename?: 'ReassignmentConfirmationJobInfo' }
    & Pick<ReassignmentConfirmationJobInfoGQLType, 'jobId' | 'receivableCount'>
  ) }
);

export type InitiateReceivableReassignmentFromDataPipelineMutationVariablesGQLType = Exact<{
  loanProductSlug: Scalars['String'];
  implementationId: Scalars['UUID'];
  externalReceivableIds: Array<Scalars['String']> | Scalars['String'];
  creditFacilitySlug?: Maybe<Scalars['String']>;
}>;


export type InitiateReceivableReassignmentFromDataPipelineMutationGQLType = (
  { __typename?: 'Mutation' }
  & { initiateReceivableReassignmentFromDataPipeline: (
    { __typename?: 'ReassignmentConfirmationJobInfo' }
    & Pick<ReassignmentConfirmationJobInfoGQLType, 'jobId' | 'receivableCount'>
  ) }
);

export type GetHistoricalRecordsForReceivableQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDateParams?: Maybe<DateRangeInputGQLType>;
}>;


export type GetHistoricalRecordsForReceivableQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'historicalRecordsForReceivable'>
);

export type GetRepaymentDataForAssignedReceivableQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
  repaymentDateParams?: Maybe<DateRangeInputGQLType>;
}>;


export type GetRepaymentDataForAssignedReceivableQueryGQLType = (
  { __typename?: 'Query' }
  & { repaymentDataForAssignedReceivable?: Maybe<Array<(
    { __typename?: 'ReceivableRepaymentsHistory' }
    & Pick<ReceivableRepaymentsHistoryGQLType, 'normalizedRepaymentAmount' | 'finleyRepaymentDate'>
  )>> }
);

export type ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  waiversWithEntitiesJson: Scalars['String'];
}>;


export type ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { convertReceivableBorrowingBaseWaiversWithNewIds: Array<(
    { __typename?: 'ReceivableBorrowingBaseTestWaiver' }
    & ReceivableBorrowingBaseTestWaiverFragmentGQLType
  )> }
);

export type CreateLoanProductClientMutationVariablesGQLType = Exact<{
  name: Scalars['String'];
  slug: Scalars['String'];
  implementationId: Scalars['UUID'];
}>;


export type CreateLoanProductClientMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createLoanProduct: (
    { __typename?: 'LoanProduct' }
    & Pick<LoanProductGQLType, 'id' | 'name' | 'slug' | 'implementationId'>
  ) }
);

export type CreatePreassignedInternalLoanTapesFromManualAssignmentMutationVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
  signaledAssignments: Array<SignaledAssignmentsInputGQLType> | SignaledAssignmentsInputGQLType;
}>;


export type CreatePreassignedInternalLoanTapesFromManualAssignmentMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'createPreassignedInternalLoanTapesFromManualAssignment'>
);

export type CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationVariablesGQLType = Exact<{
  implementationId: Scalars['String'];
  previewIdentifier: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Float'];
  receivableResponseTapePreviewJobId: Scalars['String'];
}>;


export type CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'createPreassignedInternalLoanTapesFromPreviewMetadata'>
);

export type CreateReceivableResponseTapePreviewsFromPayloadMutationVariablesGQLType = Exact<{
  masterLoanTapeIds: Array<Scalars['String']> | Scalars['String'];
  signaledAssignments: Array<SignaledAssignmentsInputGQLType> | SignaledAssignmentsInputGQLType;
}>;


export type CreateReceivableResponseTapePreviewsFromPayloadMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createReceivableResponseTapePreviewsFromPayload: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateAssignmentServicerReportPreviewMutationVariablesGQLType = Exact<{
  assignmentServicerReportPreviewInput: AssignmentServicerReportPreviewInputGQLType;
}>;


export type CreateAssignmentServicerReportPreviewMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createAssignmentServicerReportPreview: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateAssignmentServicerReportPreviewV1MutationVariablesGQLType = Exact<{
  assignmentServicerReportPreviewInput: AssignmentServicerReportPreviewInputV1GQLType;
}>;


export type CreateAssignmentServicerReportPreviewV1MutationGQLType = (
  { __typename?: 'Mutation' }
  & { createAssignmentServicerReportPreviewV1: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateAssignmentStrategiesDefaultMutationVariablesGQLType = Exact<{
  assignmentStrategyId: Scalars['UUID'];
  isDefault: Scalars['Boolean'];
}>;


export type UpdateAssignmentStrategiesDefaultMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateAssignmentStrategiesDefault: (
    { __typename?: 'AssignmentStrategy' }
    & AssignmentStrategyFragmentGQLType
  ) }
);

export type DeleteAssignmentStrategyMutationVariablesGQLType = Exact<{
  assignmentStrategyId: Scalars['UUID'];
}>;


export type DeleteAssignmentStrategyMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteAssignmentStrategy: (
    { __typename?: 'AssignmentStrategy' }
    & AssignmentStrategyFragmentGQLType
  ) }
);

export type CreateOrUpdateAssignmentStrategyMutationVariablesGQLType = Exact<{
  strategyName: Scalars['String'];
  description: Scalars['String'];
  implementationId: Scalars['UUID'];
  strategyId?: Maybe<Scalars['UUID']>;
  loanProductCriteria: Array<LoanProductCriteriaInputGQLType> | LoanProductCriteriaInputGQLType;
  loanProductCriteriaIdsToDelete: Array<Scalars['String']> | Scalars['String'];
  eligibilityExclusions: Array<EligibilityExclusionInputGQLType> | EligibilityExclusionInputGQLType;
  eligibilityExclusionIdsToDelete: Array<Scalars['String']> | Scalars['String'];
  decisionHeuristicConfig: Scalars['String'];
}>;


export type CreateOrUpdateAssignmentStrategyMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrUpdateAssignmentStrategy: (
    { __typename?: 'AssignmentStrategy' }
    & AssignmentStrategyFragmentGQLType
  ) }
);

export type CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
  strategyId: Scalars['UUID'];
}>;


export type CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'createReceivableResponseTapePreviewsFromAssignmentStrategy'>
);

export type ValleyIbsApiRecordFragmentGQLType = (
  { __typename?: 'ValleyIbsApiRecord' }
  & Pick<ValleyIbsApiRecordGQLType, 'id' | 'action' | 'status' | 'version' | 'externalDomainTable' | 'externalDomainId' | 'executorUserId' | 'executedAt' | 'errorMessage'>
);

export type GetParticipantValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetParticipantValleyIbsApiRecordsForFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { records: Array<(
    { __typename?: 'ValleyIbsApiRecord' }
    & ValleyIbsApiRecordFragmentGQLType
  )> }
);

export type GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { records: Array<(
    { __typename?: 'ValleyIbsApiRecord' }
    & ValleyIbsApiRecordFragmentGQLType
  )> }
);

export type ExecuteValleyIbsApiRecordMutationVariablesGQLType = Exact<{
  ibsApiRecordId: Scalars['UUID'];
  loanId?: Maybe<Scalars['UUID']>;
}>;


export type ExecuteValleyIbsApiRecordMutationGQLType = (
  { __typename?: 'Mutation' }
  & { record: (
    { __typename?: 'ValleyIbsApiRecord' }
    & ValleyIbsApiRecordFragmentGQLType
  ) }
);

export type RetryValleyIbsApiRecordMutationVariablesGQLType = Exact<{
  existingIbsApiRecordId: Scalars['UUID'];
  loanId?: Maybe<Scalars['UUID']>;
}>;


export type RetryValleyIbsApiRecordMutationGQLType = (
  { __typename?: 'Mutation' }
  & { record: (
    { __typename?: 'ValleyIbsApiRecord' }
    & ValleyIbsApiRecordFragmentGQLType
  ) }
);

export type LoanRecordFragmentGQLType = (
  { __typename?: 'LoanRecord' }
  & Pick<LoanRecordGQLType, 'id' | 'creditFacilityId' | 'borrowerOrganizationId' | 'externalLoanId' | 'name' | 'loanStatus' | 'loanType' | 'isFinal' | 'maturityDate'>
);

export type ShareFundingComponentFragmentGQLType = (
  { __typename?: 'ShareFundingComponent' }
  & Pick<ShareFundingComponentGQLType, 'fundingRequestComponentId' | 'type' | 'requestedAmount' | 'targetFundingDate' | 'postingDate' | 'fundTransferDate' | 'lenderShareId' | 'lenderOrganizationId' | 'projectedInterest'>
);

export type FundingLenderSharesFragmentGQLType = (
  { __typename?: 'FundingLenderShares' }
  & Pick<FundingLenderSharesGQLType, 'lenderShareId' | 'allocationPercent' | 'initialFundingAmount' | 'outstandingBalance' | 'totalAccruedInterest' | 'projectedInterest'>
  & { lenderOrganization: (
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  ) }
);

export type FundingRequestEntitiesFragmentGQLType = (
  { __typename?: 'FundingRequestEntities' }
  & Pick<FundingRequestEntitiesGQLType, 'fundingRequestId' | 'fundingRequestStatus' | 'fundingRequestType' | 'fundingRequestCreatedAt' | 'totalRequestedAmount' | 'originationDate'>
  & { fundingComponents: Array<(
    { __typename?: 'ShareFundingComponent' }
    & ShareFundingComponentFragmentGQLType
  )> }
);

export type LoanActionRecordFragmentGQLType = (
  { __typename?: 'LoanActionRecord' }
  & Pick<LoanActionRecordGQLType, 'id' | 'action' | 'status' | 'submittedUserId' | 'approvedUserId' | 'creditFacilityId' | 'metadata'>
);

export type LoanEditDestinationDataFragmentGQLType = (
  { __typename?: 'LoanEditDestinationData' }
  & Pick<LoanEditDestinationDataGQLType, 'loanId'>
  & { loanAction: (
    { __typename?: 'LoanActionRecord' }
    & LoanActionRecordFragmentGQLType
  ) }
);

export type LoanEditDataFragmentGQLType = (
  { __typename?: 'LoanEditData' }
  & { source?: Maybe<(
    { __typename?: 'LoanEditSourceData' }
    & Pick<LoanEditSourceDataGQLType, 'loanId'>
    & { loanAction: (
      { __typename?: 'LoanActionRecord' }
      & LoanActionRecordFragmentGQLType
    ) }
  )>, destination?: Maybe<(
    { __typename?: 'LoanEditDestinationData' }
    & LoanEditDestinationDataFragmentGQLType
  )> }
);

export type ResolvedLoanFragmentGQLType = (
  { __typename?: 'ResolvedLoan' }
  & Pick<ResolvedLoanGQLType, 'id' | 'externalLoanId' | 'commitmentKey' | 'name' | 'memo' | 'calculatedLoanStatus' | 'loanType'>
  & { edits: (
    { __typename?: 'LoanEditData' }
    & LoanEditDataFragmentGQLType
  ), dates: (
    { __typename?: 'LoanDatesData' }
    & Pick<LoanDatesDataGQLType, 'originationDate' | 'targetFundingDate' | 'settledDate' | 'maturityDate'>
  ), facility: (
    { __typename?: 'LoanFacilityData' }
    & Pick<LoanFacilityDataGQLType, 'commitmentAmount' | 'creditFacilityId' | 'creditFacilityName' | 'externalFacilityId' | 'loanMechanics'>
  ), funding: (
    { __typename?: 'LoanFundingData' }
    & Pick<LoanFundingDataGQLType, 'commitmentKey' | 'initialFundingAmount' | 'totalOutstandingBalance'>
    & { lenderShares: Array<(
      { __typename?: 'FundingLenderShares' }
      & FundingLenderSharesFragmentGQLType
    )>, requests: Array<(
      { __typename?: 'FundingRequestEntities' }
      & FundingRequestEntitiesFragmentGQLType
    )> }
  ), parties: (
    { __typename?: 'LoanPartiesData' }
    & { borrowerOrganization: (
      { __typename?: 'BaseOrganization' }
      & BaseOrganizationFragmentGQLType
    ), adminAgentOrganization?: Maybe<(
      { __typename?: 'BaseOrganization' }
      & BaseOrganizationFragmentGQLType
    )>, lenderOrganizations: Array<(
      { __typename?: 'BaseOrganization' }
      & BaseOrganizationFragmentGQLType
    )> }
  ), pricing: (
    { __typename?: 'LoanPricing' }
    & Pick<LoanPricingGQLType, 'key' | 'name'>
    & { accrual: (
      { __typename?: 'LoanPricingAccrual' }
      & Pick<LoanPricingAccrualGQLType, 'basis'>
      & { cadence: (
        { __typename?: 'LoanAccrualCadence' }
        & Pick<LoanAccrualCadenceGQLType, 'type'>
      ) }
    ), current: (
      { __typename?: 'LoanInterestRateConfiguration' }
      & Pick<LoanInterestRateConfigurationGQLType, 'effectiveDate' | 'allInRate' | 'weightedAverageMarginRate'>
      & { baseRate: (
        { __typename?: 'LoanInterestRateBaseConfiguration' }
        & Pick<LoanInterestRateBaseConfigurationGQLType, 'type' | 'name' | 'determinationDate' | 'publishedDate' | 'publishedRate' | 'adjustedRate' | 'ceiling' | 'floor' | 'spread'>
      ) }
    ), history: Array<(
      { __typename?: 'LoanInterestRateConfiguration' }
      & Pick<LoanInterestRateConfigurationGQLType, 'effectiveDate' | 'weightedAverageMarginRate'>
      & { baseRate: (
        { __typename?: 'LoanInterestRateBaseConfiguration' }
        & Pick<LoanInterestRateBaseConfigurationGQLType, 'type' | 'name' | 'determinationDate' | 'publishedDate' | 'publishedRate' | 'adjustedRate'>
      ) }
    )>, margins: Array<(
      { __typename?: 'LoanShareMargin' }
      & Pick<LoanShareMarginGQLType, 'organizationId' | 'rate'>
      & { skimFee?: Maybe<(
        { __typename?: 'SkimFee' }
        & Pick<SkimFeeGQLType, 'type' | 'rate'>
      )> }
    )> }
  ), fees: (
    { __typename?: 'LoanFees' }
    & Pick<LoanFeesGQLType, 'projectedInterest' | 'projectedServiceFees'>
    & { accruedInterest: (
      { __typename?: 'AccruedInterestAndFeesSummary' }
      & Pick<AccruedInterestAndFeesSummaryGQLType, 'totalAmount'>
      & { annualAmounts: Array<Maybe<(
        { __typename?: 'AccruedInterestAndFeesAnnualAmounts' }
        & Pick<AccruedInterestAndFeesAnnualAmountsGQLType, 'year' | 'amount'>
      )>> }
    ), accruedServiceFees: (
      { __typename?: 'AccruedInterestAndFeesSummary' }
      & Pick<AccruedInterestAndFeesSummaryGQLType, 'totalAmount'>
      & { annualAmounts: Array<Maybe<(
        { __typename?: 'AccruedInterestAndFeesAnnualAmounts' }
        & Pick<AccruedInterestAndFeesAnnualAmountsGQLType, 'year' | 'amount'>
      )>> }
    ), totalAccruedInterestAndFees: (
      { __typename?: 'AccruedInterestAndFeesSummary' }
      & Pick<AccruedInterestAndFeesSummaryGQLType, 'totalAmount'>
      & { annualAmounts: Array<Maybe<(
        { __typename?: 'AccruedInterestAndFeesAnnualAmounts' }
        & Pick<AccruedInterestAndFeesAnnualAmountsGQLType, 'year' | 'amount'>
      )>> }
    ) }
  ), invoices?: Maybe<(
    { __typename?: 'LoanInvoice' }
    & Pick<LoanInvoiceGQLType, 'nextInvoiceId' | 'nextPaymentDate' | 'mostRecentAccrualEndDate'>
  )>, customerProvided?: Maybe<(
    { __typename?: 'CustomerProvided' }
    & { escrow?: Maybe<(
      { __typename?: 'CustomerProvidedEscrow' }
      & Pick<CustomerProvidedEscrowGQLType, 'amount'>
    )>, status?: Maybe<(
      { __typename?: 'CustomerProvidedStatus' }
      & Pick<CustomerProvidedStatusGQLType, 'code' | 'name'>
    )>, servicer?: Maybe<(
      { __typename?: 'CustomerProvidedServicer' }
      & Pick<CustomerProvidedServicerGQLType, 'name'>
    )> }
  )> }
);

export type SummarizedLoanFragmentGQLType = (
  { __typename?: 'SummarizedLoan' }
  & Pick<SummarizedLoanGQLType, 'id' | 'externalLoanId' | 'name' | 'calculatedLoanStatus' | 'loanType' | 'isFinal' | 'originationDate' | 'nextPaymentDate' | 'maturityDate' | 'creditFacilityId' | 'creditFacilityName' | 'externalFacilityId'>
  & { borrowerOrganization: (
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  ), lenderOrganizations: Array<(
    { __typename?: 'BaseOrganization' }
    & BaseOrganizationFragmentGQLType
  )>, edits: (
    { __typename?: 'LoanEditData' }
    & LoanEditDataFragmentGQLType
  ) }
);

export type LenderShareReportFragmentGQLType = (
  { __typename?: 'LenderShareReport' }
  & Pick<LenderShareReportGQLType, 'id' | 'creditFacilityId' | 'lenderShareId' | 'fundingRequestComponentId' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview' | 'capitalProviderName'>
);

export type BatchSettlementReportFragmentGQLType = (
  { __typename?: 'BatchSettlementReport' }
  & Pick<BatchSettlementReportGQLType, 'id' | 'creditFacilityId' | 'batchSettlementId' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview'>
);

export type BatchSettlementFragmentGQLType = (
  { __typename?: 'BatchSettlement' }
  & Pick<BatchSettlementGQLType, 'id' | 'creditFacilityId' | 'capitalProviderId' | 'startDate' | 'endDate' | 'capitalProviderName' | 'created_at'>
  & { loans: Array<(
    { __typename?: 'LoanNameAndExternalId' }
    & Pick<LoanNameAndExternalIdGQLType, 'loanId' | 'loanName' | 'externalLoanId'>
  )>, report?: Maybe<(
    { __typename?: 'BatchSettlementReport' }
    & BatchSettlementReportFragmentGQLType
  )> }
);

export type GetCreditFacilitiesLoanRecordsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesLoanRecordsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loanRecords: Array<(
      { __typename?: 'LoanRecord' }
      & Pick<LoanRecordGQLType, 'id' | 'name' | 'externalLoanId'>
    )> }
  )> }
);

export type GetCreditFacilityFullLoansQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCreditFacilityFullLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loans: Array<(
      { __typename?: 'ResolvedLoan' }
      & ResolvedLoanFragmentGQLType
    )> }
  ) }
);

export type GetCreditFacilitiesFullLoansQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesFullLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    & { loans: Array<(
      { __typename?: 'ResolvedLoan' }
      & ResolvedLoanFragmentGQLType
    )> }
  )> }
);

export type GetLoanRecordByIdQueryVariablesGQLType = Exact<{
  loanId?: Maybe<Scalars['UUID']>;
  externalLoanId?: Maybe<Scalars['UUID']>;
  creditFacilityId?: Maybe<Scalars['UUID']>;
}>;


export type GetLoanRecordByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { loan: (
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  ) }
);

export type GetLoanRecordsByMetadataQueryVariablesGQLType = Exact<{
  filterParams: LoanMetadataFilterParamsGQLType;
}>;


export type GetLoanRecordsByMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  )> }
);

export type GetResolvedLoanByIdQueryVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
}>;


export type GetResolvedLoanByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { loan: (
    { __typename?: 'ResolvedLoan' }
    & ResolvedLoanFragmentGQLType
  ) }
);

export type GetLoanRecordsByFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetLoanRecordsByFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  )> }
);

export type GetResolvedLoansByFundingRequestQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
}>;


export type GetResolvedLoansByFundingRequestQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'ResolvedLoan' }
    & ResolvedLoanFragmentGQLType
  )> }
);

export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
  commitmentKey: Scalars['String'];
}>;


export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { loan?: Maybe<(
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  )> }
);

export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
  commitmentKey: Scalars['String'];
}>;


export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { loan?: Maybe<(
    { __typename?: 'ResolvedLoan' }
    & ResolvedLoanFragmentGQLType
  )> }
);

export type GetAggregateLoansMetadataQueryVariablesGQLType = Exact<{
  filterParams: LoanMetadataFilterParamsGQLType;
}>;


export type GetAggregateLoansMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { results: (
    { __typename?: 'LoanAggregateMetadata' }
    & Pick<LoanAggregateMetadataGQLType, 'totalOutstandingBalance' | 'totalAccruedInterest' | 'totalAccruedServiceFees'>
  ) }
);

export type GetSummarizedLoansQueryVariablesGQLType = Exact<{
  filterParams: LoanMetadataFilterParamsGQLType;
}>;


export type GetSummarizedLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { loans: Array<(
    { __typename?: 'SummarizedLoan' }
    & SummarizedLoanFragmentGQLType
  )> }
);

export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
  accrualStartDate: Scalars['FullDateStr'];
  accrualEndDate: Scalars['FullDateStr'];
  inclusiveOfAccrualEndDate: Scalars['Boolean'];
}>;


export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType = (
  { __typename?: 'Query' }
  & { accounts: Array<(
    { __typename?: 'LoanAccountAccrualObject' }
    & Pick<LoanAccountAccrualObjectGQLType, 'actualAccruedAmount' | 'projectedAccruedAmount' | 'totalAccruedAmount'>
    & { tAccount: (
      { __typename?: 'TAccount' }
      & Pick<TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
    ) }
  )> }
);

export type GetLenderShareReportsQueryVariablesGQLType = Exact<{
  lenderShareId: Scalars['UUID'];
  fundingRequestComponentId: Scalars['UUID'];
}>;


export type GetLenderShareReportsQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: Array<(
    { __typename?: 'LenderShareReport' }
    & LenderShareReportFragmentGQLType
  )> }
);

export type GetLenderShareReportsForLoanQueryVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
  fundingRequestId: Scalars['UUID'];
}>;


export type GetLenderShareReportsForLoanQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: Array<(
    { __typename?: 'LenderShareReport' }
    & LenderShareReportFragmentGQLType
  )> }
);

export type GetActiveEditLoanEntitiesForLoanQueryVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
}>;


export type GetActiveEditLoanEntitiesForLoanQueryGQLType = (
  { __typename?: 'Query' }
  & { loanEditData: (
    { __typename?: 'LoanEditData' }
    & LoanEditDataFragmentGQLType
  ) }
);

export type GetEarliestOriginationDateForLoansQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  loanIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetEarliestOriginationDateForLoansQueryGQLType = (
  { __typename?: 'Query' }
  & { earliestOriginationDate: QueryGQLType['getEarliestOriginationDateForLoans'] }
);

export type GetBatchSettlementsForCreditFacilityQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  lenderIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  loanIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type GetBatchSettlementsForCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { settlements: Array<(
    { __typename?: 'BatchSettlement' }
    & BatchSettlementFragmentGQLType
  )> }
);

export type MarkLenderShareComponentFundTransferDateMutationVariablesGQLType = Exact<{
  lenderShareId: Scalars['UUID'];
  fundingRequestComponentId: Scalars['UUID'];
  fundTransferDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type MarkLenderShareComponentFundTransferDateMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'markLenderShareComponentFundTransferDate'>
);

export type SubmitLoanEditRequestMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  originalLoanId: Scalars['UUID'];
  proposedUserId: Scalars['UUID'];
  loanAttributes: EditLoanAttributesGQLType;
  fundingRequestChangesets: Array<EditFundingRequestChangesetGQLType> | EditFundingRequestChangesetGQLType;
}>;


export type SubmitLoanEditRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'submitLoanEditRequest'>
);

export type CancelLoanEditMutationVariablesGQLType = Exact<{
  loanActionId: Scalars['UUID'];
}>;


export type CancelLoanEditMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'cancelLoanEdit'>
);

export type ApproveAndExecuteLoanEditMutationVariablesGQLType = Exact<{
  originalLoanId: Scalars['UUID'];
  newLoanId: Scalars['UUID'];
  loanActionId: Scalars['UUID'];
  approvedUserId: Scalars['UUID'];
}>;


export type ApproveAndExecuteLoanEditMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'approveAndExecuteLoanEdit'>
);

export type UpdateLoanExternalLoanIdMutationVariablesGQLType = Exact<{
  loanId: Scalars['UUID'];
  newExternalLoanId?: Maybe<Scalars['String']>;
}>;


export type UpdateLoanExternalLoanIdMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateLoanExternalLoanId: (
    { __typename?: 'LoanRecord' }
    & LoanRecordFragmentGQLType
  ) }
);

export type CreateBatchSettlementMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  lenderIds: Array<Scalars['UUID']> | Scalars['UUID'];
  loanIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type CreateBatchSettlementMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createBatchSettlement: Array<(
    { __typename?: 'BatchSettlementSubmissionResult' }
    & Pick<BatchSettlementSubmissionResultGQLType, 'batchSettlementId' | 'workleaseId'>
  )> }
);

export type GetLocalizedLabelsQueryVariablesGQLType = Exact<{
  scope: Scalars['String'];
}>;


export type GetLocalizedLabelsQueryGQLType = (
  { __typename?: 'Query' }
  & { getLocalizedLabels?: Maybe<(
    { __typename?: 'LocalizedLabels' }
    & Pick<LocalizedLabelsGQLType, 'scope'>
    & { labels: Array<(
      { __typename?: 'LocalizedLabel' }
      & Pick<LocalizedLabelGQLType, 'labelKey' | 'localizedValue'>
    )> }
  )> }
);

export type ColumnInfoFragmentGQLType = (
  { __typename?: 'ColumnInfo' }
  & Pick<ColumnInfoGQLType, 'name' | 'required' | 'type' | 'description' | 'examples' | 'defaultValue'>
);

export type RequiredDataTapeFragmentGQLType = (
  { __typename?: 'RequiredDataTape' }
  & Pick<RequiredDataTapeGQLType, 'externalFilename' | 'artifactType' | 'artifactSlug' | 'artifactId' | 'validCreditFacilityIds' | 'loanProductSlug' | 'currentFileVersion' | 'currentReportingDate' | 'progressSummary' | 'fileExtension'>
  & { columns: Array<(
    { __typename?: 'ColumnInfo' }
    & ColumnInfoFragmentGQLType
  )> }
);

export type RequiredXlsxTapeFragmentGQLType = (
  { __typename?: 'RequiredXlsxTape' }
  & Pick<RequiredXlsxTapeGQLType, 'externalFilename' | 'artifactType' | 'artifactSlug' | 'artifactId' | 'validCreditFacilityIds' | 'loanProductSlug' | 'currentFileVersion' | 'currentReportingDate' | 'progressSummary' | 'fileExtension'>
  & { valueFieldGroups: Array<(
    { __typename?: 'XlsxValueFieldGroup' }
    & Pick<XlsxValueFieldGroupGQLType, 'dataTapeSlug'>
    & { columns: Array<(
      { __typename?: 'ColumnInfo' }
      & Pick<ColumnInfoGQLType, 'sheetName' | 'cellAddress'>
      & ColumnInfoFragmentGQLType
    )> }
  )>, tapeFieldGroups: Array<(
    { __typename?: 'XlsxTapeFieldGroup' }
    & Pick<XlsxTapeFieldGroupGQLType, 'dataTapeSlug' | 'sheetName' | 'headerRange'>
    & { columns: Array<(
      { __typename?: 'ColumnInfo' }
      & ColumnInfoFragmentGQLType
    )> }
  )> }
);

export type GetRequiredDataTapesQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  omitOrgProvidedInputGraphs: Scalars['Boolean'];
  reportingDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetRequiredDataTapesQueryGQLType = (
  { __typename?: 'Query' }
  & { getRequiredDataTapes: (
    { __typename?: 'RequiredDataTapes' }
    & { requiredDataTapesGroupings: Array<(
      { __typename?: 'RequiredDataTapeGrouping' }
      & Pick<RequiredDataTapeGroupingGQLType, 'latestReportingDate'>
      & { requiredDataTapes: Array<(
        { __typename?: 'RequiredDataTape' }
        & RequiredDataTapeFragmentGQLType
      )>, requiredXlsxTapes: Array<(
        { __typename?: 'RequiredXlsxTape' }
        & RequiredXlsxTapeFragmentGQLType
      )>, requiredCashBalances: Array<(
        { __typename?: 'RequiredCashBalance' }
        & Pick<RequiredCashBalanceGQLType, 'externalFilename' | 'creditFacilityId' | 'artifactType' | 'artifactSlug' | 'artifactId' | 'currentFileVersion' | 'currentReportingDate' | 'accountTypesWithConnectionProvider'>
        & { columns: Array<(
          { __typename?: 'ColumnInfo' }
          & Pick<ColumnInfoGQLType, 'name' | 'required' | 'type' | 'description' | 'examples' | 'defaultValue'>
        )> }
      )> }
    )> }
  ) }
);

export type GetRequiredDataTapesForVerificationQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetRequiredDataTapesForVerificationQueryGQLType = (
  { __typename?: 'Query' }
  & { getRequiredDataTapesForVerification: (
    { __typename?: 'RequiredDataTapes' }
    & { requiredDataTapesGroupings: Array<(
      { __typename?: 'RequiredDataTapeGrouping' }
      & Pick<RequiredDataTapeGroupingGQLType, 'latestReportingDate'>
      & { requiredDataTapes: Array<(
        { __typename?: 'RequiredDataTape' }
        & RequiredDataTapeFragmentGQLType
      )>, requiredXlsxTapes: Array<(
        { __typename?: 'RequiredXlsxTape' }
        & RequiredXlsxTapeFragmentGQLType
      )> }
    )> }
  ) }
);

export type EmailSubscriptionFragmentGQLType = (
  { __typename?: 'EmailSubscription' }
  & Pick<EmailSubscriptionGQLType, 'id' | 'userId' | 'emailType'>
  & { filter: (
    { __typename?: 'SubscriptionFilter' }
    & Pick<SubscriptionFilterGQLType, 'creditFacilitySlugs'>
  ) }
);

export type UserWithEmailSubscriptionsFragmentGQLType = (
  { __typename?: 'User' }
  & Pick<UserGQLType, 'id' | 'email' | 'userType' | 'isActive' | 'organizationId' | 'roleType' | 'firstName' | 'lastName'>
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
  ), emailSubscriptions: Array<(
    { __typename?: 'EmailSubscription' }
    & EmailSubscriptionFragmentGQLType
  )> }
);

export type GetUserWithEmailSubscriptionsQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetUserWithEmailSubscriptionsQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & UserWithEmailSubscriptionsFragmentGQLType
  )> }
);

export type OrgProvidedInputFragFragmentGQLType = (
  { __typename?: 'OrgProvidedInput' }
  & Pick<OrgProvidedInputGQLType, 'id' | 'organizationId' | 'key' | 'type' | 'nullable'>
);

export type OrgProvidedValueFragFragmentGQLType = (
  { __typename?: 'OrgProvidedValue' }
  & Pick<OrgProvidedValueGQLType, 'id' | 'orgProvidedInputId' | 'value' | 'reportingDate' | 'version' | 'supplementalS3Path'>
);

export type GetOrgProvidedInputsByOrgIdQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrgProvidedInputsByOrgIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedInputsByOrgId: Array<(
    { __typename?: 'OrgProvidedInput' }
    & OrgProvidedInputFragFragmentGQLType
  )> }
);

export type GetOrgProvidedInputByIdQueryVariablesGQLType = Exact<{
  orgProvidedInputId: Scalars['UUID'];
}>;


export type GetOrgProvidedInputByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedInputById: (
    { __typename?: 'OrgProvidedInput' }
    & OrgProvidedInputFragFragmentGQLType
  ) }
);

export type GetOrgProvidedInputByKeyQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
}>;


export type GetOrgProvidedInputByKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedInputByKey: (
    { __typename?: 'OrgProvidedInput' }
    & OrgProvidedInputFragFragmentGQLType
  ) }
);

export type GetOrgProvidedValueByIdQueryVariablesGQLType = Exact<{
  orgProvidedValueId: Scalars['UUID'];
}>;


export type GetOrgProvidedValueByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedValueById: (
    { __typename?: 'OrgProvidedValue' }
    & OrgProvidedValueFragFragmentGQLType
  ) }
);

export type GetOrgProvidedValuesByKeyQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetOrgProvidedValuesByKeyQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedValuesByKey: Array<(
    { __typename?: 'OrgProvidedValue' }
    & OrgProvidedValueFragFragmentGQLType
  )> }
);

export type GetOrgProvidedValuesByKeysQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  keys: Array<Scalars['String']> | Scalars['String'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetOrgProvidedValuesByKeysQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedValuesByKeys: Array<(
    { __typename?: 'OrgProvidedValue' }
    & OrgProvidedValueFragFragmentGQLType
  )> }
);

export type GetOrgProvidedValueByReportingPeriodQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  reportingPeriod: Scalars['String'];
}>;


export type GetOrgProvidedValueByReportingPeriodQueryGQLType = (
  { __typename?: 'Query' }
  & { getOrgProvidedValueByReportingPeriod?: Maybe<(
    { __typename?: 'OrgProvidedValue' }
    & OrgProvidedValueFragFragmentGQLType
  )> }
);

export type CreateOrgProvidedInputMutationVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
  key: Scalars['String'];
  type: OrgProvidedInputTypeGQLType;
  nullable: Scalars['Boolean'];
}>;


export type CreateOrgProvidedInputMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrgProvidedInput: (
    { __typename?: 'OrgProvidedInput' }
    & OrgProvidedInputFragFragmentGQLType
  ) }
);

export type CreateOrgProvidedValueMutationVariablesGQLType = Exact<{
  orgProvidedInputId: Scalars['UUID'];
  value?: Maybe<Scalars['Primitive']>;
  reportingDate: Scalars['FullDateStr'];
  supplementalS3Path?: Maybe<Scalars['String']>;
}>;


export type CreateOrgProvidedValueMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrgProvidedValue: (
    { __typename?: 'OrgProvidedValue' }
    & OrgProvidedValueFragFragmentGQLType
  ) }
);

export type BaseOrganizationFragmentGQLType = (
  { __typename?: 'BaseOrganization' }
  & Pick<BaseOrganizationGQLType, 'id' | 'name' | 'slug'>
);

export type GetOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
    & { users: Array<(
      { __typename?: 'User' }
      & Pick<UserGQLType, 'id' | 'firstName' | 'lastName' | 'email' | 'roleType'>
    )> }
  ) }
);

export type GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationActiveCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
    & { creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
    )> }
  ) }
);

export type GetOrganizationsByIdsQueryVariablesGQLType = Exact<{
  organizationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetOrganizationsByIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { organizationsByIds: Array<(
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
  )> }
);

export type GetOrganizationsByIdsWithUsersQueryVariablesGQLType = Exact<{
  organizationIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetOrganizationsByIdsWithUsersQueryGQLType = (
  { __typename?: 'Query' }
  & { organizationsByIds: Array<(
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug' | 'name' | 'type'>
    & { users: Array<(
      { __typename?: 'User' }
      & Pick<UserGQLType, 'id' | 'firstName' | 'lastName' | 'email' | 'roleType'>
    )> }
  )> }
);

export type GetCapitalProvidersQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCapitalProvidersQueryGQLType = (
  { __typename?: 'Query' }
  & { capitalProviders: Array<(
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'name' | 'type' | 'slug'>
  )> }
);

export type GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  partyType: PartyTypeGQLType;
}>;


export type GetPartiesByTypeAndCreditFacilityIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { partiesByTypeAndCreditFacilityIds: Array<(
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'name' | 'type' | 'slug'>
  )> }
);

export type GetOrganizationLoanProductsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationLoanProductsQueryGQLType = (
  { __typename?: 'Query' }
  & { organization: (
    { __typename?: 'Organization' }
    & Pick<OrganizationGQLType, 'id' | 'slug'>
    & { loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'name' | 'slug' | 'implementationId'>
      & { currentMasterLoanTape?: Maybe<(
        { __typename?: 'MasterLoanTapeMetadata' }
        & Pick<MasterLoanTapeMetadataGQLType, 'id' | 'fileVersion' | 'reportingDate'>
      )> }
    )> }
  ) }
);

export type GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetOrganizationLoanProductsByCreditFacilityQueryGQLType = (
  { __typename?: 'Query' }
  & { result: (
    { __typename?: 'Organization' }
    & { creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
      & { loanProducts: Array<(
        { __typename?: 'LoanProduct' }
        & Pick<LoanProductGQLType, 'id' | 'slug' | 'name'>
      )> }
    )> }
  ) }
);

export type GetAthenaSchemaForOrganizationQueryVariablesGQLType = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetAthenaSchemaForOrganizationQueryGQLType = (
  { __typename?: 'Query' }
  & { athenaTables: Array<(
    { __typename?: 'AthenaTable' }
    & Pick<AthenaTableGQLType, 'tableName'>
    & { properties: Array<(
      { __typename?: 'AthenaTableProperty' }
      & Pick<AthenaTablePropertyGQLType, 'name' | 'type'>
    )> }
  )> }
);

export type CreateUserMutationVariablesGQLType = Exact<{
  userData: CreateUserGQLType;
}>;


export type CreateUserMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createUser?: Maybe<(
    { __typename?: 'UserObject' }
    & Pick<UserObjectGQLType, 'id' | 'firstName' | 'lastName' | 'email' | 'roleType'>
  )> }
);

export type RemoveUserMutationVariablesGQLType = Exact<{
  userId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
}>;


export type RemoveUserMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'removeUser'>
);

export type UpdateUserMutationVariablesGQLType = Exact<{
  settings: UpdateUserSettingsGQLType;
}>;


export type UpdateUserMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateUserSettingsWithRole?: Maybe<(
    { __typename?: 'UserObject' }
    & Pick<UserObjectGQLType, 'id' | 'email' | 'firstName' | 'lastName' | 'roleType'>
  )> }
);

export type UpdateLoanProductNameMutationVariablesGQLType = Exact<{
  id: Scalars['UUID'];
  newName: Scalars['String'];
}>;


export type UpdateLoanProductNameMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateLoanProductName: (
    { __typename?: 'LoanProduct' }
    & Pick<LoanProductGQLType, 'name'>
  ) }
);

export type CoreBorrowingBaseInsightsFragmentGQLType = (
  { __typename?: 'CoreBorrowingBaseInsightsGqlData' }
  & Pick<CoreBorrowingBaseInsightsGqlDataGQLType, 'reportingDate' | 'fileVersion' | 'totalReceivableExposure' | 'totalEligibleExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalReceivableBorrowingBaseAmount' | 'effectiveReceivableAdvanceRate' | 'totalEligibleBorrowingBaseAccountCash' | 'totalCollectionsAccountCash' | 'totalPreAdvanceCashContribution' | 'totalCashBorrowingBaseAmount' | 'effectiveCashAdvanceRate' | 'totalBorrowingBaseAmount' | 'effectiveAdvanceRate' | 'totalAssets' | 'commitmentAmount' | 'currentPrincipalBalance' | 'totalFacilityUtilization'>
);

export type GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyCoreBorrowingBaseInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyCoreBorrowingBaseInsights: Array<(
    { __typename?: 'CoreBorrowingBaseInsightsGqlData' }
    & CoreBorrowingBaseInsightsFragmentGQLType
  )> }
);

export type GetDailyEligibilityInsightsQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyEligibilityInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyEligibilityInsights: Array<(
    { __typename?: 'EligibilityAggregateInsightsGqlData' }
    & Pick<EligibilityAggregateInsightsGqlDataGQLType, 'reportingDate' | 'totalEligibleExposure' | 'totalNetEligibilityKickout' | 'totalGrossEligibilityKickout'>
    & { eligibilityPropertiesData: Array<(
      { __typename?: 'EligibilityPropertyInsightsGqlData' }
      & Pick<EligibilityPropertyInsightsGqlDataGQLType, 'propertyKey' | 'totalEligibilityKickout'>
    )> }
  )> }
);

export type GetDailyConcentrationInsightsQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyConcentrationInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyConcentrationInsights: Array<(
    { __typename?: 'ConcentrationLimitAggregateInsightsGqlData' }
    & Pick<ConcentrationLimitAggregateInsightsGqlDataGQLType, 'reportingDate' | 'totalConcentrationLimitKickout'>
    & { concentrationLimitsData: Array<(
      { __typename?: 'ConcentrationLimitInsightsGqlData' }
      & Pick<ConcentrationLimitInsightsGqlDataGQLType, 'reportingDate' | 'propertyKey' | 'valueType' | 'concentrationAmount' | 'concentrationLimit' | 'concentration' | 'totalConcentrationLimitKickout'>
    )> }
  )> }
);

export type GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
}>;


export type GetDailyPreadvanceCollectionsCashBalanceQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyCoreBorrowingBaseInsights: Array<(
    { __typename?: 'CoreBorrowingBaseInsightsGqlData' }
    & Pick<CoreBorrowingBaseInsightsGqlDataGQLType, 'reportingDate' | 'totalCollectionsAccountCash'>
  )> }
);

export type GetDailyTotalRiskInsightsQueryVariablesGQLType = Exact<{
  organizationParams: OrganizationInsightsParamInputGQLType;
}>;


export type GetDailyTotalRiskInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { riskData: (
    { __typename?: 'TotalRiskInsightsOutputData' }
    & { borrowingBaseRisk: Array<(
      { __typename?: 'AggregateBorrowingRiskInsightsGqlData' }
      & Pick<AggregateBorrowingRiskInsightsGqlDataGQLType, 'reportingDate' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalCollectionsAccountCash' | 'currentPrincipalBalance' | 'collateralCovenantLtv' | 'netOutstandingLtv' | 'performingLtv'>
      & { creditFacilityData: Array<(
        { __typename?: 'CreditFacilityBorrowingRiskInsightsGqlData' }
        & Pick<CreditFacilityBorrowingRiskInsightsGqlDataGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'reportingDate' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalCollectionsAccountCash' | 'currentPrincipalBalance' | 'collateralCovenantLtv' | 'netOutstandingLtv' | 'performingLtv'>
      )> }
    )>, receivableRisk: Array<(
      { __typename?: 'AggregateReceivableRiskInsightsGqlData' }
      & Pick<AggregateReceivableRiskInsightsGqlDataGQLType, 'reportingDate' | 'totalExposure' | 'totalNormalizedIsChargedOffExposure' | 'totalNormalizedIsDelinquentExposure' | 'chargedOffPercentageOfTotalExposure' | 'delinquentPercentageOfTotalExposure'>
      & { creditFacilityData: Array<(
        { __typename?: 'CreditFacilityReceivableRiskInsightsGqlData' }
        & Pick<CreditFacilityReceivableRiskInsightsGqlDataGQLType, 'reportingDate' | 'creditFacilityId' | 'creditFacilitySlug' | 'totalExposure' | 'totalNormalizedIsChargedOffExposure' | 'totalNormalizedIsDelinquentExposure' | 'chargedOffPercentageOfTotalExposure' | 'delinquentPercentageOfTotalExposure'>
      )> }
    )> }
  ) }
);

export type GetDailyReceivableExposureInsightsQueryVariablesGQLType = Exact<{
  organizationParams: OrganizationInsightsParamInputGQLType;
}>;


export type GetDailyReceivableExposureInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyReceivableExposureInsights: Array<(
    { __typename?: 'AggregateReceivableExposureInsightsGqlData' }
    & Pick<AggregateReceivableExposureInsightsGqlDataGQLType, 'reportingDate' | 'totalExposure' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalReceivableBorrowingBase'>
    & { creditFacilityData: Array<(
      { __typename?: 'CreditFacilityReceivableExposureInsightsGqlData' }
      & Pick<CreditFacilityReceivableExposureInsightsGqlDataGQLType, 'reportingDate' | 'creditFacilityId' | 'creditFacilitySlug' | 'totalExposure' | 'totalPerformingExposure' | 'totalEligibleExposureLessConcentrationKickouts' | 'totalReceivableBorrowingBase'>
    )> }
  )> }
);

export type GetDailyPrincipalInsightsQueryVariablesGQLType = Exact<{
  organizationParams: OrganizationInsightsParamInputGQLType;
}>;


export type GetDailyPrincipalInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getDailyPrincipalInsights: Array<(
    { __typename?: 'AggregatePrincipalInsightsGqlData' }
    & Pick<AggregatePrincipalInsightsGqlDataGQLType, 'reportingDate' | 'currentPrincipalBalance' | 'commitmentAmount' | 'totalFacilityUtilization'>
    & { creditFacilityData: Array<(
      { __typename?: 'CreditFacilityPrincipalInsightsGqlData' }
      & Pick<CreditFacilityPrincipalInsightsGqlDataGQLType, 'reportingDate' | 'creditFacilityId' | 'creditFacilitySlug' | 'currentPrincipalBalance' | 'commitmentAmount' | 'totalFacilityUtilization'>
    )> }
  )> }
);

export type GetProfitOverviewInsightsQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
}>;


export type GetProfitOverviewInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getProfitOverviewInsights: Array<(
    { __typename?: 'CreditFacilityProfitOverviewInsightsGqlData' }
    & Pick<CreditFacilityProfitOverviewInsightsGqlDataGQLType, 'creditFacilityId' | 'creditFacilitySlug' | 'reportingDate' | 'totalExposure' | 'totalNormalizedIsChargedOffExposure' | 'totalNormalizedIsDelinquentExposure' | 'totalExposureDaysPastDue0' | 'totalExposureDaysPastDue1to30' | 'totalExposureDaysPastDue31to60' | 'totalExposureDaysPastDue61to90' | 'totalExposureDaysPastDue91to120' | 'totalExposureDaysPastDue121plus' | 'chargedOffPercentageOfTotalExposure' | 'delinquentPercentageOfTotalExposure' | 'percentExposureDaysPastDue0' | 'percentExposureDaysPastDue1to30' | 'percentExposureDaysPastDue31to60' | 'percentExposureDaysPastDue61to90' | 'percentExposureDaysPastDue91to120' | 'percentExposureDaysPastDue121plus'>
  )> }
);

export type GetProfitVintageInsightsQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityInsightsParamInputGQLType;
}>;


export type GetProfitVintageInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getProfitVintageInsights: (
    { __typename?: 'CreditFacilityProfitFullVintageInsightsGqlData' }
    & { profitVintageInputData: Array<(
      { __typename?: 'CreditFacilityProfitVintageInputInsightsGqlData' }
      & Pick<CreditFacilityProfitVintageInputInsightsGqlDataGQLType, 'cohortBaseDate' | 'cohortSeriesDate' | 'totalVintageCalcValue' | 'totalNormalizedIsChargedOffVintageCalcValue' | 'totalNormalizedIsDelinquentVintageCalcValue'>
    )> }
  ) }
);

export type GetRepaymentVintageInsightsQueryVariablesGQLType = Exact<{
  creditFacilityParams: CreditFacilityRepaymentInsightsParamInputGQLType;
}>;


export type GetRepaymentVintageInsightsQueryGQLType = (
  { __typename?: 'Query' }
  & { getRepaymentVintageInsights: (
    { __typename?: 'CreditFacilityRepaymentVintageInsightsGqlData' }
    & { repaymentVintageInputData: Array<(
      { __typename?: 'CreditFacilityRepaymentVintageInputInsightsGqlData' }
      & Pick<CreditFacilityRepaymentVintageInputInsightsGqlDataGQLType, 'cohortBaseDate' | 'cohortSeriesDate' | 'cumulativeRepayments'>
    )>, receivableOriginationSummaryInfo: Array<(
      { __typename?: 'CreditFacilityReceivableOriginationSummaryInfo' }
      & Pick<CreditFacilityReceivableOriginationSummaryInfoGQLType, 'originationDate' | 'originatedReceivablesCount' | 'totalInitialBalanceOfOriginatedReceivables'>
    )> }
  ) }
);

export type GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetCustomerProvidedVariablesAndValuesQueryGQLType = (
  { __typename?: 'Query' }
  & { attributes: Array<(
    { __typename?: 'Attribute' }
    & AttributeFragmentFragmentGQLType
  )> }
);

export type CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType = Exact<{
  attributeId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  effectiveFromReportingDate: Scalars['FullDateStr'];
  value: AttributeValueInputGQLType;
}>;


export type CreateOrUpdateCustomerProvidedValueMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createOrUpdateCustomerProvidedValue: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType = Exact<{
  worklease: ReportingGenerateWorkleaseGQLType;
}>;


export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType = (
  { __typename?: 'Query' }
  & { inputConfig: (
    { __typename?: 'EvaluatedReportingInputConfig' }
    & Pick<EvaluatedReportingInputConfigGQLType, 'errors'>
    & { variables: Array<(
      { __typename?: 'ReportingVariable' }
      & Pick<ReportingVariableGQLType, 'name' | 'value'>
    )> }
  ) }
);

export type GetReportsByCreditFacilityIdQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetReportsByCreditFacilityIdQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: Array<(
    { __typename?: 'DownloadableReport' }
    & Pick<DownloadableReportGQLType, 'id' | 'reportName' | 'reportType' | 'isPreview' | 'reportingDate' | 'version'>
  )> }
);

export type GetReportS3DownloadUrlQueryVariablesGQLType = Exact<{
  reportId: Scalars['UUID'];
  reportConfigType: ReportConfigTypeGQLType;
}>;


export type GetReportS3DownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrl: QueryGQLType['getReportS3DownloadUrl'] }
);

export type GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryVariablesGQLType = Exact<{
  reportingWorkleaseRecordId: Scalars['UUID'];
  reportConfigType: ReportConfigTypeGQLType;
}>;


export type GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getReportS3DownloadUrlByReportingWorkleaseRecordId: (
    { __typename?: 'S3DownloadUrlByWorklease' }
    & Pick<S3DownloadUrlByWorkleaseGQLType, 'workleaseStatus' | 's3DownloadUrl' | 'error'>
  ) }
);

export type GetReportsS3DownloadUrlsQueryVariablesGQLType = Exact<{
  reportIdsWithFilename: Array<ReportIdWithFilenameInputGQLType> | ReportIdWithFilenameInputGQLType;
  reportConfigType: ReportConfigTypeGQLType;
}>;


export type GetReportsS3DownloadUrlsQueryGQLType = (
  { __typename?: 'Query' }
  & { getReportsS3DownloadUrls: Array<(
    { __typename?: 'ReportS3DownloadUrlWithFilename' }
    & Pick<ReportS3DownloadUrlWithFilenameGQLType, 's3DownloadUrl' | 'filename'>
  )> }
);

export type GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryVariablesGQLType = Exact<{
  reportingWorkleaseRecordIds: Array<Scalars['UUID']> | Scalars['UUID'];
  reportConfigType: ReportConfigTypeGQLType;
}>;


export type GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { getReportS3DownloadUrlsByReportingWorkleaseRecordIds: Array<(
    { __typename?: 'S3DownloadUrlByWorklease' }
    & Pick<S3DownloadUrlByWorkleaseGQLType, 'workleaseStatus' | 's3DownloadUrl' | 'error'>
  )> }
);

export type GetReportingTemplateDownloadUrlQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  creditAgreementId: Scalars['UUID'];
  reportName: Scalars['String'];
}>;


export type GetReportingTemplateDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrl: QueryGQLType['getReportingTemplateDownloadUrl'] }
);

export type GetStatementQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetStatementQueryGQLType = (
  { __typename?: 'Query' }
  & { generateStatement: (
    { __typename?: 'FormattedStatement' }
    & Pick<FormattedStatementGQLType, 'creditFacilityId' | 'paymentDate' | 'rows'>
    & { period: (
      { __typename?: 'FormattedStatementPeriod' }
      & Pick<FormattedStatementPeriodGQLType, 'startDate' | 'endDate' | 'cutoffTime'>
    ), summary: (
      { __typename?: 'FormattedStatementSummary' }
      & Pick<FormattedStatementSummaryGQLType, 'totalBalance'>
      & { balances: Array<(
        { __typename?: 'SummaryBalance' }
        & Pick<SummaryBalanceGQLType, 'description' | 'balance'>
        & { accounts: Array<(
          { __typename?: 'SummaryBalanceAccount' }
          & Pick<SummaryBalanceAccountGQLType, 'organizationId' | 'account' | 'balance'>
        )> }
      )> }
    ), columns: Array<(
      { __typename?: 'FormattedStatementColumn' }
      & Pick<FormattedStatementColumnGQLType, 'name'>
      & { format: (
        { __typename?: 'FormattedStatementColumnFormat' }
        & Pick<FormattedStatementColumnFormatGQLType, 'type' | 'currency'>
      ) }
    )> }
  ) }
);

export type GenerateSummaryPeriodStatementQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  cadence: SummaryStatementCadenceGQLType;
  cutoffCreatedDate?: Maybe<Scalars['JSDate']>;
}>;


export type GenerateSummaryPeriodStatementQueryGQLType = (
  { __typename?: 'Query' }
  & { summary: Array<(
    { __typename?: 'SummaryPeriodStatement' }
    & Pick<SummaryPeriodStatementGQLType, 'startDate' | 'endDate' | 'totalStartingBalance' | 'totalEndingBalance'>
    & { accountBalances: Array<(
      { __typename?: 'SummaryAccountBalance' }
      & Pick<SummaryAccountBalanceGQLType, 'tAccount' | 'startingBalance' | 'endingBalance'>
    )> }
  )> }
);

export type GetMultiFacilityStatementQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
  transactionAggregation: StatementTransactionAggregationLevelGQLType;
}>;


export type GetMultiFacilityStatementQueryGQLType = (
  { __typename?: 'Query' }
  & { generateMultiFacilityStatement: (
    { __typename?: 'FormattedMultiFacilityStatement' }
    & Pick<FormattedMultiFacilityStatementGQLType, 'creditFacilityIds' | 'paymentDate' | 'rows'>
    & { period: (
      { __typename?: 'FormattedStatementPeriod' }
      & Pick<FormattedStatementPeriodGQLType, 'startDate' | 'endDate' | 'cutoffTime'>
    ), summary: (
      { __typename?: 'FormattedStatementSummary' }
      & Pick<FormattedStatementSummaryGQLType, 'totalBalance'>
      & { balances: Array<(
        { __typename?: 'SummaryBalance' }
        & Pick<SummaryBalanceGQLType, 'description' | 'balance'>
        & { accounts: Array<(
          { __typename?: 'SummaryBalanceAccount' }
          & Pick<SummaryBalanceAccountGQLType, 'organizationId' | 'account' | 'balance'>
        )> }
      )> }
    ), columns: Array<(
      { __typename?: 'FormattedStatementColumn' }
      & Pick<FormattedStatementColumnGQLType, 'name'>
      & { format: (
        { __typename?: 'FormattedStatementColumnFormat' }
        & Pick<FormattedStatementColumnFormatGQLType, 'type' | 'currency'>
      ) }
    )> }
  ) }
);

export type ProduceReportingGenerateMessageMutationVariablesGQLType = Exact<{
  worklease: ReportingGenerateWorkleaseGQLType;
  parameters?: Maybe<Scalars['Object']>;
}>;


export type ProduceReportingGenerateMessageMutationGQLType = (
  { __typename?: 'Mutation' }
  & { result: (
    { __typename?: 'ReportingGenerateResponse' }
    & Pick<ReportingGenerateResponseGQLType, 'status' | 'recordId'>
  ) }
);

export type ProduceReportingGenerateMessagesMutationVariablesGQLType = Exact<{
  workleases: Array<ReportingGenerateWorkleaseGQLType> | ReportingGenerateWorkleaseGQLType;
}>;


export type ProduceReportingGenerateMessagesMutationGQLType = (
  { __typename?: 'Mutation' }
  & { result: Array<(
    { __typename?: 'ReportingGenerateResponse' }
    & Pick<ReportingGenerateResponseGQLType, 'status' | 'recordId'>
  )> }
);

export type GenerateReportingOutputFileDevOnlyMutationVariablesGQLType = Exact<{
  worklease: ReportingGenerateWorkleaseGQLType;
  parameters?: Maybe<Scalars['Object']>;
}>;


export type GenerateReportingOutputFileDevOnlyMutationGQLType = (
  { __typename?: 'Mutation' }
  & { result: (
    { __typename?: 'ReportingGenerateResponse' }
    & Pick<ReportingGenerateResponseGQLType, 'status'>
  ) }
);

export type AdjustCurrentLiabilityMutationVariablesGQLType = Exact<{
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  counterpartyOrganizationId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  currentLiabilityAccount: Scalars['String'];
  date: Scalars['FullDateStr'];
  type: AdjustCurrentLiabilityTypesGQLType;
}>;


export type AdjustCurrentLiabilityMutationGQLType = (
  { __typename?: 'Mutation' }
  & { adjustCurrentLiability: (
    { __typename?: 'AccountingAdjustmentResponse' }
    & Pick<AccountingAdjustmentResponseGQLType, 'success' | 'errors'>
  ) }
);

export type GetReportsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  limit?: Maybe<Scalars['Int']>;
  reportTypes?: Maybe<Array<ReportTypeGQLType> | ReportTypeGQLType>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['JSDate']>;
  endDate?: Maybe<Scalars['JSDate']>;
  isPreview?: Maybe<Scalars['Boolean']>;
}>;


export type GetReportsQueryGQLType = (
  { __typename?: 'Query' }
  & { reports: (
    { __typename?: 'ReportsConnection' }
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), nodes: Array<(
      { __typename?: 'Report' }
      & Pick<ReportGQLType, 'id' | 'borrowerId' | 'reportType' | 's3Path' | 'isPreview' | 'created_at' | 'updated_at'>
    )> }
  ) }
);

export type GetReportDownloadUrlQueryVariablesGQLType = Exact<{
  reportId: Scalars['UUID'];
  isDomainReport: Scalars['Boolean'];
}>;


export type GetReportDownloadUrlQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'reportDownloadUrl'>
);

export type LedgerTransactionFragmentGQLType = (
  { __typename?: 'LedgerTransaction' }
  & Pick<LedgerTransactionGQLType, 'organizationId' | 'transactionType' | 'amount' | 'normalizedAmount' | 'type' | 'accountType' | 'postingDate' | 'balance' | 'comment'>
);

export type GetTAccountsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetTAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { getTAccounts: Array<(
    { __typename?: 'TAccount' }
    & Pick<TAccountGQLType, 'id' | 'creditFacilityId' | 'organizationId' | 'tAccount'>
  )> }
);

export type GetLedgerAccountsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  ledgerAccountGroup: LedgerAccountGroupGQLType;
}>;


export type GetLedgerAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { ledgerAccounts: Array<(
    { __typename?: 'AccountDetails' }
    & Pick<AccountDetailsGQLType, 'id' | 'creditFacilityId' | 'organizationId' | 'tAccount'>
  )> }
);

export type GetLedgerQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  organizationIds: Array<Scalars['UUID']> | Scalars['UUID'];
  selectedTransactionTypes?: Maybe<Array<TransactionTypeGQLType> | TransactionTypeGQLType>;
  accountTypes: Array<TAccountTypeGQLType> | TAccountTypeGQLType;
  startDate?: Maybe<Scalars['LuxonDate']>;
  endDate?: Maybe<Scalars['LuxonDate']>;
}>;


export type GetLedgerQueryGQLType = (
  { __typename?: 'Query' }
  & { ledger: Array<(
    { __typename?: 'LedgerTransaction' }
    & LedgerTransactionFragmentGQLType
  )> }
);

export type GetLatestLedgersForCreditFacilitiesQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  countersignerOrganizationIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  ledgerAccountGroup: LedgerAccountGroupGQLType;
}>;


export type GetLatestLedgersForCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { latestLedgersForCreditFacilities: Array<(
    { __typename?: 'LedgerTransactionWithCreditFacilityId' }
    & Pick<LedgerTransactionWithCreditFacilityIdGQLType, 'creditFacilityId'>
    & { ledger: (
      { __typename?: 'LedgerTransaction' }
      & LedgerTransactionFragmentGQLType
    ) }
  )> }
);

export type GetImplementationDetailsQueryVariablesGQLType = Exact<{
  implementationId: Scalars['UUID'];
}>;


export type GetImplementationDetailsQueryGQLType = (
  { __typename?: 'Query' }
  & { getImplementationDetails: (
    { __typename?: 'Implementation' }
    & Pick<ImplementationGQLType, 'id' | 'slug' | 'name' | 'borrowerPipelineDefinitionId'>
    & { ownerOrganization: (
      { __typename?: 'BaseOrganization' }
      & Pick<BaseOrganizationGQLType, 'id' | 'name' | 'slug'>
    ), borrowerOrganization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug' | 'type' | 'industry'>
    ), loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'slug' | 'name'>
    )>, creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
      & { borrower: (
        { __typename?: 'Organization' }
        & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
      ) }
    )> }
  ) }
);

export type GetBorrowingBasePipelineArtifactDocumentsQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
}>;


export type GetBorrowingBasePipelineArtifactDocumentsQueryGQLType = (
  { __typename?: 'Query' }
  & { borrowingBasePipelineArtifactDocuments: Array<(
    { __typename?: 'BorrowingBasePipelineArtifactDocument' }
    & Pick<BorrowingBasePipelineArtifactDocumentGQLType, 'id' | 'version' | 'isWip'>
  )> }
);

export type GetBorrowingBasePipelineStatusQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
}>;


export type GetBorrowingBasePipelineStatusQueryGQLType = (
  { __typename?: 'Query' }
  & { implementation: (
    { __typename?: 'Implementation' }
    & { borrowerOrganization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'slug'>
    ), creditFacilities: Array<(
      { __typename?: 'CreditFacility' }
      & Pick<CreditFacilityGQLType, 'id' | 'slug'>
    )>, loanProducts: Array<(
      { __typename?: 'LoanProduct' }
      & Pick<LoanProductGQLType, 'id' | 'slug'>
    )> }
  ), borrowingBasePipelineStatus: (
    { __typename?: 'BorrowingBasePipelineStatus' }
    & Pick<BorrowingBasePipelineStatusGQLType, 'latestArtifactDocumentId' | 'wipNeedsCommit' | 'creditAgreementsNeedLink' | 'latestArtifactDocumentVersion' | 'artifactDocumentWipId'>
  ) }
);

export type GetLoanTapeMetadataQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  loanProductId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
}>;


export type GetLoanTapeMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { loanTapeMetadata: (
    { __typename?: 'LoanTapeMetadata' }
    & Pick<LoanTapeMetadataGQLType, 'commitmentAmount' | 'principalBalance' | 'drawRequestAmountForCalendarMonth' | 'lastApprovedOrSubmittedFundingRequestDate' | 'reportingDate' | 'fileVersion' | 'portfolioCovenants' | 'customerProvidedValues'>
  ) }
);

export type GetPdfAnalysisQueryVariablesGQLType = Exact<{
  input: PdfAnalysisParamsGQLType;
}>;


export type GetPdfAnalysisQueryGQLType = (
  { __typename?: 'Query' }
  & { pdfAnalysis: (
    { __typename?: 'PdfAnalysisResponse' }
    & Pick<PdfAnalysisResponseGQLType, 'rawResponse'>
    & { answers: Array<(
      { __typename?: 'PdfAnswer' }
      & Pick<PdfAnswerGQLType, 'value' | 'error' | 'confidence' | 'pageNumber'>
    )> }
  ) }
);

export type GetExtractPyXlsx2Csv2QueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['String'];
  xlsxS3Bucket: Scalars['String'];
  xlsxS3Key: Scalars['String'];
  extractionParams: PyXlxs2CsvExtractionParamsGQLType;
}>;


export type GetExtractPyXlsx2Csv2QueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'extractPyXlsx2Csv2'>
);

export type GetPyXslx2Csv2UploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetPyXslx2Csv2UploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetExtractPyXlsxVirtualSheet2CsvQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['String'];
  xlsxS3Bucket: Scalars['String'];
  xlsxS3Key: Scalars['String'];
  extractionParams: PyXlxsVirtualSheet2CsvExtractionParamsGQLType;
}>;


export type GetExtractPyXlsxVirtualSheet2CsvQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'extractPyXlsxVirtualSheet2Csv'>
);

export type GetExtractAi2CsvQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['String'];
  prompt: Scalars['String'];
  documentsStr: Scalars['String'];
  tool: Scalars['Object'];
  baseFieldsTemplate?: Maybe<BaseFieldsTemplateGQLType>;
}>;


export type GetExtractAi2CsvQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'extractAi2Csv'>
);

export type GetExtractPyCSvVirtualSheetQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['String'];
  extractionParams: PyCsvVirtualSheetExtractionParamsGQLType;
}>;


export type GetExtractPyCSvVirtualSheetQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'extractPyCsvVirtualSheet'>
);

export type GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetPyCsvVirtualSheetUploadSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetPyCsvVirtualSheetUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetAi2CsvSignedUrlQueryVariablesGQLType = Exact<{
  serializedParams: Scalars['String'];
}>;


export type GetAi2CsvSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type GetAssetAnalysisQueryVariablesGQLType = Exact<{
  params: Scalars['String'];
  pipelineDefinitionId: Scalars['UUID'];
}>;


export type GetAssetAnalysisQueryGQLType = (
  { __typename?: 'Query' }
  & { result: QueryGQLType['extractAsset2Json'] }
);

export type GetBorrowingBasePipelineDocumentInfoQueryVariablesGQLType = Exact<{
  artifactDocumentId: Scalars['UUID'];
  dbView: Scalars['Boolean'];
}>;


export type GetBorrowingBasePipelineDocumentInfoQueryGQLType = (
  { __typename?: 'Query' }
  & { borrowingBasePipelineArtifactDocumentInfo: (
    { __typename?: 'BorrowingBasePipelineArtifactDocumentInfo' }
    & Pick<BorrowingBasePipelineArtifactDocumentInfoGQLType, 'artifactDocumentId' | 'artifactsDocumentString'>
  ) }
);

export type GetPipelineInstancesQueryVariablesGQLType = Exact<{
  pipelineRunId: Scalars['UUID'];
}>;


export type GetPipelineInstancesQueryGQLType = (
  { __typename?: 'Query' }
  & { getArtifactInstancesForPipelineRun?: Maybe<(
    { __typename?: 'PipelineInstances' }
    & Pick<PipelineInstancesGQLType, 'artifactDocumentId'>
    & { artifactInstances: Array<(
      { __typename?: 'BorrowingBasePipelineArtifactInstance' }
      & Pick<BorrowingBasePipelineArtifactInstanceGQLType, 'status' | 'id' | 'artifactId' | 'instanceRecordString' | 'updated_at' | 'jsonRecords'>
      & { downloads: Array<(
        { __typename?: 'UrlAndFilename' }
        & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
      )> }
    )> }
  )> }
);

export type GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryVariablesGQLType = Exact<{
  artifactDocumentId?: Maybe<Scalars['UUID']>;
}>;


export type GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'artifactSlugs'>
);

export type GetPipelineRunsQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
  startDate?: Maybe<Scalars['FullDateStr']>;
  endDate?: Maybe<Scalars['FullDateStr']>;
}>;


export type GetPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRuns: Array<(
    { __typename?: 'PipelineRun' }
    & Pick<PipelineRunGQLType, 'reportingDate' | 'fileVersion' | 'artifactDocumentId' | 'pipelineRunId'>
  )> }
);

export type SaveBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
  artifactsDocumentString: Scalars['String'];
}>;


export type SaveBorrowingBasePipelineArtifactDocumentWipMutationGQLType = (
  { __typename?: 'Mutation' }
  & { saveBorrowingBasePipelineArtifactDocumentWip: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeleteBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
  artifactDocumentId: Scalars['UUID'];
}>;


export type DeleteBorrowingBasePipelineArtifactDocumentWipMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteBorrowingBasePipelineArtifactDocumentWip: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type GetTapeBuilderLatestPipelineRunQueryVariablesGQLType = Exact<{
  pipelineDefinitionId: Scalars['UUID'];
}>;


export type GetTapeBuilderLatestPipelineRunQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRuns: Array<(
    { __typename?: 'PipelineRun' }
    & Pick<PipelineRunGQLType, 'reportingDate' | 'fileVersion' | 'artifactDocumentId' | 'pipelineRunId'>
  )> }
);

export type GetTapeBuilderPipelineRunQueryVariablesGQLType = Exact<{
  pipelineRunId: Scalars['UUID'];
}>;


export type GetTapeBuilderPipelineRunQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRunById: (
    { __typename?: 'PipelineRun' }
    & Pick<PipelineRunGQLType, 'reportingDate' | 'fileVersion' | 'artifactDocumentId'>
  ) }
);

export type GetTapeBuilderNodePositionsQueryVariablesGQLType = Exact<{
  artifactDocumentId: Scalars['UUID'];
  purpose: NodePositionPurposeGQLType;
}>;


export type GetTapeBuilderNodePositionsQueryGQLType = (
  { __typename?: 'Query' }
  & { nodePositions: Array<(
    { __typename?: 'NodePosition' }
    & Pick<NodePositionGQLType, 'artifactIdentifier' | 'x' | 'y'>
  )> }
);

export type GetGraphWithPositionsQueryVariablesGQLType = Exact<{
  artifactDocumentId: Scalars['UUID'];
  dbView: Scalars['Boolean'];
  purpose: NodePositionPurposeGQLType;
}>;


export type GetGraphWithPositionsQueryGQLType = (
  { __typename?: 'Query' }
  & { borrowingBasePipelineArtifactDocumentInfo: (
    { __typename?: 'BorrowingBasePipelineArtifactDocumentInfo' }
    & Pick<BorrowingBasePipelineArtifactDocumentInfoGQLType, 'artifactDocumentId' | 'artifactsDocumentString'>
  ), nodePositions: Array<(
    { __typename?: 'NodePosition' }
    & Pick<NodePositionGQLType, 'artifactIdentifier' | 'x' | 'y'>
  )> }
);

export type SetNodePositionsMutationVariablesGQLType = Exact<{
  artifactDocumentId: Scalars['UUID'];
  purpose: NodePositionPurposeGQLType;
  positions: Array<NodePositionInputGQLType> | NodePositionInputGQLType;
}>;


export type SetNodePositionsMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'setNodePositions'>
);

export type TaskEntityFragmentGQLType = (
  { __typename?: 'TaskEntity' }
  & Pick<TaskEntityGQLType, 'id' | 'status' | 'dueDate'>
  & { assignedUser?: Maybe<(
    { __typename?: 'UserObject' }
    & Pick<UserObjectGQLType, 'id' | 'firstName' | 'lastName'>
  )> }
);

export type TaskFragmentGQLType = (
  { __typename?: 'Task' }
  & { taskEntity: (
    { __typename?: 'TaskEntity' }
    & TaskEntityFragmentGQLType
  ), domainProperties: (
    { __typename?: 'DomainProperties' }
    & Pick<DomainPropertiesGQLType, 'amount'>
    & { creditFacility: (
      { __typename?: 'CreditFacilityProperties' }
      & Pick<CreditFacilityPropertiesGQLType, 'id' | 'name'>
    ), party: (
      { __typename?: 'PartyProperties' }
      & Pick<PartyPropertiesGQLType, 'id' | 'name'>
    ), categorySpecificProperties: (
      { __typename?: 'FundingRequestTaskSpecificProperties' }
      & Pick<FundingRequestTaskSpecificPropertiesGQLType, 'category' | 'fundingRequestId' | 'loanIds' | 'fundingRequestDueDate'>
    ) | (
      { __typename?: 'InvoiceTaskSpecificProperties' }
      & Pick<InvoiceTaskSpecificPropertiesGQLType, 'category' | 'invoiceId' | 'invoiceLoanIds' | 'invoiceDueDate'>
    ) | (
      { __typename?: 'ConsolidatedDisbursementTaskProperties' }
      & Pick<ConsolidatedDisbursementTaskPropertiesGQLType, 'category' | 'consolidatedDisbursementId' | 'invoiceLoanIds'>
    ) | (
      { __typename?: 'LenderSharesTaskSpecificProperties' }
      & Pick<LenderSharesTaskSpecificPropertiesGQLType, 'category' | 'lenderSharesId' | 'lenderSharesLoanId' | 'lenderSharesDueDate' | 'fundingComponentId'>
    ) }
  ) }
);

export type GetTasksQueryVariablesGQLType = Exact<{
  filters?: Maybe<TaskFilterInputGQLType>;
}>;


export type GetTasksQueryGQLType = (
  { __typename?: 'Query' }
  & { getTasks: (
    { __typename?: 'TaskResult' }
    & { tasks: Array<(
      { __typename?: 'Task' }
      & TaskFragmentGQLType
    )>, filterState?: Maybe<(
      { __typename?: 'TaskFilterState' }
      & Pick<TaskFilterStateGQLType, 'allLoanIds'>
      & { currentFilters: (
        { __typename?: 'TaskFilter' }
        & Pick<TaskFilterGQLType, 'creditFacilityIds' | 'loanIds' | 'categories' | 'statuses'>
        & { dateRange?: Maybe<(
          { __typename?: 'TaskDateRangeFilter' }
          & Pick<TaskDateRangeFilterGQLType, 'startDate' | 'endDate'>
        )> }
      ) }
    )> }
  ) }
);

export type GetTasksBySectionQueryVariablesGQLType = Exact<{
  section: TaskSectionParamInputGQLType;
  filters?: Maybe<TaskFilterInputGQLType>;
}>;


export type GetTasksBySectionQueryGQLType = (
  { __typename?: 'Query' }
  & { getTasksBySection: Array<(
    { __typename?: 'Task' }
    & TaskFragmentGQLType
  )> }
);

export type GetTaskByIdQueryVariablesGQLType = Exact<{
  taskId: Scalars['UUID'];
}>;


export type GetTaskByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getTaskById: (
    { __typename?: 'Task' }
    & TaskFragmentGQLType
  ) }
);

export type GetTasksInitialFiltersQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetTasksInitialFiltersQueryGQLType = (
  { __typename?: 'Query' }
  & { getTasksInitialFilters: (
    { __typename?: 'TaskFilterState' }
    & Pick<TaskFilterStateGQLType, 'allLoanIds'>
    & { currentFilters: (
      { __typename?: 'TaskFilter' }
      & Pick<TaskFilterGQLType, 'creditFacilityIds' | 'loanIds' | 'categories' | 'statuses'>
      & { dateRange?: Maybe<(
        { __typename?: 'TaskDateRangeFilter' }
        & Pick<TaskDateRangeFilterGQLType, 'startDate' | 'endDate'>
      )> }
    ) }
  ) }
);

export type UpdateTaskPropertiesMutationVariablesGQLType = Exact<{
  taskId: Scalars['UUID'];
  newDueDate?: Maybe<Scalars['FullDateStr']>;
  newAssignedUserId?: Maybe<Scalars['UUID']>;
}>;


export type UpdateTaskPropertiesMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateTaskProperties: (
    { __typename?: 'TaskEntity' }
    & TaskEntityFragmentGQLType
  ) }
);

export type BulkReassignTasksMutationVariablesGQLType = Exact<{
  taskIds: Array<Scalars['UUID']> | Scalars['UUID'];
  newAssignedUserId: Scalars['UUID'];
}>;


export type BulkReassignTasksMutationGQLType = (
  { __typename?: 'Mutation' }
  & { bulkReassignTasks: Array<(
    { __typename?: 'TaskEntity' }
    & TaskEntityFragmentGQLType
  )> }
);

export type GetIncompleteTasksCountQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetIncompleteTasksCountQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'getIncompleteTasksCount'>
);

export type GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetCreditFacilitiesWithLiabilityAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'name'>
    & { liabilityAccounts: Array<(
      { __typename?: 'AccountingAccount' }
      & Pick<AccountingAccountGQLType, 'tAccount'>
    )> }
  )> }
);

export type GetEarliestAndLatestTransactionDatesQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetEarliestAndLatestTransactionDatesQueryGQLType = (
  { __typename?: 'Query' }
  & { dates?: Maybe<(
    { __typename?: 'TransactionDateRange' }
    & Pick<TransactionDateRangeGQLType, 'earliestDate' | 'latestDate'>
  )> }
);

export type GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
}>;


export type GetDatesForCurrentLiabilityTransactionsQueryGQLType = (
  { __typename?: 'Query' }
  & { dates?: Maybe<(
    { __typename?: 'TransactionDateRange' }
    & Pick<TransactionDateRangeGQLType, 'earliestDate' | 'latestDate'>
  )> }
);

export type GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  loanIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  accountTypes?: Maybe<Array<TAccountTypeGQLType> | TAccountTypeGQLType>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetResolvedDetailedEntriesForFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { entries: Array<(
    { __typename?: 'ResolvedDetailedEntryItem' }
    & Pick<ResolvedDetailedEntryItemGQLType, 'postingDate' | 'transactionType' | 'transactionCreatedAt' | 'comment' | 'amount' | 'tAccount' | 'creditFacilityId' | 'creditFacilitySlug' | 'creditFacilityName' | 'organizationId' | 'organizationSlug' | 'organizationName' | 'loanId' | 'loanName' | 'externalLoanId' | 'invoiceId'>
  )> }
);

export type GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  loanIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  accountTypes?: Maybe<Array<TAccountTypeGQLType> | TAccountTypeGQLType>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetDailyResolvedAggregateLineItemEntriesQueryGQLType = (
  { __typename?: 'Query' }
  & { entries: Array<(
    { __typename?: 'ResolvedAggregateLineItemEntry' }
    & Pick<ResolvedAggregateLineItemEntryGQLType, 'postingDate' | 'tAccount' | 'creditFacilityId' | 'organizationId' | 'aggregateAmount' | 'loanId' | 'loanName' | 'externalLoanId' | 'invoiceId' | 'creditFacilitySlug' | 'creditFacilityName' | 'organizationSlug' | 'organizationName'>
  )> }
);

export type GetDailyAccountActivityQueryVariablesGQLType = Exact<{
  creditFacilityIds: Array<Scalars['UUID']> | Scalars['UUID'];
  loanIds?: Maybe<Array<Scalars['UUID']> | Scalars['UUID']>;
  accountTypes?: Maybe<Array<TAccountTypeGQLType> | TAccountTypeGQLType>;
  startDate: Scalars['FullDateStr'];
  endDate: Scalars['FullDateStr'];
}>;


export type GetDailyAccountActivityQueryGQLType = (
  { __typename?: 'Query' }
  & { activity?: Maybe<(
    { __typename?: 'DailyAccountActivityResponse' }
    & { accountData: Array<(
      { __typename?: 'DailyAccountActivity' }
      & Pick<DailyAccountActivityGQLType, 'postingDate' | 'tAccount' | 'aggregateAmount'>
    )>, metadata?: Maybe<(
      { __typename?: 'AccountActivityMetadata' }
      & Pick<AccountActivityMetadataGQLType, 'minDate' | 'maxDate' | 'accountTypes' | 'totalCurrentLiabilities'>
      & { accountTotals: Array<(
        { __typename?: 'TAccountTotalAmounts' }
        & Pick<TAccountTotalAmountsGQLType, 'tAccount' | 'totalAmount'>
      )> }
    )> }
  )> }
);

export type GetCreditFacilityMetricsQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  postingDate: Scalars['FullDateStr'];
}>;


export type GetCreditFacilityMetricsQueryGQLType = (
  { __typename?: 'Query' }
  & { metrics?: Maybe<(
    { __typename?: 'CreditFacilityMetricsResponse' }
    & Pick<CreditFacilityMetricsResponseGQLType, 'commitmentAmount' | 'externalFacilityId' | 'outstandingPrincipalBalance' | 'utilization' | 'totalAccruedInterest' | 'totalAccruedServiceFees'>
    & { borrower: (
      { __typename?: 'BaseOrganization' }
      & Pick<BaseOrganizationGQLType, 'id' | 'name'>
    ) }
  )> }
);

export type GetLenderVerificationProgressBreakdownQueryVariablesGQLType = Exact<{
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
}>;


export type GetLenderVerificationProgressBreakdownQueryGQLType = (
  { __typename?: 'Query' }
  & { lenderVerificationProgressBreakdown?: Maybe<(
    { __typename?: 'BorrowingBasePipelineProgressBreakdown' }
    & Pick<BorrowingBasePipelineProgressBreakdownGQLType, 'isRunning' | 'status'>
    & { uploadProgressBreakdown: Array<(
      { __typename?: 'BorrowingBasePipelineSingleProgressBreakdown' }
      & Pick<BorrowingBasePipelineSingleProgressBreakdownGQLType, 'stepDescription'>
      & { status: (
        { __typename?: 'StepStatus' }
        & Pick<StepStatusGQLType, 'status' | 'errors'>
      ) }
    )>, progressBreakdown: Array<(
      { __typename?: 'BorrowingBasePipelineSingleProgressBreakdown' }
      & Pick<BorrowingBasePipelineSingleProgressBreakdownGQLType, 'stepDescription'>
      & { status: (
        { __typename?: 'StepStatus' }
        & Pick<StepStatusGQLType, 'status' | 'errors'>
      ) }
    )>, servicerReportDownload?: Maybe<(
      { __typename?: 'UrlAndFilename' }
      & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
    )>, extendedResponseTapeDownloads?: Maybe<Array<(
      { __typename?: 'DownloadWithLoanProduct' }
      & Pick<DownloadWithLoanProductGQLType, 'loanProductId'>
      & { download: (
        { __typename?: 'UrlAndFilename' }
        & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
      ), loanProduct?: Maybe<(
        { __typename?: 'LoanProduct' }
        & Pick<LoanProductGQLType, 'id' | 'name' | 'slug' | 'implementationId'>
      )> }
    )>>, initiatorDetails?: Maybe<(
      { __typename?: 'ArtifactInstanceInitiatorDetails' }
      & Pick<ArtifactInstanceInitiatorDetailsGQLType, 'firstName' | 'lastName' | 'organizationName'>
    )> }
  )> }
);

export type GetFundingRequestVerificationReportByMetadataQueryVariablesGQLType = Exact<{
  artifactDocumentId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
}>;


export type GetFundingRequestVerificationReportByMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestVerificationReportByMetadata?: Maybe<(
    { __typename?: 'FundingRequestVerificationReport' }
    & Pick<FundingRequestVerificationReportGQLType, 'verificationReportId' | 'verificationReport' | 'borrowingBaseReportId' | 'remediationRequested' | 'remediationNote' | 'artifactDocumentId'>
  )> }
);

export type GetLenderVerificationCreditFacilitiesQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetLenderVerificationCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { lenderVerificationCreditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name'>
  )> }
);

export type GetFundingVerificationPipelineRunsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetFundingVerificationPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingVerificationPipelineRuns: Array<(
    { __typename?: 'FundingVerificationPipelineRun' }
    & Pick<FundingVerificationPipelineRunGQLType, 'artifactDocumentId' | 'creditFacilityId' | 'reportingDate' | 'fileVersion' | 'goalArtifactIds' | 'status'>
    & { initiatorDetails?: Maybe<(
      { __typename?: 'ArtifactInstanceInitiatorDetails' }
      & Pick<ArtifactInstanceInitiatorDetailsGQLType, 'firstName' | 'lastName' | 'organizationName'>
    )> }
  )> }
);

export type GetActionableFundingVerificationPipelineRunsQueryVariablesGQLType = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GetActionableFundingVerificationPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { actionableFundingVerificationPipelineRuns: Array<(
    { __typename?: 'FundingVerificationPipelineRun' }
    & Pick<FundingVerificationPipelineRunGQLType, 'artifactDocumentId' | 'creditFacilityId' | 'reportingDate' | 'fileVersion' | 'goalArtifactIds' | 'status'>
  )> }
);

export type GetFundingRequestVerificationReceivableEligibilityQueryVariablesGQLType = Exact<{
  verificationReportId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
}>;


export type GetFundingRequestVerificationReceivableEligibilityQueryGQLType = (
  { __typename?: 'Query' }
  & { fundingRequestVerificationReceivableEligibility?: Maybe<(
    { __typename?: 'FundingRequestVerificationReceivableEligibility' }
    & Pick<FundingRequestVerificationReceivableEligibilityGQLType, 'reportingDate'>
    & { verificationEligibilityReceivables: Array<(
      { __typename?: 'VerificationEligibilityReceivable' }
      & Pick<VerificationEligibilityReceivableGQLType, 'id' | 'fundingVerificationReportId' | 'externalReceivableId' | 'finleyReceivableId' | 'eligibilityCriteriaKey' | 'exposure' | 'borrowerEligible' | 'finleyEligibilityStatus' | 'loanProductId' | 'note' | 'waived' | 'eligibleExposure' | 'borrowerFormula' | 'baseFields'>
    )> }
  )> }
);

export type NotifyVerificationReportReadyForReviewMutationVariablesGQLType = Exact<{
  verificationReportId: Scalars['UUID'];
}>;


export type NotifyVerificationReportReadyForReviewMutationGQLType = (
  { __typename?: 'Mutation' }
  & { notifyVerificationReportReadyForReview: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type AdjudicateFundingRequestVerificationReportMutationVariablesGQLType = Exact<{
  verificationReportId: Scalars['UUID'];
  action: VerificationReportAdjudicationActionGQLType;
  note?: Maybe<Scalars['String']>;
}>;


export type AdjudicateFundingRequestVerificationReportMutationGQLType = (
  { __typename?: 'Mutation' }
  & { adjudicateFundingRequestVerificationReport: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateAssetVerificationRecordMutationVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  fileVersion: Scalars['Int'];
  artifactDocumentId: Scalars['UUID'];
  finleyReceivableId: Scalars['UUID'];
}>;


export type CreateAssetVerificationRecordMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createAssetVerificationRecord: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type UpdateFundingVerificationReceivableEligibilityMutationVariablesGQLType = Exact<{
  receivableEligibility: Array<UpdateFundingVerificationReceivableEligibilityChangesetGQLType> | UpdateFundingVerificationReceivableEligibilityChangesetGQLType;
}>;


export type UpdateFundingVerificationReceivableEligibilityMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateFundingVerificationReceivableEligibility: (
    { __typename?: 'ResponseWithString' }
    & Pick<ResponseWithStringGQLType, 'response'>
  ) }
);

export type GetIsAssetVerificationRequiredQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  artifactDocumentId: Scalars['UUID'];
}>;


export type GetIsAssetVerificationRequiredQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'isAssetVerificationRequired'>
);

export type GetAssetVerificationReceivableHistoryQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  artifactDocumentId: Scalars['UUID'];
  fileVersion: Scalars['Int'];
  loanProductId?: Maybe<Scalars['UUID']>;
}>;


export type GetAssetVerificationReceivableHistoryQueryGQLType = (
  { __typename?: 'Query' }
  & { assetVerificationReceivableHistory: Array<(
    { __typename?: 'HistoricalAssetVerificationData' }
    & Pick<HistoricalAssetVerificationDataGQLType, 'assignedAtDate' | 'totalAssignedAtExposure' | 'totalUntestedAssignedAtExposure' | 'totalUnverifiedFailureAssignedAtExposure' | 'totalVerifiedFailureAssignedAtExposure' | 'totalVerifiedPassAssignedAtExposure' | 'totalReceivableCount' | 'verifiedPassReceivableCount' | 'verifiedFailureReceivableCount' | 'unverifiedFailureReceivableCount' | 'untestedReceivableCount'>
  )> }
);

export type GetAssetVerificationReceivablesByMetadataQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  artifactDocumentId: Scalars['UUID'];
  fileVersion: Scalars['Int'];
  loanProductId?: Maybe<Scalars['UUID']>;
}>;


export type GetAssetVerificationReceivablesByMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'assetVerificationReportByMetadata'>
);

export type GetStoredAssetVerificationReceivablesByMetadataQueryVariablesGQLType = Exact<{
  creditFacilityId: Scalars['UUID'];
  reportingDate: Scalars['FullDateStr'];
  artifactDocumentId: Scalars['UUID'];
  fileVersion: Scalars['Int'];
  loanProductId?: Maybe<Scalars['UUID']>;
}>;


export type GetStoredAssetVerificationReceivablesByMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'assetVerificationReportByMetadataStored'>
);

export type GetAssetVerificationDocumentByRawIdQueryVariablesGQLType = Exact<{
  receivableDocumentationRawId: Scalars['UUID'];
}>;


export type GetAssetVerificationDocumentByRawIdQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'assetVerificationDocumentByRawId'>
);

export type GetAssetVerificationDocumentSignedUrllQueryVariablesGQLType = Exact<{
  receivableDocumentationRawId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
  artifactDocumentId: Scalars['UUID'];
}>;


export type GetAssetVerificationDocumentSignedUrllQueryGQLType = (
  { __typename?: 'Query' }
  & { assetVerificationDocumentSignedUrl: (
    { __typename?: 'UrlAndFilename' }
    & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
  ) }
);

export type GetVerificationBorrowingBaseWaiverImpactQueryVariablesGQLType = Exact<{
  verificationReportId: Scalars['UUID'];
  creditFacilityId: Scalars['UUID'];
}>;


export type GetVerificationBorrowingBaseWaiverImpactQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'verificationBorrowingBaseWaiverImpact'>
);

export type WorkflowTemplateConstructorFieldsFragmentGQLType = (
  { __typename?: 'WorkflowTemplateConstructor' }
  & Pick<WorkflowTemplateConstructorGQLType, 'title'>
  & { finalAction?: Maybe<(
    { __typename?: 'WorkflowTemplateFinalAction' }
    & Pick<WorkflowTemplateFinalActionGQLType, 'title' | 'functionName'>
  )>, optionsExposedToUsers: (
    { __typename?: 'WorkflowTemplateOptionsExposedToUsers' }
    & { runtimeVariables: Array<(
      { __typename?: 'StringRuntimeVariableTemplate' }
      & Pick<StringRuntimeVariableTemplateGQLType, 'name' | 'returnType'>
      & { options: Array<(
        { __typename?: 'StringOptions' }
        & Pick<StringOptionsGQLType, 'label' | 'stringValue'>
      )> }
    ) | (
      { __typename?: 'StringArrayRuntimeVariableTemplate' }
      & Pick<StringArrayRuntimeVariableTemplateGQLType, 'name' | 'returnType'>
      & { options: Array<(
        { __typename?: 'StringOptions' }
        & Pick<StringOptionsGQLType, 'label' | 'stringValue'>
      )> }
    ) | (
      { __typename?: 'NumberRuntimeVariableTemplate' }
      & Pick<NumberRuntimeVariableTemplateGQLType, 'name' | 'returnType'>
      & { options: Array<(
        { __typename?: 'NumberOptions' }
        & Pick<NumberOptionsGQLType, 'label' | 'numberValue'>
      )> }
    )>, domainSpecificRuntimeVariable?: Maybe<(
      { __typename?: 'WorkflowTemplateDomainSpecificRuntimeVariable' }
      & { usersApprovalRuntimeVariable: (
        { __typename?: 'StringArrayRuntimeVariableTemplate' }
        & Pick<StringArrayRuntimeVariableTemplateGQLType, 'name' | 'returnType'>
        & { options: Array<(
          { __typename?: 'StringOptions' }
          & Pick<StringOptionsGQLType, 'label' | 'stringValue'>
        )> }
      ) }
    )>, actions: Array<(
      { __typename?: 'WorkflowActionTypeTemplate' }
      & Pick<WorkflowActionTypeTemplateGQLType, 'functionName'>
      & { params: Array<(
        { __typename?: 'StringStaticParamTemplate' }
        & Pick<StringStaticParamTemplateGQLType, 'variableName' | 'variableType'>
        & { options: Array<(
          { __typename?: 'StringOptions' }
          & Pick<StringOptionsGQLType, 'label' | 'stringValue'>
        )> }
      ) | (
        { __typename?: 'NumberStaticParamTemplate' }
        & Pick<NumberStaticParamTemplateGQLType, 'variableName' | 'variableType'>
        & { options: Array<(
          { __typename?: 'NumberOptions' }
          & Pick<NumberOptionsGQLType, 'label' | 'numberValue'>
        )> }
      ) | (
        { __typename?: 'StringArrayStaticParamTemplate' }
        & Pick<StringArrayStaticParamTemplateGQLType, 'variableName' | 'variableType'>
        & { options: Array<(
          { __typename?: 'StringOptions' }
          & Pick<StringOptionsGQLType, 'label' | 'stringValue'>
        )> }
      )> }
    )> }
  ) }
);

export type WorkflowTemplateFieldsFragmentGQLType = (
  { __typename?: 'WorkflowTemplate' }
  & Pick<WorkflowTemplateGQLType, 'id' | 'workflowId' | 'version' | 'workflowType' | 'name' | 'organizationId' | 'authorUserId'>
  & { workflow: (
    { __typename?: 'WorkflowGraphObject' }
    & { userApprovalNodes: Array<(
      { __typename?: 'WorkflowUserApprovalGraphNode' }
      & Pick<WorkflowUserApprovalGraphNodeGQLType, 'id' | 'comparator' | 'userIds'>
    )>, actionNodes: Array<(
      { __typename?: 'WorkflowActionGraphNode' }
      & Pick<WorkflowActionGraphNodeGQLType, 'id' | 'actionFunctionName'>
      & { actionParams: Array<(
        { __typename?: 'WorkflowActionGraphNodeParams' }
        & Pick<WorkflowActionGraphNodeParamsGQLType, 'variableName'>
        & { variableBinding: (
          { __typename?: 'WorkflowActionGraphNodeVariableBinding' }
          & Pick<WorkflowActionGraphNodeVariableBindingGQLType, 'stringVariableBinding' | 'numberVariableBinding' | 'stringArrayVariableBinding'>
        ) }
      )> }
    )>, conditionalNodes: Array<(
      { __typename?: 'WorkflowConditionalGraphNode' }
      & { if: (
        { __typename?: 'WorkflowConditionalGraphNodeConfig' }
        & Pick<WorkflowConditionalGraphNodeConfigGQLType, 'id' | 'comparator' | 'runtimeVariableName' | 'rightOperandStringArray' | 'rightOperandNumber'>
      ), elif: Array<(
        { __typename?: 'WorkflowConditionalGraphNodeConfig' }
        & Pick<WorkflowConditionalGraphNodeConfigGQLType, 'id' | 'comparator' | 'runtimeVariableName' | 'rightOperandStringArray' | 'rightOperandNumber'>
      )>, else: (
        { __typename?: 'WorkflowConditionalElseConfig' }
        & Pick<WorkflowConditionalElseConfigGQLType, 'id'>
      ) }
    )>, edges: Array<(
      { __typename?: 'WorkflowGraphEdges' }
      & Pick<WorkflowGraphEdgesGQLType, 'from' | 'to'>
    )> }
  ) }
);

export type GetWorkflowTemplateConstructorQueryVariablesGQLType = Exact<{
  workflowType: WorkflowTypeGQLType;
  organizationId: Scalars['UUID'];
}>;


export type GetWorkflowTemplateConstructorQueryGQLType = (
  { __typename?: 'Query' }
  & { getWorkflowTemplateConstructor: (
    { __typename?: 'WorkflowTemplateConstructor' }
    & WorkflowTemplateConstructorFieldsFragmentGQLType
  ) }
);

export type GetWorkflowTemplateQueryVariablesGQLType = Exact<{
  workflowTemplateId: Scalars['UUID'];
}>;


export type GetWorkflowTemplateQueryGQLType = (
  { __typename?: 'Query' }
  & { getWorkflowTemplate: (
    { __typename?: 'WorkflowTemplate' }
    & WorkflowTemplateFieldsFragmentGQLType
  ) }
);

export type GetWorkflowTemplatesQueryVariablesGQLType = Exact<{
  workflowType: WorkflowTypeGQLType;
  organizationId: Scalars['UUID'];
}>;


export type GetWorkflowTemplatesQueryGQLType = (
  { __typename?: 'Query' }
  & { getWorkflowTemplates: Array<(
    { __typename?: 'WorkflowTemplate' }
    & WorkflowTemplateFieldsFragmentGQLType
  )> }
);

export type CreateWorkflowTemplateMutationVariablesGQLType = Exact<{
  workflowId: Scalars['UUID'];
  workflowType: WorkflowTypeGQLType;
  workflow: WorkflowGraphObjectInputGQLType;
  name: Scalars['String'];
  organizationId: Scalars['UUID'];
  authorUserId: Scalars['UUID'];
}>;


export type CreateWorkflowTemplateMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createWorkflowTemplate: (
    { __typename?: 'ErrorCreateWorkflowTemplateResponse' }
    & Pick<ErrorCreateWorkflowTemplateResponseGQLType, 'status' | 'errors'>
  ) | (
    { __typename?: 'SuccessCreateWorkflowTemplateResponse' }
    & Pick<SuccessCreateWorkflowTemplateResponseGQLType, 'status'>
    & { template: (
      { __typename?: 'WorkflowTemplate' }
      & WorkflowTemplateFieldsFragmentGQLType
    ) }
  ) }
);

export type RequestApprovalForFundingRequestMutationVariablesGQLType = Exact<{
  fundingRequestId: Scalars['UUID'];
  workflowInstanceId: Scalars['UUID'];
  approverUserId: Scalars['UUID'];
}>;


export type RequestApprovalForFundingRequestMutationGQLType = (
  { __typename?: 'Mutation' }
  & { requestApprovalForFundingRequest: (
    { __typename?: 'FundingRequestResponse' }
    & Pick<FundingRequestResponseGQLType, 'fundingRequestId' | 'response'>
  ) }
);

export type GetUserTablePreferenceQueryVariablesGQLType = Exact<{
  tableKey: Scalars['String'];
  defaultTableColumnConfiguration: DefaultTableColumnConfigurationInputGQLType;
}>;


export type GetUserTablePreferenceQueryGQLType = (
  { __typename?: 'Query' }
  & { getUserTablePreference?: Maybe<(
    { __typename?: 'TablePreference' }
    & Pick<TablePreferenceGQLType, 'id' | 'tableKey'>
    & { config: (
      { __typename?: 'TablePreferenceConfig' }
      & { columns: Array<(
        { __typename?: 'ColumnConfiguration' }
        & Pick<ColumnConfigurationGQLType, 'columnKey' | 'isVisible' | 'isFixed'>
      )> }
    ) }
  )> }
);

export type UpsertUserTablePreferenceMutationVariablesGQLType = Exact<{
  tablePreference: TablePreferenceInputGQLType;
  defaultTableColumnConfiguration: DefaultTableColumnConfigurationInputGQLType;
}>;


export type UpsertUserTablePreferenceMutationGQLType = (
  { __typename?: 'Mutation' }
  & { upsertUserTablePreference: (
    { __typename?: 'TablePreference' }
    & Pick<TablePreferenceGQLType, 'id' | 'tableKey'>
    & { config: (
      { __typename?: 'TablePreferenceConfig' }
      & { columns: Array<(
        { __typename?: 'ColumnConfiguration' }
        & Pick<ColumnConfigurationGQLType, 'columnKey' | 'isVisible' | 'isFixed'>
      )> }
    ) }
  ) }
);

export type GetUserActiveCreditFacilitiesQueryVariablesGQLType = Exact<{
  creditFacilitySlugsToHide: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetUserActiveCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<UserGQLType, 'id' | 'email' | 'userType' | 'isActive' | 'organizationId' | 'roleType' | 'firstName' | 'lastName'>
    & { organization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id' | 'name' | 'slug'>
      & { creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'slug' | 'name' | 'latestCreditAgreementId' | 'implementationId'>
      )> }
    ) }
  )> }
);

export type GetValleyBankArrangementGroupQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  arrangementGroupNumber: Scalars['String'];
}>;


export type GetValleyBankArrangementGroupQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankArrangementGroup'>
);

export type GetValleyBankAssignmentDeviationQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetValleyBankAssignmentDeviationQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankAssignmentDeviations: (
    { __typename?: 'ValleyBankAssignmentDeviation' }
    & Pick<ValleyBankAssignmentDeviationGQLType, 'reportingDate'>
    & { collateralAccountsNoLongerPledged: Array<(
      { __typename?: 'ValleyBankCollateralToLoanAccountMapping' }
      & Pick<ValleyBankCollateralToLoanAccountMappingGQLType, 'loanAccountNum' | 'collateralAccountNum' | 'collateralAccountType' | 'reportingDate'>
    )>, collateralAccountsAssignedToNonExistentLoanAccountNum: Array<(
      { __typename?: 'ValleyBankCollateralToLoanAccountMapping' }
      & Pick<ValleyBankCollateralToLoanAccountMappingGQLType, 'loanAccountNum' | 'collateralAccountNum' | 'collateralAccountType' | 'reportingDate'>
    )>, collateralAccounts: Array<(
      { __typename?: 'ValleyBankAssignmentDetail' }
      & Pick<ValleyBankAssignmentDetailGQLType, 'collateralAccountNum' | 'collateralAccountType' | 'cifNum' | 'fullName' | 'arrangmentGroup' | 'assignedLoanAccountNums'>
    )> }
  ) }
);

export type GetValleyBankAssignmentPreviewRrtQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  previewLoanAccountNum: Scalars['String'];
  assignmentsToPreview: Array<ValleyBankSubmitAssignmentInputGQLType> | ValleyBankSubmitAssignmentInputGQLType;
}>;


export type GetValleyBankAssignmentPreviewRrtQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankAssignmentPreviewRRT'>
);

export type GetValleyBankAssignmentQueueQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetValleyBankAssignmentQueueQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankAssignmentQueue: Array<(
    { __typename?: 'ValleyBankAssignmentQueueWithName' }
    & Pick<ValleyBankAssignmentQueueWithNameGQLType, 'id' | 'created_at' | 'updated_at' | 'collateralAccountNumber' | 'loanAccountNumber' | 'collateralAccountType' | 'action' | 'userId' | 'userFirstName' | 'userLastName'>
  )> }
);

export type GetValleyBankAssignmentEventLogQueryVariablesGQLType = Exact<{ [key: string]: never; }>;


export type GetValleyBankAssignmentEventLogQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankAssignmentEventLog: Array<(
    { __typename?: 'ValleyBankAssignmentEventLogWithName' }
    & Pick<ValleyBankAssignmentEventLogWithNameGQLType, 'id' | 'created_at' | 'updated_at' | 'collateralAccountNumber' | 'loanAccountNumber' | 'collateralAccountType' | 'action' | 'userId' | 'userFirstName' | 'userLastName' | 'reportingDate'>
  )> }
);

export type AddToValleyBankAssignmentQueueMutationVariablesGQLType = Exact<{
  records: Array<ValleyBankAddToAssignmentQueueGQLType> | ValleyBankAddToAssignmentQueueGQLType;
}>;


export type AddToValleyBankAssignmentQueueMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'valleyBankAddToAssignmentsQueue'>
);

export type DeleteFromValleyBankAssignmentQueueMutationVariablesGQLType = Exact<{
  assignmentQueueId: Scalars['String'];
}>;


export type DeleteFromValleyBankAssignmentQueueMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'valleyBankDeleteFromAssignmentQueue'>
);

export type SubmitValleyBankAssignmentQueueMutationVariablesGQLType = Exact<{ [key: string]: never; }>;


export type SubmitValleyBankAssignmentQueueMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'submitValleyBankAssignmentQueue'>
);

export type GetValleyBankCreditFacilityLoanProductMechanicsQueryVariablesGQLType = Exact<{
  isWip?: Maybe<Scalars['Boolean']>;
}>;


export type GetValleyBankCreditFacilityLoanProductMechanicsQueryGQLType = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<UserGQLType, 'id'>
    & { organization: (
      { __typename?: 'Organization' }
      & Pick<OrganizationGQLType, 'id'>
      & { creditFacilities: Array<(
        { __typename?: 'CreditFacility' }
        & Pick<CreditFacilityGQLType, 'id' | 'slug'>
        & { borrowingBaseMechanicsForLoanProducts: Array<(
          { __typename?: 'BorrowingBaseMechanicsForLoanProduct' }
          & Pick<BorrowingBaseMechanicsForLoanProductGQLType, 'loanProductId' | 'loanProductName' | 'baseFields' | 'intermediateFields'>
        )> }
      )> }
    ) }
  )> }
);

export type GetValleyBankCustomersQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  paginationOptions: PaginationOptionsGQLType;
  queryParams?: Maybe<ValleyBankCustomerQueryParamsGQLType>;
}>;


export type GetValleyBankCustomersQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankCustomers: (
    { __typename?: 'ValleyBankCustomerConnection' }
    & Pick<ValleyBankCustomerConnectionGQLType, 'customers'>
    & { paginationInfo: (
      { __typename?: 'PaginationInfo' }
      & Pick<PaginationInfoGQLType, 'totalCount' | 'limit' | 'offset'>
    ) }
  ) }
);

export type GetValleyBankCustomerQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  cifNumber: Scalars['String'];
}>;


export type GetValleyBankCustomerQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankCustomer?: Maybe<(
    { __typename?: 'ValleyBankCustomer' }
    & Pick<ValleyBankCustomerGQLType, 'customer'>
  )> }
);

export type GetAllValleyBankLoanAccountsQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  paginationOptions: PaginationOptionsGQLType;
  queryParams?: Maybe<ValleyBankLoanAccountQueryParamsGQLType>;
  orderByParam?: Maybe<ValleyBankLoanAccountOrderByParamGQLType>;
}>;


export type GetAllValleyBankLoanAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { allValleyBankLoanAccounts: (
    { __typename?: 'ValleyBankLoanAccountConnection' }
    & Pick<ValleyBankLoanAccountConnectionGQLType, 'loanAccounts'>
    & { paginationInfo: (
      { __typename?: 'PaginationInfo' }
      & Pick<PaginationInfoGQLType, 'totalCount' | 'limit' | 'offset'>
    ) }
  ) }
);

export type GetValleyBankLoanAccountQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  loanAccountNumber: Scalars['String'];
  selectedFinleyReceivableIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetValleyBankLoanAccountQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankLoanAccount?: Maybe<(
    { __typename?: 'ValleyBankLoanAccount' }
    & Pick<ValleyBankLoanAccountGQLType, 'loanAccount'>
  )> }
);

export type GetValleyBankLatestPinnedCommentForLoanAccountsQueryVariablesGQLType = Exact<{
  loanAccountNums: Array<Scalars['String']> | Scalars['String'];
  reportingDate: Scalars['FullDateStr'];
  isHistorical: Scalars['Boolean'];
}>;


export type GetValleyBankLatestPinnedCommentForLoanAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankLatestPinnedCommentForLoanAccounts: Array<(
    { __typename?: 'ValleyBankLoanAccountLatestPinnedComment' }
    & Pick<ValleyBankLoanAccountLatestPinnedCommentGQLType, 'loanAccountNum'>
    & { pinnedComment: (
      { __typename?: 'Comment' }
      & CommentFragmentFragmentGQLType
    ) }
  )> }
);

export type GetValleyBankLoanAccountsByCifNumsQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  cifNums: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetValleyBankLoanAccountsByCifNumsQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankLoanAccountsByCifNums'>
);

export type GetValleyBankAssociatedLoanAccountsByCifNumsQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  cifNums: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetValleyBankAssociatedLoanAccountsByCifNumsQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankAssociatedLoanAccountsByCifNums'>
);

export type GetValleyBankLoanAccountsByAccountNumsQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
  loanAccountNumbers: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetValleyBankLoanAccountsByAccountNumsQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankLoanAccountByAccountNums'>
);

export type GetValleyBankUnderMarginLoanAccountsQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
}>;


export type GetValleyBankUnderMarginLoanAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankUnderMarginLoanAccounts'>
);

export type GetValleyBankPipelineStatusMetadataQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
}>;


export type GetValleyBankPipelineStatusMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<QueryGQLType, 'valleyBankPipelineStatusMetadata'>
);

export type GetValleyBankDownloadLinksQueryVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
  isPreview: Scalars['Boolean'];
}>;


export type GetValleyBankDownloadLinksQueryGQLType = (
  { __typename?: 'Query' }
  & { valleyBankDownloadLinks: (
    { __typename?: 'ValleyBankDownloads' }
    & { ingestionLogs?: Maybe<(
      { __typename?: 'UrlAndFilename' }
      & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
    )>, collateralAssignments?: Maybe<(
      { __typename?: 'UrlAndFilename' }
      & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
    )>, securitiesExtendedResponseTape?: Maybe<(
      { __typename?: 'UrlAndFilename' }
      & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
    )>, depositsExtendedResponseTape?: Maybe<(
      { __typename?: 'UrlAndFilename' }
      & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
    )>, loanAccountDetails?: Maybe<(
      { __typename?: 'UrlAndFilename' }
      & Pick<UrlAndFilenameGQLType, 'url' | 'filename'>
    )> }
  ) }
);

export type RestoreValleyBankReportingDateMutationVariablesGQLType = Exact<{
  reportingDate: Scalars['FullDateStr'];
}>;


export type RestoreValleyBankReportingDateMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<MutationGQLType, 'restoreValleyBankReportingDate'>
);

export const BankAccountWithInstitutionAndDesignationFragmentDocGQLType = gql`
    fragment BankAccountWithInstitutionAndDesignation on BankAccountWithInstitutionAndDesignation {
  accountNumber
  currencyCode
  id
  name
  institutionName
  organizationId
  isActive
  bankInstitutionKey
  routingNumber
  accountType
  creditFacilityId
}
    `;
export const FundingRequestComponentFieldsFragmentDocGQLType = gql`
    fragment FundingRequestComponentFields on FundingRequestComponent {
  id
  fundingRequestId
  commitmentKey
  type
  amount
  sourceBankAccountId
  sourceBankAccountType
  destinationBankAccountId
  destinationBankAccountType
  targetFundingDate
  postingDate
  borrowerVerifiedTransactionId
  borrowerFinancialDataSourceKey
  created_at
  updated_at
}
    `;
export const FundingRequestWithComponentsAndBankAccountsFragmentDocGQLType = gql`
    fragment FundingRequestWithComponentsAndBankAccounts on FundingRequestWithFullDetails {
  id
  status
  bankAccounts {
    ...BankAccountWithInstitutionAndDesignation
  }
  fundingRequestComponents {
    ...FundingRequestComponentFields
  }
}
    ${BankAccountWithInstitutionAndDesignationFragmentDocGQLType}
${FundingRequestComponentFieldsFragmentDocGQLType}`;
export const ApiKeyWithOrganizationFragmentDocGQLType = gql`
    fragment ApiKeyWithOrganization on ApiKeyWithOrganization {
  actorType
  id
  key
  secret
  description
  created_at
  updated_at
  isActive
  userId
  organizationId
  organizationName
  organizationSlug
}
    `;
export const FinleyAutomatedFragmentDocGQLType = gql`
    fragment FinleyAutomated on FinleyAutomated {
  actorType
  id
  name
}
    `;
export const UnknownActorFragmentDocGQLType = gql`
    fragment UnknownActor on UnknownActor {
  actorType
  id
  originalActorType
  name
}
    `;
export const UserActorFragmentDocGQLType = gql`
    fragment UserActor on UserActor {
  actorType
  id
  email
  userType
  organizationId
  isActive
  roleType
  firstName
  lastName
}
    `;
export const FundingRequestPayloadFragmentDocGQLType = gql`
    fragment FundingRequestPayload on FundingRequestPayload {
  fundingRequest {
    id
    creditFacilityName
  }
}
    `;
export const FundingRequestComponentPayloadFragmentDocGQLType = gql`
    fragment FundingRequestComponentPayload on FundingRequestComponentPayload {
  fundingRequest {
    id
    creditFacilityName
  }
  fundingRequestComponent {
    amount
    type
  }
}
    `;
export const DeliverablesPayloadFragmentDocGQLType = gql`
    fragment DeliverablesPayload on DeliverablesPayload {
  deliverableItem {
    creditFacilityName
    status
  }
}
    `;
export const InsertedDeliverablePayloadFragmentDocGQLType = gql`
    fragment InsertedDeliverablePayload on InsertedDeliverablePayload {
  deliverable {
    id
    creditFacilityName
    status
    updated_at
  }
}
    `;
export const UpdatedDeliverableStatusPayloadFragmentDocGQLType = gql`
    fragment UpdatedDeliverableStatusPayload on UpdatedDeliverableStatusPayload {
  deliverable {
    id
    creditFacilityName
    status
    updated_at
  }
}
    `;
export const SubmittedDeliverableSubmissionPayloadFragmentDocGQLType = gql`
    fragment SubmittedDeliverableSubmissionPayload on SubmittedDeliverableSubmissionPayload {
  deliverable {
    id
    creditFacilityName
    status
    updated_at
  }
}
    `;
export const IngestionPayloadFragmentDocGQLType = gql`
    fragment IngestionPayload on IngestionPayload {
  origin
  failedOps
  successOps
  messages
}
    `;
export const VerificationPayloadFragmentDocGQLType = gql`
    fragment VerificationPayload on VerificationPayload {
  verificationReportId
  creditFacilityName
}
    `;
export const EventForRenderFragmentDocGQLType = gql`
    fragment EventForRender on EventWithActor {
  id
  domainKey
  actionKey
  actorName
  targetName
  created_at
  isCapitalProvider
  payload {
    ... on FundingRequestPayload {
      ...FundingRequestPayload
    }
    ... on FundingRequestComponentPayload {
      ...FundingRequestComponentPayload
    }
    ... on DeliverablesPayload {
      ...DeliverablesPayload
    }
    ... on InsertedDeliverablePayload {
      ...InsertedDeliverablePayload
    }
    ... on UpdatedDeliverableStatusPayload {
      ...UpdatedDeliverableStatusPayload
    }
    ... on SubmittedDeliverableSubmissionPayload {
      ...SubmittedDeliverableSubmissionPayload
    }
    ... on IngestionPayload {
      ...IngestionPayload
    }
    ... on VerificationPayload {
      ...VerificationPayload
    }
  }
}
    ${FundingRequestPayloadFragmentDocGQLType}
${FundingRequestComponentPayloadFragmentDocGQLType}
${DeliverablesPayloadFragmentDocGQLType}
${InsertedDeliverablePayloadFragmentDocGQLType}
${UpdatedDeliverableStatusPayloadFragmentDocGQLType}
${SubmittedDeliverableSubmissionPayloadFragmentDocGQLType}
${IngestionPayloadFragmentDocGQLType}
${VerificationPayloadFragmentDocGQLType}`;
export const FundingRequestWithThreadMetadataFragmentDocGQLType = gql`
    fragment FundingRequestWithThreadMetadata on FundingRequestWithFullDetails {
  id
  status
  creditFacility {
    id
    name
  }
  loans {
    id
    externalLoanId
    maturityDate
    loanStatus
  }
}
    `;
export const BankInstitutionFragmentDocGQLType = gql`
    fragment BankInstitution on BankInstitution {
  tellerInstitutionId
  plaidInstitutionId
  name
  institutionUrl
  primaryColor
  logoUrl
  bankInstitutionKey
}
    `;
export const BankDataProviderInstitutionAccountFieldsFragmentDocGQLType = gql`
    fragment BankDataProviderInstitutionAccountFields on BankDataProviderInstitutionAccount {
  dataProviderAccountId
  bankInstitutionId
  name
  mask
  type
  current
  available
  currency
  retrievedAt
}
    `;
export const BankDataProviderInstitutionFieldsFragmentDocGQLType = gql`
    fragment BankDataProviderInstitutionFields on BankDataProviderInstitution {
  bankInstitutionId
  name
  bankInstitutionKey
  dataProvider
  dataProviderInstitutionId
  itemId
  institutionUrl
  primaryColor
  logoUrl
  externalItemId
  needsUpdate
  bankAccounts {
    ...BankDataProviderInstitutionAccountFields
  }
}
    ${BankDataProviderInstitutionAccountFieldsFragmentDocGQLType}`;
export const CreditAgreementDocumentMetadataFieldsFragmentDocGQLType = gql`
    fragment CreditAgreementDocumentMetadataFields on CreditAgreementMetadata {
  id
  facilityType
  creditFacilityId
  effectiveFrom
  effectiveTo
  version
  _schemaVersion_
  s3Path
  _note_
  displayName
}
    `;
export const CreditAgreementFullArtifactFieldsFragmentDocGQLType = gql`
    fragment CreditAgreementFullArtifactFields on CreditAgreementFullArtifact {
  id
  creditAgreement
}
    `;
export const CommonAttributeValueFieldsFragmentDocGQLType = gql`
    fragment CommonAttributeValueFields on AbstractAttributeValue {
  attributeId
  name
  ownerOrganizationId
  type
  attributeValueId
  entityIdentifier
  entityDomain
  effectiveFromReportingDate
  displayName
}
    `;
export const AttributeValueFragmentFragmentDocGQLType = gql`
    fragment AttributeValueFragment on AttributeValue {
  __typename
  ...CommonAttributeValueFields
  ... on StringAttributeValue {
    stringValue: value
    stringValidation: validation {
      type
      allowedValues
    }
  }
  ... on FloatAttributeValue {
    floatValue: value
    floatValidation: validation {
      type
      display {
        ... on AttributeValueCurrencyDisplay {
          displayType
          currencyCode
        }
      }
    }
  }
  ... on IntegerAttributeValue {
    integerValue: value
    integerValidation: validation {
      type
    }
  }
  ... on BooleanAttributeValue {
    booleanValue: value
    booleanValidation: validation {
      type
    }
  }
  ... on PercentageRateAttributeValue {
    percentageRateValue: value
    percentageRateValidation: validation {
      type
    }
  }
  ... on FullDateStrAttributeValue {
    fullDateStrValue: value
    fullDateStrValidation: validation {
      type
    }
  }
  ... on StringArrayAttributeValue {
    stringArrayValue: value
    stringArrayValidation: validation {
      type
      allowedValues
    }
  }
}
    ${CommonAttributeValueFieldsFragmentDocGQLType}`;
export const AttributeFragmentFragmentDocGQLType = gql`
    fragment AttributeFragment on Attribute {
  attributeId
  displayName
  type
  validation {
    type
    allowedValues
    display {
      ... on AttributeValueCurrencyDisplay {
        displayType
        currencyCode
      }
    }
  }
  attributeValue {
    ...AttributeValueFragment
  }
  attributeValues {
    ...AttributeValueFragment
  }
}
    ${AttributeValueFragmentFragmentDocGQLType}`;
export const BorrowingBaseReportFragmentDocGQLType = gql`
    fragment BorrowingBaseReport on BorrowingBaseReport {
  id
  assetValuation
  effectiveReceivableValuationRate
  borrowerId
  cashAdvanceRate
  creditFacilitySlug
  creditAgreementId
  creditAgreementVersion
  creditFacilityId
  fileVersion
  borrowingBaseAmountAssets
  totalCash
  totalBorrowingBaseAmount
  borrowingBaseReserveAmount
  isBorrowingBaseReservePositiveExcessCollectionsOverReserve
  maxReceivableAdvanceAmount
  maxCashAdvanceAmount
  commitmentAmount
  currentPrincipalBalance
  reportingDate
  totalEligibleExposure
  totalReceivableExposure
  totalEligibilityKickout
  totalConcentrationKickout
  totalFacilityUtilization
  totalMaxAdvanceAmount
  borrowingBaseUtilization
  weightedAverageReceivableAdvanceRate
  totalEligibleBorrowingBaseAccountCash
  totalAssets
  effectiveAdvanceRate
  effectiveReceivableAdvanceRate
  totalCollectionsAccountCash
  totalPreAdvanceCashContribution
  totalCashBorrowingBaseAmount
  effectiveCashAdvanceRate
  maximumAvailableAmount
  borrowingBaseAvailability
  borrowingBaseAvailabilityRate
  assignedEligibleExposureSinceLastApprovedFundingRequest
  created_at
  updated_at
}
    `;
export const BorrowingBaseReportLoanProductCalculationFragmentDocGQLType = gql`
    fragment BorrowingBaseReportLoanProductCalculation on BorrowingBaseReportLoanProductCalculation {
  id
  borrowingBaseReportId
  creditFacilityId
  loanProductId
  created_at
  updated_at
  totalReceivableExposure
  totalEligibilityKickout
  totalEligibleExposure
  totalConcentrationKickout
  totalEligibleExposureLessConcentrationKickouts
  weightedAverageReceivableAdvanceRate
  totalReceivableBorrowingBaseAmount
  effectiveReceivableAdvanceRate
  effectiveReceivableValuationRate
}
    `;
export const ConcentrationLimitCalculationFragmentDocGQLType = gql`
    fragment ConcentrationLimitCalculation on ConcentrationLimitCalculation {
  id
  borrowingBaseReportId
  concentrationLimitKey
  concentrationLimit
  concentrationAmount
  totalEligibleExposure
  concentration
  borrowingBaseReduction
  complianceStatus
  created_at
}
    `;
export const EligibilityCriteriaCalculationFragmentDocGQLType = gql`
    fragment EligibilityCriteriaCalculation on EligibilityCriteriaCalculation {
  id
  borrowingBaseReportId
  eligibilityCriteriaKey
  eligibilityReduction
  created_at
}
    `;
export const BankAccountCashBalanceFragmentDocGQLType = gql`
    fragment BankAccountCashBalance on BankAccountCashBalance {
  bankAccountId
  balance
  accountType
  cashAdvanceRate
  currencyCode
  conversionRate
}
    `;
export const ReceivableBorrowingBaseTestWaiverFragmentDocGQLType = gql`
    fragment ReceivableBorrowingBaseTestWaiver on ReceivableBorrowingBaseTestWaiver {
  id
  finleyReceivableId
  externalReceivableId
  loanProductId
  creditFacilityId
  borrowingBaseTestType
  borrowingBaseTestKey
  waiverStartReportingDate
  waiverExpirationReportingDate
  isActive
  lastUpdatedUserId
  lastUpdatedOrganizationName
  created_at
  updated_at
}
    `;
export const SuccessPortfolioCovenantFragmentDocGQLType = gql`
    fragment SuccessPortfolioCovenant on SuccessPortfolioCovenant {
  id
  creditFacilityId
  creditAgreementId
  covenantKey
  reportingDate
  version
  triggerDate
  result
  value
  variables {
    name
    value
  }
  warnings
  status
  metadata {
    errors
  }
  created_at
  updated_at
}
    `;
export const BaseOrganizationFragmentDocGQLType = gql`
    fragment BaseOrganization on BaseOrganization {
  id
  name
  slug
}
    `;
export const ThreadActorFragmentFragmentDocGQLType = gql`
    fragment ThreadActorFragment on ThreadActor {
  id
  firstName
  lastName
  organization {
    ...BaseOrganization
  }
}
    ${BaseOrganizationFragmentDocGQLType}`;
export const LatestThreadActionLogFragmentFragmentDocGQLType = gql`
    fragment LatestThreadActionLogFragment on LatestThreadActionLog {
  actionType
  user {
    ...ThreadActorFragment
  }
}
    ${ThreadActorFragmentFragmentDocGQLType}`;
export const CommentFragmentFragmentDocGQLType = gql`
    fragment CommentFragment on Comment {
  id
  created_at
  updated_at
  comment
  author {
    ...ThreadActorFragment
  }
}
    ${ThreadActorFragmentFragmentDocGQLType}`;
export const BaseThreadFragmentFragmentDocGQLType = gql`
    fragment BaseThreadFragment on Thread {
  threadId
  domain
  domainIdentifier
  resolved
  pinned
  created_at
  updated_at
  latestActionLog {
    ...LatestThreadActionLogFragment
  }
  participatingOrganizations {
    ...BaseOrganization
  }
  comments {
    ...CommentFragment
  }
}
    ${LatestThreadActionLogFragmentFragmentDocGQLType}
${BaseOrganizationFragmentDocGQLType}
${CommentFragmentFragmentDocGQLType}`;
export const SuccessFinancialCovenantFragmentDocGQLType = gql`
    fragment SuccessFinancialCovenant on SuccessFinancialCovenant {
  id
  creditFacilityId
  creditAgreementId
  covenantKey
  triggerDate
  reportingDate
  version
  result
  value
  variables {
    name
    value
  }
  errors
  status
}
    `;
export const CreditAgreementArtifactFieldsFragmentDocGQLType = gql`
    fragment CreditAgreementArtifactFields on CreditAgreementArtifact {
  id
  creditAgreement
}
    `;
export const BaseOrganizationFragmentFragmentDocGQLType = gql`
    fragment BaseOrganizationFragment on BaseOrganization {
  id
  name
}
    `;
export const EventLogActorFragmentFragmentDocGQLType = gql`
    fragment EventLogActorFragment on EventLogActor {
  id
  firstName
  lastName
  organization {
    ...BaseOrganizationFragment
  }
}
    ${BaseOrganizationFragmentFragmentDocGQLType}`;
export const EventLogBaseEventFragmentFragmentDocGQLType = gql`
    fragment EventLogBaseEventFragment on EventLogBaseEvent {
  eventId
  eventLogType
  eventMessage
  entityId
  createdAt
  updatedAt
  actor {
    ...EventLogActorFragment
  }
}
    ${EventLogActorFragmentFragmentDocGQLType}`;
export const ThreadCreatedEventSnapshotFragmentFragmentDocGQLType = gql`
    fragment ThreadCreatedEventSnapshotFragment on ThreadCreatedEventSnapshot {
  id
  pinned
  resolved
}
    `;
export const DeliverableEntityMetaFragmentFragmentDocGQLType = gql`
    fragment DeliverableEntityMetaFragment on DeliverableEntityMeta {
  deliverableId: id
  configName
  dueDate
  creditFacilityId
  creditFacilityName
  latestReceiptId
}
    `;
export const CreditFacilityEntityMetaFragmentFragmentDocGQLType = gql`
    fragment CreditFacilityEntityMetaFragment on EventLogCreditFacility {
  id
  name
  externalFacilityId
}
    `;
export const DeliverableThreadCreateEventFragmentFragmentDocGQLType = gql`
    fragment DeliverableThreadCreateEventFragment on DeliverableThreadCreateEvent {
  ...EventLogBaseEventFragment
  current {
    ...ThreadCreatedEventSnapshotFragment
  }
  entityMetadata {
    ...DeliverableEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${ThreadCreatedEventSnapshotFragmentFragmentDocGQLType}
${DeliverableEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}`;
export const FundingRequestEntityMetaFragmentFragmentDocGQLType = gql`
    fragment FundingRequestEntityMetaFragment on FundingRequestEntityMeta {
  fundingRequestId: id
  expire
  status
  creditFacilityId
  creditFacilityName
  loanNames
  externalLoanIds
}
    `;
export const FundingRequestThreadCreateEventFragmentFragmentDocGQLType = gql`
    fragment FundingRequestThreadCreateEventFragment on FundingRequestThreadCreateEvent {
  ...EventLogBaseEventFragment
  current {
    ...ThreadCreatedEventSnapshotFragment
  }
  entityMetadata {
    ...FundingRequestEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${ThreadCreatedEventSnapshotFragmentFragmentDocGQLType}
${FundingRequestEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}`;
export const FundingRequestStatusEventsCommonSnapshotFragmentFragmentDocGQLType = gql`
    fragment FundingRequestStatusEventsCommonSnapshotFragment on FundingRequestStatusEventsCommonSnapshot {
  status
  creditFacilityId
  drawRequestTotalAmount
  collectionsPaydownTotalAmount
  collectionsRecycleTotalAmount
  curePaydownTotalAmount
}
    `;
export const FundingRequestCreatedEventFragmentFragmentDocGQLType = gql`
    fragment FundingRequestCreatedEventFragment on FundingRequestCreatedEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...FundingRequestEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
  current {
    ...FundingRequestStatusEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${FundingRequestEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}
${FundingRequestStatusEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const FundingRequestStatusChangeEventFragmentFragmentDocGQLType = gql`
    fragment FundingRequestStatusChangeEventFragment on FundingRequestStatusChangeEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...FundingRequestEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
  current {
    ...FundingRequestStatusEventsCommonSnapshotFragment
  }
  previous {
    ...FundingRequestStatusEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${FundingRequestEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}
${FundingRequestStatusEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const InvoiceEntityMetaFragmentFragmentDocGQLType = gql`
    fragment InvoiceEntityMetaFragment on InvoiceEntityMeta {
  invoiceId: id
  dueDate
  invoiceStatus: status
  totalAmount
}
    `;
export const InvoiceThreadCreateEventFragmentFragmentDocGQLType = gql`
    fragment InvoiceThreadCreateEventFragment on InvoiceThreadCreateEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...InvoiceEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
  current {
    ...ThreadCreatedEventSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${InvoiceEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}
${ThreadCreatedEventSnapshotFragmentFragmentDocGQLType}`;
export const InvoiceStatusEventsCommonSnapshotFragmentFragmentDocGQLType = gql`
    fragment InvoiceStatusEventsCommonSnapshotFragment on InvoiceStatusEventsCommonSnapshot {
  dueDate
  invoiceStatus: status
  totalAmount
}
    `;
export const InvoiceCreatedEventFragmentFragmentDocGQLType = gql`
    fragment InvoiceCreatedEventFragment on InvoiceCreatedEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...InvoiceEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
  current {
    ...InvoiceStatusEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${InvoiceEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}
${InvoiceStatusEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const InvoiceUpdatedEventFragmentFragmentDocGQLType = gql`
    fragment InvoiceUpdatedEventFragment on InvoiceUpdatedEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...InvoiceEntityMetaFragment
  }
  creditFacility {
    ...CreditFacilityEntityMetaFragment
  }
  current {
    ...InvoiceStatusEventsCommonSnapshotFragment
  }
  previous {
    ...InvoiceStatusEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${InvoiceEntityMetaFragmentFragmentDocGQLType}
${CreditFacilityEntityMetaFragmentFragmentDocGQLType}
${InvoiceStatusEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const LimitedPartnerEntityMetaFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerEntityMetaFragment on LimitedPartnerEntityMeta {
  limitedPartnerId: id
  name
}
    `;
export const LimitedPartnerThreadCreateEventFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerThreadCreateEventFragment on LimitedPartnerThreadCreateEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...LimitedPartnerEntityMetaFragment
  }
  current {
    ...ThreadCreatedEventSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${LimitedPartnerEntityMetaFragmentFragmentDocGQLType}
${ThreadCreatedEventSnapshotFragmentFragmentDocGQLType}`;
export const LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerStatusEventsCommonSnapshotFragment on LimitedPartnerStatusEventsCommonSnapshot {
  id
  name
  otherNames
  ownerOrganizationId
  parentEntityId
}
    `;
export const LimitedPartnerCreatedEventFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerCreatedEventFragment on LimitedPartnerCreatedEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...LimitedPartnerEntityMetaFragment
  }
  current {
    ...LimitedPartnerStatusEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${LimitedPartnerEntityMetaFragmentFragmentDocGQLType}
${LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const LimitedPartnerUpdatedEventFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerUpdatedEventFragment on LimitedPartnerUpdatedEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...LimitedPartnerEntityMetaFragment
  }
  current {
    ...LimitedPartnerStatusEventsCommonSnapshotFragment
  }
  previous {
    ...LimitedPartnerStatusEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${LimitedPartnerEntityMetaFragmentFragmentDocGQLType}
${LimitedPartnerStatusEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const LimitedPartnerMatchEventsCommonSnapshotFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerMatchEventsCommonSnapshotFragment on LimitedPartnerMatchEventsCommonSnapshot {
  matchMetadataId
  mappingId
  limitedPartnerId
}
    `;
export const LimitedPartnerMappingMatchEventFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerMappingMatchEventFragment on LimitedPartnerMappingMatchEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...LimitedPartnerEntityMetaFragment
  }
  current {
    ...LimitedPartnerMatchEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${LimitedPartnerEntityMetaFragmentFragmentDocGQLType}
${LimitedPartnerMatchEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const LimitedPartnerMappingUnmatchEventFragmentFragmentDocGQLType = gql`
    fragment LimitedPartnerMappingUnmatchEventFragment on LimitedPartnerMappingUnmatchEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...LimitedPartnerEntityMetaFragment
  }
  previous {
    ...LimitedPartnerMatchEventsCommonSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${LimitedPartnerEntityMetaFragmentFragmentDocGQLType}
${LimitedPartnerMatchEventsCommonSnapshotFragmentFragmentDocGQLType}`;
export const ValleyBankLoanAccountEntityMetaFragmentFragmentDocGQLType = gql`
    fragment ValleyBankLoanAccountEntityMetaFragment on ValleySBLLoanAccountEntityMeta {
  loanAccountId: id
}
    `;
export const ValleyBankLoanAccountThreadCreateEventFragmentFragmentDocGQLType = gql`
    fragment ValleyBankLoanAccountThreadCreateEventFragment on ValleyBankLoanAccountThreadCreateEvent {
  ...EventLogBaseEventFragment
  entityMetadata {
    ...ValleyBankLoanAccountEntityMetaFragment
  }
  current {
    ...ThreadCreatedEventSnapshotFragment
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${ValleyBankLoanAccountEntityMetaFragmentFragmentDocGQLType}
${ThreadCreatedEventSnapshotFragmentFragmentDocGQLType}`;
export const ExploPlacementIntegrationFragmentDocGQLType = gql`
    fragment ExploPlacementIntegration on ExploPlacementIntegration {
  id
  exploPlacement
  exploArtifactType
  exploEmbedId
  organizationId
  creditFacilityId
}
    `;
export const RailzIntegrationFragmentDocGQLType = gql`
    fragment RailzIntegration on RailzIntegration {
  id
  railzBusinessId
  railzConnectionId
  railzServiceName
  organizationId
  created_at
  deletedAt
}
    `;
export const FundingRequestFieldsFragmentDocGQLType = gql`
    fragment FundingRequestFields on FundingRequest {
  comment
  borrowingBaseReportId
  creditFacilityId
  creditFacility {
    id
    name
    borrower {
      id
      slug
      name
    }
  }
  loans {
    id
    externalLoanId
    maturityDate
    loanStatus
  }
  curePaydownTotalAmount
  drawRequestTotalAmount
  collectionsRecycleTotalAmount
  collectionsPaydownTotalAmount
  id
  fundingRequestConstraintId
  isCurrent
  expire
  status
  type
  created_at
  updated_at
}
    `;
export const FundingRequestComponentTotalAmountsFieldsFragmentDocGQLType = gql`
    fragment FundingRequestComponentTotalAmountsFields on FundingRequestComponentTotalAmounts {
  drawRequestTotalAmount
  collectionsRecycleTotalAmount
  collectionsPaydownTotalAmount
  curePaydownTotalAmount
}
    `;
export const FundingRequestComponentChangesetFieldsFragmentDocGQLType = gql`
    fragment FundingRequestComponentChangesetFields on FundingRequestComponentChangeset {
  id
  type
  amount
  sourceBankAccountId
  destinationBankAccountId
  targetFundingDate
}
    `;
export const FundingRequestWithFullDetailsFieldsFragmentDocGQLType = gql`
    fragment FundingRequestWithFullDetailsFields on FundingRequestWithFullDetails {
  comment
  borrowingBaseReportId
  creditFacilityId
  creditFacility {
    id
    name
    closingDate
    borrower {
      id
      slug
      name
    }
  }
  curePaydownTotalAmount
  drawRequestTotalAmount
  collectionsRecycleTotalAmount
  collectionsPaydownTotalAmount
  id
  fundingRequestConstraintId
  isCurrent
  type
  expire
  status
  reportingDate
  loans {
    id
    externalLoanId
    maturityDate
    loanStatus
  }
  created_at
  updated_at
  submittedAt
}
    `;
export const FundingRequestEventForRenderFragmentDocGQLType = gql`
    fragment FundingRequestEventForRender on EventWithActor {
  id
  domainKey
  actionKey
  actorName
  targetName
  created_at
  payload {
    ... on FundingRequestPayload {
      fundingRequest {
        creditFacilityName
      }
    }
    ... on FundingRequestComponentPayload {
      fundingRequestComponent {
        amount
        destinationBankAccountId
        type
      }
    }
  }
}
    `;
export const VerificationEventForRenderFragmentDocGQLType = gql`
    fragment VerificationEventForRender on EventWithActor {
  id
  domainKey
  actionKey
  actorName
  targetName
  created_at
  payload {
    ... on VerificationPayload {
      creditFacilityName
      verificationReportId
    }
  }
}
    `;
export const FundingRequestWithBaseDetailsFragmentDocGQLType = gql`
    fragment FundingRequestWithBaseDetails on FundingRequestWithFullDetails {
  ...FundingRequestWithFullDetailsFields
  creditFacility {
    id
    name
    borrower {
      id
      slug
      name
    }
  }
  bankAccounts {
    ...BankAccountWithInstitutionAndDesignation
  }
  fundingRequestComponents {
    ...FundingRequestComponentFields
  }
  fundingRequestEvents {
    ...FundingRequestEventForRender
  }
  fundingRequestReports {
    id
    reportType
    s3Path
  }
  verificationReport {
    verificationReport
    verificationReportId
    borrowingBaseReportId
    approvalReportNote
    remediationRequested
    remediationNote
    artifactDocumentId
  }
  verificationReportEvents {
    ...VerificationEventForRender
  }
}
    ${FundingRequestWithFullDetailsFieldsFragmentDocGQLType}
${BankAccountWithInstitutionAndDesignationFragmentDocGQLType}
${FundingRequestComponentFieldsFragmentDocGQLType}
${FundingRequestEventForRenderFragmentDocGQLType}
${VerificationEventForRenderFragmentDocGQLType}`;
export const FundingRequestWithBorrowingBaseFieldsFragmentDocGQLType = gql`
    fragment FundingRequestWithBorrowingBaseFields on FundingRequestWithFullDetails {
  comment
  borrowingBaseReportId
  creditFacilityId
  creditFacility {
    id
    name
    borrower {
      id
      slug
      name
    }
  }
  curePaydownTotalAmount
  drawRequestTotalAmount
  collectionsRecycleTotalAmount
  collectionsPaydownTotalAmount
  id
  fundingRequestConstraintId
  isCurrent
  expire
  status
  reportingDate
  type
  created_at
  updated_at
  borrower {
    name
  }
  borrowingBaseReport {
    id
    borrowingBaseAvailability
    cashAdvanceRate
    commitmentAmount
    effectiveAdvanceRate
    currentPrincipalBalance
    totalCash
    borrowingBaseAmountAssets
    totalBorrowingBaseAmount
    reportingDate
    fileVersion
    maxReceivableAdvanceAmount
    totalMaxAdvanceAmount
    cashReserveAmount
    borrowingBaseReserveAmount
    borrowingBaseUtilization
    weightedAverageReceivableAdvanceRate
    totalEligibleBorrowingBaseAccountCash
    totalAssets
    totalCollectionsAccountCash
    borrowingBaseAvailabilityRate
    maximumAvailableAmount
  }
}
    `;
export const FundingRequestWithBaseDetailsAndBorrowingBaseFragmentDocGQLType = gql`
    fragment FundingRequestWithBaseDetailsAndBorrowingBase on FundingRequestWithFullDetails {
  ...FundingRequestWithBorrowingBaseFields
  creditFacility {
    id
    name
    borrower {
      id
      slug
      name
    }
  }
  bankAccounts {
    ...BankAccountWithInstitutionAndDesignation
  }
  fundingRequestComponents {
    ...FundingRequestComponentFields
  }
  fundingRequestEvents {
    ...FundingRequestEventForRender
  }
  fundingRequestReports {
    id
    reportType
    s3Path
    isDomainReport
  }
  verificationReport {
    verificationReport
    verificationReportId
    borrowingBaseReportId
    approvalReportNote
    remediationRequested
    remediationNote
    artifactDocumentId
  }
  verificationReportEvents {
    ...VerificationEventForRender
  }
}
    ${FundingRequestWithBorrowingBaseFieldsFragmentDocGQLType}
${BankAccountWithInstitutionAndDesignationFragmentDocGQLType}
${FundingRequestComponentFieldsFragmentDocGQLType}
${FundingRequestEventForRenderFragmentDocGQLType}
${VerificationEventForRenderFragmentDocGQLType}`;
export const FundingRequestConstraintFieldsFragmentDocGQLType = gql`
    fragment FundingRequestConstraintFields on FundingRequestConstraint {
  borrowingBaseReportId
  creditAgreementId
  collectionsRecycleMax
  collectionsPaydownMax
  drawRequestIncrementAmount
  id
  isCollectionsRecycleEnabled
  isStopDrawEnforced
  isVoluntaryPaydownAllowed
  maxFundingRequestAmount
  maxDrawRequestAmount
  maxCollectionsRecycleAmount
  minimumDrawRequestAmount
  minimumRepaymentAmount
  preAdvanceCashContributionToBorrowingBase
  targetCurePaydownAmount
  targetDrawRequestAmount
  targetCollectionsRecycleAmount
  targetCollectionsPaydownAmount
  collectionsRecycleContributesToBorrowingBase
}
    `;
export const FundingRequestWithFullDetailsFragmentDocGQLType = gql`
    fragment FundingRequestWithFullDetails on FundingRequestWithFullDetails {
  ...FundingRequestWithFullDetailsFields
  bankAccounts {
    ...BankAccountWithInstitutionAndDesignation
  }
  fundingRequestComponents {
    ...FundingRequestComponentFields
  }
  fundingRequestEvents {
    ...FundingRequestEventForRender
  }
  fundingRequestReports {
    id
    reportType
    s3Path
    isDomainReport
  }
  borrowingBaseReport {
    id
    cashAdvanceRate
    commitmentAmount
    effectiveAdvanceRate
    currentPrincipalBalance
    totalCash
    borrowingBaseAmountAssets
    totalBorrowingBaseAmount
    reportingDate
    fileVersion
    maxReceivableAdvanceAmount
    totalMaxAdvanceAmount
    cashReserveAmount
    borrowingBaseReserveAmount
    borrowingBaseUtilization
    weightedAverageReceivableAdvanceRate
    totalEligibleBorrowingBaseAccountCash
    totalAssets
    borrowingBaseAvailability
    totalCollectionsAccountCash
    totalCashBorrowingBaseAmount
    borrowingBaseAvailabilityRate
    maximumAvailableAmount
  }
  borrower {
    name
  }
  adjustedPrincipalBalance
}
    ${FundingRequestWithFullDetailsFieldsFragmentDocGQLType}
${BankAccountWithInstitutionAndDesignationFragmentDocGQLType}
${FundingRequestComponentFieldsFragmentDocGQLType}
${FundingRequestEventForRenderFragmentDocGQLType}`;
export const InvoiceItemFragmentDocGQLType = gql`
    fragment InvoiceItem on InvoiceItem {
  id
  invoiceId
  accountingAccountId
  amount
  status
  capitalizedLoanId
  finleyAccruedAmount
  created_at
  updated_at
  accountingAccount {
    id
    tAccount
    creditFacilityId
    organizationId
  }
}
    `;
export const InvoiceComponentWithInvoiceItemsFragmentDocGQLType = gql`
    fragment InvoiceComponentWithInvoiceItems on InvoiceComponentWithInvoiceItems {
  invoiceComponent {
    id
    invoiceId
    finleyLoanId
    invoiceComponentType
    totalAmount
    accrualStartDate
    accrualEndDate
    created_at
    updated_at
  }
  invoiceItems {
    ...InvoiceItem
  }
}
    ${InvoiceItemFragmentDocGQLType}`;
export const BankAccountWithInstitutionAndOwnerFragmentDocGQLType = gql`
    fragment BankAccountWithInstitutionAndOwner on BankAccountWithInstitutionAndOwner {
  id
  accountNumber
  currencyCode
  name
  bankInstitutionId
  plaidAccountId
  tellerAccountId
  retrievedAt
  current
  available
  conversionRate
  routingNumber
  institutionName
  bankInstitutionKey
  organizationId
  ownerType
  ownerName
  connectionProviderName
  connectionProviderAccountMask
}
    `;
export const InvoiceDisbursementItemDifferenceFragmentDocGQLType = gql`
    fragment InvoiceDisbursementItemDifference on InvoiceDisbursementItemDifference {
  capitalProviderId
  capitalProviderName
  tAccountType
  inputAmount
  finleyAmount
  difference
  inputProRataShare
  finleyProRataShare
}
    `;
export const InvoiceCalculationComparisonFragmentDocGQLType = gql`
    fragment InvoiceCalculationComparison on InvoiceCalculationComparison {
  loanId
  loanName
  externalLoanId
  invoiceComponentDifferences {
    inputAmount
    finleyAmount
    difference
  }
  invoiceDisbursementItemDifferences {
    interest {
      ...InvoiceDisbursementItemDifference
    }
    principal {
      ...InvoiceDisbursementItemDifference
    }
  }
}
    ${InvoiceDisbursementItemDifferenceFragmentDocGQLType}`;
export const InvoiceFragmentDocGQLType = gql`
    fragment Invoice on Invoice {
  id
  creditFacilityId
  originatingInvoiceId
  paymentSourceOrganizationId
  paymentDestinationOrganizationId
  sourceBankAccountId
  destinationBankAccountId
  status
  totalAmount
  autoSettle
  memo
  createdByType
  targetInvoiceDate
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceComponentsWithInvoiceItems {
    ...InvoiceComponentWithInvoiceItems
  }
  creditFacility {
    id
    name
    externalFacilityId
  }
  paymentSourceOrganization {
    id
    name
  }
  paymentDestinationOrganization {
    id
    name
  }
  destinationBankAccount {
    ...BankAccountWithInstitutionAndOwner
  }
  invoiceReports {
    id
    reportType
    reportName
    reportingDate
    version
    isPreview
    capitalProviderId
    capitalProviderName
    invoiceId
    paymentInKindItemId
  }
  invoiceCalculationComparisons {
    ...InvoiceCalculationComparison
  }
}
    ${InvoiceComponentWithInvoiceItemsFragmentDocGQLType}
${BankAccountWithInstitutionAndOwnerFragmentDocGQLType}
${InvoiceCalculationComparisonFragmentDocGQLType}`;
export const InvoiceReportFragmentDocGQLType = gql`
    fragment InvoiceReport on InvoiceReport {
  id
  reportType
  reportName
  reportingDate
  version
  isPreview
  capitalProviderId
  capitalProviderName
  invoiceId
  paymentInKindItemId
}
    `;
export const InvoiceSummaryFragmentDocGQLType = gql`
    fragment InvoiceSummary on Invoice {
  id
  creditFacilityId
  originatingInvoiceId
  paymentSourceOrganizationId
  paymentDestinationOrganizationId
  sourceBankAccountId
  destinationBankAccountId
  status
  totalAmount
  autoSettle
  memo
  createdByType
  targetInvoiceDate
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceComponentsWithInvoiceItems {
    ...InvoiceComponentWithInvoiceItems
  }
  creditFacility {
    id
    name
    externalFacilityId
  }
  invoiceReports {
    ...InvoiceReport
  }
  invoiceCalculationComparisons {
    ...InvoiceCalculationComparison
  }
}
    ${InvoiceComponentWithInvoiceItemsFragmentDocGQLType}
${InvoiceReportFragmentDocGQLType}
${InvoiceCalculationComparisonFragmentDocGQLType}`;
export const InvoiceListItemFragmentDocGQLType = gql`
    fragment InvoiceListItem on Invoice {
  id
  creditFacilityId
  originatingInvoiceId
  paymentSourceOrganizationId
  paymentDestinationOrganizationId
  status
  totalAmount
  autoSettle
  memo
  createdByType
  targetInvoiceDate
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceComponentsWithInvoiceItems {
    invoiceComponent {
      id
      invoiceId
      finleyLoanId
      invoiceComponentType
      totalAmount
      accrualStartDate
      accrualEndDate
      created_at
      updated_at
    }
    invoiceItems {
      id
      invoiceId
      accountingAccountId
      amount
      status
      capitalizedLoanId
      finleyAccruedAmount
      created_at
      updated_at
      accountingAccount {
        id
        tAccount
        creditFacilityId
        organizationId
      }
    }
  }
  creditFacility {
    id
    name
  }
}
    `;
export const InvoiceDisbursementItemFragmentDocGQLType = gql`
    fragment InvoiceDisbursementItem on InvoiceDisbursementItem {
  id
  invoiceDisbursementId
  accountingAccountId
  accountingTransactionId
  amount
  serviceFeeAmount
  postServiceFeeTotalAmount
  created_at
  updated_at
  accountingAccount {
    id
    tAccount
    creditFacilityId
    organizationId
  }
}
    `;
export const InvoiceDisbursementFragmentDocGQLType = gql`
    fragment InvoiceDisbursement on InvoiceDisbursement {
  id
  invoiceId
  invoiceComponentId
  capitalProviderOrganizationId
  totalAmount
  autoSettle
  status
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceDisbursementItems {
    ...InvoiceDisbursementItem
  }
  capitalProviderOrganization {
    id
    name
  }
  capitalProviderProRata
  serviceFeeTotals {
    serviceFeeAmount
    postServiceFeeTotalAmount
  }
}
    ${InvoiceDisbursementItemFragmentDocGQLType}`;
export const InvoicePaymentInKindItemFragmentDocGQLType = gql`
    fragment InvoicePaymentInKindItem on InvoicePaymentInKindItem {
  id
  invoiceId
  invoiceItemId
  capitalizedLenderShareId
  capitalizedLoanId
  totalAmount
  serviceFeeAmount
  postServiceFeeTotalAmount
  status
  dueDate
  notifiedDate
  created_at
  updated_at
  capitalProviderOrganization {
    id
    name
  }
  capitalProviderProRata
}
    `;
export const InvoiceConsolidatedDisbursementFragmentDocGQLType = gql`
    fragment InvoiceConsolidatedDisbursement on InvoiceConsolidatedDisbursement {
  id
  invoiceId
  capitalProviderOrganizationId
  totalCashDisbursementAmount
  totalCashServiceFeeAmount
  totalPostServiceFeeCashDisbursementAmount
  totalInterestCapitalizationAmount
  totalInterestCapitalizationServiceFeeAmount
  totalPostServiceFeeInterestCapitalizationAmount
  status
  paymentDate
  created_at
  updated_at
  capitalProviderOrganization {
    id
    name
  }
  capitalProviderProRataForFacility
}
    `;
export const LimitedPartnerMappingForAliasingFragmentDocGQLType = gql`
    fragment LimitedPartnerMappingForAliasing on LimitedPartnerMappingForAliasing {
  mappingId
  limitedPartnerId
  limitedPartnerName
  matchedByUserName
  matchedByUserEmail
  externalReceivableId
  limitedPartnerAlias
  committedCapital
  loanProductId
  creditFacilityId
  reportingDate
  fileVersion
  ownerOrganizationId
  matchMetadataId
}
    `;
export const LimitedPartnerCommitmentFragmentDocGQLType = gql`
    fragment LimitedPartnerCommitment on LimitedPartnerCommitment {
  limitedPartnerAlias
  finleyReceivableId
  limitedPartnerId
  limitedPartnerName
  creditFacilityId
  creditFacilityName
  borrowerSlug
  borrowerName
  committedCapital
  uncalledCapital
  reportingDate
}
    `;
export const LimitedPartnerCommitmentDetailFragmentDocGQLType = gql`
    fragment LimitedPartnerCommitmentDetail on LimitedPartnerCommitmentDetail {
  limitedPartnerAlias
  finleyReceivableId
  limitedPartnerId
  limitedPartnerName
  creditFacilityId
  creditFacilityName
  borrowerSlug
  borrowerName
  committedCapital
  uncalledCapital
  recallableCapital
  reportingDate
  eligibleUncalledCapitalLessKickouts
  netUncalledCapital
  percentageOfNetUncalledCapital
  mappingId
  matchedByUserName
  matchedByUserEmail
  matchedAt
}
    `;
export const AggregatedLimitedPartnerCommitmentDataFragmentDocGQLType = gql`
    fragment AggregatedLimitedPartnerCommitmentData on AggregatedLimitedPartnerCommitmentData {
  limitedPartnerName
  limitedPartnerId
  commitmentCount
  totalCommittedCapital
  totalRecallableCapital
  percentageOfPortfolioCommittedCapital
  totalUncalledCapital
  percentageOfPortfolioUncalledCapital
  eligibleUncalledCapital
  eligibleUncalledCapitalLessKickouts
  advanceRate
  netUncalledCapital
  percentageOfPortfolioNetUncalledCapital
}
    `;
export const LimitedPartnerCapitalTrendDataFragmentDocGQLType = gql`
    fragment LimitedPartnerCapitalTrendData on LimitedPartnerCapitalTrendData {
  finleyReceivableId
  committedCapital
  uncalledCapital
  reportingDate
}
    `;
export const LimitedPartnerPortfolioOverviewGraphDataFragmentDocGQLType = gql`
    fragment LimitedPartnerPortfolioOverviewGraphData on LimitedPartnerPortfolioOverviewGraphData {
  totalUncalledCapital
  totalCommittedCapital
  totalPrincipalBalance
  reportingDate
}
    `;
export const AssignmentPreviewJobFragmentDocGQLType = gql`
    fragment AssignmentPreviewJob on AssignmentPreviewJob {
  id
  implementationId
  assignmentMethod
  strategyId
  previewIdentifier
  status
  created_at
  updated_at
  strategyName
  completedAt
  initiatedByUserIdentifier
  totalProposedExposure
  newlyProposedExposure
  proposedBorrowingBaseFromReceivables
  balanceSheetExposure
  s3Path
}
    `;
export const AssignmentConfirmationJobFragmentDocGQLType = gql`
    fragment AssignmentConfirmationJob on AssignmentConfirmationJob {
  id
  implementationId
  status
  fileVersion
  reportingDate
  previewJobId
  created_at
  updated_at
  completedAt
  initiatedByUserId
  errorLogS3Path
  payloadS3Path
  jobType
}
    `;
export const AssignmentReceivableFragmentDocGQLType = gql`
    fragment AssignmentReceivable on AssignmentReceivable {
  finleyReceivableId
  externalReceivableId
  baseFields {
    key
    value
  }
  dynamicIntermediateFields {
    creditFacilityId
    dynamicIntermediateFields {
      key
      value
    }
  }
  requiredIntermediateFields {
    creditFacilityId
    requiredIntermediateFields {
      assignmentExclusion
      exposure
      waiveAllEligibility
      waiveAllConcentration
      includeInConcentrationLimitDenominatorIfWaived
      originalOwnerSlug
      normalizedDaysPastDue
      normalizedDurationDays
      normalizedisChargedOff
      normalizedisDelinquent
      normalizedOriginationDate
      normalizedInitialBalance
    }
  }
  postProcessedFields {
    creditFacilityId
    postProcessedFields {
      originalOwnerId
      performingExposure
    }
  }
  loanProductId
  isAssignable
  leaveUnassigned
  assignableCreditFacilityIds
  receivableResponseTapeProperties {
    creditFacilityId
    valuationFields {
      valuation
      valuationRate
    }
    eligibilityFields {
      eligibleExposure
      isEligible
      eligibilityKickout
    }
    concentrationLimitFields {
      eligibleExposureLessConcentrationLimitKickouts
    }
    borrowingBaseFields {
      borrowingBaseAmount
      advanceRate
    }
    concentrationLimitReasons {
      propertyKey
      concentrationLimitKickout
    }
    concentrationLimitWaivers {
      propertyKey
      waiveReason
    }
    eligibilityStatuses {
      eligibilityCriteriaKey
      eligibilityStatus
    }
  }
}
    `;
export const AssignmentBorrowingBaseReportFragmentDocGQLType = gql`
    fragment AssignmentBorrowingBaseReport on AssignmentBorrowingBaseReport {
  creditFacilityId
  totalExposure
  totalBorrowingBaseAmount
  totalEligibleExposureLessConcentrationKickouts
  effectiveReceivableAdvanceRate
  balanceSheetExposure
  concentrationLimitCalculations {
    concentrationLimitKey
    concentrationLimit
    concentrationAmount
    totalEligibleExposure
    concentration
    borrowingBaseReduction
    complianceStatus
  }
  eligibilityCriteriaCalculations {
    eligibilityCriteriaKey
    eligibilityReduction
  }
}
    `;
export const AssignmentReceivablesAggregateTotalsByStatusFragmentDocGQLType = gql`
    fragment AssignmentReceivablesAggregateTotalsByStatus on AssignmentReceivablesAggregateTotalsByStatus {
  proposed {
    count
    exposure
  }
  unassigned {
    count
    exposure
  }
  previouslyAssigned {
    count
    exposure
  }
}
    `;
export const AssignmentStrategyFragmentDocGQLType = gql`
    fragment AssignmentStrategy on AssignmentStrategy {
  id
  name
  default
  description
  createdByUserId
  updatedByUserId
  decisionHeuristic
}
    `;
export const LoanProductCriteriaFragmentDocGQLType = gql`
    fragment LoanProductCriteria on LoanProductCriteria {
  id
  creditFacilityId
  assignmentStrategyId
  loanProductId
  exclusionSqlClause
}
    `;
export const EligibilityExclusionFragmentDocGQLType = gql`
    fragment EligibilityExclusion on EligibilityExclusion {
  id
  creditFacilityId
  assignmentStrategyId
  loanProductId
  eligibilityCriteriaKey
}
    `;
export const ReceivablePaginationMetadataFragmentDocGQLType = gql`
    fragment ReceivablePaginationMetadata on ReceivablePaginationMetadata {
  hasNextPage
  queryPageBoundaryReceivableIds
  queryPageNumber
}
    `;
export const ValleyIbsApiRecordFragmentDocGQLType = gql`
    fragment ValleyIbsApiRecord on ValleyIbsApiRecord {
  id
  action
  status
  version
  externalDomainTable
  externalDomainId
  executorUserId
  executedAt
  errorMessage
}
    `;
export const LoanRecordFragmentDocGQLType = gql`
    fragment LoanRecord on LoanRecord {
  id
  creditFacilityId
  borrowerOrganizationId
  externalLoanId
  name
  loanStatus
  loanType
  isFinal
  maturityDate
}
    `;
export const LoanActionRecordFragmentDocGQLType = gql`
    fragment LoanActionRecord on LoanActionRecord {
  id
  action
  status
  submittedUserId
  approvedUserId
  creditFacilityId
  metadata
}
    `;
export const LoanEditDestinationDataFragmentDocGQLType = gql`
    fragment LoanEditDestinationData on LoanEditDestinationData {
  loanId
  loanAction {
    ...LoanActionRecord
  }
}
    ${LoanActionRecordFragmentDocGQLType}`;
export const LoanEditDataFragmentDocGQLType = gql`
    fragment LoanEditData on LoanEditData {
  source {
    loanId
    loanAction {
      ...LoanActionRecord
    }
  }
  destination {
    ...LoanEditDestinationData
  }
}
    ${LoanActionRecordFragmentDocGQLType}
${LoanEditDestinationDataFragmentDocGQLType}`;
export const FundingLenderSharesFragmentDocGQLType = gql`
    fragment FundingLenderShares on FundingLenderShares {
  lenderShareId
  lenderOrganization {
    ...BaseOrganization
  }
  allocationPercent
  initialFundingAmount
  outstandingBalance
  totalAccruedInterest
  projectedInterest
}
    ${BaseOrganizationFragmentDocGQLType}`;
export const ShareFundingComponentFragmentDocGQLType = gql`
    fragment ShareFundingComponent on ShareFundingComponent {
  fundingRequestComponentId
  type
  requestedAmount
  targetFundingDate
  postingDate
  fundTransferDate
  lenderShareId
  lenderOrganizationId
  projectedInterest
}
    `;
export const FundingRequestEntitiesFragmentDocGQLType = gql`
    fragment FundingRequestEntities on FundingRequestEntities {
  fundingRequestId
  fundingRequestStatus
  fundingRequestType
  fundingRequestCreatedAt
  totalRequestedAmount
  originationDate
  fundingComponents {
    ...ShareFundingComponent
  }
}
    ${ShareFundingComponentFragmentDocGQLType}`;
export const ResolvedLoanFragmentDocGQLType = gql`
    fragment ResolvedLoan on ResolvedLoan {
  id
  externalLoanId
  commitmentKey
  name
  memo
  calculatedLoanStatus
  loanType
  edits {
    ...LoanEditData
  }
  dates {
    originationDate
    targetFundingDate
    settledDate
    maturityDate
  }
  facility {
    commitmentAmount
    creditFacilityId
    creditFacilityName
    externalFacilityId
    loanMechanics
  }
  funding {
    commitmentKey
    initialFundingAmount
    totalOutstandingBalance
    lenderShares {
      ...FundingLenderShares
    }
    requests {
      ...FundingRequestEntities
    }
  }
  parties {
    borrowerOrganization {
      ...BaseOrganization
    }
    adminAgentOrganization {
      ...BaseOrganization
    }
    lenderOrganizations {
      ...BaseOrganization
    }
  }
  pricing {
    key
    name
    accrual {
      basis
      cadence {
        type
      }
    }
    current {
      effectiveDate
      allInRate
      baseRate {
        type
        name
        determinationDate
        publishedDate
        publishedRate
        adjustedRate
        ceiling
        floor
        spread
      }
      weightedAverageMarginRate
    }
    history {
      effectiveDate
      baseRate {
        type
        name
        determinationDate
        publishedDate
        publishedRate
        adjustedRate
      }
      weightedAverageMarginRate
    }
    margins {
      organizationId
      rate
      skimFee {
        type
        rate
      }
    }
  }
  fees {
    accruedInterest {
      totalAmount
      annualAmounts {
        year
        amount
      }
    }
    projectedInterest
    accruedServiceFees {
      totalAmount
      annualAmounts {
        year
        amount
      }
    }
    projectedServiceFees
    totalAccruedInterestAndFees {
      totalAmount
      annualAmounts {
        year
        amount
      }
    }
  }
  invoices {
    nextInvoiceId
    nextPaymentDate
    mostRecentAccrualEndDate
  }
  customerProvided {
    escrow {
      amount
    }
    status {
      code
      name
    }
    servicer {
      name
    }
  }
}
    ${LoanEditDataFragmentDocGQLType}
${FundingLenderSharesFragmentDocGQLType}
${FundingRequestEntitiesFragmentDocGQLType}
${BaseOrganizationFragmentDocGQLType}`;
export const SummarizedLoanFragmentDocGQLType = gql`
    fragment SummarizedLoan on SummarizedLoan {
  id
  externalLoanId
  name
  calculatedLoanStatus
  loanType
  isFinal
  originationDate
  nextPaymentDate
  maturityDate
  creditFacilityId
  creditFacilityName
  externalFacilityId
  borrowerOrganization {
    ...BaseOrganization
  }
  lenderOrganizations {
    ...BaseOrganization
  }
  edits {
    ...LoanEditData
  }
}
    ${BaseOrganizationFragmentDocGQLType}
${LoanEditDataFragmentDocGQLType}`;
export const LenderShareReportFragmentDocGQLType = gql`
    fragment LenderShareReport on LenderShareReport {
  id
  creditFacilityId
  lenderShareId
  fundingRequestComponentId
  reportType
  reportName
  reportingDate
  version
  isPreview
  capitalProviderName
}
    `;
export const BatchSettlementReportFragmentDocGQLType = gql`
    fragment BatchSettlementReport on BatchSettlementReport {
  id
  creditFacilityId
  batchSettlementId
  reportType
  reportName
  reportingDate
  version
  isPreview
}
    `;
export const BatchSettlementFragmentDocGQLType = gql`
    fragment BatchSettlement on BatchSettlement {
  id
  creditFacilityId
  capitalProviderId
  startDate
  endDate
  capitalProviderName
  loans {
    loanId
    loanName
    externalLoanId
  }
  report {
    ...BatchSettlementReport
  }
  created_at
}
    ${BatchSettlementReportFragmentDocGQLType}`;
export const ColumnInfoFragmentDocGQLType = gql`
    fragment ColumnInfo on ColumnInfo {
  name
  required
  type
  description
  examples
  defaultValue
}
    `;
export const RequiredDataTapeFragmentDocGQLType = gql`
    fragment RequiredDataTape on RequiredDataTape {
  externalFilename
  artifactType
  artifactSlug
  artifactId
  validCreditFacilityIds
  loanProductSlug
  currentFileVersion
  currentReportingDate
  progressSummary
  fileExtension
  columns {
    ...ColumnInfo
  }
}
    ${ColumnInfoFragmentDocGQLType}`;
export const RequiredXlsxTapeFragmentDocGQLType = gql`
    fragment RequiredXlsxTape on RequiredXlsxTape {
  externalFilename
  artifactType
  artifactSlug
  artifactId
  validCreditFacilityIds
  loanProductSlug
  currentFileVersion
  currentReportingDate
  progressSummary
  fileExtension
  valueFieldGroups {
    dataTapeSlug
    columns {
      ...ColumnInfo
      sheetName
      cellAddress
    }
  }
  tapeFieldGroups {
    dataTapeSlug
    sheetName
    headerRange
    columns {
      ...ColumnInfo
    }
  }
}
    ${ColumnInfoFragmentDocGQLType}`;
export const EmailSubscriptionFragmentDocGQLType = gql`
    fragment EmailSubscription on EmailSubscription {
  id
  userId
  emailType
  filter {
    creditFacilitySlugs
  }
}
    `;
export const UserWithEmailSubscriptionsFragmentDocGQLType = gql`
    fragment UserWithEmailSubscriptions on User {
  id
  email
  userType
  isActive
  organizationId
  roleType
  firstName
  lastName
  organization {
    id
    name
    slug
  }
  emailSubscriptions {
    ...EmailSubscription
  }
}
    ${EmailSubscriptionFragmentDocGQLType}`;
export const OrgProvidedInputFragFragmentDocGQLType = gql`
    fragment OrgProvidedInputFrag on OrgProvidedInput {
  id
  organizationId
  key
  type
  nullable
}
    `;
export const OrgProvidedValueFragFragmentDocGQLType = gql`
    fragment OrgProvidedValueFrag on OrgProvidedValue {
  id
  orgProvidedInputId
  value
  reportingDate
  version
  supplementalS3Path
}
    `;
export const CoreBorrowingBaseInsightsFragmentDocGQLType = gql`
    fragment CoreBorrowingBaseInsights on CoreBorrowingBaseInsightsGqlData {
  reportingDate
  fileVersion
  totalReceivableExposure
  totalEligibleExposure
  totalEligibleExposureLessConcentrationKickouts
  totalReceivableBorrowingBaseAmount
  effectiveReceivableAdvanceRate
  totalEligibleBorrowingBaseAccountCash
  totalCollectionsAccountCash
  totalPreAdvanceCashContribution
  totalCashBorrowingBaseAmount
  effectiveCashAdvanceRate
  totalBorrowingBaseAmount
  effectiveAdvanceRate
  totalAssets
  commitmentAmount
  currentPrincipalBalance
  totalFacilityUtilization
}
    `;
export const LedgerTransactionFragmentDocGQLType = gql`
    fragment LedgerTransaction on LedgerTransaction {
  organizationId
  transactionType
  amount
  normalizedAmount
  type
  accountType
  postingDate
  balance
  comment
}
    `;
export const TaskEntityFragmentDocGQLType = gql`
    fragment TaskEntity on TaskEntity {
  id
  status
  dueDate
  assignedUser {
    id
    firstName
    lastName
  }
}
    `;
export const TaskFragmentDocGQLType = gql`
    fragment Task on Task {
  taskEntity {
    ...TaskEntity
  }
  domainProperties {
    creditFacility {
      id
      name
    }
    amount
    party {
      id
      name
    }
    categorySpecificProperties {
      ... on FundingRequestTaskSpecificProperties {
        category
        fundingRequestId
        loanIds
        fundingRequestDueDate
      }
      ... on InvoiceTaskSpecificProperties {
        category
        invoiceId
        invoiceLoanIds
        invoiceDueDate
      }
      ... on ConsolidatedDisbursementTaskProperties {
        category
        consolidatedDisbursementId
        invoiceLoanIds
      }
      ... on LenderSharesTaskSpecificProperties {
        category
        lenderSharesId
        lenderSharesLoanId
        lenderSharesDueDate
        fundingComponentId
      }
    }
  }
}
    ${TaskEntityFragmentDocGQLType}`;
export const WorkflowTemplateConstructorFieldsFragmentDocGQLType = gql`
    fragment WorkflowTemplateConstructorFields on WorkflowTemplateConstructor {
  title
  finalAction {
    title
    functionName
  }
  optionsExposedToUsers {
    runtimeVariables {
      ... on StringRuntimeVariableTemplate {
        name
        returnType
        options {
          label
          stringValue
        }
      }
      ... on StringArrayRuntimeVariableTemplate {
        name
        returnType
        options {
          label
          stringValue
        }
      }
      ... on NumberRuntimeVariableTemplate {
        name
        returnType
        options {
          label
          numberValue
        }
      }
    }
    domainSpecificRuntimeVariable {
      usersApprovalRuntimeVariable {
        name
        returnType
        options {
          label
          stringValue
        }
      }
    }
    actions {
      functionName
      params {
        ... on StringStaticParamTemplate {
          variableName
          variableType
          options {
            label
            stringValue
          }
        }
        ... on NumberStaticParamTemplate {
          variableName
          variableType
          options {
            label
            numberValue
          }
        }
        ... on StringArrayStaticParamTemplate {
          variableName
          variableType
          options {
            label
            stringValue
          }
        }
      }
    }
  }
}
    `;
export const WorkflowTemplateFieldsFragmentDocGQLType = gql`
    fragment WorkflowTemplateFields on WorkflowTemplate {
  id
  workflowId
  version
  workflowType
  workflow {
    userApprovalNodes {
      id
      comparator
      userIds
    }
    actionNodes {
      id
      actionFunctionName
      actionParams {
        variableName
        variableBinding {
          stringVariableBinding
          numberVariableBinding
          stringArrayVariableBinding
        }
      }
    }
    conditionalNodes {
      if {
        id
        comparator
        runtimeVariableName
        rightOperandStringArray
        rightOperandNumber
      }
      elif {
        id
        comparator
        runtimeVariableName
        rightOperandStringArray
        rightOperandNumber
      }
      else {
        id
      }
    }
    edges {
      from
      to
    }
  }
  name
  organizationId
  authorUserId
}
    `;
export const CancelFundingRequestDocumentGQLType = gql`
    mutation CancelFundingRequest($fundingRequestId: UUID!) {
  cancelFundingRequest(fundingRequestId: $fundingRequestId) {
    fundingRequestId
    response
  }
}
    `;
export type CancelFundingRequestMutationFnGQLType = Apollo.MutationFunction<CancelFundingRequestMutationGQLType, CancelFundingRequestMutationVariablesGQLType>;

/**
 * __useCancelFundingRequestMutation__
 *
 * To run a mutation, you first call `useCancelFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFundingRequestMutation, { data, loading, error }] = useCancelFundingRequestMutation({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useCancelFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelFundingRequestMutationGQLType, CancelFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFundingRequestMutationGQLType, CancelFundingRequestMutationVariablesGQLType>(CancelFundingRequestDocumentGQLType, options);
      }
export type CancelFundingRequestMutationHookResult = ReturnType<typeof useCancelFundingRequestMutation>;
export type CancelFundingRequestMutationResultGQLType = Apollo.MutationResult<CancelFundingRequestMutationGQLType>;
export type CancelFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<CancelFundingRequestMutationGQLType, CancelFundingRequestMutationVariablesGQLType>;
export const CreateFundingRequestDocumentGQLType = gql`
    mutation CreateFundingRequest($creditFacilityId: UUID!) {
  createFundingRequest(creditFacilityId: $creditFacilityId) {
    fundingRequestId
    response
  }
}
    `;
export type CreateFundingRequestMutationFnGQLType = Apollo.MutationFunction<CreateFundingRequestMutationGQLType, CreateFundingRequestMutationVariablesGQLType>;

/**
 * __useCreateFundingRequestMutation__
 *
 * To run a mutation, you first call `useCreateFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFundingRequestMutation, { data, loading, error }] = useCreateFundingRequestMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCreateFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateFundingRequestMutationGQLType, CreateFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFundingRequestMutationGQLType, CreateFundingRequestMutationVariablesGQLType>(CreateFundingRequestDocumentGQLType, options);
      }
export type CreateFundingRequestMutationHookResult = ReturnType<typeof useCreateFundingRequestMutation>;
export type CreateFundingRequestMutationResultGQLType = Apollo.MutationResult<CreateFundingRequestMutationGQLType>;
export type CreateFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateFundingRequestMutationGQLType, CreateFundingRequestMutationVariablesGQLType>;
export const CreateServicerReportPreviewDocumentGQLType = gql`
    mutation CreateServicerReportPreview($fundingRequestChangeset: UpdateFundingRequestChangeset!) {
  createServicerReportPreview(fundingRequestChangeset: $fundingRequestChangeset) {
    response
  }
}
    `;
export type CreateServicerReportPreviewMutationFnGQLType = Apollo.MutationFunction<CreateServicerReportPreviewMutationGQLType, CreateServicerReportPreviewMutationVariablesGQLType>;

/**
 * __useCreateServicerReportPreviewMutation__
 *
 * To run a mutation, you first call `useCreateServicerReportPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServicerReportPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServicerReportPreviewMutation, { data, loading, error }] = useCreateServicerReportPreviewMutation({
 *   variables: {
 *      fundingRequestChangeset: // value for 'fundingRequestChangeset'
 *   },
 * });
 */
export function useCreateServicerReportPreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateServicerReportPreviewMutationGQLType, CreateServicerReportPreviewMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServicerReportPreviewMutationGQLType, CreateServicerReportPreviewMutationVariablesGQLType>(CreateServicerReportPreviewDocumentGQLType, options);
      }
export type CreateServicerReportPreviewMutationHookResult = ReturnType<typeof useCreateServicerReportPreviewMutation>;
export type CreateServicerReportPreviewMutationResultGQLType = Apollo.MutationResult<CreateServicerReportPreviewMutationGQLType>;
export type CreateServicerReportPreviewMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateServicerReportPreviewMutationGQLType, CreateServicerReportPreviewMutationVariablesGQLType>;
export const CreateAssetVerificationDocumentDocumentGQLType = gql`
    mutation CreateAssetVerificationDocument($receivableDocumentationRawId: UUID!, $assetVerificationDocument: String!, $note: String!) {
  createAssetVerificationDocument(
    receivableDocumentationRawId: $receivableDocumentationRawId
    assetVerificationDocument: $assetVerificationDocument
    note: $note
  ) {
    response
  }
}
    `;
export type CreateAssetVerificationDocumentMutationFnGQLType = Apollo.MutationFunction<CreateAssetVerificationDocumentMutationGQLType, CreateAssetVerificationDocumentMutationVariablesGQLType>;

/**
 * __useCreateAssetVerificationDocumentMutation__
 *
 * To run a mutation, you first call `useCreateAssetVerificationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetVerificationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetVerificationDocumentMutation, { data, loading, error }] = useCreateAssetVerificationDocumentMutation({
 *   variables: {
 *      receivableDocumentationRawId: // value for 'receivableDocumentationRawId'
 *      assetVerificationDocument: // value for 'assetVerificationDocument'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateAssetVerificationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetVerificationDocumentMutationGQLType, CreateAssetVerificationDocumentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetVerificationDocumentMutationGQLType, CreateAssetVerificationDocumentMutationVariablesGQLType>(CreateAssetVerificationDocumentDocumentGQLType, options);
      }
export type CreateAssetVerificationDocumentMutationHookResult = ReturnType<typeof useCreateAssetVerificationDocumentMutation>;
export type CreateAssetVerificationDocumentMutationResultGQLType = Apollo.MutationResult<CreateAssetVerificationDocumentMutationGQLType>;
export type CreateAssetVerificationDocumentMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateAssetVerificationDocumentMutationGQLType, CreateAssetVerificationDocumentMutationVariablesGQLType>;
export const SubmitFundingRequestDocumentGQLType = gql`
    mutation SubmitFundingRequest($fundingRequestChangeset: UpdateFundingRequestChangeset!) {
  submitFundingRequest(fundingRequestChangeset: $fundingRequestChangeset) {
    ...FundingRequestWithFullDetails
  }
}
    ${FundingRequestWithFullDetailsFragmentDocGQLType}`;
export type SubmitFundingRequestMutationFnGQLType = Apollo.MutationFunction<SubmitFundingRequestMutationGQLType, SubmitFundingRequestMutationVariablesGQLType>;

/**
 * __useSubmitFundingRequestMutation__
 *
 * To run a mutation, you first call `useSubmitFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFundingRequestMutation, { data, loading, error }] = useSubmitFundingRequestMutation({
 *   variables: {
 *      fundingRequestChangeset: // value for 'fundingRequestChangeset'
 *   },
 * });
 */
export function useSubmitFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFundingRequestMutationGQLType, SubmitFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFundingRequestMutationGQLType, SubmitFundingRequestMutationVariablesGQLType>(SubmitFundingRequestDocumentGQLType, options);
      }
export type SubmitFundingRequestMutationHookResult = ReturnType<typeof useSubmitFundingRequestMutation>;
export type SubmitFundingRequestMutationResultGQLType = Apollo.MutationResult<SubmitFundingRequestMutationGQLType>;
export type SubmitFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<SubmitFundingRequestMutationGQLType, SubmitFundingRequestMutationVariablesGQLType>;
export const GetCreditFacilitySummariesDocumentGQLType = gql`
    query GetCreditFacilitySummaries {
  creditFacilitySummaries {
    id
    isActive
    currentFundingRequest {
      ...FundingRequestWithComponentsAndBankAccounts
    }
  }
}
    ${FundingRequestWithComponentsAndBankAccountsFragmentDocGQLType}`;

/**
 * __useGetCreditFacilitySummariesQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitySummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitySummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitySummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditFacilitySummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditFacilitySummariesQueryGQLType, GetCreditFacilitySummariesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitySummariesQueryGQLType, GetCreditFacilitySummariesQueryVariablesGQLType>(GetCreditFacilitySummariesDocumentGQLType, options);
      }
export function useGetCreditFacilitySummariesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitySummariesQueryGQLType, GetCreditFacilitySummariesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitySummariesQueryGQLType, GetCreditFacilitySummariesQueryVariablesGQLType>(GetCreditFacilitySummariesDocumentGQLType, options);
        }
export type GetCreditFacilitySummariesQueryHookResult = ReturnType<typeof useGetCreditFacilitySummariesQuery>;
export type GetCreditFacilitySummariesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitySummariesLazyQueryGQLType>;
export type GetCreditFacilitySummariesQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitySummariesQueryGQLType, GetCreditFacilitySummariesQueryVariablesGQLType>;
export const GetCreditFacilitySummariesNewDocumentGQLType = gql`
    query GetCreditFacilitySummariesNew($creditFacilityIds: [UUID!]!) {
  creditFacilitySummariesNew(creditFacilityIds: $creditFacilityIds) {
    id
    isActive
    currentFundingRequest {
      ...FundingRequestWithComponentsAndBankAccounts
    }
  }
}
    ${FundingRequestWithComponentsAndBankAccountsFragmentDocGQLType}`;

/**
 * __useGetCreditFacilitySummariesNewQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitySummariesNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitySummariesNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitySummariesNewQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetCreditFacilitySummariesNewQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitySummariesNewQueryGQLType, GetCreditFacilitySummariesNewQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitySummariesNewQueryGQLType, GetCreditFacilitySummariesNewQueryVariablesGQLType>(GetCreditFacilitySummariesNewDocumentGQLType, options);
      }
export function useGetCreditFacilitySummariesNewLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitySummariesNewQueryGQLType, GetCreditFacilitySummariesNewQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitySummariesNewQueryGQLType, GetCreditFacilitySummariesNewQueryVariablesGQLType>(GetCreditFacilitySummariesNewDocumentGQLType, options);
        }
export type GetCreditFacilitySummariesNewQueryHookResult = ReturnType<typeof useGetCreditFacilitySummariesNewQuery>;
export type GetCreditFacilitySummariesNewLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitySummariesNewLazyQueryGQLType>;
export type GetCreditFacilitySummariesNewQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitySummariesNewQueryGQLType, GetCreditFacilitySummariesNewQueryVariablesGQLType>;
export const ApproveFundingRequestDocumentGQLType = gql`
    mutation ApproveFundingRequest($fundingRequestId: UUID!) {
  approveFundingRequest(fundingRequestId: $fundingRequestId) {
    fundingRequestId
    response
  }
}
    `;
export type ApproveFundingRequestMutationFnGQLType = Apollo.MutationFunction<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>;

/**
 * __useApproveFundingRequestMutation__
 *
 * To run a mutation, you first call `useApproveFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFundingRequestMutation, { data, loading, error }] = useApproveFundingRequestMutation({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useApproveFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>(ApproveFundingRequestDocumentGQLType, options);
      }
export type ApproveFundingRequestMutationHookResult = ReturnType<typeof useApproveFundingRequestMutation>;
export type ApproveFundingRequestMutationResultGQLType = Apollo.MutationResult<ApproveFundingRequestMutationGQLType>;
export type ApproveFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<ApproveFundingRequestMutationGQLType, ApproveFundingRequestMutationVariablesGQLType>;
export const RejectFundingRequestDocumentGQLType = gql`
    mutation RejectFundingRequest($fundingRequestId: UUID!) {
  rejectFundingRequest(fundingRequestId: $fundingRequestId) {
    fundingRequestId
    response
  }
}
    `;
export type RejectFundingRequestMutationFnGQLType = Apollo.MutationFunction<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>;

/**
 * __useRejectFundingRequestMutation__
 *
 * To run a mutation, you first call `useRejectFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectFundingRequestMutation, { data, loading, error }] = useRejectFundingRequestMutation({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useRejectFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>(RejectFundingRequestDocumentGQLType, options);
      }
export type RejectFundingRequestMutationHookResult = ReturnType<typeof useRejectFundingRequestMutation>;
export type RejectFundingRequestMutationResultGQLType = Apollo.MutationResult<RejectFundingRequestMutationGQLType>;
export type RejectFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<RejectFundingRequestMutationGQLType, RejectFundingRequestMutationVariablesGQLType>;
export const UserApprovalActionForFundingRequestWorkflowInstanceDocumentGQLType = gql`
    mutation UserApprovalActionForFundingRequestWorkflowInstance($action: UserApprovalAction!, $userId: UUID!, $fundingRequestId: UUID!, $workflowInstanceId: UUID!) {
  userApprovalActionForFundingRequestWorkflowInstance(
    action: $action
    userId: $userId
    fundingRequestId: $fundingRequestId
    workflowInstanceId: $workflowInstanceId
  ) {
    fundingRequestId
    response
  }
}
    `;
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationFnGQLType = Apollo.MutationFunction<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>;

/**
 * __useUserApprovalActionForFundingRequestWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useUserApprovalActionForFundingRequestWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserApprovalActionForFundingRequestWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userApprovalActionForFundingRequestWorkflowInstanceMutation, { data, loading, error }] = useUserApprovalActionForFundingRequestWorkflowInstanceMutation({
 *   variables: {
 *      action: // value for 'action'
 *      userId: // value for 'userId'
 *      fundingRequestId: // value for 'fundingRequestId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *   },
 * });
 */
export function useUserApprovalActionForFundingRequestWorkflowInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>(UserApprovalActionForFundingRequestWorkflowInstanceDocumentGQLType, options);
      }
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationHookResult = ReturnType<typeof useUserApprovalActionForFundingRequestWorkflowInstanceMutation>;
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationResultGQLType = Apollo.MutationResult<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType>;
export type UserApprovalActionForFundingRequestWorkflowInstanceMutationOptionsGQLType = Apollo.BaseMutationOptions<UserApprovalActionForFundingRequestWorkflowInstanceMutationGQLType, UserApprovalActionForFundingRequestWorkflowInstanceMutationVariablesGQLType>;
export const GetWorkflowInstanceIdForFundingRequestDocumentGQLType = gql`
    query GetWorkflowInstanceIdForFundingRequest($fundingRequestId: UUID!, $organizationId: UUID!) {
  getWorkflowInstanceIdForFundingRequest(
    fundingRequestId: $fundingRequestId
    organizationId: $organizationId
  )
}
    `;

/**
 * __useGetWorkflowInstanceIdForFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetWorkflowInstanceIdForFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowInstanceIdForFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowInstanceIdForFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkflowInstanceIdForFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>(GetWorkflowInstanceIdForFundingRequestDocumentGQLType, options);
      }
export function useGetWorkflowInstanceIdForFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>(GetWorkflowInstanceIdForFundingRequestDocumentGQLType, options);
        }
export type GetWorkflowInstanceIdForFundingRequestQueryHookResult = ReturnType<typeof useGetWorkflowInstanceIdForFundingRequestQuery>;
export type GetWorkflowInstanceIdForFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetWorkflowInstanceIdForFundingRequestLazyQueryGQLType>;
export type GetWorkflowInstanceIdForFundingRequestQueryResultGQLType = Apollo.QueryResult<GetWorkflowInstanceIdForFundingRequestQueryGQLType, GetWorkflowInstanceIdForFundingRequestQueryVariablesGQLType>;
export const UserApprovalGroupsForFundingRequestDocumentGQLType = gql`
    query UserApprovalGroupsForFundingRequest($fundingRequestId: UUID!) {
  userApprovalGroupsForFundingRequest(fundingRequestId: $fundingRequestId) {
    id
    comparator
    requestedApprovals {
      user {
        id
        email
        firstName
        lastName
        userType
        roleType
      }
      state {
        status
        statusAt
      }
    }
    groupState {
      status
      statusAt
    }
  }
}
    `;

/**
 * __useUserApprovalGroupsForFundingRequestQuery__
 *
 * To run a query within a React component, call `useUserApprovalGroupsForFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserApprovalGroupsForFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserApprovalGroupsForFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useUserApprovalGroupsForFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>(UserApprovalGroupsForFundingRequestDocumentGQLType, options);
      }
export function useUserApprovalGroupsForFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>(UserApprovalGroupsForFundingRequestDocumentGQLType, options);
        }
export type UserApprovalGroupsForFundingRequestQueryHookResult = ReturnType<typeof useUserApprovalGroupsForFundingRequestQuery>;
export type UserApprovalGroupsForFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useUserApprovalGroupsForFundingRequestLazyQueryGQLType>;
export type UserApprovalGroupsForFundingRequestQueryResultGQLType = Apollo.QueryResult<UserApprovalGroupsForFundingRequestQueryGQLType, UserApprovalGroupsForFundingRequestQueryVariablesGQLType>;
export const GetUserWithCreditFacilitiesCountDocumentGQLType = gql`
    query GetUserWithCreditFacilitiesCount {
  user {
    id
    email
    userType
    isActive
    organizationId
    roleType
    firstName
    lastName
    organization {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useGetUserWithCreditFacilitiesCountQuery__
 *
 * To run a query within a React component, call `useGetUserWithCreditFacilitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithCreditFacilitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithCreditFacilitiesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithCreditFacilitiesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithCreditFacilitiesCountQueryGQLType, GetUserWithCreditFacilitiesCountQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithCreditFacilitiesCountQueryGQLType, GetUserWithCreditFacilitiesCountQueryVariablesGQLType>(GetUserWithCreditFacilitiesCountDocumentGQLType, options);
      }
export function useGetUserWithCreditFacilitiesCountLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithCreditFacilitiesCountQueryGQLType, GetUserWithCreditFacilitiesCountQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithCreditFacilitiesCountQueryGQLType, GetUserWithCreditFacilitiesCountQueryVariablesGQLType>(GetUserWithCreditFacilitiesCountDocumentGQLType, options);
        }
export type GetUserWithCreditFacilitiesCountQueryHookResult = ReturnType<typeof useGetUserWithCreditFacilitiesCountQuery>;
export type GetUserWithCreditFacilitiesCountLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUserWithCreditFacilitiesCountLazyQueryGQLType>;
export type GetUserWithCreditFacilitiesCountQueryResultGQLType = Apollo.QueryResult<GetUserWithCreditFacilitiesCountQueryGQLType, GetUserWithCreditFacilitiesCountQueryVariablesGQLType>;
export const GetLoanTapeSanitizeConfigsQueryDocumentGQLType = gql`
    query getLoanTapeSanitizeConfigsQuery($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    slug
    borrowerId
    loanProducts {
      id
      slug
    }
  }
  getLoanTapeSanitizeConfigs(creditFacilityId: $creditFacilityId) {
    loanProductSlug
    sanitizeArtifactSlug
    rawExternalReceivableIdField
    baseFields
  }
}
    `;

/**
 * __useGetLoanTapeSanitizeConfigsQueryQuery__
 *
 * To run a query within a React component, call `useGetLoanTapeSanitizeConfigsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanTapeSanitizeConfigsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanTapeSanitizeConfigsQueryQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLoanTapeSanitizeConfigsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetLoanTapeSanitizeConfigsQueryQueryGQLType, GetLoanTapeSanitizeConfigsQueryQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanTapeSanitizeConfigsQueryQueryGQLType, GetLoanTapeSanitizeConfigsQueryQueryVariablesGQLType>(GetLoanTapeSanitizeConfigsQueryDocumentGQLType, options);
      }
export function useGetLoanTapeSanitizeConfigsQueryLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanTapeSanitizeConfigsQueryQueryGQLType, GetLoanTapeSanitizeConfigsQueryQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanTapeSanitizeConfigsQueryQueryGQLType, GetLoanTapeSanitizeConfigsQueryQueryVariablesGQLType>(GetLoanTapeSanitizeConfigsQueryDocumentGQLType, options);
        }
export type GetLoanTapeSanitizeConfigsQueryQueryHookResult = ReturnType<typeof useGetLoanTapeSanitizeConfigsQueryQuery>;
export type GetLoanTapeSanitizeConfigsQueryLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanTapeSanitizeConfigsQueryLazyQueryGQLType>;
export type GetLoanTapeSanitizeConfigsQueryQueryResultGQLType = Apollo.QueryResult<GetLoanTapeSanitizeConfigsQueryQueryGQLType, GetLoanTapeSanitizeConfigsQueryQueryVariablesGQLType>;
export const SetLoanTapeSanitizeConfigsDocumentGQLType = gql`
    mutation setLoanTapeSanitizeConfigs($creditFacilityId: UUID!, $configs: [LoanTapeSanitizeConfigInput!]!) {
  setLoanTapeSanitizeConfigs(
    creditFacilityId: $creditFacilityId
    sanitizeConfigs: $configs
  ) {
    response
  }
}
    `;
export type SetLoanTapeSanitizeConfigsMutationFnGQLType = Apollo.MutationFunction<SetLoanTapeSanitizeConfigsMutationGQLType, SetLoanTapeSanitizeConfigsMutationVariablesGQLType>;

/**
 * __useSetLoanTapeSanitizeConfigsMutation__
 *
 * To run a mutation, you first call `useSetLoanTapeSanitizeConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLoanTapeSanitizeConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLoanTapeSanitizeConfigsMutation, { data, loading, error }] = useSetLoanTapeSanitizeConfigsMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      configs: // value for 'configs'
 *   },
 * });
 */
export function useSetLoanTapeSanitizeConfigsMutation(baseOptions?: Apollo.MutationHookOptions<SetLoanTapeSanitizeConfigsMutationGQLType, SetLoanTapeSanitizeConfigsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLoanTapeSanitizeConfigsMutationGQLType, SetLoanTapeSanitizeConfigsMutationVariablesGQLType>(SetLoanTapeSanitizeConfigsDocumentGQLType, options);
      }
export type SetLoanTapeSanitizeConfigsMutationHookResult = ReturnType<typeof useSetLoanTapeSanitizeConfigsMutation>;
export type SetLoanTapeSanitizeConfigsMutationResultGQLType = Apollo.MutationResult<SetLoanTapeSanitizeConfigsMutationGQLType>;
export type SetLoanTapeSanitizeConfigsMutationOptionsGQLType = Apollo.BaseMutationOptions<SetLoanTapeSanitizeConfigsMutationGQLType, SetLoanTapeSanitizeConfigsMutationVariablesGQLType>;
export const CommitCreditAgreementWipToSandboxDocumentGQLType = gql`
    mutation CommitCreditAgreementWipToSandbox($creditFacilityId: UUID!) {
  commitCreditAgreementWipToSandbox(creditFacilityId: $creditFacilityId) {
    errors
  }
}
    `;
export type CommitCreditAgreementWipToSandboxMutationFnGQLType = Apollo.MutationFunction<CommitCreditAgreementWipToSandboxMutationGQLType, CommitCreditAgreementWipToSandboxMutationVariablesGQLType>;

/**
 * __useCommitCreditAgreementWipToSandboxMutation__
 *
 * To run a mutation, you first call `useCommitCreditAgreementWipToSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitCreditAgreementWipToSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitCreditAgreementWipToSandboxMutation, { data, loading, error }] = useCommitCreditAgreementWipToSandboxMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCommitCreditAgreementWipToSandboxMutation(baseOptions?: Apollo.MutationHookOptions<CommitCreditAgreementWipToSandboxMutationGQLType, CommitCreditAgreementWipToSandboxMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitCreditAgreementWipToSandboxMutationGQLType, CommitCreditAgreementWipToSandboxMutationVariablesGQLType>(CommitCreditAgreementWipToSandboxDocumentGQLType, options);
      }
export type CommitCreditAgreementWipToSandboxMutationHookResult = ReturnType<typeof useCommitCreditAgreementWipToSandboxMutation>;
export type CommitCreditAgreementWipToSandboxMutationResultGQLType = Apollo.MutationResult<CommitCreditAgreementWipToSandboxMutationGQLType>;
export type CommitCreditAgreementWipToSandboxMutationOptionsGQLType = Apollo.BaseMutationOptions<CommitCreditAgreementWipToSandboxMutationGQLType, CommitCreditAgreementWipToSandboxMutationVariablesGQLType>;
export const GetCreditFacilitiesByOrganizationDocumentGQLType = gql`
    query GetCreditFacilitiesByOrganization($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]!) {
  organization(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  ) {
    id
    creditFacilities {
      id
      borrowerId
      name
      isActive
      slug
      type
      implementationId
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesByOrganizationQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetCreditFacilitiesByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesByOrganizationQueryGQLType, GetCreditFacilitiesByOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesByOrganizationQueryGQLType, GetCreditFacilitiesByOrganizationQueryVariablesGQLType>(GetCreditFacilitiesByOrganizationDocumentGQLType, options);
      }
export function useGetCreditFacilitiesByOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesByOrganizationQueryGQLType, GetCreditFacilitiesByOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesByOrganizationQueryGQLType, GetCreditFacilitiesByOrganizationQueryVariablesGQLType>(GetCreditFacilitiesByOrganizationDocumentGQLType, options);
        }
export type GetCreditFacilitiesByOrganizationQueryHookResult = ReturnType<typeof useGetCreditFacilitiesByOrganizationQuery>;
export type GetCreditFacilitiesByOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesByOrganizationLazyQueryGQLType>;
export type GetCreditFacilitiesByOrganizationQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesByOrganizationQueryGQLType, GetCreditFacilitiesByOrganizationQueryVariablesGQLType>;
export const GetUserDocumentGQLType = gql`
    query GetUser {
  user {
    id
    email
    userType
    isActive
    organizationId
    roleType
    firstName
    lastName
    organization {
      id
      name
      slug
      orgPreferences {
        cashBalancePreference
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQueryGQLType, GetUserQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQueryGQLType, GetUserQueryVariablesGQLType>(GetUserDocumentGQLType, options);
      }
export function useGetUserLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQueryGQLType, GetUserQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQueryGQLType, GetUserQueryVariablesGQLType>(GetUserDocumentGQLType, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUserLazyQueryGQLType>;
export type GetUserQueryResultGQLType = Apollo.QueryResult<GetUserQueryGQLType, GetUserQueryVariablesGQLType>;
export const CreateCdqDocumentGQLType = gql`
    mutation createCDQ($name: String!, $organizationId: UUID!, $decodedQuery: String!, $creditFacilityId: UUID) {
  createCDQ(
    name: $name
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
    decodedQuery: $decodedQuery
  ) {
    id
    errors
  }
}
    `;
export type CreateCdqMutationFnGQLType = Apollo.MutationFunction<CreateCdqMutationGQLType, CreateCdqMutationVariablesGQLType>;

/**
 * __useCreateCdqMutation__
 *
 * To run a mutation, you first call `useCreateCdqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCdqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCdqMutation, { data, loading, error }] = useCreateCdqMutation({
 *   variables: {
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      decodedQuery: // value for 'decodedQuery'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCreateCdqMutation(baseOptions?: Apollo.MutationHookOptions<CreateCdqMutationGQLType, CreateCdqMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCdqMutationGQLType, CreateCdqMutationVariablesGQLType>(CreateCdqDocumentGQLType, options);
      }
export type CreateCdqMutationHookResult = ReturnType<typeof useCreateCdqMutation>;
export type CreateCdqMutationResultGQLType = Apollo.MutationResult<CreateCdqMutationGQLType>;
export type CreateCdqMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateCdqMutationGQLType, CreateCdqMutationVariablesGQLType>;
export const GetActiveCdqConfigsDocumentGQLType = gql`
    query getActiveCdqConfigs($organizationId: UUID!, $creditFacilityId: UUID) {
  getActiveCdqConfigs(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
  ) {
    id
    name
    decodedQuery
  }
}
    `;

/**
 * __useGetActiveCdqConfigsQuery__
 *
 * To run a query within a React component, call `useGetActiveCdqConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCdqConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCdqConfigsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetActiveCdqConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveCdqConfigsQueryGQLType, GetActiveCdqConfigsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCdqConfigsQueryGQLType, GetActiveCdqConfigsQueryVariablesGQLType>(GetActiveCdqConfigsDocumentGQLType, options);
      }
export function useGetActiveCdqConfigsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCdqConfigsQueryGQLType, GetActiveCdqConfigsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCdqConfigsQueryGQLType, GetActiveCdqConfigsQueryVariablesGQLType>(GetActiveCdqConfigsDocumentGQLType, options);
        }
export type GetActiveCdqConfigsQueryHookResult = ReturnType<typeof useGetActiveCdqConfigsQuery>;
export type GetActiveCdqConfigsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActiveCdqConfigsLazyQueryGQLType>;
export type GetActiveCdqConfigsQueryResultGQLType = Apollo.QueryResult<GetActiveCdqConfigsQueryGQLType, GetActiveCdqConfigsQueryVariablesGQLType>;
export const DeactivateCdqConfigDocumentGQLType = gql`
    mutation deactivateCdqConfig($id: UUID!) {
  deactivateCdqConfig(id: $id) {
    id
    errors
  }
}
    `;
export type DeactivateCdqConfigMutationFnGQLType = Apollo.MutationFunction<DeactivateCdqConfigMutationGQLType, DeactivateCdqConfigMutationVariablesGQLType>;

/**
 * __useDeactivateCdqConfigMutation__
 *
 * To run a mutation, you first call `useDeactivateCdqConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCdqConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCdqConfigMutation, { data, loading, error }] = useDeactivateCdqConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateCdqConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCdqConfigMutationGQLType, DeactivateCdqConfigMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCdqConfigMutationGQLType, DeactivateCdqConfigMutationVariablesGQLType>(DeactivateCdqConfigDocumentGQLType, options);
      }
export type DeactivateCdqConfigMutationHookResult = ReturnType<typeof useDeactivateCdqConfigMutation>;
export type DeactivateCdqConfigMutationResultGQLType = Apollo.MutationResult<DeactivateCdqConfigMutationGQLType>;
export type DeactivateCdqConfigMutationOptionsGQLType = Apollo.BaseMutationOptions<DeactivateCdqConfigMutationGQLType, DeactivateCdqConfigMutationVariablesGQLType>;
export const FetchAcknowledgedCdqResultsDocumentGQLType = gql`
    query fetchAcknowledgedCdqResults($cdqId: UUID!) {
  acknowledgedCdqResults: getAcknowledgedItems(cdqId: $cdqId) {
    Items {
      finleyReceivableId
      currentReportingDate
      previousReportingDate
      otherFields
      acknowledgementData {
        acknowledgementId
        acknowledgedOn
        acknowledgedBy
        acknowledgedFor
      }
    }
    NextToken
    QueryExecutionId
    totalUnAcknowledgedIssueCount
    totalAcknowledgedIssueCount
  }
}
    `;

/**
 * __useFetchAcknowledgedCdqResultsQuery__
 *
 * To run a query within a React component, call `useFetchAcknowledgedCdqResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAcknowledgedCdqResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAcknowledgedCdqResultsQuery({
 *   variables: {
 *      cdqId: // value for 'cdqId'
 *   },
 * });
 */
export function useFetchAcknowledgedCdqResultsQuery(baseOptions: Apollo.QueryHookOptions<FetchAcknowledgedCdqResultsQueryGQLType, FetchAcknowledgedCdqResultsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAcknowledgedCdqResultsQueryGQLType, FetchAcknowledgedCdqResultsQueryVariablesGQLType>(FetchAcknowledgedCdqResultsDocumentGQLType, options);
      }
export function useFetchAcknowledgedCdqResultsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<FetchAcknowledgedCdqResultsQueryGQLType, FetchAcknowledgedCdqResultsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAcknowledgedCdqResultsQueryGQLType, FetchAcknowledgedCdqResultsQueryVariablesGQLType>(FetchAcknowledgedCdqResultsDocumentGQLType, options);
        }
export type FetchAcknowledgedCdqResultsQueryHookResult = ReturnType<typeof useFetchAcknowledgedCdqResultsQuery>;
export type FetchAcknowledgedCdqResultsLazyQueryGQLTypeHookResult = ReturnType<typeof useFetchAcknowledgedCdqResultsLazyQueryGQLType>;
export type FetchAcknowledgedCdqResultsQueryResultGQLType = Apollo.QueryResult<FetchAcknowledgedCdqResultsQueryGQLType, FetchAcknowledgedCdqResultsQueryVariablesGQLType>;
export const FetchCdqResultsDocumentGQLType = gql`
    query fetchCdqResults($cdqId: UUID!) {
  unacknowledged: getUnAcknowledgedItems(cdqId: $cdqId) {
    Items {
      finleyReceivableId
      currentReportingDate
      previousReportingDate
      otherFields
      acknowledgementData {
        acknowledgementId
        acknowledgedOn
        acknowledgedBy
        acknowledgedFor
      }
    }
    NextToken
    QueryExecutionId
    totalUnAcknowledgedIssueCount
    totalAcknowledgedIssueCount
  }
  acknowledged: getAcknowledgedItems(cdqId: $cdqId) {
    Items {
      finleyReceivableId
      currentReportingDate
      previousReportingDate
      otherFields
      acknowledgementData {
        acknowledgementId
        acknowledgedOn
        acknowledgedBy
        acknowledgedFor
      }
    }
    NextToken
    QueryExecutionId
    totalUnAcknowledgedIssueCount
    totalAcknowledgedIssueCount
  }
}
    `;

/**
 * __useFetchCdqResultsQuery__
 *
 * To run a query within a React component, call `useFetchCdqResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCdqResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCdqResultsQuery({
 *   variables: {
 *      cdqId: // value for 'cdqId'
 *   },
 * });
 */
export function useFetchCdqResultsQuery(baseOptions: Apollo.QueryHookOptions<FetchCdqResultsQueryGQLType, FetchCdqResultsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCdqResultsQueryGQLType, FetchCdqResultsQueryVariablesGQLType>(FetchCdqResultsDocumentGQLType, options);
      }
export function useFetchCdqResultsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<FetchCdqResultsQueryGQLType, FetchCdqResultsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCdqResultsQueryGQLType, FetchCdqResultsQueryVariablesGQLType>(FetchCdqResultsDocumentGQLType, options);
        }
export type FetchCdqResultsQueryHookResult = ReturnType<typeof useFetchCdqResultsQuery>;
export type FetchCdqResultsLazyQueryGQLTypeHookResult = ReturnType<typeof useFetchCdqResultsLazyQueryGQLType>;
export type FetchCdqResultsQueryResultGQLType = Apollo.QueryResult<FetchCdqResultsQueryGQLType, FetchCdqResultsQueryVariablesGQLType>;
export const FetchUnacknowledgedCdqResultsDocumentGQLType = gql`
    query fetchUnacknowledgedCdqResults($cdqId: UUID!) {
  unacknowledgedCdqResults: getUnAcknowledgedItems(cdqId: $cdqId) {
    Items {
      finleyReceivableId
      currentReportingDate
      previousReportingDate
      otherFields
    }
    NextToken
    QueryExecutionId
    totalUnAcknowledgedIssueCount
    totalAcknowledgedIssueCount
  }
}
    `;

/**
 * __useFetchUnacknowledgedCdqResultsQuery__
 *
 * To run a query within a React component, call `useFetchUnacknowledgedCdqResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUnacknowledgedCdqResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUnacknowledgedCdqResultsQuery({
 *   variables: {
 *      cdqId: // value for 'cdqId'
 *   },
 * });
 */
export function useFetchUnacknowledgedCdqResultsQuery(baseOptions: Apollo.QueryHookOptions<FetchUnacknowledgedCdqResultsQueryGQLType, FetchUnacknowledgedCdqResultsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUnacknowledgedCdqResultsQueryGQLType, FetchUnacknowledgedCdqResultsQueryVariablesGQLType>(FetchUnacknowledgedCdqResultsDocumentGQLType, options);
      }
export function useFetchUnacknowledgedCdqResultsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<FetchUnacknowledgedCdqResultsQueryGQLType, FetchUnacknowledgedCdqResultsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUnacknowledgedCdqResultsQueryGQLType, FetchUnacknowledgedCdqResultsQueryVariablesGQLType>(FetchUnacknowledgedCdqResultsDocumentGQLType, options);
        }
export type FetchUnacknowledgedCdqResultsQueryHookResult = ReturnType<typeof useFetchUnacknowledgedCdqResultsQuery>;
export type FetchUnacknowledgedCdqResultsLazyQueryGQLTypeHookResult = ReturnType<typeof useFetchUnacknowledgedCdqResultsLazyQueryGQLType>;
export type FetchUnacknowledgedCdqResultsQueryResultGQLType = Apollo.QueryResult<FetchUnacknowledgedCdqResultsQueryGQLType, FetchUnacknowledgedCdqResultsQueryVariablesGQLType>;
export const AcknowledgeForAllDatesDocumentGQLType = gql`
    mutation acknowledgeForAllDates($cdqId: UUID!, $receivableIds: [UUID!]!) {
  acknowledgeForAllDates(cdqId: $cdqId, receivableIds: $receivableIds)
}
    `;
export type AcknowledgeForAllDatesMutationFnGQLType = Apollo.MutationFunction<AcknowledgeForAllDatesMutationGQLType, AcknowledgeForAllDatesMutationVariablesGQLType>;

/**
 * __useAcknowledgeForAllDatesMutation__
 *
 * To run a mutation, you first call `useAcknowledgeForAllDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeForAllDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeForAllDatesMutation, { data, loading, error }] = useAcknowledgeForAllDatesMutation({
 *   variables: {
 *      cdqId: // value for 'cdqId'
 *      receivableIds: // value for 'receivableIds'
 *   },
 * });
 */
export function useAcknowledgeForAllDatesMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeForAllDatesMutationGQLType, AcknowledgeForAllDatesMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeForAllDatesMutationGQLType, AcknowledgeForAllDatesMutationVariablesGQLType>(AcknowledgeForAllDatesDocumentGQLType, options);
      }
export type AcknowledgeForAllDatesMutationHookResult = ReturnType<typeof useAcknowledgeForAllDatesMutation>;
export type AcknowledgeForAllDatesMutationResultGQLType = Apollo.MutationResult<AcknowledgeForAllDatesMutationGQLType>;
export type AcknowledgeForAllDatesMutationOptionsGQLType = Apollo.BaseMutationOptions<AcknowledgeForAllDatesMutationGQLType, AcknowledgeForAllDatesMutationVariablesGQLType>;
export const AcknowledgeForSpecificDatesDocumentGQLType = gql`
    mutation acknowledgeForSpecificDates($cdqId: UUID!, $acknowledgements: [SpecificDateAcknowledgement!]!) {
  acknowledgeForSpecificDates(cdqId: $cdqId, acknowledgements: $acknowledgements)
}
    `;
export type AcknowledgeForSpecificDatesMutationFnGQLType = Apollo.MutationFunction<AcknowledgeForSpecificDatesMutationGQLType, AcknowledgeForSpecificDatesMutationVariablesGQLType>;

/**
 * __useAcknowledgeForSpecificDatesMutation__
 *
 * To run a mutation, you first call `useAcknowledgeForSpecificDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeForSpecificDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeForSpecificDatesMutation, { data, loading, error }] = useAcknowledgeForSpecificDatesMutation({
 *   variables: {
 *      cdqId: // value for 'cdqId'
 *      acknowledgements: // value for 'acknowledgements'
 *   },
 * });
 */
export function useAcknowledgeForSpecificDatesMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeForSpecificDatesMutationGQLType, AcknowledgeForSpecificDatesMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeForSpecificDatesMutationGQLType, AcknowledgeForSpecificDatesMutationVariablesGQLType>(AcknowledgeForSpecificDatesDocumentGQLType, options);
      }
export type AcknowledgeForSpecificDatesMutationHookResult = ReturnType<typeof useAcknowledgeForSpecificDatesMutation>;
export type AcknowledgeForSpecificDatesMutationResultGQLType = Apollo.MutationResult<AcknowledgeForSpecificDatesMutationGQLType>;
export type AcknowledgeForSpecificDatesMutationOptionsGQLType = Apollo.BaseMutationOptions<AcknowledgeForSpecificDatesMutationGQLType, AcknowledgeForSpecificDatesMutationVariablesGQLType>;
export const UnAcknowledgeDocumentGQLType = gql`
    mutation unAcknowledge($cdqId: UUID!, $receivableIds: [UUID!]!) {
  unAcknowledge(cdqId: $cdqId, receivableIds: $receivableIds)
}
    `;
export type UnAcknowledgeMutationFnGQLType = Apollo.MutationFunction<UnAcknowledgeMutationGQLType, UnAcknowledgeMutationVariablesGQLType>;

/**
 * __useUnAcknowledgeMutation__
 *
 * To run a mutation, you first call `useUnAcknowledgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnAcknowledgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unAcknowledgeMutation, { data, loading, error }] = useUnAcknowledgeMutation({
 *   variables: {
 *      cdqId: // value for 'cdqId'
 *      receivableIds: // value for 'receivableIds'
 *   },
 * });
 */
export function useUnAcknowledgeMutation(baseOptions?: Apollo.MutationHookOptions<UnAcknowledgeMutationGQLType, UnAcknowledgeMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnAcknowledgeMutationGQLType, UnAcknowledgeMutationVariablesGQLType>(UnAcknowledgeDocumentGQLType, options);
      }
export type UnAcknowledgeMutationHookResult = ReturnType<typeof useUnAcknowledgeMutation>;
export type UnAcknowledgeMutationResultGQLType = Apollo.MutationResult<UnAcknowledgeMutationGQLType>;
export type UnAcknowledgeMutationOptionsGQLType = Apollo.BaseMutationOptions<UnAcknowledgeMutationGQLType, UnAcknowledgeMutationVariablesGQLType>;
export const GetBalanceSheetExposureDataDocumentGQLType = gql`
    query GetBalanceSheetExposureData($organizationId: UUID!) {
  balanceSheetImpactCalculations(organizationId: $organizationId) {
    totalBalanceSheetExposure
    loanProductCalculations {
      loanProductId
      loanProductName
      balanceSheetExposure
      eligibleExposureForCreditFacilities {
        creditFacility {
          id
          name
        }
        eligibleExposure
      }
    }
  }
}
    `;

/**
 * __useGetBalanceSheetExposureDataQuery__
 *
 * To run a query within a React component, call `useGetBalanceSheetExposureDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalanceSheetExposureDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalanceSheetExposureDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetBalanceSheetExposureDataQuery(baseOptions: Apollo.QueryHookOptions<GetBalanceSheetExposureDataQueryGQLType, GetBalanceSheetExposureDataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalanceSheetExposureDataQueryGQLType, GetBalanceSheetExposureDataQueryVariablesGQLType>(GetBalanceSheetExposureDataDocumentGQLType, options);
      }
export function useGetBalanceSheetExposureDataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBalanceSheetExposureDataQueryGQLType, GetBalanceSheetExposureDataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalanceSheetExposureDataQueryGQLType, GetBalanceSheetExposureDataQueryVariablesGQLType>(GetBalanceSheetExposureDataDocumentGQLType, options);
        }
export type GetBalanceSheetExposureDataQueryHookResult = ReturnType<typeof useGetBalanceSheetExposureDataQuery>;
export type GetBalanceSheetExposureDataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBalanceSheetExposureDataLazyQueryGQLType>;
export type GetBalanceSheetExposureDataQueryResultGQLType = Apollo.QueryResult<GetBalanceSheetExposureDataQueryGQLType, GetBalanceSheetExposureDataQueryVariablesGQLType>;
export const GetFacilitiesTableDataDocumentGQLType = gql`
    query GetFacilitiesTableData($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]!, $creditFacilityIds: [UUID!]!, $startDate: JSDate, $endDate: JSDate, $startDateStr: FullDateStr, $endDateStr: FullDateStr, $getAttributeValuesParams: GetAttributeValuesByParamsInput!) {
  organization(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  ) {
    currentCreditAgreementArtifacts {
      id
      creditAgreement
    }
  }
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    endDate: $endDate
    statuses: [approved]
  ) {
    nodes {
      id
      creditFacilityId
      created_at
    }
  }
  expensesFeesLedgerForAllCountersigners: ledgerBalanceForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    ledgerAccountGroup: expensesFees
  ) {
    creditFacilityId
    ledgerBalance
  }
  outstandingLedgerForAllCountersigners: ledgerBalanceForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    ledgerAccountGroup: outstandingLedger
  ) {
    creditFacilityId
    ledgerBalance
  }
  outstandingLedgerForCapitalProvider: ledgerBalanceForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    countersignerOrganizationIds: [$organizationId]
    ledgerAccountGroup: outstandingLedger
  ) {
    creditFacilityId
    ledgerBalance
  }
  getSuccessPortfolioCovenantsByCreditFacilityIds(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDateStr
    endDate: $endDateStr
    mode: RESULT
  ) {
    ...SuccessPortfolioCovenant
  }
  getSuccessFinancialCovenantsByCreditFacilityIds(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDateStr
    endDate: $endDateStr
    mode: RESULT
  ) {
    ...SuccessFinancialCovenant
  }
  latestBorrowingBaseReports(creditFacilityIds: $creditFacilityIds) {
    creditFacilityId
    maxReceivableAdvanceAmount
    commitmentAmount
    totalCollectionsAccountCash
    totalCashBorrowingBaseAmount
    totalFacilityUtilization
    currentPrincipalBalance
    borrowingBaseReserveAmount
  }
  getAttributeValuesByParams(getAttributeValuesParams: $getAttributeValuesParams) {
    ...AttributeValueFragment
  }
}
    ${SuccessPortfolioCovenantFragmentDocGQLType}
${SuccessFinancialCovenantFragmentDocGQLType}
${AttributeValueFragmentFragmentDocGQLType}`;

/**
 * __useGetFacilitiesTableDataQuery__
 *
 * To run a query within a React component, call `useGetFacilitiesTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilitiesTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilitiesTableDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      startDateStr: // value for 'startDateStr'
 *      endDateStr: // value for 'endDateStr'
 *      getAttributeValuesParams: // value for 'getAttributeValuesParams'
 *   },
 * });
 */
export function useGetFacilitiesTableDataQuery(baseOptions: Apollo.QueryHookOptions<GetFacilitiesTableDataQueryGQLType, GetFacilitiesTableDataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilitiesTableDataQueryGQLType, GetFacilitiesTableDataQueryVariablesGQLType>(GetFacilitiesTableDataDocumentGQLType, options);
      }
export function useGetFacilitiesTableDataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilitiesTableDataQueryGQLType, GetFacilitiesTableDataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilitiesTableDataQueryGQLType, GetFacilitiesTableDataQueryVariablesGQLType>(GetFacilitiesTableDataDocumentGQLType, options);
        }
export type GetFacilitiesTableDataQueryHookResult = ReturnType<typeof useGetFacilitiesTableDataQuery>;
export type GetFacilitiesTableDataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFacilitiesTableDataLazyQueryGQLType>;
export type GetFacilitiesTableDataQueryResultGQLType = Apollo.QueryResult<GetFacilitiesTableDataQueryGQLType, GetFacilitiesTableDataQueryVariablesGQLType>;
export const GetFacilitiesTableLimitedDataDocumentGQLType = gql`
    query GetFacilitiesTableLimitedData($capitalProviderOrganizationId: UUID!, $creditFacilityIds: [UUID!]!, $startDate: JSDate, $endDate: JSDate) {
  slsCreditAgreementsPropertiesForCapitalProvider(
    capitalProviderOrganizationId: $capitalProviderOrganizationId
  ) {
    creditFacilityId
    externalFacilityId
    maturityDate
    closingDate
    revolvingPeriodEndDate
    globalCommitmentAmount
    capitalProviderCommitmentAmount
    interestRatesDisplay
    unusedFeesDisplay
    upfrontFeesDisplay
  }
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    endDate: $endDate
    statuses: [approved]
  ) {
    nodes {
      id
      creditFacilityId
      created_at
    }
  }
  expensesFeesLedgerForAllCountersigners: ledgerBalanceForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    ledgerAccountGroup: expensesFees
  ) {
    creditFacilityId
    ledgerBalance
  }
  outstandingLedgerForAllCountersigners: ledgerBalanceForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    ledgerAccountGroup: outstandingLedger
  ) {
    creditFacilityId
    ledgerBalance
  }
  outstandingLedgerForCapitalProvider: ledgerBalanceForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    countersignerOrganizationIds: [$capitalProviderOrganizationId]
    ledgerAccountGroup: outstandingLedger
  ) {
    creditFacilityId
    ledgerBalance
  }
}
    `;

/**
 * __useGetFacilitiesTableLimitedDataQuery__
 *
 * To run a query within a React component, call `useGetFacilitiesTableLimitedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilitiesTableLimitedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilitiesTableLimitedDataQuery({
 *   variables: {
 *      capitalProviderOrganizationId: // value for 'capitalProviderOrganizationId'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetFacilitiesTableLimitedDataQuery(baseOptions: Apollo.QueryHookOptions<GetFacilitiesTableLimitedDataQueryGQLType, GetFacilitiesTableLimitedDataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilitiesTableLimitedDataQueryGQLType, GetFacilitiesTableLimitedDataQueryVariablesGQLType>(GetFacilitiesTableLimitedDataDocumentGQLType, options);
      }
export function useGetFacilitiesTableLimitedDataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilitiesTableLimitedDataQueryGQLType, GetFacilitiesTableLimitedDataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilitiesTableLimitedDataQueryGQLType, GetFacilitiesTableLimitedDataQueryVariablesGQLType>(GetFacilitiesTableLimitedDataDocumentGQLType, options);
        }
export type GetFacilitiesTableLimitedDataQueryHookResult = ReturnType<typeof useGetFacilitiesTableLimitedDataQuery>;
export type GetFacilitiesTableLimitedDataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFacilitiesTableLimitedDataLazyQueryGQLType>;
export type GetFacilitiesTableLimitedDataQueryResultGQLType = Apollo.QueryResult<GetFacilitiesTableLimitedDataQueryGQLType, GetFacilitiesTableLimitedDataQueryVariablesGQLType>;
export const CreateDeliverableContainerReceiptActionDocumentGQLType = gql`
    mutation CreateDeliverableContainerReceiptAction($userId: UUID!, $organizationId: UUID!, $receiptId: UUID!, $action: ReceiptActionTypePostCreation!, $commentId: UUID) {
  deliverableContainerReceiptAction(
    userId: $userId
    organizationId: $organizationId
    receiptId: $receiptId
    action: $action
    commentId: $commentId
  )
}
    `;
export type CreateDeliverableContainerReceiptActionMutationFnGQLType = Apollo.MutationFunction<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>;

/**
 * __useCreateDeliverableContainerReceiptActionMutation__
 *
 * To run a mutation, you first call `useCreateDeliverableContainerReceiptActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliverableContainerReceiptActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliverableContainerReceiptActionMutation, { data, loading, error }] = useCreateDeliverableContainerReceiptActionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *      receiptId: // value for 'receiptId'
 *      action: // value for 'action'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useCreateDeliverableContainerReceiptActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>(CreateDeliverableContainerReceiptActionDocumentGQLType, options);
      }
export type CreateDeliverableContainerReceiptActionMutationHookResult = ReturnType<typeof useCreateDeliverableContainerReceiptActionMutation>;
export type CreateDeliverableContainerReceiptActionMutationResultGQLType = Apollo.MutationResult<CreateDeliverableContainerReceiptActionMutationGQLType>;
export type CreateDeliverableContainerReceiptActionMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateDeliverableContainerReceiptActionMutationGQLType, CreateDeliverableContainerReceiptActionMutationVariablesGQLType>;
export const CompleteFinalOutputDeliverableArtifactInstanceDocumentGQLType = gql`
    mutation CompleteFinalOutputDeliverableArtifactInstance($artifactInstanceId: UUID!) {
  completeFinalOutputDeliverableArtifactInstance(
    artifactInstanceId: $artifactInstanceId
  ) {
    instance {
      id
      deliverableArtifactId
      version
      active
      status
    }
    errors
  }
}
    `;
export type CompleteFinalOutputDeliverableArtifactInstanceMutationFnGQLType = Apollo.MutationFunction<CompleteFinalOutputDeliverableArtifactInstanceMutationGQLType, CompleteFinalOutputDeliverableArtifactInstanceMutationVariablesGQLType>;

/**
 * __useCompleteFinalOutputDeliverableArtifactInstanceMutation__
 *
 * To run a mutation, you first call `useCompleteFinalOutputDeliverableArtifactInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteFinalOutputDeliverableArtifactInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeFinalOutputDeliverableArtifactInstanceMutation, { data, loading, error }] = useCompleteFinalOutputDeliverableArtifactInstanceMutation({
 *   variables: {
 *      artifactInstanceId: // value for 'artifactInstanceId'
 *   },
 * });
 */
export function useCompleteFinalOutputDeliverableArtifactInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CompleteFinalOutputDeliverableArtifactInstanceMutationGQLType, CompleteFinalOutputDeliverableArtifactInstanceMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteFinalOutputDeliverableArtifactInstanceMutationGQLType, CompleteFinalOutputDeliverableArtifactInstanceMutationVariablesGQLType>(CompleteFinalOutputDeliverableArtifactInstanceDocumentGQLType, options);
      }
export type CompleteFinalOutputDeliverableArtifactInstanceMutationHookResult = ReturnType<typeof useCompleteFinalOutputDeliverableArtifactInstanceMutation>;
export type CompleteFinalOutputDeliverableArtifactInstanceMutationResultGQLType = Apollo.MutationResult<CompleteFinalOutputDeliverableArtifactInstanceMutationGQLType>;
export type CompleteFinalOutputDeliverableArtifactInstanceMutationOptionsGQLType = Apollo.BaseMutationOptions<CompleteFinalOutputDeliverableArtifactInstanceMutationGQLType, CompleteFinalOutputDeliverableArtifactInstanceMutationVariablesGQLType>;
export const CreateDeliverableArtifactInstanceDocumentGQLType = gql`
    mutation CreateDeliverableArtifactInstance($deliverableArtifactId: UUID!, $active: Boolean, $status: ArtifactInstanceStatus!, $rawDatabase: DeliverableDatabase, $rawNamespace: DeliverableRawNamespace, $rawIdentifier: String, $completedDatabase: DeliverableDatabase, $completedNamespace: DeliverableExternalNamespace, $completedIdentifier: String) {
  createDeliverableArtifactInstance(
    deliverableArtifactId: $deliverableArtifactId
    active: $active
    status: $status
    rawDatabase: $rawDatabase
    rawNamespace: $rawNamespace
    rawIdentifier: $rawIdentifier
    completedDatabase: $completedDatabase
    completedNamespace: $completedNamespace
    completedIdentifier: $completedIdentifier
  ) {
    id
    deliverableArtifactId
    version
    active
    status
  }
}
    `;
export type CreateDeliverableArtifactInstanceMutationFnGQLType = Apollo.MutationFunction<CreateDeliverableArtifactInstanceMutationGQLType, CreateDeliverableArtifactInstanceMutationVariablesGQLType>;

/**
 * __useCreateDeliverableArtifactInstanceMutation__
 *
 * To run a mutation, you first call `useCreateDeliverableArtifactInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliverableArtifactInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliverableArtifactInstanceMutation, { data, loading, error }] = useCreateDeliverableArtifactInstanceMutation({
 *   variables: {
 *      deliverableArtifactId: // value for 'deliverableArtifactId'
 *      active: // value for 'active'
 *      status: // value for 'status'
 *      rawDatabase: // value for 'rawDatabase'
 *      rawNamespace: // value for 'rawNamespace'
 *      rawIdentifier: // value for 'rawIdentifier'
 *      completedDatabase: // value for 'completedDatabase'
 *      completedNamespace: // value for 'completedNamespace'
 *      completedIdentifier: // value for 'completedIdentifier'
 *   },
 * });
 */
export function useCreateDeliverableArtifactInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliverableArtifactInstanceMutationGQLType, CreateDeliverableArtifactInstanceMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliverableArtifactInstanceMutationGQLType, CreateDeliverableArtifactInstanceMutationVariablesGQLType>(CreateDeliverableArtifactInstanceDocumentGQLType, options);
      }
export type CreateDeliverableArtifactInstanceMutationHookResult = ReturnType<typeof useCreateDeliverableArtifactInstanceMutation>;
export type CreateDeliverableArtifactInstanceMutationResultGQLType = Apollo.MutationResult<CreateDeliverableArtifactInstanceMutationGQLType>;
export type CreateDeliverableArtifactInstanceMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateDeliverableArtifactInstanceMutationGQLType, CreateDeliverableArtifactInstanceMutationVariablesGQLType>;
export const CreateDeliverableContainerReceiptDocumentGQLType = gql`
    mutation CreateDeliverableContainerReceipt($containerId: UUID!, $receipt: ReceiptColumnInput!, $userId: UUID!, $organizationId: UUID!, $creditFacilityId: UUID!) {
  deliverableContainerReceipt(
    containerId: $containerId
    receipt: $receipt
    userId: $userId
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
  )
}
    `;
export type CreateDeliverableContainerReceiptMutationFnGQLType = Apollo.MutationFunction<CreateDeliverableContainerReceiptMutationGQLType, CreateDeliverableContainerReceiptMutationVariablesGQLType>;

/**
 * __useCreateDeliverableContainerReceiptMutation__
 *
 * To run a mutation, you first call `useCreateDeliverableContainerReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliverableContainerReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliverableContainerReceiptMutation, { data, loading, error }] = useCreateDeliverableContainerReceiptMutation({
 *   variables: {
 *      containerId: // value for 'containerId'
 *      receipt: // value for 'receipt'
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCreateDeliverableContainerReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliverableContainerReceiptMutationGQLType, CreateDeliverableContainerReceiptMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliverableContainerReceiptMutationGQLType, CreateDeliverableContainerReceiptMutationVariablesGQLType>(CreateDeliverableContainerReceiptDocumentGQLType, options);
      }
export type CreateDeliverableContainerReceiptMutationHookResult = ReturnType<typeof useCreateDeliverableContainerReceiptMutation>;
export type CreateDeliverableContainerReceiptMutationResultGQLType = Apollo.MutationResult<CreateDeliverableContainerReceiptMutationGQLType>;
export type CreateDeliverableContainerReceiptMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateDeliverableContainerReceiptMutationGQLType, CreateDeliverableContainerReceiptMutationVariablesGQLType>;
export const GenerateReceiptForDeliverableContainerDocumentGQLType = gql`
    mutation GenerateReceiptForDeliverableContainer($containerId: UUID!, $fixedInputDependencies: [UUID!]!, $userId: UUID!) {
  generateReceiptForDeliverableContainer(
    containerId: $containerId
    fixedInputDependencies: $fixedInputDependencies
    userId: $userId
  )
}
    `;
export type GenerateReceiptForDeliverableContainerMutationFnGQLType = Apollo.MutationFunction<GenerateReceiptForDeliverableContainerMutationGQLType, GenerateReceiptForDeliverableContainerMutationVariablesGQLType>;

/**
 * __useGenerateReceiptForDeliverableContainerMutation__
 *
 * To run a mutation, you first call `useGenerateReceiptForDeliverableContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReceiptForDeliverableContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReceiptForDeliverableContainerMutation, { data, loading, error }] = useGenerateReceiptForDeliverableContainerMutation({
 *   variables: {
 *      containerId: // value for 'containerId'
 *      fixedInputDependencies: // value for 'fixedInputDependencies'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateReceiptForDeliverableContainerMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReceiptForDeliverableContainerMutationGQLType, GenerateReceiptForDeliverableContainerMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReceiptForDeliverableContainerMutationGQLType, GenerateReceiptForDeliverableContainerMutationVariablesGQLType>(GenerateReceiptForDeliverableContainerDocumentGQLType, options);
      }
export type GenerateReceiptForDeliverableContainerMutationHookResult = ReturnType<typeof useGenerateReceiptForDeliverableContainerMutation>;
export type GenerateReceiptForDeliverableContainerMutationResultGQLType = Apollo.MutationResult<GenerateReceiptForDeliverableContainerMutationGQLType>;
export type GenerateReceiptForDeliverableContainerMutationOptionsGQLType = Apollo.BaseMutationOptions<GenerateReceiptForDeliverableContainerMutationGQLType, GenerateReceiptForDeliverableContainerMutationVariablesGQLType>;
export const NotifyNewCommentForDeliverableContainerDocumentGQLType = gql`
    mutation NotifyNewCommentForDeliverableContainer($commentId: UUID!, $containerId: UUID!, $receiptId: UUID) {
  notifyNewCommentForDeliverableContainer(
    commentId: $commentId
    containerId: $containerId
    receiptId: $receiptId
  )
}
    `;
export type NotifyNewCommentForDeliverableContainerMutationFnGQLType = Apollo.MutationFunction<NotifyNewCommentForDeliverableContainerMutationGQLType, NotifyNewCommentForDeliverableContainerMutationVariablesGQLType>;

/**
 * __useNotifyNewCommentForDeliverableContainerMutation__
 *
 * To run a mutation, you first call `useNotifyNewCommentForDeliverableContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyNewCommentForDeliverableContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyNewCommentForDeliverableContainerMutation, { data, loading, error }] = useNotifyNewCommentForDeliverableContainerMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      containerId: // value for 'containerId'
 *      receiptId: // value for 'receiptId'
 *   },
 * });
 */
export function useNotifyNewCommentForDeliverableContainerMutation(baseOptions?: Apollo.MutationHookOptions<NotifyNewCommentForDeliverableContainerMutationGQLType, NotifyNewCommentForDeliverableContainerMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyNewCommentForDeliverableContainerMutationGQLType, NotifyNewCommentForDeliverableContainerMutationVariablesGQLType>(NotifyNewCommentForDeliverableContainerDocumentGQLType, options);
      }
export type NotifyNewCommentForDeliverableContainerMutationHookResult = ReturnType<typeof useNotifyNewCommentForDeliverableContainerMutation>;
export type NotifyNewCommentForDeliverableContainerMutationResultGQLType = Apollo.MutationResult<NotifyNewCommentForDeliverableContainerMutationGQLType>;
export type NotifyNewCommentForDeliverableContainerMutationOptionsGQLType = Apollo.BaseMutationOptions<NotifyNewCommentForDeliverableContainerMutationGQLType, NotifyNewCommentForDeliverableContainerMutationVariablesGQLType>;
export const RefreshDeliverableDocumentGQLType = gql`
    mutation RefreshDeliverable($deliverableContainerId: UUID!) {
  refreshDeliverable(deliverableContainerId: $deliverableContainerId) {
    status
  }
}
    `;
export type RefreshDeliverableMutationFnGQLType = Apollo.MutationFunction<RefreshDeliverableMutationGQLType, RefreshDeliverableMutationVariablesGQLType>;

/**
 * __useRefreshDeliverableMutation__
 *
 * To run a mutation, you first call `useRefreshDeliverableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDeliverableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDeliverableMutation, { data, loading, error }] = useRefreshDeliverableMutation({
 *   variables: {
 *      deliverableContainerId: // value for 'deliverableContainerId'
 *   },
 * });
 */
export function useRefreshDeliverableMutation(baseOptions?: Apollo.MutationHookOptions<RefreshDeliverableMutationGQLType, RefreshDeliverableMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshDeliverableMutationGQLType, RefreshDeliverableMutationVariablesGQLType>(RefreshDeliverableDocumentGQLType, options);
      }
export type RefreshDeliverableMutationHookResult = ReturnType<typeof useRefreshDeliverableMutation>;
export type RefreshDeliverableMutationResultGQLType = Apollo.MutationResult<RefreshDeliverableMutationGQLType>;
export type RefreshDeliverableMutationOptionsGQLType = Apollo.BaseMutationOptions<RefreshDeliverableMutationGQLType, RefreshDeliverableMutationVariablesGQLType>;
export const SubmitMonthlyStatementDeliverableDocumentGQLType = gql`
    mutation SubmitMonthlyStatementDeliverable($deliverableArtifactId: UUID!, $deliverableArtifactInstanceId: UUID, $creditFacilityId: UUID!, $reportingPeriodStartDate: FullDateStr!, $reportingPeriodEndDate: FullDateStr!, $asOfTimestamp: JSDate!) {
  submitMonthlyStatementDeliverable(
    deliverableArtifactId: $deliverableArtifactId
    deliverableArtifactInstanceId: $deliverableArtifactInstanceId
    creditFacilityId: $creditFacilityId
    reportingPeriodStartDate: $reportingPeriodStartDate
    reportingPeriodEndDate: $reportingPeriodEndDate
    asOfTimestamp: $asOfTimestamp
  ) {
    id
    deliverableArtifactId
    version
    active
    status
  }
}
    `;
export type SubmitMonthlyStatementDeliverableMutationFnGQLType = Apollo.MutationFunction<SubmitMonthlyStatementDeliverableMutationGQLType, SubmitMonthlyStatementDeliverableMutationVariablesGQLType>;

/**
 * __useSubmitMonthlyStatementDeliverableMutation__
 *
 * To run a mutation, you first call `useSubmitMonthlyStatementDeliverableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMonthlyStatementDeliverableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMonthlyStatementDeliverableMutation, { data, loading, error }] = useSubmitMonthlyStatementDeliverableMutation({
 *   variables: {
 *      deliverableArtifactId: // value for 'deliverableArtifactId'
 *      deliverableArtifactInstanceId: // value for 'deliverableArtifactInstanceId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingPeriodStartDate: // value for 'reportingPeriodStartDate'
 *      reportingPeriodEndDate: // value for 'reportingPeriodEndDate'
 *      asOfTimestamp: // value for 'asOfTimestamp'
 *   },
 * });
 */
export function useSubmitMonthlyStatementDeliverableMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMonthlyStatementDeliverableMutationGQLType, SubmitMonthlyStatementDeliverableMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMonthlyStatementDeliverableMutationGQLType, SubmitMonthlyStatementDeliverableMutationVariablesGQLType>(SubmitMonthlyStatementDeliverableDocumentGQLType, options);
      }
export type SubmitMonthlyStatementDeliverableMutationHookResult = ReturnType<typeof useSubmitMonthlyStatementDeliverableMutation>;
export type SubmitMonthlyStatementDeliverableMutationResultGQLType = Apollo.MutationResult<SubmitMonthlyStatementDeliverableMutationGQLType>;
export type SubmitMonthlyStatementDeliverableMutationOptionsGQLType = Apollo.BaseMutationOptions<SubmitMonthlyStatementDeliverableMutationGQLType, SubmitMonthlyStatementDeliverableMutationVariablesGQLType>;
export const UpdateFailedDeliverableArtifactInstanceDocumentGQLType = gql`
    mutation UpdateFailedDeliverableArtifactInstance($instanceId: UUID!) {
  failedDeliverableArtifactInstance(instanceId: $instanceId) {
    id
    deliverableArtifactId
    version
    active
    status
  }
}
    `;
export type UpdateFailedDeliverableArtifactInstanceMutationFnGQLType = Apollo.MutationFunction<UpdateFailedDeliverableArtifactInstanceMutationGQLType, UpdateFailedDeliverableArtifactInstanceMutationVariablesGQLType>;

/**
 * __useUpdateFailedDeliverableArtifactInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateFailedDeliverableArtifactInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFailedDeliverableArtifactInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFailedDeliverableArtifactInstanceMutation, { data, loading, error }] = useUpdateFailedDeliverableArtifactInstanceMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUpdateFailedDeliverableArtifactInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFailedDeliverableArtifactInstanceMutationGQLType, UpdateFailedDeliverableArtifactInstanceMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFailedDeliverableArtifactInstanceMutationGQLType, UpdateFailedDeliverableArtifactInstanceMutationVariablesGQLType>(UpdateFailedDeliverableArtifactInstanceDocumentGQLType, options);
      }
export type UpdateFailedDeliverableArtifactInstanceMutationHookResult = ReturnType<typeof useUpdateFailedDeliverableArtifactInstanceMutation>;
export type UpdateFailedDeliverableArtifactInstanceMutationResultGQLType = Apollo.MutationResult<UpdateFailedDeliverableArtifactInstanceMutationGQLType>;
export type UpdateFailedDeliverableArtifactInstanceMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateFailedDeliverableArtifactInstanceMutationGQLType, UpdateFailedDeliverableArtifactInstanceMutationVariablesGQLType>;
export const GetAreDeliverablesReceiptsZipFilesAvailableForDownloadDocumentGQLType = gql`
    query GetAreDeliverablesReceiptsZipFilesAvailableForDownload($receiptId: UUID!) {
  areDeliverablesReceiptsZipFilesAvailableForDownload(receiptId: $receiptId) {
    canDownloadInput
    canDownloadOutput
  }
}
    `;

/**
 * __useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadQuery__
 *
 * To run a query within a React component, call `useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadQuery({
 *   variables: {
 *      receiptId: // value for 'receiptId'
 *   },
 * });
 */
export function useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadQuery(baseOptions: Apollo.QueryHookOptions<GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryGQLType, GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryGQLType, GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryVariablesGQLType>(GetAreDeliverablesReceiptsZipFilesAvailableForDownloadDocumentGQLType, options);
      }
export function useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryGQLType, GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryGQLType, GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryVariablesGQLType>(GetAreDeliverablesReceiptsZipFilesAvailableForDownloadDocumentGQLType, options);
        }
export type GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryHookResult = ReturnType<typeof useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadQuery>;
export type GetAreDeliverablesReceiptsZipFilesAvailableForDownloadLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAreDeliverablesReceiptsZipFilesAvailableForDownloadLazyQueryGQLType>;
export type GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryResultGQLType = Apollo.QueryResult<GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryGQLType, GetAreDeliverablesReceiptsZipFilesAvailableForDownloadQueryVariablesGQLType>;
export const GetBorrowingBasePipelineArtifactInstancesErrorsDocumentGQLType = gql`
    query GetBorrowingBasePipelineArtifactInstancesErrors($rawArtifactInstanceIds: [UUID!]!) {
  borrowingBasePipelineDataValidationErrors(
    rawArtifactInstanceIds: $rawArtifactInstanceIds
  ) {
    artifactInstanceId
    progressBreakdown {
      status {
        status
        errors
      }
    }
  }
}
    `;

/**
 * __useGetBorrowingBasePipelineArtifactInstancesErrorsQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBasePipelineArtifactInstancesErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBasePipelineArtifactInstancesErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBasePipelineArtifactInstancesErrorsQuery({
 *   variables: {
 *      rawArtifactInstanceIds: // value for 'rawArtifactInstanceIds'
 *   },
 * });
 */
export function useGetBorrowingBasePipelineArtifactInstancesErrorsQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowingBasePipelineArtifactInstancesErrorsQueryGQLType, GetBorrowingBasePipelineArtifactInstancesErrorsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBasePipelineArtifactInstancesErrorsQueryGQLType, GetBorrowingBasePipelineArtifactInstancesErrorsQueryVariablesGQLType>(GetBorrowingBasePipelineArtifactInstancesErrorsDocumentGQLType, options);
      }
export function useGetBorrowingBasePipelineArtifactInstancesErrorsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBasePipelineArtifactInstancesErrorsQueryGQLType, GetBorrowingBasePipelineArtifactInstancesErrorsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBasePipelineArtifactInstancesErrorsQueryGQLType, GetBorrowingBasePipelineArtifactInstancesErrorsQueryVariablesGQLType>(GetBorrowingBasePipelineArtifactInstancesErrorsDocumentGQLType, options);
        }
export type GetBorrowingBasePipelineArtifactInstancesErrorsQueryHookResult = ReturnType<typeof useGetBorrowingBasePipelineArtifactInstancesErrorsQuery>;
export type GetBorrowingBasePipelineArtifactInstancesErrorsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBasePipelineArtifactInstancesErrorsLazyQueryGQLType>;
export type GetBorrowingBasePipelineArtifactInstancesErrorsQueryResultGQLType = Apollo.QueryResult<GetBorrowingBasePipelineArtifactInstancesErrorsQueryGQLType, GetBorrowingBasePipelineArtifactInstancesErrorsQueryVariablesGQLType>;
export const GetDeliverableArtifactInstanceDocumentGQLType = gql`
    query GetDeliverableArtifactInstance($artifactInstanceId: UUID!) {
  deliverableArtifactInstance(artifactInstanceId: $artifactInstanceId) {
    id
    deliverableArtifactId
    version
    active
    status
    rawDatabase
    rawNamespace
    rawIdentifier
    completedObject {
      object
      filename
    }
  }
}
    `;

/**
 * __useGetDeliverableArtifactInstanceQuery__
 *
 * To run a query within a React component, call `useGetDeliverableArtifactInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableArtifactInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableArtifactInstanceQuery({
 *   variables: {
 *      artifactInstanceId: // value for 'artifactInstanceId'
 *   },
 * });
 */
export function useGetDeliverableArtifactInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableArtifactInstanceQueryGQLType, GetDeliverableArtifactInstanceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableArtifactInstanceQueryGQLType, GetDeliverableArtifactInstanceQueryVariablesGQLType>(GetDeliverableArtifactInstanceDocumentGQLType, options);
      }
export function useGetDeliverableArtifactInstanceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableArtifactInstanceQueryGQLType, GetDeliverableArtifactInstanceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableArtifactInstanceQueryGQLType, GetDeliverableArtifactInstanceQueryVariablesGQLType>(GetDeliverableArtifactInstanceDocumentGQLType, options);
        }
export type GetDeliverableArtifactInstanceQueryHookResult = ReturnType<typeof useGetDeliverableArtifactInstanceQuery>;
export type GetDeliverableArtifactInstanceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableArtifactInstanceLazyQueryGQLType>;
export type GetDeliverableArtifactInstanceQueryResultGQLType = Apollo.QueryResult<GetDeliverableArtifactInstanceQueryGQLType, GetDeliverableArtifactInstanceQueryVariablesGQLType>;
export const GetDeliverableArtifactInstanceDownloadDocumentGQLType = gql`
    query GetDeliverableArtifactInstanceDownload($artifactInstanceId: UUID!) {
  deliverableArtifactInstanceDownload(artifactInstanceId: $artifactInstanceId) {
    __typename
    ... on ArtifactInstanceDownloadUrl {
      signedUrl
      filename
    }
    ... on ArtifactInstanceDownloadObject {
      object
      filename
    }
  }
}
    `;

/**
 * __useGetDeliverableArtifactInstanceDownloadQuery__
 *
 * To run a query within a React component, call `useGetDeliverableArtifactInstanceDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableArtifactInstanceDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableArtifactInstanceDownloadQuery({
 *   variables: {
 *      artifactInstanceId: // value for 'artifactInstanceId'
 *   },
 * });
 */
export function useGetDeliverableArtifactInstanceDownloadQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableArtifactInstanceDownloadQueryGQLType, GetDeliverableArtifactInstanceDownloadQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableArtifactInstanceDownloadQueryGQLType, GetDeliverableArtifactInstanceDownloadQueryVariablesGQLType>(GetDeliverableArtifactInstanceDownloadDocumentGQLType, options);
      }
export function useGetDeliverableArtifactInstanceDownloadLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableArtifactInstanceDownloadQueryGQLType, GetDeliverableArtifactInstanceDownloadQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableArtifactInstanceDownloadQueryGQLType, GetDeliverableArtifactInstanceDownloadQueryVariablesGQLType>(GetDeliverableArtifactInstanceDownloadDocumentGQLType, options);
        }
export type GetDeliverableArtifactInstanceDownloadQueryHookResult = ReturnType<typeof useGetDeliverableArtifactInstanceDownloadQuery>;
export type GetDeliverableArtifactInstanceDownloadLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableArtifactInstanceDownloadLazyQueryGQLType>;
export type GetDeliverableArtifactInstanceDownloadQueryResultGQLType = Apollo.QueryResult<GetDeliverableArtifactInstanceDownloadQueryGQLType, GetDeliverableArtifactInstanceDownloadQueryVariablesGQLType>;
export const GetDeliverableArtifactsByContainerIdDocumentGQLType = gql`
    query GetDeliverableArtifactsByContainerId($containerId: UUID!) {
  getDeliverableArtifactsByContainerId(containerId: $containerId) {
    id
    containerId
    reportingDate
    reportingPeriod
    configKey
    inputType
    instances {
      id
      deliverableArtifactId
      version
      active
      status
      rawDatabase
      rawNamespace
      rawIdentifier
      completedObject {
        object
        filename
      }
    }
    config {
      __typename
      ... on CashBalancesFeedConfig {
        artifactType
      }
      ... on SupplementalTapeConfig {
        artifactType
        artifactSlug
      }
      ... on RepaymentTapeConfig {
        artifactType
        loanProductSlug
      }
      ... on LoanTapeConfig {
        artifactType
        loanProductSlug
      }
      ... on PortfolioCovenantConfig {
        artifactType
        covenantKey
      }
      ... on FinancialCovenantConfig {
        artifactType
        covenantKey
      }
      ... on OrgProvidedInputConfig {
        artifactType
        key
        bbplArtifactSlug
      }
      ... on MonthlyServicerReportConfig {
        artifactType
        reportName
      }
      ... on MonthlyStatementConfig {
        artifactType
        reportingPeriodStartDateFormula
        reportingPeriodEndDateFormula
      }
      ... on FinancialStatementConfig {
        artifactType
        artifactSlug
        financialDataArtifactSlug
      }
    }
  }
}
    `;

/**
 * __useGetDeliverableArtifactsByContainerIdQuery__
 *
 * To run a query within a React component, call `useGetDeliverableArtifactsByContainerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableArtifactsByContainerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableArtifactsByContainerIdQuery({
 *   variables: {
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useGetDeliverableArtifactsByContainerIdQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableArtifactsByContainerIdQueryGQLType, GetDeliverableArtifactsByContainerIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableArtifactsByContainerIdQueryGQLType, GetDeliverableArtifactsByContainerIdQueryVariablesGQLType>(GetDeliverableArtifactsByContainerIdDocumentGQLType, options);
      }
export function useGetDeliverableArtifactsByContainerIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableArtifactsByContainerIdQueryGQLType, GetDeliverableArtifactsByContainerIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableArtifactsByContainerIdQueryGQLType, GetDeliverableArtifactsByContainerIdQueryVariablesGQLType>(GetDeliverableArtifactsByContainerIdDocumentGQLType, options);
        }
export type GetDeliverableArtifactsByContainerIdQueryHookResult = ReturnType<typeof useGetDeliverableArtifactsByContainerIdQuery>;
export type GetDeliverableArtifactsByContainerIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableArtifactsByContainerIdLazyQueryGQLType>;
export type GetDeliverableArtifactsByContainerIdQueryResultGQLType = Apollo.QueryResult<GetDeliverableArtifactsByContainerIdQueryGQLType, GetDeliverableArtifactsByContainerIdQueryVariablesGQLType>;
export const GetDeliverableContainerByIdDocumentGQLType = gql`
    query GetDeliverableContainerById($containerId: UUID!) {
  deliverableContainer(containerId: $containerId) {
    id
    configKey
    configName
    creditAgreementId
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    dueDate
    type
    period
    daysOffset
    totalDependencies
    completedDependencies
    totalFinalArtifacts
    completedFinalArtifacts
    borrowerId
    borrowerSlug
    borrowerName
    capitalProviderEntities {
      id
      slug
      name
    }
    latestReceiptId
    mostRecentActionType
    approvedDate
    latestGenerateReceiptRecord {
      id
      deliverableContainerId
      successfulReceiptId
      userId
      status
    }
  }
}
    `;

/**
 * __useGetDeliverableContainerByIdQuery__
 *
 * To run a query within a React component, call `useGetDeliverableContainerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableContainerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableContainerByIdQuery({
 *   variables: {
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useGetDeliverableContainerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableContainerByIdQueryGQLType, GetDeliverableContainerByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableContainerByIdQueryGQLType, GetDeliverableContainerByIdQueryVariablesGQLType>(GetDeliverableContainerByIdDocumentGQLType, options);
      }
export function useGetDeliverableContainerByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableContainerByIdQueryGQLType, GetDeliverableContainerByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableContainerByIdQueryGQLType, GetDeliverableContainerByIdQueryVariablesGQLType>(GetDeliverableContainerByIdDocumentGQLType, options);
        }
export type GetDeliverableContainerByIdQueryHookResult = ReturnType<typeof useGetDeliverableContainerByIdQuery>;
export type GetDeliverableContainerByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableContainerByIdLazyQueryGQLType>;
export type GetDeliverableContainerByIdQueryResultGQLType = Apollo.QueryResult<GetDeliverableContainerByIdQueryGQLType, GetDeliverableContainerByIdQueryVariablesGQLType>;
export const GetDeliverableContainerReceiptsDocumentGQLType = gql`
    query GetDeliverableContainerReceipts($containerId: UUID!) {
  deliverableContainerReceipts(containerId: $containerId) {
    id
    created_at
    updated_at
    version
    expired
    deliverableContainerId
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    containerDueDate
    containerName
    containerType
    borrowerId
    borrowerSlug
    borrowerName
    capitalProviderEntities {
      id
      slug
      name
    }
    dependenciesInstances {
      receiptInstanceId
      artifactType
      artifactConfigKey
      artifactReportingDate
    }
    finalArtifactsInstances {
      receiptInstanceId
      artifactType
      artifactConfigKey
      artifactReportingDate
    }
    actionsLog {
      id
      created_at
      updated_at
      action
      receiptId
      userId
      organizationId
      userFirstName
      userLastName
      organizationName
    }
  }
}
    `;

/**
 * __useGetDeliverableContainerReceiptsQuery__
 *
 * To run a query within a React component, call `useGetDeliverableContainerReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableContainerReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableContainerReceiptsQuery({
 *   variables: {
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useGetDeliverableContainerReceiptsQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableContainerReceiptsQueryGQLType, GetDeliverableContainerReceiptsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableContainerReceiptsQueryGQLType, GetDeliverableContainerReceiptsQueryVariablesGQLType>(GetDeliverableContainerReceiptsDocumentGQLType, options);
      }
export function useGetDeliverableContainerReceiptsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableContainerReceiptsQueryGQLType, GetDeliverableContainerReceiptsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableContainerReceiptsQueryGQLType, GetDeliverableContainerReceiptsQueryVariablesGQLType>(GetDeliverableContainerReceiptsDocumentGQLType, options);
        }
export type GetDeliverableContainerReceiptsQueryHookResult = ReturnType<typeof useGetDeliverableContainerReceiptsQuery>;
export type GetDeliverableContainerReceiptsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableContainerReceiptsLazyQueryGQLType>;
export type GetDeliverableContainerReceiptsQueryResultGQLType = Apollo.QueryResult<GetDeliverableContainerReceiptsQueryGQLType, GetDeliverableContainerReceiptsQueryVariablesGQLType>;
export const GetDeliverablesContainerReceiptZipFilesDownloadUrlDocumentGQLType = gql`
    query GetDeliverablesContainerReceiptZipFilesDownloadUrl($receiptId: UUID!, $type: InputType!) {
  deliverablesContainerReceiptZipFilesDownloadUrl(
    receiptId: $receiptId
    type: $type
  )
}
    `;

/**
 * __useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery({
 *   variables: {
 *      receiptId: // value for 'receiptId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>(GetDeliverablesContainerReceiptZipFilesDownloadUrlDocumentGQLType, options);
      }
export function useGetDeliverablesContainerReceiptZipFilesDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>(GetDeliverablesContainerReceiptZipFilesDownloadUrlDocumentGQLType, options);
        }
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryHookResult = ReturnType<typeof useGetDeliverablesContainerReceiptZipFilesDownloadUrlQuery>;
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverablesContainerReceiptZipFilesDownloadUrlLazyQueryGQLType>;
export type GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryGQLType, GetDeliverablesContainerReceiptZipFilesDownloadUrlQueryVariablesGQLType>;
export const GetFinalOutputDeliverableArtifactInstanceDocumentGQLType = gql`
    query GetFinalOutputDeliverableArtifactInstance($artifactInstanceId: UUID!) {
  finalOutputDeliverableArtifactInstance(artifactInstanceId: $artifactInstanceId) {
    id
    deliverableArtifactId
    status
    rawRecordStatus
  }
}
    `;

/**
 * __useGetFinalOutputDeliverableArtifactInstanceQuery__
 *
 * To run a query within a React component, call `useGetFinalOutputDeliverableArtifactInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinalOutputDeliverableArtifactInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinalOutputDeliverableArtifactInstanceQuery({
 *   variables: {
 *      artifactInstanceId: // value for 'artifactInstanceId'
 *   },
 * });
 */
export function useGetFinalOutputDeliverableArtifactInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>(GetFinalOutputDeliverableArtifactInstanceDocumentGQLType, options);
      }
export function useGetFinalOutputDeliverableArtifactInstanceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>(GetFinalOutputDeliverableArtifactInstanceDocumentGQLType, options);
        }
export type GetFinalOutputDeliverableArtifactInstanceQueryHookResult = ReturnType<typeof useGetFinalOutputDeliverableArtifactInstanceQuery>;
export type GetFinalOutputDeliverableArtifactInstanceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinalOutputDeliverableArtifactInstanceLazyQueryGQLType>;
export type GetFinalOutputDeliverableArtifactInstanceQueryResultGQLType = Apollo.QueryResult<GetFinalOutputDeliverableArtifactInstanceQueryGQLType, GetFinalOutputDeliverableArtifactInstanceQueryVariablesGQLType>;
export const GetLastOutputDeliverableArtifactInstanceFromReceiptIdDocumentGQLType = gql`
    query GetLastOutputDeliverableArtifactInstanceFromReceiptId($receiptId: UUID!) {
  lastOutputDeliverableArtifactInstanceFromReceiptId(receiptId: $receiptId) {
    id
    creditAgreementId
    creditFacilityId
    reportName
    reportType
    reportingDate
    version
    isPreview
    database
    namespace
    identifier
    entityRecords {
      accessorEntityAttributes {
        domain
        database
        namespace
        identifier
        accessorName
        supplementalEntityKey
      }
    }
  }
}
    `;

/**
 * __useGetLastOutputDeliverableArtifactInstanceFromReceiptIdQuery__
 *
 * To run a query within a React component, call `useGetLastOutputDeliverableArtifactInstanceFromReceiptIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastOutputDeliverableArtifactInstanceFromReceiptIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastOutputDeliverableArtifactInstanceFromReceiptIdQuery({
 *   variables: {
 *      receiptId: // value for 'receiptId'
 *   },
 * });
 */
export function useGetLastOutputDeliverableArtifactInstanceFromReceiptIdQuery(baseOptions: Apollo.QueryHookOptions<GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryGQLType, GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryGQLType, GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryVariablesGQLType>(GetLastOutputDeliverableArtifactInstanceFromReceiptIdDocumentGQLType, options);
      }
export function useGetLastOutputDeliverableArtifactInstanceFromReceiptIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryGQLType, GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryGQLType, GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryVariablesGQLType>(GetLastOutputDeliverableArtifactInstanceFromReceiptIdDocumentGQLType, options);
        }
export type GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryHookResult = ReturnType<typeof useGetLastOutputDeliverableArtifactInstanceFromReceiptIdQuery>;
export type GetLastOutputDeliverableArtifactInstanceFromReceiptIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLastOutputDeliverableArtifactInstanceFromReceiptIdLazyQueryGQLType>;
export type GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryResultGQLType = Apollo.QueryResult<GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryGQLType, GetLastOutputDeliverableArtifactInstanceFromReceiptIdQueryVariablesGQLType>;
export const CreateDeliverableDocumentGQLType = gql`
    mutation CreateDeliverable($creditFacilityId: UUID!, $configKey: String!, $dueDate: FullDateStr!) {
  deliverable: manuallyCreateDeliverableByDueDate(
    creditFacilityId: $creditFacilityId
    configKey: $configKey
    dueDate: $dueDate
  ) {
    id
    configKey
    configName
    creditAgreementId
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    dueDate
    type
    period
    daysOffset
    totalDependencies
    completedDependencies
    totalFinalArtifacts
    completedFinalArtifacts
    borrowerId
    borrowerSlug
    borrowerName
    capitalProviderEntities {
      id
      slug
      name
    }
  }
}
    `;
export type CreateDeliverableMutationFnGQLType = Apollo.MutationFunction<CreateDeliverableMutationGQLType, CreateDeliverableMutationVariablesGQLType>;

/**
 * __useCreateDeliverableMutation__
 *
 * To run a mutation, you first call `useCreateDeliverableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliverableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliverableMutation, { data, loading, error }] = useCreateDeliverableMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      configKey: // value for 'configKey'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useCreateDeliverableMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliverableMutationGQLType, CreateDeliverableMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliverableMutationGQLType, CreateDeliverableMutationVariablesGQLType>(CreateDeliverableDocumentGQLType, options);
      }
export type CreateDeliverableMutationHookResult = ReturnType<typeof useCreateDeliverableMutation>;
export type CreateDeliverableMutationResultGQLType = Apollo.MutationResult<CreateDeliverableMutationGQLType>;
export type CreateDeliverableMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateDeliverableMutationGQLType, CreateDeliverableMutationVariablesGQLType>;
export const DeleteDeliverablesRecordsForContainerDocumentGQLType = gql`
    mutation DeleteDeliverablesRecordsForContainer($containerId: UUID!) {
  deleteDeliverableRecordsForContainerId(containerId: $containerId)
}
    `;
export type DeleteDeliverablesRecordsForContainerMutationFnGQLType = Apollo.MutationFunction<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>;

/**
 * __useDeleteDeliverablesRecordsForContainerMutation__
 *
 * To run a mutation, you first call `useDeleteDeliverablesRecordsForContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliverablesRecordsForContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliverablesRecordsForContainerMutation, { data, loading, error }] = useDeleteDeliverablesRecordsForContainerMutation({
 *   variables: {
 *      containerId: // value for 'containerId'
 *   },
 * });
 */
export function useDeleteDeliverablesRecordsForContainerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>(DeleteDeliverablesRecordsForContainerDocumentGQLType, options);
      }
export type DeleteDeliverablesRecordsForContainerMutationHookResult = ReturnType<typeof useDeleteDeliverablesRecordsForContainerMutation>;
export type DeleteDeliverablesRecordsForContainerMutationResultGQLType = Apollo.MutationResult<DeleteDeliverablesRecordsForContainerMutationGQLType>;
export type DeleteDeliverablesRecordsForContainerMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteDeliverablesRecordsForContainerMutationGQLType, DeleteDeliverablesRecordsForContainerMutationVariablesGQLType>;
export const GetDeliverableContainersDocumentGQLType = gql`
    query GetDeliverableContainers($creditFacilityIds: [UUID!]!, $limit: Int, $offset: Int) {
  getDeliverableContainers(
    creditFacilityIds: $creditFacilityIds
    limit: $limit
    offset: $offset
  ) {
    id
    configKey
    configName
    creditAgreementId
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    dueDate
    type
    period
    daysOffset
    totalDependencies
    completedDependencies
    totalFinalArtifacts
    completedFinalArtifacts
    borrowerId
    borrowerSlug
    borrowerName
    capitalProviderEntities {
      id
      slug
      name
    }
    latestReceiptId
    mostRecentActionType
    approvedDate
  }
}
    `;

/**
 * __useGetDeliverableContainersQuery__
 *
 * To run a query within a React component, call `useGetDeliverableContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableContainersQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDeliverableContainersQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableContainersQueryGQLType, GetDeliverableContainersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableContainersQueryGQLType, GetDeliverableContainersQueryVariablesGQLType>(GetDeliverableContainersDocumentGQLType, options);
      }
export function useGetDeliverableContainersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableContainersQueryGQLType, GetDeliverableContainersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableContainersQueryGQLType, GetDeliverableContainersQueryVariablesGQLType>(GetDeliverableContainersDocumentGQLType, options);
        }
export type GetDeliverableContainersQueryHookResult = ReturnType<typeof useGetDeliverableContainersQuery>;
export type GetDeliverableContainersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableContainersLazyQueryGQLType>;
export type GetDeliverableContainersQueryResultGQLType = Apollo.QueryResult<GetDeliverableContainersQueryGQLType, GetDeliverableContainersQueryVariablesGQLType>;
export const GetDeliverablesContainersLenderViewDocumentGQLType = gql`
    query GetDeliverablesContainersLenderView($creditFacilityIds: [UUID!]!, $includeFutureDays: Int) {
  deliverablesContainersLenderView(
    creditFacilityIds: $creditFacilityIds
    includeFutureDays: $includeFutureDays
  ) {
    id
    configKey
    configName
    creditAgreementId
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    dueDate
    dueDateDescription
    type
    borrower {
      id
      name
    }
    latestReceiptId
    mostRecentActionType
    approvedDate
  }
}
    `;

/**
 * __useGetDeliverablesContainersLenderViewQuery__
 *
 * To run a query within a React component, call `useGetDeliverablesContainersLenderViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverablesContainersLenderViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverablesContainersLenderViewQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      includeFutureDays: // value for 'includeFutureDays'
 *   },
 * });
 */
export function useGetDeliverablesContainersLenderViewQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverablesContainersLenderViewQueryGQLType, GetDeliverablesContainersLenderViewQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverablesContainersLenderViewQueryGQLType, GetDeliverablesContainersLenderViewQueryVariablesGQLType>(GetDeliverablesContainersLenderViewDocumentGQLType, options);
      }
export function useGetDeliverablesContainersLenderViewLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverablesContainersLenderViewQueryGQLType, GetDeliverablesContainersLenderViewQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverablesContainersLenderViewQueryGQLType, GetDeliverablesContainersLenderViewQueryVariablesGQLType>(GetDeliverablesContainersLenderViewDocumentGQLType, options);
        }
export type GetDeliverablesContainersLenderViewQueryHookResult = ReturnType<typeof useGetDeliverablesContainersLenderViewQuery>;
export type GetDeliverablesContainersLenderViewLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverablesContainersLenderViewLazyQueryGQLType>;
export type GetDeliverablesContainersLenderViewQueryResultGQLType = Apollo.QueryResult<GetDeliverablesContainersLenderViewQueryGQLType, GetDeliverablesContainersLenderViewQueryVariablesGQLType>;
export const GetEventsDocumentGQLType = gql`
    query GetEvents($organizationId: String!, $limit: Int!, $after: String, $before: String, $startDate: FullDateStr, $endDate: FullDateStr) {
  events(
    organizationId: $organizationId
    limit: $limit
    after: $after
    before: $before
    startDate: $startDate
    endDate: $endDate
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...EventForRender
    }
  }
}
    ${EventForRenderFragmentDocGQLType}`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions: Apollo.QueryHookOptions<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>(GetEventsDocumentGQLType, options);
      }
export function useGetEventsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>(GetEventsDocumentGQLType, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEventsLazyQueryGQLType>;
export type GetEventsQueryResultGQLType = Apollo.QueryResult<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>;
export const GetFundingRequestsWithThreadMetadataDocumentGQLType = gql`
    query GetFundingRequestsWithThreadMetadata($creditFacilityIds: [UUID!]!) {
  fundingRequests(creditFacilityIds: $creditFacilityIds) {
    nodes {
      ...FundingRequestWithThreadMetadata
    }
  }
}
    ${FundingRequestWithThreadMetadataFragmentDocGQLType}`;

/**
 * __useGetFundingRequestsWithThreadMetadataQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestsWithThreadMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestsWithThreadMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestsWithThreadMetadataQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetFundingRequestsWithThreadMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestsWithThreadMetadataQueryGQLType, GetFundingRequestsWithThreadMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestsWithThreadMetadataQueryGQLType, GetFundingRequestsWithThreadMetadataQueryVariablesGQLType>(GetFundingRequestsWithThreadMetadataDocumentGQLType, options);
      }
export function useGetFundingRequestsWithThreadMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestsWithThreadMetadataQueryGQLType, GetFundingRequestsWithThreadMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestsWithThreadMetadataQueryGQLType, GetFundingRequestsWithThreadMetadataQueryVariablesGQLType>(GetFundingRequestsWithThreadMetadataDocumentGQLType, options);
        }
export type GetFundingRequestsWithThreadMetadataQueryHookResult = ReturnType<typeof useGetFundingRequestsWithThreadMetadataQuery>;
export type GetFundingRequestsWithThreadMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestsWithThreadMetadataLazyQueryGQLType>;
export type GetFundingRequestsWithThreadMetadataQueryResultGQLType = Apollo.QueryResult<GetFundingRequestsWithThreadMetadataQueryGQLType, GetFundingRequestsWithThreadMetadataQueryVariablesGQLType>;
export const GetUserOrgCashBalancePreferenceDocumentGQLType = gql`
    query GetUserOrgCashBalancePreference {
  user {
    id
    organization {
      id
      slug
      orgPreferences {
        cashBalancePreference
      }
    }
  }
}
    `;

/**
 * __useGetUserOrgCashBalancePreferenceQuery__
 *
 * To run a query within a React component, call `useGetUserOrgCashBalancePreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrgCashBalancePreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrgCashBalancePreferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOrgCashBalancePreferenceQuery(baseOptions?: Apollo.QueryHookOptions<GetUserOrgCashBalancePreferenceQueryGQLType, GetUserOrgCashBalancePreferenceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrgCashBalancePreferenceQueryGQLType, GetUserOrgCashBalancePreferenceQueryVariablesGQLType>(GetUserOrgCashBalancePreferenceDocumentGQLType, options);
      }
export function useGetUserOrgCashBalancePreferenceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrgCashBalancePreferenceQueryGQLType, GetUserOrgCashBalancePreferenceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrgCashBalancePreferenceQueryGQLType, GetUserOrgCashBalancePreferenceQueryVariablesGQLType>(GetUserOrgCashBalancePreferenceDocumentGQLType, options);
        }
export type GetUserOrgCashBalancePreferenceQueryHookResult = ReturnType<typeof useGetUserOrgCashBalancePreferenceQuery>;
export type GetUserOrgCashBalancePreferenceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUserOrgCashBalancePreferenceLazyQueryGQLType>;
export type GetUserOrgCashBalancePreferenceQueryResultGQLType = Apollo.QueryResult<GetUserOrgCashBalancePreferenceQueryGQLType, GetUserOrgCashBalancePreferenceQueryVariablesGQLType>;
export const ConnectPlaidItemDocumentGQLType = gql`
    mutation ConnectPlaidItem($publicToken: String!, $plaidInstitutionId: String!) {
  connectPlaidItem(
    publicToken: $publicToken
    plaidInstitutionId: $plaidInstitutionId
  ) {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;
export type ConnectPlaidItemMutationFnGQLType = Apollo.MutationFunction<ConnectPlaidItemMutationGQLType, ConnectPlaidItemMutationVariablesGQLType>;

/**
 * __useConnectPlaidItemMutation__
 *
 * To run a mutation, you first call `useConnectPlaidItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectPlaidItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectPlaidItemMutation, { data, loading, error }] = useConnectPlaidItemMutation({
 *   variables: {
 *      publicToken: // value for 'publicToken'
 *      plaidInstitutionId: // value for 'plaidInstitutionId'
 *   },
 * });
 */
export function useConnectPlaidItemMutation(baseOptions?: Apollo.MutationHookOptions<ConnectPlaidItemMutationGQLType, ConnectPlaidItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectPlaidItemMutationGQLType, ConnectPlaidItemMutationVariablesGQLType>(ConnectPlaidItemDocumentGQLType, options);
      }
export type ConnectPlaidItemMutationHookResult = ReturnType<typeof useConnectPlaidItemMutation>;
export type ConnectPlaidItemMutationResultGQLType = Apollo.MutationResult<ConnectPlaidItemMutationGQLType>;
export type ConnectPlaidItemMutationOptionsGQLType = Apollo.BaseMutationOptions<ConnectPlaidItemMutationGQLType, ConnectPlaidItemMutationVariablesGQLType>;
export const RefreshPlaidInstitutionAccountsDocumentGQLType = gql`
    mutation RefreshPlaidInstitutionAccounts($plaidItemId: UUID!) {
  refreshPlaidInstitutionAccounts(plaidItemId: $plaidItemId) {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;
export type RefreshPlaidInstitutionAccountsMutationFnGQLType = Apollo.MutationFunction<RefreshPlaidInstitutionAccountsMutationGQLType, RefreshPlaidInstitutionAccountsMutationVariablesGQLType>;

/**
 * __useRefreshPlaidInstitutionAccountsMutation__
 *
 * To run a mutation, you first call `useRefreshPlaidInstitutionAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPlaidInstitutionAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPlaidInstitutionAccountsMutation, { data, loading, error }] = useRefreshPlaidInstitutionAccountsMutation({
 *   variables: {
 *      plaidItemId: // value for 'plaidItemId'
 *   },
 * });
 */
export function useRefreshPlaidInstitutionAccountsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshPlaidInstitutionAccountsMutationGQLType, RefreshPlaidInstitutionAccountsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshPlaidInstitutionAccountsMutationGQLType, RefreshPlaidInstitutionAccountsMutationVariablesGQLType>(RefreshPlaidInstitutionAccountsDocumentGQLType, options);
      }
export type RefreshPlaidInstitutionAccountsMutationHookResult = ReturnType<typeof useRefreshPlaidInstitutionAccountsMutation>;
export type RefreshPlaidInstitutionAccountsMutationResultGQLType = Apollo.MutationResult<RefreshPlaidInstitutionAccountsMutationGQLType>;
export type RefreshPlaidInstitutionAccountsMutationOptionsGQLType = Apollo.BaseMutationOptions<RefreshPlaidInstitutionAccountsMutationGQLType, RefreshPlaidInstitutionAccountsMutationVariablesGQLType>;
export const InvalidatePlaidItemDocumentGQLType = gql`
    mutation InvalidatePlaidItem($plaidItemId: UUID!) {
  disconnectPlaidItem(plaidItemId: $plaidItemId) {
    plaidResponse
  }
}
    `;
export type InvalidatePlaidItemMutationFnGQLType = Apollo.MutationFunction<InvalidatePlaidItemMutationGQLType, InvalidatePlaidItemMutationVariablesGQLType>;

/**
 * __useInvalidatePlaidItemMutation__
 *
 * To run a mutation, you first call `useInvalidatePlaidItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidatePlaidItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidatePlaidItemMutation, { data, loading, error }] = useInvalidatePlaidItemMutation({
 *   variables: {
 *      plaidItemId: // value for 'plaidItemId'
 *   },
 * });
 */
export function useInvalidatePlaidItemMutation(baseOptions?: Apollo.MutationHookOptions<InvalidatePlaidItemMutationGQLType, InvalidatePlaidItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvalidatePlaidItemMutationGQLType, InvalidatePlaidItemMutationVariablesGQLType>(InvalidatePlaidItemDocumentGQLType, options);
      }
export type InvalidatePlaidItemMutationHookResult = ReturnType<typeof useInvalidatePlaidItemMutation>;
export type InvalidatePlaidItemMutationResultGQLType = Apollo.MutationResult<InvalidatePlaidItemMutationGQLType>;
export type InvalidatePlaidItemMutationOptionsGQLType = Apollo.BaseMutationOptions<InvalidatePlaidItemMutationGQLType, InvalidatePlaidItemMutationVariablesGQLType>;
export const ReconnectPlaidItemDocumentGQLType = gql`
    mutation ReconnectPlaidItem($plaidItemId: UUID!) {
  reconnectPlaidItem(plaidItemId: $plaidItemId) {
    plaidResponse
  }
}
    `;
export type ReconnectPlaidItemMutationFnGQLType = Apollo.MutationFunction<ReconnectPlaidItemMutationGQLType, ReconnectPlaidItemMutationVariablesGQLType>;

/**
 * __useReconnectPlaidItemMutation__
 *
 * To run a mutation, you first call `useReconnectPlaidItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconnectPlaidItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconnectPlaidItemMutation, { data, loading, error }] = useReconnectPlaidItemMutation({
 *   variables: {
 *      plaidItemId: // value for 'plaidItemId'
 *   },
 * });
 */
export function useReconnectPlaidItemMutation(baseOptions?: Apollo.MutationHookOptions<ReconnectPlaidItemMutationGQLType, ReconnectPlaidItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconnectPlaidItemMutationGQLType, ReconnectPlaidItemMutationVariablesGQLType>(ReconnectPlaidItemDocumentGQLType, options);
      }
export type ReconnectPlaidItemMutationHookResult = ReturnType<typeof useReconnectPlaidItemMutation>;
export type ReconnectPlaidItemMutationResultGQLType = Apollo.MutationResult<ReconnectPlaidItemMutationGQLType>;
export type ReconnectPlaidItemMutationOptionsGQLType = Apollo.BaseMutationOptions<ReconnectPlaidItemMutationGQLType, ReconnectPlaidItemMutationVariablesGQLType>;
export const GetPlaidLinkTokenDocumentGQLType = gql`
    query GetPlaidLinkToken {
  plaidLinkToken {
    token
    needsUpdate
    institutionName
    plaidItemId
  }
}
    `;

/**
 * __useGetPlaidLinkTokenQuery__
 *
 * To run a query within a React component, call `useGetPlaidLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaidLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaidLinkTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaidLinkTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetPlaidLinkTokenQueryGQLType, GetPlaidLinkTokenQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaidLinkTokenQueryGQLType, GetPlaidLinkTokenQueryVariablesGQLType>(GetPlaidLinkTokenDocumentGQLType, options);
      }
export function useGetPlaidLinkTokenLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaidLinkTokenQueryGQLType, GetPlaidLinkTokenQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaidLinkTokenQueryGQLType, GetPlaidLinkTokenQueryVariablesGQLType>(GetPlaidLinkTokenDocumentGQLType, options);
        }
export type GetPlaidLinkTokenQueryHookResult = ReturnType<typeof useGetPlaidLinkTokenQuery>;
export type GetPlaidLinkTokenLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPlaidLinkTokenLazyQueryGQLType>;
export type GetPlaidLinkTokenQueryResultGQLType = Apollo.QueryResult<GetPlaidLinkTokenQueryGQLType, GetPlaidLinkTokenQueryVariablesGQLType>;
export const GetAllPlaidInstitutionAccountsDocumentGQLType = gql`
    query GetAllPlaidInstitutionAccounts {
  allPlaidInstitutionAccounts {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;

/**
 * __useGetAllPlaidInstitutionAccountsQuery__
 *
 * To run a query within a React component, call `useGetAllPlaidInstitutionAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlaidInstitutionAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlaidInstitutionAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlaidInstitutionAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPlaidInstitutionAccountsQueryGQLType, GetAllPlaidInstitutionAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPlaidInstitutionAccountsQueryGQLType, GetAllPlaidInstitutionAccountsQueryVariablesGQLType>(GetAllPlaidInstitutionAccountsDocumentGQLType, options);
      }
export function useGetAllPlaidInstitutionAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPlaidInstitutionAccountsQueryGQLType, GetAllPlaidInstitutionAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPlaidInstitutionAccountsQueryGQLType, GetAllPlaidInstitutionAccountsQueryVariablesGQLType>(GetAllPlaidInstitutionAccountsDocumentGQLType, options);
        }
export type GetAllPlaidInstitutionAccountsQueryHookResult = ReturnType<typeof useGetAllPlaidInstitutionAccountsQuery>;
export type GetAllPlaidInstitutionAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllPlaidInstitutionAccountsLazyQueryGQLType>;
export type GetAllPlaidInstitutionAccountsQueryResultGQLType = Apollo.QueryResult<GetAllPlaidInstitutionAccountsQueryGQLType, GetAllPlaidInstitutionAccountsQueryVariablesGQLType>;
export const ConnectTellerAccountsForInstitutionDocumentGQLType = gql`
    mutation connectTellerAccountsForInstitution($accessToken: String!) {
  connectTellerAccountsForInstitution(accessToken: $accessToken) {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;
export type ConnectTellerAccountsForInstitutionMutationFnGQLType = Apollo.MutationFunction<ConnectTellerAccountsForInstitutionMutationGQLType, ConnectTellerAccountsForInstitutionMutationVariablesGQLType>;

/**
 * __useConnectTellerAccountsForInstitutionMutation__
 *
 * To run a mutation, you first call `useConnectTellerAccountsForInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectTellerAccountsForInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectTellerAccountsForInstitutionMutation, { data, loading, error }] = useConnectTellerAccountsForInstitutionMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useConnectTellerAccountsForInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<ConnectTellerAccountsForInstitutionMutationGQLType, ConnectTellerAccountsForInstitutionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectTellerAccountsForInstitutionMutationGQLType, ConnectTellerAccountsForInstitutionMutationVariablesGQLType>(ConnectTellerAccountsForInstitutionDocumentGQLType, options);
      }
export type ConnectTellerAccountsForInstitutionMutationHookResult = ReturnType<typeof useConnectTellerAccountsForInstitutionMutation>;
export type ConnectTellerAccountsForInstitutionMutationResultGQLType = Apollo.MutationResult<ConnectTellerAccountsForInstitutionMutationGQLType>;
export type ConnectTellerAccountsForInstitutionMutationOptionsGQLType = Apollo.BaseMutationOptions<ConnectTellerAccountsForInstitutionMutationGQLType, ConnectTellerAccountsForInstitutionMutationVariablesGQLType>;
export const ReconnectTellerInstitutionDocumentGQLType = gql`
    mutation reconnectTellerInstitution($tellerItemId: String!) {
  reconnectTellerInstitution(tellerItemId: $tellerItemId) {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;
export type ReconnectTellerInstitutionMutationFnGQLType = Apollo.MutationFunction<ReconnectTellerInstitutionMutationGQLType, ReconnectTellerInstitutionMutationVariablesGQLType>;

/**
 * __useReconnectTellerInstitutionMutation__
 *
 * To run a mutation, you first call `useReconnectTellerInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconnectTellerInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconnectTellerInstitutionMutation, { data, loading, error }] = useReconnectTellerInstitutionMutation({
 *   variables: {
 *      tellerItemId: // value for 'tellerItemId'
 *   },
 * });
 */
export function useReconnectTellerInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<ReconnectTellerInstitutionMutationGQLType, ReconnectTellerInstitutionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconnectTellerInstitutionMutationGQLType, ReconnectTellerInstitutionMutationVariablesGQLType>(ReconnectTellerInstitutionDocumentGQLType, options);
      }
export type ReconnectTellerInstitutionMutationHookResult = ReturnType<typeof useReconnectTellerInstitutionMutation>;
export type ReconnectTellerInstitutionMutationResultGQLType = Apollo.MutationResult<ReconnectTellerInstitutionMutationGQLType>;
export type ReconnectTellerInstitutionMutationOptionsGQLType = Apollo.BaseMutationOptions<ReconnectTellerInstitutionMutationGQLType, ReconnectTellerInstitutionMutationVariablesGQLType>;
export const DisconnectTellerInstitutionDocumentGQLType = gql`
    mutation disconnectTellerInstitution($tellerItemId: String!) {
  disconnectTellerInstitution(tellerItemId: $tellerItemId) {
    disconnectedItemId
  }
}
    `;
export type DisconnectTellerInstitutionMutationFnGQLType = Apollo.MutationFunction<DisconnectTellerInstitutionMutationGQLType, DisconnectTellerInstitutionMutationVariablesGQLType>;

/**
 * __useDisconnectTellerInstitutionMutation__
 *
 * To run a mutation, you first call `useDisconnectTellerInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectTellerInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectTellerInstitutionMutation, { data, loading, error }] = useDisconnectTellerInstitutionMutation({
 *   variables: {
 *      tellerItemId: // value for 'tellerItemId'
 *   },
 * });
 */
export function useDisconnectTellerInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectTellerInstitutionMutationGQLType, DisconnectTellerInstitutionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectTellerInstitutionMutationGQLType, DisconnectTellerInstitutionMutationVariablesGQLType>(DisconnectTellerInstitutionDocumentGQLType, options);
      }
export type DisconnectTellerInstitutionMutationHookResult = ReturnType<typeof useDisconnectTellerInstitutionMutation>;
export type DisconnectTellerInstitutionMutationResultGQLType = Apollo.MutationResult<DisconnectTellerInstitutionMutationGQLType>;
export type DisconnectTellerInstitutionMutationOptionsGQLType = Apollo.BaseMutationOptions<DisconnectTellerInstitutionMutationGQLType, DisconnectTellerInstitutionMutationVariablesGQLType>;
export const RefreshTellerInstitutionDocumentGQLType = gql`
    mutation refreshTellerInstitution($tellerItemId: String!) {
  refreshTellerInstitution(tellerItemId: $tellerItemId) {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;
export type RefreshTellerInstitutionMutationFnGQLType = Apollo.MutationFunction<RefreshTellerInstitutionMutationGQLType, RefreshTellerInstitutionMutationVariablesGQLType>;

/**
 * __useRefreshTellerInstitutionMutation__
 *
 * To run a mutation, you first call `useRefreshTellerInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTellerInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTellerInstitutionMutation, { data, loading, error }] = useRefreshTellerInstitutionMutation({
 *   variables: {
 *      tellerItemId: // value for 'tellerItemId'
 *   },
 * });
 */
export function useRefreshTellerInstitutionMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTellerInstitutionMutationGQLType, RefreshTellerInstitutionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTellerInstitutionMutationGQLType, RefreshTellerInstitutionMutationVariablesGQLType>(RefreshTellerInstitutionDocumentGQLType, options);
      }
export type RefreshTellerInstitutionMutationHookResult = ReturnType<typeof useRefreshTellerInstitutionMutation>;
export type RefreshTellerInstitutionMutationResultGQLType = Apollo.MutationResult<RefreshTellerInstitutionMutationGQLType>;
export type RefreshTellerInstitutionMutationOptionsGQLType = Apollo.BaseMutationOptions<RefreshTellerInstitutionMutationGQLType, RefreshTellerInstitutionMutationVariablesGQLType>;
export const GetAllTellerInstitutionAccountsDocumentGQLType = gql`
    query GetAllTellerInstitutionAccounts {
  allTellerInstitutionAccounts {
    ...BankDataProviderInstitutionFields
  }
}
    ${BankDataProviderInstitutionFieldsFragmentDocGQLType}`;

/**
 * __useGetAllTellerInstitutionAccountsQuery__
 *
 * To run a query within a React component, call `useGetAllTellerInstitutionAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTellerInstitutionAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTellerInstitutionAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTellerInstitutionAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTellerInstitutionAccountsQueryGQLType, GetAllTellerInstitutionAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTellerInstitutionAccountsQueryGQLType, GetAllTellerInstitutionAccountsQueryVariablesGQLType>(GetAllTellerInstitutionAccountsDocumentGQLType, options);
      }
export function useGetAllTellerInstitutionAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTellerInstitutionAccountsQueryGQLType, GetAllTellerInstitutionAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTellerInstitutionAccountsQueryGQLType, GetAllTellerInstitutionAccountsQueryVariablesGQLType>(GetAllTellerInstitutionAccountsDocumentGQLType, options);
        }
export type GetAllTellerInstitutionAccountsQueryHookResult = ReturnType<typeof useGetAllTellerInstitutionAccountsQuery>;
export type GetAllTellerInstitutionAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllTellerInstitutionAccountsLazyQueryGQLType>;
export type GetAllTellerInstitutionAccountsQueryResultGQLType = Apollo.QueryResult<GetAllTellerInstitutionAccountsQueryGQLType, GetAllTellerInstitutionAccountsQueryVariablesGQLType>;
export const UpsertImplementationPortalBankAccountDocumentGQLType = gql`
    mutation UpsertImplementationPortalBankAccount($implementationId: UUID!, $ownerId: UUID!, $accountType: AccountType!) {
  upsertImplementationPortalBankAccount(
    implementationId: $implementationId
    ownerId: $ownerId
    accountType: $accountType
  ) {
    id
    name
  }
}
    `;
export type UpsertImplementationPortalBankAccountMutationFnGQLType = Apollo.MutationFunction<UpsertImplementationPortalBankAccountMutationGQLType, UpsertImplementationPortalBankAccountMutationVariablesGQLType>;

/**
 * __useUpsertImplementationPortalBankAccountMutation__
 *
 * To run a mutation, you first call `useUpsertImplementationPortalBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertImplementationPortalBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertImplementationPortalBankAccountMutation, { data, loading, error }] = useUpsertImplementationPortalBankAccountMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      ownerId: // value for 'ownerId'
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useUpsertImplementationPortalBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpsertImplementationPortalBankAccountMutationGQLType, UpsertImplementationPortalBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertImplementationPortalBankAccountMutationGQLType, UpsertImplementationPortalBankAccountMutationVariablesGQLType>(UpsertImplementationPortalBankAccountDocumentGQLType, options);
      }
export type UpsertImplementationPortalBankAccountMutationHookResult = ReturnType<typeof useUpsertImplementationPortalBankAccountMutation>;
export type UpsertImplementationPortalBankAccountMutationResultGQLType = Apollo.MutationResult<UpsertImplementationPortalBankAccountMutationGQLType>;
export type UpsertImplementationPortalBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<UpsertImplementationPortalBankAccountMutationGQLType, UpsertImplementationPortalBankAccountMutationVariablesGQLType>;
export const GetCreditAgreementValidationErrorsDocumentGQLType = gql`
    query getCreditAgreementValidationErrors($creditAgreementId: UUID!) {
  getCreditAgreementValidationErrors(creditAgreementId: $creditAgreementId) {
    type
    message
  }
}
    `;

/**
 * __useGetCreditAgreementValidationErrorsQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementValidationErrorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementValidationErrorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementValidationErrorsQuery({
 *   variables: {
 *      creditAgreementId: // value for 'creditAgreementId'
 *   },
 * });
 */
export function useGetCreditAgreementValidationErrorsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementValidationErrorsQueryGQLType, GetCreditAgreementValidationErrorsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementValidationErrorsQueryGQLType, GetCreditAgreementValidationErrorsQueryVariablesGQLType>(GetCreditAgreementValidationErrorsDocumentGQLType, options);
      }
export function useGetCreditAgreementValidationErrorsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementValidationErrorsQueryGQLType, GetCreditAgreementValidationErrorsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementValidationErrorsQueryGQLType, GetCreditAgreementValidationErrorsQueryVariablesGQLType>(GetCreditAgreementValidationErrorsDocumentGQLType, options);
        }
export type GetCreditAgreementValidationErrorsQueryHookResult = ReturnType<typeof useGetCreditAgreementValidationErrorsQuery>;
export type GetCreditAgreementValidationErrorsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementValidationErrorsLazyQueryGQLType>;
export type GetCreditAgreementValidationErrorsQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementValidationErrorsQueryGQLType, GetCreditAgreementValidationErrorsQueryVariablesGQLType>;
export const ImplementationDetailsDocumentGQLType = gql`
    query implementationDetails($implementationId: UUID!) {
  implementation(implementationId: $implementationId) {
    id
    name
    loanProducts {
      id
      slug
      name
    }
    creditFacilities {
      id
      slug
      name
      borrowerOrganizationName
    }
  }
}
    `;

/**
 * __useImplementationDetailsQuery__
 *
 * To run a query within a React component, call `useImplementationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImplementationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImplementationDetailsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useImplementationDetailsQuery(baseOptions: Apollo.QueryHookOptions<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>(ImplementationDetailsDocumentGQLType, options);
      }
export function useImplementationDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>(ImplementationDetailsDocumentGQLType, options);
        }
export type ImplementationDetailsQueryHookResult = ReturnType<typeof useImplementationDetailsQuery>;
export type ImplementationDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useImplementationDetailsLazyQueryGQLType>;
export type ImplementationDetailsQueryResultGQLType = Apollo.QueryResult<ImplementationDetailsQueryGQLType, ImplementationDetailsQueryVariablesGQLType>;
export const UpdateImplementationNameDocumentGQLType = gql`
    mutation updateImplementationName($implementationId: UUID!, $name: String!) {
  updateImplementationName(implementationId: $implementationId, name: $name) {
    id
    name
  }
}
    `;
export type UpdateImplementationNameMutationFnGQLType = Apollo.MutationFunction<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>;

/**
 * __useUpdateImplementationNameMutation__
 *
 * To run a mutation, you first call `useUpdateImplementationNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImplementationNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImplementationNameMutation, { data, loading, error }] = useUpdateImplementationNameMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateImplementationNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>(UpdateImplementationNameDocumentGQLType, options);
      }
export type UpdateImplementationNameMutationHookResult = ReturnType<typeof useUpdateImplementationNameMutation>;
export type UpdateImplementationNameMutationResultGQLType = Apollo.MutationResult<UpdateImplementationNameMutationGQLType>;
export type UpdateImplementationNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateImplementationNameMutationGQLType, UpdateImplementationNameMutationVariablesGQLType>;
export const ImplementationsDocumentGQLType = gql`
    query implementations($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    implementations {
      id
      name
      creditFacilities {
        id
      }
    }
  }
}
    `;

/**
 * __useImplementationsQuery__
 *
 * To run a query within a React component, call `useImplementationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImplementationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImplementationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useImplementationsQuery(baseOptions: Apollo.QueryHookOptions<ImplementationsQueryGQLType, ImplementationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImplementationsQueryGQLType, ImplementationsQueryVariablesGQLType>(ImplementationsDocumentGQLType, options);
      }
export function useImplementationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ImplementationsQueryGQLType, ImplementationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImplementationsQueryGQLType, ImplementationsQueryVariablesGQLType>(ImplementationsDocumentGQLType, options);
        }
export type ImplementationsQueryHookResult = ReturnType<typeof useImplementationsQuery>;
export type ImplementationsLazyQueryGQLTypeHookResult = ReturnType<typeof useImplementationsLazyQueryGQLType>;
export type ImplementationsQueryResultGQLType = Apollo.QueryResult<ImplementationsQueryGQLType, ImplementationsQueryVariablesGQLType>;
export const GetCreditAgreementDocumentsMetadataDocumentGQLType = gql`
    query GetCreditAgreementDocumentsMetadata($creditFacilityId: UUID!) {
  creditAgreementDocumentsMetadata(creditFacilityId: $creditFacilityId) {
    ...CreditAgreementDocumentMetadataFields
  }
}
    ${CreditAgreementDocumentMetadataFieldsFragmentDocGQLType}`;

/**
 * __useGetCreditAgreementDocumentsMetadataQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementDocumentsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementDocumentsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementDocumentsMetadataQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditAgreementDocumentsMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementDocumentsMetadataQueryGQLType, GetCreditAgreementDocumentsMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementDocumentsMetadataQueryGQLType, GetCreditAgreementDocumentsMetadataQueryVariablesGQLType>(GetCreditAgreementDocumentsMetadataDocumentGQLType, options);
      }
export function useGetCreditAgreementDocumentsMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementDocumentsMetadataQueryGQLType, GetCreditAgreementDocumentsMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementDocumentsMetadataQueryGQLType, GetCreditAgreementDocumentsMetadataQueryVariablesGQLType>(GetCreditAgreementDocumentsMetadataDocumentGQLType, options);
        }
export type GetCreditAgreementDocumentsMetadataQueryHookResult = ReturnType<typeof useGetCreditAgreementDocumentsMetadataQuery>;
export type GetCreditAgreementDocumentsMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementDocumentsMetadataLazyQueryGQLType>;
export type GetCreditAgreementDocumentsMetadataQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementDocumentsMetadataQueryGQLType, GetCreditAgreementDocumentsMetadataQueryVariablesGQLType>;
export const GetCreditAgreementFullArtifactDocumentGQLType = gql`
    query GetCreditAgreementFullArtifact($creditAgreementId: UUID!) {
  creditAgreementFullArtifact(creditAgreementId: $creditAgreementId) {
    ...CreditAgreementFullArtifactFields
  }
}
    ${CreditAgreementFullArtifactFieldsFragmentDocGQLType}`;

/**
 * __useGetCreditAgreementFullArtifactQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementFullArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementFullArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementFullArtifactQuery({
 *   variables: {
 *      creditAgreementId: // value for 'creditAgreementId'
 *   },
 * });
 */
export function useGetCreditAgreementFullArtifactQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementFullArtifactQueryGQLType, GetCreditAgreementFullArtifactQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementFullArtifactQueryGQLType, GetCreditAgreementFullArtifactQueryVariablesGQLType>(GetCreditAgreementFullArtifactDocumentGQLType, options);
      }
export function useGetCreditAgreementFullArtifactLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementFullArtifactQueryGQLType, GetCreditAgreementFullArtifactQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementFullArtifactQueryGQLType, GetCreditAgreementFullArtifactQueryVariablesGQLType>(GetCreditAgreementFullArtifactDocumentGQLType, options);
        }
export type GetCreditAgreementFullArtifactQueryHookResult = ReturnType<typeof useGetCreditAgreementFullArtifactQuery>;
export type GetCreditAgreementFullArtifactLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementFullArtifactLazyQueryGQLType>;
export type GetCreditAgreementFullArtifactQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementFullArtifactQueryGQLType, GetCreditAgreementFullArtifactQueryVariablesGQLType>;
export const CreateImplementationDocumentGQLType = gql`
    mutation createImplementation($ownerOrganizationId: UUID!, $implementationName: String!, $borrowerId: UUID!) {
  createImplementation(
    ownerOrganizationId: $ownerOrganizationId
    implementationName: $implementationName
    borrowerId: $borrowerId
  ) {
    id
  }
}
    `;
export type CreateImplementationMutationFnGQLType = Apollo.MutationFunction<CreateImplementationMutationGQLType, CreateImplementationMutationVariablesGQLType>;

/**
 * __useCreateImplementationMutation__
 *
 * To run a mutation, you first call `useCreateImplementationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImplementationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImplementationMutation, { data, loading, error }] = useCreateImplementationMutation({
 *   variables: {
 *      ownerOrganizationId: // value for 'ownerOrganizationId'
 *      implementationName: // value for 'implementationName'
 *      borrowerId: // value for 'borrowerId'
 *   },
 * });
 */
export function useCreateImplementationMutation(baseOptions?: Apollo.MutationHookOptions<CreateImplementationMutationGQLType, CreateImplementationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImplementationMutationGQLType, CreateImplementationMutationVariablesGQLType>(CreateImplementationDocumentGQLType, options);
      }
export type CreateImplementationMutationHookResult = ReturnType<typeof useCreateImplementationMutation>;
export type CreateImplementationMutationResultGQLType = Apollo.MutationResult<CreateImplementationMutationGQLType>;
export type CreateImplementationMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateImplementationMutationGQLType, CreateImplementationMutationVariablesGQLType>;
export const CreateSingleFacilityImplementationDocumentGQLType = gql`
    mutation createSingleFacilityImplementation($ownerOrganizationId: UUID!, $creditFacilityName: String!, $creditFacilityParties: [PartyInput!]!) {
  createSingleFacilityImplementation(
    ownerOrganizationId: $ownerOrganizationId
    creditFacilityName: $creditFacilityName
    creditFacilityParties: $creditFacilityParties
  ) {
    id
  }
}
    `;
export type CreateSingleFacilityImplementationMutationFnGQLType = Apollo.MutationFunction<CreateSingleFacilityImplementationMutationGQLType, CreateSingleFacilityImplementationMutationVariablesGQLType>;

/**
 * __useCreateSingleFacilityImplementationMutation__
 *
 * To run a mutation, you first call `useCreateSingleFacilityImplementationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleFacilityImplementationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleFacilityImplementationMutation, { data, loading, error }] = useCreateSingleFacilityImplementationMutation({
 *   variables: {
 *      ownerOrganizationId: // value for 'ownerOrganizationId'
 *      creditFacilityName: // value for 'creditFacilityName'
 *      creditFacilityParties: // value for 'creditFacilityParties'
 *   },
 * });
 */
export function useCreateSingleFacilityImplementationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSingleFacilityImplementationMutationGQLType, CreateSingleFacilityImplementationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSingleFacilityImplementationMutationGQLType, CreateSingleFacilityImplementationMutationVariablesGQLType>(CreateSingleFacilityImplementationDocumentGQLType, options);
      }
export type CreateSingleFacilityImplementationMutationHookResult = ReturnType<typeof useCreateSingleFacilityImplementationMutation>;
export type CreateSingleFacilityImplementationMutationResultGQLType = Apollo.MutationResult<CreateSingleFacilityImplementationMutationGQLType>;
export type CreateSingleFacilityImplementationMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateSingleFacilityImplementationMutationGQLType, CreateSingleFacilityImplementationMutationVariablesGQLType>;
export const VisibleOrganizationsDocumentGQLType = gql`
    query visibleOrganizations($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    visibleOrganizations {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useVisibleOrganizationsQuery__
 *
 * To run a query within a React component, call `useVisibleOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibleOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibleOrganizationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useVisibleOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<VisibleOrganizationsQueryGQLType, VisibleOrganizationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisibleOrganizationsQueryGQLType, VisibleOrganizationsQueryVariablesGQLType>(VisibleOrganizationsDocumentGQLType, options);
      }
export function useVisibleOrganizationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<VisibleOrganizationsQueryGQLType, VisibleOrganizationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisibleOrganizationsQueryGQLType, VisibleOrganizationsQueryVariablesGQLType>(VisibleOrganizationsDocumentGQLType, options);
        }
export type VisibleOrganizationsQueryHookResult = ReturnType<typeof useVisibleOrganizationsQuery>;
export type VisibleOrganizationsLazyQueryGQLTypeHookResult = ReturnType<typeof useVisibleOrganizationsLazyQueryGQLType>;
export type VisibleOrganizationsQueryResultGQLType = Apollo.QueryResult<VisibleOrganizationsQueryGQLType, VisibleOrganizationsQueryVariablesGQLType>;
export const GetCreditAgreementFullArtifactImplementationPortalWipDocumentGQLType = gql`
    query GetCreditAgreementFullArtifactImplementationPortalWip($creditFacilityId: UUID!) {
  creditAgreementFullArtifactWip(creditFacilityId: $creditFacilityId) {
    wip {
      ...CreditAgreementFullArtifactFields
    }
    errors
  }
}
    ${CreditAgreementFullArtifactFieldsFragmentDocGQLType}`;

/**
 * __useGetCreditAgreementFullArtifactImplementationPortalWipQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementFullArtifactImplementationPortalWipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementFullArtifactImplementationPortalWipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementFullArtifactImplementationPortalWipQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditAgreementFullArtifactImplementationPortalWipQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementFullArtifactImplementationPortalWipQueryGQLType, GetCreditAgreementFullArtifactImplementationPortalWipQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementFullArtifactImplementationPortalWipQueryGQLType, GetCreditAgreementFullArtifactImplementationPortalWipQueryVariablesGQLType>(GetCreditAgreementFullArtifactImplementationPortalWipDocumentGQLType, options);
      }
export function useGetCreditAgreementFullArtifactImplementationPortalWipLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementFullArtifactImplementationPortalWipQueryGQLType, GetCreditAgreementFullArtifactImplementationPortalWipQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementFullArtifactImplementationPortalWipQueryGQLType, GetCreditAgreementFullArtifactImplementationPortalWipQueryVariablesGQLType>(GetCreditAgreementFullArtifactImplementationPortalWipDocumentGQLType, options);
        }
export type GetCreditAgreementFullArtifactImplementationPortalWipQueryHookResult = ReturnType<typeof useGetCreditAgreementFullArtifactImplementationPortalWipQuery>;
export type GetCreditAgreementFullArtifactImplementationPortalWipLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementFullArtifactImplementationPortalWipLazyQueryGQLType>;
export type GetCreditAgreementFullArtifactImplementationPortalWipQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementFullArtifactImplementationPortalWipQueryGQLType, GetCreditAgreementFullArtifactImplementationPortalWipQueryVariablesGQLType>;
export const UpdateClientCreditAgreementFullArtifactImplementationPortalWipDocumentGQLType = gql`
    mutation UpdateClientCreditAgreementFullArtifactImplementationPortalWip($creditAgreementFullArtifactWip: CreditAgreementFullArtifactInput!) {
  updateClientCreditAgreementFullArtifactImplementationPortalWip(
    creditAgreementFullArtifactWip: $creditAgreementFullArtifactWip
  ) {
    response
  }
}
    `;
export type UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationFnGQLType = Apollo.MutationFunction<UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationGQLType, UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationVariablesGQLType>;

/**
 * __useUpdateClientCreditAgreementFullArtifactImplementationPortalWipMutation__
 *
 * To run a mutation, you first call `useUpdateClientCreditAgreementFullArtifactImplementationPortalWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCreditAgreementFullArtifactImplementationPortalWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCreditAgreementFullArtifactImplementationPortalWipMutation, { data, loading, error }] = useUpdateClientCreditAgreementFullArtifactImplementationPortalWipMutation({
 *   variables: {
 *      creditAgreementFullArtifactWip: // value for 'creditAgreementFullArtifactWip'
 *   },
 * });
 */
export function useUpdateClientCreditAgreementFullArtifactImplementationPortalWipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationGQLType, UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationGQLType, UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationVariablesGQLType>(UpdateClientCreditAgreementFullArtifactImplementationPortalWipDocumentGQLType, options);
      }
export type UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationHookResult = ReturnType<typeof useUpdateClientCreditAgreementFullArtifactImplementationPortalWipMutation>;
export type UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationResultGQLType = Apollo.MutationResult<UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationGQLType>;
export type UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationGQLType, UpdateClientCreditAgreementFullArtifactImplementationPortalWipMutationVariablesGQLType>;
export const CommitArtifactDocumentAndCreditAgreementsDocumentGQLType = gql`
    mutation commitArtifactDocumentAndCreditAgreements($creditFacilityId: UUID!) {
  commitArtifactDocumentAndCreditAgreements(creditFacilityId: $creditFacilityId) {
    successes
    errors
  }
}
    `;
export type CommitArtifactDocumentAndCreditAgreementsMutationFnGQLType = Apollo.MutationFunction<CommitArtifactDocumentAndCreditAgreementsMutationGQLType, CommitArtifactDocumentAndCreditAgreementsMutationVariablesGQLType>;

/**
 * __useCommitArtifactDocumentAndCreditAgreementsMutation__
 *
 * To run a mutation, you first call `useCommitArtifactDocumentAndCreditAgreementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitArtifactDocumentAndCreditAgreementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitArtifactDocumentAndCreditAgreementsMutation, { data, loading, error }] = useCommitArtifactDocumentAndCreditAgreementsMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCommitArtifactDocumentAndCreditAgreementsMutation(baseOptions?: Apollo.MutationHookOptions<CommitArtifactDocumentAndCreditAgreementsMutationGQLType, CommitArtifactDocumentAndCreditAgreementsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitArtifactDocumentAndCreditAgreementsMutationGQLType, CommitArtifactDocumentAndCreditAgreementsMutationVariablesGQLType>(CommitArtifactDocumentAndCreditAgreementsDocumentGQLType, options);
      }
export type CommitArtifactDocumentAndCreditAgreementsMutationHookResult = ReturnType<typeof useCommitArtifactDocumentAndCreditAgreementsMutation>;
export type CommitArtifactDocumentAndCreditAgreementsMutationResultGQLType = Apollo.MutationResult<CommitArtifactDocumentAndCreditAgreementsMutationGQLType>;
export type CommitArtifactDocumentAndCreditAgreementsMutationOptionsGQLType = Apollo.BaseMutationOptions<CommitArtifactDocumentAndCreditAgreementsMutationGQLType, CommitArtifactDocumentAndCreditAgreementsMutationVariablesGQLType>;
export const UpdateCreditAgreementDisplayNameDocumentGQLType = gql`
    mutation updateCreditAgreementDisplayName($creditAgreementId: UUID!, $displayName: String!) {
  updateCreditAgreementDisplayName(
    creditAgreementId: $creditAgreementId
    displayName: $displayName
  ) {
    response
  }
}
    `;
export type UpdateCreditAgreementDisplayNameMutationFnGQLType = Apollo.MutationFunction<UpdateCreditAgreementDisplayNameMutationGQLType, UpdateCreditAgreementDisplayNameMutationVariablesGQLType>;

/**
 * __useUpdateCreditAgreementDisplayNameMutation__
 *
 * To run a mutation, you first call `useUpdateCreditAgreementDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditAgreementDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditAgreementDisplayNameMutation, { data, loading, error }] = useUpdateCreditAgreementDisplayNameMutation({
 *   variables: {
 *      creditAgreementId: // value for 'creditAgreementId'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUpdateCreditAgreementDisplayNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditAgreementDisplayNameMutationGQLType, UpdateCreditAgreementDisplayNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditAgreementDisplayNameMutationGQLType, UpdateCreditAgreementDisplayNameMutationVariablesGQLType>(UpdateCreditAgreementDisplayNameDocumentGQLType, options);
      }
export type UpdateCreditAgreementDisplayNameMutationHookResult = ReturnType<typeof useUpdateCreditAgreementDisplayNameMutation>;
export type UpdateCreditAgreementDisplayNameMutationResultGQLType = Apollo.MutationResult<UpdateCreditAgreementDisplayNameMutationGQLType>;
export type UpdateCreditAgreementDisplayNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateCreditAgreementDisplayNameMutationGQLType, UpdateCreditAgreementDisplayNameMutationVariablesGQLType>;
export const UpdateUserSettingsDocumentGQLType = gql`
    mutation UpdateUserSettings($id: UUID!, $firstName: String!, $lastName: String!) {
  updateUserSettings(id: $id, firstName: $firstName, lastName: $lastName) {
    response
  }
}
    `;
export type UpdateUserSettingsMutationFnGQLType = Apollo.MutationFunction<UpdateUserSettingsMutationGQLType, UpdateUserSettingsMutationVariablesGQLType>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutationGQLType, UpdateUserSettingsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutationGQLType, UpdateUserSettingsMutationVariablesGQLType>(UpdateUserSettingsDocumentGQLType, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResultGQLType = Apollo.MutationResult<UpdateUserSettingsMutationGQLType>;
export type UpdateUserSettingsMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateUserSettingsMutationGQLType, UpdateUserSettingsMutationVariablesGQLType>;
export const GetActiveSlackInstallationsDocumentGQLType = gql`
    query getActiveSlackInstallations {
  activeSlackInstallations {
    id
    botToken
    botId
    botUserId
    botScopes
    userId
    incomingWebhookUrl
    incomingWebhookChannelId
    incomingWebhookChannelName
    incomingWebhookConfigurationUrl
    created_at
    updated_at
    isActive
    organizationId
    teamId
    teamName
    enterpriseId
    enterpriseName
    userToken
    userScopes
  }
}
    `;

/**
 * __useGetActiveSlackInstallationsQuery__
 *
 * To run a query within a React component, call `useGetActiveSlackInstallationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveSlackInstallationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveSlackInstallationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveSlackInstallationsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveSlackInstallationsQueryGQLType, GetActiveSlackInstallationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveSlackInstallationsQueryGQLType, GetActiveSlackInstallationsQueryVariablesGQLType>(GetActiveSlackInstallationsDocumentGQLType, options);
      }
export function useGetActiveSlackInstallationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveSlackInstallationsQueryGQLType, GetActiveSlackInstallationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveSlackInstallationsQueryGQLType, GetActiveSlackInstallationsQueryVariablesGQLType>(GetActiveSlackInstallationsDocumentGQLType, options);
        }
export type GetActiveSlackInstallationsQueryHookResult = ReturnType<typeof useGetActiveSlackInstallationsQuery>;
export type GetActiveSlackInstallationsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActiveSlackInstallationsLazyQueryGQLType>;
export type GetActiveSlackInstallationsQueryResultGQLType = Apollo.QueryResult<GetActiveSlackInstallationsQueryGQLType, GetActiveSlackInstallationsQueryVariablesGQLType>;
export const DeactivateSlackInstallationForChannelDocumentGQLType = gql`
    mutation deactivateSlackInstallationForChannel($teamId: String!, $incomingWebhookChannelId: String!, $organizationId: UUID!) {
  deactivateSlackInstallationForChannel(
    teamId: $teamId
    incomingWebhookChannelId: $incomingWebhookChannelId
    organizationId: $organizationId
  ) {
    response
  }
}
    `;
export type DeactivateSlackInstallationForChannelMutationFnGQLType = Apollo.MutationFunction<DeactivateSlackInstallationForChannelMutationGQLType, DeactivateSlackInstallationForChannelMutationVariablesGQLType>;

/**
 * __useDeactivateSlackInstallationForChannelMutation__
 *
 * To run a mutation, you first call `useDeactivateSlackInstallationForChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSlackInstallationForChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSlackInstallationForChannelMutation, { data, loading, error }] = useDeactivateSlackInstallationForChannelMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      incomingWebhookChannelId: // value for 'incomingWebhookChannelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeactivateSlackInstallationForChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateSlackInstallationForChannelMutationGQLType, DeactivateSlackInstallationForChannelMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateSlackInstallationForChannelMutationGQLType, DeactivateSlackInstallationForChannelMutationVariablesGQLType>(DeactivateSlackInstallationForChannelDocumentGQLType, options);
      }
export type DeactivateSlackInstallationForChannelMutationHookResult = ReturnType<typeof useDeactivateSlackInstallationForChannelMutation>;
export type DeactivateSlackInstallationForChannelMutationResultGQLType = Apollo.MutationResult<DeactivateSlackInstallationForChannelMutationGQLType>;
export type DeactivateSlackInstallationForChannelMutationOptionsGQLType = Apollo.BaseMutationOptions<DeactivateSlackInstallationForChannelMutationGQLType, DeactivateSlackInstallationForChannelMutationVariablesGQLType>;
export const DeactivateSlackInstallationsForOrganizationDocumentGQLType = gql`
    mutation deactivateSlackInstallationsForOrganization {
  deactivateSlackInstallationsForOrganization {
    response
  }
}
    `;
export type DeactivateSlackInstallationsForOrganizationMutationFnGQLType = Apollo.MutationFunction<DeactivateSlackInstallationsForOrganizationMutationGQLType, DeactivateSlackInstallationsForOrganizationMutationVariablesGQLType>;

/**
 * __useDeactivateSlackInstallationsForOrganizationMutation__
 *
 * To run a mutation, you first call `useDeactivateSlackInstallationsForOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSlackInstallationsForOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSlackInstallationsForOrganizationMutation, { data, loading, error }] = useDeactivateSlackInstallationsForOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateSlackInstallationsForOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateSlackInstallationsForOrganizationMutationGQLType, DeactivateSlackInstallationsForOrganizationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateSlackInstallationsForOrganizationMutationGQLType, DeactivateSlackInstallationsForOrganizationMutationVariablesGQLType>(DeactivateSlackInstallationsForOrganizationDocumentGQLType, options);
      }
export type DeactivateSlackInstallationsForOrganizationMutationHookResult = ReturnType<typeof useDeactivateSlackInstallationsForOrganizationMutation>;
export type DeactivateSlackInstallationsForOrganizationMutationResultGQLType = Apollo.MutationResult<DeactivateSlackInstallationsForOrganizationMutationGQLType>;
export type DeactivateSlackInstallationsForOrganizationMutationOptionsGQLType = Apollo.BaseMutationOptions<DeactivateSlackInstallationsForOrganizationMutationGQLType, DeactivateSlackInstallationsForOrganizationMutationVariablesGQLType>;
export const ReactivateSlackInstallationForChannelDocumentGQLType = gql`
    mutation reactivateSlackInstallationForChannel($teamId: String!, $incomingWebhookChannelId: String!, $organizationId: UUID!) {
  reactivateSlackInstallationForChannel(
    teamId: $teamId
    incomingWebhookChannelId: $incomingWebhookChannelId
    organizationId: $organizationId
  ) {
    response
  }
}
    `;
export type ReactivateSlackInstallationForChannelMutationFnGQLType = Apollo.MutationFunction<ReactivateSlackInstallationForChannelMutationGQLType, ReactivateSlackInstallationForChannelMutationVariablesGQLType>;

/**
 * __useReactivateSlackInstallationForChannelMutation__
 *
 * To run a mutation, you first call `useReactivateSlackInstallationForChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSlackInstallationForChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSlackInstallationForChannelMutation, { data, loading, error }] = useReactivateSlackInstallationForChannelMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      incomingWebhookChannelId: // value for 'incomingWebhookChannelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReactivateSlackInstallationForChannelMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSlackInstallationForChannelMutationGQLType, ReactivateSlackInstallationForChannelMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSlackInstallationForChannelMutationGQLType, ReactivateSlackInstallationForChannelMutationVariablesGQLType>(ReactivateSlackInstallationForChannelDocumentGQLType, options);
      }
export type ReactivateSlackInstallationForChannelMutationHookResult = ReturnType<typeof useReactivateSlackInstallationForChannelMutation>;
export type ReactivateSlackInstallationForChannelMutationResultGQLType = Apollo.MutationResult<ReactivateSlackInstallationForChannelMutationGQLType>;
export type ReactivateSlackInstallationForChannelMutationOptionsGQLType = Apollo.BaseMutationOptions<ReactivateSlackInstallationForChannelMutationGQLType, ReactivateSlackInstallationForChannelMutationVariablesGQLType>;
export const GetWebhookSubscriptionsForUserDocumentGQLType = gql`
    query GetWebhookSubscriptionsForUser {
  webhookSubscriptionsForUser {
    endpoint
    eventTypes
    svixApplicationId
    svixDashboardUrl
  }
}
    `;

/**
 * __useGetWebhookSubscriptionsForUserQuery__
 *
 * To run a query within a React component, call `useGetWebhookSubscriptionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookSubscriptionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookSubscriptionsForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebhookSubscriptionsForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetWebhookSubscriptionsForUserQueryGQLType, GetWebhookSubscriptionsForUserQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookSubscriptionsForUserQueryGQLType, GetWebhookSubscriptionsForUserQueryVariablesGQLType>(GetWebhookSubscriptionsForUserDocumentGQLType, options);
      }
export function useGetWebhookSubscriptionsForUserLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookSubscriptionsForUserQueryGQLType, GetWebhookSubscriptionsForUserQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookSubscriptionsForUserQueryGQLType, GetWebhookSubscriptionsForUserQueryVariablesGQLType>(GetWebhookSubscriptionsForUserDocumentGQLType, options);
        }
export type GetWebhookSubscriptionsForUserQueryHookResult = ReturnType<typeof useGetWebhookSubscriptionsForUserQuery>;
export type GetWebhookSubscriptionsForUserLazyQueryGQLTypeHookResult = ReturnType<typeof useGetWebhookSubscriptionsForUserLazyQueryGQLType>;
export type GetWebhookSubscriptionsForUserQueryResultGQLType = Apollo.QueryResult<GetWebhookSubscriptionsForUserQueryGQLType, GetWebhookSubscriptionsForUserQueryVariablesGQLType>;
export const GetAthenaTablesForOrganizationDocumentGQLType = gql`
    query GetAthenaTablesForOrganization($organizationId: String!, $creditFacilityIds: [String!], $tablePrefixes: [String!]) {
  athenaTables: getAthenaTablesForOrganization(
    organizationId: $organizationId
    creditFacilityIds: $creditFacilityIds
    tablePrefixes: $tablePrefixes
  ) {
    tableName
    properties {
      name
      type
    }
  }
}
    `;

/**
 * __useGetAthenaTablesForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAthenaTablesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaTablesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaTablesForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      tablePrefixes: // value for 'tablePrefixes'
 *   },
 * });
 */
export function useGetAthenaTablesForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>(GetAthenaTablesForOrganizationDocumentGQLType, options);
      }
export function useGetAthenaTablesForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>(GetAthenaTablesForOrganizationDocumentGQLType, options);
        }
export type GetAthenaTablesForOrganizationQueryHookResult = ReturnType<typeof useGetAthenaTablesForOrganizationQuery>;
export type GetAthenaTablesForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaTablesForOrganizationLazyQueryGQLType>;
export type GetAthenaTablesForOrganizationQueryResultGQLType = Apollo.QueryResult<GetAthenaTablesForOrganizationQueryGQLType, GetAthenaTablesForOrganizationQueryVariablesGQLType>;
export const GetAthenaQueryResponseByRawDocumentGQLType = gql`
    query GetAthenaQueryResponseByRaw($organizationId: String!, $query: String!, $bindings: [String!]!, $variables: [QueryVariable!]!) {
  athenaQueryResponse: getAthenaQueryResponseByRaw(
    organizationId: $organizationId
    query: $query
    bindings: $bindings
    variables: $variables
  ) {
    Items
    NextToken
    QueryExecutionId
  }
}
    `;

/**
 * __useGetAthenaQueryResponseByRawQuery__
 *
 * To run a query within a React component, call `useGetAthenaQueryResponseByRawQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaQueryResponseByRawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaQueryResponseByRawQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      bindings: // value for 'bindings'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useGetAthenaQueryResponseByRawQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>(GetAthenaQueryResponseByRawDocumentGQLType, options);
      }
export function useGetAthenaQueryResponseByRawLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>(GetAthenaQueryResponseByRawDocumentGQLType, options);
        }
export type GetAthenaQueryResponseByRawQueryHookResult = ReturnType<typeof useGetAthenaQueryResponseByRawQuery>;
export type GetAthenaQueryResponseByRawLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaQueryResponseByRawLazyQueryGQLType>;
export type GetAthenaQueryResponseByRawQueryResultGQLType = Apollo.QueryResult<GetAthenaQueryResponseByRawQueryGQLType, GetAthenaQueryResponseByRawQueryVariablesGQLType>;
export const ExecuteAthenaRecurringQueryByRawDocumentGQLType = gql`
    query ExecuteAthenaRecurringQueryByRaw($organizationId: String!, $globalRecurringDateConfigsString: String!, $globalRecurringDateConfigFields: [String!]!, $supplementalVariables: [QueryVariable!]!, $variables: [QueryVariable!]!, $bindings: [String!]!, $queryString: String!, $queryName: String!) {
  athenaRecurringQueryResponse: executeAthenaRecurringQueryByRaw(
    organizationId: $organizationId
    globalRecurringDateConfigsString: $globalRecurringDateConfigsString
    globalRecurringDateConfigFields: $globalRecurringDateConfigFields
    supplementalVariables: $supplementalVariables
    variables: $variables
    bindings: $bindings
    queryString: $queryString
    queryName: $queryName
  ) {
    items
    errors
  }
}
    `;

/**
 * __useExecuteAthenaRecurringQueryByRawQuery__
 *
 * To run a query within a React component, call `useExecuteAthenaRecurringQueryByRawQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteAthenaRecurringQueryByRawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteAthenaRecurringQueryByRawQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      globalRecurringDateConfigsString: // value for 'globalRecurringDateConfigsString'
 *      globalRecurringDateConfigFields: // value for 'globalRecurringDateConfigFields'
 *      supplementalVariables: // value for 'supplementalVariables'
 *      variables: // value for 'variables'
 *      bindings: // value for 'bindings'
 *      queryString: // value for 'queryString'
 *      queryName: // value for 'queryName'
 *   },
 * });
 */
export function useExecuteAthenaRecurringQueryByRawQuery(baseOptions: Apollo.QueryHookOptions<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>(ExecuteAthenaRecurringQueryByRawDocumentGQLType, options);
      }
export function useExecuteAthenaRecurringQueryByRawLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>(ExecuteAthenaRecurringQueryByRawDocumentGQLType, options);
        }
export type ExecuteAthenaRecurringQueryByRawQueryHookResult = ReturnType<typeof useExecuteAthenaRecurringQueryByRawQuery>;
export type ExecuteAthenaRecurringQueryByRawLazyQueryGQLTypeHookResult = ReturnType<typeof useExecuteAthenaRecurringQueryByRawLazyQueryGQLType>;
export type ExecuteAthenaRecurringQueryByRawQueryResultGQLType = Apollo.QueryResult<ExecuteAthenaRecurringQueryByRawQueryGQLType, ExecuteAthenaRecurringQueryByRawQueryVariablesGQLType>;
export const GetAttributeListByEntityDocumentGQLType = gql`
    query GetAttributeListByEntity($organizationId: UUID!, $listName: String!, $entityDomain: AttributeEntityDomain!, $entityIdentifier: UUID) {
  attributes: getAttributeListByEntity(
    organizationId: $organizationId
    listName: $listName
    entityDomain: $entityDomain
    entityIdentifier: $entityIdentifier
  ) {
    ...AttributeFragment
  }
}
    ${AttributeFragmentFragmentDocGQLType}`;

/**
 * __useGetAttributeListByEntityQuery__
 *
 * To run a query within a React component, call `useGetAttributeListByEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributeListByEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttributeListByEntityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      listName: // value for 'listName'
 *      entityDomain: // value for 'entityDomain'
 *      entityIdentifier: // value for 'entityIdentifier'
 *   },
 * });
 */
export function useGetAttributeListByEntityQuery(baseOptions: Apollo.QueryHookOptions<GetAttributeListByEntityQueryGQLType, GetAttributeListByEntityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttributeListByEntityQueryGQLType, GetAttributeListByEntityQueryVariablesGQLType>(GetAttributeListByEntityDocumentGQLType, options);
      }
export function useGetAttributeListByEntityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAttributeListByEntityQueryGQLType, GetAttributeListByEntityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttributeListByEntityQueryGQLType, GetAttributeListByEntityQueryVariablesGQLType>(GetAttributeListByEntityDocumentGQLType, options);
        }
export type GetAttributeListByEntityQueryHookResult = ReturnType<typeof useGetAttributeListByEntityQuery>;
export type GetAttributeListByEntityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAttributeListByEntityLazyQueryGQLType>;
export type GetAttributeListByEntityQueryResultGQLType = Apollo.QueryResult<GetAttributeListByEntityQueryGQLType, GetAttributeListByEntityQueryVariablesGQLType>;
export const CreateOrUpdateLatestAttributeValueDocumentGQLType = gql`
    mutation CreateOrUpdateLatestAttributeValue($input: CreateOrUpdateLatestAttributeValueInput!) {
  createOrUpdateLatestAttributeValue(input: $input) {
    response
  }
}
    `;
export type CreateOrUpdateLatestAttributeValueMutationFnGQLType = Apollo.MutationFunction<CreateOrUpdateLatestAttributeValueMutationGQLType, CreateOrUpdateLatestAttributeValueMutationVariablesGQLType>;

/**
 * __useCreateOrUpdateLatestAttributeValueMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateLatestAttributeValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateLatestAttributeValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateLatestAttributeValueMutation, { data, loading, error }] = useCreateOrUpdateLatestAttributeValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateLatestAttributeValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateLatestAttributeValueMutationGQLType, CreateOrUpdateLatestAttributeValueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateLatestAttributeValueMutationGQLType, CreateOrUpdateLatestAttributeValueMutationVariablesGQLType>(CreateOrUpdateLatestAttributeValueDocumentGQLType, options);
      }
export type CreateOrUpdateLatestAttributeValueMutationHookResult = ReturnType<typeof useCreateOrUpdateLatestAttributeValueMutation>;
export type CreateOrUpdateLatestAttributeValueMutationResultGQLType = Apollo.MutationResult<CreateOrUpdateLatestAttributeValueMutationGQLType>;
export type CreateOrUpdateLatestAttributeValueMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrUpdateLatestAttributeValueMutationGQLType, CreateOrUpdateLatestAttributeValueMutationVariablesGQLType>;
export const GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType = gql`
    query GetInstitutionAndConnectionDetailsForBorrowerId($borrowerId: UUID!) {
  institutionAndConnectionDetailsForBorrower(borrowerId: $borrowerId) {
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    organizations {
      id
      name
      slug
      type
    }
    tellerBankInstitutionId
    tellerBankInstitutionName
    tellerBankInstitutionKey
    tellerItemId
    tellerAccountId
    tellerAccountName
    tellerAccountMask
    plaidBankInstitutionId
    plaidBankInstitutionName
    plaidBankInstitutionKey
    plaidItemId
    plaidAccountId
    plaidAccountName
    plaidAccountMask
  }
}
    `;

/**
 * __useGetInstitutionAndConnectionDetailsForBorrowerIdQuery__
 *
 * To run a query within a React component, call `useGetInstitutionAndConnectionDetailsForBorrowerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionAndConnectionDetailsForBorrowerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionAndConnectionDetailsForBorrowerIdQuery({
 *   variables: {
 *      borrowerId: // value for 'borrowerId'
 *   },
 * });
 */
export function useGetInstitutionAndConnectionDetailsForBorrowerIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType, options);
      }
export function useGetInstitutionAndConnectionDetailsForBorrowerIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForBorrowerIdDocumentGQLType, options);
        }
export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForBorrowerIdQuery>;
export type GetInstitutionAndConnectionDetailsForBorrowerIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForBorrowerIdLazyQueryGQLType>;
export type GetInstitutionAndConnectionDetailsForBorrowerIdQueryResultGQLType = Apollo.QueryResult<GetInstitutionAndConnectionDetailsForBorrowerIdQueryGQLType, GetInstitutionAndConnectionDetailsForBorrowerIdQueryVariablesGQLType>;
export const GetInstitutionAndConnectionDetailsForImplementationIdDocumentGQLType = gql`
    query GetInstitutionAndConnectionDetailsForImplementationId($implementationId: UUID!) {
  institutionAndConnectionDetailsForImplementation(
    implementationId: $implementationId
  ) {
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    organizations {
      id
      name
      slug
      type
    }
    tellerBankInstitutionId
    tellerBankInstitutionName
    tellerBankInstitutionKey
    tellerItemId
    tellerAccountId
    tellerAccountName
    tellerAccountMask
    plaidBankInstitutionId
    plaidBankInstitutionName
    plaidBankInstitutionKey
    plaidItemId
    plaidAccountId
    plaidAccountName
    plaidAccountMask
  }
}
    `;

/**
 * __useGetInstitutionAndConnectionDetailsForImplementationIdQuery__
 *
 * To run a query within a React component, call `useGetInstitutionAndConnectionDetailsForImplementationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionAndConnectionDetailsForImplementationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionAndConnectionDetailsForImplementationIdQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetInstitutionAndConnectionDetailsForImplementationIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForImplementationIdDocumentGQLType, options);
      }
export function useGetInstitutionAndConnectionDetailsForImplementationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>(GetInstitutionAndConnectionDetailsForImplementationIdDocumentGQLType, options);
        }
export type GetInstitutionAndConnectionDetailsForImplementationIdQueryHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForImplementationIdQuery>;
export type GetInstitutionAndConnectionDetailsForImplementationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInstitutionAndConnectionDetailsForImplementationIdLazyQueryGQLType>;
export type GetInstitutionAndConnectionDetailsForImplementationIdQueryResultGQLType = Apollo.QueryResult<GetInstitutionAndConnectionDetailsForImplementationIdQueryGQLType, GetInstitutionAndConnectionDetailsForImplementationIdQueryVariablesGQLType>;
export const GetBankAccountsByCreditFacilityIdDocumentGQLType = gql`
    query GetBankAccountsByCreditFacilityId($organizationId: UUID!, $creditFacilityId: UUID!) {
  bankAccountsWithDesignationAndOwner(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
  ) {
    id
    accountNumber
    currencyCode
    name
    bankInstitutionId
    plaidAccountId
    tellerAccountId
    retrievedAt
    current
    available
    conversionRate
    routingNumber
    institutionName
    bankInstitutionKey
    organizationId
    ownerType
    accountType
    creditFacilityId
    ownerName
    connectionProviderName
    connectionProviderAccountMask
  }
}
    `;

/**
 * __useGetBankAccountsByCreditFacilityIdQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsByCreditFacilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsByCreditFacilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsByCreditFacilityIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetBankAccountsByCreditFacilityIdQuery(baseOptions: Apollo.QueryHookOptions<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>(GetBankAccountsByCreditFacilityIdDocumentGQLType, options);
      }
export function useGetBankAccountsByCreditFacilityIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>(GetBankAccountsByCreditFacilityIdDocumentGQLType, options);
        }
export type GetBankAccountsByCreditFacilityIdQueryHookResult = ReturnType<typeof useGetBankAccountsByCreditFacilityIdQuery>;
export type GetBankAccountsByCreditFacilityIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBankAccountsByCreditFacilityIdLazyQueryGQLType>;
export type GetBankAccountsByCreditFacilityIdQueryResultGQLType = Apollo.QueryResult<GetBankAccountsByCreditFacilityIdQueryGQLType, GetBankAccountsByCreditFacilityIdQueryVariablesGQLType>;
export const GetAllBankInstitutionsDocumentGQLType = gql`
    query GetAllBankInstitutions {
  allBankInstitutions {
    id
    name
    bankInstitutionKey
    tellerInstitutionId
    plaidInstitutionId
  }
}
    `;

/**
 * __useGetAllBankInstitutionsQuery__
 *
 * To run a query within a React component, call `useGetAllBankInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBankInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBankInstitutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBankInstitutionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>(GetAllBankInstitutionsDocumentGQLType, options);
      }
export function useGetAllBankInstitutionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>(GetAllBankInstitutionsDocumentGQLType, options);
        }
export type GetAllBankInstitutionsQueryHookResult = ReturnType<typeof useGetAllBankInstitutionsQuery>;
export type GetAllBankInstitutionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllBankInstitutionsLazyQueryGQLType>;
export type GetAllBankInstitutionsQueryResultGQLType = Apollo.QueryResult<GetAllBankInstitutionsQueryGQLType, GetAllBankInstitutionsQueryVariablesGQLType>;
export const GetBankAccountsWithInstitutionAndOwnerByImplementationIdDocumentGQLType = gql`
    query getBankAccountsWithInstitutionAndOwnerByImplementationId($implementationId: UUID!, $maskSensitiveInfo: Boolean) {
  implementation(implementationId: $implementationId) {
    bankAccountsWithInstitutionAndOwner(maskSensitiveInfo: $maskSensitiveInfo) {
      ...BankAccountWithInstitutionAndOwner
    }
  }
}
    ${BankAccountWithInstitutionAndOwnerFragmentDocGQLType}`;

/**
 * __useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      maskSensitiveInfo: // value for 'maskSensitiveInfo'
 *   },
 * });
 */
export function useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery(baseOptions: Apollo.QueryHookOptions<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>(GetBankAccountsWithInstitutionAndOwnerByImplementationIdDocumentGQLType, options);
      }
export function useGetBankAccountsWithInstitutionAndOwnerByImplementationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>(GetBankAccountsWithInstitutionAndOwnerByImplementationIdDocumentGQLType, options);
        }
export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryHookResult = ReturnType<typeof useGetBankAccountsWithInstitutionAndOwnerByImplementationIdQuery>;
export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBankAccountsWithInstitutionAndOwnerByImplementationIdLazyQueryGQLType>;
export type GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryResultGQLType = Apollo.QueryResult<GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryGQLType, GetBankAccountsWithInstitutionAndOwnerByImplementationIdQueryVariablesGQLType>;
export const AddBankAccountDocumentGQLType = gql`
    mutation AddBankAccount($bankInstitutionId: UUID!, $accountName: String!, $accountNumber: String!, $routingNumber: String!, $implementationId: UUID!, $ownerId: UUID!, $plaidAccountId: String, $tellerAccountId: String) {
  addBankAccount(
    bankInstitutionId: $bankInstitutionId
    accountName: $accountName
    accountNumber: $accountNumber
    routingNumber: $routingNumber
    implementationId: $implementationId
    ownerId: $ownerId
    plaidAccountId: $plaidAccountId
    tellerAccountId: $tellerAccountId
  ) {
    response
  }
}
    `;
export type AddBankAccountMutationFnGQLType = Apollo.MutationFunction<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>;

/**
 * __useAddBankAccountMutation__
 *
 * To run a mutation, you first call `useAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankAccountMutation, { data, loading, error }] = useAddBankAccountMutation({
 *   variables: {
 *      bankInstitutionId: // value for 'bankInstitutionId'
 *      accountName: // value for 'accountName'
 *      accountNumber: // value for 'accountNumber'
 *      routingNumber: // value for 'routingNumber'
 *      implementationId: // value for 'implementationId'
 *      ownerId: // value for 'ownerId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *      tellerAccountId: // value for 'tellerAccountId'
 *   },
 * });
 */
export function useAddBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>(AddBankAccountDocumentGQLType, options);
      }
export type AddBankAccountMutationHookResult = ReturnType<typeof useAddBankAccountMutation>;
export type AddBankAccountMutationResultGQLType = Apollo.MutationResult<AddBankAccountMutationGQLType>;
export type AddBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<AddBankAccountMutationGQLType, AddBankAccountMutationVariablesGQLType>;
export const EditBankAccountDocumentGQLType = gql`
    mutation EditBankAccount($bankAccountId: UUID!, $accountName: String!, $ownerId: UUID!, $plaidAccountId: String, $tellerAccountId: String) {
  editBankAccount(
    bankAccountId: $bankAccountId
    accountName: $accountName
    ownerId: $ownerId
    plaidAccountId: $plaidAccountId
    tellerAccountId: $tellerAccountId
  ) {
    response
  }
}
    `;
export type EditBankAccountMutationFnGQLType = Apollo.MutationFunction<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>;

/**
 * __useEditBankAccountMutation__
 *
 * To run a mutation, you first call `useEditBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBankAccountMutation, { data, loading, error }] = useEditBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *      accountName: // value for 'accountName'
 *      ownerId: // value for 'ownerId'
 *      plaidAccountId: // value for 'plaidAccountId'
 *      tellerAccountId: // value for 'tellerAccountId'
 *   },
 * });
 */
export function useEditBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>(EditBankAccountDocumentGQLType, options);
      }
export type EditBankAccountMutationHookResult = ReturnType<typeof useEditBankAccountMutation>;
export type EditBankAccountMutationResultGQLType = Apollo.MutationResult<EditBankAccountMutationGQLType>;
export type EditBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<EditBankAccountMutationGQLType, EditBankAccountMutationVariablesGQLType>;
export const DeactivateBankAccountDocumentGQLType = gql`
    mutation DeactivateBankAccount($bankAccountId: UUID!) {
  deactivateBankAccount(bankAccountId: $bankAccountId) {
    response
  }
}
    `;
export type DeactivateBankAccountMutationFnGQLType = Apollo.MutationFunction<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>;

/**
 * __useDeactivateBankAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateBankAccountMutation, { data, loading, error }] = useDeactivateBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useDeactivateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>(DeactivateBankAccountDocumentGQLType, options);
      }
export type DeactivateBankAccountMutationHookResult = ReturnType<typeof useDeactivateBankAccountMutation>;
export type DeactivateBankAccountMutationResultGQLType = Apollo.MutationResult<DeactivateBankAccountMutationGQLType>;
export type DeactivateBankAccountMutationOptionsGQLType = Apollo.BaseMutationOptions<DeactivateBankAccountMutationGQLType, DeactivateBankAccountMutationVariablesGQLType>;
export const GetLatestBorrowingBaseReportDocumentGQLType = gql`
    query GetLatestBorrowingBaseReport($creditFacilityId: UUID!) {
  latestBorrowingBaseReport(creditFacilityId: $creditFacilityId) {
    ...BorrowingBaseReport
    concentrationLimitCalculations {
      id
      borrowingBaseReportId
      concentrationLimitKey
      concentrationLimit
      concentrationAmount
      totalEligibleExposure
      concentration
      borrowingBaseReduction
      complianceStatus
      created_at
    }
  }
}
    ${BorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetLatestBorrowingBaseReportQuery__
 *
 * To run a query within a React component, call `useGetLatestBorrowingBaseReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestBorrowingBaseReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestBorrowingBaseReportQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLatestBorrowingBaseReportQuery(baseOptions: Apollo.QueryHookOptions<GetLatestBorrowingBaseReportQueryGQLType, GetLatestBorrowingBaseReportQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestBorrowingBaseReportQueryGQLType, GetLatestBorrowingBaseReportQueryVariablesGQLType>(GetLatestBorrowingBaseReportDocumentGQLType, options);
      }
export function useGetLatestBorrowingBaseReportLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestBorrowingBaseReportQueryGQLType, GetLatestBorrowingBaseReportQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestBorrowingBaseReportQueryGQLType, GetLatestBorrowingBaseReportQueryVariablesGQLType>(GetLatestBorrowingBaseReportDocumentGQLType, options);
        }
export type GetLatestBorrowingBaseReportQueryHookResult = ReturnType<typeof useGetLatestBorrowingBaseReportQuery>;
export type GetLatestBorrowingBaseReportLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestBorrowingBaseReportLazyQueryGQLType>;
export type GetLatestBorrowingBaseReportQueryResultGQLType = Apollo.QueryResult<GetLatestBorrowingBaseReportQueryGQLType, GetLatestBorrowingBaseReportQueryVariablesGQLType>;
export const GetLatestBorrowingBaseReportsDocumentGQLType = gql`
    query GetLatestBorrowingBaseReports($creditFacilityIds: [UUID!]!) {
  latestBorrowingBaseReports(creditFacilityIds: $creditFacilityIds) {
    ...BorrowingBaseReport
  }
}
    ${BorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetLatestBorrowingBaseReportsQuery__
 *
 * To run a query within a React component, call `useGetLatestBorrowingBaseReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestBorrowingBaseReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestBorrowingBaseReportsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetLatestBorrowingBaseReportsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestBorrowingBaseReportsQueryGQLType, GetLatestBorrowingBaseReportsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestBorrowingBaseReportsQueryGQLType, GetLatestBorrowingBaseReportsQueryVariablesGQLType>(GetLatestBorrowingBaseReportsDocumentGQLType, options);
      }
export function useGetLatestBorrowingBaseReportsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestBorrowingBaseReportsQueryGQLType, GetLatestBorrowingBaseReportsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestBorrowingBaseReportsQueryGQLType, GetLatestBorrowingBaseReportsQueryVariablesGQLType>(GetLatestBorrowingBaseReportsDocumentGQLType, options);
        }
export type GetLatestBorrowingBaseReportsQueryHookResult = ReturnType<typeof useGetLatestBorrowingBaseReportsQuery>;
export type GetLatestBorrowingBaseReportsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestBorrowingBaseReportsLazyQueryGQLType>;
export type GetLatestBorrowingBaseReportsQueryResultGQLType = Apollo.QueryResult<GetLatestBorrowingBaseReportsQueryGQLType, GetLatestBorrowingBaseReportsQueryVariablesGQLType>;
export const GetBorrowingBaseReportsDocumentGQLType = gql`
    query GetBorrowingBaseReports($creditFacilityId: UUID!, $startReportingDate: String, $endReportingDate: String) {
  borrowingBaseReports(
    creditFacilityId: $creditFacilityId
    startReportingDate: $startReportingDate
    endReportingDate: $endReportingDate
  ) {
    ...BorrowingBaseReport
    concentrationLimitCalculations {
      ...ConcentrationLimitCalculation
    }
    eligibilityCriteriaCalculations {
      ...EligibilityCriteriaCalculation
    }
    bankAccountCashBalances {
      ...BankAccountCashBalance
    }
    loanProductCalculations {
      ...BorrowingBaseReportLoanProductCalculation
    }
  }
}
    ${BorrowingBaseReportFragmentDocGQLType}
${ConcentrationLimitCalculationFragmentDocGQLType}
${EligibilityCriteriaCalculationFragmentDocGQLType}
${BankAccountCashBalanceFragmentDocGQLType}
${BorrowingBaseReportLoanProductCalculationFragmentDocGQLType}`;

/**
 * __useGetBorrowingBaseReportsQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBaseReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBaseReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBaseReportsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startReportingDate: // value for 'startReportingDate'
 *      endReportingDate: // value for 'endReportingDate'
 *   },
 * });
 */
export function useGetBorrowingBaseReportsQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowingBaseReportsQueryGQLType, GetBorrowingBaseReportsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBaseReportsQueryGQLType, GetBorrowingBaseReportsQueryVariablesGQLType>(GetBorrowingBaseReportsDocumentGQLType, options);
      }
export function useGetBorrowingBaseReportsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBaseReportsQueryGQLType, GetBorrowingBaseReportsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBaseReportsQueryGQLType, GetBorrowingBaseReportsQueryVariablesGQLType>(GetBorrowingBaseReportsDocumentGQLType, options);
        }
export type GetBorrowingBaseReportsQueryHookResult = ReturnType<typeof useGetBorrowingBaseReportsQuery>;
export type GetBorrowingBaseReportsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBaseReportsLazyQueryGQLType>;
export type GetBorrowingBaseReportsQueryResultGQLType = Apollo.QueryResult<GetBorrowingBaseReportsQueryGQLType, GetBorrowingBaseReportsQueryVariablesGQLType>;
export const GetBorrowingBaseReportDocumentGQLType = gql`
    query GetBorrowingBaseReport($borrowingBaseReportId: UUID!) {
  borrowingBaseReport(borrowingBaseReportId: $borrowingBaseReportId) {
    ...BorrowingBaseReport
    concentrationLimitCalculations {
      ...ConcentrationLimitCalculation
    }
    eligibilityCriteriaCalculations {
      ...EligibilityCriteriaCalculation
    }
    bankAccountCashBalances {
      ...BankAccountCashBalance
    }
    loanProductCalculations {
      ...BorrowingBaseReportLoanProductCalculation
    }
  }
}
    ${BorrowingBaseReportFragmentDocGQLType}
${ConcentrationLimitCalculationFragmentDocGQLType}
${EligibilityCriteriaCalculationFragmentDocGQLType}
${BankAccountCashBalanceFragmentDocGQLType}
${BorrowingBaseReportLoanProductCalculationFragmentDocGQLType}`;

/**
 * __useGetBorrowingBaseReportQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBaseReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBaseReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBaseReportQuery({
 *   variables: {
 *      borrowingBaseReportId: // value for 'borrowingBaseReportId'
 *   },
 * });
 */
export function useGetBorrowingBaseReportQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowingBaseReportQueryGQLType, GetBorrowingBaseReportQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBaseReportQueryGQLType, GetBorrowingBaseReportQueryVariablesGQLType>(GetBorrowingBaseReportDocumentGQLType, options);
      }
export function useGetBorrowingBaseReportLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBaseReportQueryGQLType, GetBorrowingBaseReportQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBaseReportQueryGQLType, GetBorrowingBaseReportQueryVariablesGQLType>(GetBorrowingBaseReportDocumentGQLType, options);
        }
export type GetBorrowingBaseReportQueryHookResult = ReturnType<typeof useGetBorrowingBaseReportQuery>;
export type GetBorrowingBaseReportLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBaseReportLazyQueryGQLType>;
export type GetBorrowingBaseReportQueryResultGQLType = Apollo.QueryResult<GetBorrowingBaseReportQueryGQLType, GetBorrowingBaseReportQueryVariablesGQLType>;
export const GetExtendedResponseTapeDownloadUrlDocumentGQLType = gql`
    query GetExtendedResponseTapeDownloadUrl($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Float!, $loanProductId: UUID!) {
  getExtendedResponseTapeDownloadUrl(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    loanProductId: $loanProductId
  )
}
    `;

/**
 * __useGetExtendedResponseTapeDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetExtendedResponseTapeDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtendedResponseTapeDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtendedResponseTapeDownloadUrlQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      loanProductId: // value for 'loanProductId'
 *   },
 * });
 */
export function useGetExtendedResponseTapeDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetExtendedResponseTapeDownloadUrlQueryGQLType, GetExtendedResponseTapeDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtendedResponseTapeDownloadUrlQueryGQLType, GetExtendedResponseTapeDownloadUrlQueryVariablesGQLType>(GetExtendedResponseTapeDownloadUrlDocumentGQLType, options);
      }
export function useGetExtendedResponseTapeDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetExtendedResponseTapeDownloadUrlQueryGQLType, GetExtendedResponseTapeDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtendedResponseTapeDownloadUrlQueryGQLType, GetExtendedResponseTapeDownloadUrlQueryVariablesGQLType>(GetExtendedResponseTapeDownloadUrlDocumentGQLType, options);
        }
export type GetExtendedResponseTapeDownloadUrlQueryHookResult = ReturnType<typeof useGetExtendedResponseTapeDownloadUrlQuery>;
export type GetExtendedResponseTapeDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetExtendedResponseTapeDownloadUrlLazyQueryGQLType>;
export type GetExtendedResponseTapeDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetExtendedResponseTapeDownloadUrlQueryGQLType, GetExtendedResponseTapeDownloadUrlQueryVariablesGQLType>;
export const GetReceivableWaiversForReceivableIdsDocumentGQLType = gql`
    query GetReceivableWaiversForReceivableIds($creditFacilityId: UUID!, $reportingDate: FullDateStr, $receivableIds: [UUID!]!) {
  receivableWaiversForReceivableIds(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    receivableIds: $receivableIds
  ) {
    ...ReceivableBorrowingBaseTestWaiver
  }
}
    ${ReceivableBorrowingBaseTestWaiverFragmentDocGQLType}`;

/**
 * __useGetReceivableWaiversForReceivableIdsQuery__
 *
 * To run a query within a React component, call `useGetReceivableWaiversForReceivableIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivableWaiversForReceivableIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivableWaiversForReceivableIdsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      receivableIds: // value for 'receivableIds'
 *   },
 * });
 */
export function useGetReceivableWaiversForReceivableIdsQuery(baseOptions: Apollo.QueryHookOptions<GetReceivableWaiversForReceivableIdsQueryGQLType, GetReceivableWaiversForReceivableIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivableWaiversForReceivableIdsQueryGQLType, GetReceivableWaiversForReceivableIdsQueryVariablesGQLType>(GetReceivableWaiversForReceivableIdsDocumentGQLType, options);
      }
export function useGetReceivableWaiversForReceivableIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivableWaiversForReceivableIdsQueryGQLType, GetReceivableWaiversForReceivableIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivableWaiversForReceivableIdsQueryGQLType, GetReceivableWaiversForReceivableIdsQueryVariablesGQLType>(GetReceivableWaiversForReceivableIdsDocumentGQLType, options);
        }
export type GetReceivableWaiversForReceivableIdsQueryHookResult = ReturnType<typeof useGetReceivableWaiversForReceivableIdsQuery>;
export type GetReceivableWaiversForReceivableIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReceivableWaiversForReceivableIdsLazyQueryGQLType>;
export type GetReceivableWaiversForReceivableIdsQueryResultGQLType = Apollo.QueryResult<GetReceivableWaiversForReceivableIdsQueryGQLType, GetReceivableWaiversForReceivableIdsQueryVariablesGQLType>;
export const GetReceivableWaiversForCreditFacilityWithOrganizationDocumentGQLType = gql`
    query GetReceivableWaiversForCreditFacilityWithOrganization($creditFacilityId: UUID!, $reportingDate: FullDateStr) {
  receivableWaiversForCreditFacilityWithOrganization(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
  ) {
    ...ReceivableBorrowingBaseTestWaiver
  }
}
    ${ReceivableBorrowingBaseTestWaiverFragmentDocGQLType}`;

/**
 * __useGetReceivableWaiversForCreditFacilityWithOrganizationQuery__
 *
 * To run a query within a React component, call `useGetReceivableWaiversForCreditFacilityWithOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivableWaiversForCreditFacilityWithOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivableWaiversForCreditFacilityWithOrganizationQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *   },
 * });
 */
export function useGetReceivableWaiversForCreditFacilityWithOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetReceivableWaiversForCreditFacilityWithOrganizationQueryGQLType, GetReceivableWaiversForCreditFacilityWithOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivableWaiversForCreditFacilityWithOrganizationQueryGQLType, GetReceivableWaiversForCreditFacilityWithOrganizationQueryVariablesGQLType>(GetReceivableWaiversForCreditFacilityWithOrganizationDocumentGQLType, options);
      }
export function useGetReceivableWaiversForCreditFacilityWithOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivableWaiversForCreditFacilityWithOrganizationQueryGQLType, GetReceivableWaiversForCreditFacilityWithOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivableWaiversForCreditFacilityWithOrganizationQueryGQLType, GetReceivableWaiversForCreditFacilityWithOrganizationQueryVariablesGQLType>(GetReceivableWaiversForCreditFacilityWithOrganizationDocumentGQLType, options);
        }
export type GetReceivableWaiversForCreditFacilityWithOrganizationQueryHookResult = ReturnType<typeof useGetReceivableWaiversForCreditFacilityWithOrganizationQuery>;
export type GetReceivableWaiversForCreditFacilityWithOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReceivableWaiversForCreditFacilityWithOrganizationLazyQueryGQLType>;
export type GetReceivableWaiversForCreditFacilityWithOrganizationQueryResultGQLType = Apollo.QueryResult<GetReceivableWaiversForCreditFacilityWithOrganizationQueryGQLType, GetReceivableWaiversForCreditFacilityWithOrganizationQueryVariablesGQLType>;
export const UpdateReceivableWaiversDocumentGQLType = gql`
    mutation UpdateReceivableWaivers($creditFacilityId: UUID!, $receivableWaivers: [ReceivableBorrowingBaseTestWaiverInput!]!) {
  updateReceivableWaivers(
    creditFacilityId: $creditFacilityId
    receivableWaivers: $receivableWaivers
  ) {
    response
  }
}
    `;
export type UpdateReceivableWaiversMutationFnGQLType = Apollo.MutationFunction<UpdateReceivableWaiversMutationGQLType, UpdateReceivableWaiversMutationVariablesGQLType>;

/**
 * __useUpdateReceivableWaiversMutation__
 *
 * To run a mutation, you first call `useUpdateReceivableWaiversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReceivableWaiversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReceivableWaiversMutation, { data, loading, error }] = useUpdateReceivableWaiversMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      receivableWaivers: // value for 'receivableWaivers'
 *   },
 * });
 */
export function useUpdateReceivableWaiversMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReceivableWaiversMutationGQLType, UpdateReceivableWaiversMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReceivableWaiversMutationGQLType, UpdateReceivableWaiversMutationVariablesGQLType>(UpdateReceivableWaiversDocumentGQLType, options);
      }
export type UpdateReceivableWaiversMutationHookResult = ReturnType<typeof useUpdateReceivableWaiversMutation>;
export type UpdateReceivableWaiversMutationResultGQLType = Apollo.MutationResult<UpdateReceivableWaiversMutationGQLType>;
export type UpdateReceivableWaiversMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateReceivableWaiversMutationGQLType, UpdateReceivableWaiversMutationVariablesGQLType>;
export const DeleteReceivableWaiversDocumentGQLType = gql`
    mutation DeleteReceivableWaivers($creditFacilityId: UUID!, $receivableWaivers: [ReceivableBorrowingBaseTestWaiverInput!]!) {
  deleteReceivableWaivers(
    creditFacilityId: $creditFacilityId
    receivableWaivers: $receivableWaivers
  ) {
    response
  }
}
    `;
export type DeleteReceivableWaiversMutationFnGQLType = Apollo.MutationFunction<DeleteReceivableWaiversMutationGQLType, DeleteReceivableWaiversMutationVariablesGQLType>;

/**
 * __useDeleteReceivableWaiversMutation__
 *
 * To run a mutation, you first call `useDeleteReceivableWaiversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReceivableWaiversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReceivableWaiversMutation, { data, loading, error }] = useDeleteReceivableWaiversMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      receivableWaivers: // value for 'receivableWaivers'
 *   },
 * });
 */
export function useDeleteReceivableWaiversMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReceivableWaiversMutationGQLType, DeleteReceivableWaiversMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReceivableWaiversMutationGQLType, DeleteReceivableWaiversMutationVariablesGQLType>(DeleteReceivableWaiversDocumentGQLType, options);
      }
export type DeleteReceivableWaiversMutationHookResult = ReturnType<typeof useDeleteReceivableWaiversMutation>;
export type DeleteReceivableWaiversMutationResultGQLType = Apollo.MutationResult<DeleteReceivableWaiversMutationGQLType>;
export type DeleteReceivableWaiversMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteReceivableWaiversMutationGQLType, DeleteReceivableWaiversMutationVariablesGQLType>;
export const GetFinancialCovenantCalculationsDocumentGQLType = gql`
    query GetFinancialCovenantCalculations($creditFacilityId: UUID!, $startDate: JSDate!, $endDate: JSDate!) {
  financialCovenantCalculations(
    creditFacilityId: $creditFacilityId
    startDate: $startDate
    endDate: $endDate
  ) {
    config {
      name
      key
      valueType
      limitType
      limitValue
    }
    financialCovenantsCalculations {
      id
      creditFacilityId
      reportingDate
      covenantKey
      covenantType
      limitValue
      limitType
      value
    }
  }
}
    `;

/**
 * __useGetFinancialCovenantCalculationsQuery__
 *
 * To run a query within a React component, call `useGetFinancialCovenantCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialCovenantCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialCovenantCalculationsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetFinancialCovenantCalculationsQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialCovenantCalculationsQueryGQLType, GetFinancialCovenantCalculationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialCovenantCalculationsQueryGQLType, GetFinancialCovenantCalculationsQueryVariablesGQLType>(GetFinancialCovenantCalculationsDocumentGQLType, options);
      }
export function useGetFinancialCovenantCalculationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialCovenantCalculationsQueryGQLType, GetFinancialCovenantCalculationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialCovenantCalculationsQueryGQLType, GetFinancialCovenantCalculationsQueryVariablesGQLType>(GetFinancialCovenantCalculationsDocumentGQLType, options);
        }
export type GetFinancialCovenantCalculationsQueryHookResult = ReturnType<typeof useGetFinancialCovenantCalculationsQuery>;
export type GetFinancialCovenantCalculationsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinancialCovenantCalculationsLazyQueryGQLType>;
export type GetFinancialCovenantCalculationsQueryResultGQLType = Apollo.QueryResult<GetFinancialCovenantCalculationsQueryGQLType, GetFinancialCovenantCalculationsQueryVariablesGQLType>;
export const GetSuccessPortfolioCovenantsByCreditFacilityIdDocumentGQLType = gql`
    query GetSuccessPortfolioCovenantsByCreditFacilityId($creditFacilityId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr, $mode: PortfolioCovenantWorkleaseMode!) {
  getSuccessPortfolioCovenantsByCreditFacilityId(
    creditFacilityId: $creditFacilityId
    startDate: $startDate
    endDate: $endDate
    mode: $mode
  ) {
    ...SuccessPortfolioCovenant
  }
}
    ${SuccessPortfolioCovenantFragmentDocGQLType}`;

/**
 * __useGetSuccessPortfolioCovenantsByCreditFacilityIdQuery__
 *
 * To run a query within a React component, call `useGetSuccessPortfolioCovenantsByCreditFacilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessPortfolioCovenantsByCreditFacilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessPortfolioCovenantsByCreditFacilityIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetSuccessPortfolioCovenantsByCreditFacilityIdQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessPortfolioCovenantsByCreditFacilityIdQueryGQLType, GetSuccessPortfolioCovenantsByCreditFacilityIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessPortfolioCovenantsByCreditFacilityIdQueryGQLType, GetSuccessPortfolioCovenantsByCreditFacilityIdQueryVariablesGQLType>(GetSuccessPortfolioCovenantsByCreditFacilityIdDocumentGQLType, options);
      }
export function useGetSuccessPortfolioCovenantsByCreditFacilityIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessPortfolioCovenantsByCreditFacilityIdQueryGQLType, GetSuccessPortfolioCovenantsByCreditFacilityIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessPortfolioCovenantsByCreditFacilityIdQueryGQLType, GetSuccessPortfolioCovenantsByCreditFacilityIdQueryVariablesGQLType>(GetSuccessPortfolioCovenantsByCreditFacilityIdDocumentGQLType, options);
        }
export type GetSuccessPortfolioCovenantsByCreditFacilityIdQueryHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantsByCreditFacilityIdQuery>;
export type GetSuccessPortfolioCovenantsByCreditFacilityIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantsByCreditFacilityIdLazyQueryGQLType>;
export type GetSuccessPortfolioCovenantsByCreditFacilityIdQueryResultGQLType = Apollo.QueryResult<GetSuccessPortfolioCovenantsByCreditFacilityIdQueryGQLType, GetSuccessPortfolioCovenantsByCreditFacilityIdQueryVariablesGQLType>;
export const GetSuccessPortfolioCovenantsByKeyDocumentGQLType = gql`
    query GetSuccessPortfolioCovenantsByKey($creditFacilityId: UUID!, $covenantKey: String!, $start: FullDateStr, $end: FullDateStr, $mode: PortfolioCovenantWorkleaseMode!) {
  getSuccessPortfolioCovenantsByKey(
    creditFacilityId: $creditFacilityId
    covenantKey: $covenantKey
    start: $start
    end: $end
    mode: $mode
  ) {
    ...SuccessPortfolioCovenant
  }
}
    ${SuccessPortfolioCovenantFragmentDocGQLType}`;

/**
 * __useGetSuccessPortfolioCovenantsByKeyQuery__
 *
 * To run a query within a React component, call `useGetSuccessPortfolioCovenantsByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessPortfolioCovenantsByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessPortfolioCovenantsByKeyQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      covenantKey: // value for 'covenantKey'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetSuccessPortfolioCovenantsByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessPortfolioCovenantsByKeyQueryGQLType, GetSuccessPortfolioCovenantsByKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessPortfolioCovenantsByKeyQueryGQLType, GetSuccessPortfolioCovenantsByKeyQueryVariablesGQLType>(GetSuccessPortfolioCovenantsByKeyDocumentGQLType, options);
      }
export function useGetSuccessPortfolioCovenantsByKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessPortfolioCovenantsByKeyQueryGQLType, GetSuccessPortfolioCovenantsByKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessPortfolioCovenantsByKeyQueryGQLType, GetSuccessPortfolioCovenantsByKeyQueryVariablesGQLType>(GetSuccessPortfolioCovenantsByKeyDocumentGQLType, options);
        }
export type GetSuccessPortfolioCovenantsByKeyQueryHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantsByKeyQuery>;
export type GetSuccessPortfolioCovenantsByKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantsByKeyLazyQueryGQLType>;
export type GetSuccessPortfolioCovenantsByKeyQueryResultGQLType = Apollo.QueryResult<GetSuccessPortfolioCovenantsByKeyQueryGQLType, GetSuccessPortfolioCovenantsByKeyQueryVariablesGQLType>;
export const GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdDocumentGQLType = gql`
    query GetSuccessPortfolioCovenantsByKeyAndCreditAgreementId($creditFacilityId: UUID!, $creditAgreementId: UUID!, $covenantKey: String!, $start: FullDateStr, $end: FullDateStr, $mode: PortfolioCovenantWorkleaseMode!) {
  getSuccessPortfolioCovenantsByKeyAndCreditAgreementId(
    creditFacilityId: $creditFacilityId
    creditAgreementId: $creditAgreementId
    covenantKey: $covenantKey
    start: $start
    end: $end
    mode: $mode
  ) {
    ...SuccessPortfolioCovenant
  }
}
    ${SuccessPortfolioCovenantFragmentDocGQLType}`;

/**
 * __useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQuery__
 *
 * To run a query within a React component, call `useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      creditAgreementId: // value for 'creditAgreementId'
 *      covenantKey: // value for 'covenantKey'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryGQLType, GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryGQLType, GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryVariablesGQLType>(GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdDocumentGQLType, options);
      }
export function useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryGQLType, GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryGQLType, GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryVariablesGQLType>(GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdDocumentGQLType, options);
        }
export type GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQuery>;
export type GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdLazyQueryGQLType>;
export type GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryResultGQLType = Apollo.QueryResult<GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryGQLType, GetSuccessPortfolioCovenantsByKeyAndCreditAgreementIdQueryVariablesGQLType>;
export const GetSuccessPortfolioCovenantByIdDocumentGQLType = gql`
    query GetSuccessPortfolioCovenantById($portfolioCovenantId: UUID!) {
  getSuccessPortfolioCovenantById(portfolioCovenantId: $portfolioCovenantId) {
    ...SuccessPortfolioCovenant
  }
}
    ${SuccessPortfolioCovenantFragmentDocGQLType}`;

/**
 * __useGetSuccessPortfolioCovenantByIdQuery__
 *
 * To run a query within a React component, call `useGetSuccessPortfolioCovenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessPortfolioCovenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessPortfolioCovenantByIdQuery({
 *   variables: {
 *      portfolioCovenantId: // value for 'portfolioCovenantId'
 *   },
 * });
 */
export function useGetSuccessPortfolioCovenantByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessPortfolioCovenantByIdQueryGQLType, GetSuccessPortfolioCovenantByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessPortfolioCovenantByIdQueryGQLType, GetSuccessPortfolioCovenantByIdQueryVariablesGQLType>(GetSuccessPortfolioCovenantByIdDocumentGQLType, options);
      }
export function useGetSuccessPortfolioCovenantByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessPortfolioCovenantByIdQueryGQLType, GetSuccessPortfolioCovenantByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessPortfolioCovenantByIdQueryGQLType, GetSuccessPortfolioCovenantByIdQueryVariablesGQLType>(GetSuccessPortfolioCovenantByIdDocumentGQLType, options);
        }
export type GetSuccessPortfolioCovenantByIdQueryHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantByIdQuery>;
export type GetSuccessPortfolioCovenantByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSuccessPortfolioCovenantByIdLazyQueryGQLType>;
export type GetSuccessPortfolioCovenantByIdQueryResultGQLType = Apollo.QueryResult<GetSuccessPortfolioCovenantByIdQueryGQLType, GetSuccessPortfolioCovenantByIdQueryVariablesGQLType>;
export const GetPortfolioCovenantByIdDocumentGQLType = gql`
    query GetPortfolioCovenantById($portfolioCovenantId: UUID!) {
  getPortfolioCovenantById(portfolioCovenantId: $portfolioCovenantId) {
    ... on SuccessPortfolioCovenant {
      ...SuccessPortfolioCovenant
    }
    ... on ErrorPortfolioCovenant {
      id
      creditFacilityId
      creditAgreementId
      covenantKey
      triggerDate
      status
      metadata {
        errors
      }
      created_at
      updated_at
    }
  }
}
    ${SuccessPortfolioCovenantFragmentDocGQLType}`;

/**
 * __useGetPortfolioCovenantByIdQuery__
 *
 * To run a query within a React component, call `useGetPortfolioCovenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioCovenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioCovenantByIdQuery({
 *   variables: {
 *      portfolioCovenantId: // value for 'portfolioCovenantId'
 *   },
 * });
 */
export function useGetPortfolioCovenantByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioCovenantByIdQueryGQLType, GetPortfolioCovenantByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioCovenantByIdQueryGQLType, GetPortfolioCovenantByIdQueryVariablesGQLType>(GetPortfolioCovenantByIdDocumentGQLType, options);
      }
export function useGetPortfolioCovenantByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioCovenantByIdQueryGQLType, GetPortfolioCovenantByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioCovenantByIdQueryGQLType, GetPortfolioCovenantByIdQueryVariablesGQLType>(GetPortfolioCovenantByIdDocumentGQLType, options);
        }
export type GetPortfolioCovenantByIdQueryHookResult = ReturnType<typeof useGetPortfolioCovenantByIdQuery>;
export type GetPortfolioCovenantByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPortfolioCovenantByIdLazyQueryGQLType>;
export type GetPortfolioCovenantByIdQueryResultGQLType = Apollo.QueryResult<GetPortfolioCovenantByIdQueryGQLType, GetPortfolioCovenantByIdQueryVariablesGQLType>;
export const CreateCommentDocumentGQLType = gql`
    mutation CreateComment($threadId: UUID!, $comment: String!) {
  commentId: createComment(threadId: $threadId, comment: $comment)
}
    `;
export type CreateCommentMutationFnGQLType = Apollo.MutationFunction<CreateCommentMutationGQLType, CreateCommentMutationVariablesGQLType>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutationGQLType, CreateCommentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutationGQLType, CreateCommentMutationVariablesGQLType>(CreateCommentDocumentGQLType, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResultGQLType = Apollo.MutationResult<CreateCommentMutationGQLType>;
export type CreateCommentMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateCommentMutationGQLType, CreateCommentMutationVariablesGQLType>;
export const CreateThreadActionDocumentGQLType = gql`
    mutation CreateThreadAction($threadId: UUID!, $action: ThreadAction!) {
  createThreadAction(threadId: $threadId, action: $action) {
    ...BaseThreadFragment
  }
}
    ${BaseThreadFragmentFragmentDocGQLType}`;
export type CreateThreadActionMutationFnGQLType = Apollo.MutationFunction<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>;

/**
 * __useCreateThreadActionMutation__
 *
 * To run a mutation, you first call `useCreateThreadActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadActionMutation, { data, loading, error }] = useCreateThreadActionMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useCreateThreadActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>(CreateThreadActionDocumentGQLType, options);
      }
export type CreateThreadActionMutationHookResult = ReturnType<typeof useCreateThreadActionMutation>;
export type CreateThreadActionMutationResultGQLType = Apollo.MutationResult<CreateThreadActionMutationGQLType>;
export type CreateThreadActionMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateThreadActionMutationGQLType, CreateThreadActionMutationVariablesGQLType>;
export const CreateThreadWithCommentDocumentGQLType = gql`
    mutation CreateThreadWithComment($comment: String!, $isPinned: Boolean, $participatingOrganizationIds: [UUID!]!, $domain: ThreadDomain!, $domainIdentifier: String!) {
  thread: createThread(
    comment: $comment
    isPinned: $isPinned
    participatingOrganizationIds: $participatingOrganizationIds
    domain: $domain
    domainIdentifier: $domainIdentifier
  ) {
    ...BaseThreadFragment
  }
}
    ${BaseThreadFragmentFragmentDocGQLType}`;
export type CreateThreadWithCommentMutationFnGQLType = Apollo.MutationFunction<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>;

/**
 * __useCreateThreadWithCommentMutation__
 *
 * To run a mutation, you first call `useCreateThreadWithCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadWithCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadWithCommentMutation, { data, loading, error }] = useCreateThreadWithCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      isPinned: // value for 'isPinned'
 *      participatingOrganizationIds: // value for 'participatingOrganizationIds'
 *      domain: // value for 'domain'
 *      domainIdentifier: // value for 'domainIdentifier'
 *   },
 * });
 */
export function useCreateThreadWithCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>(CreateThreadWithCommentDocumentGQLType, options);
      }
export type CreateThreadWithCommentMutationHookResult = ReturnType<typeof useCreateThreadWithCommentMutation>;
export type CreateThreadWithCommentMutationResultGQLType = Apollo.MutationResult<CreateThreadWithCommentMutationGQLType>;
export type CreateThreadWithCommentMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateThreadWithCommentMutationGQLType, CreateThreadWithCommentMutationVariablesGQLType>;
export const GetThreadByIdDocumentGQLType = gql`
    query GetThreadById($threadId: UUID!) {
  thread(threadId: $threadId) {
    ...BaseThreadFragment
  }
}
    ${BaseThreadFragmentFragmentDocGQLType}`;

/**
 * __useGetThreadByIdQuery__
 *
 * To run a query within a React component, call `useGetThreadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadByIdQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetThreadByIdQuery(baseOptions: Apollo.QueryHookOptions<GetThreadByIdQueryGQLType, GetThreadByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadByIdQueryGQLType, GetThreadByIdQueryVariablesGQLType>(GetThreadByIdDocumentGQLType, options);
      }
export function useGetThreadByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadByIdQueryGQLType, GetThreadByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadByIdQueryGQLType, GetThreadByIdQueryVariablesGQLType>(GetThreadByIdDocumentGQLType, options);
        }
export type GetThreadByIdQueryHookResult = ReturnType<typeof useGetThreadByIdQuery>;
export type GetThreadByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadByIdLazyQueryGQLType>;
export type GetThreadByIdQueryResultGQLType = Apollo.QueryResult<GetThreadByIdQueryGQLType, GetThreadByIdQueryVariablesGQLType>;
export const GetThreadCountsByDomainDocumentGQLType = gql`
    query GetThreadCountsByDomain($domain: ThreadDomain!, $domainIdentifier: String) {
  threadCountsByDomain(domain: $domain, domainIdentifier: $domainIdentifier) {
    total
    pinned
    resolved
  }
}
    `;

/**
 * __useGetThreadCountsByDomainQuery__
 *
 * To run a query within a React component, call `useGetThreadCountsByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadCountsByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadCountsByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      domainIdentifier: // value for 'domainIdentifier'
 *   },
 * });
 */
export function useGetThreadCountsByDomainQuery(baseOptions: Apollo.QueryHookOptions<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>(GetThreadCountsByDomainDocumentGQLType, options);
      }
export function useGetThreadCountsByDomainLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>(GetThreadCountsByDomainDocumentGQLType, options);
        }
export type GetThreadCountsByDomainQueryHookResult = ReturnType<typeof useGetThreadCountsByDomainQuery>;
export type GetThreadCountsByDomainLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadCountsByDomainLazyQueryGQLType>;
export type GetThreadCountsByDomainQueryResultGQLType = Apollo.QueryResult<GetThreadCountsByDomainQueryGQLType, GetThreadCountsByDomainQueryVariablesGQLType>;
export const GetThreadsByDomainIdentifierDocumentGQLType = gql`
    query GetThreadsByDomainIdentifier($domain: ThreadDomain!, $domainIdentifier: String!) {
  threads: threadsByDomainIdentifier(
    domain: $domain
    domainIdentifier: $domainIdentifier
  ) {
    ...BaseThreadFragment
  }
}
    ${BaseThreadFragmentFragmentDocGQLType}`;

/**
 * __useGetThreadsByDomainIdentifierQuery__
 *
 * To run a query within a React component, call `useGetThreadsByDomainIdentifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsByDomainIdentifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsByDomainIdentifierQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      domainIdentifier: // value for 'domainIdentifier'
 *   },
 * });
 */
export function useGetThreadsByDomainIdentifierQuery(baseOptions: Apollo.QueryHookOptions<GetThreadsByDomainIdentifierQueryGQLType, GetThreadsByDomainIdentifierQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadsByDomainIdentifierQueryGQLType, GetThreadsByDomainIdentifierQueryVariablesGQLType>(GetThreadsByDomainIdentifierDocumentGQLType, options);
      }
export function useGetThreadsByDomainIdentifierLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadsByDomainIdentifierQueryGQLType, GetThreadsByDomainIdentifierQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadsByDomainIdentifierQueryGQLType, GetThreadsByDomainIdentifierQueryVariablesGQLType>(GetThreadsByDomainIdentifierDocumentGQLType, options);
        }
export type GetThreadsByDomainIdentifierQueryHookResult = ReturnType<typeof useGetThreadsByDomainIdentifierQuery>;
export type GetThreadsByDomainIdentifierLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadsByDomainIdentifierLazyQueryGQLType>;
export type GetThreadsByDomainIdentifierQueryResultGQLType = Apollo.QueryResult<GetThreadsByDomainIdentifierQueryGQLType, GetThreadsByDomainIdentifierQueryVariablesGQLType>;
export const GetThreadsByDomainMappingDocumentGQLType = gql`
    query GetThreadsByDomainMapping($domain: ThreadDomain!) {
  threadsByDomainMapping(domain: $domain) {
    thread {
      ...BaseThreadFragment
    }
  }
}
    ${BaseThreadFragmentFragmentDocGQLType}`;

/**
 * __useGetThreadsByDomainMappingQuery__
 *
 * To run a query within a React component, call `useGetThreadsByDomainMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsByDomainMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsByDomainMappingQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetThreadsByDomainMappingQuery(baseOptions: Apollo.QueryHookOptions<GetThreadsByDomainMappingQueryGQLType, GetThreadsByDomainMappingQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadsByDomainMappingQueryGQLType, GetThreadsByDomainMappingQueryVariablesGQLType>(GetThreadsByDomainMappingDocumentGQLType, options);
      }
export function useGetThreadsByDomainMappingLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadsByDomainMappingQueryGQLType, GetThreadsByDomainMappingQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadsByDomainMappingQueryGQLType, GetThreadsByDomainMappingQueryVariablesGQLType>(GetThreadsByDomainMappingDocumentGQLType, options);
        }
export type GetThreadsByDomainMappingQueryHookResult = ReturnType<typeof useGetThreadsByDomainMappingQuery>;
export type GetThreadsByDomainMappingLazyQueryGQLTypeHookResult = ReturnType<typeof useGetThreadsByDomainMappingLazyQueryGQLType>;
export type GetThreadsByDomainMappingQueryResultGQLType = Apollo.QueryResult<GetThreadsByDomainMappingQueryGQLType, GetThreadsByDomainMappingQueryVariablesGQLType>;
export const GetSuccessFinancialCovenantsByCreditFacilityIdDocumentGQLType = gql`
    query GetSuccessFinancialCovenantsByCreditFacilityId($creditFacilityId: UUID!, $mode: FinancialCovenantWorkleaseMode!, $startDate: FullDateStr, $endDate: FullDateStr) {
  successFinCovs: getSuccessFinancialCovenantsByCreditFacilityId(
    creditFacilityId: $creditFacilityId
    mode: $mode
    startDate: $startDate
    endDate: $endDate
  ) {
    ...SuccessFinancialCovenant
  }
}
    ${SuccessFinancialCovenantFragmentDocGQLType}`;

/**
 * __useGetSuccessFinancialCovenantsByCreditFacilityIdQuery__
 *
 * To run a query within a React component, call `useGetSuccessFinancialCovenantsByCreditFacilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessFinancialCovenantsByCreditFacilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessFinancialCovenantsByCreditFacilityIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      mode: // value for 'mode'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetSuccessFinancialCovenantsByCreditFacilityIdQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessFinancialCovenantsByCreditFacilityIdQueryGQLType, GetSuccessFinancialCovenantsByCreditFacilityIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessFinancialCovenantsByCreditFacilityIdQueryGQLType, GetSuccessFinancialCovenantsByCreditFacilityIdQueryVariablesGQLType>(GetSuccessFinancialCovenantsByCreditFacilityIdDocumentGQLType, options);
      }
export function useGetSuccessFinancialCovenantsByCreditFacilityIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessFinancialCovenantsByCreditFacilityIdQueryGQLType, GetSuccessFinancialCovenantsByCreditFacilityIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessFinancialCovenantsByCreditFacilityIdQueryGQLType, GetSuccessFinancialCovenantsByCreditFacilityIdQueryVariablesGQLType>(GetSuccessFinancialCovenantsByCreditFacilityIdDocumentGQLType, options);
        }
export type GetSuccessFinancialCovenantsByCreditFacilityIdQueryHookResult = ReturnType<typeof useGetSuccessFinancialCovenantsByCreditFacilityIdQuery>;
export type GetSuccessFinancialCovenantsByCreditFacilityIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSuccessFinancialCovenantsByCreditFacilityIdLazyQueryGQLType>;
export type GetSuccessFinancialCovenantsByCreditFacilityIdQueryResultGQLType = Apollo.QueryResult<GetSuccessFinancialCovenantsByCreditFacilityIdQueryGQLType, GetSuccessFinancialCovenantsByCreditFacilityIdQueryVariablesGQLType>;
export const GetSuccessFinancialCovenantsByKeyDocumentGQLType = gql`
    query GetSuccessFinancialCovenantsByKey($creditFacilityId: UUID!, $mode: FinancialCovenantWorkleaseMode!, $covenantKey: String!, $startDate: FullDateStr, $endDate: FullDateStr) {
  successFinCovsByKey: getSuccessFinancialCovenantsByKey(
    creditFacilityId: $creditFacilityId
    mode: $mode
    covenantKey: $covenantKey
    startDate: $startDate
    endDate: $endDate
  ) {
    ...SuccessFinancialCovenant
  }
}
    ${SuccessFinancialCovenantFragmentDocGQLType}`;

/**
 * __useGetSuccessFinancialCovenantsByKeyQuery__
 *
 * To run a query within a React component, call `useGetSuccessFinancialCovenantsByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuccessFinancialCovenantsByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuccessFinancialCovenantsByKeyQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      mode: // value for 'mode'
 *      covenantKey: // value for 'covenantKey'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetSuccessFinancialCovenantsByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetSuccessFinancialCovenantsByKeyQueryGQLType, GetSuccessFinancialCovenantsByKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuccessFinancialCovenantsByKeyQueryGQLType, GetSuccessFinancialCovenantsByKeyQueryVariablesGQLType>(GetSuccessFinancialCovenantsByKeyDocumentGQLType, options);
      }
export function useGetSuccessFinancialCovenantsByKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSuccessFinancialCovenantsByKeyQueryGQLType, GetSuccessFinancialCovenantsByKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuccessFinancialCovenantsByKeyQueryGQLType, GetSuccessFinancialCovenantsByKeyQueryVariablesGQLType>(GetSuccessFinancialCovenantsByKeyDocumentGQLType, options);
        }
export type GetSuccessFinancialCovenantsByKeyQueryHookResult = ReturnType<typeof useGetSuccessFinancialCovenantsByKeyQuery>;
export type GetSuccessFinancialCovenantsByKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSuccessFinancialCovenantsByKeyLazyQueryGQLType>;
export type GetSuccessFinancialCovenantsByKeyQueryResultGQLType = Apollo.QueryResult<GetSuccessFinancialCovenantsByKeyQueryGQLType, GetSuccessFinancialCovenantsByKeyQueryVariablesGQLType>;
export const ProduceFinancialCovenantWorkleaseMessageDocumentGQLType = gql`
    mutation ProduceFinancialCovenantWorkleaseMessage($worklease: FinancialCovenantInputWorklease!) {
  produceFinancialCovenantWorkleaseMessage(worklease: $worklease) {
    response
    financialCovenantKeyToIdMap {
      covenantKey
      financialCovenantRecordId
    }
  }
}
    `;
export type ProduceFinancialCovenantWorkleaseMessageMutationFnGQLType = Apollo.MutationFunction<ProduceFinancialCovenantWorkleaseMessageMutationGQLType, ProduceFinancialCovenantWorkleaseMessageMutationVariablesGQLType>;

/**
 * __useProduceFinancialCovenantWorkleaseMessageMutation__
 *
 * To run a mutation, you first call `useProduceFinancialCovenantWorkleaseMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProduceFinancialCovenantWorkleaseMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [produceFinancialCovenantWorkleaseMessageMutation, { data, loading, error }] = useProduceFinancialCovenantWorkleaseMessageMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useProduceFinancialCovenantWorkleaseMessageMutation(baseOptions?: Apollo.MutationHookOptions<ProduceFinancialCovenantWorkleaseMessageMutationGQLType, ProduceFinancialCovenantWorkleaseMessageMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProduceFinancialCovenantWorkleaseMessageMutationGQLType, ProduceFinancialCovenantWorkleaseMessageMutationVariablesGQLType>(ProduceFinancialCovenantWorkleaseMessageDocumentGQLType, options);
      }
export type ProduceFinancialCovenantWorkleaseMessageMutationHookResult = ReturnType<typeof useProduceFinancialCovenantWorkleaseMessageMutation>;
export type ProduceFinancialCovenantWorkleaseMessageMutationResultGQLType = Apollo.MutationResult<ProduceFinancialCovenantWorkleaseMessageMutationGQLType>;
export type ProduceFinancialCovenantWorkleaseMessageMutationOptionsGQLType = Apollo.BaseMutationOptions<ProduceFinancialCovenantWorkleaseMessageMutationGQLType, ProduceFinancialCovenantWorkleaseMessageMutationVariablesGQLType>;
export const EvaluateDevFinCovWorkleaseDocumentGQLType = gql`
    mutation EvaluateDevFinCovWorklease($worklease: FinancialCovenantInputWorklease!) {
  evaluateDevFinCovWorklease(worklease: $worklease) {
    response
  }
}
    `;
export type EvaluateDevFinCovWorkleaseMutationFnGQLType = Apollo.MutationFunction<EvaluateDevFinCovWorkleaseMutationGQLType, EvaluateDevFinCovWorkleaseMutationVariablesGQLType>;

/**
 * __useEvaluateDevFinCovWorkleaseMutation__
 *
 * To run a mutation, you first call `useEvaluateDevFinCovWorkleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateDevFinCovWorkleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateDevFinCovWorkleaseMutation, { data, loading, error }] = useEvaluateDevFinCovWorkleaseMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useEvaluateDevFinCovWorkleaseMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateDevFinCovWorkleaseMutationGQLType, EvaluateDevFinCovWorkleaseMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateDevFinCovWorkleaseMutationGQLType, EvaluateDevFinCovWorkleaseMutationVariablesGQLType>(EvaluateDevFinCovWorkleaseDocumentGQLType, options);
      }
export type EvaluateDevFinCovWorkleaseMutationHookResult = ReturnType<typeof useEvaluateDevFinCovWorkleaseMutation>;
export type EvaluateDevFinCovWorkleaseMutationResultGQLType = Apollo.MutationResult<EvaluateDevFinCovWorkleaseMutationGQLType>;
export type EvaluateDevFinCovWorkleaseMutationOptionsGQLType = Apollo.BaseMutationOptions<EvaluateDevFinCovWorkleaseMutationGQLType, EvaluateDevFinCovWorkleaseMutationVariablesGQLType>;
export const GetCreditFacilityDocumentGQLType = gql`
    query GetCreditFacility($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    slug
    isActive
    borrowerId
    name
    type
    implementationId
    externalFacilityId
    capitalProviderRepresentativeOrganization {
      id
      name
    }
    loanProducts {
      id
      name
      slug
      implementationId
    }
  }
}
    `;

/**
 * __useGetCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityQueryGQLType, GetCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityQueryGQLType, GetCreditFacilityQueryVariablesGQLType>(GetCreditFacilityDocumentGQLType, options);
      }
export function useGetCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityQueryGQLType, GetCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityQueryGQLType, GetCreditFacilityQueryVariablesGQLType>(GetCreditFacilityDocumentGQLType, options);
        }
export type GetCreditFacilityQueryHookResult = ReturnType<typeof useGetCreditFacilityQuery>;
export type GetCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityLazyQueryGQLType>;
export type GetCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityQueryGQLType, GetCreditFacilityQueryVariablesGQLType>;
export const GetCreditFacilityCapitalProviderRepresentativeDocumentGQLType = gql`
    query GetCreditFacilityCapitalProviderRepresentative($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    capitalProviderRepresentativeOrganization {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetCreditFacilityCapitalProviderRepresentativeQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityCapitalProviderRepresentativeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityCapitalProviderRepresentativeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityCapitalProviderRepresentativeQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityCapitalProviderRepresentativeQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityCapitalProviderRepresentativeQueryGQLType, GetCreditFacilityCapitalProviderRepresentativeQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityCapitalProviderRepresentativeQueryGQLType, GetCreditFacilityCapitalProviderRepresentativeQueryVariablesGQLType>(GetCreditFacilityCapitalProviderRepresentativeDocumentGQLType, options);
      }
export function useGetCreditFacilityCapitalProviderRepresentativeLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityCapitalProviderRepresentativeQueryGQLType, GetCreditFacilityCapitalProviderRepresentativeQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityCapitalProviderRepresentativeQueryGQLType, GetCreditFacilityCapitalProviderRepresentativeQueryVariablesGQLType>(GetCreditFacilityCapitalProviderRepresentativeDocumentGQLType, options);
        }
export type GetCreditFacilityCapitalProviderRepresentativeQueryHookResult = ReturnType<typeof useGetCreditFacilityCapitalProviderRepresentativeQuery>;
export type GetCreditFacilityCapitalProviderRepresentativeLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityCapitalProviderRepresentativeLazyQueryGQLType>;
export type GetCreditFacilityCapitalProviderRepresentativeQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityCapitalProviderRepresentativeQueryGQLType, GetCreditFacilityCapitalProviderRepresentativeQueryVariablesGQLType>;
export const GetCreditFacilityBorrowerEntityNameDocumentGQLType = gql`
    query GetCreditFacilityBorrowerEntityName($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    borrowerEntityName
  }
}
    `;

/**
 * __useGetCreditFacilityBorrowerEntityNameQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityBorrowerEntityNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityBorrowerEntityNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityBorrowerEntityNameQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityBorrowerEntityNameQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityBorrowerEntityNameQueryGQLType, GetCreditFacilityBorrowerEntityNameQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityBorrowerEntityNameQueryGQLType, GetCreditFacilityBorrowerEntityNameQueryVariablesGQLType>(GetCreditFacilityBorrowerEntityNameDocumentGQLType, options);
      }
export function useGetCreditFacilityBorrowerEntityNameLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityBorrowerEntityNameQueryGQLType, GetCreditFacilityBorrowerEntityNameQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityBorrowerEntityNameQueryGQLType, GetCreditFacilityBorrowerEntityNameQueryVariablesGQLType>(GetCreditFacilityBorrowerEntityNameDocumentGQLType, options);
        }
export type GetCreditFacilityBorrowerEntityNameQueryHookResult = ReturnType<typeof useGetCreditFacilityBorrowerEntityNameQuery>;
export type GetCreditFacilityBorrowerEntityNameLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityBorrowerEntityNameLazyQueryGQLType>;
export type GetCreditFacilityBorrowerEntityNameQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityBorrowerEntityNameQueryGQLType, GetCreditFacilityBorrowerEntityNameQueryVariablesGQLType>;
export const GetCreditFacilityExternalFacilityIdDocumentGQLType = gql`
    query GetCreditFacilityExternalFacilityId($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    externalFacilityId
  }
}
    `;

/**
 * __useGetCreditFacilityExternalFacilityIdQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityExternalFacilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityExternalFacilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityExternalFacilityIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityExternalFacilityIdQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityExternalFacilityIdQueryGQLType, GetCreditFacilityExternalFacilityIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityExternalFacilityIdQueryGQLType, GetCreditFacilityExternalFacilityIdQueryVariablesGQLType>(GetCreditFacilityExternalFacilityIdDocumentGQLType, options);
      }
export function useGetCreditFacilityExternalFacilityIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityExternalFacilityIdQueryGQLType, GetCreditFacilityExternalFacilityIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityExternalFacilityIdQueryGQLType, GetCreditFacilityExternalFacilityIdQueryVariablesGQLType>(GetCreditFacilityExternalFacilityIdDocumentGQLType, options);
        }
export type GetCreditFacilityExternalFacilityIdQueryHookResult = ReturnType<typeof useGetCreditFacilityExternalFacilityIdQuery>;
export type GetCreditFacilityExternalFacilityIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityExternalFacilityIdLazyQueryGQLType>;
export type GetCreditFacilityExternalFacilityIdQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityExternalFacilityIdQueryGQLType, GetCreditFacilityExternalFacilityIdQueryVariablesGQLType>;
export const GetMultipleExternalFacilityIdsDocumentGQLType = gql`
    query GetMultipleExternalFacilityIds($creditFacilityIds: [UUID!]!) {
  result: getMultipleExternalFacilityIds(creditFacilityIds: $creditFacilityIds) {
    creditFacilityId
    externalFacilityId
  }
}
    `;

/**
 * __useGetMultipleExternalFacilityIdsQuery__
 *
 * To run a query within a React component, call `useGetMultipleExternalFacilityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleExternalFacilityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleExternalFacilityIdsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetMultipleExternalFacilityIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMultipleExternalFacilityIdsQueryGQLType, GetMultipleExternalFacilityIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipleExternalFacilityIdsQueryGQLType, GetMultipleExternalFacilityIdsQueryVariablesGQLType>(GetMultipleExternalFacilityIdsDocumentGQLType, options);
      }
export function useGetMultipleExternalFacilityIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipleExternalFacilityIdsQueryGQLType, GetMultipleExternalFacilityIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipleExternalFacilityIdsQueryGQLType, GetMultipleExternalFacilityIdsQueryVariablesGQLType>(GetMultipleExternalFacilityIdsDocumentGQLType, options);
        }
export type GetMultipleExternalFacilityIdsQueryHookResult = ReturnType<typeof useGetMultipleExternalFacilityIdsQuery>;
export type GetMultipleExternalFacilityIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMultipleExternalFacilityIdsLazyQueryGQLType>;
export type GetMultipleExternalFacilityIdsQueryResultGQLType = Apollo.QueryResult<GetMultipleExternalFacilityIdsQueryGQLType, GetMultipleExternalFacilityIdsQueryVariablesGQLType>;
export const CheckIfAnyFacilitiesHaveBorrowingBaseDocumentGQLType = gql`
    query CheckIfAnyFacilitiesHaveBorrowingBase($creditFacilityIds: [UUID!]!, $creditFacilitySlugsToHide: [String!]) {
  hasBorrowingBase: checkIfAnyFacilitiesHaveBorrowingBase(
    creditFacilityIds: $creditFacilityIds
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  )
}
    `;

/**
 * __useCheckIfAnyFacilitiesHaveBorrowingBaseQuery__
 *
 * To run a query within a React component, call `useCheckIfAnyFacilitiesHaveBorrowingBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfAnyFacilitiesHaveBorrowingBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfAnyFacilitiesHaveBorrowingBaseQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useCheckIfAnyFacilitiesHaveBorrowingBaseQuery(baseOptions: Apollo.QueryHookOptions<CheckIfAnyFacilitiesHaveBorrowingBaseQueryGQLType, CheckIfAnyFacilitiesHaveBorrowingBaseQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfAnyFacilitiesHaveBorrowingBaseQueryGQLType, CheckIfAnyFacilitiesHaveBorrowingBaseQueryVariablesGQLType>(CheckIfAnyFacilitiesHaveBorrowingBaseDocumentGQLType, options);
      }
export function useCheckIfAnyFacilitiesHaveBorrowingBaseLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfAnyFacilitiesHaveBorrowingBaseQueryGQLType, CheckIfAnyFacilitiesHaveBorrowingBaseQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfAnyFacilitiesHaveBorrowingBaseQueryGQLType, CheckIfAnyFacilitiesHaveBorrowingBaseQueryVariablesGQLType>(CheckIfAnyFacilitiesHaveBorrowingBaseDocumentGQLType, options);
        }
export type CheckIfAnyFacilitiesHaveBorrowingBaseQueryHookResult = ReturnType<typeof useCheckIfAnyFacilitiesHaveBorrowingBaseQuery>;
export type CheckIfAnyFacilitiesHaveBorrowingBaseLazyQueryGQLTypeHookResult = ReturnType<typeof useCheckIfAnyFacilitiesHaveBorrowingBaseLazyQueryGQLType>;
export type CheckIfAnyFacilitiesHaveBorrowingBaseQueryResultGQLType = Apollo.QueryResult<CheckIfAnyFacilitiesHaveBorrowingBaseQueryGQLType, CheckIfAnyFacilitiesHaveBorrowingBaseQueryVariablesGQLType>;
export const GetLoanProductsAndAssociatedFacilitiesForCreditFacilityDocumentGQLType = gql`
    query GetLoanProductsAndAssociatedFacilitiesForCreditFacility($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    slug
    name
    implementationId
    loanProducts {
      id
      name
      slug
      currentCreditFacilities {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryGQLType, GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryGQLType, GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryVariablesGQLType>(GetLoanProductsAndAssociatedFacilitiesForCreditFacilityDocumentGQLType, options);
      }
export function useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryGQLType, GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryGQLType, GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryVariablesGQLType>(GetLoanProductsAndAssociatedFacilitiesForCreditFacilityDocumentGQLType, options);
        }
export type GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryHookResult = ReturnType<typeof useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityQuery>;
export type GetLoanProductsAndAssociatedFacilitiesForCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanProductsAndAssociatedFacilitiesForCreditFacilityLazyQueryGQLType>;
export type GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryGQLType, GetLoanProductsAndAssociatedFacilitiesForCreditFacilityQueryVariablesGQLType>;
export const GetCreditFacilityWithCurrentCreditAgreementDocumentGQLType = gql`
    query GetCreditFacilityWithCurrentCreditAgreement($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    slug
    isActive
    borrowerId
    name
    type
    loanProducts {
      id
      name
      slug
    }
    currentCreditAgreement {
      id
      creditAgreement
    }
  }
}
    `;

/**
 * __useGetCreditFacilityWithCurrentCreditAgreementQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityWithCurrentCreditAgreementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityWithCurrentCreditAgreementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityWithCurrentCreditAgreementQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityWithCurrentCreditAgreementQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityWithCurrentCreditAgreementQueryGQLType, GetCreditFacilityWithCurrentCreditAgreementQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityWithCurrentCreditAgreementQueryGQLType, GetCreditFacilityWithCurrentCreditAgreementQueryVariablesGQLType>(GetCreditFacilityWithCurrentCreditAgreementDocumentGQLType, options);
      }
export function useGetCreditFacilityWithCurrentCreditAgreementLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityWithCurrentCreditAgreementQueryGQLType, GetCreditFacilityWithCurrentCreditAgreementQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityWithCurrentCreditAgreementQueryGQLType, GetCreditFacilityWithCurrentCreditAgreementQueryVariablesGQLType>(GetCreditFacilityWithCurrentCreditAgreementDocumentGQLType, options);
        }
export type GetCreditFacilityWithCurrentCreditAgreementQueryHookResult = ReturnType<typeof useGetCreditFacilityWithCurrentCreditAgreementQuery>;
export type GetCreditFacilityWithCurrentCreditAgreementLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityWithCurrentCreditAgreementLazyQueryGQLType>;
export type GetCreditFacilityWithCurrentCreditAgreementQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityWithCurrentCreditAgreementQueryGQLType, GetCreditFacilityWithCurrentCreditAgreementQueryVariablesGQLType>;
export const GetCreditFacilitiesDocumentGQLType = gql`
    query GetCreditFacilities($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    slug
    name
    isActive
    borrowerId
    borrowerEntityName
    type
    implementationId
  }
}
    `;

/**
 * __useGetCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesQueryGQLType, GetCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesQueryGQLType, GetCreditFacilitiesQueryVariablesGQLType>(GetCreditFacilitiesDocumentGQLType, options);
      }
export function useGetCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesQueryGQLType, GetCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesQueryGQLType, GetCreditFacilitiesQueryVariablesGQLType>(GetCreditFacilitiesDocumentGQLType, options);
        }
export type GetCreditFacilitiesQueryHookResult = ReturnType<typeof useGetCreditFacilitiesQuery>;
export type GetCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesLazyQueryGQLType>;
export type GetCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesQueryGQLType, GetCreditFacilitiesQueryVariablesGQLType>;
export const GetCreditFacilitiesForAssignmentGroupingDocumentGQLType = gql`
    query GetCreditFacilitiesForAssignmentGrouping($implementationId: UUID!) {
  creditFacilitiesForAssignmentGrouping(implementationId: $implementationId) {
    id
    slug
    name
    isActive
    borrowerId
    borrowerEntityName
    type
  }
}
    `;

/**
 * __useGetCreditFacilitiesForAssignmentGroupingQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesForAssignmentGroupingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesForAssignmentGroupingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesForAssignmentGroupingQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesForAssignmentGroupingQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesForAssignmentGroupingQueryGQLType, GetCreditFacilitiesForAssignmentGroupingQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesForAssignmentGroupingQueryGQLType, GetCreditFacilitiesForAssignmentGroupingQueryVariablesGQLType>(GetCreditFacilitiesForAssignmentGroupingDocumentGQLType, options);
      }
export function useGetCreditFacilitiesForAssignmentGroupingLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesForAssignmentGroupingQueryGQLType, GetCreditFacilitiesForAssignmentGroupingQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesForAssignmentGroupingQueryGQLType, GetCreditFacilitiesForAssignmentGroupingQueryVariablesGQLType>(GetCreditFacilitiesForAssignmentGroupingDocumentGQLType, options);
        }
export type GetCreditFacilitiesForAssignmentGroupingQueryHookResult = ReturnType<typeof useGetCreditFacilitiesForAssignmentGroupingQuery>;
export type GetCreditFacilitiesForAssignmentGroupingLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesForAssignmentGroupingLazyQueryGQLType>;
export type GetCreditFacilitiesForAssignmentGroupingQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesForAssignmentGroupingQueryGQLType, GetCreditFacilitiesForAssignmentGroupingQueryVariablesGQLType>;
export const GetCreditFacilitiesAndLoanProductsForAssignmentGroupingDocumentGQLType = gql`
    query GetCreditFacilitiesAndLoanProductsForAssignmentGrouping($implementationId: UUID!) {
  creditFacilitiesForAssignmentGrouping(implementationId: $implementationId) {
    id
    slug
    name
    loanProducts {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryVariablesGQLType>(GetCreditFacilitiesAndLoanProductsForAssignmentGroupingDocumentGQLType, options);
      }
export function useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryVariablesGQLType>(GetCreditFacilitiesAndLoanProductsForAssignmentGroupingDocumentGQLType, options);
        }
export type GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryHookResult = ReturnType<typeof useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingQuery>;
export type GetCreditFacilitiesAndLoanProductsForAssignmentGroupingLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesAndLoanProductsForAssignmentGroupingLazyQueryGQLType>;
export type GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsForAssignmentGroupingQueryVariablesGQLType>;
export const GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingDocumentGQLType = gql`
    query GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGrouping($implementationId: UUID!) {
  creditFacilitiesForAssignmentGrouping(implementationId: $implementationId) {
    id
    name
    slug
    implementationId
    borrowingBaseMechanicsForLoanProducts {
      loanProductId
      loanProductName
      implementationId
      baseFields
      eligibilityCriteria {
        eligibilityCriteriaKey
        eligibilityConfigDetail
      }
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryVariablesGQLType>(GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingDocumentGQLType, options);
      }
export function useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryVariablesGQLType>(GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingDocumentGQLType, options);
        }
export type GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryHookResult = ReturnType<typeof useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQuery>;
export type GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingLazyQueryGQLType>;
export type GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryGQLType, GetCreditFacilitiesAndLoanProductsWithBorrowingBaseMechanicsForAssignmentGroupingQueryVariablesGQLType>;
export const GetCreditFacilityLiabilityAccountsDocumentGQLType = gql`
    query GetCreditFacilityLiabilityAccounts($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    liabilityAccounts {
      tAccount
      organization {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCreditFacilityLiabilityAccountsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityLiabilityAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityLiabilityAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityLiabilityAccountsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityLiabilityAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityLiabilityAccountsQueryGQLType, GetCreditFacilityLiabilityAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityLiabilityAccountsQueryGQLType, GetCreditFacilityLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilityLiabilityAccountsDocumentGQLType, options);
      }
export function useGetCreditFacilityLiabilityAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityLiabilityAccountsQueryGQLType, GetCreditFacilityLiabilityAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityLiabilityAccountsQueryGQLType, GetCreditFacilityLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilityLiabilityAccountsDocumentGQLType, options);
        }
export type GetCreditFacilityLiabilityAccountsQueryHookResult = ReturnType<typeof useGetCreditFacilityLiabilityAccountsQuery>;
export type GetCreditFacilityLiabilityAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityLiabilityAccountsLazyQueryGQLType>;
export type GetCreditFacilityLiabilityAccountsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityLiabilityAccountsQueryGQLType, GetCreditFacilityLiabilityAccountsQueryVariablesGQLType>;
export const GetCreditFacilitiesLiabilityAccountsDocumentGQLType = gql`
    query GetCreditFacilitiesLiabilityAccounts($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    liabilityAccounts {
      tAccount
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesLiabilityAccountsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesLiabilityAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesLiabilityAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesLiabilityAccountsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesLiabilityAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesLiabilityAccountsQueryGQLType, GetCreditFacilitiesLiabilityAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesLiabilityAccountsQueryGQLType, GetCreditFacilitiesLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilitiesLiabilityAccountsDocumentGQLType, options);
      }
export function useGetCreditFacilitiesLiabilityAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesLiabilityAccountsQueryGQLType, GetCreditFacilitiesLiabilityAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesLiabilityAccountsQueryGQLType, GetCreditFacilitiesLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilitiesLiabilityAccountsDocumentGQLType, options);
        }
export type GetCreditFacilitiesLiabilityAccountsQueryHookResult = ReturnType<typeof useGetCreditFacilitiesLiabilityAccountsQuery>;
export type GetCreditFacilitiesLiabilityAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesLiabilityAccountsLazyQueryGQLType>;
export type GetCreditFacilitiesLiabilityAccountsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesLiabilityAccountsQueryGQLType, GetCreditFacilitiesLiabilityAccountsQueryVariablesGQLType>;
export const UpdateCreditFacilityIsActiveDocumentGQLType = gql`
    mutation UpdateCreditFacilityIsActive($creditFacilityId: UUID!, $isActive: Boolean!) {
  updateCreditFacilityIsActive(
    creditFacilityId: $creditFacilityId
    isActive: $isActive
  ) {
    response
  }
}
    `;
export type UpdateCreditFacilityIsActiveMutationFnGQLType = Apollo.MutationFunction<UpdateCreditFacilityIsActiveMutationGQLType, UpdateCreditFacilityIsActiveMutationVariablesGQLType>;

/**
 * __useUpdateCreditFacilityIsActiveMutation__
 *
 * To run a mutation, you first call `useUpdateCreditFacilityIsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditFacilityIsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditFacilityIsActiveMutation, { data, loading, error }] = useUpdateCreditFacilityIsActiveMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateCreditFacilityIsActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditFacilityIsActiveMutationGQLType, UpdateCreditFacilityIsActiveMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditFacilityIsActiveMutationGQLType, UpdateCreditFacilityIsActiveMutationVariablesGQLType>(UpdateCreditFacilityIsActiveDocumentGQLType, options);
      }
export type UpdateCreditFacilityIsActiveMutationHookResult = ReturnType<typeof useUpdateCreditFacilityIsActiveMutation>;
export type UpdateCreditFacilityIsActiveMutationResultGQLType = Apollo.MutationResult<UpdateCreditFacilityIsActiveMutationGQLType>;
export type UpdateCreditFacilityIsActiveMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateCreditFacilityIsActiveMutationGQLType, UpdateCreditFacilityIsActiveMutationVariablesGQLType>;
export const UpdateCreditFacilityNameDocumentGQLType = gql`
    mutation UpdateCreditFacilityName($creditFacilityId: UUID!, $name: String!) {
  updateCreditFacilityName(creditFacilityId: $creditFacilityId, name: $name) {
    id
    name
  }
}
    `;
export type UpdateCreditFacilityNameMutationFnGQLType = Apollo.MutationFunction<UpdateCreditFacilityNameMutationGQLType, UpdateCreditFacilityNameMutationVariablesGQLType>;

/**
 * __useUpdateCreditFacilityNameMutation__
 *
 * To run a mutation, you first call `useUpdateCreditFacilityNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditFacilityNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditFacilityNameMutation, { data, loading, error }] = useUpdateCreditFacilityNameMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCreditFacilityNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditFacilityNameMutationGQLType, UpdateCreditFacilityNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditFacilityNameMutationGQLType, UpdateCreditFacilityNameMutationVariablesGQLType>(UpdateCreditFacilityNameDocumentGQLType, options);
      }
export type UpdateCreditFacilityNameMutationHookResult = ReturnType<typeof useUpdateCreditFacilityNameMutation>;
export type UpdateCreditFacilityNameMutationResultGQLType = Apollo.MutationResult<UpdateCreditFacilityNameMutationGQLType>;
export type UpdateCreditFacilityNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateCreditFacilityNameMutationGQLType, UpdateCreditFacilityNameMutationVariablesGQLType>;
export const GetUploadedDocumentsDocumentGQLType = gql`
    query getUploadedDocuments($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    uploadedDocuments {
      id
      documentType
      capitalProvider {
        id
        name
      }
      documentName
      status
      uploadedAt
    }
  }
}
    `;

/**
 * __useGetUploadedDocumentsQuery__
 *
 * To run a query within a React component, call `useGetUploadedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedDocumentsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetUploadedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetUploadedDocumentsQueryGQLType, GetUploadedDocumentsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadedDocumentsQueryGQLType, GetUploadedDocumentsQueryVariablesGQLType>(GetUploadedDocumentsDocumentGQLType, options);
      }
export function useGetUploadedDocumentsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedDocumentsQueryGQLType, GetUploadedDocumentsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadedDocumentsQueryGQLType, GetUploadedDocumentsQueryVariablesGQLType>(GetUploadedDocumentsDocumentGQLType, options);
        }
export type GetUploadedDocumentsQueryHookResult = ReturnType<typeof useGetUploadedDocumentsQuery>;
export type GetUploadedDocumentsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUploadedDocumentsLazyQueryGQLType>;
export type GetUploadedDocumentsQueryResultGQLType = Apollo.QueryResult<GetUploadedDocumentsQueryGQLType, GetUploadedDocumentsQueryVariablesGQLType>;
export const GetCreditFacilityKnowledgeBaseDocumentIdDocumentGQLType = gql`
    query getCreditFacilityKnowledgeBaseDocumentId($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    knowledgeBaseDocumentId
  }
}
    `;

/**
 * __useGetCreditFacilityKnowledgeBaseDocumentIdQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityKnowledgeBaseDocumentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityKnowledgeBaseDocumentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityKnowledgeBaseDocumentIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityKnowledgeBaseDocumentIdQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityKnowledgeBaseDocumentIdQueryGQLType, GetCreditFacilityKnowledgeBaseDocumentIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityKnowledgeBaseDocumentIdQueryGQLType, GetCreditFacilityKnowledgeBaseDocumentIdQueryVariablesGQLType>(GetCreditFacilityKnowledgeBaseDocumentIdDocumentGQLType, options);
      }
export function useGetCreditFacilityKnowledgeBaseDocumentIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityKnowledgeBaseDocumentIdQueryGQLType, GetCreditFacilityKnowledgeBaseDocumentIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityKnowledgeBaseDocumentIdQueryGQLType, GetCreditFacilityKnowledgeBaseDocumentIdQueryVariablesGQLType>(GetCreditFacilityKnowledgeBaseDocumentIdDocumentGQLType, options);
        }
export type GetCreditFacilityKnowledgeBaseDocumentIdQueryHookResult = ReturnType<typeof useGetCreditFacilityKnowledgeBaseDocumentIdQuery>;
export type GetCreditFacilityKnowledgeBaseDocumentIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityKnowledgeBaseDocumentIdLazyQueryGQLType>;
export type GetCreditFacilityKnowledgeBaseDocumentIdQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityKnowledgeBaseDocumentIdQueryGQLType, GetCreditFacilityKnowledgeBaseDocumentIdQueryVariablesGQLType>;
export const GetDocumentUploadSignedUrlDocumentGQLType = gql`
    query getDocumentUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getDocumentUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetDocumentUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDocumentUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDocumentUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentUploadSignedUrlQueryGQLType, GetDocumentUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentUploadSignedUrlQueryGQLType, GetDocumentUploadSignedUrlQueryVariablesGQLType>(GetDocumentUploadSignedUrlDocumentGQLType, options);
      }
export function useGetDocumentUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentUploadSignedUrlQueryGQLType, GetDocumentUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentUploadSignedUrlQueryGQLType, GetDocumentUploadSignedUrlQueryVariablesGQLType>(GetDocumentUploadSignedUrlDocumentGQLType, options);
        }
export type GetDocumentUploadSignedUrlQueryHookResult = ReturnType<typeof useGetDocumentUploadSignedUrlQuery>;
export type GetDocumentUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDocumentUploadSignedUrlLazyQueryGQLType>;
export type GetDocumentUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDocumentUploadSignedUrlQueryGQLType, GetDocumentUploadSignedUrlQueryVariablesGQLType>;
export const GetDocumentDownloadDestinationDocumentGQLType = gql`
    query getDocumentDownloadDestination($serializedParams: String!) {
  downloadUrls: getSignedDownloadUrls(
    feature: "getDocumentDownloadDestination"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetDocumentDownloadDestinationQuery__
 *
 * To run a query within a React component, call `useGetDocumentDownloadDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDownloadDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDownloadDestinationQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDocumentDownloadDestinationQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDownloadDestinationQueryGQLType, GetDocumentDownloadDestinationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDownloadDestinationQueryGQLType, GetDocumentDownloadDestinationQueryVariablesGQLType>(GetDocumentDownloadDestinationDocumentGQLType, options);
      }
export function useGetDocumentDownloadDestinationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDownloadDestinationQueryGQLType, GetDocumentDownloadDestinationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDownloadDestinationQueryGQLType, GetDocumentDownloadDestinationQueryVariablesGQLType>(GetDocumentDownloadDestinationDocumentGQLType, options);
        }
export type GetDocumentDownloadDestinationQueryHookResult = ReturnType<typeof useGetDocumentDownloadDestinationQuery>;
export type GetDocumentDownloadDestinationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDocumentDownloadDestinationLazyQueryGQLType>;
export type GetDocumentDownloadDestinationQueryResultGQLType = Apollo.QueryResult<GetDocumentDownloadDestinationQueryGQLType, GetDocumentDownloadDestinationQueryVariablesGQLType>;
export const UpdateDocumentToLatestPublishedDocumentGQLType = gql`
    mutation updateDocumentToLatestPublished($documentId: UUID!) {
  updateDocumentToLatestPublished(documentId: $documentId) {
    response
  }
}
    `;
export type UpdateDocumentToLatestPublishedMutationFnGQLType = Apollo.MutationFunction<UpdateDocumentToLatestPublishedMutationGQLType, UpdateDocumentToLatestPublishedMutationVariablesGQLType>;

/**
 * __useUpdateDocumentToLatestPublishedMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentToLatestPublishedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentToLatestPublishedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentToLatestPublishedMutation, { data, loading, error }] = useUpdateDocumentToLatestPublishedMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useUpdateDocumentToLatestPublishedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentToLatestPublishedMutationGQLType, UpdateDocumentToLatestPublishedMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentToLatestPublishedMutationGQLType, UpdateDocumentToLatestPublishedMutationVariablesGQLType>(UpdateDocumentToLatestPublishedDocumentGQLType, options);
      }
export type UpdateDocumentToLatestPublishedMutationHookResult = ReturnType<typeof useUpdateDocumentToLatestPublishedMutation>;
export type UpdateDocumentToLatestPublishedMutationResultGQLType = Apollo.MutationResult<UpdateDocumentToLatestPublishedMutationGQLType>;
export type UpdateDocumentToLatestPublishedMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateDocumentToLatestPublishedMutationGQLType, UpdateDocumentToLatestPublishedMutationVariablesGQLType>;
export const UpdateDocumentNameDocumentGQLType = gql`
    mutation updateDocumentName($documentId: UUID!, $newDocumentName: String!) {
  updateDocumentName(documentId: $documentId, newDocumentName: $newDocumentName) {
    response
  }
}
    `;
export type UpdateDocumentNameMutationFnGQLType = Apollo.MutationFunction<UpdateDocumentNameMutationGQLType, UpdateDocumentNameMutationVariablesGQLType>;

/**
 * __useUpdateDocumentNameMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentNameMutation, { data, loading, error }] = useUpdateDocumentNameMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      newDocumentName: // value for 'newDocumentName'
 *   },
 * });
 */
export function useUpdateDocumentNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentNameMutationGQLType, UpdateDocumentNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentNameMutationGQLType, UpdateDocumentNameMutationVariablesGQLType>(UpdateDocumentNameDocumentGQLType, options);
      }
export type UpdateDocumentNameMutationHookResult = ReturnType<typeof useUpdateDocumentNameMutation>;
export type UpdateDocumentNameMutationResultGQLType = Apollo.MutationResult<UpdateDocumentNameMutationGQLType>;
export type UpdateDocumentNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateDocumentNameMutationGQLType, UpdateDocumentNameMutationVariablesGQLType>;
export const UploadCreditAgreementToKnowledgeBaseDocumentGQLType = gql`
    mutation uploadCreditAgreementToKnowledgeBase($creditFacilityDocumentId: UUID!) {
  uploadCreditAgreementToKnowledgeBase(
    creditFacilityDocumentId: $creditFacilityDocumentId
  ) {
    response
  }
}
    `;
export type UploadCreditAgreementToKnowledgeBaseMutationFnGQLType = Apollo.MutationFunction<UploadCreditAgreementToKnowledgeBaseMutationGQLType, UploadCreditAgreementToKnowledgeBaseMutationVariablesGQLType>;

/**
 * __useUploadCreditAgreementToKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useUploadCreditAgreementToKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCreditAgreementToKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCreditAgreementToKnowledgeBaseMutation, { data, loading, error }] = useUploadCreditAgreementToKnowledgeBaseMutation({
 *   variables: {
 *      creditFacilityDocumentId: // value for 'creditFacilityDocumentId'
 *   },
 * });
 */
export function useUploadCreditAgreementToKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<UploadCreditAgreementToKnowledgeBaseMutationGQLType, UploadCreditAgreementToKnowledgeBaseMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCreditAgreementToKnowledgeBaseMutationGQLType, UploadCreditAgreementToKnowledgeBaseMutationVariablesGQLType>(UploadCreditAgreementToKnowledgeBaseDocumentGQLType, options);
      }
export type UploadCreditAgreementToKnowledgeBaseMutationHookResult = ReturnType<typeof useUploadCreditAgreementToKnowledgeBaseMutation>;
export type UploadCreditAgreementToKnowledgeBaseMutationResultGQLType = Apollo.MutationResult<UploadCreditAgreementToKnowledgeBaseMutationGQLType>;
export type UploadCreditAgreementToKnowledgeBaseMutationOptionsGQLType = Apollo.BaseMutationOptions<UploadCreditAgreementToKnowledgeBaseMutationGQLType, UploadCreditAgreementToKnowledgeBaseMutationVariablesGQLType>;
export const CreateCreditFacilityDocumentGQLType = gql`
    mutation CreateCreditFacility($slug: String!, $name: String!, $implementationId: UUID!, $capitalProviderIds: [UUID!]!, $capitalProviderRepresentativeIds: [UUID!]!, $type: FacilityType!) {
  createCreditFacility(
    slug: $slug
    name: $name
    implementationId: $implementationId
    capitalProviderIds: $capitalProviderIds
    capitalProviderRepresentativeIds: $capitalProviderRepresentativeIds
    type: $type
  ) {
    id
  }
}
    `;
export type CreateCreditFacilityMutationFnGQLType = Apollo.MutationFunction<CreateCreditFacilityMutationGQLType, CreateCreditFacilityMutationVariablesGQLType>;

/**
 * __useCreateCreditFacilityMutation__
 *
 * To run a mutation, you first call `useCreateCreditFacilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditFacilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditFacilityMutation, { data, loading, error }] = useCreateCreditFacilityMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      name: // value for 'name'
 *      implementationId: // value for 'implementationId'
 *      capitalProviderIds: // value for 'capitalProviderIds'
 *      capitalProviderRepresentativeIds: // value for 'capitalProviderRepresentativeIds'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCreditFacilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditFacilityMutationGQLType, CreateCreditFacilityMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditFacilityMutationGQLType, CreateCreditFacilityMutationVariablesGQLType>(CreateCreditFacilityDocumentGQLType, options);
      }
export type CreateCreditFacilityMutationHookResult = ReturnType<typeof useCreateCreditFacilityMutation>;
export type CreateCreditFacilityMutationResultGQLType = Apollo.MutationResult<CreateCreditFacilityMutationGQLType>;
export type CreateCreditFacilityMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateCreditFacilityMutationGQLType, CreateCreditFacilityMutationVariablesGQLType>;
export const GetCreditAgreementFullArtifactWipDocumentGQLType = gql`
    query GetCreditAgreementFullArtifactWip($creditFacilityId: UUID!) {
  creditAgreementFullArtifactWip(creditFacilityId: $creditFacilityId) {
    wip {
      ...CreditAgreementFullArtifactFields
    }
    errors
  }
}
    ${CreditAgreementFullArtifactFieldsFragmentDocGQLType}`;

/**
 * __useGetCreditAgreementFullArtifactWipQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementFullArtifactWipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementFullArtifactWipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementFullArtifactWipQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditAgreementFullArtifactWipQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementFullArtifactWipQueryGQLType, GetCreditAgreementFullArtifactWipQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementFullArtifactWipQueryGQLType, GetCreditAgreementFullArtifactWipQueryVariablesGQLType>(GetCreditAgreementFullArtifactWipDocumentGQLType, options);
      }
export function useGetCreditAgreementFullArtifactWipLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementFullArtifactWipQueryGQLType, GetCreditAgreementFullArtifactWipQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementFullArtifactWipQueryGQLType, GetCreditAgreementFullArtifactWipQueryVariablesGQLType>(GetCreditAgreementFullArtifactWipDocumentGQLType, options);
        }
export type GetCreditAgreementFullArtifactWipQueryHookResult = ReturnType<typeof useGetCreditAgreementFullArtifactWipQuery>;
export type GetCreditAgreementFullArtifactWipLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementFullArtifactWipLazyQueryGQLType>;
export type GetCreditAgreementFullArtifactWipQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementFullArtifactWipQueryGQLType, GetCreditAgreementFullArtifactWipQueryVariablesGQLType>;
export const GetCreditAgreementArtifactDocumentGQLType = gql`
    query GetCreditAgreementArtifact($creditAgreementId: UUID!) {
  creditAgreementArtifact(creditAgreementId: $creditAgreementId) {
    ...CreditAgreementArtifactFields
  }
}
    ${CreditAgreementArtifactFieldsFragmentDocGQLType}`;

/**
 * __useGetCreditAgreementArtifactQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementArtifactQuery({
 *   variables: {
 *      creditAgreementId: // value for 'creditAgreementId'
 *   },
 * });
 */
export function useGetCreditAgreementArtifactQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementArtifactQueryGQLType, GetCreditAgreementArtifactQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementArtifactQueryGQLType, GetCreditAgreementArtifactQueryVariablesGQLType>(GetCreditAgreementArtifactDocumentGQLType, options);
      }
export function useGetCreditAgreementArtifactLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementArtifactQueryGQLType, GetCreditAgreementArtifactQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementArtifactQueryGQLType, GetCreditAgreementArtifactQueryVariablesGQLType>(GetCreditAgreementArtifactDocumentGQLType, options);
        }
export type GetCreditAgreementArtifactQueryHookResult = ReturnType<typeof useGetCreditAgreementArtifactQuery>;
export type GetCreditAgreementArtifactLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementArtifactLazyQueryGQLType>;
export type GetCreditAgreementArtifactQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementArtifactQueryGQLType, GetCreditAgreementArtifactQueryVariablesGQLType>;
export const GetCurrentCreditAgreementFullArtifactDocumentGQLType = gql`
    query GetCurrentCreditAgreementFullArtifact($creditFacilityId: UUID!) {
  currentCreditAgreementFullArtifact(creditFacilityId: $creditFacilityId) {
    ...CreditAgreementFullArtifactFields
  }
}
    ${CreditAgreementFullArtifactFieldsFragmentDocGQLType}`;

/**
 * __useGetCurrentCreditAgreementFullArtifactQuery__
 *
 * To run a query within a React component, call `useGetCurrentCreditAgreementFullArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCreditAgreementFullArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCreditAgreementFullArtifactQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCurrentCreditAgreementFullArtifactQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentCreditAgreementFullArtifactQueryGQLType, GetCurrentCreditAgreementFullArtifactQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCreditAgreementFullArtifactQueryGQLType, GetCurrentCreditAgreementFullArtifactQueryVariablesGQLType>(GetCurrentCreditAgreementFullArtifactDocumentGQLType, options);
      }
export function useGetCurrentCreditAgreementFullArtifactLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCreditAgreementFullArtifactQueryGQLType, GetCurrentCreditAgreementFullArtifactQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCreditAgreementFullArtifactQueryGQLType, GetCurrentCreditAgreementFullArtifactQueryVariablesGQLType>(GetCurrentCreditAgreementFullArtifactDocumentGQLType, options);
        }
export type GetCurrentCreditAgreementFullArtifactQueryHookResult = ReturnType<typeof useGetCurrentCreditAgreementFullArtifactQuery>;
export type GetCurrentCreditAgreementFullArtifactLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentCreditAgreementFullArtifactLazyQueryGQLType>;
export type GetCurrentCreditAgreementFullArtifactQueryResultGQLType = Apollo.QueryResult<GetCurrentCreditAgreementFullArtifactQueryGQLType, GetCurrentCreditAgreementFullArtifactQueryVariablesGQLType>;
export const GetCurrentCreditAgreementFullArtifactsForOrganizationDocumentGQLType = gql`
    query GetCurrentCreditAgreementFullArtifactsForOrganization($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]!) {
  organization(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  ) {
    currentCreditAgreementArtifacts {
      ...CreditAgreementArtifactFields
    }
  }
}
    ${CreditAgreementArtifactFieldsFragmentDocGQLType}`;

/**
 * __useGetCurrentCreditAgreementFullArtifactsForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetCurrentCreditAgreementFullArtifactsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCreditAgreementFullArtifactsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCreditAgreementFullArtifactsForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetCurrentCreditAgreementFullArtifactsForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentCreditAgreementFullArtifactsForOrganizationQueryGQLType, GetCurrentCreditAgreementFullArtifactsForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCreditAgreementFullArtifactsForOrganizationQueryGQLType, GetCurrentCreditAgreementFullArtifactsForOrganizationQueryVariablesGQLType>(GetCurrentCreditAgreementFullArtifactsForOrganizationDocumentGQLType, options);
      }
export function useGetCurrentCreditAgreementFullArtifactsForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCreditAgreementFullArtifactsForOrganizationQueryGQLType, GetCurrentCreditAgreementFullArtifactsForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCreditAgreementFullArtifactsForOrganizationQueryGQLType, GetCurrentCreditAgreementFullArtifactsForOrganizationQueryVariablesGQLType>(GetCurrentCreditAgreementFullArtifactsForOrganizationDocumentGQLType, options);
        }
export type GetCurrentCreditAgreementFullArtifactsForOrganizationQueryHookResult = ReturnType<typeof useGetCurrentCreditAgreementFullArtifactsForOrganizationQuery>;
export type GetCurrentCreditAgreementFullArtifactsForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentCreditAgreementFullArtifactsForOrganizationLazyQueryGQLType>;
export type GetCurrentCreditAgreementFullArtifactsForOrganizationQueryResultGQLType = Apollo.QueryResult<GetCurrentCreditAgreementFullArtifactsForOrganizationQueryGQLType, GetCurrentCreditAgreementFullArtifactsForOrganizationQueryVariablesGQLType>;
export const GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesDocumentGQLType = gql`
    query GetCurrentCreditAgreementFullArtifactsForCreditFacilities($creditFacilityIds: [UUID!]!) {
  currentCreditAgreementFullArtifacts(creditFacilityIds: $creditFacilityIds) {
    id
    creditAgreement
    creditFacilityId
  }
}
    `;

/**
 * __useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryGQLType, GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryGQLType, GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryVariablesGQLType>(GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesDocumentGQLType, options);
      }
export function useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryGQLType, GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryGQLType, GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryVariablesGQLType>(GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesDocumentGQLType, options);
        }
export type GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryHookResult = ReturnType<typeof useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQuery>;
export type GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentCreditAgreementFullArtifactsForCreditFacilitiesLazyQueryGQLType>;
export type GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryGQLType, GetCurrentCreditAgreementFullArtifactsForCreditFacilitiesQueryVariablesGQLType>;
export const DoesCreditAgreementWipExistDocumentGQLType = gql`
    query DoesCreditAgreementWipExist($creditFacilityId: UUID!) {
  doesCreditAgreementWipExist(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useDoesCreditAgreementWipExistQuery__
 *
 * To run a query within a React component, call `useDoesCreditAgreementWipExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoesCreditAgreementWipExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoesCreditAgreementWipExistQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useDoesCreditAgreementWipExistQuery(baseOptions: Apollo.QueryHookOptions<DoesCreditAgreementWipExistQueryGQLType, DoesCreditAgreementWipExistQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoesCreditAgreementWipExistQueryGQLType, DoesCreditAgreementWipExistQueryVariablesGQLType>(DoesCreditAgreementWipExistDocumentGQLType, options);
      }
export function useDoesCreditAgreementWipExistLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<DoesCreditAgreementWipExistQueryGQLType, DoesCreditAgreementWipExistQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoesCreditAgreementWipExistQueryGQLType, DoesCreditAgreementWipExistQueryVariablesGQLType>(DoesCreditAgreementWipExistDocumentGQLType, options);
        }
export type DoesCreditAgreementWipExistQueryHookResult = ReturnType<typeof useDoesCreditAgreementWipExistQuery>;
export type DoesCreditAgreementWipExistLazyQueryGQLTypeHookResult = ReturnType<typeof useDoesCreditAgreementWipExistLazyQueryGQLType>;
export type DoesCreditAgreementWipExistQueryResultGQLType = Apollo.QueryResult<DoesCreditAgreementWipExistQueryGQLType, DoesCreditAgreementWipExistQueryVariablesGQLType>;
export const GetCreditAgreementDownloadUrlDocumentGQLType = gql`
    query GetCreditAgreementDownloadUrl($creditFacilityId: UUID!) {
  getCreditAgreementS3Path(creditFacilityId: $creditFacilityId) {
    downloadUrl
    fileName
  }
}
    `;

/**
 * __useGetCreditAgreementDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementDownloadUrlQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditAgreementDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementDownloadUrlQueryGQLType, GetCreditAgreementDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementDownloadUrlQueryGQLType, GetCreditAgreementDownloadUrlQueryVariablesGQLType>(GetCreditAgreementDownloadUrlDocumentGQLType, options);
      }
export function useGetCreditAgreementDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementDownloadUrlQueryGQLType, GetCreditAgreementDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementDownloadUrlQueryGQLType, GetCreditAgreementDownloadUrlQueryVariablesGQLType>(GetCreditAgreementDownloadUrlDocumentGQLType, options);
        }
export type GetCreditAgreementDownloadUrlQueryHookResult = ReturnType<typeof useGetCreditAgreementDownloadUrlQuery>;
export type GetCreditAgreementDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementDownloadUrlLazyQueryGQLType>;
export type GetCreditAgreementDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementDownloadUrlQueryGQLType, GetCreditAgreementDownloadUrlQueryVariablesGQLType>;
export const GetCreditAgreementBorrowerEntityNameDocumentGQLType = gql`
    query GetCreditAgreementBorrowerEntityName($creditFacilityId: UUID!) {
  creditAgreementBorrowerEntityName(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useGetCreditAgreementBorrowerEntityNameQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementBorrowerEntityNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementBorrowerEntityNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementBorrowerEntityNameQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditAgreementBorrowerEntityNameQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementBorrowerEntityNameQueryGQLType, GetCreditAgreementBorrowerEntityNameQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementBorrowerEntityNameQueryGQLType, GetCreditAgreementBorrowerEntityNameQueryVariablesGQLType>(GetCreditAgreementBorrowerEntityNameDocumentGQLType, options);
      }
export function useGetCreditAgreementBorrowerEntityNameLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementBorrowerEntityNameQueryGQLType, GetCreditAgreementBorrowerEntityNameQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementBorrowerEntityNameQueryGQLType, GetCreditAgreementBorrowerEntityNameQueryVariablesGQLType>(GetCreditAgreementBorrowerEntityNameDocumentGQLType, options);
        }
export type GetCreditAgreementBorrowerEntityNameQueryHookResult = ReturnType<typeof useGetCreditAgreementBorrowerEntityNameQuery>;
export type GetCreditAgreementBorrowerEntityNameLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementBorrowerEntityNameLazyQueryGQLType>;
export type GetCreditAgreementBorrowerEntityNameQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementBorrowerEntityNameQueryGQLType, GetCreditAgreementBorrowerEntityNameQueryVariablesGQLType>;
export const GetCreditAgreementEglibilityTestsBaseFieldsDocumentGQLType = gql`
    query GetCreditAgreementEglibilityTestsBaseFields($organizationId: UUID!) {
  creditAgreementEligibilityTestsBaseFields(organizationId: $organizationId)
}
    `;

/**
 * __useGetCreditAgreementEglibilityTestsBaseFieldsQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementEglibilityTestsBaseFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementEglibilityTestsBaseFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementEglibilityTestsBaseFieldsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditAgreementEglibilityTestsBaseFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementEglibilityTestsBaseFieldsQueryGQLType, GetCreditAgreementEglibilityTestsBaseFieldsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementEglibilityTestsBaseFieldsQueryGQLType, GetCreditAgreementEglibilityTestsBaseFieldsQueryVariablesGQLType>(GetCreditAgreementEglibilityTestsBaseFieldsDocumentGQLType, options);
      }
export function useGetCreditAgreementEglibilityTestsBaseFieldsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementEglibilityTestsBaseFieldsQueryGQLType, GetCreditAgreementEglibilityTestsBaseFieldsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementEglibilityTestsBaseFieldsQueryGQLType, GetCreditAgreementEglibilityTestsBaseFieldsQueryVariablesGQLType>(GetCreditAgreementEglibilityTestsBaseFieldsDocumentGQLType, options);
        }
export type GetCreditAgreementEglibilityTestsBaseFieldsQueryHookResult = ReturnType<typeof useGetCreditAgreementEglibilityTestsBaseFieldsQuery>;
export type GetCreditAgreementEglibilityTestsBaseFieldsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementEglibilityTestsBaseFieldsLazyQueryGQLType>;
export type GetCreditAgreementEglibilityTestsBaseFieldsQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementEglibilityTestsBaseFieldsQueryGQLType, GetCreditAgreementEglibilityTestsBaseFieldsQueryVariablesGQLType>;
export const GetCreditAgreementCapitalProviderOrganizationsDocumentGQLType = gql`
    query GetCreditAgreementCapitalProviderOrganizations($creditFacilityIds: [UUID!]!) {
  creditAgreementCapitalProviderOrganizations(
    creditFacilityIds: $creditFacilityIds
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetCreditAgreementCapitalProviderOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetCreditAgreementCapitalProviderOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditAgreementCapitalProviderOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditAgreementCapitalProviderOrganizationsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetCreditAgreementCapitalProviderOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditAgreementCapitalProviderOrganizationsQueryGQLType, GetCreditAgreementCapitalProviderOrganizationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditAgreementCapitalProviderOrganizationsQueryGQLType, GetCreditAgreementCapitalProviderOrganizationsQueryVariablesGQLType>(GetCreditAgreementCapitalProviderOrganizationsDocumentGQLType, options);
      }
export function useGetCreditAgreementCapitalProviderOrganizationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditAgreementCapitalProviderOrganizationsQueryGQLType, GetCreditAgreementCapitalProviderOrganizationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditAgreementCapitalProviderOrganizationsQueryGQLType, GetCreditAgreementCapitalProviderOrganizationsQueryVariablesGQLType>(GetCreditAgreementCapitalProviderOrganizationsDocumentGQLType, options);
        }
export type GetCreditAgreementCapitalProviderOrganizationsQueryHookResult = ReturnType<typeof useGetCreditAgreementCapitalProviderOrganizationsQuery>;
export type GetCreditAgreementCapitalProviderOrganizationsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditAgreementCapitalProviderOrganizationsLazyQueryGQLType>;
export type GetCreditAgreementCapitalProviderOrganizationsQueryResultGQLType = Apollo.QueryResult<GetCreditAgreementCapitalProviderOrganizationsQueryGQLType, GetCreditAgreementCapitalProviderOrganizationsQueryVariablesGQLType>;
export const ConvertCreditAgreementFullArtifactIdsDocumentGQLType = gql`
    query ConvertCreditAgreementFullArtifactIds($creditAgreementFullArtifact: CreditAgreementFullArtifactInput!) {
  convertCreditAgreementFullArtifactIds(
    creditAgreementFullArtifact: $creditAgreementFullArtifact
  ) {
    creditAgreement
  }
}
    `;

/**
 * __useConvertCreditAgreementFullArtifactIdsQuery__
 *
 * To run a query within a React component, call `useConvertCreditAgreementFullArtifactIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertCreditAgreementFullArtifactIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertCreditAgreementFullArtifactIdsQuery({
 *   variables: {
 *      creditAgreementFullArtifact: // value for 'creditAgreementFullArtifact'
 *   },
 * });
 */
export function useConvertCreditAgreementFullArtifactIdsQuery(baseOptions: Apollo.QueryHookOptions<ConvertCreditAgreementFullArtifactIdsQueryGQLType, ConvertCreditAgreementFullArtifactIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConvertCreditAgreementFullArtifactIdsQueryGQLType, ConvertCreditAgreementFullArtifactIdsQueryVariablesGQLType>(ConvertCreditAgreementFullArtifactIdsDocumentGQLType, options);
      }
export function useConvertCreditAgreementFullArtifactIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ConvertCreditAgreementFullArtifactIdsQueryGQLType, ConvertCreditAgreementFullArtifactIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConvertCreditAgreementFullArtifactIdsQueryGQLType, ConvertCreditAgreementFullArtifactIdsQueryVariablesGQLType>(ConvertCreditAgreementFullArtifactIdsDocumentGQLType, options);
        }
export type ConvertCreditAgreementFullArtifactIdsQueryHookResult = ReturnType<typeof useConvertCreditAgreementFullArtifactIdsQuery>;
export type ConvertCreditAgreementFullArtifactIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useConvertCreditAgreementFullArtifactIdsLazyQueryGQLType>;
export type ConvertCreditAgreementFullArtifactIdsQueryResultGQLType = Apollo.QueryResult<ConvertCreditAgreementFullArtifactIdsQueryGQLType, ConvertCreditAgreementFullArtifactIdsQueryVariablesGQLType>;
export const EvaluatePortfolioCovenantPostgresQueryDocumentGQLType = gql`
    query EvaluatePortfolioCovenantPostgresQuery($creditAgreementId: UUID!, $postgresQuery: PostgresQuery!) {
  evaluatePortfolioCovenantPostgresQuery(
    creditAgreementId: $creditAgreementId
    postgresQuery: $postgresQuery
  ) {
    result {
      name
      value
    }
    warnings
    inputs {
      ... on PrincipalBalanceDailyAverageInputValues {
        type
        inputValues {
          date
          value
        }
      }
      ... on TAccountsSumInputValues {
        type
        inputValues {
          tAccount
          counterpartySlug
          value
        }
      }
      ... on OrgProvidedInputInputValues {
        type
        inputValues {
          reportingDate
          version
          orgProvidedInputValue
        }
      }
    }
  }
}
    `;

/**
 * __useEvaluatePortfolioCovenantPostgresQueryQuery__
 *
 * To run a query within a React component, call `useEvaluatePortfolioCovenantPostgresQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluatePortfolioCovenantPostgresQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluatePortfolioCovenantPostgresQueryQuery({
 *   variables: {
 *      creditAgreementId: // value for 'creditAgreementId'
 *      postgresQuery: // value for 'postgresQuery'
 *   },
 * });
 */
export function useEvaluatePortfolioCovenantPostgresQueryQuery(baseOptions: Apollo.QueryHookOptions<EvaluatePortfolioCovenantPostgresQueryQueryGQLType, EvaluatePortfolioCovenantPostgresQueryQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluatePortfolioCovenantPostgresQueryQueryGQLType, EvaluatePortfolioCovenantPostgresQueryQueryVariablesGQLType>(EvaluatePortfolioCovenantPostgresQueryDocumentGQLType, options);
      }
export function useEvaluatePortfolioCovenantPostgresQueryLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<EvaluatePortfolioCovenantPostgresQueryQueryGQLType, EvaluatePortfolioCovenantPostgresQueryQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluatePortfolioCovenantPostgresQueryQueryGQLType, EvaluatePortfolioCovenantPostgresQueryQueryVariablesGQLType>(EvaluatePortfolioCovenantPostgresQueryDocumentGQLType, options);
        }
export type EvaluatePortfolioCovenantPostgresQueryQueryHookResult = ReturnType<typeof useEvaluatePortfolioCovenantPostgresQueryQuery>;
export type EvaluatePortfolioCovenantPostgresQueryLazyQueryGQLTypeHookResult = ReturnType<typeof useEvaluatePortfolioCovenantPostgresQueryLazyQueryGQLType>;
export type EvaluatePortfolioCovenantPostgresQueryQueryResultGQLType = Apollo.QueryResult<EvaluatePortfolioCovenantPostgresQueryQueryGQLType, EvaluatePortfolioCovenantPostgresQueryQueryVariablesGQLType>;
export const GetLoanMechanicsSerializedDocumentGQLType = gql`
    query GetLoanMechanicsSerialized($creditFacilityId: UUID!) {
  loanMechanicsSerialized(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useGetLoanMechanicsSerializedQuery__
 *
 * To run a query within a React component, call `useGetLoanMechanicsSerializedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanMechanicsSerializedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanMechanicsSerializedQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLoanMechanicsSerializedQuery(baseOptions: Apollo.QueryHookOptions<GetLoanMechanicsSerializedQueryGQLType, GetLoanMechanicsSerializedQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanMechanicsSerializedQueryGQLType, GetLoanMechanicsSerializedQueryVariablesGQLType>(GetLoanMechanicsSerializedDocumentGQLType, options);
      }
export function useGetLoanMechanicsSerializedLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanMechanicsSerializedQueryGQLType, GetLoanMechanicsSerializedQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanMechanicsSerializedQueryGQLType, GetLoanMechanicsSerializedQueryVariablesGQLType>(GetLoanMechanicsSerializedDocumentGQLType, options);
        }
export type GetLoanMechanicsSerializedQueryHookResult = ReturnType<typeof useGetLoanMechanicsSerializedQuery>;
export type GetLoanMechanicsSerializedLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanMechanicsSerializedLazyQueryGQLType>;
export type GetLoanMechanicsSerializedQueryResultGQLType = Apollo.QueryResult<GetLoanMechanicsSerializedQueryGQLType, GetLoanMechanicsSerializedQueryVariablesGQLType>;
export const RemoveCreditAgreementFullArtifactWipDocumentGQLType = gql`
    mutation RemoveCreditAgreementFullArtifactWip($creditFacilityId: UUID!) {
  removeCreditAgreementFullArtifactWip(creditFacilityId: $creditFacilityId) {
    response
  }
}
    `;
export type RemoveCreditAgreementFullArtifactWipMutationFnGQLType = Apollo.MutationFunction<RemoveCreditAgreementFullArtifactWipMutationGQLType, RemoveCreditAgreementFullArtifactWipMutationVariablesGQLType>;

/**
 * __useRemoveCreditAgreementFullArtifactWipMutation__
 *
 * To run a mutation, you first call `useRemoveCreditAgreementFullArtifactWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreditAgreementFullArtifactWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreditAgreementFullArtifactWipMutation, { data, loading, error }] = useRemoveCreditAgreementFullArtifactWipMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useRemoveCreditAgreementFullArtifactWipMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreditAgreementFullArtifactWipMutationGQLType, RemoveCreditAgreementFullArtifactWipMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreditAgreementFullArtifactWipMutationGQLType, RemoveCreditAgreementFullArtifactWipMutationVariablesGQLType>(RemoveCreditAgreementFullArtifactWipDocumentGQLType, options);
      }
export type RemoveCreditAgreementFullArtifactWipMutationHookResult = ReturnType<typeof useRemoveCreditAgreementFullArtifactWipMutation>;
export type RemoveCreditAgreementFullArtifactWipMutationResultGQLType = Apollo.MutationResult<RemoveCreditAgreementFullArtifactWipMutationGQLType>;
export type RemoveCreditAgreementFullArtifactWipMutationOptionsGQLType = Apollo.BaseMutationOptions<RemoveCreditAgreementFullArtifactWipMutationGQLType, RemoveCreditAgreementFullArtifactWipMutationVariablesGQLType>;
export const UpdateCreditAgreementFullArtifactWipDocumentGQLType = gql`
    mutation UpdateCreditAgreementFullArtifactWip($creditAgreementFullArtifactWip: CreditAgreementFullArtifactInput!) {
  updateCreditAgreementFullArtifactWip(
    creditAgreementFullArtifactWip: $creditAgreementFullArtifactWip
  ) {
    response
  }
}
    `;
export type UpdateCreditAgreementFullArtifactWipMutationFnGQLType = Apollo.MutationFunction<UpdateCreditAgreementFullArtifactWipMutationGQLType, UpdateCreditAgreementFullArtifactWipMutationVariablesGQLType>;

/**
 * __useUpdateCreditAgreementFullArtifactWipMutation__
 *
 * To run a mutation, you first call `useUpdateCreditAgreementFullArtifactWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditAgreementFullArtifactWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditAgreementFullArtifactWipMutation, { data, loading, error }] = useUpdateCreditAgreementFullArtifactWipMutation({
 *   variables: {
 *      creditAgreementFullArtifactWip: // value for 'creditAgreementFullArtifactWip'
 *   },
 * });
 */
export function useUpdateCreditAgreementFullArtifactWipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCreditAgreementFullArtifactWipMutationGQLType, UpdateCreditAgreementFullArtifactWipMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCreditAgreementFullArtifactWipMutationGQLType, UpdateCreditAgreementFullArtifactWipMutationVariablesGQLType>(UpdateCreditAgreementFullArtifactWipDocumentGQLType, options);
      }
export type UpdateCreditAgreementFullArtifactWipMutationHookResult = ReturnType<typeof useUpdateCreditAgreementFullArtifactWipMutation>;
export type UpdateCreditAgreementFullArtifactWipMutationResultGQLType = Apollo.MutationResult<UpdateCreditAgreementFullArtifactWipMutationGQLType>;
export type UpdateCreditAgreementFullArtifactWipMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateCreditAgreementFullArtifactWipMutationGQLType, UpdateCreditAgreementFullArtifactWipMutationVariablesGQLType>;
export const UpdateClientCreditAgreementFullArtifactWipDocumentGQLType = gql`
    mutation UpdateClientCreditAgreementFullArtifactWip($creditAgreementFullArtifactWip: CreditAgreementFullArtifactInput!) {
  updateClientCreditAgreementFullArtifactWip(
    creditAgreementFullArtifactWip: $creditAgreementFullArtifactWip
  ) {
    response
  }
}
    `;
export type UpdateClientCreditAgreementFullArtifactWipMutationFnGQLType = Apollo.MutationFunction<UpdateClientCreditAgreementFullArtifactWipMutationGQLType, UpdateClientCreditAgreementFullArtifactWipMutationVariablesGQLType>;

/**
 * __useUpdateClientCreditAgreementFullArtifactWipMutation__
 *
 * To run a mutation, you first call `useUpdateClientCreditAgreementFullArtifactWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCreditAgreementFullArtifactWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCreditAgreementFullArtifactWipMutation, { data, loading, error }] = useUpdateClientCreditAgreementFullArtifactWipMutation({
 *   variables: {
 *      creditAgreementFullArtifactWip: // value for 'creditAgreementFullArtifactWip'
 *   },
 * });
 */
export function useUpdateClientCreditAgreementFullArtifactWipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCreditAgreementFullArtifactWipMutationGQLType, UpdateClientCreditAgreementFullArtifactWipMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCreditAgreementFullArtifactWipMutationGQLType, UpdateClientCreditAgreementFullArtifactWipMutationVariablesGQLType>(UpdateClientCreditAgreementFullArtifactWipDocumentGQLType, options);
      }
export type UpdateClientCreditAgreementFullArtifactWipMutationHookResult = ReturnType<typeof useUpdateClientCreditAgreementFullArtifactWipMutation>;
export type UpdateClientCreditAgreementFullArtifactWipMutationResultGQLType = Apollo.MutationResult<UpdateClientCreditAgreementFullArtifactWipMutationGQLType>;
export type UpdateClientCreditAgreementFullArtifactWipMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateClientCreditAgreementFullArtifactWipMutationGQLType, UpdateClientCreditAgreementFullArtifactWipMutationVariablesGQLType>;
export const EvaluatePortfolioCovenantsDocumentGQLType = gql`
    mutation EvaluatePortfolioCovenants($evaluatePortfolioCovenantsRequest: EvaluatePortfolioCovenantsRequest!) {
  evaluatePortfolioCovenants(
    evaluatePortfolioCovenantsRequest: $evaluatePortfolioCovenantsRequest
  ) {
    response
    portfolioCovenantIds
  }
}
    `;
export type EvaluatePortfolioCovenantsMutationFnGQLType = Apollo.MutationFunction<EvaluatePortfolioCovenantsMutationGQLType, EvaluatePortfolioCovenantsMutationVariablesGQLType>;

/**
 * __useEvaluatePortfolioCovenantsMutation__
 *
 * To run a mutation, you first call `useEvaluatePortfolioCovenantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluatePortfolioCovenantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluatePortfolioCovenantsMutation, { data, loading, error }] = useEvaluatePortfolioCovenantsMutation({
 *   variables: {
 *      evaluatePortfolioCovenantsRequest: // value for 'evaluatePortfolioCovenantsRequest'
 *   },
 * });
 */
export function useEvaluatePortfolioCovenantsMutation(baseOptions?: Apollo.MutationHookOptions<EvaluatePortfolioCovenantsMutationGQLType, EvaluatePortfolioCovenantsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluatePortfolioCovenantsMutationGQLType, EvaluatePortfolioCovenantsMutationVariablesGQLType>(EvaluatePortfolioCovenantsDocumentGQLType, options);
      }
export type EvaluatePortfolioCovenantsMutationHookResult = ReturnType<typeof useEvaluatePortfolioCovenantsMutation>;
export type EvaluatePortfolioCovenantsMutationResultGQLType = Apollo.MutationResult<EvaluatePortfolioCovenantsMutationGQLType>;
export type EvaluatePortfolioCovenantsMutationOptionsGQLType = Apollo.BaseMutationOptions<EvaluatePortfolioCovenantsMutationGQLType, EvaluatePortfolioCovenantsMutationVariablesGQLType>;
export const EvaluateDevPortfolioCovenantWorkleaseDocumentGQLType = gql`
    mutation EvaluateDevPortfolioCovenantWorklease($worklease: EvaluatePortfolioCovenantsRequest!) {
  result: evaluateDevPortfolioCovenantWorklease(worklease: $worklease) {
    response
  }
}
    `;
export type EvaluateDevPortfolioCovenantWorkleaseMutationFnGQLType = Apollo.MutationFunction<EvaluateDevPortfolioCovenantWorkleaseMutationGQLType, EvaluateDevPortfolioCovenantWorkleaseMutationVariablesGQLType>;

/**
 * __useEvaluateDevPortfolioCovenantWorkleaseMutation__
 *
 * To run a mutation, you first call `useEvaluateDevPortfolioCovenantWorkleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateDevPortfolioCovenantWorkleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateDevPortfolioCovenantWorkleaseMutation, { data, loading, error }] = useEvaluateDevPortfolioCovenantWorkleaseMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useEvaluateDevPortfolioCovenantWorkleaseMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateDevPortfolioCovenantWorkleaseMutationGQLType, EvaluateDevPortfolioCovenantWorkleaseMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateDevPortfolioCovenantWorkleaseMutationGQLType, EvaluateDevPortfolioCovenantWorkleaseMutationVariablesGQLType>(EvaluateDevPortfolioCovenantWorkleaseDocumentGQLType, options);
      }
export type EvaluateDevPortfolioCovenantWorkleaseMutationHookResult = ReturnType<typeof useEvaluateDevPortfolioCovenantWorkleaseMutation>;
export type EvaluateDevPortfolioCovenantWorkleaseMutationResultGQLType = Apollo.MutationResult<EvaluateDevPortfolioCovenantWorkleaseMutationGQLType>;
export type EvaluateDevPortfolioCovenantWorkleaseMutationOptionsGQLType = Apollo.BaseMutationOptions<EvaluateDevPortfolioCovenantWorkleaseMutationGQLType, EvaluateDevPortfolioCovenantWorkleaseMutationVariablesGQLType>;
export const CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionDocumentGQLType = gql`
    mutation commitArtifactDocumentAndCreditAgreementsForPipelineDefinition($pipelineDefinitionId: UUID!, $creditFacilityId: UUID) {
  commitArtifactDocumentAndCreditAgreements(
    pipelineDefinitionId: $pipelineDefinitionId
    creditFacilityId: $creditFacilityId
  ) {
    successes
    errors
  }
}
    `;
export type CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationFnGQLType = Apollo.MutationFunction<CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationGQLType, CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationVariablesGQLType>;

/**
 * __useCommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation__
 *
 * To run a mutation, you first call `useCommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation, { data, loading, error }] = useCommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationGQLType, CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationGQLType, CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationVariablesGQLType>(CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionDocumentGQLType, options);
      }
export type CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationHookResult = ReturnType<typeof useCommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutation>;
export type CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationResultGQLType = Apollo.MutationResult<CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationGQLType>;
export type CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationOptionsGQLType = Apollo.BaseMutationOptions<CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationGQLType, CommitArtifactDocumentAndCreditAgreementsForPipelineDefinitionMutationVariablesGQLType>;
export const GetRecentMeshRunsDocumentGQLType = gql`
    query GetRecentMeshRuns($organizationId: UUID!, $creditFacilitySlugsToHide: [String!], $startDate: JSDate, $endDate: JSDate) {
  meshRuns: getRecentMeshRuns(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

/**
 * __useGetRecentMeshRunsQuery__
 *
 * To run a query within a React component, call `useGetRecentMeshRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentMeshRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentMeshRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetRecentMeshRunsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>(GetRecentMeshRunsDocumentGQLType, options);
      }
export function useGetRecentMeshRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>(GetRecentMeshRunsDocumentGQLType, options);
        }
export type GetRecentMeshRunsQueryHookResult = ReturnType<typeof useGetRecentMeshRunsQuery>;
export type GetRecentMeshRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRecentMeshRunsLazyQueryGQLType>;
export type GetRecentMeshRunsQueryResultGQLType = Apollo.QueryResult<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>;
export const GetLatestMeshRunDocumentGQLType = gql`
    query GetLatestMeshRun($implementationId: UUID!) {
  getLatestMeshRun(implementationId: $implementationId)
}
    `;

/**
 * __useGetLatestMeshRunQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshRunQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetLatestMeshRunQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>(GetLatestMeshRunDocumentGQLType, options);
      }
export function useGetLatestMeshRunLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>(GetLatestMeshRunDocumentGQLType, options);
        }
export type GetLatestMeshRunQueryHookResult = ReturnType<typeof useGetLatestMeshRunQuery>;
export type GetLatestMeshRunLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshRunLazyQueryGQLType>;
export type GetLatestMeshRunQueryResultGQLType = Apollo.QueryResult<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>;
export const GetBorrowerPipelineRunsDocumentGQLType = gql`
    query GetBorrowerPipelineRuns($borrowerOrganizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRuns(
    organizationId: $borrowerOrganizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
  }
}
    `;

/**
 * __useGetBorrowerPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetBorrowerPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowerPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowerPipelineRunsQuery({
 *   variables: {
 *      borrowerOrganizationId: // value for 'borrowerOrganizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetBorrowerPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>(GetBorrowerPipelineRunsDocumentGQLType, options);
      }
export function useGetBorrowerPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>(GetBorrowerPipelineRunsDocumentGQLType, options);
        }
export type GetBorrowerPipelineRunsQueryHookResult = ReturnType<typeof useGetBorrowerPipelineRunsQuery>;
export type GetBorrowerPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowerPipelineRunsLazyQueryGQLType>;
export type GetBorrowerPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>;
export const GetPipelineRunsWithArtifactIdsDocumentGQLType = gql`
    query GetPipelineRunsWithArtifactIds($borrowerOrganizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRunsWithArtifactIds(
    organizationId: $borrowerOrganizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
    uploadedArtifactIds
  }
}
    `;

/**
 * __useGetPipelineRunsWithArtifactIdsQuery__
 *
 * To run a query within a React component, call `useGetPipelineRunsWithArtifactIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineRunsWithArtifactIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineRunsWithArtifactIdsQuery({
 *   variables: {
 *      borrowerOrganizationId: // value for 'borrowerOrganizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetPipelineRunsWithArtifactIdsQuery(baseOptions: Apollo.QueryHookOptions<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>(GetPipelineRunsWithArtifactIdsDocumentGQLType, options);
      }
export function useGetPipelineRunsWithArtifactIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>(GetPipelineRunsWithArtifactIdsDocumentGQLType, options);
        }
export type GetPipelineRunsWithArtifactIdsQueryHookResult = ReturnType<typeof useGetPipelineRunsWithArtifactIdsQuery>;
export type GetPipelineRunsWithArtifactIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPipelineRunsWithArtifactIdsLazyQueryGQLType>;
export type GetPipelineRunsWithArtifactIdsQueryResultGQLType = Apollo.QueryResult<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>;
export const GetMaybeCompleteMeshRunRecordDocumentGQLType = gql`
    query GetMaybeCompleteMeshRunRecord($meshRunId: String, $meshRunParams: MeshRunParams) {
  maybeCompleteMeshRunRecord: getCompleteMeshRunRecordIfAvailable(
    meshRunId: $meshRunId
    meshRunParams: $meshRunParams
  )
}
    `;

/**
 * __useGetMaybeCompleteMeshRunRecordQuery__
 *
 * To run a query within a React component, call `useGetMaybeCompleteMeshRunRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaybeCompleteMeshRunRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaybeCompleteMeshRunRecordQuery({
 *   variables: {
 *      meshRunId: // value for 'meshRunId'
 *      meshRunParams: // value for 'meshRunParams'
 *   },
 * });
 */
export function useGetMaybeCompleteMeshRunRecordQuery(baseOptions?: Apollo.QueryHookOptions<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>(GetMaybeCompleteMeshRunRecordDocumentGQLType, options);
      }
export function useGetMaybeCompleteMeshRunRecordLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>(GetMaybeCompleteMeshRunRecordDocumentGQLType, options);
        }
export type GetMaybeCompleteMeshRunRecordQueryHookResult = ReturnType<typeof useGetMaybeCompleteMeshRunRecordQuery>;
export type GetMaybeCompleteMeshRunRecordLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMaybeCompleteMeshRunRecordLazyQueryGQLType>;
export type GetMaybeCompleteMeshRunRecordQueryResultGQLType = Apollo.QueryResult<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>;
export const GetLatestMeshDocumentsDocumentGQLType = gql`
    query GetLatestMeshDocuments($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]) {
  latestMeshDocuments: getLatestMeshDocuments(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  )
}
    `;

/**
 * __useGetLatestMeshDocumentsQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshDocumentsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetLatestMeshDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>(GetLatestMeshDocumentsDocumentGQLType, options);
      }
export function useGetLatestMeshDocumentsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>(GetLatestMeshDocumentsDocumentGQLType, options);
        }
export type GetLatestMeshDocumentsQueryHookResult = ReturnType<typeof useGetLatestMeshDocumentsQuery>;
export type GetLatestMeshDocumentsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshDocumentsLazyQueryGQLType>;
export type GetLatestMeshDocumentsQueryResultGQLType = Apollo.QueryResult<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>;
export const GetDataPipelineDownloadSignedUrlDocumentGQLType = gql`
    query getDataPipelineDownloadSignedUrl($serializedParams: String!) {
  downloadUrls: getSignedDownloadUrls(
    feature: "dataPipelineInstanceRecord"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetDataPipelineDownloadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDataPipelineDownloadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPipelineDownloadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPipelineDownloadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDataPipelineDownloadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>(GetDataPipelineDownloadSignedUrlDocumentGQLType, options);
      }
export function useGetDataPipelineDownloadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>(GetDataPipelineDownloadSignedUrlDocumentGQLType, options);
        }
export type GetDataPipelineDownloadSignedUrlQueryHookResult = ReturnType<typeof useGetDataPipelineDownloadSignedUrlQuery>;
export type GetDataPipelineDownloadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDataPipelineDownloadSignedUrlLazyQueryGQLType>;
export type GetDataPipelineDownloadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>;
export const GetDataPipelineUploadSignedUrlDocumentGQLType = gql`
    query getDataPipelineUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getDataPipelineUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetDataPipelineUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDataPipelineUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPipelineUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPipelineUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDataPipelineUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>(GetDataPipelineUploadSignedUrlDocumentGQLType, options);
      }
export function useGetDataPipelineUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>(GetDataPipelineUploadSignedUrlDocumentGQLType, options);
        }
export type GetDataPipelineUploadSignedUrlQueryHookResult = ReturnType<typeof useGetDataPipelineUploadSignedUrlQuery>;
export type GetDataPipelineUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDataPipelineUploadSignedUrlLazyQueryGQLType>;
export type GetDataPipelineUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>;
export const ReUploadLoanTapeDocumentGQLType = gql`
    mutation ReUploadLoanTape($implementationId: UUID!, $artifactId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!, $currentArtifactInstanceId: UUID!) {
  reUploadLoanTape(
    implementationId: $implementationId
    artifactId: $artifactId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    currentArtifactInstanceId: $currentArtifactInstanceId
  ) {
    response
  }
}
    `;
export type ReUploadLoanTapeMutationFnGQLType = Apollo.MutationFunction<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>;

/**
 * __useReUploadLoanTapeMutation__
 *
 * To run a mutation, you first call `useReUploadLoanTapeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReUploadLoanTapeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reUploadLoanTapeMutation, { data, loading, error }] = useReUploadLoanTapeMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      artifactId: // value for 'artifactId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      currentArtifactInstanceId: // value for 'currentArtifactInstanceId'
 *   },
 * });
 */
export function useReUploadLoanTapeMutation(baseOptions?: Apollo.MutationHookOptions<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>(ReUploadLoanTapeDocumentGQLType, options);
      }
export type ReUploadLoanTapeMutationHookResult = ReturnType<typeof useReUploadLoanTapeMutation>;
export type ReUploadLoanTapeMutationResultGQLType = Apollo.MutationResult<ReUploadLoanTapeMutationGQLType>;
export type ReUploadLoanTapeMutationOptionsGQLType = Apollo.BaseMutationOptions<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>;
export const GetEventLogsDocumentGQLType = gql`
    query GetEventLogs($params: EventLogPaginatedFeedParams!) {
  eventLogs(params: $params) {
    hasMore
    items {
      ...EventLogBaseEventFragment
      ...DeliverableThreadCreateEventFragment
      ...FundingRequestThreadCreateEventFragment
      ...FundingRequestCreatedEventFragment
      ...FundingRequestStatusChangeEventFragment
      ...InvoiceThreadCreateEventFragment
      ...InvoiceCreatedEventFragment
      ...InvoiceUpdatedEventFragment
      ...LimitedPartnerThreadCreateEventFragment
      ...LimitedPartnerCreatedEventFragment
      ...LimitedPartnerUpdatedEventFragment
      ...LimitedPartnerMappingMatchEventFragment
      ...LimitedPartnerMappingUnmatchEventFragment
      ...ValleyBankLoanAccountThreadCreateEventFragment
    }
  }
}
    ${EventLogBaseEventFragmentFragmentDocGQLType}
${DeliverableThreadCreateEventFragmentFragmentDocGQLType}
${FundingRequestThreadCreateEventFragmentFragmentDocGQLType}
${FundingRequestCreatedEventFragmentFragmentDocGQLType}
${FundingRequestStatusChangeEventFragmentFragmentDocGQLType}
${InvoiceThreadCreateEventFragmentFragmentDocGQLType}
${InvoiceCreatedEventFragmentFragmentDocGQLType}
${InvoiceUpdatedEventFragmentFragmentDocGQLType}
${LimitedPartnerThreadCreateEventFragmentFragmentDocGQLType}
${LimitedPartnerCreatedEventFragmentFragmentDocGQLType}
${LimitedPartnerUpdatedEventFragmentFragmentDocGQLType}
${LimitedPartnerMappingMatchEventFragmentFragmentDocGQLType}
${LimitedPartnerMappingUnmatchEventFragmentFragmentDocGQLType}
${ValleyBankLoanAccountThreadCreateEventFragmentFragmentDocGQLType}`;

/**
 * __useGetEventLogsQuery__
 *
 * To run a query within a React component, call `useGetEventLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetEventLogsQuery(baseOptions: Apollo.QueryHookOptions<GetEventLogsQueryGQLType, GetEventLogsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogsQueryGQLType, GetEventLogsQueryVariablesGQLType>(GetEventLogsDocumentGQLType, options);
      }
export function useGetEventLogsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogsQueryGQLType, GetEventLogsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogsQueryGQLType, GetEventLogsQueryVariablesGQLType>(GetEventLogsDocumentGQLType, options);
        }
export type GetEventLogsQueryHookResult = ReturnType<typeof useGetEventLogsQuery>;
export type GetEventLogsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEventLogsLazyQueryGQLType>;
export type GetEventLogsQueryResultGQLType = Apollo.QueryResult<GetEventLogsQueryGQLType, GetEventLogsQueryVariablesGQLType>;
export const GetActorFiltersDocumentGQLType = gql`
    query GetActorFilters {
  user {
    id
    organization {
      id
      name
      slug
      users {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetActorFiltersQuery__
 *
 * To run a query within a React component, call `useGetActorFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActorFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActorFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActorFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetActorFiltersQueryGQLType, GetActorFiltersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActorFiltersQueryGQLType, GetActorFiltersQueryVariablesGQLType>(GetActorFiltersDocumentGQLType, options);
      }
export function useGetActorFiltersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActorFiltersQueryGQLType, GetActorFiltersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActorFiltersQueryGQLType, GetActorFiltersQueryVariablesGQLType>(GetActorFiltersDocumentGQLType, options);
        }
export type GetActorFiltersQueryHookResult = ReturnType<typeof useGetActorFiltersQuery>;
export type GetActorFiltersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActorFiltersLazyQueryGQLType>;
export type GetActorFiltersQueryResultGQLType = Apollo.QueryResult<GetActorFiltersQueryGQLType, GetActorFiltersQueryVariablesGQLType>;
export const GetDeliverableFiltersDocumentGQLType = gql`
    query GetDeliverableFilters($creditFacilityIds: [UUID!]!, $limit: Int) {
  items: getDeliverableContainers(
    creditFacilityIds: $creditFacilityIds
    limit: $limit
  ) {
    deliverableId: id
    configName
    dueDate
    creditFacilityId
    creditFacilityName
    latestReceiptId
  }
}
    `;

/**
 * __useGetDeliverableFiltersQuery__
 *
 * To run a query within a React component, call `useGetDeliverableFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableFiltersQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDeliverableFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableFiltersQueryGQLType, GetDeliverableFiltersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableFiltersQueryGQLType, GetDeliverableFiltersQueryVariablesGQLType>(GetDeliverableFiltersDocumentGQLType, options);
      }
export function useGetDeliverableFiltersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableFiltersQueryGQLType, GetDeliverableFiltersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableFiltersQueryGQLType, GetDeliverableFiltersQueryVariablesGQLType>(GetDeliverableFiltersDocumentGQLType, options);
        }
export type GetDeliverableFiltersQueryHookResult = ReturnType<typeof useGetDeliverableFiltersQuery>;
export type GetDeliverableFiltersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableFiltersLazyQueryGQLType>;
export type GetDeliverableFiltersQueryResultGQLType = Apollo.QueryResult<GetDeliverableFiltersQueryGQLType, GetDeliverableFiltersQueryVariablesGQLType>;
export const GetFundingRequestFiltersDocumentGQLType = gql`
    query GetFundingRequestFilters($creditFacilityIds: [UUID!]!, $startDate: JSDate, $limit: Int) {
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    limit: $limit
  ) {
    items: nodes {
      fundingRequestId: id
      expire
      status
      created_at
      creditFacility {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetFundingRequestFiltersQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestFiltersQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFundingRequestFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestFiltersQueryGQLType, GetFundingRequestFiltersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestFiltersQueryGQLType, GetFundingRequestFiltersQueryVariablesGQLType>(GetFundingRequestFiltersDocumentGQLType, options);
      }
export function useGetFundingRequestFiltersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestFiltersQueryGQLType, GetFundingRequestFiltersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestFiltersQueryGQLType, GetFundingRequestFiltersQueryVariablesGQLType>(GetFundingRequestFiltersDocumentGQLType, options);
        }
export type GetFundingRequestFiltersQueryHookResult = ReturnType<typeof useGetFundingRequestFiltersQuery>;
export type GetFundingRequestFiltersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestFiltersLazyQueryGQLType>;
export type GetFundingRequestFiltersQueryResultGQLType = Apollo.QueryResult<GetFundingRequestFiltersQueryGQLType, GetFundingRequestFiltersQueryVariablesGQLType>;
export const GetLimitedPartnerFiltersDocumentGQLType = gql`
    query GetLimitedPartnerFilters($organizationId: UUID!, $queryString: String) {
  limitedPartners: getLimitedPartnersForOrganization(
    organizationId: $organizationId
    queryString: $queryString
  ) {
    id
    name
    alternateAliases
  }
}
    `;

/**
 * __useGetLimitedPartnerFiltersQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerFiltersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useGetLimitedPartnerFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerFiltersQueryGQLType, GetLimitedPartnerFiltersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerFiltersQueryGQLType, GetLimitedPartnerFiltersQueryVariablesGQLType>(GetLimitedPartnerFiltersDocumentGQLType, options);
      }
export function useGetLimitedPartnerFiltersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerFiltersQueryGQLType, GetLimitedPartnerFiltersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerFiltersQueryGQLType, GetLimitedPartnerFiltersQueryVariablesGQLType>(GetLimitedPartnerFiltersDocumentGQLType, options);
        }
export type GetLimitedPartnerFiltersQueryHookResult = ReturnType<typeof useGetLimitedPartnerFiltersQuery>;
export type GetLimitedPartnerFiltersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerFiltersLazyQueryGQLType>;
export type GetLimitedPartnerFiltersQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerFiltersQueryGQLType, GetLimitedPartnerFiltersQueryVariablesGQLType>;
export const GetInvoiceFiltersDocumentGQLType = gql`
    query GetInvoiceFilters($organizationId: UUID!) {
  invoices: getInvoicesByOrganizationId(organizationId: $organizationId) {
    id
    dueDate
    invoiceStatus: status
    totalAmount
  }
}
    `;

/**
 * __useGetInvoiceFiltersQuery__
 *
 * To run a query within a React component, call `useGetInvoiceFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceFiltersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvoiceFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceFiltersQueryGQLType, GetInvoiceFiltersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceFiltersQueryGQLType, GetInvoiceFiltersQueryVariablesGQLType>(GetInvoiceFiltersDocumentGQLType, options);
      }
export function useGetInvoiceFiltersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceFiltersQueryGQLType, GetInvoiceFiltersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceFiltersQueryGQLType, GetInvoiceFiltersQueryVariablesGQLType>(GetInvoiceFiltersDocumentGQLType, options);
        }
export type GetInvoiceFiltersQueryHookResult = ReturnType<typeof useGetInvoiceFiltersQuery>;
export type GetInvoiceFiltersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceFiltersLazyQueryGQLType>;
export type GetInvoiceFiltersQueryResultGQLType = Apollo.QueryResult<GetInvoiceFiltersQueryGQLType, GetInvoiceFiltersQueryVariablesGQLType>;
export const GetOrgExploPlacementIntegrationsDocumentGQLType = gql`
    query GetOrgExploPlacementIntegrations($organizationId: UUID!) {
  integrations: getOrgExploPlacementIntegrations(organizationId: $organizationId) {
    ...ExploPlacementIntegration
  }
}
    ${ExploPlacementIntegrationFragmentDocGQLType}`;

/**
 * __useGetOrgExploPlacementIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetOrgExploPlacementIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgExploPlacementIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgExploPlacementIntegrationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrgExploPlacementIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrgExploPlacementIntegrationsQueryGQLType, GetOrgExploPlacementIntegrationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgExploPlacementIntegrationsQueryGQLType, GetOrgExploPlacementIntegrationsQueryVariablesGQLType>(GetOrgExploPlacementIntegrationsDocumentGQLType, options);
      }
export function useGetOrgExploPlacementIntegrationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgExploPlacementIntegrationsQueryGQLType, GetOrgExploPlacementIntegrationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgExploPlacementIntegrationsQueryGQLType, GetOrgExploPlacementIntegrationsQueryVariablesGQLType>(GetOrgExploPlacementIntegrationsDocumentGQLType, options);
        }
export type GetOrgExploPlacementIntegrationsQueryHookResult = ReturnType<typeof useGetOrgExploPlacementIntegrationsQuery>;
export type GetOrgExploPlacementIntegrationsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgExploPlacementIntegrationsLazyQueryGQLType>;
export type GetOrgExploPlacementIntegrationsQueryResultGQLType = Apollo.QueryResult<GetOrgExploPlacementIntegrationsQueryGQLType, GetOrgExploPlacementIntegrationsQueryVariablesGQLType>;
export const GetExploDashboardsAndReportBuildersDocumentGQLType = gql`
    query GetExploDashboardsAndReportBuilders {
  response: getExploDashboardsAndReportBuilders {
    dashboards {
      name
      embedId
    }
    reportBuilders {
      name
      embedId
    }
  }
}
    `;

/**
 * __useGetExploDashboardsAndReportBuildersQuery__
 *
 * To run a query within a React component, call `useGetExploDashboardsAndReportBuildersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExploDashboardsAndReportBuildersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExploDashboardsAndReportBuildersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExploDashboardsAndReportBuildersQuery(baseOptions?: Apollo.QueryHookOptions<GetExploDashboardsAndReportBuildersQueryGQLType, GetExploDashboardsAndReportBuildersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExploDashboardsAndReportBuildersQueryGQLType, GetExploDashboardsAndReportBuildersQueryVariablesGQLType>(GetExploDashboardsAndReportBuildersDocumentGQLType, options);
      }
export function useGetExploDashboardsAndReportBuildersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetExploDashboardsAndReportBuildersQueryGQLType, GetExploDashboardsAndReportBuildersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExploDashboardsAndReportBuildersQueryGQLType, GetExploDashboardsAndReportBuildersQueryVariablesGQLType>(GetExploDashboardsAndReportBuildersDocumentGQLType, options);
        }
export type GetExploDashboardsAndReportBuildersQueryHookResult = ReturnType<typeof useGetExploDashboardsAndReportBuildersQuery>;
export type GetExploDashboardsAndReportBuildersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetExploDashboardsAndReportBuildersLazyQueryGQLType>;
export type GetExploDashboardsAndReportBuildersQueryResultGQLType = Apollo.QueryResult<GetExploDashboardsAndReportBuildersQueryGQLType, GetExploDashboardsAndReportBuildersQueryVariablesGQLType>;
export const GenerateExploApiJwtDocumentGQLType = gql`
    query GenerateExploApiJwt($organizationId: UUID!, $creditFacilityId: UUID, $exploArtifactType: ExploArtifactType!, $exploPlacement: ExploPlacementOptions!) {
  tokenResponse: generateExploApiJwt(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
    exploArtifactType: $exploArtifactType
    exploPlacement: $exploPlacement
  ) {
    isIntegrationAvailable
    jwt
    error
  }
}
    `;

/**
 * __useGenerateExploApiJwtQuery__
 *
 * To run a query within a React component, call `useGenerateExploApiJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateExploApiJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateExploApiJwtQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      exploArtifactType: // value for 'exploArtifactType'
 *      exploPlacement: // value for 'exploPlacement'
 *   },
 * });
 */
export function useGenerateExploApiJwtQuery(baseOptions: Apollo.QueryHookOptions<GenerateExploApiJwtQueryGQLType, GenerateExploApiJwtQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateExploApiJwtQueryGQLType, GenerateExploApiJwtQueryVariablesGQLType>(GenerateExploApiJwtDocumentGQLType, options);
      }
export function useGenerateExploApiJwtLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GenerateExploApiJwtQueryGQLType, GenerateExploApiJwtQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateExploApiJwtQueryGQLType, GenerateExploApiJwtQueryVariablesGQLType>(GenerateExploApiJwtDocumentGQLType, options);
        }
export type GenerateExploApiJwtQueryHookResult = ReturnType<typeof useGenerateExploApiJwtQuery>;
export type GenerateExploApiJwtLazyQueryGQLTypeHookResult = ReturnType<typeof useGenerateExploApiJwtLazyQueryGQLType>;
export type GenerateExploApiJwtQueryResultGQLType = Apollo.QueryResult<GenerateExploApiJwtQueryGQLType, GenerateExploApiJwtQueryVariablesGQLType>;
export const CreateExploPlacementIntegrationDocumentGQLType = gql`
    mutation CreateExploPlacementIntegration($createParams: CreateExploPlacementIntegrationParams!) {
  integration: createExploPlacementIntegration(createParams: $createParams) {
    ...ExploPlacementIntegration
  }
}
    ${ExploPlacementIntegrationFragmentDocGQLType}`;
export type CreateExploPlacementIntegrationMutationFnGQLType = Apollo.MutationFunction<CreateExploPlacementIntegrationMutationGQLType, CreateExploPlacementIntegrationMutationVariablesGQLType>;

/**
 * __useCreateExploPlacementIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateExploPlacementIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploPlacementIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploPlacementIntegrationMutation, { data, loading, error }] = useCreateExploPlacementIntegrationMutation({
 *   variables: {
 *      createParams: // value for 'createParams'
 *   },
 * });
 */
export function useCreateExploPlacementIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateExploPlacementIntegrationMutationGQLType, CreateExploPlacementIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExploPlacementIntegrationMutationGQLType, CreateExploPlacementIntegrationMutationVariablesGQLType>(CreateExploPlacementIntegrationDocumentGQLType, options);
      }
export type CreateExploPlacementIntegrationMutationHookResult = ReturnType<typeof useCreateExploPlacementIntegrationMutation>;
export type CreateExploPlacementIntegrationMutationResultGQLType = Apollo.MutationResult<CreateExploPlacementIntegrationMutationGQLType>;
export type CreateExploPlacementIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateExploPlacementIntegrationMutationGQLType, CreateExploPlacementIntegrationMutationVariablesGQLType>;
export const DeleteExploPlacementIntegrationDocumentGQLType = gql`
    mutation DeleteExploPlacementIntegration($exploPlacementIntegrationId: UUID!, $organizationId: UUID!) {
  response: deleteExploPlacementIntegration(
    exploPlacementIntegrationId: $exploPlacementIntegrationId
    organizationId: $organizationId
  )
}
    `;
export type DeleteExploPlacementIntegrationMutationFnGQLType = Apollo.MutationFunction<DeleteExploPlacementIntegrationMutationGQLType, DeleteExploPlacementIntegrationMutationVariablesGQLType>;

/**
 * __useDeleteExploPlacementIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteExploPlacementIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExploPlacementIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExploPlacementIntegrationMutation, { data, loading, error }] = useDeleteExploPlacementIntegrationMutation({
 *   variables: {
 *      exploPlacementIntegrationId: // value for 'exploPlacementIntegrationId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteExploPlacementIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExploPlacementIntegrationMutationGQLType, DeleteExploPlacementIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExploPlacementIntegrationMutationGQLType, DeleteExploPlacementIntegrationMutationVariablesGQLType>(DeleteExploPlacementIntegrationDocumentGQLType, options);
      }
export type DeleteExploPlacementIntegrationMutationHookResult = ReturnType<typeof useDeleteExploPlacementIntegrationMutation>;
export type DeleteExploPlacementIntegrationMutationResultGQLType = Apollo.MutationResult<DeleteExploPlacementIntegrationMutationGQLType>;
export type DeleteExploPlacementIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteExploPlacementIntegrationMutationGQLType, DeleteExploPlacementIntegrationMutationVariablesGQLType>;
export const UpdateExploPlacementIntegrationDocumentGQLType = gql`
    mutation UpdateExploPlacementIntegration($exploPlacementIntegrationId: UUID!, $organizationId: UUID!, $updateParams: UpdateExploPlacementIntegrationParams!) {
  response: updateExploPlacementIntegration(
    exploPlacementIntegrationId: $exploPlacementIntegrationId
    organizationId: $organizationId
    updateParams: $updateParams
  ) {
    ...ExploPlacementIntegration
  }
}
    ${ExploPlacementIntegrationFragmentDocGQLType}`;
export type UpdateExploPlacementIntegrationMutationFnGQLType = Apollo.MutationFunction<UpdateExploPlacementIntegrationMutationGQLType, UpdateExploPlacementIntegrationMutationVariablesGQLType>;

/**
 * __useUpdateExploPlacementIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateExploPlacementIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExploPlacementIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExploPlacementIntegrationMutation, { data, loading, error }] = useUpdateExploPlacementIntegrationMutation({
 *   variables: {
 *      exploPlacementIntegrationId: // value for 'exploPlacementIntegrationId'
 *      organizationId: // value for 'organizationId'
 *      updateParams: // value for 'updateParams'
 *   },
 * });
 */
export function useUpdateExploPlacementIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExploPlacementIntegrationMutationGQLType, UpdateExploPlacementIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExploPlacementIntegrationMutationGQLType, UpdateExploPlacementIntegrationMutationVariablesGQLType>(UpdateExploPlacementIntegrationDocumentGQLType, options);
      }
export type UpdateExploPlacementIntegrationMutationHookResult = ReturnType<typeof useUpdateExploPlacementIntegrationMutation>;
export type UpdateExploPlacementIntegrationMutationResultGQLType = Apollo.MutationResult<UpdateExploPlacementIntegrationMutationGQLType>;
export type UpdateExploPlacementIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateExploPlacementIntegrationMutationGQLType, UpdateExploPlacementIntegrationMutationVariablesGQLType>;
export const GetDeliverableSubmissionSignedUrlDocumentGQLType = gql`
    query getDeliverableSubmissionSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "deliverableSubmission"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetDeliverableSubmissionSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDeliverableSubmissionSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliverableSubmissionSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliverableSubmissionSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDeliverableSubmissionSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDeliverableSubmissionSignedUrlQueryGQLType, GetDeliverableSubmissionSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliverableSubmissionSignedUrlQueryGQLType, GetDeliverableSubmissionSignedUrlQueryVariablesGQLType>(GetDeliverableSubmissionSignedUrlDocumentGQLType, options);
      }
export function useGetDeliverableSubmissionSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliverableSubmissionSignedUrlQueryGQLType, GetDeliverableSubmissionSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliverableSubmissionSignedUrlQueryGQLType, GetDeliverableSubmissionSignedUrlQueryVariablesGQLType>(GetDeliverableSubmissionSignedUrlDocumentGQLType, options);
        }
export type GetDeliverableSubmissionSignedUrlQueryHookResult = ReturnType<typeof useGetDeliverableSubmissionSignedUrlQuery>;
export type GetDeliverableSubmissionSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDeliverableSubmissionSignedUrlLazyQueryGQLType>;
export type GetDeliverableSubmissionSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDeliverableSubmissionSignedUrlQueryGQLType, GetDeliverableSubmissionSignedUrlQueryVariablesGQLType>;
export const GetReportingTemplateUploadSignedUrlDocumentGQLType = gql`
    query getReportingTemplateUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getReportingTemplateUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetReportingTemplateUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetReportingTemplateUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingTemplateUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingTemplateUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetReportingTemplateUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReportingTemplateUploadSignedUrlQueryGQLType, GetReportingTemplateUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingTemplateUploadSignedUrlQueryGQLType, GetReportingTemplateUploadSignedUrlQueryVariablesGQLType>(GetReportingTemplateUploadSignedUrlDocumentGQLType, options);
      }
export function useGetReportingTemplateUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingTemplateUploadSignedUrlQueryGQLType, GetReportingTemplateUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingTemplateUploadSignedUrlQueryGQLType, GetReportingTemplateUploadSignedUrlQueryVariablesGQLType>(GetReportingTemplateUploadSignedUrlDocumentGQLType, options);
        }
export type GetReportingTemplateUploadSignedUrlQueryHookResult = ReturnType<typeof useGetReportingTemplateUploadSignedUrlQuery>;
export type GetReportingTemplateUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportingTemplateUploadSignedUrlLazyQueryGQLType>;
export type GetReportingTemplateUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetReportingTemplateUploadSignedUrlQueryGQLType, GetReportingTemplateUploadSignedUrlQueryVariablesGQLType>;
export const GetReceivableDocumentationUploadSignedUrlDocumentGQLType = gql`
    query getReceivableDocumentationUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getReceivableDocumentationUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetReceivableDocumentationUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetReceivableDocumentationUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivableDocumentationUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivableDocumentationUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetReceivableDocumentationUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReceivableDocumentationUploadSignedUrlQueryGQLType, GetReceivableDocumentationUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivableDocumentationUploadSignedUrlQueryGQLType, GetReceivableDocumentationUploadSignedUrlQueryVariablesGQLType>(GetReceivableDocumentationUploadSignedUrlDocumentGQLType, options);
      }
export function useGetReceivableDocumentationUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivableDocumentationUploadSignedUrlQueryGQLType, GetReceivableDocumentationUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivableDocumentationUploadSignedUrlQueryGQLType, GetReceivableDocumentationUploadSignedUrlQueryVariablesGQLType>(GetReceivableDocumentationUploadSignedUrlDocumentGQLType, options);
        }
export type GetReceivableDocumentationUploadSignedUrlQueryHookResult = ReturnType<typeof useGetReceivableDocumentationUploadSignedUrlQuery>;
export type GetReceivableDocumentationUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReceivableDocumentationUploadSignedUrlLazyQueryGQLType>;
export type GetReceivableDocumentationUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetReceivableDocumentationUploadSignedUrlQueryGQLType, GetReceivableDocumentationUploadSignedUrlQueryVariablesGQLType>;
export const GetOrgProvidedValuesUploadDestinationDocumentGQLType = gql`
    query getOrgProvidedValuesUploadDestination($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getOrgProvidedValuesUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetOrgProvidedValuesUploadDestinationQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedValuesUploadDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedValuesUploadDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedValuesUploadDestinationQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetOrgProvidedValuesUploadDestinationQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedValuesUploadDestinationQueryGQLType, GetOrgProvidedValuesUploadDestinationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedValuesUploadDestinationQueryGQLType, GetOrgProvidedValuesUploadDestinationQueryVariablesGQLType>(GetOrgProvidedValuesUploadDestinationDocumentGQLType, options);
      }
export function useGetOrgProvidedValuesUploadDestinationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedValuesUploadDestinationQueryGQLType, GetOrgProvidedValuesUploadDestinationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedValuesUploadDestinationQueryGQLType, GetOrgProvidedValuesUploadDestinationQueryVariablesGQLType>(GetOrgProvidedValuesUploadDestinationDocumentGQLType, options);
        }
export type GetOrgProvidedValuesUploadDestinationQueryHookResult = ReturnType<typeof useGetOrgProvidedValuesUploadDestinationQuery>;
export type GetOrgProvidedValuesUploadDestinationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedValuesUploadDestinationLazyQueryGQLType>;
export type GetOrgProvidedValuesUploadDestinationQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedValuesUploadDestinationQueryGQLType, GetOrgProvidedValuesUploadDestinationQueryVariablesGQLType>;
export const GetActiveRailzConnectionsByOrgIdDocumentGQLType = gql`
    query GetActiveRailzConnectionsByOrgId($organizationId: UUID!) {
  connections: getActiveRailzConnectionsByOrgId(organizationId: $organizationId) {
    ...RailzIntegration
  }
}
    ${RailzIntegrationFragmentDocGQLType}`;

/**
 * __useGetActiveRailzConnectionsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetActiveRailzConnectionsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveRailzConnectionsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveRailzConnectionsByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetActiveRailzConnectionsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>(GetActiveRailzConnectionsByOrgIdDocumentGQLType, options);
      }
export function useGetActiveRailzConnectionsByOrgIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>(GetActiveRailzConnectionsByOrgIdDocumentGQLType, options);
        }
export type GetActiveRailzConnectionsByOrgIdQueryHookResult = ReturnType<typeof useGetActiveRailzConnectionsByOrgIdQuery>;
export type GetActiveRailzConnectionsByOrgIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActiveRailzConnectionsByOrgIdLazyQueryGQLType>;
export type GetActiveRailzConnectionsByOrgIdQueryResultGQLType = Apollo.QueryResult<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>;
export const GetFinancialStatementDataByDateRangeDocumentGQLType = gql`
    query GetFinancialStatementDataByDateRange($startDate: FullDateStr!, $endDate: FullDateStr!, $financialStatement: FinancialStatementType!, $reportFrequency: ReportFrequency!, $creditFacilityId: UUID!) {
  getFinancialStatementDataByDateRange(
    startDate: $startDate
    endDate: $endDate
    financialStatement: $financialStatement
    reportFrequency: $reportFrequency
    creditFacilityId: $creditFacilityId
  ) {
    currency
    finleyStatementKey
    reportFrequency
    metadata {
      sortedEndOfPeriodDates
    }
    adHocCalculations {
      adHocKey
      totals {
        cadenceDelta
        endOfPeriodDate
        value
      }
    }
    sectionKeysToLineItems {
      finleySectionKey
      totals {
        cadenceDelta
        endOfPeriodDate
        value
      }
      lineItemsToValues {
        lineItemDescription
        values {
          cadenceDelta
          endOfPeriodDate
          value
          finStatementLineItemId
          finStatementId
        }
      }
    }
  }
}
    `;

/**
 * __useGetFinancialStatementDataByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetFinancialStatementDataByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialStatementDataByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialStatementDataByDateRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      financialStatement: // value for 'financialStatement'
 *      reportFrequency: // value for 'reportFrequency'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetFinancialStatementDataByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>(GetFinancialStatementDataByDateRangeDocumentGQLType, options);
      }
export function useGetFinancialStatementDataByDateRangeLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>(GetFinancialStatementDataByDateRangeDocumentGQLType, options);
        }
export type GetFinancialStatementDataByDateRangeQueryHookResult = ReturnType<typeof useGetFinancialStatementDataByDateRangeQuery>;
export type GetFinancialStatementDataByDateRangeLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinancialStatementDataByDateRangeLazyQueryGQLType>;
export type GetFinancialStatementDataByDateRangeQueryResultGQLType = Apollo.QueryResult<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>;
export const DoesFinancialsAthenaTableExistDocumentGQLType = gql`
    query doesFinancialsAthenaTableExist($creditFacilityId: UUID!) {
  doesFinancialsAthenaTableExist(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useDoesFinancialsAthenaTableExistQuery__
 *
 * To run a query within a React component, call `useDoesFinancialsAthenaTableExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoesFinancialsAthenaTableExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoesFinancialsAthenaTableExistQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useDoesFinancialsAthenaTableExistQuery(baseOptions: Apollo.QueryHookOptions<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>(DoesFinancialsAthenaTableExistDocumentGQLType, options);
      }
export function useDoesFinancialsAthenaTableExistLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>(DoesFinancialsAthenaTableExistDocumentGQLType, options);
        }
export type DoesFinancialsAthenaTableExistQueryHookResult = ReturnType<typeof useDoesFinancialsAthenaTableExistQuery>;
export type DoesFinancialsAthenaTableExistLazyQueryGQLTypeHookResult = ReturnType<typeof useDoesFinancialsAthenaTableExistLazyQueryGQLType>;
export type DoesFinancialsAthenaTableExistQueryResultGQLType = Apollo.QueryResult<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>;
export const CreateRailzIntegrationDocumentGQLType = gql`
    mutation CreateRailzIntegration($organizationId: UUID!, $railzBusinessId: String!, $railzConnectionId: String!, $railzServiceName: RailzAccountingServiceNames!) {
  connection: createRailzIntegration(
    organizationId: $organizationId
    railzBusinessId: $railzBusinessId
    railzConnectionId: $railzConnectionId
    railzServiceName: $railzServiceName
  ) {
    ...RailzIntegration
  }
}
    ${RailzIntegrationFragmentDocGQLType}`;
export type CreateRailzIntegrationMutationFnGQLType = Apollo.MutationFunction<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>;

/**
 * __useCreateRailzIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateRailzIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRailzIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRailzIntegrationMutation, { data, loading, error }] = useCreateRailzIntegrationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      railzBusinessId: // value for 'railzBusinessId'
 *      railzConnectionId: // value for 'railzConnectionId'
 *      railzServiceName: // value for 'railzServiceName'
 *   },
 * });
 */
export function useCreateRailzIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>(CreateRailzIntegrationDocumentGQLType, options);
      }
export type CreateRailzIntegrationMutationHookResult = ReturnType<typeof useCreateRailzIntegrationMutation>;
export type CreateRailzIntegrationMutationResultGQLType = Apollo.MutationResult<CreateRailzIntegrationMutationGQLType>;
export type CreateRailzIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>;
export const DisconnectRailzIntegrationDocumentGQLType = gql`
    mutation DisconnectRailzIntegration($railzIntegrationId: UUID!) {
  connection: disconnectRailzIntegration(railzIntegrationId: $railzIntegrationId) {
    ...RailzIntegration
  }
}
    ${RailzIntegrationFragmentDocGQLType}`;
export type DisconnectRailzIntegrationMutationFnGQLType = Apollo.MutationFunction<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>;

/**
 * __useDisconnectRailzIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectRailzIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectRailzIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectRailzIntegrationMutation, { data, loading, error }] = useDisconnectRailzIntegrationMutation({
 *   variables: {
 *      railzIntegrationId: // value for 'railzIntegrationId'
 *   },
 * });
 */
export function useDisconnectRailzIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>(DisconnectRailzIntegrationDocumentGQLType, options);
      }
export type DisconnectRailzIntegrationMutationHookResult = ReturnType<typeof useDisconnectRailzIntegrationMutation>;
export type DisconnectRailzIntegrationMutationResultGQLType = Apollo.MutationResult<DisconnectRailzIntegrationMutationGQLType>;
export type DisconnectRailzIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>;
export const FetchAndUploadFinancialDataFromRailzDocumentGQLType = gql`
    mutation FetchAndUploadFinancialDataFromRailz($railzIntegrationId: UUID!, $queryParamInputs: RailzFinancialApiQueryParams!) {
  dataCount: fetchAndUploadFinancialDataFromRailz(
    railzIntegrationId: $railzIntegrationId
    queryParamInputs: $queryParamInputs
  )
}
    `;
export type FetchAndUploadFinancialDataFromRailzMutationFnGQLType = Apollo.MutationFunction<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>;

/**
 * __useFetchAndUploadFinancialDataFromRailzMutation__
 *
 * To run a mutation, you first call `useFetchAndUploadFinancialDataFromRailzMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchAndUploadFinancialDataFromRailzMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchAndUploadFinancialDataFromRailzMutation, { data, loading, error }] = useFetchAndUploadFinancialDataFromRailzMutation({
 *   variables: {
 *      railzIntegrationId: // value for 'railzIntegrationId'
 *      queryParamInputs: // value for 'queryParamInputs'
 *   },
 * });
 */
export function useFetchAndUploadFinancialDataFromRailzMutation(baseOptions?: Apollo.MutationHookOptions<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>(FetchAndUploadFinancialDataFromRailzDocumentGQLType, options);
      }
export type FetchAndUploadFinancialDataFromRailzMutationHookResult = ReturnType<typeof useFetchAndUploadFinancialDataFromRailzMutation>;
export type FetchAndUploadFinancialDataFromRailzMutationResultGQLType = Apollo.MutationResult<FetchAndUploadFinancialDataFromRailzMutationGQLType>;
export type FetchAndUploadFinancialDataFromRailzMutationOptionsGQLType = Apollo.BaseMutationOptions<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>;
export const UpdateFinStatementLineItemDocumentGQLType = gql`
    mutation UpdateFinStatementLineItem($updateInput: UpdateFinStatementLineItemInput!) {
  updateFinStatementLineItem(updateInput: $updateInput) {
    response
  }
}
    `;
export type UpdateFinStatementLineItemMutationFnGQLType = Apollo.MutationFunction<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>;

/**
 * __useUpdateFinStatementLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateFinStatementLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinStatementLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinStatementLineItemMutation, { data, loading, error }] = useUpdateFinStatementLineItemMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateFinStatementLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>(UpdateFinStatementLineItemDocumentGQLType, options);
      }
export type UpdateFinStatementLineItemMutationHookResult = ReturnType<typeof useUpdateFinStatementLineItemMutation>;
export type UpdateFinStatementLineItemMutationResultGQLType = Apollo.MutationResult<UpdateFinStatementLineItemMutationGQLType>;
export type UpdateFinStatementLineItemMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>;
export const CreateFinStatementLineItemDocumentGQLType = gql`
    mutation CreateFinStatementLineItem($finStatementLineItem: CreateFinStatementLineItemInput!) {
  createFinStatementLineItem(finStatementLineItem: $finStatementLineItem) {
    response
  }
}
    `;
export type CreateFinStatementLineItemMutationFnGQLType = Apollo.MutationFunction<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>;

/**
 * __useCreateFinStatementLineItemMutation__
 *
 * To run a mutation, you first call `useCreateFinStatementLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinStatementLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinStatementLineItemMutation, { data, loading, error }] = useCreateFinStatementLineItemMutation({
 *   variables: {
 *      finStatementLineItem: // value for 'finStatementLineItem'
 *   },
 * });
 */
export function useCreateFinStatementLineItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>(CreateFinStatementLineItemDocumentGQLType, options);
      }
export type CreateFinStatementLineItemMutationHookResult = ReturnType<typeof useCreateFinStatementLineItemMutation>;
export type CreateFinStatementLineItemMutationResultGQLType = Apollo.MutationResult<CreateFinStatementLineItemMutationGQLType>;
export type CreateFinStatementLineItemMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>;
export const DeleteFinStatementLineItemDocumentGQLType = gql`
    mutation DeleteFinStatementLineItem($finStatementLineItemId: UUID!) {
  deleteFinStatementLineItem(finStatementLineItemId: $finStatementLineItemId) {
    response
  }
}
    `;
export type DeleteFinStatementLineItemMutationFnGQLType = Apollo.MutationFunction<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>;

/**
 * __useDeleteFinStatementLineItemMutation__
 *
 * To run a mutation, you first call `useDeleteFinStatementLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinStatementLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinStatementLineItemMutation, { data, loading, error }] = useDeleteFinStatementLineItemMutation({
 *   variables: {
 *      finStatementLineItemId: // value for 'finStatementLineItemId'
 *   },
 * });
 */
export function useDeleteFinStatementLineItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>(DeleteFinStatementLineItemDocumentGQLType, options);
      }
export type DeleteFinStatementLineItemMutationHookResult = ReturnType<typeof useDeleteFinStatementLineItemMutation>;
export type DeleteFinStatementLineItemMutationResultGQLType = Apollo.MutationResult<DeleteFinStatementLineItemMutationGQLType>;
export type DeleteFinStatementLineItemMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>;
export const DeleteFinStatementDocumentGQLType = gql`
    mutation DeleteFinStatement($finStatementId: UUID!) {
  deleteFinStatement(finStatementId: $finStatementId) {
    response
  }
}
    `;
export type DeleteFinStatementMutationFnGQLType = Apollo.MutationFunction<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>;

/**
 * __useDeleteFinStatementMutation__
 *
 * To run a mutation, you first call `useDeleteFinStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinStatementMutation, { data, loading, error }] = useDeleteFinStatementMutation({
 *   variables: {
 *      finStatementId: // value for 'finStatementId'
 *   },
 * });
 */
export function useDeleteFinStatementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>(DeleteFinStatementDocumentGQLType, options);
      }
export type DeleteFinStatementMutationHookResult = ReturnType<typeof useDeleteFinStatementMutation>;
export type DeleteFinStatementMutationResultGQLType = Apollo.MutationResult<DeleteFinStatementMutationGQLType>;
export type DeleteFinStatementMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>;
export const GetFinancialStatementConfigDocumentGQLType = gql`
    query GetFinancialStatementConfig($organizationSlug: String!) {
  getFinancialStatementConfig(organizationSlug: $organizationSlug) {
    financialFormatting {
      displayFormat
    }
  }
}
    `;

/**
 * __useGetFinancialStatementConfigQuery__
 *
 * To run a query within a React component, call `useGetFinancialStatementConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialStatementConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialStatementConfigQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useGetFinancialStatementConfigQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialStatementConfigQueryGQLType, GetFinancialStatementConfigQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialStatementConfigQueryGQLType, GetFinancialStatementConfigQueryVariablesGQLType>(GetFinancialStatementConfigDocumentGQLType, options);
      }
export function useGetFinancialStatementConfigLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialStatementConfigQueryGQLType, GetFinancialStatementConfigQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialStatementConfigQueryGQLType, GetFinancialStatementConfigQueryVariablesGQLType>(GetFinancialStatementConfigDocumentGQLType, options);
        }
export type GetFinancialStatementConfigQueryHookResult = ReturnType<typeof useGetFinancialStatementConfigQuery>;
export type GetFinancialStatementConfigLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinancialStatementConfigLazyQueryGQLType>;
export type GetFinancialStatementConfigQueryResultGQLType = Apollo.QueryResult<GetFinancialStatementConfigQueryGQLType, GetFinancialStatementConfigQueryVariablesGQLType>;
export const GetFinleyAiThreadsDocumentGQLType = gql`
    query GetFinleyAiThreads($userId: UUID!) {
  getFinleyAiThreads(userId: $userId) {
    threads
  }
}
    `;

/**
 * __useGetFinleyAiThreadsQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiThreadsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFinleyAiThreadsQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiThreadsQueryGQLType, GetFinleyAiThreadsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiThreadsQueryGQLType, GetFinleyAiThreadsQueryVariablesGQLType>(GetFinleyAiThreadsDocumentGQLType, options);
      }
export function useGetFinleyAiThreadsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiThreadsQueryGQLType, GetFinleyAiThreadsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiThreadsQueryGQLType, GetFinleyAiThreadsQueryVariablesGQLType>(GetFinleyAiThreadsDocumentGQLType, options);
        }
export type GetFinleyAiThreadsQueryHookResult = ReturnType<typeof useGetFinleyAiThreadsQuery>;
export type GetFinleyAiThreadsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiThreadsLazyQueryGQLType>;
export type GetFinleyAiThreadsQueryResultGQLType = Apollo.QueryResult<GetFinleyAiThreadsQueryGQLType, GetFinleyAiThreadsQueryVariablesGQLType>;
export const GetFinleyAiThreadWithPromptResponsesDocumentGQLType = gql`
    query GetFinleyAiThreadWithPromptResponses($finleyAiThreadId: UUID!) {
  getFinleyAiThreadWithPromptResponses(finleyAiThreadId: $finleyAiThreadId) {
    threadWithPromptResponses
  }
}
    `;

/**
 * __useGetFinleyAiThreadWithPromptResponsesQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiThreadWithPromptResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiThreadWithPromptResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiThreadWithPromptResponsesQuery({
 *   variables: {
 *      finleyAiThreadId: // value for 'finleyAiThreadId'
 *   },
 * });
 */
export function useGetFinleyAiThreadWithPromptResponsesQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiThreadWithPromptResponsesQueryGQLType, GetFinleyAiThreadWithPromptResponsesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiThreadWithPromptResponsesQueryGQLType, GetFinleyAiThreadWithPromptResponsesQueryVariablesGQLType>(GetFinleyAiThreadWithPromptResponsesDocumentGQLType, options);
      }
export function useGetFinleyAiThreadWithPromptResponsesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiThreadWithPromptResponsesQueryGQLType, GetFinleyAiThreadWithPromptResponsesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiThreadWithPromptResponsesQueryGQLType, GetFinleyAiThreadWithPromptResponsesQueryVariablesGQLType>(GetFinleyAiThreadWithPromptResponsesDocumentGQLType, options);
        }
export type GetFinleyAiThreadWithPromptResponsesQueryHookResult = ReturnType<typeof useGetFinleyAiThreadWithPromptResponsesQuery>;
export type GetFinleyAiThreadWithPromptResponsesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiThreadWithPromptResponsesLazyQueryGQLType>;
export type GetFinleyAiThreadWithPromptResponsesQueryResultGQLType = Apollo.QueryResult<GetFinleyAiThreadWithPromptResponsesQueryGQLType, GetFinleyAiThreadWithPromptResponsesQueryVariablesGQLType>;
export const GetKnowledgeBaseDocumentsByOrganizationIdDocumentGQLType = gql`
    query GetKnowledgeBaseDocumentsByOrganizationId($organizationId: UUID!) {
  getKnowledgeBaseDocumentsByOrganizationId(organizationId: $organizationId) {
    knowledgeBaseDocuments {
      id
      documentName
      s3Bucket
      s3Path
      documentType
      tags
      organizationId
      userId
      embeddedChunksS3Bucket
      embeddedChunksS3Path
    }
  }
}
    `;

/**
 * __useGetKnowledgeBaseDocumentsByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentsByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentsByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentsByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentsByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseDocumentsByOrganizationIdQueryGQLType, GetKnowledgeBaseDocumentsByOrganizationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseDocumentsByOrganizationIdQueryGQLType, GetKnowledgeBaseDocumentsByOrganizationIdQueryVariablesGQLType>(GetKnowledgeBaseDocumentsByOrganizationIdDocumentGQLType, options);
      }
export function useGetKnowledgeBaseDocumentsByOrganizationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseDocumentsByOrganizationIdQueryGQLType, GetKnowledgeBaseDocumentsByOrganizationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseDocumentsByOrganizationIdQueryGQLType, GetKnowledgeBaseDocumentsByOrganizationIdQueryVariablesGQLType>(GetKnowledgeBaseDocumentsByOrganizationIdDocumentGQLType, options);
        }
export type GetKnowledgeBaseDocumentsByOrganizationIdQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsByOrganizationIdQuery>;
export type GetKnowledgeBaseDocumentsByOrganizationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsByOrganizationIdLazyQueryGQLType>;
export type GetKnowledgeBaseDocumentsByOrganizationIdQueryResultGQLType = Apollo.QueryResult<GetKnowledgeBaseDocumentsByOrganizationIdQueryGQLType, GetKnowledgeBaseDocumentsByOrganizationIdQueryVariablesGQLType>;
export const GetFinleyAiPromptResponseDocumentGQLType = gql`
    query GetFinleyAiPromptResponse($finleyAiPromptResponseId: UUID!) {
  getFinleyAiPromptResponse(finleyAiPromptResponseId: $finleyAiPromptResponseId) {
    promptResponse
  }
}
    `;

/**
 * __useGetFinleyAiPromptResponseQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiPromptResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiPromptResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiPromptResponseQuery({
 *   variables: {
 *      finleyAiPromptResponseId: // value for 'finleyAiPromptResponseId'
 *   },
 * });
 */
export function useGetFinleyAiPromptResponseQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiPromptResponseQueryGQLType, GetFinleyAiPromptResponseQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiPromptResponseQueryGQLType, GetFinleyAiPromptResponseQueryVariablesGQLType>(GetFinleyAiPromptResponseDocumentGQLType, options);
      }
export function useGetFinleyAiPromptResponseLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiPromptResponseQueryGQLType, GetFinleyAiPromptResponseQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiPromptResponseQueryGQLType, GetFinleyAiPromptResponseQueryVariablesGQLType>(GetFinleyAiPromptResponseDocumentGQLType, options);
        }
export type GetFinleyAiPromptResponseQueryHookResult = ReturnType<typeof useGetFinleyAiPromptResponseQuery>;
export type GetFinleyAiPromptResponseLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiPromptResponseLazyQueryGQLType>;
export type GetFinleyAiPromptResponseQueryResultGQLType = Apollo.QueryResult<GetFinleyAiPromptResponseQueryGQLType, GetFinleyAiPromptResponseQueryVariablesGQLType>;
export const ProduceFinleyAiWorkleaseDocumentGQLType = gql`
    mutation ProduceFinleyAiWorklease($params: FinleyAiRequest!) {
  produceFinleyAiWorklease(params: $params) {
    thread
  }
}
    `;
export type ProduceFinleyAiWorkleaseMutationFnGQLType = Apollo.MutationFunction<ProduceFinleyAiWorkleaseMutationGQLType, ProduceFinleyAiWorkleaseMutationVariablesGQLType>;

/**
 * __useProduceFinleyAiWorkleaseMutation__
 *
 * To run a mutation, you first call `useProduceFinleyAiWorkleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProduceFinleyAiWorkleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [produceFinleyAiWorkleaseMutation, { data, loading, error }] = useProduceFinleyAiWorkleaseMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useProduceFinleyAiWorkleaseMutation(baseOptions?: Apollo.MutationHookOptions<ProduceFinleyAiWorkleaseMutationGQLType, ProduceFinleyAiWorkleaseMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProduceFinleyAiWorkleaseMutationGQLType, ProduceFinleyAiWorkleaseMutationVariablesGQLType>(ProduceFinleyAiWorkleaseDocumentGQLType, options);
      }
export type ProduceFinleyAiWorkleaseMutationHookResult = ReturnType<typeof useProduceFinleyAiWorkleaseMutation>;
export type ProduceFinleyAiWorkleaseMutationResultGQLType = Apollo.MutationResult<ProduceFinleyAiWorkleaseMutationGQLType>;
export type ProduceFinleyAiWorkleaseMutationOptionsGQLType = Apollo.BaseMutationOptions<ProduceFinleyAiWorkleaseMutationGQLType, ProduceFinleyAiWorkleaseMutationVariablesGQLType>;
export const GetAthenaSqlGenerationSignedUrlsDocumentGQLType = gql`
    query getAthenaSqlGenerationSignedUrls($serializedParams: String!) {
  getSignedDownloadUrls(
    feature: "athenaSqlGeneration"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetAthenaSqlGenerationSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetAthenaSqlGenerationSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaSqlGenerationSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaSqlGenerationSignedUrlsQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetAthenaSqlGenerationSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaSqlGenerationSignedUrlsQueryGQLType, GetAthenaSqlGenerationSignedUrlsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaSqlGenerationSignedUrlsQueryGQLType, GetAthenaSqlGenerationSignedUrlsQueryVariablesGQLType>(GetAthenaSqlGenerationSignedUrlsDocumentGQLType, options);
      }
export function useGetAthenaSqlGenerationSignedUrlsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaSqlGenerationSignedUrlsQueryGQLType, GetAthenaSqlGenerationSignedUrlsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaSqlGenerationSignedUrlsQueryGQLType, GetAthenaSqlGenerationSignedUrlsQueryVariablesGQLType>(GetAthenaSqlGenerationSignedUrlsDocumentGQLType, options);
        }
export type GetAthenaSqlGenerationSignedUrlsQueryHookResult = ReturnType<typeof useGetAthenaSqlGenerationSignedUrlsQuery>;
export type GetAthenaSqlGenerationSignedUrlsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaSqlGenerationSignedUrlsLazyQueryGQLType>;
export type GetAthenaSqlGenerationSignedUrlsQueryResultGQLType = Apollo.QueryResult<GetAthenaSqlGenerationSignedUrlsQueryGQLType, GetAthenaSqlGenerationSignedUrlsQueryVariablesGQLType>;
export const GetKnowledgeBaseDocumentSignedUrlDocumentGQLType = gql`
    query getKnowledgeBaseDocumentSignedUrl($serializedParams: String!) {
  getSignedDownloadUrls(
    feature: "knowledgeBaseDocument"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetKnowledgeBaseDocumentSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseDocumentSignedUrlQueryGQLType, GetKnowledgeBaseDocumentSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseDocumentSignedUrlQueryGQLType, GetKnowledgeBaseDocumentSignedUrlQueryVariablesGQLType>(GetKnowledgeBaseDocumentSignedUrlDocumentGQLType, options);
      }
export function useGetKnowledgeBaseDocumentSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseDocumentSignedUrlQueryGQLType, GetKnowledgeBaseDocumentSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseDocumentSignedUrlQueryGQLType, GetKnowledgeBaseDocumentSignedUrlQueryVariablesGQLType>(GetKnowledgeBaseDocumentSignedUrlDocumentGQLType, options);
        }
export type GetKnowledgeBaseDocumentSignedUrlQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentSignedUrlQuery>;
export type GetKnowledgeBaseDocumentSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentSignedUrlLazyQueryGQLType>;
export type GetKnowledgeBaseDocumentSignedUrlQueryResultGQLType = Apollo.QueryResult<GetKnowledgeBaseDocumentSignedUrlQueryGQLType, GetKnowledgeBaseDocumentSignedUrlQueryVariablesGQLType>;
export const GetFinleyAiAthenaSqlGenerationPromptResultPreviewDocumentGQLType = gql`
    query getFinleyAiAthenaSqlGenerationPromptResultPreview($finleyAiPromptResponseId: UUID!, $numberOfPreviewRows: Int) {
  getFinleyAiAthenaSqlGenerationPromptResultPreview(
    finleyAiPromptResponseId: $finleyAiPromptResponseId
    numberOfPreviewRows: $numberOfPreviewRows
  )
}
    `;

/**
 * __useGetFinleyAiAthenaSqlGenerationPromptResultPreviewQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiAthenaSqlGenerationPromptResultPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiAthenaSqlGenerationPromptResultPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiAthenaSqlGenerationPromptResultPreviewQuery({
 *   variables: {
 *      finleyAiPromptResponseId: // value for 'finleyAiPromptResponseId'
 *      numberOfPreviewRows: // value for 'numberOfPreviewRows'
 *   },
 * });
 */
export function useGetFinleyAiAthenaSqlGenerationPromptResultPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryGQLType, GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryGQLType, GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryVariablesGQLType>(GetFinleyAiAthenaSqlGenerationPromptResultPreviewDocumentGQLType, options);
      }
export function useGetFinleyAiAthenaSqlGenerationPromptResultPreviewLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryGQLType, GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryGQLType, GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryVariablesGQLType>(GetFinleyAiAthenaSqlGenerationPromptResultPreviewDocumentGQLType, options);
        }
export type GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryHookResult = ReturnType<typeof useGetFinleyAiAthenaSqlGenerationPromptResultPreviewQuery>;
export type GetFinleyAiAthenaSqlGenerationPromptResultPreviewLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiAthenaSqlGenerationPromptResultPreviewLazyQueryGQLType>;
export type GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryResultGQLType = Apollo.QueryResult<GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryGQLType, GetFinleyAiAthenaSqlGenerationPromptResultPreviewQueryVariablesGQLType>;
export const GetFinleyAiExtractValuesUploadSignedUrlDocumentGQLType = gql`
    query getFinleyAiExtractValuesUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "finleyAiExtractValues"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetFinleyAiExtractValuesUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiExtractValuesUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiExtractValuesUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiExtractValuesUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetFinleyAiExtractValuesUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiExtractValuesUploadSignedUrlQueryGQLType, GetFinleyAiExtractValuesUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiExtractValuesUploadSignedUrlQueryGQLType, GetFinleyAiExtractValuesUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiExtractValuesUploadSignedUrlDocumentGQLType, options);
      }
export function useGetFinleyAiExtractValuesUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiExtractValuesUploadSignedUrlQueryGQLType, GetFinleyAiExtractValuesUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiExtractValuesUploadSignedUrlQueryGQLType, GetFinleyAiExtractValuesUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiExtractValuesUploadSignedUrlDocumentGQLType, options);
        }
export type GetFinleyAiExtractValuesUploadSignedUrlQueryHookResult = ReturnType<typeof useGetFinleyAiExtractValuesUploadSignedUrlQuery>;
export type GetFinleyAiExtractValuesUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiExtractValuesUploadSignedUrlLazyQueryGQLType>;
export type GetFinleyAiExtractValuesUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetFinleyAiExtractValuesUploadSignedUrlQueryGQLType, GetFinleyAiExtractValuesUploadSignedUrlQueryVariablesGQLType>;
export const GetFinleyAiVirtualSheetUploadSignedUrlDocumentGQLType = gql`
    query getFinleyAiVirtualSheetUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "finleyAiVirtualSheet"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetFinleyAiVirtualSheetUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiVirtualSheetUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiVirtualSheetUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiVirtualSheetUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetFinleyAiVirtualSheetUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiVirtualSheetUploadSignedUrlQueryGQLType, GetFinleyAiVirtualSheetUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiVirtualSheetUploadSignedUrlQueryGQLType, GetFinleyAiVirtualSheetUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiVirtualSheetUploadSignedUrlDocumentGQLType, options);
      }
export function useGetFinleyAiVirtualSheetUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiVirtualSheetUploadSignedUrlQueryGQLType, GetFinleyAiVirtualSheetUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiVirtualSheetUploadSignedUrlQueryGQLType, GetFinleyAiVirtualSheetUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiVirtualSheetUploadSignedUrlDocumentGQLType, options);
        }
export type GetFinleyAiVirtualSheetUploadSignedUrlQueryHookResult = ReturnType<typeof useGetFinleyAiVirtualSheetUploadSignedUrlQuery>;
export type GetFinleyAiVirtualSheetUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiVirtualSheetUploadSignedUrlLazyQueryGQLType>;
export type GetFinleyAiVirtualSheetUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetFinleyAiVirtualSheetUploadSignedUrlQueryGQLType, GetFinleyAiVirtualSheetUploadSignedUrlQueryVariablesGQLType>;
export const GetFinleyAiTransformUploadSignedUrlDocumentGQLType = gql`
    query getFinleyAiTransformUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "finleyAiTransform"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetFinleyAiTransformUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiTransformUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiTransformUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiTransformUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetFinleyAiTransformUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiTransformUploadSignedUrlQueryGQLType, GetFinleyAiTransformUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiTransformUploadSignedUrlQueryGQLType, GetFinleyAiTransformUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiTransformUploadSignedUrlDocumentGQLType, options);
      }
export function useGetFinleyAiTransformUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiTransformUploadSignedUrlQueryGQLType, GetFinleyAiTransformUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiTransformUploadSignedUrlQueryGQLType, GetFinleyAiTransformUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiTransformUploadSignedUrlDocumentGQLType, options);
        }
export type GetFinleyAiTransformUploadSignedUrlQueryHookResult = ReturnType<typeof useGetFinleyAiTransformUploadSignedUrlQuery>;
export type GetFinleyAiTransformUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiTransformUploadSignedUrlLazyQueryGQLType>;
export type GetFinleyAiTransformUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetFinleyAiTransformUploadSignedUrlQueryGQLType, GetFinleyAiTransformUploadSignedUrlQueryVariablesGQLType>;
export const GetFinleyAiVirtualSheetSignedUrlsDocumentGQLType = gql`
    query getFinleyAiVirtualSheetSignedUrls($serializedParams: String!) {
  getSignedDownloadUrls(
    feature: "finleyAiVirtualSheet"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetFinleyAiVirtualSheetSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiVirtualSheetSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiVirtualSheetSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiVirtualSheetSignedUrlsQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetFinleyAiVirtualSheetSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiVirtualSheetSignedUrlsQueryGQLType, GetFinleyAiVirtualSheetSignedUrlsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiVirtualSheetSignedUrlsQueryGQLType, GetFinleyAiVirtualSheetSignedUrlsQueryVariablesGQLType>(GetFinleyAiVirtualSheetSignedUrlsDocumentGQLType, options);
      }
export function useGetFinleyAiVirtualSheetSignedUrlsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiVirtualSheetSignedUrlsQueryGQLType, GetFinleyAiVirtualSheetSignedUrlsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiVirtualSheetSignedUrlsQueryGQLType, GetFinleyAiVirtualSheetSignedUrlsQueryVariablesGQLType>(GetFinleyAiVirtualSheetSignedUrlsDocumentGQLType, options);
        }
export type GetFinleyAiVirtualSheetSignedUrlsQueryHookResult = ReturnType<typeof useGetFinleyAiVirtualSheetSignedUrlsQuery>;
export type GetFinleyAiVirtualSheetSignedUrlsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiVirtualSheetSignedUrlsLazyQueryGQLType>;
export type GetFinleyAiVirtualSheetSignedUrlsQueryResultGQLType = Apollo.QueryResult<GetFinleyAiVirtualSheetSignedUrlsQueryGQLType, GetFinleyAiVirtualSheetSignedUrlsQueryVariablesGQLType>;
export const GetFinleyAiTransformSignedUrlsDocumentGQLType = gql`
    query getFinleyAiTransformSignedUrls($serializedParams: String!) {
  getSignedDownloadUrls(
    feature: "finleyAiTransform"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetFinleyAiTransformSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiTransformSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiTransformSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiTransformSignedUrlsQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetFinleyAiTransformSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiTransformSignedUrlsQueryGQLType, GetFinleyAiTransformSignedUrlsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiTransformSignedUrlsQueryGQLType, GetFinleyAiTransformSignedUrlsQueryVariablesGQLType>(GetFinleyAiTransformSignedUrlsDocumentGQLType, options);
      }
export function useGetFinleyAiTransformSignedUrlsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiTransformSignedUrlsQueryGQLType, GetFinleyAiTransformSignedUrlsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiTransformSignedUrlsQueryGQLType, GetFinleyAiTransformSignedUrlsQueryVariablesGQLType>(GetFinleyAiTransformSignedUrlsDocumentGQLType, options);
        }
export type GetFinleyAiTransformSignedUrlsQueryHookResult = ReturnType<typeof useGetFinleyAiTransformSignedUrlsQuery>;
export type GetFinleyAiTransformSignedUrlsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiTransformSignedUrlsLazyQueryGQLType>;
export type GetFinleyAiTransformSignedUrlsQueryResultGQLType = Apollo.QueryResult<GetFinleyAiTransformSignedUrlsQueryGQLType, GetFinleyAiTransformSignedUrlsQueryVariablesGQLType>;
export const GetFinleyAiDocumentAmaUploadSignedUrlDocumentGQLType = gql`
    query getFinleyAiDocumentAmaUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "finleyAiDocumentAmaUpload"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetFinleyAiDocumentAmaUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetFinleyAiDocumentAmaUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinleyAiDocumentAmaUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinleyAiDocumentAmaUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetFinleyAiDocumentAmaUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetFinleyAiDocumentAmaUploadSignedUrlQueryGQLType, GetFinleyAiDocumentAmaUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinleyAiDocumentAmaUploadSignedUrlQueryGQLType, GetFinleyAiDocumentAmaUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiDocumentAmaUploadSignedUrlDocumentGQLType, options);
      }
export function useGetFinleyAiDocumentAmaUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinleyAiDocumentAmaUploadSignedUrlQueryGQLType, GetFinleyAiDocumentAmaUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinleyAiDocumentAmaUploadSignedUrlQueryGQLType, GetFinleyAiDocumentAmaUploadSignedUrlQueryVariablesGQLType>(GetFinleyAiDocumentAmaUploadSignedUrlDocumentGQLType, options);
        }
export type GetFinleyAiDocumentAmaUploadSignedUrlQueryHookResult = ReturnType<typeof useGetFinleyAiDocumentAmaUploadSignedUrlQuery>;
export type GetFinleyAiDocumentAmaUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinleyAiDocumentAmaUploadSignedUrlLazyQueryGQLType>;
export type GetFinleyAiDocumentAmaUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetFinleyAiDocumentAmaUploadSignedUrlQueryGQLType, GetFinleyAiDocumentAmaUploadSignedUrlQueryVariablesGQLType>;
export const CanFundingRequestBeCreatedDocumentGQLType = gql`
    query CanFundingRequestBeCreated($creditFacilityId: UUID!) {
  canFundingRequestBeCreated(creditFacilityId: $creditFacilityId) {
    canCreate
    errorCode
  }
}
    `;

/**
 * __useCanFundingRequestBeCreatedQuery__
 *
 * To run a query within a React component, call `useCanFundingRequestBeCreatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanFundingRequestBeCreatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanFundingRequestBeCreatedQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCanFundingRequestBeCreatedQuery(baseOptions: Apollo.QueryHookOptions<CanFundingRequestBeCreatedQueryGQLType, CanFundingRequestBeCreatedQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanFundingRequestBeCreatedQueryGQLType, CanFundingRequestBeCreatedQueryVariablesGQLType>(CanFundingRequestBeCreatedDocumentGQLType, options);
      }
export function useCanFundingRequestBeCreatedLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<CanFundingRequestBeCreatedQueryGQLType, CanFundingRequestBeCreatedQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanFundingRequestBeCreatedQueryGQLType, CanFundingRequestBeCreatedQueryVariablesGQLType>(CanFundingRequestBeCreatedDocumentGQLType, options);
        }
export type CanFundingRequestBeCreatedQueryHookResult = ReturnType<typeof useCanFundingRequestBeCreatedQuery>;
export type CanFundingRequestBeCreatedLazyQueryGQLTypeHookResult = ReturnType<typeof useCanFundingRequestBeCreatedLazyQueryGQLType>;
export type CanFundingRequestBeCreatedQueryResultGQLType = Apollo.QueryResult<CanFundingRequestBeCreatedQueryGQLType, CanFundingRequestBeCreatedQueryVariablesGQLType>;
export const AllocateFundingRequestTargetAmountsDocumentGQLType = gql`
    mutation AllocateFundingRequestTargetAmounts($fundingRequestTotalAmountsChangeset: UpdateFundingRequestTotalAmounts!) {
  allocateFundingRequestTargetAmounts(
    fundingRequestTotalAmountsChangeset: $fundingRequestTotalAmountsChangeset
  ) {
    fundingRequestComponentTotalAmounts {
      ...FundingRequestComponentTotalAmountsFields
    }
    fundingRequestComponents {
      ...FundingRequestComponentChangesetFields
    }
  }
}
    ${FundingRequestComponentTotalAmountsFieldsFragmentDocGQLType}
${FundingRequestComponentChangesetFieldsFragmentDocGQLType}`;
export type AllocateFundingRequestTargetAmountsMutationFnGQLType = Apollo.MutationFunction<AllocateFundingRequestTargetAmountsMutationGQLType, AllocateFundingRequestTargetAmountsMutationVariablesGQLType>;

/**
 * __useAllocateFundingRequestTargetAmountsMutation__
 *
 * To run a mutation, you first call `useAllocateFundingRequestTargetAmountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocateFundingRequestTargetAmountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocateFundingRequestTargetAmountsMutation, { data, loading, error }] = useAllocateFundingRequestTargetAmountsMutation({
 *   variables: {
 *      fundingRequestTotalAmountsChangeset: // value for 'fundingRequestTotalAmountsChangeset'
 *   },
 * });
 */
export function useAllocateFundingRequestTargetAmountsMutation(baseOptions?: Apollo.MutationHookOptions<AllocateFundingRequestTargetAmountsMutationGQLType, AllocateFundingRequestTargetAmountsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocateFundingRequestTargetAmountsMutationGQLType, AllocateFundingRequestTargetAmountsMutationVariablesGQLType>(AllocateFundingRequestTargetAmountsDocumentGQLType, options);
      }
export type AllocateFundingRequestTargetAmountsMutationHookResult = ReturnType<typeof useAllocateFundingRequestTargetAmountsMutation>;
export type AllocateFundingRequestTargetAmountsMutationResultGQLType = Apollo.MutationResult<AllocateFundingRequestTargetAmountsMutationGQLType>;
export type AllocateFundingRequestTargetAmountsMutationOptionsGQLType = Apollo.BaseMutationOptions<AllocateFundingRequestTargetAmountsMutationGQLType, AllocateFundingRequestTargetAmountsMutationVariablesGQLType>;
export const GetMaximumDrawRequestFrequencyMetadataDocumentGQLType = gql`
    query GetMaximumDrawRequestFrequencyMetadata($creditFacilityId: UUID!, $creditAgreementId: UUID!) {
  maximumDrawRequestFrequencyMetadata(
    creditFacilityId: $creditFacilityId
    creditAgreementId: $creditAgreementId
  ) {
    limitReached
    message
  }
}
    `;

/**
 * __useGetMaximumDrawRequestFrequencyMetadataQuery__
 *
 * To run a query within a React component, call `useGetMaximumDrawRequestFrequencyMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaximumDrawRequestFrequencyMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaximumDrawRequestFrequencyMetadataQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      creditAgreementId: // value for 'creditAgreementId'
 *   },
 * });
 */
export function useGetMaximumDrawRequestFrequencyMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetMaximumDrawRequestFrequencyMetadataQueryGQLType, GetMaximumDrawRequestFrequencyMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaximumDrawRequestFrequencyMetadataQueryGQLType, GetMaximumDrawRequestFrequencyMetadataQueryVariablesGQLType>(GetMaximumDrawRequestFrequencyMetadataDocumentGQLType, options);
      }
export function useGetMaximumDrawRequestFrequencyMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMaximumDrawRequestFrequencyMetadataQueryGQLType, GetMaximumDrawRequestFrequencyMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaximumDrawRequestFrequencyMetadataQueryGQLType, GetMaximumDrawRequestFrequencyMetadataQueryVariablesGQLType>(GetMaximumDrawRequestFrequencyMetadataDocumentGQLType, options);
        }
export type GetMaximumDrawRequestFrequencyMetadataQueryHookResult = ReturnType<typeof useGetMaximumDrawRequestFrequencyMetadataQuery>;
export type GetMaximumDrawRequestFrequencyMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMaximumDrawRequestFrequencyMetadataLazyQueryGQLType>;
export type GetMaximumDrawRequestFrequencyMetadataQueryResultGQLType = Apollo.QueryResult<GetMaximumDrawRequestFrequencyMetadataQueryGQLType, GetMaximumDrawRequestFrequencyMetadataQueryVariablesGQLType>;
export const CanServicingReportPreviewBeCreatedDocumentGQLType = gql`
    query CanServicingReportPreviewBeCreated($creditFacilityId: UUID!) {
  canServicingReportPreviewBeCreated(creditFacilityId: $creditFacilityId) {
    canCreate
    errorCode
  }
}
    `;

/**
 * __useCanServicingReportPreviewBeCreatedQuery__
 *
 * To run a query within a React component, call `useCanServicingReportPreviewBeCreatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanServicingReportPreviewBeCreatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanServicingReportPreviewBeCreatedQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useCanServicingReportPreviewBeCreatedQuery(baseOptions: Apollo.QueryHookOptions<CanServicingReportPreviewBeCreatedQueryGQLType, CanServicingReportPreviewBeCreatedQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanServicingReportPreviewBeCreatedQueryGQLType, CanServicingReportPreviewBeCreatedQueryVariablesGQLType>(CanServicingReportPreviewBeCreatedDocumentGQLType, options);
      }
export function useCanServicingReportPreviewBeCreatedLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<CanServicingReportPreviewBeCreatedQueryGQLType, CanServicingReportPreviewBeCreatedQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanServicingReportPreviewBeCreatedQueryGQLType, CanServicingReportPreviewBeCreatedQueryVariablesGQLType>(CanServicingReportPreviewBeCreatedDocumentGQLType, options);
        }
export type CanServicingReportPreviewBeCreatedQueryHookResult = ReturnType<typeof useCanServicingReportPreviewBeCreatedQuery>;
export type CanServicingReportPreviewBeCreatedLazyQueryGQLTypeHookResult = ReturnType<typeof useCanServicingReportPreviewBeCreatedLazyQueryGQLType>;
export type CanServicingReportPreviewBeCreatedQueryResultGQLType = Apollo.QueryResult<CanServicingReportPreviewBeCreatedQueryGQLType, CanServicingReportPreviewBeCreatedQueryVariablesGQLType>;
export const GetFundingRequestDocumentGQLType = gql`
    query GetFundingRequest($fundingRequestId: UUID!) {
  fundingRequestWithFullDetails(fundingRequestId: $fundingRequestId) {
    ...FundingRequestWithFullDetailsFields
    fundingRequestReports {
      id
      reportType
      s3Path
      isDomainReport
    }
  }
}
    ${FundingRequestWithFullDetailsFieldsFragmentDocGQLType}`;

/**
 * __useGetFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestQueryGQLType, GetFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestQueryGQLType, GetFundingRequestQueryVariablesGQLType>(GetFundingRequestDocumentGQLType, options);
      }
export function useGetFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestQueryGQLType, GetFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestQueryGQLType, GetFundingRequestQueryVariablesGQLType>(GetFundingRequestDocumentGQLType, options);
        }
export type GetFundingRequestQueryHookResult = ReturnType<typeof useGetFundingRequestQuery>;
export type GetFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestLazyQueryGQLType>;
export type GetFundingRequestQueryResultGQLType = Apollo.QueryResult<GetFundingRequestQueryGQLType, GetFundingRequestQueryVariablesGQLType>;
export const GetFundingRequestWithBaseDetailsDocumentGQLType = gql`
    query GetFundingRequestWithBaseDetails($fundingRequestId: UUID!) {
  fundingRequestWithFullDetails(fundingRequestId: $fundingRequestId) {
    ...FundingRequestWithBaseDetails
  }
}
    ${FundingRequestWithBaseDetailsFragmentDocGQLType}`;

/**
 * __useGetFundingRequestWithBaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestWithBaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestWithBaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestWithBaseDetailsQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetFundingRequestWithBaseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestWithBaseDetailsQueryGQLType, GetFundingRequestWithBaseDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestWithBaseDetailsQueryGQLType, GetFundingRequestWithBaseDetailsQueryVariablesGQLType>(GetFundingRequestWithBaseDetailsDocumentGQLType, options);
      }
export function useGetFundingRequestWithBaseDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestWithBaseDetailsQueryGQLType, GetFundingRequestWithBaseDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestWithBaseDetailsQueryGQLType, GetFundingRequestWithBaseDetailsQueryVariablesGQLType>(GetFundingRequestWithBaseDetailsDocumentGQLType, options);
        }
export type GetFundingRequestWithBaseDetailsQueryHookResult = ReturnType<typeof useGetFundingRequestWithBaseDetailsQuery>;
export type GetFundingRequestWithBaseDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestWithBaseDetailsLazyQueryGQLType>;
export type GetFundingRequestWithBaseDetailsQueryResultGQLType = Apollo.QueryResult<GetFundingRequestWithBaseDetailsQueryGQLType, GetFundingRequestWithBaseDetailsQueryVariablesGQLType>;
export const GetFundingRequestWithBaseDetailsAndBorrowingBaseDocumentGQLType = gql`
    query GetFundingRequestWithBaseDetailsAndBorrowingBase($fundingRequestId: UUID!) {
  fundingRequestWithFullDetails(fundingRequestId: $fundingRequestId) {
    ...FundingRequestWithBaseDetailsAndBorrowingBase
  }
}
    ${FundingRequestWithBaseDetailsAndBorrowingBaseFragmentDocGQLType}`;

/**
 * __useGetFundingRequestWithBaseDetailsAndBorrowingBaseQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestWithBaseDetailsAndBorrowingBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestWithBaseDetailsAndBorrowingBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestWithBaseDetailsAndBorrowingBaseQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetFundingRequestWithBaseDetailsAndBorrowingBaseQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryGQLType, GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryGQLType, GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryVariablesGQLType>(GetFundingRequestWithBaseDetailsAndBorrowingBaseDocumentGQLType, options);
      }
export function useGetFundingRequestWithBaseDetailsAndBorrowingBaseLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryGQLType, GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryGQLType, GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryVariablesGQLType>(GetFundingRequestWithBaseDetailsAndBorrowingBaseDocumentGQLType, options);
        }
export type GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryHookResult = ReturnType<typeof useGetFundingRequestWithBaseDetailsAndBorrowingBaseQuery>;
export type GetFundingRequestWithBaseDetailsAndBorrowingBaseLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestWithBaseDetailsAndBorrowingBaseLazyQueryGQLType>;
export type GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryResultGQLType = Apollo.QueryResult<GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryGQLType, GetFundingRequestWithBaseDetailsAndBorrowingBaseQueryVariablesGQLType>;
export const GetFundingRequestsWithBaseDetailsDocumentGQLType = gql`
    query GetFundingRequestsWithBaseDetails($creditFacilityIds: [UUID!]!, $limit: Int, $after: String, $before: String, $startDate: JSDate, $endDate: JSDate, $statuses: [FundingRequestStatusEnum!]) {
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    limit: $limit
    after: $after
    before: $before
    startDate: $startDate
    endDate: $endDate
    statuses: $statuses
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...FundingRequestWithFullDetailsFields
    }
  }
}
    ${FundingRequestWithFullDetailsFieldsFragmentDocGQLType}`;

/**
 * __useGetFundingRequestsWithBaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestsWithBaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestsWithBaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestsWithBaseDetailsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetFundingRequestsWithBaseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestsWithBaseDetailsQueryGQLType, GetFundingRequestsWithBaseDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestsWithBaseDetailsQueryGQLType, GetFundingRequestsWithBaseDetailsQueryVariablesGQLType>(GetFundingRequestsWithBaseDetailsDocumentGQLType, options);
      }
export function useGetFundingRequestsWithBaseDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestsWithBaseDetailsQueryGQLType, GetFundingRequestsWithBaseDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestsWithBaseDetailsQueryGQLType, GetFundingRequestsWithBaseDetailsQueryVariablesGQLType>(GetFundingRequestsWithBaseDetailsDocumentGQLType, options);
        }
export type GetFundingRequestsWithBaseDetailsQueryHookResult = ReturnType<typeof useGetFundingRequestsWithBaseDetailsQuery>;
export type GetFundingRequestsWithBaseDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestsWithBaseDetailsLazyQueryGQLType>;
export type GetFundingRequestsWithBaseDetailsQueryResultGQLType = Apollo.QueryResult<GetFundingRequestsWithBaseDetailsQueryGQLType, GetFundingRequestsWithBaseDetailsQueryVariablesGQLType>;
export const GetFundingRequestsWithEventDetailsDocumentGQLType = gql`
    query GetFundingRequestsWithEventDetails($creditFacilityIds: [UUID!]!, $limit: Int, $after: String, $before: String, $startDate: JSDate, $endDate: JSDate, $statuses: [FundingRequestStatusEnum!]) {
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    limit: $limit
    after: $after
    before: $before
    startDate: $startDate
    endDate: $endDate
    statuses: $statuses
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...FundingRequestWithBorrowingBaseFields
      fundingRequestEvents {
        ...FundingRequestEventForRender
      }
    }
  }
}
    ${FundingRequestWithBorrowingBaseFieldsFragmentDocGQLType}
${FundingRequestEventForRenderFragmentDocGQLType}`;

/**
 * __useGetFundingRequestsWithEventDetailsQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestsWithEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestsWithEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestsWithEventDetailsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetFundingRequestsWithEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestsWithEventDetailsQueryGQLType, GetFundingRequestsWithEventDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestsWithEventDetailsQueryGQLType, GetFundingRequestsWithEventDetailsQueryVariablesGQLType>(GetFundingRequestsWithEventDetailsDocumentGQLType, options);
      }
export function useGetFundingRequestsWithEventDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestsWithEventDetailsQueryGQLType, GetFundingRequestsWithEventDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestsWithEventDetailsQueryGQLType, GetFundingRequestsWithEventDetailsQueryVariablesGQLType>(GetFundingRequestsWithEventDetailsDocumentGQLType, options);
        }
export type GetFundingRequestsWithEventDetailsQueryHookResult = ReturnType<typeof useGetFundingRequestsWithEventDetailsQuery>;
export type GetFundingRequestsWithEventDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestsWithEventDetailsLazyQueryGQLType>;
export type GetFundingRequestsWithEventDetailsQueryResultGQLType = Apollo.QueryResult<GetFundingRequestsWithEventDetailsQueryGQLType, GetFundingRequestsWithEventDetailsQueryVariablesGQLType>;
export const GetFundingRequestsForCreditFacilitiesDocumentGQLType = gql`
    query GetFundingRequestsForCreditFacilities($creditFacilityIds: [UUID!]!) {
  fundingRequests(creditFacilityIds: $creditFacilityIds) {
    nodes {
      ...FundingRequestWithBaseDetails
    }
  }
}
    ${FundingRequestWithBaseDetailsFragmentDocGQLType}`;

/**
 * __useGetFundingRequestsForCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestsForCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestsForCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestsForCreditFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetFundingRequestsForCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestsForCreditFacilitiesQueryGQLType, GetFundingRequestsForCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestsForCreditFacilitiesQueryGQLType, GetFundingRequestsForCreditFacilitiesQueryVariablesGQLType>(GetFundingRequestsForCreditFacilitiesDocumentGQLType, options);
      }
export function useGetFundingRequestsForCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestsForCreditFacilitiesQueryGQLType, GetFundingRequestsForCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestsForCreditFacilitiesQueryGQLType, GetFundingRequestsForCreditFacilitiesQueryVariablesGQLType>(GetFundingRequestsForCreditFacilitiesDocumentGQLType, options);
        }
export type GetFundingRequestsForCreditFacilitiesQueryHookResult = ReturnType<typeof useGetFundingRequestsForCreditFacilitiesQuery>;
export type GetFundingRequestsForCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestsForCreditFacilitiesLazyQueryGQLType>;
export type GetFundingRequestsForCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetFundingRequestsForCreditFacilitiesQueryGQLType, GetFundingRequestsForCreditFacilitiesQueryVariablesGQLType>;
export const GetFundingRequestConstraintDocumentGQLType = gql`
    query GetFundingRequestConstraint($fundingRequestId: UUID!) {
  fundingRequestConstraint(fundingRequestId: fundingRequestId) {
    ...FundingRequestConstraintFields
  }
}
    ${FundingRequestConstraintFieldsFragmentDocGQLType}`;

/**
 * __useGetFundingRequestConstraintQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestConstraintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestConstraintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestConstraintQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetFundingRequestConstraintQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestConstraintQueryGQLType, GetFundingRequestConstraintQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestConstraintQueryGQLType, GetFundingRequestConstraintQueryVariablesGQLType>(GetFundingRequestConstraintDocumentGQLType, options);
      }
export function useGetFundingRequestConstraintLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestConstraintQueryGQLType, GetFundingRequestConstraintQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestConstraintQueryGQLType, GetFundingRequestConstraintQueryVariablesGQLType>(GetFundingRequestConstraintDocumentGQLType, options);
        }
export type GetFundingRequestConstraintQueryHookResult = ReturnType<typeof useGetFundingRequestConstraintQuery>;
export type GetFundingRequestConstraintLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestConstraintLazyQueryGQLType>;
export type GetFundingRequestConstraintQueryResultGQLType = Apollo.QueryResult<GetFundingRequestConstraintQueryGQLType, GetFundingRequestConstraintQueryVariablesGQLType>;
export const GetCurrentFundingRequestConstraintForCreditFacilityDocumentGQLType = gql`
    query GetCurrentFundingRequestConstraintForCreditFacility($creditFacilityId: UUID!) {
  currentFundingRequestConstraint(creditFacilityId: $creditFacilityId) {
    ...FundingRequestConstraintFields
  }
}
    ${FundingRequestConstraintFieldsFragmentDocGQLType}`;

/**
 * __useGetCurrentFundingRequestConstraintForCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetCurrentFundingRequestConstraintForCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentFundingRequestConstraintForCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentFundingRequestConstraintForCreditFacilityQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCurrentFundingRequestConstraintForCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentFundingRequestConstraintForCreditFacilityQueryGQLType, GetCurrentFundingRequestConstraintForCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentFundingRequestConstraintForCreditFacilityQueryGQLType, GetCurrentFundingRequestConstraintForCreditFacilityQueryVariablesGQLType>(GetCurrentFundingRequestConstraintForCreditFacilityDocumentGQLType, options);
      }
export function useGetCurrentFundingRequestConstraintForCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentFundingRequestConstraintForCreditFacilityQueryGQLType, GetCurrentFundingRequestConstraintForCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentFundingRequestConstraintForCreditFacilityQueryGQLType, GetCurrentFundingRequestConstraintForCreditFacilityQueryVariablesGQLType>(GetCurrentFundingRequestConstraintForCreditFacilityDocumentGQLType, options);
        }
export type GetCurrentFundingRequestConstraintForCreditFacilityQueryHookResult = ReturnType<typeof useGetCurrentFundingRequestConstraintForCreditFacilityQuery>;
export type GetCurrentFundingRequestConstraintForCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentFundingRequestConstraintForCreditFacilityLazyQueryGQLType>;
export type GetCurrentFundingRequestConstraintForCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetCurrentFundingRequestConstraintForCreditFacilityQueryGQLType, GetCurrentFundingRequestConstraintForCreditFacilityQueryVariablesGQLType>;
export const GetFundingRequestWithFullDetailsAndConstraintDocumentGQLType = gql`
    query GetFundingRequestWithFullDetailsAndConstraint($fundingRequestId: UUID!) {
  fundingRequestConstraint(fundingRequestId: $fundingRequestId) {
    borrowingBaseReportId
    collectionsRecycleContributesToBorrowingBase
    collectionsRecycleMax
    collectionsPaydownMax
    creditAgreementId
    drawRequestContributesToBorrowingBase
    drawRequestIncrementAmount
    id
    isCollectionsRecycleEnabled
    isStopDrawEnforced
    isVoluntaryPaydownAllowed
    maxFundingRequestAmount
    maxDrawRequestAmount
    maxCollectionsRecycleAmount
    minimumDrawRequestAmount
    minimumRepaymentAmount
    preAdvanceCashContributionToBorrowingBase
    targetCurePaydownAmount
    targetDrawRequestAmount
    targetCollectionsRecycleAmount
    targetCollectionsPaydownAmount
  }
  fundingRequestWithFullDetails(fundingRequestId: $fundingRequestId) {
    ...FundingRequestWithFullDetails
  }
}
    ${FundingRequestWithFullDetailsFragmentDocGQLType}`;

/**
 * __useGetFundingRequestWithFullDetailsAndConstraintQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestWithFullDetailsAndConstraintQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestWithFullDetailsAndConstraintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestWithFullDetailsAndConstraintQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetFundingRequestWithFullDetailsAndConstraintQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestWithFullDetailsAndConstraintQueryGQLType, GetFundingRequestWithFullDetailsAndConstraintQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestWithFullDetailsAndConstraintQueryGQLType, GetFundingRequestWithFullDetailsAndConstraintQueryVariablesGQLType>(GetFundingRequestWithFullDetailsAndConstraintDocumentGQLType, options);
      }
export function useGetFundingRequestWithFullDetailsAndConstraintLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestWithFullDetailsAndConstraintQueryGQLType, GetFundingRequestWithFullDetailsAndConstraintQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestWithFullDetailsAndConstraintQueryGQLType, GetFundingRequestWithFullDetailsAndConstraintQueryVariablesGQLType>(GetFundingRequestWithFullDetailsAndConstraintDocumentGQLType, options);
        }
export type GetFundingRequestWithFullDetailsAndConstraintQueryHookResult = ReturnType<typeof useGetFundingRequestWithFullDetailsAndConstraintQuery>;
export type GetFundingRequestWithFullDetailsAndConstraintLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestWithFullDetailsAndConstraintLazyQueryGQLType>;
export type GetFundingRequestWithFullDetailsAndConstraintQueryResultGQLType = Apollo.QueryResult<GetFundingRequestWithFullDetailsAndConstraintQueryGQLType, GetFundingRequestWithFullDetailsAndConstraintQueryVariablesGQLType>;
export const GetFundingRequestsWithComponentDetailsDocumentGQLType = gql`
    query GetFundingRequestsWithComponentDetails($creditFacilityIds: [UUID!]!, $limit: Int, $after: String, $before: String, $startDate: JSDate, $endDate: JSDate, $statuses: [FundingRequestStatusEnum!]) {
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    limit: $limit
    after: $after
    before: $before
    startDate: $startDate
    endDate: $endDate
    statuses: $statuses
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...FundingRequestWithFullDetailsFields
      fundingRequestComponents {
        ...FundingRequestComponentFields
      }
      fundingRequestEvents {
        ...FundingRequestEventForRender
      }
      bankAccounts {
        ...BankAccountWithInstitutionAndDesignation
      }
    }
  }
}
    ${FundingRequestWithFullDetailsFieldsFragmentDocGQLType}
${FundingRequestComponentFieldsFragmentDocGQLType}
${FundingRequestEventForRenderFragmentDocGQLType}
${BankAccountWithInstitutionAndDesignationFragmentDocGQLType}`;

/**
 * __useGetFundingRequestsWithComponentDetailsQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestsWithComponentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestsWithComponentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestsWithComponentDetailsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetFundingRequestsWithComponentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestsWithComponentDetailsQueryGQLType, GetFundingRequestsWithComponentDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestsWithComponentDetailsQueryGQLType, GetFundingRequestsWithComponentDetailsQueryVariablesGQLType>(GetFundingRequestsWithComponentDetailsDocumentGQLType, options);
      }
export function useGetFundingRequestsWithComponentDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestsWithComponentDetailsQueryGQLType, GetFundingRequestsWithComponentDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestsWithComponentDetailsQueryGQLType, GetFundingRequestsWithComponentDetailsQueryVariablesGQLType>(GetFundingRequestsWithComponentDetailsDocumentGQLType, options);
        }
export type GetFundingRequestsWithComponentDetailsQueryHookResult = ReturnType<typeof useGetFundingRequestsWithComponentDetailsQuery>;
export type GetFundingRequestsWithComponentDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestsWithComponentDetailsLazyQueryGQLType>;
export type GetFundingRequestsWithComponentDetailsQueryResultGQLType = Apollo.QueryResult<GetFundingRequestsWithComponentDetailsQueryGQLType, GetFundingRequestsWithComponentDetailsQueryVariablesGQLType>;
export const GetApprovedFundingRequestsMetadataWithBorrowingBaseReportDocumentGQLType = gql`
    query GetApprovedFundingRequestsMetadataWithBorrowingBaseReport($creditFacilityIds: [UUID!]!, $startDate: JSDate, $endDate: JSDate) {
  fundingRequests(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    endDate: $endDate
    statuses: [approved]
  ) {
    nodes {
      id
      creditFacilityId
      drawRequestTotalAmount
      collectionsRecycleTotalAmount
      collectionsPaydownTotalAmount
      curePaydownTotalAmount
      created_at
      reportingDate
    }
  }
}
    `;

/**
 * __useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportQuery__
 *
 * To run a query within a React component, call `useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportQuery(baseOptions: Apollo.QueryHookOptions<GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryGQLType, GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryGQLType, GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryVariablesGQLType>(GetApprovedFundingRequestsMetadataWithBorrowingBaseReportDocumentGQLType, options);
      }
export function useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryGQLType, GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryGQLType, GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryVariablesGQLType>(GetApprovedFundingRequestsMetadataWithBorrowingBaseReportDocumentGQLType, options);
        }
export type GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryHookResult = ReturnType<typeof useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportQuery>;
export type GetApprovedFundingRequestsMetadataWithBorrowingBaseReportLazyQueryGQLTypeHookResult = ReturnType<typeof useGetApprovedFundingRequestsMetadataWithBorrowingBaseReportLazyQueryGQLType>;
export type GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryResultGQLType = Apollo.QueryResult<GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryGQLType, GetApprovedFundingRequestsMetadataWithBorrowingBaseReportQueryVariablesGQLType>;
export const GetOrCreateFundingRequestTemplateDocumentGQLType = gql`
    query getOrCreateFundingRequestTemplate($mode: FundingRequestTemplateMode!, $creditFacilityId: UUID!, $fundingRequestId: UUID, $loanId: UUID, $fundingRequestIdToDuplicate: UUID) {
  template: getOrCreateFundingRequestTemplate(
    mode: $mode
    creditFacilityId: $creditFacilityId
    fundingRequestId: $fundingRequestId
    loanId: $loanId
    fundingRequestIdToDuplicate: $fundingRequestIdToDuplicate
  ) {
    creditAgreementId
    creditFacilityId
    reportingMechanics {
      fundingNotices {
        reportName
        fundingRequestComponents
      }
    }
    fundingMechanicsV2Serialized
    fundingMechanics {
      fundingRequestId
      commitments {
        key
        label
        amount
        attachmentRate
        shares {
          lenderId
          lenderName
          amount
          applicableMargin
          fundingRequestComponentId
          routing {
            source {
              bankAccountId
              label
            }
            destination {
              bankAccountId
              label
            }
          }
        }
      }
      draw {
        allocation {
          strategy
          strict
        }
        constraints {
          ... on FundingMechanicsNonConditionConstraint {
            type
            label
            value
          }
          ... on FundingMechanicsConditionConstraint {
            type
            label
            value
            condition
          }
        }
        pricingOptions {
          key
          name
          lookbackDays
          invoiceMechanics {
            single {
              key
              name
            }
            recurring {
              key
              name
            }
          }
        }
        targetFundingDate
      }
      recycles {
        fundingRequestComponentId
        targetFundingDate
        constraints {
          ... on FundingMechanicsNonConditionConstraint {
            type
            label
            value
          }
          ... on FundingMechanicsConditionConstraint {
            type
            label
            value
            condition
          }
        }
        routing {
          source {
            bankAccountId
            label
          }
          destination {
            bankAccountId
            label
          }
        }
      }
      requestRoutings {
        type
        source {
          accountId
          accountName
          accountType
          organizationId
        }
        destination {
          accountId
          accountName
          accountType
          organizationId
        }
      }
    }
    borrowingBaseReport {
      id
      borrowingBaseAvailability
      cashAdvanceRate
      commitmentAmount
      effectiveAdvanceRate
      currentPrincipalBalance
      totalCash
      borrowingBaseAmountAssets
      totalBorrowingBaseAmount
      reportingDate
      fileVersion
      maxReceivableAdvanceAmount
      totalMaxAdvanceAmount
      cashReserveAmount
      borrowingBaseReserveAmount
      borrowingBaseUtilization
      weightedAverageReceivableAdvanceRate
      totalEligibleBorrowingBaseAccountCash
      totalAssets
      totalCollectionsAccountCash
      borrowingBaseAvailabilityRate
      maximumAvailableAmount
      totalCashBorrowingBaseAmount
      assignedEligibleExposureSinceLastApprovedFundingRequest
    }
    cashBalances {
      ...BankAccountCashBalance
    }
    outstandingBalances {
      organizationId
      amount
    }
    loanBalances {
      loanId
      commitmentKey
      amount
    }
    pendingRequests {
      ...FundingRequestComponentFields
    }
    currentFundingRequestComponents {
      ...FundingRequestComponentFields
    }
    borrowingBaseReportMetadataForLastApprovedFundingRequest {
      reportingDate
      fileVersion
    }
    loans {
      ...ResolvedLoan
    }
    fundingRequestToDuplicate {
      id
      creditFacilityId
      borrowingBaseReportId
      drawRequestTotalAmount
      collectionsRecycleTotalAmount
      collectionsPaydownTotalAmount
      curePaydownTotalAmount
      status
      type
      expire
      reportingDate
      fundingRequestComponents {
        ...FundingRequestComponentFields
      }
      resolvedLoans {
        ...ResolvedLoan
      }
      created_at
      updated_at
    }
  }
}
    ${BankAccountCashBalanceFragmentDocGQLType}
${FundingRequestComponentFieldsFragmentDocGQLType}
${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetOrCreateFundingRequestTemplateQuery__
 *
 * To run a query within a React component, call `useGetOrCreateFundingRequestTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateFundingRequestTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrCreateFundingRequestTemplateQuery({
 *   variables: {
 *      mode: // value for 'mode'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      fundingRequestId: // value for 'fundingRequestId'
 *      loanId: // value for 'loanId'
 *      fundingRequestIdToDuplicate: // value for 'fundingRequestIdToDuplicate'
 *   },
 * });
 */
export function useGetOrCreateFundingRequestTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetOrCreateFundingRequestTemplateQueryGQLType, GetOrCreateFundingRequestTemplateQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrCreateFundingRequestTemplateQueryGQLType, GetOrCreateFundingRequestTemplateQueryVariablesGQLType>(GetOrCreateFundingRequestTemplateDocumentGQLType, options);
      }
export function useGetOrCreateFundingRequestTemplateLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrCreateFundingRequestTemplateQueryGQLType, GetOrCreateFundingRequestTemplateQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrCreateFundingRequestTemplateQueryGQLType, GetOrCreateFundingRequestTemplateQueryVariablesGQLType>(GetOrCreateFundingRequestTemplateDocumentGQLType, options);
        }
export type GetOrCreateFundingRequestTemplateQueryHookResult = ReturnType<typeof useGetOrCreateFundingRequestTemplateQuery>;
export type GetOrCreateFundingRequestTemplateLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrCreateFundingRequestTemplateLazyQueryGQLType>;
export type GetOrCreateFundingRequestTemplateQueryResultGQLType = Apollo.QueryResult<GetOrCreateFundingRequestTemplateQueryGQLType, GetOrCreateFundingRequestTemplateQueryVariablesGQLType>;
export const GetCurrentFundingRequestDocumentGQLType = gql`
    query GetCurrentFundingRequest($creditFacilityId: UUID!) {
  currentFundingRequest(creditFacilityId: $creditFacilityId) {
    ...FundingRequestFields
  }
}
    ${FundingRequestFieldsFragmentDocGQLType}`;

/**
 * __useGetCurrentFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetCurrentFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentFundingRequestQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCurrentFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentFundingRequestQueryGQLType, GetCurrentFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentFundingRequestQueryGQLType, GetCurrentFundingRequestQueryVariablesGQLType>(GetCurrentFundingRequestDocumentGQLType, options);
      }
export function useGetCurrentFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentFundingRequestQueryGQLType, GetCurrentFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentFundingRequestQueryGQLType, GetCurrentFundingRequestQueryVariablesGQLType>(GetCurrentFundingRequestDocumentGQLType, options);
        }
export type GetCurrentFundingRequestQueryHookResult = ReturnType<typeof useGetCurrentFundingRequestQuery>;
export type GetCurrentFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentFundingRequestLazyQueryGQLType>;
export type GetCurrentFundingRequestQueryResultGQLType = Apollo.QueryResult<GetCurrentFundingRequestQueryGQLType, GetCurrentFundingRequestQueryVariablesGQLType>;
export const GetOrganizationImplementationsDocumentGQLType = gql`
    query GetOrganizationImplementations($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    implementations {
      id
      name
      creditFacilities {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationImplementationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationImplementationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationImplementationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationImplementationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationImplementationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationImplementationsQueryGQLType, GetOrganizationImplementationsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationImplementationsQueryGQLType, GetOrganizationImplementationsQueryVariablesGQLType>(GetOrganizationImplementationsDocumentGQLType, options);
      }
export function useGetOrganizationImplementationsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationImplementationsQueryGQLType, GetOrganizationImplementationsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationImplementationsQueryGQLType, GetOrganizationImplementationsQueryVariablesGQLType>(GetOrganizationImplementationsDocumentGQLType, options);
        }
export type GetOrganizationImplementationsQueryHookResult = ReturnType<typeof useGetOrganizationImplementationsQuery>;
export type GetOrganizationImplementationsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationImplementationsLazyQueryGQLType>;
export type GetOrganizationImplementationsQueryResultGQLType = Apollo.QueryResult<GetOrganizationImplementationsQueryGQLType, GetOrganizationImplementationsQueryVariablesGQLType>;
export const GetOrganizationImplementationsDetailsDocumentGQLType = gql`
    query GetOrganizationImplementationsDetails($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    implementations {
      id
      name
      slug
      ownerOrganization {
        id
        name
        slug
      }
      borrowerOrganization {
        id
        name
        slug
      }
      loanProducts {
        id
        name
        slug
      }
      creditFacilities(includeInactive: true) {
        id
        name
        slug
        isActive
        borrowerEntityName
        type
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationImplementationsDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationImplementationsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationImplementationsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationImplementationsDetailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationImplementationsDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationImplementationsDetailsQueryGQLType, GetOrganizationImplementationsDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationImplementationsDetailsQueryGQLType, GetOrganizationImplementationsDetailsQueryVariablesGQLType>(GetOrganizationImplementationsDetailsDocumentGQLType, options);
      }
export function useGetOrganizationImplementationsDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationImplementationsDetailsQueryGQLType, GetOrganizationImplementationsDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationImplementationsDetailsQueryGQLType, GetOrganizationImplementationsDetailsQueryVariablesGQLType>(GetOrganizationImplementationsDetailsDocumentGQLType, options);
        }
export type GetOrganizationImplementationsDetailsQueryHookResult = ReturnType<typeof useGetOrganizationImplementationsDetailsQuery>;
export type GetOrganizationImplementationsDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationImplementationsDetailsLazyQueryGQLType>;
export type GetOrganizationImplementationsDetailsQueryResultGQLType = Apollo.QueryResult<GetOrganizationImplementationsDetailsQueryGQLType, GetOrganizationImplementationsDetailsQueryVariablesGQLType>;
export const GetInvoicesByOrganizationIdDocumentGQLType = gql`
    query GetInvoicesByOrganizationId($organizationId: UUID!) {
  getInvoicesByOrganizationId(organizationId: $organizationId) {
    ...InvoiceListItem
  }
}
    ${InvoiceListItemFragmentDocGQLType}`;

/**
 * __useGetInvoicesByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicesByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvoicesByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>(GetInvoicesByOrganizationIdDocumentGQLType, options);
      }
export function useGetInvoicesByOrganizationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>(GetInvoicesByOrganizationIdDocumentGQLType, options);
        }
export type GetInvoicesByOrganizationIdQueryHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdQuery>;
export type GetInvoicesByOrganizationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdLazyQueryGQLType>;
export type GetInvoicesByOrganizationIdQueryResultGQLType = Apollo.QueryResult<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>;
export const GetInvoicesByOrganizationIdPaginatedDocumentGQLType = gql`
    query GetInvoicesByOrganizationIdPaginated($organizationId: UUID!, $pagination: InvoicesPaginationInput!, $creditFacilityIds: [UUID!], $startDate: FullDateStr, $endDate: FullDateStr, $sortBy: InvoiceSortField, $sortDirection: SortDirection) {
  getInvoicesByOrganizationIdPaginated(
    organizationId: $organizationId
    pagination: $pagination
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    endDate: $endDate
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    nodes {
      ...InvoiceListItem
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${InvoiceListItemFragmentDocGQLType}`;

/**
 * __useGetInvoicesByOrganizationIdPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInvoicesByOrganizationIdPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesByOrganizationIdPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesByOrganizationIdPaginatedQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      pagination: // value for 'pagination'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetInvoicesByOrganizationIdPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>(GetInvoicesByOrganizationIdPaginatedDocumentGQLType, options);
      }
export function useGetInvoicesByOrganizationIdPaginatedLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>(GetInvoicesByOrganizationIdPaginatedDocumentGQLType, options);
        }
export type GetInvoicesByOrganizationIdPaginatedQueryHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdPaginatedQuery>;
export type GetInvoicesByOrganizationIdPaginatedLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdPaginatedLazyQueryGQLType>;
export type GetInvoicesByOrganizationIdPaginatedQueryResultGQLType = Apollo.QueryResult<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>;
export const GetInvoiceAggregatesByOrganizationIdDocumentGQLType = gql`
    query GetInvoiceAggregatesByOrganizationId($organizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr, $creditFacilityIds: [UUID!]) {
  getInvoiceAggregatesByOrganizationId(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
    creditFacilityIds: $creditFacilityIds
  ) {
    dueSoon {
      status
      totalAmount
      count
    }
    overdue {
      status
      totalAmount
      count
    }
    paid {
      status
      totalAmount
      count
    }
    totalCount
  }
}
    `;

/**
 * __useGetInvoiceAggregatesByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceAggregatesByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceAggregatesByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceAggregatesByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetInvoiceAggregatesByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>(GetInvoiceAggregatesByOrganizationIdDocumentGQLType, options);
      }
export function useGetInvoiceAggregatesByOrganizationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>(GetInvoiceAggregatesByOrganizationIdDocumentGQLType, options);
        }
export type GetInvoiceAggregatesByOrganizationIdQueryHookResult = ReturnType<typeof useGetInvoiceAggregatesByOrganizationIdQuery>;
export type GetInvoiceAggregatesByOrganizationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceAggregatesByOrganizationIdLazyQueryGQLType>;
export type GetInvoiceAggregatesByOrganizationIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>;
export const GetInvoicesByLoanIdDocumentGQLType = gql`
    query GetInvoicesByLoanId($loanId: UUID!) {
  invoices: getInvoicesByLoanId(loanId: $loanId) {
    ...InvoiceSummary
  }
}
    ${InvoiceSummaryFragmentDocGQLType}`;

/**
 * __useGetInvoicesByLoanIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicesByLoanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesByLoanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesByLoanIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetInvoicesByLoanIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>(GetInvoicesByLoanIdDocumentGQLType, options);
      }
export function useGetInvoicesByLoanIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>(GetInvoicesByLoanIdDocumentGQLType, options);
        }
export type GetInvoicesByLoanIdQueryHookResult = ReturnType<typeof useGetInvoicesByLoanIdQuery>;
export type GetInvoicesByLoanIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicesByLoanIdLazyQueryGQLType>;
export type GetInvoicesByLoanIdQueryResultGQLType = Apollo.QueryResult<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>;
export const GetInvoiceByIdDocumentGQLType = gql`
    query GetInvoiceById($invoiceId: UUID!) {
  getInvoiceById(invoiceId: $invoiceId) {
    ...Invoice
  }
}
    ${InvoiceFragmentDocGQLType}`;

/**
 * __useGetInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceByIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>(GetInvoiceByIdDocumentGQLType, options);
      }
export function useGetInvoiceByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>(GetInvoiceByIdDocumentGQLType, options);
        }
export type GetInvoiceByIdQueryHookResult = ReturnType<typeof useGetInvoiceByIdQuery>;
export type GetInvoiceByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceByIdLazyQueryGQLType>;
export type GetInvoiceByIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>;
export const GetInvoiceDisbursementsByInvoiceIdDocumentGQLType = gql`
    query GetInvoiceDisbursementsByInvoiceId($invoiceId: UUID!) {
  getInvoiceDisbursementsByInvoiceId(invoiceId: $invoiceId) {
    ...InvoiceDisbursement
  }
}
    ${InvoiceDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceDisbursementsByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDisbursementsByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDisbursementsByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDisbursementsByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceDisbursementsByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceDisbursementsByInvoiceIdDocumentGQLType, options);
      }
export function useGetInvoiceDisbursementsByInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceDisbursementsByInvoiceIdDocumentGQLType, options);
        }
export type GetInvoiceDisbursementsByInvoiceIdQueryHookResult = ReturnType<typeof useGetInvoiceDisbursementsByInvoiceIdQuery>;
export type GetInvoiceDisbursementsByInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceDisbursementsByInvoiceIdLazyQueryGQLType>;
export type GetInvoiceDisbursementsByInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>;
export const GetInvoiceDisbursementByIdDocumentGQLType = gql`
    query GetInvoiceDisbursementById($invoiceDisbursementId: UUID!) {
  getInvoiceDisbursementById(invoiceDisbursementId: $invoiceDisbursementId) {
    ...InvoiceDisbursement
  }
}
    ${InvoiceDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceDisbursementByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDisbursementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDisbursementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDisbursementByIdQuery({
 *   variables: {
 *      invoiceDisbursementId: // value for 'invoiceDisbursementId'
 *   },
 * });
 */
export function useGetInvoiceDisbursementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>(GetInvoiceDisbursementByIdDocumentGQLType, options);
      }
export function useGetInvoiceDisbursementByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>(GetInvoiceDisbursementByIdDocumentGQLType, options);
        }
export type GetInvoiceDisbursementByIdQueryHookResult = ReturnType<typeof useGetInvoiceDisbursementByIdQuery>;
export type GetInvoiceDisbursementByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceDisbursementByIdLazyQueryGQLType>;
export type GetInvoiceDisbursementByIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>;
export const GetInvoicePaymentInKindItemsByInvoiceIdDocumentGQLType = gql`
    query GetInvoicePaymentInKindItemsByInvoiceId($invoiceId: UUID!) {
  getInvoicePaymentInKindItemsByInvoiceId(invoiceId: $invoiceId) {
    invoiceItemId
    capitalizedLoanId
    capitalizedLoanName
    invoicePaymentInKindItems {
      ...InvoicePaymentInKindItem
    }
  }
}
    ${InvoicePaymentInKindItemFragmentDocGQLType}`;

/**
 * __useGetInvoicePaymentInKindItemsByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentInKindItemsByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentInKindItemsByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentInKindItemsByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoicePaymentInKindItemsByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemsByInvoiceIdDocumentGQLType, options);
      }
export function useGetInvoicePaymentInKindItemsByInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemsByInvoiceIdDocumentGQLType, options);
        }
export type GetInvoicePaymentInKindItemsByInvoiceIdQueryHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemsByInvoiceIdQuery>;
export type GetInvoicePaymentInKindItemsByInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemsByInvoiceIdLazyQueryGQLType>;
export type GetInvoicePaymentInKindItemsByInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>;
export const GetInvoicePaymentInKindItemByIdDocumentGQLType = gql`
    query GetInvoicePaymentInKindItemById($invoicePaymentInKindItemId: UUID!) {
  getInvoicePaymentInKindItemById(
    invoicePaymentInKindItemId: $invoicePaymentInKindItemId
  ) {
    ...InvoicePaymentInKindItem
  }
}
    ${InvoicePaymentInKindItemFragmentDocGQLType}`;

/**
 * __useGetInvoicePaymentInKindItemByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentInKindItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentInKindItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentInKindItemByIdQuery({
 *   variables: {
 *      invoicePaymentInKindItemId: // value for 'invoicePaymentInKindItemId'
 *   },
 * });
 */
export function useGetInvoicePaymentInKindItemByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemByIdDocumentGQLType, options);
      }
export function useGetInvoicePaymentInKindItemByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemByIdDocumentGQLType, options);
        }
export type GetInvoicePaymentInKindItemByIdQueryHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemByIdQuery>;
export type GetInvoicePaymentInKindItemByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemByIdLazyQueryGQLType>;
export type GetInvoicePaymentInKindItemByIdQueryResultGQLType = Apollo.QueryResult<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>;
export const GetInvoiceConsolidatedDisbursementsByInvoiceIdDocumentGQLType = gql`
    query GetInvoiceConsolidatedDisbursementsByInvoiceId($invoiceId: UUID!) {
  getInvoiceConsolidatedDisbursementsByInvoiceId(invoiceId: $invoiceId) {
    ...InvoiceConsolidatedDisbursement
  }
}
    ${InvoiceConsolidatedDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementsByInvoiceIdDocumentGQLType, options);
      }
export function useGetInvoiceConsolidatedDisbursementsByInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementsByInvoiceIdDocumentGQLType, options);
        }
export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery>;
export type GetInvoiceConsolidatedDisbursementsByInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementsByInvoiceIdLazyQueryGQLType>;
export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>;
export const GetLatestInvoiceFacilityFeeAccrualEndDateDocumentGQLType = gql`
    query GetLatestInvoiceFacilityFeeAccrualEndDate($creditFacilityId: UUID!) {
  getLatestInvoiceFacilityFeeAccrualEndDate(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useGetLatestInvoiceFacilityFeeAccrualEndDateQuery__
 *
 * To run a query within a React component, call `useGetLatestInvoiceFacilityFeeAccrualEndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestInvoiceFacilityFeeAccrualEndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestInvoiceFacilityFeeAccrualEndDateQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLatestInvoiceFacilityFeeAccrualEndDateQuery(baseOptions: Apollo.QueryHookOptions<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>(GetLatestInvoiceFacilityFeeAccrualEndDateDocumentGQLType, options);
      }
export function useGetLatestInvoiceFacilityFeeAccrualEndDateLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>(GetLatestInvoiceFacilityFeeAccrualEndDateDocumentGQLType, options);
        }
export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryHookResult = ReturnType<typeof useGetLatestInvoiceFacilityFeeAccrualEndDateQuery>;
export type GetLatestInvoiceFacilityFeeAccrualEndDateLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestInvoiceFacilityFeeAccrualEndDateLazyQueryGQLType>;
export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryResultGQLType = Apollo.QueryResult<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>;
export const GetInvoiceConsolidatedDisbursementByIdDocumentGQLType = gql`
    query GetInvoiceConsolidatedDisbursementById($invoiceConsolidatedDisbursementId: UUID!) {
  getInvoiceConsolidatedDisbursementById(
    invoiceConsolidatedDisbursementId: $invoiceConsolidatedDisbursementId
  ) {
    ...InvoiceConsolidatedDisbursement
  }
}
    ${InvoiceConsolidatedDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceConsolidatedDisbursementByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceConsolidatedDisbursementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceConsolidatedDisbursementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceConsolidatedDisbursementByIdQuery({
 *   variables: {
 *      invoiceConsolidatedDisbursementId: // value for 'invoiceConsolidatedDisbursementId'
 *   },
 * });
 */
export function useGetInvoiceConsolidatedDisbursementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementByIdDocumentGQLType, options);
      }
export function useGetInvoiceConsolidatedDisbursementByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementByIdDocumentGQLType, options);
        }
export type GetInvoiceConsolidatedDisbursementByIdQueryHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementByIdQuery>;
export type GetInvoiceConsolidatedDisbursementByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementByIdLazyQueryGQLType>;
export type GetInvoiceConsolidatedDisbursementByIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>;
export const GetInvoiceFacilityFeeBalancesDocumentGQLType = gql`
    query GetInvoiceFacilityFeeBalances($creditFacilityId: UUID!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  getInvoiceFacilityFeeBalances(
    creditFacilityId: $creditFacilityId
    startDate: $startDate
    endDate: $endDate
  ) {
    account {
      id
      tAccount
      creditFacilityId
      organizationId
    }
    totalAccruedAmount
  }
}
    `;

/**
 * __useGetInvoiceFacilityFeeBalancesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceFacilityFeeBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceFacilityFeeBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceFacilityFeeBalancesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetInvoiceFacilityFeeBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>(GetInvoiceFacilityFeeBalancesDocumentGQLType, options);
      }
export function useGetInvoiceFacilityFeeBalancesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>(GetInvoiceFacilityFeeBalancesDocumentGQLType, options);
        }
export type GetInvoiceFacilityFeeBalancesQueryHookResult = ReturnType<typeof useGetInvoiceFacilityFeeBalancesQuery>;
export type GetInvoiceFacilityFeeBalancesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceFacilityFeeBalancesLazyQueryGQLType>;
export type GetInvoiceFacilityFeeBalancesQueryResultGQLType = Apollo.QueryResult<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>;
export const GetPrincipalPaymentMetricsByLoanIdDocumentGQLType = gql`
    query getPrincipalPaymentMetricsByLoanId($loanId: UUID!) {
  result: getPrincipalPaymentMetricsByLoanId(loanId: $loanId) {
    latestPaymentDate
    loanHasPayment
  }
}
    `;

/**
 * __useGetPrincipalPaymentMetricsByLoanIdQuery__
 *
 * To run a query within a React component, call `useGetPrincipalPaymentMetricsByLoanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrincipalPaymentMetricsByLoanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrincipalPaymentMetricsByLoanIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetPrincipalPaymentMetricsByLoanIdQuery(baseOptions: Apollo.QueryHookOptions<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>(GetPrincipalPaymentMetricsByLoanIdDocumentGQLType, options);
      }
export function useGetPrincipalPaymentMetricsByLoanIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>(GetPrincipalPaymentMetricsByLoanIdDocumentGQLType, options);
        }
export type GetPrincipalPaymentMetricsByLoanIdQueryHookResult = ReturnType<typeof useGetPrincipalPaymentMetricsByLoanIdQuery>;
export type GetPrincipalPaymentMetricsByLoanIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPrincipalPaymentMetricsByLoanIdLazyQueryGQLType>;
export type GetPrincipalPaymentMetricsByLoanIdQueryResultGQLType = Apollo.QueryResult<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>;
export const GetLoanMetricsForInvoiceIdDocumentGQLType = gql`
    query getLoanMetricsForInvoiceId($invoiceId: UUID!) {
  result: getLoanMetricsForInvoiceId(invoiceId: $invoiceId) {
    latestFundTransferDate
    hasPrincipalPayment
  }
}
    `;

/**
 * __useGetLoanMetricsForInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetLoanMetricsForInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanMetricsForInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanMetricsForInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetLoanMetricsForInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>(GetLoanMetricsForInvoiceIdDocumentGQLType, options);
      }
export function useGetLoanMetricsForInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>(GetLoanMetricsForInvoiceIdDocumentGQLType, options);
        }
export type GetLoanMetricsForInvoiceIdQueryHookResult = ReturnType<typeof useGetLoanMetricsForInvoiceIdQuery>;
export type GetLoanMetricsForInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanMetricsForInvoiceIdLazyQueryGQLType>;
export type GetLoanMetricsForInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>;
export const GetPaymentInKindServicingFeeDetailsForCreditFacilitiesDocumentGQLType = gql`
    query GetPaymentInKindServicingFeeDetailsForCreditFacilities($creditFacilityIds: [UUID!]!, $invoicePaymentStartDate: FullDateStr!, $invoicePaymentEndDate: FullDateStr!, $capitalizedLoanIds: [UUID!], $capitalProviderOrganizationIds: [UUID!]) {
  servicingFeeDetails: getPaymentInKindServicingFeeDetailsForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    invoicePaymentStartDate: $invoicePaymentStartDate
    invoicePaymentEndDate: $invoicePaymentEndDate
    capitalizedLoanIds: $capitalizedLoanIds
    capitalProviderOrganizationIds: $capitalProviderOrganizationIds
  ) {
    creditFacilityId
    creditFacilityName
    capitalProviderId
    capitalProviderName
    capitalizedLoanId
    capitalizedLoanName
    capitalizedExternalLoanId
    originatingLoanId
    originatingLoanName
    originatingExternalLoanId
    serviceFeeAmount
    invoicePaymentDate
    invoiceUpdatedAt
    runningBalance
    report {
      ...InvoiceReport
    }
  }
}
    ${InvoiceReportFragmentDocGQLType}`;

/**
 * __useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      invoicePaymentStartDate: // value for 'invoicePaymentStartDate'
 *      invoicePaymentEndDate: // value for 'invoicePaymentEndDate'
 *      capitalizedLoanIds: // value for 'capitalizedLoanIds'
 *      capitalProviderOrganizationIds: // value for 'capitalProviderOrganizationIds'
 *   },
 * });
 */
export function useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>(GetPaymentInKindServicingFeeDetailsForCreditFacilitiesDocumentGQLType, options);
      }
export function useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>(GetPaymentInKindServicingFeeDetailsForCreditFacilitiesDocumentGQLType, options);
        }
export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryHookResult = ReturnType<typeof useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery>;
export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesLazyQueryGQLType>;
export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>;
export const CreateInvoiceWithInvoiceItemsDocumentGQLType = gql`
    mutation CreateInvoiceWithInvoiceItems($invoice: InvoiceInput!, $invoiceComponentsWithInvoiceItems: [InvoiceComponentWithInvoiceItemsInput!]!) {
  createInvoiceWithInvoiceItems(
    invoice: $invoice
    invoiceComponentsWithInvoiceItems: $invoiceComponentsWithInvoiceItems
  ) {
    invoiceId
    invoiceWorkleaseId
    disbursementWorkleaseIds
  }
}
    `;
export type CreateInvoiceWithInvoiceItemsMutationFnGQLType = Apollo.MutationFunction<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>;

/**
 * __useCreateInvoiceWithInvoiceItemsMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceWithInvoiceItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceWithInvoiceItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceWithInvoiceItemsMutation, { data, loading, error }] = useCreateInvoiceWithInvoiceItemsMutation({
 *   variables: {
 *      invoice: // value for 'invoice'
 *      invoiceComponentsWithInvoiceItems: // value for 'invoiceComponentsWithInvoiceItems'
 *   },
 * });
 */
export function useCreateInvoiceWithInvoiceItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>(CreateInvoiceWithInvoiceItemsDocumentGQLType, options);
      }
export type CreateInvoiceWithInvoiceItemsMutationHookResult = ReturnType<typeof useCreateInvoiceWithInvoiceItemsMutation>;
export type CreateInvoiceWithInvoiceItemsMutationResultGQLType = Apollo.MutationResult<CreateInvoiceWithInvoiceItemsMutationGQLType>;
export type CreateInvoiceWithInvoiceItemsMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>;
export const MarkInvoiceAsPaidDocumentGQLType = gql`
    mutation MarkInvoiceAsPaid($invoiceId: UUID!, $invoicePaymentDate: FullDateStr!) {
  markInvoiceAsPaid(
    invoiceId: $invoiceId
    invoicePaymentDate: $invoicePaymentDate
  ) {
    invoiceId
  }
}
    `;
export type MarkInvoiceAsPaidMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>;

/**
 * __useMarkInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidMutation, { data, loading, error }] = useMarkInvoiceAsPaidMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      invoicePaymentDate: // value for 'invoicePaymentDate'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>(MarkInvoiceAsPaidDocumentGQLType, options);
      }
export type MarkInvoiceAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidMutation>;
export type MarkInvoiceAsPaidMutationResultGQLType = Apollo.MutationResult<MarkInvoiceAsPaidMutationGQLType>;
export type MarkInvoiceAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>;
export const MarkInvoiceAsCanceledDocumentGQLType = gql`
    mutation MarkInvoiceAsCanceled($invoiceId: UUID!) {
  markInvoiceAsCanceled(invoiceId: $invoiceId) {
    invoiceId
  }
}
    `;
export type MarkInvoiceAsCanceledMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>;

/**
 * __useMarkInvoiceAsCanceledMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsCanceledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsCanceledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsCanceledMutation, { data, loading, error }] = useMarkInvoiceAsCanceledMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useMarkInvoiceAsCanceledMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>(MarkInvoiceAsCanceledDocumentGQLType, options);
      }
export type MarkInvoiceAsCanceledMutationHookResult = ReturnType<typeof useMarkInvoiceAsCanceledMutation>;
export type MarkInvoiceAsCanceledMutationResultGQLType = Apollo.MutationResult<MarkInvoiceAsCanceledMutationGQLType>;
export type MarkInvoiceAsCanceledMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>;
export const MarkInvoiceDisbursementAsPaidDocumentGQLType = gql`
    mutation MarkInvoiceDisbursementAsPaid($invoiceDisbursementId: UUID!, $disbursementDate: FullDateStr!) {
  markInvoiceDisbursementAsPaid(
    invoiceDisbursementId: $invoiceDisbursementId
    disbursementDate: $disbursementDate
  ) {
    invoiceDisbursementId
  }
}
    `;
export type MarkInvoiceDisbursementAsPaidMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>;

/**
 * __useMarkInvoiceDisbursementAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceDisbursementAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceDisbursementAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceDisbursementAsPaidMutation, { data, loading, error }] = useMarkInvoiceDisbursementAsPaidMutation({
 *   variables: {
 *      invoiceDisbursementId: // value for 'invoiceDisbursementId'
 *      disbursementDate: // value for 'disbursementDate'
 *   },
 * });
 */
export function useMarkInvoiceDisbursementAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>(MarkInvoiceDisbursementAsPaidDocumentGQLType, options);
      }
export type MarkInvoiceDisbursementAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceDisbursementAsPaidMutation>;
export type MarkInvoiceDisbursementAsPaidMutationResultGQLType = Apollo.MutationResult<MarkInvoiceDisbursementAsPaidMutationGQLType>;
export type MarkInvoiceDisbursementAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>;
export const MarkInvoicePaymentInKindItemAsNotifiedDocumentGQLType = gql`
    mutation MarkInvoicePaymentInKindItemAsNotified($invoicePaymentInKindItemId: UUID!, $notifiedDate: FullDateStr!) {
  markInvoicePaymentInKindItemAsNotified(
    invoicePaymentInKindItemId: $invoicePaymentInKindItemId
    notifiedDate: $notifiedDate
  ) {
    invoicePaymentInKindItemId
  }
}
    `;
export type MarkInvoicePaymentInKindItemAsNotifiedMutationFnGQLType = Apollo.MutationFunction<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>;

/**
 * __useMarkInvoicePaymentInKindItemAsNotifiedMutation__
 *
 * To run a mutation, you first call `useMarkInvoicePaymentInKindItemAsNotifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoicePaymentInKindItemAsNotifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoicePaymentInKindItemAsNotifiedMutation, { data, loading, error }] = useMarkInvoicePaymentInKindItemAsNotifiedMutation({
 *   variables: {
 *      invoicePaymentInKindItemId: // value for 'invoicePaymentInKindItemId'
 *      notifiedDate: // value for 'notifiedDate'
 *   },
 * });
 */
export function useMarkInvoicePaymentInKindItemAsNotifiedMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>(MarkInvoicePaymentInKindItemAsNotifiedDocumentGQLType, options);
      }
export type MarkInvoicePaymentInKindItemAsNotifiedMutationHookResult = ReturnType<typeof useMarkInvoicePaymentInKindItemAsNotifiedMutation>;
export type MarkInvoicePaymentInKindItemAsNotifiedMutationResultGQLType = Apollo.MutationResult<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType>;
export type MarkInvoicePaymentInKindItemAsNotifiedMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>;
export const UpdateInvoiceDueDateDocumentGQLType = gql`
    mutation UpdateInvoiceDueDate($invoiceId: UUID!, $newDueDate: FullDateStr!) {
  updateInvoiceDueDate(invoiceId: $invoiceId, newDueDate: $newDueDate) {
    invoiceId
  }
}
    `;
export type UpdateInvoiceDueDateMutationFnGQLType = Apollo.MutationFunction<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>;

/**
 * __useUpdateInvoiceDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceDueDateMutation, { data, loading, error }] = useUpdateInvoiceDueDateMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      newDueDate: // value for 'newDueDate'
 *   },
 * });
 */
export function useUpdateInvoiceDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>(UpdateInvoiceDueDateDocumentGQLType, options);
      }
export type UpdateInvoiceDueDateMutationHookResult = ReturnType<typeof useUpdateInvoiceDueDateMutation>;
export type UpdateInvoiceDueDateMutationResultGQLType = Apollo.MutationResult<UpdateInvoiceDueDateMutationGQLType>;
export type UpdateInvoiceDueDateMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>;
export const ReverseInvoicePaymentDocumentGQLType = gql`
    mutation ReverseInvoicePayment($invoiceId: UUID!) {
  reverseInvoicePayment(invoiceId: $invoiceId) {
    invoiceId
  }
}
    `;
export type ReverseInvoicePaymentMutationFnGQLType = Apollo.MutationFunction<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>;

/**
 * __useReverseInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useReverseInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseInvoicePaymentMutation, { data, loading, error }] = useReverseInvoicePaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useReverseInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>(ReverseInvoicePaymentDocumentGQLType, options);
      }
export type ReverseInvoicePaymentMutationHookResult = ReturnType<typeof useReverseInvoicePaymentMutation>;
export type ReverseInvoicePaymentMutationResultGQLType = Apollo.MutationResult<ReverseInvoicePaymentMutationGQLType>;
export type ReverseInvoicePaymentMutationOptionsGQLType = Apollo.BaseMutationOptions<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>;
export const MarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType = gql`
    mutation MarkInvoiceConsolidatedDisbursementAsPaid($invoiceConsolidatedDisbursementId: UUID!, $paymentDate: FullDateStr!) {
  markInvoiceConsolidatedDisbursementAsPaid(
    invoiceConsolidatedDisbursementId: $invoiceConsolidatedDisbursementId
    paymentDate: $paymentDate
  ) {
    invoiceConsolidatedDisbursementId
  }
}
    `;
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;

/**
 * __useMarkInvoiceConsolidatedDisbursementAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceConsolidatedDisbursementAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceConsolidatedDisbursementAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceConsolidatedDisbursementAsPaidMutation, { data, loading, error }] = useMarkInvoiceConsolidatedDisbursementAsPaidMutation({
 *   variables: {
 *      invoiceConsolidatedDisbursementId: // value for 'invoiceConsolidatedDisbursementId'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function useMarkInvoiceConsolidatedDisbursementAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>(MarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType, options);
      }
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceConsolidatedDisbursementAsPaidMutation>;
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationResultGQLType = Apollo.MutationResult<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType>;
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;
export const UndoMarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType = gql`
    mutation UndoMarkInvoiceConsolidatedDisbursementAsPaid($invoiceConsolidatedDisbursementId: UUID!) {
  undoMarkInvoiceConsolidatedDisbursementAsPaid(
    invoiceConsolidatedDisbursementId: $invoiceConsolidatedDisbursementId
  ) {
    invoiceConsolidatedDisbursementId
  }
}
    `;
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationFnGQLType = Apollo.MutationFunction<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;

/**
 * __useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation__
 *
 * To run a mutation, you first call `useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoMarkInvoiceConsolidatedDisbursementAsPaidMutation, { data, loading, error }] = useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation({
 *   variables: {
 *      invoiceConsolidatedDisbursementId: // value for 'invoiceConsolidatedDisbursementId'
 *   },
 * });
 */
export function useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>(UndoMarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType, options);
      }
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationHookResult = ReturnType<typeof useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation>;
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationResultGQLType = Apollo.MutationResult<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType>;
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;
export const GetLimitedPartnerMappingsForAliasingDocumentGQLType = gql`
    query GetLimitedPartnerMappingsForAliasing($lenderOrganizationId: UUID!, $queryString: String) {
  limitedPartnerMappingsByFacility: getLimitedPartnerMappingsForLenderCapitalCallLineFacilities(
    lenderOrganizationId: $lenderOrganizationId
    queryString: $queryString
  ) {
    creditFacilityId
    creditFacilityName
    mappings {
      ...LimitedPartnerMappingForAliasing
    }
  }
}
    ${LimitedPartnerMappingForAliasingFragmentDocGQLType}`;

/**
 * __useGetLimitedPartnerMappingsForAliasingQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerMappingsForAliasingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerMappingsForAliasingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerMappingsForAliasingQuery({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useGetLimitedPartnerMappingsForAliasingQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerMappingsForAliasingQueryGQLType, GetLimitedPartnerMappingsForAliasingQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerMappingsForAliasingQueryGQLType, GetLimitedPartnerMappingsForAliasingQueryVariablesGQLType>(GetLimitedPartnerMappingsForAliasingDocumentGQLType, options);
      }
export function useGetLimitedPartnerMappingsForAliasingLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerMappingsForAliasingQueryGQLType, GetLimitedPartnerMappingsForAliasingQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerMappingsForAliasingQueryGQLType, GetLimitedPartnerMappingsForAliasingQueryVariablesGQLType>(GetLimitedPartnerMappingsForAliasingDocumentGQLType, options);
        }
export type GetLimitedPartnerMappingsForAliasingQueryHookResult = ReturnType<typeof useGetLimitedPartnerMappingsForAliasingQuery>;
export type GetLimitedPartnerMappingsForAliasingLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerMappingsForAliasingLazyQueryGQLType>;
export type GetLimitedPartnerMappingsForAliasingQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerMappingsForAliasingQueryGQLType, GetLimitedPartnerMappingsForAliasingQueryVariablesGQLType>;
export const GetCountOfUnmatchedLimitedPartnerMappingsDocumentGQLType = gql`
    query GetCountOfUnmatchedLimitedPartnerMappings($lenderOrganizationId: UUID!) {
  unmatchedLimitedPartnerMappingsCount: getCountOfUnmatchedLimitedPartnerMappings(
    lenderOrganizationId: $lenderOrganizationId
  )
}
    `;

/**
 * __useGetCountOfUnmatchedLimitedPartnerMappingsQuery__
 *
 * To run a query within a React component, call `useGetCountOfUnmatchedLimitedPartnerMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountOfUnmatchedLimitedPartnerMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountOfUnmatchedLimitedPartnerMappingsQuery({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *   },
 * });
 */
export function useGetCountOfUnmatchedLimitedPartnerMappingsQuery(baseOptions: Apollo.QueryHookOptions<GetCountOfUnmatchedLimitedPartnerMappingsQueryGQLType, GetCountOfUnmatchedLimitedPartnerMappingsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountOfUnmatchedLimitedPartnerMappingsQueryGQLType, GetCountOfUnmatchedLimitedPartnerMappingsQueryVariablesGQLType>(GetCountOfUnmatchedLimitedPartnerMappingsDocumentGQLType, options);
      }
export function useGetCountOfUnmatchedLimitedPartnerMappingsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCountOfUnmatchedLimitedPartnerMappingsQueryGQLType, GetCountOfUnmatchedLimitedPartnerMappingsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountOfUnmatchedLimitedPartnerMappingsQueryGQLType, GetCountOfUnmatchedLimitedPartnerMappingsQueryVariablesGQLType>(GetCountOfUnmatchedLimitedPartnerMappingsDocumentGQLType, options);
        }
export type GetCountOfUnmatchedLimitedPartnerMappingsQueryHookResult = ReturnType<typeof useGetCountOfUnmatchedLimitedPartnerMappingsQuery>;
export type GetCountOfUnmatchedLimitedPartnerMappingsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCountOfUnmatchedLimitedPartnerMappingsLazyQueryGQLType>;
export type GetCountOfUnmatchedLimitedPartnerMappingsQueryResultGQLType = Apollo.QueryResult<GetCountOfUnmatchedLimitedPartnerMappingsQueryGQLType, GetCountOfUnmatchedLimitedPartnerMappingsQueryVariablesGQLType>;
export const GetLimitedPartnerByIdDocumentGQLType = gql`
    query GetLimitedPartnerById($limitedPartnerId: UUID!) {
  limitedPartner: getLimitedPartnerById(limitedPartnerId: $limitedPartnerId) {
    id
    name
    alternateAliases
  }
}
    `;

/**
 * __useGetLimitedPartnerByIdQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerByIdQuery({
 *   variables: {
 *      limitedPartnerId: // value for 'limitedPartnerId'
 *   },
 * });
 */
export function useGetLimitedPartnerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerByIdQueryGQLType, GetLimitedPartnerByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerByIdQueryGQLType, GetLimitedPartnerByIdQueryVariablesGQLType>(GetLimitedPartnerByIdDocumentGQLType, options);
      }
export function useGetLimitedPartnerByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerByIdQueryGQLType, GetLimitedPartnerByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerByIdQueryGQLType, GetLimitedPartnerByIdQueryVariablesGQLType>(GetLimitedPartnerByIdDocumentGQLType, options);
        }
export type GetLimitedPartnerByIdQueryHookResult = ReturnType<typeof useGetLimitedPartnerByIdQuery>;
export type GetLimitedPartnerByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerByIdLazyQueryGQLType>;
export type GetLimitedPartnerByIdQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerByIdQueryGQLType, GetLimitedPartnerByIdQueryVariablesGQLType>;
export const GetLimitedPartnerDetailsDocumentGQLType = gql`
    query GetLimitedPartnerDetails($limitedPartnerId: UUID!, $organizationId: UUID!) {
  limitedPartner: getLimitedPartnerById(limitedPartnerId: $limitedPartnerId) {
    id
    name
    alternateAliases
  }
  attributes: getAttributeListByEntity(
    organizationId: $organizationId
    listName: "limitedPartnerCustomAttributes"
    entityDomain: limitedPartner
    entityIdentifier: $limitedPartnerId
  ) {
    ...AttributeFragment
  }
}
    ${AttributeFragmentFragmentDocGQLType}`;

/**
 * __useGetLimitedPartnerDetailsQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerDetailsQuery({
 *   variables: {
 *      limitedPartnerId: // value for 'limitedPartnerId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetLimitedPartnerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerDetailsQueryGQLType, GetLimitedPartnerDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerDetailsQueryGQLType, GetLimitedPartnerDetailsQueryVariablesGQLType>(GetLimitedPartnerDetailsDocumentGQLType, options);
      }
export function useGetLimitedPartnerDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerDetailsQueryGQLType, GetLimitedPartnerDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerDetailsQueryGQLType, GetLimitedPartnerDetailsQueryVariablesGQLType>(GetLimitedPartnerDetailsDocumentGQLType, options);
        }
export type GetLimitedPartnerDetailsQueryHookResult = ReturnType<typeof useGetLimitedPartnerDetailsQuery>;
export type GetLimitedPartnerDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerDetailsLazyQueryGQLType>;
export type GetLimitedPartnerDetailsQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerDetailsQueryGQLType, GetLimitedPartnerDetailsQueryVariablesGQLType>;
export const GetLimitedPartnersForOrganizationDocumentGQLType = gql`
    query GetLimitedPartnersForOrganization($organizationId: UUID!, $queryString: String) {
  limitedPartners: getLimitedPartnersForOrganization(
    organizationId: $organizationId
    queryString: $queryString
  ) {
    id
    name
    alternateAliases
  }
}
    `;

/**
 * __useGetLimitedPartnersForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnersForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnersForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnersForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      queryString: // value for 'queryString'
 *   },
 * });
 */
export function useGetLimitedPartnersForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnersForOrganizationQueryGQLType, GetLimitedPartnersForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnersForOrganizationQueryGQLType, GetLimitedPartnersForOrganizationQueryVariablesGQLType>(GetLimitedPartnersForOrganizationDocumentGQLType, options);
      }
export function useGetLimitedPartnersForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnersForOrganizationQueryGQLType, GetLimitedPartnersForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnersForOrganizationQueryGQLType, GetLimitedPartnersForOrganizationQueryVariablesGQLType>(GetLimitedPartnersForOrganizationDocumentGQLType, options);
        }
export type GetLimitedPartnersForOrganizationQueryHookResult = ReturnType<typeof useGetLimitedPartnersForOrganizationQuery>;
export type GetLimitedPartnersForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnersForOrganizationLazyQueryGQLType>;
export type GetLimitedPartnersForOrganizationQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnersForOrganizationQueryGQLType, GetLimitedPartnersForOrganizationQueryVariablesGQLType>;
export const GetAggregatedLimitedPartnerCommitmentDataForLenderDocumentGQLType = gql`
    query GetAggregatedLimitedPartnerCommitmentDataForLender($lenderOrganizationId: UUID!, $filters: LimitedPartnerFilters!) {
  aggregatedLimitedPartnerCommitmentData: getAggregatedLimitedPartnerCommitmentDataForLender(
    lenderOrganizationId: $lenderOrganizationId
    filters: $filters
  ) {
    ...AggregatedLimitedPartnerCommitmentData
  }
}
    ${AggregatedLimitedPartnerCommitmentDataFragmentDocGQLType}`;

/**
 * __useGetAggregatedLimitedPartnerCommitmentDataForLenderQuery__
 *
 * To run a query within a React component, call `useGetAggregatedLimitedPartnerCommitmentDataForLenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedLimitedPartnerCommitmentDataForLenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedLimitedPartnerCommitmentDataForLenderQuery({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAggregatedLimitedPartnerCommitmentDataForLenderQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedLimitedPartnerCommitmentDataForLenderQueryGQLType, GetAggregatedLimitedPartnerCommitmentDataForLenderQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedLimitedPartnerCommitmentDataForLenderQueryGQLType, GetAggregatedLimitedPartnerCommitmentDataForLenderQueryVariablesGQLType>(GetAggregatedLimitedPartnerCommitmentDataForLenderDocumentGQLType, options);
      }
export function useGetAggregatedLimitedPartnerCommitmentDataForLenderLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedLimitedPartnerCommitmentDataForLenderQueryGQLType, GetAggregatedLimitedPartnerCommitmentDataForLenderQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedLimitedPartnerCommitmentDataForLenderQueryGQLType, GetAggregatedLimitedPartnerCommitmentDataForLenderQueryVariablesGQLType>(GetAggregatedLimitedPartnerCommitmentDataForLenderDocumentGQLType, options);
        }
export type GetAggregatedLimitedPartnerCommitmentDataForLenderQueryHookResult = ReturnType<typeof useGetAggregatedLimitedPartnerCommitmentDataForLenderQuery>;
export type GetAggregatedLimitedPartnerCommitmentDataForLenderLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAggregatedLimitedPartnerCommitmentDataForLenderLazyQueryGQLType>;
export type GetAggregatedLimitedPartnerCommitmentDataForLenderQueryResultGQLType = Apollo.QueryResult<GetAggregatedLimitedPartnerCommitmentDataForLenderQueryGQLType, GetAggregatedLimitedPartnerCommitmentDataForLenderQueryVariablesGQLType>;
export const GetLimitedPartnerCommitmentsForLenderDocumentGQLType = gql`
    query GetLimitedPartnerCommitmentsForLender($lenderOrganizationId: UUID!) {
  limitedPartnerCommitments: getLimitedPartnerCommitmentsForLender(
    lenderOrganizationId: $lenderOrganizationId
  ) {
    ...LimitedPartnerCommitment
  }
}
    ${LimitedPartnerCommitmentFragmentDocGQLType}`;

/**
 * __useGetLimitedPartnerCommitmentsForLenderQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerCommitmentsForLenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerCommitmentsForLenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerCommitmentsForLenderQuery({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *   },
 * });
 */
export function useGetLimitedPartnerCommitmentsForLenderQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerCommitmentsForLenderQueryGQLType, GetLimitedPartnerCommitmentsForLenderQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerCommitmentsForLenderQueryGQLType, GetLimitedPartnerCommitmentsForLenderQueryVariablesGQLType>(GetLimitedPartnerCommitmentsForLenderDocumentGQLType, options);
      }
export function useGetLimitedPartnerCommitmentsForLenderLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerCommitmentsForLenderQueryGQLType, GetLimitedPartnerCommitmentsForLenderQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerCommitmentsForLenderQueryGQLType, GetLimitedPartnerCommitmentsForLenderQueryVariablesGQLType>(GetLimitedPartnerCommitmentsForLenderDocumentGQLType, options);
        }
export type GetLimitedPartnerCommitmentsForLenderQueryHookResult = ReturnType<typeof useGetLimitedPartnerCommitmentsForLenderQuery>;
export type GetLimitedPartnerCommitmentsForLenderLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerCommitmentsForLenderLazyQueryGQLType>;
export type GetLimitedPartnerCommitmentsForLenderQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerCommitmentsForLenderQueryGQLType, GetLimitedPartnerCommitmentsForLenderQueryVariablesGQLType>;
export const GetCommitmentsForLimitedPartnerDocumentGQLType = gql`
    query GetCommitmentsForLimitedPartner($limitedPartnerId: UUID!) {
  limitedPartnerCommitments: getCommitmentsForLimitedPartner(
    limitedPartnerId: $limitedPartnerId
  ) {
    ...LimitedPartnerCommitmentDetail
  }
}
    ${LimitedPartnerCommitmentDetailFragmentDocGQLType}`;

/**
 * __useGetCommitmentsForLimitedPartnerQuery__
 *
 * To run a query within a React component, call `useGetCommitmentsForLimitedPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommitmentsForLimitedPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommitmentsForLimitedPartnerQuery({
 *   variables: {
 *      limitedPartnerId: // value for 'limitedPartnerId'
 *   },
 * });
 */
export function useGetCommitmentsForLimitedPartnerQuery(baseOptions: Apollo.QueryHookOptions<GetCommitmentsForLimitedPartnerQueryGQLType, GetCommitmentsForLimitedPartnerQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommitmentsForLimitedPartnerQueryGQLType, GetCommitmentsForLimitedPartnerQueryVariablesGQLType>(GetCommitmentsForLimitedPartnerDocumentGQLType, options);
      }
export function useGetCommitmentsForLimitedPartnerLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCommitmentsForLimitedPartnerQueryGQLType, GetCommitmentsForLimitedPartnerQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommitmentsForLimitedPartnerQueryGQLType, GetCommitmentsForLimitedPartnerQueryVariablesGQLType>(GetCommitmentsForLimitedPartnerDocumentGQLType, options);
        }
export type GetCommitmentsForLimitedPartnerQueryHookResult = ReturnType<typeof useGetCommitmentsForLimitedPartnerQuery>;
export type GetCommitmentsForLimitedPartnerLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCommitmentsForLimitedPartnerLazyQueryGQLType>;
export type GetCommitmentsForLimitedPartnerQueryResultGQLType = Apollo.QueryResult<GetCommitmentsForLimitedPartnerQueryGQLType, GetCommitmentsForLimitedPartnerQueryVariablesGQLType>;
export const GetLimitedPartnerCapitalTrendDataDocumentGQLType = gql`
    query GetLimitedPartnerCapitalTrendData($limitedPartnerId: UUID!) {
  capitalTrendData: getLimitedPartnerCapitalTrendData(
    limitedPartnerId: $limitedPartnerId
  ) {
    ...LimitedPartnerCapitalTrendData
  }
}
    ${LimitedPartnerCapitalTrendDataFragmentDocGQLType}`;

/**
 * __useGetLimitedPartnerCapitalTrendDataQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerCapitalTrendDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerCapitalTrendDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerCapitalTrendDataQuery({
 *   variables: {
 *      limitedPartnerId: // value for 'limitedPartnerId'
 *   },
 * });
 */
export function useGetLimitedPartnerCapitalTrendDataQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerCapitalTrendDataQueryGQLType, GetLimitedPartnerCapitalTrendDataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerCapitalTrendDataQueryGQLType, GetLimitedPartnerCapitalTrendDataQueryVariablesGQLType>(GetLimitedPartnerCapitalTrendDataDocumentGQLType, options);
      }
export function useGetLimitedPartnerCapitalTrendDataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerCapitalTrendDataQueryGQLType, GetLimitedPartnerCapitalTrendDataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerCapitalTrendDataQueryGQLType, GetLimitedPartnerCapitalTrendDataQueryVariablesGQLType>(GetLimitedPartnerCapitalTrendDataDocumentGQLType, options);
        }
export type GetLimitedPartnerCapitalTrendDataQueryHookResult = ReturnType<typeof useGetLimitedPartnerCapitalTrendDataQuery>;
export type GetLimitedPartnerCapitalTrendDataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerCapitalTrendDataLazyQueryGQLType>;
export type GetLimitedPartnerCapitalTrendDataQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerCapitalTrendDataQueryGQLType, GetLimitedPartnerCapitalTrendDataQueryVariablesGQLType>;
export const GetLimitedPartnerPortfolioOverviewGraphDataDocumentGQLType = gql`
    query GetLimitedPartnerPortfolioOverviewGraphData($lenderOrganizationId: UUID!) {
  portfolioOverviewGraphData: getLimitedPartnerPortfolioOverviewGraphData(
    lenderOrganizationId: $lenderOrganizationId
  ) {
    ...LimitedPartnerPortfolioOverviewGraphData
  }
}
    ${LimitedPartnerPortfolioOverviewGraphDataFragmentDocGQLType}`;

/**
 * __useGetLimitedPartnerPortfolioOverviewGraphDataQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerPortfolioOverviewGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerPortfolioOverviewGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerPortfolioOverviewGraphDataQuery({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *   },
 * });
 */
export function useGetLimitedPartnerPortfolioOverviewGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerPortfolioOverviewGraphDataQueryGQLType, GetLimitedPartnerPortfolioOverviewGraphDataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerPortfolioOverviewGraphDataQueryGQLType, GetLimitedPartnerPortfolioOverviewGraphDataQueryVariablesGQLType>(GetLimitedPartnerPortfolioOverviewGraphDataDocumentGQLType, options);
      }
export function useGetLimitedPartnerPortfolioOverviewGraphDataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerPortfolioOverviewGraphDataQueryGQLType, GetLimitedPartnerPortfolioOverviewGraphDataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerPortfolioOverviewGraphDataQueryGQLType, GetLimitedPartnerPortfolioOverviewGraphDataQueryVariablesGQLType>(GetLimitedPartnerPortfolioOverviewGraphDataDocumentGQLType, options);
        }
export type GetLimitedPartnerPortfolioOverviewGraphDataQueryHookResult = ReturnType<typeof useGetLimitedPartnerPortfolioOverviewGraphDataQuery>;
export type GetLimitedPartnerPortfolioOverviewGraphDataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerPortfolioOverviewGraphDataLazyQueryGQLType>;
export type GetLimitedPartnerPortfolioOverviewGraphDataQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerPortfolioOverviewGraphDataQueryGQLType, GetLimitedPartnerPortfolioOverviewGraphDataQueryVariablesGQLType>;
export const GetLimitedPartnerPortfolioSummaryDocumentGQLType = gql`
    query GetLimitedPartnerPortfolioSummary($lenderOrganizationId: UUID!, $filters: LimitedPartnerFilters!) {
  portfolioSummary: getLimitedPartnerPortfolioSummary(
    lenderOrganizationId: $lenderOrganizationId
    filters: $filters
  ) {
    totalCommittedCapital
    totalUncalledCapital
    limitedPartnerCount
    commitmentCount
  }
}
    `;

/**
 * __useGetLimitedPartnerPortfolioSummaryQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerPortfolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerPortfolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerPortfolioSummaryQuery({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLimitedPartnerPortfolioSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerPortfolioSummaryQueryGQLType, GetLimitedPartnerPortfolioSummaryQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerPortfolioSummaryQueryGQLType, GetLimitedPartnerPortfolioSummaryQueryVariablesGQLType>(GetLimitedPartnerPortfolioSummaryDocumentGQLType, options);
      }
export function useGetLimitedPartnerPortfolioSummaryLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerPortfolioSummaryQueryGQLType, GetLimitedPartnerPortfolioSummaryQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerPortfolioSummaryQueryGQLType, GetLimitedPartnerPortfolioSummaryQueryVariablesGQLType>(GetLimitedPartnerPortfolioSummaryDocumentGQLType, options);
        }
export type GetLimitedPartnerPortfolioSummaryQueryHookResult = ReturnType<typeof useGetLimitedPartnerPortfolioSummaryQuery>;
export type GetLimitedPartnerPortfolioSummaryLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerPortfolioSummaryLazyQueryGQLType>;
export type GetLimitedPartnerPortfolioSummaryQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerPortfolioSummaryQueryGQLType, GetLimitedPartnerPortfolioSummaryQueryVariablesGQLType>;
export const CreateLimitedPartnerDocumentGQLType = gql`
    mutation CreateLimitedPartner($lenderOrganizationId: UUID!, $name: String!, $attributeValues: [CreateOrUpdateLimitedPartnerLatestAttributeValueInput!]!) {
  createLimitedPartner(
    lenderOrganizationId: $lenderOrganizationId
    name: $name
    attributeValues: $attributeValues
  ) {
    id
    name
    alternateAliases
  }
}
    `;
export type CreateLimitedPartnerMutationFnGQLType = Apollo.MutationFunction<CreateLimitedPartnerMutationGQLType, CreateLimitedPartnerMutationVariablesGQLType>;

/**
 * __useCreateLimitedPartnerMutation__
 *
 * To run a mutation, you first call `useCreateLimitedPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLimitedPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLimitedPartnerMutation, { data, loading, error }] = useCreateLimitedPartnerMutation({
 *   variables: {
 *      lenderOrganizationId: // value for 'lenderOrganizationId'
 *      name: // value for 'name'
 *      attributeValues: // value for 'attributeValues'
 *   },
 * });
 */
export function useCreateLimitedPartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateLimitedPartnerMutationGQLType, CreateLimitedPartnerMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLimitedPartnerMutationGQLType, CreateLimitedPartnerMutationVariablesGQLType>(CreateLimitedPartnerDocumentGQLType, options);
      }
export type CreateLimitedPartnerMutationHookResult = ReturnType<typeof useCreateLimitedPartnerMutation>;
export type CreateLimitedPartnerMutationResultGQLType = Apollo.MutationResult<CreateLimitedPartnerMutationGQLType>;
export type CreateLimitedPartnerMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateLimitedPartnerMutationGQLType, CreateLimitedPartnerMutationVariablesGQLType>;
export const UpdateLimitedPartnerDocumentGQLType = gql`
    mutation UpdateLimitedPartner($limitedPartnerId: UUID!, $name: String, $alternateAliases: [String!]) {
  updateLimitedPartner(
    limitedPartnerId: $limitedPartnerId
    updates: {name: $name, alternateAliases: $alternateAliases}
  ) {
    id
    name
    alternateAliases
  }
}
    `;
export type UpdateLimitedPartnerMutationFnGQLType = Apollo.MutationFunction<UpdateLimitedPartnerMutationGQLType, UpdateLimitedPartnerMutationVariablesGQLType>;

/**
 * __useUpdateLimitedPartnerMutation__
 *
 * To run a mutation, you first call `useUpdateLimitedPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLimitedPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLimitedPartnerMutation, { data, loading, error }] = useUpdateLimitedPartnerMutation({
 *   variables: {
 *      limitedPartnerId: // value for 'limitedPartnerId'
 *      name: // value for 'name'
 *      alternateAliases: // value for 'alternateAliases'
 *   },
 * });
 */
export function useUpdateLimitedPartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLimitedPartnerMutationGQLType, UpdateLimitedPartnerMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLimitedPartnerMutationGQLType, UpdateLimitedPartnerMutationVariablesGQLType>(UpdateLimitedPartnerDocumentGQLType, options);
      }
export type UpdateLimitedPartnerMutationHookResult = ReturnType<typeof useUpdateLimitedPartnerMutation>;
export type UpdateLimitedPartnerMutationResultGQLType = Apollo.MutationResult<UpdateLimitedPartnerMutationGQLType>;
export type UpdateLimitedPartnerMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateLimitedPartnerMutationGQLType, UpdateLimitedPartnerMutationVariablesGQLType>;
export const UpdateLimitedPartnerMappingDocumentGQLType = gql`
    mutation UpdateLimitedPartnerMapping($limitedPartnerMappingId: UUID!, $limitedPartnerId: UUID) {
  updateLimitedPartnerMapping(
    limitedPartnerMappingId: $limitedPartnerMappingId
    limitedPartnerId: $limitedPartnerId
  ) {
    limitedPartnerMappingId
    limitedPartnerName
    limitedPartnerAlias
    limitedPartnerId
  }
}
    `;
export type UpdateLimitedPartnerMappingMutationFnGQLType = Apollo.MutationFunction<UpdateLimitedPartnerMappingMutationGQLType, UpdateLimitedPartnerMappingMutationVariablesGQLType>;

/**
 * __useUpdateLimitedPartnerMappingMutation__
 *
 * To run a mutation, you first call `useUpdateLimitedPartnerMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLimitedPartnerMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLimitedPartnerMappingMutation, { data, loading, error }] = useUpdateLimitedPartnerMappingMutation({
 *   variables: {
 *      limitedPartnerMappingId: // value for 'limitedPartnerMappingId'
 *      limitedPartnerId: // value for 'limitedPartnerId'
 *   },
 * });
 */
export function useUpdateLimitedPartnerMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLimitedPartnerMappingMutationGQLType, UpdateLimitedPartnerMappingMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLimitedPartnerMappingMutationGQLType, UpdateLimitedPartnerMappingMutationVariablesGQLType>(UpdateLimitedPartnerMappingDocumentGQLType, options);
      }
export type UpdateLimitedPartnerMappingMutationHookResult = ReturnType<typeof useUpdateLimitedPartnerMappingMutation>;
export type UpdateLimitedPartnerMappingMutationResultGQLType = Apollo.MutationResult<UpdateLimitedPartnerMappingMutationGQLType>;
export type UpdateLimitedPartnerMappingMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateLimitedPartnerMappingMutationGQLType, UpdateLimitedPartnerMappingMutationVariablesGQLType>;
export const GetLimitedPartnerAttributeListDocumentGQLType = gql`
    query GetLimitedPartnerAttributeList($organizationId: UUID!, $entityIdentifier: UUID) {
  attributes: getAttributeListByEntity(
    organizationId: $organizationId
    listName: "limitedPartnerCustomAttributes"
    entityDomain: limitedPartner
    entityIdentifier: $entityIdentifier
  ) {
    ...AttributeFragment
  }
}
    ${AttributeFragmentFragmentDocGQLType}`;

/**
 * __useGetLimitedPartnerAttributeListQuery__
 *
 * To run a query within a React component, call `useGetLimitedPartnerAttributeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLimitedPartnerAttributeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLimitedPartnerAttributeListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      entityIdentifier: // value for 'entityIdentifier'
 *   },
 * });
 */
export function useGetLimitedPartnerAttributeListQuery(baseOptions: Apollo.QueryHookOptions<GetLimitedPartnerAttributeListQueryGQLType, GetLimitedPartnerAttributeListQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLimitedPartnerAttributeListQueryGQLType, GetLimitedPartnerAttributeListQueryVariablesGQLType>(GetLimitedPartnerAttributeListDocumentGQLType, options);
      }
export function useGetLimitedPartnerAttributeListLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLimitedPartnerAttributeListQueryGQLType, GetLimitedPartnerAttributeListQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLimitedPartnerAttributeListQueryGQLType, GetLimitedPartnerAttributeListQueryVariablesGQLType>(GetLimitedPartnerAttributeListDocumentGQLType, options);
        }
export type GetLimitedPartnerAttributeListQueryHookResult = ReturnType<typeof useGetLimitedPartnerAttributeListQuery>;
export type GetLimitedPartnerAttributeListLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLimitedPartnerAttributeListLazyQueryGQLType>;
export type GetLimitedPartnerAttributeListQueryResultGQLType = Apollo.QueryResult<GetLimitedPartnerAttributeListQueryGQLType, GetLimitedPartnerAttributeListQueryVariablesGQLType>;
export const CreateOrUpdateLimitedPartnerAttributeValueDocumentGQLType = gql`
    mutation CreateOrUpdateLimitedPartnerAttributeValue($input: CreateOrUpdateLatestAttributeValueInput!) {
  createOrUpdateLatestAttributeValue(input: $input) {
    response
  }
}
    `;
export type CreateOrUpdateLimitedPartnerAttributeValueMutationFnGQLType = Apollo.MutationFunction<CreateOrUpdateLimitedPartnerAttributeValueMutationGQLType, CreateOrUpdateLimitedPartnerAttributeValueMutationVariablesGQLType>;

/**
 * __useCreateOrUpdateLimitedPartnerAttributeValueMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateLimitedPartnerAttributeValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateLimitedPartnerAttributeValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateLimitedPartnerAttributeValueMutation, { data, loading, error }] = useCreateOrUpdateLimitedPartnerAttributeValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateLimitedPartnerAttributeValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateLimitedPartnerAttributeValueMutationGQLType, CreateOrUpdateLimitedPartnerAttributeValueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateLimitedPartnerAttributeValueMutationGQLType, CreateOrUpdateLimitedPartnerAttributeValueMutationVariablesGQLType>(CreateOrUpdateLimitedPartnerAttributeValueDocumentGQLType, options);
      }
export type CreateOrUpdateLimitedPartnerAttributeValueMutationHookResult = ReturnType<typeof useCreateOrUpdateLimitedPartnerAttributeValueMutation>;
export type CreateOrUpdateLimitedPartnerAttributeValueMutationResultGQLType = Apollo.MutationResult<CreateOrUpdateLimitedPartnerAttributeValueMutationGQLType>;
export type CreateOrUpdateLimitedPartnerAttributeValueMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrUpdateLimitedPartnerAttributeValueMutationGQLType, CreateOrUpdateLimitedPartnerAttributeValueMutationVariablesGQLType>;
export const GetAssignedReceivableDocumentGQLType = gql`
    query GetAssignedReceivable($finleyReceivableId: UUID!) {
  assignedReceivable(finleyReceivableId: $finleyReceivableId) {
    id
    externalReceivableId
    status
    creditFacility {
      id
      name
      slug
      borrowerOrganizationName
    }
    loanProductId
  }
}
    `;

/**
 * __useGetAssignedReceivableQuery__
 *
 * To run a query within a React component, call `useGetAssignedReceivableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedReceivableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedReceivableQuery({
 *   variables: {
 *      finleyReceivableId: // value for 'finleyReceivableId'
 *   },
 * });
 */
export function useGetAssignedReceivableQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedReceivableQueryGQLType, GetAssignedReceivableQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedReceivableQueryGQLType, GetAssignedReceivableQueryVariablesGQLType>(GetAssignedReceivableDocumentGQLType, options);
      }
export function useGetAssignedReceivableLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedReceivableQueryGQLType, GetAssignedReceivableQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedReceivableQueryGQLType, GetAssignedReceivableQueryVariablesGQLType>(GetAssignedReceivableDocumentGQLType, options);
        }
export type GetAssignedReceivableQueryHookResult = ReturnType<typeof useGetAssignedReceivableQuery>;
export type GetAssignedReceivableLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignedReceivableLazyQueryGQLType>;
export type GetAssignedReceivableQueryResultGQLType = Apollo.QueryResult<GetAssignedReceivableQueryGQLType, GetAssignedReceivableQueryVariablesGQLType>;
export const GetAssignedReceivablesForLoanProductDocumentGQLType = gql`
    query GetAssignedReceivablesForLoanProduct($externalReceivableIds: [String!]!, $loanProductSlug: String!) {
  assignedReceivablesForLoanProduct(
    externalReceivableIds: $externalReceivableIds
    loanProductSlug: $loanProductSlug
  ) {
    id
    externalReceivableId
    status
    creditFacility {
      id
      name
      slug
    }
    loanProductId
  }
}
    `;

/**
 * __useGetAssignedReceivablesForLoanProductQuery__
 *
 * To run a query within a React component, call `useGetAssignedReceivablesForLoanProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedReceivablesForLoanProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedReceivablesForLoanProductQuery({
 *   variables: {
 *      externalReceivableIds: // value for 'externalReceivableIds'
 *      loanProductSlug: // value for 'loanProductSlug'
 *   },
 * });
 */
export function useGetAssignedReceivablesForLoanProductQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedReceivablesForLoanProductQueryGQLType, GetAssignedReceivablesForLoanProductQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedReceivablesForLoanProductQueryGQLType, GetAssignedReceivablesForLoanProductQueryVariablesGQLType>(GetAssignedReceivablesForLoanProductDocumentGQLType, options);
      }
export function useGetAssignedReceivablesForLoanProductLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedReceivablesForLoanProductQueryGQLType, GetAssignedReceivablesForLoanProductQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedReceivablesForLoanProductQueryGQLType, GetAssignedReceivablesForLoanProductQueryVariablesGQLType>(GetAssignedReceivablesForLoanProductDocumentGQLType, options);
        }
export type GetAssignedReceivablesForLoanProductQueryHookResult = ReturnType<typeof useGetAssignedReceivablesForLoanProductQuery>;
export type GetAssignedReceivablesForLoanProductLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignedReceivablesForLoanProductLazyQueryGQLType>;
export type GetAssignedReceivablesForLoanProductQueryResultGQLType = Apollo.QueryResult<GetAssignedReceivablesForLoanProductQueryGQLType, GetAssignedReceivablesForLoanProductQueryVariablesGQLType>;
export const GetAssignmentReceivablesDocumentGQLType = gql`
    query GetAssignmentReceivables($previewIdentifier: String!, $reportingDate: FullDateStr!, $fileVersion: Float!) {
  assignmentReceivablesWithMetadata(
    previewIdentifier: $previewIdentifier
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    assignmentReceivables
    borrowingBaseReports {
      ...AssignmentBorrowingBaseReport
    }
  }
}
    ${AssignmentBorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetAssignmentReceivablesQuery__
 *
 * To run a query within a React component, call `useGetAssignmentReceivablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentReceivablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentReceivablesQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetAssignmentReceivablesQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentReceivablesQueryGQLType, GetAssignmentReceivablesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentReceivablesQueryGQLType, GetAssignmentReceivablesQueryVariablesGQLType>(GetAssignmentReceivablesDocumentGQLType, options);
      }
export function useGetAssignmentReceivablesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentReceivablesQueryGQLType, GetAssignmentReceivablesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentReceivablesQueryGQLType, GetAssignmentReceivablesQueryVariablesGQLType>(GetAssignmentReceivablesDocumentGQLType, options);
        }
export type GetAssignmentReceivablesQueryHookResult = ReturnType<typeof useGetAssignmentReceivablesQuery>;
export type GetAssignmentReceivablesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentReceivablesLazyQueryGQLType>;
export type GetAssignmentReceivablesQueryResultGQLType = Apollo.QueryResult<GetAssignmentReceivablesQueryGQLType, GetAssignmentReceivablesQueryVariablesGQLType>;
export const GetInitialConditionAssignmentReceivablesDocumentGQLType = gql`
    query GetInitialConditionAssignmentReceivables($masterLoanTapeIds: [String!]!) {
  initialConditionAssignmentReceivablesWithMetadata(
    masterLoanTapeIds: $masterLoanTapeIds
  ) {
    assignmentReceivables
    borrowingBaseReports {
      ...AssignmentBorrowingBaseReport
    }
  }
}
    ${AssignmentBorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetInitialConditionAssignmentReceivablesQuery__
 *
 * To run a query within a React component, call `useGetInitialConditionAssignmentReceivablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialConditionAssignmentReceivablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialConditionAssignmentReceivablesQuery({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *   },
 * });
 */
export function useGetInitialConditionAssignmentReceivablesQuery(baseOptions: Apollo.QueryHookOptions<GetInitialConditionAssignmentReceivablesQueryGQLType, GetInitialConditionAssignmentReceivablesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialConditionAssignmentReceivablesQueryGQLType, GetInitialConditionAssignmentReceivablesQueryVariablesGQLType>(GetInitialConditionAssignmentReceivablesDocumentGQLType, options);
      }
export function useGetInitialConditionAssignmentReceivablesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialConditionAssignmentReceivablesQueryGQLType, GetInitialConditionAssignmentReceivablesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialConditionAssignmentReceivablesQueryGQLType, GetInitialConditionAssignmentReceivablesQueryVariablesGQLType>(GetInitialConditionAssignmentReceivablesDocumentGQLType, options);
        }
export type GetInitialConditionAssignmentReceivablesQueryHookResult = ReturnType<typeof useGetInitialConditionAssignmentReceivablesQuery>;
export type GetInitialConditionAssignmentReceivablesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInitialConditionAssignmentReceivablesLazyQueryGQLType>;
export type GetInitialConditionAssignmentReceivablesQueryResultGQLType = Apollo.QueryResult<GetInitialConditionAssignmentReceivablesQueryGQLType, GetInitialConditionAssignmentReceivablesQueryVariablesGQLType>;
export const GetLatestAssignmentReceivablesDocumentGQLType = gql`
    query GetLatestAssignmentReceivables($masterLoanTapeIds: [String!]!) {
  latestAssignmentReceivablesWithMetadata(masterLoanTapeIds: $masterLoanTapeIds) {
    assignmentReceivables
    borrowingBaseReports {
      ...AssignmentBorrowingBaseReport
    }
  }
}
    ${AssignmentBorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetLatestAssignmentReceivablesQuery__
 *
 * To run a query within a React component, call `useGetLatestAssignmentReceivablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestAssignmentReceivablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestAssignmentReceivablesQuery({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *   },
 * });
 */
export function useGetLatestAssignmentReceivablesQuery(baseOptions: Apollo.QueryHookOptions<GetLatestAssignmentReceivablesQueryGQLType, GetLatestAssignmentReceivablesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestAssignmentReceivablesQueryGQLType, GetLatestAssignmentReceivablesQueryVariablesGQLType>(GetLatestAssignmentReceivablesDocumentGQLType, options);
      }
export function useGetLatestAssignmentReceivablesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestAssignmentReceivablesQueryGQLType, GetLatestAssignmentReceivablesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestAssignmentReceivablesQueryGQLType, GetLatestAssignmentReceivablesQueryVariablesGQLType>(GetLatestAssignmentReceivablesDocumentGQLType, options);
        }
export type GetLatestAssignmentReceivablesQueryHookResult = ReturnType<typeof useGetLatestAssignmentReceivablesQuery>;
export type GetLatestAssignmentReceivablesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestAssignmentReceivablesLazyQueryGQLType>;
export type GetLatestAssignmentReceivablesQueryResultGQLType = Apollo.QueryResult<GetLatestAssignmentReceivablesQueryGQLType, GetLatestAssignmentReceivablesQueryVariablesGQLType>;
export const GetLatestInitialAssignmentSummaryDocumentGQLType = gql`
    query GetLatestInitialAssignmentSummary($creditFacilityId: UUID!, $implementationId: UUID!) {
  latestAssignmentSummary(
    creditFacilityId: $creditFacilityId
    implementationId: $implementationId
  )
}
    `;

/**
 * __useGetLatestInitialAssignmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetLatestInitialAssignmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestInitialAssignmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestInitialAssignmentSummaryQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetLatestInitialAssignmentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetLatestInitialAssignmentSummaryQueryGQLType, GetLatestInitialAssignmentSummaryQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestInitialAssignmentSummaryQueryGQLType, GetLatestInitialAssignmentSummaryQueryVariablesGQLType>(GetLatestInitialAssignmentSummaryDocumentGQLType, options);
      }
export function useGetLatestInitialAssignmentSummaryLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestInitialAssignmentSummaryQueryGQLType, GetLatestInitialAssignmentSummaryQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestInitialAssignmentSummaryQueryGQLType, GetLatestInitialAssignmentSummaryQueryVariablesGQLType>(GetLatestInitialAssignmentSummaryDocumentGQLType, options);
        }
export type GetLatestInitialAssignmentSummaryQueryHookResult = ReturnType<typeof useGetLatestInitialAssignmentSummaryQuery>;
export type GetLatestInitialAssignmentSummaryLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestInitialAssignmentSummaryLazyQueryGQLType>;
export type GetLatestInitialAssignmentSummaryQueryResultGQLType = Apollo.QueryResult<GetLatestInitialAssignmentSummaryQueryGQLType, GetLatestInitialAssignmentSummaryQueryVariablesGQLType>;
export const GetAssignmentSummaryDocumentGQLType = gql`
    query GetAssignmentSummary($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!, $previewIdentifier: String) {
  initial: assignmentSummary(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    isInitialPreview: true
    previewIdentifier: null
  )
  proposed: assignmentSummary(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    isInitialPreview: false
    previewIdentifier: $previewIdentifier
  )
}
    `;

/**
 * __useGetAssignmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetAssignmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentSummaryQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useGetAssignmentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentSummaryQueryGQLType, GetAssignmentSummaryQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentSummaryQueryGQLType, GetAssignmentSummaryQueryVariablesGQLType>(GetAssignmentSummaryDocumentGQLType, options);
      }
export function useGetAssignmentSummaryLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentSummaryQueryGQLType, GetAssignmentSummaryQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentSummaryQueryGQLType, GetAssignmentSummaryQueryVariablesGQLType>(GetAssignmentSummaryDocumentGQLType, options);
        }
export type GetAssignmentSummaryQueryHookResult = ReturnType<typeof useGetAssignmentSummaryQuery>;
export type GetAssignmentSummaryLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentSummaryLazyQueryGQLType>;
export type GetAssignmentSummaryQueryResultGQLType = Apollo.QueryResult<GetAssignmentSummaryQueryGQLType, GetAssignmentSummaryQueryVariablesGQLType>;
export const GetAggregatedAssignmentSummaryPreviewDocumentGQLType = gql`
    query GetAggregatedAssignmentSummaryPreview($initialPreviewJobId: UUID!, $proposedPreviewJobId: UUID!) {
  initial: aggregatedAssignmentSummaryPreview(
    receivableResponseTapePreviewJobId: $initialPreviewJobId
  )
  proposed: aggregatedAssignmentSummaryPreview(
    receivableResponseTapePreviewJobId: $proposedPreviewJobId
  )
}
    `;

/**
 * __useGetAggregatedAssignmentSummaryPreviewQuery__
 *
 * To run a query within a React component, call `useGetAggregatedAssignmentSummaryPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedAssignmentSummaryPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedAssignmentSummaryPreviewQuery({
 *   variables: {
 *      initialPreviewJobId: // value for 'initialPreviewJobId'
 *      proposedPreviewJobId: // value for 'proposedPreviewJobId'
 *   },
 * });
 */
export function useGetAggregatedAssignmentSummaryPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetAggregatedAssignmentSummaryPreviewQueryGQLType, GetAggregatedAssignmentSummaryPreviewQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedAssignmentSummaryPreviewQueryGQLType, GetAggregatedAssignmentSummaryPreviewQueryVariablesGQLType>(GetAggregatedAssignmentSummaryPreviewDocumentGQLType, options);
      }
export function useGetAggregatedAssignmentSummaryPreviewLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedAssignmentSummaryPreviewQueryGQLType, GetAggregatedAssignmentSummaryPreviewQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedAssignmentSummaryPreviewQueryGQLType, GetAggregatedAssignmentSummaryPreviewQueryVariablesGQLType>(GetAggregatedAssignmentSummaryPreviewDocumentGQLType, options);
        }
export type GetAggregatedAssignmentSummaryPreviewQueryHookResult = ReturnType<typeof useGetAggregatedAssignmentSummaryPreviewQuery>;
export type GetAggregatedAssignmentSummaryPreviewLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAggregatedAssignmentSummaryPreviewLazyQueryGQLType>;
export type GetAggregatedAssignmentSummaryPreviewQueryResultGQLType = Apollo.QueryResult<GetAggregatedAssignmentSummaryPreviewQueryGQLType, GetAggregatedAssignmentSummaryPreviewQueryVariablesGQLType>;
export const GetLatestAssignmentSummariesDocumentGQLType = gql`
    query GetLatestAssignmentSummaries($masterLoanTapeIds: [String!]!, $creditFacilityIds: [UUID!]!, $includeInitialCondition: Boolean!) {
  latestAssignmentSummaries(
    masterLoanTapeIds: $masterLoanTapeIds
    creditFacilityIds: $creditFacilityIds
    includeInitialCondition: $includeInitialCondition
  )
}
    `;

/**
 * __useGetLatestAssignmentSummariesQuery__
 *
 * To run a query within a React component, call `useGetLatestAssignmentSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestAssignmentSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestAssignmentSummariesQuery({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      includeInitialCondition: // value for 'includeInitialCondition'
 *   },
 * });
 */
export function useGetLatestAssignmentSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetLatestAssignmentSummariesQueryGQLType, GetLatestAssignmentSummariesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestAssignmentSummariesQueryGQLType, GetLatestAssignmentSummariesQueryVariablesGQLType>(GetLatestAssignmentSummariesDocumentGQLType, options);
      }
export function useGetLatestAssignmentSummariesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestAssignmentSummariesQueryGQLType, GetLatestAssignmentSummariesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestAssignmentSummariesQueryGQLType, GetLatestAssignmentSummariesQueryVariablesGQLType>(GetLatestAssignmentSummariesDocumentGQLType, options);
        }
export type GetLatestAssignmentSummariesQueryHookResult = ReturnType<typeof useGetLatestAssignmentSummariesQuery>;
export type GetLatestAssignmentSummariesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestAssignmentSummariesLazyQueryGQLType>;
export type GetLatestAssignmentSummariesQueryResultGQLType = Apollo.QueryResult<GetLatestAssignmentSummariesQueryGQLType, GetLatestAssignmentSummariesQueryVariablesGQLType>;
export const GetLatestAssignmentPipelineRunStatusForImplementationDocumentGQLType = gql`
    query GetLatestAssignmentPipelineRunStatusForImplementation($implementationId: String!) {
  latestAssignmentPipelineRunStatusForImplementation(
    implementationId: $implementationId
  ) {
    status
    fileVersion
    reportingDate
    implementationId
    masterLoanTapeIds
  }
}
    `;

/**
 * __useGetLatestAssignmentPipelineRunStatusForImplementationQuery__
 *
 * To run a query within a React component, call `useGetLatestAssignmentPipelineRunStatusForImplementationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestAssignmentPipelineRunStatusForImplementationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestAssignmentPipelineRunStatusForImplementationQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetLatestAssignmentPipelineRunStatusForImplementationQuery(baseOptions: Apollo.QueryHookOptions<GetLatestAssignmentPipelineRunStatusForImplementationQueryGQLType, GetLatestAssignmentPipelineRunStatusForImplementationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestAssignmentPipelineRunStatusForImplementationQueryGQLType, GetLatestAssignmentPipelineRunStatusForImplementationQueryVariablesGQLType>(GetLatestAssignmentPipelineRunStatusForImplementationDocumentGQLType, options);
      }
export function useGetLatestAssignmentPipelineRunStatusForImplementationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestAssignmentPipelineRunStatusForImplementationQueryGQLType, GetLatestAssignmentPipelineRunStatusForImplementationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestAssignmentPipelineRunStatusForImplementationQueryGQLType, GetLatestAssignmentPipelineRunStatusForImplementationQueryVariablesGQLType>(GetLatestAssignmentPipelineRunStatusForImplementationDocumentGQLType, options);
        }
export type GetLatestAssignmentPipelineRunStatusForImplementationQueryHookResult = ReturnType<typeof useGetLatestAssignmentPipelineRunStatusForImplementationQuery>;
export type GetLatestAssignmentPipelineRunStatusForImplementationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestAssignmentPipelineRunStatusForImplementationLazyQueryGQLType>;
export type GetLatestAssignmentPipelineRunStatusForImplementationQueryResultGQLType = Apollo.QueryResult<GetLatestAssignmentPipelineRunStatusForImplementationQueryGQLType, GetLatestAssignmentPipelineRunStatusForImplementationQueryVariablesGQLType>;
export const GetAreMasterLoanTapesAssignedDocumentGQLType = gql`
    query GetAreMasterLoanTapesAssigned($masterLoanTapeIds: [String!]!) {
  areMasterLoanTapesAssigned(masterLoanTapeIds: $masterLoanTapeIds)
}
    `;

/**
 * __useGetAreMasterLoanTapesAssignedQuery__
 *
 * To run a query within a React component, call `useGetAreMasterLoanTapesAssignedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreMasterLoanTapesAssignedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreMasterLoanTapesAssignedQuery({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *   },
 * });
 */
export function useGetAreMasterLoanTapesAssignedQuery(baseOptions: Apollo.QueryHookOptions<GetAreMasterLoanTapesAssignedQueryGQLType, GetAreMasterLoanTapesAssignedQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreMasterLoanTapesAssignedQueryGQLType, GetAreMasterLoanTapesAssignedQueryVariablesGQLType>(GetAreMasterLoanTapesAssignedDocumentGQLType, options);
      }
export function useGetAreMasterLoanTapesAssignedLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAreMasterLoanTapesAssignedQueryGQLType, GetAreMasterLoanTapesAssignedQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreMasterLoanTapesAssignedQueryGQLType, GetAreMasterLoanTapesAssignedQueryVariablesGQLType>(GetAreMasterLoanTapesAssignedDocumentGQLType, options);
        }
export type GetAreMasterLoanTapesAssignedQueryHookResult = ReturnType<typeof useGetAreMasterLoanTapesAssignedQuery>;
export type GetAreMasterLoanTapesAssignedLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAreMasterLoanTapesAssignedLazyQueryGQLType>;
export type GetAreMasterLoanTapesAssignedQueryResultGQLType = Apollo.QueryResult<GetAreMasterLoanTapesAssignedQueryGQLType, GetAreMasterLoanTapesAssignedQueryVariablesGQLType>;
export const GetLatestCompletedReceivableResponseTapePreviewIdsDocumentGQLType = gql`
    query GetLatestCompletedReceivableResponseTapePreviewIds($creditFacilityIds: [String!]!, $reportingDate: FullDateStr!, $fileVersion: Float!) {
  latestCompletedReceivableResponseTapePreviewIds(
    creditFacilityIds: $creditFacilityIds
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  )
}
    `;

/**
 * __useGetLatestCompletedReceivableResponseTapePreviewIdsQuery__
 *
 * To run a query within a React component, call `useGetLatestCompletedReceivableResponseTapePreviewIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestCompletedReceivableResponseTapePreviewIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestCompletedReceivableResponseTapePreviewIdsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetLatestCompletedReceivableResponseTapePreviewIdsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestCompletedReceivableResponseTapePreviewIdsQueryGQLType, GetLatestCompletedReceivableResponseTapePreviewIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestCompletedReceivableResponseTapePreviewIdsQueryGQLType, GetLatestCompletedReceivableResponseTapePreviewIdsQueryVariablesGQLType>(GetLatestCompletedReceivableResponseTapePreviewIdsDocumentGQLType, options);
      }
export function useGetLatestCompletedReceivableResponseTapePreviewIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestCompletedReceivableResponseTapePreviewIdsQueryGQLType, GetLatestCompletedReceivableResponseTapePreviewIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestCompletedReceivableResponseTapePreviewIdsQueryGQLType, GetLatestCompletedReceivableResponseTapePreviewIdsQueryVariablesGQLType>(GetLatestCompletedReceivableResponseTapePreviewIdsDocumentGQLType, options);
        }
export type GetLatestCompletedReceivableResponseTapePreviewIdsQueryHookResult = ReturnType<typeof useGetLatestCompletedReceivableResponseTapePreviewIdsQuery>;
export type GetLatestCompletedReceivableResponseTapePreviewIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestCompletedReceivableResponseTapePreviewIdsLazyQueryGQLType>;
export type GetLatestCompletedReceivableResponseTapePreviewIdsQueryResultGQLType = Apollo.QueryResult<GetLatestCompletedReceivableResponseTapePreviewIdsQueryGQLType, GetLatestCompletedReceivableResponseTapePreviewIdsQueryVariablesGQLType>;
export const GetCompletedReceivableResponseTapePreviewIdDocumentGQLType = gql`
    query GetCompletedReceivableResponseTapePreviewId($creditFacilityId: String!, $reportingDate: FullDateStr!, $fileVersion: Float!, $previewIdentifier: String!) {
  completedReceivableResponseTapePreviewId(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    previewIdentifier: $previewIdentifier
  )
}
    `;

/**
 * __useGetCompletedReceivableResponseTapePreviewIdQuery__
 *
 * To run a query within a React component, call `useGetCompletedReceivableResponseTapePreviewIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedReceivableResponseTapePreviewIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedReceivableResponseTapePreviewIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useGetCompletedReceivableResponseTapePreviewIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedReceivableResponseTapePreviewIdQueryGQLType, GetCompletedReceivableResponseTapePreviewIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedReceivableResponseTapePreviewIdQueryGQLType, GetCompletedReceivableResponseTapePreviewIdQueryVariablesGQLType>(GetCompletedReceivableResponseTapePreviewIdDocumentGQLType, options);
      }
export function useGetCompletedReceivableResponseTapePreviewIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedReceivableResponseTapePreviewIdQueryGQLType, GetCompletedReceivableResponseTapePreviewIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedReceivableResponseTapePreviewIdQueryGQLType, GetCompletedReceivableResponseTapePreviewIdQueryVariablesGQLType>(GetCompletedReceivableResponseTapePreviewIdDocumentGQLType, options);
        }
export type GetCompletedReceivableResponseTapePreviewIdQueryHookResult = ReturnType<typeof useGetCompletedReceivableResponseTapePreviewIdQuery>;
export type GetCompletedReceivableResponseTapePreviewIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCompletedReceivableResponseTapePreviewIdLazyQueryGQLType>;
export type GetCompletedReceivableResponseTapePreviewIdQueryResultGQLType = Apollo.QueryResult<GetCompletedReceivableResponseTapePreviewIdQueryGQLType, GetCompletedReceivableResponseTapePreviewIdQueryVariablesGQLType>;
export const GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType = gql`
    query GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadata($masterLoanTapeIds: [String!]!) {
  initialConditionAssignmentReceivablesAggregateTotalsWithMetadata(
    masterLoanTapeIds: $masterLoanTapeIds
  ) {
    assignmentReceivablesAggregateTotalsByStatus {
      ...AssignmentReceivablesAggregateTotalsByStatus
    }
    reportingDate
    fileVersion
    previewIdentifier
    borrowingBaseReports {
      ...AssignmentBorrowingBaseReport
    }
  }
}
    ${AssignmentReceivablesAggregateTotalsByStatusFragmentDocGQLType}
${AssignmentBorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQuery__
 *
 * To run a query within a React component, call `useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQuery({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *   },
 * });
 */
export function useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>(GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType, options);
      }
export function useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>(GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType, options);
        }
export type GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryHookResult = ReturnType<typeof useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQuery>;
export type GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLType>;
export type GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryResultGQLType = Apollo.QueryResult<GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetInitialConditionAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>;
export const GetLatestAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType = gql`
    query GetLatestAssignmentReceivablesAggregateTotalsWithMetadata($masterLoanTapeIds: [String!]!) {
  latestAssignmentReceivablesAggregateTotalsWithMetadata(
    masterLoanTapeIds: $masterLoanTapeIds
  ) {
    assignmentReceivablesAggregateTotalsByStatus {
      ...AssignmentReceivablesAggregateTotalsByStatus
    }
    reportingDate
    fileVersion
    previewIdentifier
    borrowingBaseReports {
      ...AssignmentBorrowingBaseReport
    }
  }
}
    ${AssignmentReceivablesAggregateTotalsByStatusFragmentDocGQLType}
${AssignmentBorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataQuery__
 *
 * To run a query within a React component, call `useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataQuery({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *   },
 * });
 */
export function useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>(GetLatestAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType, options);
      }
export function useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>(GetLatestAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType, options);
        }
export type GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryHookResult = ReturnType<typeof useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataQuery>;
export type GetLatestAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLType>;
export type GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryResultGQLType = Apollo.QueryResult<GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetLatestAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>;
export const GetAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType = gql`
    query GetAssignmentReceivablesAggregateTotalsWithMetadata($previewIdentifier: String!, $reportingDate: FullDateStr!, $fileVersion: Float!) {
  assignmentReceivablesAggregateTotalsWithMetadata(
    previewIdentifier: $previewIdentifier
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    assignmentReceivablesAggregateTotalsByStatus {
      ...AssignmentReceivablesAggregateTotalsByStatus
    }
    borrowingBaseReports {
      ...AssignmentBorrowingBaseReport
    }
  }
}
    ${AssignmentReceivablesAggregateTotalsByStatusFragmentDocGQLType}
${AssignmentBorrowingBaseReportFragmentDocGQLType}`;

/**
 * __useGetAssignmentReceivablesAggregateTotalsWithMetadataQuery__
 *
 * To run a query within a React component, call `useGetAssignmentReceivablesAggregateTotalsWithMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentReceivablesAggregateTotalsWithMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentReceivablesAggregateTotalsWithMetadataQuery({
 *   variables: {
 *      previewIdentifier: // value for 'previewIdentifier'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetAssignmentReceivablesAggregateTotalsWithMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>(GetAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType, options);
      }
export function useGetAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>(GetAssignmentReceivablesAggregateTotalsWithMetadataDocumentGQLType, options);
        }
export type GetAssignmentReceivablesAggregateTotalsWithMetadataQueryHookResult = ReturnType<typeof useGetAssignmentReceivablesAggregateTotalsWithMetadataQuery>;
export type GetAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentReceivablesAggregateTotalsWithMetadataLazyQueryGQLType>;
export type GetAssignmentReceivablesAggregateTotalsWithMetadataQueryResultGQLType = Apollo.QueryResult<GetAssignmentReceivablesAggregateTotalsWithMetadataQueryGQLType, GetAssignmentReceivablesAggregateTotalsWithMetadataQueryVariablesGQLType>;
export const GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentDocumentGQLType = gql`
    query GetOrganizationLoanProductCreditFacilityGroupingsForAssignment($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    loanProductCreditFacilityGroupsForAssignment {
      implementationId
      creditFacilities {
        id
        name
        slug
        borrowerEntityName
      }
      loanProducts {
        id
        name
        slug
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryVariablesGQLType>(GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentDocumentGQLType, options);
      }
export function useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryVariablesGQLType>(GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentDocumentGQLType, options);
        }
export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryHookResult = ReturnType<typeof useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQuery>;
export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentLazyQueryGQLType>;
export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryResultGQLType = Apollo.QueryResult<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentQueryVariablesGQLType>;
export const GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoDocumentGQLType = gql`
    query GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfo($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    loanProductCreditFacilityGroupsForAssignment {
      implementationId
      creditFacilities {
        id
        name
        slug
        borrowerEntityName
      }
      loanProducts {
        id
        name
        slug
      }
      pipelineInfo {
        status
        latestCompletedPreviewJob {
          id
          assignmentMethod
          status
          strategyId
          strategyName
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryVariablesGQLType>(GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoDocumentGQLType, options);
      }
export function useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryVariablesGQLType>(GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoDocumentGQLType, options);
        }
export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryHookResult = ReturnType<typeof useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQuery>;
export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoLazyQueryGQLType>;
export type GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryResultGQLType = Apollo.QueryResult<GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryGQLType, GetOrganizationLoanProductCreditFacilityGroupingsForAssignmentWithPipelineInfoQueryVariablesGQLType>;
export const GetAssignmentStrategiesForImplementationDocumentGQLType = gql`
    query GetAssignmentStrategiesForImplementation($implementationId: String!) {
  assignmentStrategiesForImplementation(implementationId: $implementationId) {
    id
    name
    created_at
    updated_at
    createdByEmail
    updatedByEmail
    description
    default
  }
}
    `;

/**
 * __useGetAssignmentStrategiesForImplementationQuery__
 *
 * To run a query within a React component, call `useGetAssignmentStrategiesForImplementationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentStrategiesForImplementationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentStrategiesForImplementationQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetAssignmentStrategiesForImplementationQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentStrategiesForImplementationQueryGQLType, GetAssignmentStrategiesForImplementationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentStrategiesForImplementationQueryGQLType, GetAssignmentStrategiesForImplementationQueryVariablesGQLType>(GetAssignmentStrategiesForImplementationDocumentGQLType, options);
      }
export function useGetAssignmentStrategiesForImplementationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentStrategiesForImplementationQueryGQLType, GetAssignmentStrategiesForImplementationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentStrategiesForImplementationQueryGQLType, GetAssignmentStrategiesForImplementationQueryVariablesGQLType>(GetAssignmentStrategiesForImplementationDocumentGQLType, options);
        }
export type GetAssignmentStrategiesForImplementationQueryHookResult = ReturnType<typeof useGetAssignmentStrategiesForImplementationQuery>;
export type GetAssignmentStrategiesForImplementationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentStrategiesForImplementationLazyQueryGQLType>;
export type GetAssignmentStrategiesForImplementationQueryResultGQLType = Apollo.QueryResult<GetAssignmentStrategiesForImplementationQueryGQLType, GetAssignmentStrategiesForImplementationQueryVariablesGQLType>;
export const GetAssignmentStrategiesForOrganizationDocumentGQLType = gql`
    query GetAssignmentStrategiesForOrganization($organizationId: String!) {
  assignmentStrategiesForOrganization(organizationId: $organizationId) {
    implementationId
    assignmentStrategies {
      id
      name
      created_at
      updated_at
      createdByEmail
      updatedByEmail
      description
      default
    }
  }
}
    `;

/**
 * __useGetAssignmentStrategiesForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAssignmentStrategiesForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentStrategiesForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentStrategiesForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAssignmentStrategiesForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentStrategiesForOrganizationQueryGQLType, GetAssignmentStrategiesForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentStrategiesForOrganizationQueryGQLType, GetAssignmentStrategiesForOrganizationQueryVariablesGQLType>(GetAssignmentStrategiesForOrganizationDocumentGQLType, options);
      }
export function useGetAssignmentStrategiesForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentStrategiesForOrganizationQueryGQLType, GetAssignmentStrategiesForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentStrategiesForOrganizationQueryGQLType, GetAssignmentStrategiesForOrganizationQueryVariablesGQLType>(GetAssignmentStrategiesForOrganizationDocumentGQLType, options);
        }
export type GetAssignmentStrategiesForOrganizationQueryHookResult = ReturnType<typeof useGetAssignmentStrategiesForOrganizationQuery>;
export type GetAssignmentStrategiesForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentStrategiesForOrganizationLazyQueryGQLType>;
export type GetAssignmentStrategiesForOrganizationQueryResultGQLType = Apollo.QueryResult<GetAssignmentStrategiesForOrganizationQueryGQLType, GetAssignmentStrategiesForOrganizationQueryVariablesGQLType>;
export const GetAssignmentStrategyDocumentGQLType = gql`
    query GetAssignmentStrategy($strategyId: UUID!, $implementationId: UUID) {
  assignmentStrategy(strategyId: $strategyId, implementationId: $implementationId) {
    id
    name
    created_at
    updated_at
    createdByEmail
    updatedByEmail
    description
    default
    implementationId
    decisionHeuristic
    loanProductCriteria {
      ...LoanProductCriteria
    }
    eligibilityExclusions {
      ...EligibilityExclusion
    }
  }
}
    ${LoanProductCriteriaFragmentDocGQLType}
${EligibilityExclusionFragmentDocGQLType}`;

/**
 * __useGetAssignmentStrategyQuery__
 *
 * To run a query within a React component, call `useGetAssignmentStrategyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentStrategyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentStrategyQuery({
 *   variables: {
 *      strategyId: // value for 'strategyId'
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetAssignmentStrategyQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentStrategyQueryGQLType, GetAssignmentStrategyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentStrategyQueryGQLType, GetAssignmentStrategyQueryVariablesGQLType>(GetAssignmentStrategyDocumentGQLType, options);
      }
export function useGetAssignmentStrategyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentStrategyQueryGQLType, GetAssignmentStrategyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentStrategyQueryGQLType, GetAssignmentStrategyQueryVariablesGQLType>(GetAssignmentStrategyDocumentGQLType, options);
        }
export type GetAssignmentStrategyQueryHookResult = ReturnType<typeof useGetAssignmentStrategyQuery>;
export type GetAssignmentStrategyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentStrategyLazyQueryGQLType>;
export type GetAssignmentStrategyQueryResultGQLType = Apollo.QueryResult<GetAssignmentStrategyQueryGQLType, GetAssignmentStrategyQueryVariablesGQLType>;
export const GetLoanProductsForCreditFacilityDocumentGQLType = gql`
    query GetLoanProductsForCreditFacility($creditFacilityId: UUID!, $useWip: Boolean!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    loanProducts(useWip: $useWip) {
      id
      slug
      name
      implementationId
    }
  }
}
    `;

/**
 * __useGetLoanProductsForCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetLoanProductsForCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanProductsForCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanProductsForCreditFacilityQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      useWip: // value for 'useWip'
 *   },
 * });
 */
export function useGetLoanProductsForCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetLoanProductsForCreditFacilityQueryGQLType, GetLoanProductsForCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanProductsForCreditFacilityQueryGQLType, GetLoanProductsForCreditFacilityQueryVariablesGQLType>(GetLoanProductsForCreditFacilityDocumentGQLType, options);
      }
export function useGetLoanProductsForCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanProductsForCreditFacilityQueryGQLType, GetLoanProductsForCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanProductsForCreditFacilityQueryGQLType, GetLoanProductsForCreditFacilityQueryVariablesGQLType>(GetLoanProductsForCreditFacilityDocumentGQLType, options);
        }
export type GetLoanProductsForCreditFacilityQueryHookResult = ReturnType<typeof useGetLoanProductsForCreditFacilityQuery>;
export type GetLoanProductsForCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanProductsForCreditFacilityLazyQueryGQLType>;
export type GetLoanProductsForCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetLoanProductsForCreditFacilityQueryGQLType, GetLoanProductsForCreditFacilityQueryVariablesGQLType>;
export const GetReceivableResponseTapePreviewCsvDownloadUrlDocumentGQLType = gql`
    query GetReceivableResponseTapePreviewCsvDownloadUrl($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Float!, $type: ReceivableResponseTapePreviewAttachmentType!, $loanProductId: UUID!, $previewIdentifier: String!) {
  getReceivableResponseTapePreviewCsvDownloadUrl(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    type: $type
    loanProductId: $loanProductId
    previewIdentifier: $previewIdentifier
  )
}
    `;

/**
 * __useGetReceivableResponseTapePreviewCsvDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReceivableResponseTapePreviewCsvDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivableResponseTapePreviewCsvDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivableResponseTapePreviewCsvDownloadUrlQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      type: // value for 'type'
 *      loanProductId: // value for 'loanProductId'
 *      previewIdentifier: // value for 'previewIdentifier'
 *   },
 * });
 */
export function useGetReceivableResponseTapePreviewCsvDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReceivableResponseTapePreviewCsvDownloadUrlQueryGQLType, GetReceivableResponseTapePreviewCsvDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivableResponseTapePreviewCsvDownloadUrlQueryGQLType, GetReceivableResponseTapePreviewCsvDownloadUrlQueryVariablesGQLType>(GetReceivableResponseTapePreviewCsvDownloadUrlDocumentGQLType, options);
      }
export function useGetReceivableResponseTapePreviewCsvDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivableResponseTapePreviewCsvDownloadUrlQueryGQLType, GetReceivableResponseTapePreviewCsvDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivableResponseTapePreviewCsvDownloadUrlQueryGQLType, GetReceivableResponseTapePreviewCsvDownloadUrlQueryVariablesGQLType>(GetReceivableResponseTapePreviewCsvDownloadUrlDocumentGQLType, options);
        }
export type GetReceivableResponseTapePreviewCsvDownloadUrlQueryHookResult = ReturnType<typeof useGetReceivableResponseTapePreviewCsvDownloadUrlQuery>;
export type GetReceivableResponseTapePreviewCsvDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReceivableResponseTapePreviewCsvDownloadUrlLazyQueryGQLType>;
export type GetReceivableResponseTapePreviewCsvDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetReceivableResponseTapePreviewCsvDownloadUrlQueryGQLType, GetReceivableResponseTapePreviewCsvDownloadUrlQueryVariablesGQLType>;
export const GetGeneratedAssignedLoanTapeDownloadUrlDocumentGQLType = gql`
    query GetGeneratedAssignedLoanTapeDownloadUrl($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Float!, $loanProductId: UUID!) {
  getGeneratedAssignedLoanTapeDownloadUrl(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    loanProductId: $loanProductId
  )
}
    `;

/**
 * __useGetGeneratedAssignedLoanTapeDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetGeneratedAssignedLoanTapeDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedAssignedLoanTapeDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneratedAssignedLoanTapeDownloadUrlQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      loanProductId: // value for 'loanProductId'
 *   },
 * });
 */
export function useGetGeneratedAssignedLoanTapeDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetGeneratedAssignedLoanTapeDownloadUrlQueryGQLType, GetGeneratedAssignedLoanTapeDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneratedAssignedLoanTapeDownloadUrlQueryGQLType, GetGeneratedAssignedLoanTapeDownloadUrlQueryVariablesGQLType>(GetGeneratedAssignedLoanTapeDownloadUrlDocumentGQLType, options);
      }
export function useGetGeneratedAssignedLoanTapeDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneratedAssignedLoanTapeDownloadUrlQueryGQLType, GetGeneratedAssignedLoanTapeDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneratedAssignedLoanTapeDownloadUrlQueryGQLType, GetGeneratedAssignedLoanTapeDownloadUrlQueryVariablesGQLType>(GetGeneratedAssignedLoanTapeDownloadUrlDocumentGQLType, options);
        }
export type GetGeneratedAssignedLoanTapeDownloadUrlQueryHookResult = ReturnType<typeof useGetGeneratedAssignedLoanTapeDownloadUrlQuery>;
export type GetGeneratedAssignedLoanTapeDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetGeneratedAssignedLoanTapeDownloadUrlLazyQueryGQLType>;
export type GetGeneratedAssignedLoanTapeDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetGeneratedAssignedLoanTapeDownloadUrlQueryGQLType, GetGeneratedAssignedLoanTapeDownloadUrlQueryVariablesGQLType>;
export const GetAssignmentJobsDocumentGQLType = gql`
    query GetAssignmentJobs($implementationId: String!, $reportingDate: FullDateStr, $fileVersion: Int) {
  assignmentJobs(
    implementationId: $implementationId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    previewJobs {
      ...AssignmentPreviewJob
    }
    latestConfirmationJob {
      ...AssignmentConfirmationJob
    }
  }
}
    ${AssignmentPreviewJobFragmentDocGQLType}
${AssignmentConfirmationJobFragmentDocGQLType}`;

/**
 * __useGetAssignmentJobsQuery__
 *
 * To run a query within a React component, call `useGetAssignmentJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentJobsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetAssignmentJobsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentJobsQueryGQLType, GetAssignmentJobsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentJobsQueryGQLType, GetAssignmentJobsQueryVariablesGQLType>(GetAssignmentJobsDocumentGQLType, options);
      }
export function useGetAssignmentJobsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentJobsQueryGQLType, GetAssignmentJobsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentJobsQueryGQLType, GetAssignmentJobsQueryVariablesGQLType>(GetAssignmentJobsDocumentGQLType, options);
        }
export type GetAssignmentJobsQueryHookResult = ReturnType<typeof useGetAssignmentJobsQuery>;
export type GetAssignmentJobsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssignmentJobsLazyQueryGQLType>;
export type GetAssignmentJobsQueryResultGQLType = Apollo.QueryResult<GetAssignmentJobsQueryGQLType, GetAssignmentJobsQueryVariablesGQLType>;
export const GetRepurchaseAndTransferJobsDocumentGQLType = gql`
    query GetRepurchaseAndTransferJobs($implementationId: String!) {
  repurchaseAndTransferJobs(implementationId: $implementationId) {
    ...AssignmentConfirmationJob
  }
}
    ${AssignmentConfirmationJobFragmentDocGQLType}`;

/**
 * __useGetRepurchaseAndTransferJobsQuery__
 *
 * To run a query within a React component, call `useGetRepurchaseAndTransferJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepurchaseAndTransferJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepurchaseAndTransferJobsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetRepurchaseAndTransferJobsQuery(baseOptions: Apollo.QueryHookOptions<GetRepurchaseAndTransferJobsQueryGQLType, GetRepurchaseAndTransferJobsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRepurchaseAndTransferJobsQueryGQLType, GetRepurchaseAndTransferJobsQueryVariablesGQLType>(GetRepurchaseAndTransferJobsDocumentGQLType, options);
      }
export function useGetRepurchaseAndTransferJobsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRepurchaseAndTransferJobsQueryGQLType, GetRepurchaseAndTransferJobsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRepurchaseAndTransferJobsQueryGQLType, GetRepurchaseAndTransferJobsQueryVariablesGQLType>(GetRepurchaseAndTransferJobsDocumentGQLType, options);
        }
export type GetRepurchaseAndTransferJobsQueryHookResult = ReturnType<typeof useGetRepurchaseAndTransferJobsQuery>;
export type GetRepurchaseAndTransferJobsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRepurchaseAndTransferJobsLazyQueryGQLType>;
export type GetRepurchaseAndTransferJobsQueryResultGQLType = Apollo.QueryResult<GetRepurchaseAndTransferJobsQueryGQLType, GetRepurchaseAndTransferJobsQueryVariablesGQLType>;
export const GetLatestHistoricalReceivableResponseTapeValuesDocumentGQLType = gql`
    query GetLatestHistoricalReceivableResponseTapeValues($organizationId: UUID!, $creditFacilityId: UUID!, $loanProductId: UUID, $reportingDatesRange: FullDateStrDateRangeInput, $queryFilters: String, $queryPageNumber: Int!, $queryPageBoundaryReceivableIds: [String]!) {
  latestHistoricalReceivableResponseTapeValues(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
    loanProductId: $loanProductId
    reportingDatesRange: $reportingDatesRange
    queryFilters: $queryFilters
    queryPageNumber: $queryPageNumber
    queryPageBoundaryReceivableIds: $queryPageBoundaryReceivableIds
  ) {
    paginationMetadata {
      ...ReceivablePaginationMetadata
    }
    receivables
  }
}
    ${ReceivablePaginationMetadataFragmentDocGQLType}`;

/**
 * __useGetLatestHistoricalReceivableResponseTapeValuesQuery__
 *
 * To run a query within a React component, call `useGetLatestHistoricalReceivableResponseTapeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestHistoricalReceivableResponseTapeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestHistoricalReceivableResponseTapeValuesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      loanProductId: // value for 'loanProductId'
 *      reportingDatesRange: // value for 'reportingDatesRange'
 *      queryFilters: // value for 'queryFilters'
 *      queryPageNumber: // value for 'queryPageNumber'
 *      queryPageBoundaryReceivableIds: // value for 'queryPageBoundaryReceivableIds'
 *   },
 * });
 */
export function useGetLatestHistoricalReceivableResponseTapeValuesQuery(baseOptions: Apollo.QueryHookOptions<GetLatestHistoricalReceivableResponseTapeValuesQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestHistoricalReceivableResponseTapeValuesQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesQueryVariablesGQLType>(GetLatestHistoricalReceivableResponseTapeValuesDocumentGQLType, options);
      }
export function useGetLatestHistoricalReceivableResponseTapeValuesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestHistoricalReceivableResponseTapeValuesQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestHistoricalReceivableResponseTapeValuesQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesQueryVariablesGQLType>(GetLatestHistoricalReceivableResponseTapeValuesDocumentGQLType, options);
        }
export type GetLatestHistoricalReceivableResponseTapeValuesQueryHookResult = ReturnType<typeof useGetLatestHistoricalReceivableResponseTapeValuesQuery>;
export type GetLatestHistoricalReceivableResponseTapeValuesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestHistoricalReceivableResponseTapeValuesLazyQueryGQLType>;
export type GetLatestHistoricalReceivableResponseTapeValuesQueryResultGQLType = Apollo.QueryResult<GetLatestHistoricalReceivableResponseTapeValuesQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesQueryVariablesGQLType>;
export const GetLatestHistoricalReceivableResponseTapeValuesCountDocumentGQLType = gql`
    query GetLatestHistoricalReceivableResponseTapeValuesCount($organizationId: UUID!, $creditFacilityId: UUID!, $loanProductId: UUID, $reportingDatesRange: FullDateStrDateRangeInput, $queryFilters: String) {
  latestHistoricalReceivableResponseTapeValuesCount(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
    loanProductId: $loanProductId
    reportingDatesRange: $reportingDatesRange
    queryFilters: $queryFilters
  )
}
    `;

/**
 * __useGetLatestHistoricalReceivableResponseTapeValuesCountQuery__
 *
 * To run a query within a React component, call `useGetLatestHistoricalReceivableResponseTapeValuesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestHistoricalReceivableResponseTapeValuesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestHistoricalReceivableResponseTapeValuesCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      loanProductId: // value for 'loanProductId'
 *      reportingDatesRange: // value for 'reportingDatesRange'
 *      queryFilters: // value for 'queryFilters'
 *   },
 * });
 */
export function useGetLatestHistoricalReceivableResponseTapeValuesCountQuery(baseOptions: Apollo.QueryHookOptions<GetLatestHistoricalReceivableResponseTapeValuesCountQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesCountQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestHistoricalReceivableResponseTapeValuesCountQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesCountQueryVariablesGQLType>(GetLatestHistoricalReceivableResponseTapeValuesCountDocumentGQLType, options);
      }
export function useGetLatestHistoricalReceivableResponseTapeValuesCountLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestHistoricalReceivableResponseTapeValuesCountQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesCountQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestHistoricalReceivableResponseTapeValuesCountQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesCountQueryVariablesGQLType>(GetLatestHistoricalReceivableResponseTapeValuesCountDocumentGQLType, options);
        }
export type GetLatestHistoricalReceivableResponseTapeValuesCountQueryHookResult = ReturnType<typeof useGetLatestHistoricalReceivableResponseTapeValuesCountQuery>;
export type GetLatestHistoricalReceivableResponseTapeValuesCountLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestHistoricalReceivableResponseTapeValuesCountLazyQueryGQLType>;
export type GetLatestHistoricalReceivableResponseTapeValuesCountQueryResultGQLType = Apollo.QueryResult<GetLatestHistoricalReceivableResponseTapeValuesCountQueryGQLType, GetLatestHistoricalReceivableResponseTapeValuesCountQueryVariablesGQLType>;
export const InitiateReceivableReassignmentFromAthenaQueryDocumentGQLType = gql`
    mutation InitiateReceivableReassignmentFromAthenaQuery($organizationId: UUID!, $creditFacilityId: UUID!, $loanProductId: UUID, $reportingDatesRange: FullDateStrDateRangeInput, $queryFilters: String, $allQueryRowsSelected: Boolean!, $finleyReceivableIdsToInclude: [UUID!]!, $finleyReceivableIdsToExclude: [UUID!]!, $reassignmentInfo: [LpCfReassignmentInput!]!) {
  initiateReceivableReassignmentFromAthenaQuery(
    organizationId: $organizationId
    creditFacilityId: $creditFacilityId
    loanProductId: $loanProductId
    reportingDatesRange: $reportingDatesRange
    queryFilters: $queryFilters
    allQueryRowsSelected: $allQueryRowsSelected
    finleyReceivableIdsToInclude: $finleyReceivableIdsToInclude
    finleyReceivableIdsToExclude: $finleyReceivableIdsToExclude
    reassignmentInfo: $reassignmentInfo
  ) {
    jobId
    receivableCount
  }
}
    `;
export type InitiateReceivableReassignmentFromAthenaQueryMutationFnGQLType = Apollo.MutationFunction<InitiateReceivableReassignmentFromAthenaQueryMutationGQLType, InitiateReceivableReassignmentFromAthenaQueryMutationVariablesGQLType>;

/**
 * __useInitiateReceivableReassignmentFromAthenaQueryMutation__
 *
 * To run a mutation, you first call `useInitiateReceivableReassignmentFromAthenaQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateReceivableReassignmentFromAthenaQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateReceivableReassignmentFromAthenaQueryMutation, { data, loading, error }] = useInitiateReceivableReassignmentFromAthenaQueryMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      loanProductId: // value for 'loanProductId'
 *      reportingDatesRange: // value for 'reportingDatesRange'
 *      queryFilters: // value for 'queryFilters'
 *      allQueryRowsSelected: // value for 'allQueryRowsSelected'
 *      finleyReceivableIdsToInclude: // value for 'finleyReceivableIdsToInclude'
 *      finleyReceivableIdsToExclude: // value for 'finleyReceivableIdsToExclude'
 *      reassignmentInfo: // value for 'reassignmentInfo'
 *   },
 * });
 */
export function useInitiateReceivableReassignmentFromAthenaQueryMutation(baseOptions?: Apollo.MutationHookOptions<InitiateReceivableReassignmentFromAthenaQueryMutationGQLType, InitiateReceivableReassignmentFromAthenaQueryMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateReceivableReassignmentFromAthenaQueryMutationGQLType, InitiateReceivableReassignmentFromAthenaQueryMutationVariablesGQLType>(InitiateReceivableReassignmentFromAthenaQueryDocumentGQLType, options);
      }
export type InitiateReceivableReassignmentFromAthenaQueryMutationHookResult = ReturnType<typeof useInitiateReceivableReassignmentFromAthenaQueryMutation>;
export type InitiateReceivableReassignmentFromAthenaQueryMutationResultGQLType = Apollo.MutationResult<InitiateReceivableReassignmentFromAthenaQueryMutationGQLType>;
export type InitiateReceivableReassignmentFromAthenaQueryMutationOptionsGQLType = Apollo.BaseMutationOptions<InitiateReceivableReassignmentFromAthenaQueryMutationGQLType, InitiateReceivableReassignmentFromAthenaQueryMutationVariablesGQLType>;
export const InitiateReceivableReassignmentFromDataPipelineDocumentGQLType = gql`
    mutation InitiateReceivableReassignmentFromDataPipeline($loanProductSlug: String!, $implementationId: UUID!, $externalReceivableIds: [String!]!, $creditFacilitySlug: String) {
  initiateReceivableReassignmentFromDataPipeline(
    loanProductSlug: $loanProductSlug
    implementationId: $implementationId
    externalReceivableIds: $externalReceivableIds
    creditFacilitySlug: $creditFacilitySlug
  ) {
    jobId
    receivableCount
  }
}
    `;
export type InitiateReceivableReassignmentFromDataPipelineMutationFnGQLType = Apollo.MutationFunction<InitiateReceivableReassignmentFromDataPipelineMutationGQLType, InitiateReceivableReassignmentFromDataPipelineMutationVariablesGQLType>;

/**
 * __useInitiateReceivableReassignmentFromDataPipelineMutation__
 *
 * To run a mutation, you first call `useInitiateReceivableReassignmentFromDataPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateReceivableReassignmentFromDataPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateReceivableReassignmentFromDataPipelineMutation, { data, loading, error }] = useInitiateReceivableReassignmentFromDataPipelineMutation({
 *   variables: {
 *      loanProductSlug: // value for 'loanProductSlug'
 *      implementationId: // value for 'implementationId'
 *      externalReceivableIds: // value for 'externalReceivableIds'
 *      creditFacilitySlug: // value for 'creditFacilitySlug'
 *   },
 * });
 */
export function useInitiateReceivableReassignmentFromDataPipelineMutation(baseOptions?: Apollo.MutationHookOptions<InitiateReceivableReassignmentFromDataPipelineMutationGQLType, InitiateReceivableReassignmentFromDataPipelineMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateReceivableReassignmentFromDataPipelineMutationGQLType, InitiateReceivableReassignmentFromDataPipelineMutationVariablesGQLType>(InitiateReceivableReassignmentFromDataPipelineDocumentGQLType, options);
      }
export type InitiateReceivableReassignmentFromDataPipelineMutationHookResult = ReturnType<typeof useInitiateReceivableReassignmentFromDataPipelineMutation>;
export type InitiateReceivableReassignmentFromDataPipelineMutationResultGQLType = Apollo.MutationResult<InitiateReceivableReassignmentFromDataPipelineMutationGQLType>;
export type InitiateReceivableReassignmentFromDataPipelineMutationOptionsGQLType = Apollo.BaseMutationOptions<InitiateReceivableReassignmentFromDataPipelineMutationGQLType, InitiateReceivableReassignmentFromDataPipelineMutationVariablesGQLType>;
export const GetHistoricalRecordsForReceivableDocumentGQLType = gql`
    query GetHistoricalRecordsForReceivable($organizationId: UUID!, $finleyReceivableId: UUID!, $creditFacilityId: UUID!, $reportingDateParams: DateRangeInput) {
  historicalRecordsForReceivable(
    organizationId: $organizationId
    finleyReceivableId: $finleyReceivableId
    creditFacilityId: $creditFacilityId
    reportingDateParams: $reportingDateParams
  )
}
    `;

/**
 * __useGetHistoricalRecordsForReceivableQuery__
 *
 * To run a query within a React component, call `useGetHistoricalRecordsForReceivableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalRecordsForReceivableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalRecordsForReceivableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      finleyReceivableId: // value for 'finleyReceivableId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDateParams: // value for 'reportingDateParams'
 *   },
 * });
 */
export function useGetHistoricalRecordsForReceivableQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalRecordsForReceivableQueryGQLType, GetHistoricalRecordsForReceivableQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalRecordsForReceivableQueryGQLType, GetHistoricalRecordsForReceivableQueryVariablesGQLType>(GetHistoricalRecordsForReceivableDocumentGQLType, options);
      }
export function useGetHistoricalRecordsForReceivableLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalRecordsForReceivableQueryGQLType, GetHistoricalRecordsForReceivableQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalRecordsForReceivableQueryGQLType, GetHistoricalRecordsForReceivableQueryVariablesGQLType>(GetHistoricalRecordsForReceivableDocumentGQLType, options);
        }
export type GetHistoricalRecordsForReceivableQueryHookResult = ReturnType<typeof useGetHistoricalRecordsForReceivableQuery>;
export type GetHistoricalRecordsForReceivableLazyQueryGQLTypeHookResult = ReturnType<typeof useGetHistoricalRecordsForReceivableLazyQueryGQLType>;
export type GetHistoricalRecordsForReceivableQueryResultGQLType = Apollo.QueryResult<GetHistoricalRecordsForReceivableQueryGQLType, GetHistoricalRecordsForReceivableQueryVariablesGQLType>;
export const GetRepaymentDataForAssignedReceivableDocumentGQLType = gql`
    query GetRepaymentDataForAssignedReceivable($organizationId: UUID!, $finleyReceivableId: UUID!, $repaymentDateParams: DateRangeInput) {
  repaymentDataForAssignedReceivable(
    organizationId: $organizationId
    finleyReceivableId: $finleyReceivableId
    repaymentDateParams: $repaymentDateParams
  ) {
    normalizedRepaymentAmount
    finleyRepaymentDate
  }
}
    `;

/**
 * __useGetRepaymentDataForAssignedReceivableQuery__
 *
 * To run a query within a React component, call `useGetRepaymentDataForAssignedReceivableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepaymentDataForAssignedReceivableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepaymentDataForAssignedReceivableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      finleyReceivableId: // value for 'finleyReceivableId'
 *      repaymentDateParams: // value for 'repaymentDateParams'
 *   },
 * });
 */
export function useGetRepaymentDataForAssignedReceivableQuery(baseOptions: Apollo.QueryHookOptions<GetRepaymentDataForAssignedReceivableQueryGQLType, GetRepaymentDataForAssignedReceivableQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRepaymentDataForAssignedReceivableQueryGQLType, GetRepaymentDataForAssignedReceivableQueryVariablesGQLType>(GetRepaymentDataForAssignedReceivableDocumentGQLType, options);
      }
export function useGetRepaymentDataForAssignedReceivableLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRepaymentDataForAssignedReceivableQueryGQLType, GetRepaymentDataForAssignedReceivableQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRepaymentDataForAssignedReceivableQueryGQLType, GetRepaymentDataForAssignedReceivableQueryVariablesGQLType>(GetRepaymentDataForAssignedReceivableDocumentGQLType, options);
        }
export type GetRepaymentDataForAssignedReceivableQueryHookResult = ReturnType<typeof useGetRepaymentDataForAssignedReceivableQuery>;
export type GetRepaymentDataForAssignedReceivableLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRepaymentDataForAssignedReceivableLazyQueryGQLType>;
export type GetRepaymentDataForAssignedReceivableQueryResultGQLType = Apollo.QueryResult<GetRepaymentDataForAssignedReceivableQueryGQLType, GetRepaymentDataForAssignedReceivableQueryVariablesGQLType>;
export const ConvertReceivableBorrowingBaseWaiversWithNewIdsDocumentGQLType = gql`
    query ConvertReceivableBorrowingBaseWaiversWithNewIds($creditFacilityId: UUID!, $waiversWithEntitiesJson: String!) {
  convertReceivableBorrowingBaseWaiversWithNewIds(
    creditFacilityId: $creditFacilityId
    waiversWithEntitiesJson: $waiversWithEntitiesJson
  ) {
    ...ReceivableBorrowingBaseTestWaiver
  }
}
    ${ReceivableBorrowingBaseTestWaiverFragmentDocGQLType}`;

/**
 * __useConvertReceivableBorrowingBaseWaiversWithNewIdsQuery__
 *
 * To run a query within a React component, call `useConvertReceivableBorrowingBaseWaiversWithNewIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertReceivableBorrowingBaseWaiversWithNewIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertReceivableBorrowingBaseWaiversWithNewIdsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      waiversWithEntitiesJson: // value for 'waiversWithEntitiesJson'
 *   },
 * });
 */
export function useConvertReceivableBorrowingBaseWaiversWithNewIdsQuery(baseOptions: Apollo.QueryHookOptions<ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryGQLType, ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryGQLType, ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryVariablesGQLType>(ConvertReceivableBorrowingBaseWaiversWithNewIdsDocumentGQLType, options);
      }
export function useConvertReceivableBorrowingBaseWaiversWithNewIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryGQLType, ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryGQLType, ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryVariablesGQLType>(ConvertReceivableBorrowingBaseWaiversWithNewIdsDocumentGQLType, options);
        }
export type ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryHookResult = ReturnType<typeof useConvertReceivableBorrowingBaseWaiversWithNewIdsQuery>;
export type ConvertReceivableBorrowingBaseWaiversWithNewIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useConvertReceivableBorrowingBaseWaiversWithNewIdsLazyQueryGQLType>;
export type ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryResultGQLType = Apollo.QueryResult<ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryGQLType, ConvertReceivableBorrowingBaseWaiversWithNewIdsQueryVariablesGQLType>;
export const CreateLoanProductClientDocumentGQLType = gql`
    mutation CreateLoanProductClient($name: String!, $slug: String!, $implementationId: UUID!) {
  createLoanProduct(name: $name, slug: $slug, implementationId: $implementationId) {
    id
    name
    slug
    implementationId
  }
}
    `;
export type CreateLoanProductClientMutationFnGQLType = Apollo.MutationFunction<CreateLoanProductClientMutationGQLType, CreateLoanProductClientMutationVariablesGQLType>;

/**
 * __useCreateLoanProductClientMutation__
 *
 * To run a mutation, you first call `useCreateLoanProductClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanProductClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanProductClientMutation, { data, loading, error }] = useCreateLoanProductClientMutation({
 *   variables: {
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useCreateLoanProductClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoanProductClientMutationGQLType, CreateLoanProductClientMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoanProductClientMutationGQLType, CreateLoanProductClientMutationVariablesGQLType>(CreateLoanProductClientDocumentGQLType, options);
      }
export type CreateLoanProductClientMutationHookResult = ReturnType<typeof useCreateLoanProductClientMutation>;
export type CreateLoanProductClientMutationResultGQLType = Apollo.MutationResult<CreateLoanProductClientMutationGQLType>;
export type CreateLoanProductClientMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateLoanProductClientMutationGQLType, CreateLoanProductClientMutationVariablesGQLType>;
export const CreatePreassignedInternalLoanTapesFromManualAssignmentDocumentGQLType = gql`
    mutation CreatePreassignedInternalLoanTapesFromManualAssignment($masterLoanTapeIds: [String!]!, $signaledAssignments: [SignaledAssignmentsInput!]!) {
  createPreassignedInternalLoanTapesFromManualAssignment(
    masterLoanTapeIds: $masterLoanTapeIds
    signaledAssignments: $signaledAssignments
  )
}
    `;
export type CreatePreassignedInternalLoanTapesFromManualAssignmentMutationFnGQLType = Apollo.MutationFunction<CreatePreassignedInternalLoanTapesFromManualAssignmentMutationGQLType, CreatePreassignedInternalLoanTapesFromManualAssignmentMutationVariablesGQLType>;

/**
 * __useCreatePreassignedInternalLoanTapesFromManualAssignmentMutation__
 *
 * To run a mutation, you first call `useCreatePreassignedInternalLoanTapesFromManualAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreassignedInternalLoanTapesFromManualAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreassignedInternalLoanTapesFromManualAssignmentMutation, { data, loading, error }] = useCreatePreassignedInternalLoanTapesFromManualAssignmentMutation({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *      signaledAssignments: // value for 'signaledAssignments'
 *   },
 * });
 */
export function useCreatePreassignedInternalLoanTapesFromManualAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreassignedInternalLoanTapesFromManualAssignmentMutationGQLType, CreatePreassignedInternalLoanTapesFromManualAssignmentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreassignedInternalLoanTapesFromManualAssignmentMutationGQLType, CreatePreassignedInternalLoanTapesFromManualAssignmentMutationVariablesGQLType>(CreatePreassignedInternalLoanTapesFromManualAssignmentDocumentGQLType, options);
      }
export type CreatePreassignedInternalLoanTapesFromManualAssignmentMutationHookResult = ReturnType<typeof useCreatePreassignedInternalLoanTapesFromManualAssignmentMutation>;
export type CreatePreassignedInternalLoanTapesFromManualAssignmentMutationResultGQLType = Apollo.MutationResult<CreatePreassignedInternalLoanTapesFromManualAssignmentMutationGQLType>;
export type CreatePreassignedInternalLoanTapesFromManualAssignmentMutationOptionsGQLType = Apollo.BaseMutationOptions<CreatePreassignedInternalLoanTapesFromManualAssignmentMutationGQLType, CreatePreassignedInternalLoanTapesFromManualAssignmentMutationVariablesGQLType>;
export const CreatePreassignedInternalLoanTapesFromPreviewMetadataDocumentGQLType = gql`
    mutation CreatePreassignedInternalLoanTapesFromPreviewMetadata($implementationId: String!, $previewIdentifier: String!, $reportingDate: FullDateStr!, $fileVersion: Float!, $receivableResponseTapePreviewJobId: String!) {
  createPreassignedInternalLoanTapesFromPreviewMetadata(
    implementationId: $implementationId
    previewIdentifier: $previewIdentifier
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    receivableResponseTapePreviewJobId: $receivableResponseTapePreviewJobId
  )
}
    `;
export type CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationFnGQLType = Apollo.MutationFunction<CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationGQLType, CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationVariablesGQLType>;

/**
 * __useCreatePreassignedInternalLoanTapesFromPreviewMetadataMutation__
 *
 * To run a mutation, you first call `useCreatePreassignedInternalLoanTapesFromPreviewMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreassignedInternalLoanTapesFromPreviewMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreassignedInternalLoanTapesFromPreviewMetadataMutation, { data, loading, error }] = useCreatePreassignedInternalLoanTapesFromPreviewMetadataMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      previewIdentifier: // value for 'previewIdentifier'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      receivableResponseTapePreviewJobId: // value for 'receivableResponseTapePreviewJobId'
 *   },
 * });
 */
export function useCreatePreassignedInternalLoanTapesFromPreviewMetadataMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationGQLType, CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationGQLType, CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationVariablesGQLType>(CreatePreassignedInternalLoanTapesFromPreviewMetadataDocumentGQLType, options);
      }
export type CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationHookResult = ReturnType<typeof useCreatePreassignedInternalLoanTapesFromPreviewMetadataMutation>;
export type CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationResultGQLType = Apollo.MutationResult<CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationGQLType>;
export type CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationOptionsGQLType = Apollo.BaseMutationOptions<CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationGQLType, CreatePreassignedInternalLoanTapesFromPreviewMetadataMutationVariablesGQLType>;
export const CreateReceivableResponseTapePreviewsFromPayloadDocumentGQLType = gql`
    mutation CreateReceivableResponseTapePreviewsFromPayload($masterLoanTapeIds: [String!]!, $signaledAssignments: [SignaledAssignmentsInput!]!) {
  createReceivableResponseTapePreviewsFromPayload(
    masterLoanTapeIds: $masterLoanTapeIds
    signaledAssignments: $signaledAssignments
  ) {
    response
  }
}
    `;
export type CreateReceivableResponseTapePreviewsFromPayloadMutationFnGQLType = Apollo.MutationFunction<CreateReceivableResponseTapePreviewsFromPayloadMutationGQLType, CreateReceivableResponseTapePreviewsFromPayloadMutationVariablesGQLType>;

/**
 * __useCreateReceivableResponseTapePreviewsFromPayloadMutation__
 *
 * To run a mutation, you first call `useCreateReceivableResponseTapePreviewsFromPayloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReceivableResponseTapePreviewsFromPayloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReceivableResponseTapePreviewsFromPayloadMutation, { data, loading, error }] = useCreateReceivableResponseTapePreviewsFromPayloadMutation({
 *   variables: {
 *      masterLoanTapeIds: // value for 'masterLoanTapeIds'
 *      signaledAssignments: // value for 'signaledAssignments'
 *   },
 * });
 */
export function useCreateReceivableResponseTapePreviewsFromPayloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateReceivableResponseTapePreviewsFromPayloadMutationGQLType, CreateReceivableResponseTapePreviewsFromPayloadMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReceivableResponseTapePreviewsFromPayloadMutationGQLType, CreateReceivableResponseTapePreviewsFromPayloadMutationVariablesGQLType>(CreateReceivableResponseTapePreviewsFromPayloadDocumentGQLType, options);
      }
export type CreateReceivableResponseTapePreviewsFromPayloadMutationHookResult = ReturnType<typeof useCreateReceivableResponseTapePreviewsFromPayloadMutation>;
export type CreateReceivableResponseTapePreviewsFromPayloadMutationResultGQLType = Apollo.MutationResult<CreateReceivableResponseTapePreviewsFromPayloadMutationGQLType>;
export type CreateReceivableResponseTapePreviewsFromPayloadMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateReceivableResponseTapePreviewsFromPayloadMutationGQLType, CreateReceivableResponseTapePreviewsFromPayloadMutationVariablesGQLType>;
export const CreateAssignmentServicerReportPreviewDocumentGQLType = gql`
    mutation CreateAssignmentServicerReportPreview($assignmentServicerReportPreviewInput: AssignmentServicerReportPreviewInput!) {
  createAssignmentServicerReportPreview(
    assignmentServicerReportPreviewInput: $assignmentServicerReportPreviewInput
  ) {
    response
  }
}
    `;
export type CreateAssignmentServicerReportPreviewMutationFnGQLType = Apollo.MutationFunction<CreateAssignmentServicerReportPreviewMutationGQLType, CreateAssignmentServicerReportPreviewMutationVariablesGQLType>;

/**
 * __useCreateAssignmentServicerReportPreviewMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentServicerReportPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentServicerReportPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentServicerReportPreviewMutation, { data, loading, error }] = useCreateAssignmentServicerReportPreviewMutation({
 *   variables: {
 *      assignmentServicerReportPreviewInput: // value for 'assignmentServicerReportPreviewInput'
 *   },
 * });
 */
export function useCreateAssignmentServicerReportPreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentServicerReportPreviewMutationGQLType, CreateAssignmentServicerReportPreviewMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentServicerReportPreviewMutationGQLType, CreateAssignmentServicerReportPreviewMutationVariablesGQLType>(CreateAssignmentServicerReportPreviewDocumentGQLType, options);
      }
export type CreateAssignmentServicerReportPreviewMutationHookResult = ReturnType<typeof useCreateAssignmentServicerReportPreviewMutation>;
export type CreateAssignmentServicerReportPreviewMutationResultGQLType = Apollo.MutationResult<CreateAssignmentServicerReportPreviewMutationGQLType>;
export type CreateAssignmentServicerReportPreviewMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateAssignmentServicerReportPreviewMutationGQLType, CreateAssignmentServicerReportPreviewMutationVariablesGQLType>;
export const CreateAssignmentServicerReportPreviewV1DocumentGQLType = gql`
    mutation CreateAssignmentServicerReportPreviewV1($assignmentServicerReportPreviewInput: AssignmentServicerReportPreviewInputV1!) {
  createAssignmentServicerReportPreviewV1(
    assignmentServicerReportPreviewInput: $assignmentServicerReportPreviewInput
  ) {
    response
  }
}
    `;
export type CreateAssignmentServicerReportPreviewV1MutationFnGQLType = Apollo.MutationFunction<CreateAssignmentServicerReportPreviewV1MutationGQLType, CreateAssignmentServicerReportPreviewV1MutationVariablesGQLType>;

/**
 * __useCreateAssignmentServicerReportPreviewV1Mutation__
 *
 * To run a mutation, you first call `useCreateAssignmentServicerReportPreviewV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentServicerReportPreviewV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentServicerReportPreviewV1Mutation, { data, loading, error }] = useCreateAssignmentServicerReportPreviewV1Mutation({
 *   variables: {
 *      assignmentServicerReportPreviewInput: // value for 'assignmentServicerReportPreviewInput'
 *   },
 * });
 */
export function useCreateAssignmentServicerReportPreviewV1Mutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentServicerReportPreviewV1MutationGQLType, CreateAssignmentServicerReportPreviewV1MutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentServicerReportPreviewV1MutationGQLType, CreateAssignmentServicerReportPreviewV1MutationVariablesGQLType>(CreateAssignmentServicerReportPreviewV1DocumentGQLType, options);
      }
export type CreateAssignmentServicerReportPreviewV1MutationHookResult = ReturnType<typeof useCreateAssignmentServicerReportPreviewV1Mutation>;
export type CreateAssignmentServicerReportPreviewV1MutationResultGQLType = Apollo.MutationResult<CreateAssignmentServicerReportPreviewV1MutationGQLType>;
export type CreateAssignmentServicerReportPreviewV1MutationOptionsGQLType = Apollo.BaseMutationOptions<CreateAssignmentServicerReportPreviewV1MutationGQLType, CreateAssignmentServicerReportPreviewV1MutationVariablesGQLType>;
export const UpdateAssignmentStrategiesDefaultDocumentGQLType = gql`
    mutation UpdateAssignmentStrategiesDefault($assignmentStrategyId: UUID!, $isDefault: Boolean!) {
  updateAssignmentStrategiesDefault(
    assignmentStrategyId: $assignmentStrategyId
    isDefault: $isDefault
  ) {
    ...AssignmentStrategy
  }
}
    ${AssignmentStrategyFragmentDocGQLType}`;
export type UpdateAssignmentStrategiesDefaultMutationFnGQLType = Apollo.MutationFunction<UpdateAssignmentStrategiesDefaultMutationGQLType, UpdateAssignmentStrategiesDefaultMutationVariablesGQLType>;

/**
 * __useUpdateAssignmentStrategiesDefaultMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentStrategiesDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentStrategiesDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentStrategiesDefaultMutation, { data, loading, error }] = useUpdateAssignmentStrategiesDefaultMutation({
 *   variables: {
 *      assignmentStrategyId: // value for 'assignmentStrategyId'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useUpdateAssignmentStrategiesDefaultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentStrategiesDefaultMutationGQLType, UpdateAssignmentStrategiesDefaultMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentStrategiesDefaultMutationGQLType, UpdateAssignmentStrategiesDefaultMutationVariablesGQLType>(UpdateAssignmentStrategiesDefaultDocumentGQLType, options);
      }
export type UpdateAssignmentStrategiesDefaultMutationHookResult = ReturnType<typeof useUpdateAssignmentStrategiesDefaultMutation>;
export type UpdateAssignmentStrategiesDefaultMutationResultGQLType = Apollo.MutationResult<UpdateAssignmentStrategiesDefaultMutationGQLType>;
export type UpdateAssignmentStrategiesDefaultMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateAssignmentStrategiesDefaultMutationGQLType, UpdateAssignmentStrategiesDefaultMutationVariablesGQLType>;
export const DeleteAssignmentStrategyDocumentGQLType = gql`
    mutation DeleteAssignmentStrategy($assignmentStrategyId: UUID!) {
  deleteAssignmentStrategy(assignmentStrategyId: $assignmentStrategyId) {
    ...AssignmentStrategy
  }
}
    ${AssignmentStrategyFragmentDocGQLType}`;
export type DeleteAssignmentStrategyMutationFnGQLType = Apollo.MutationFunction<DeleteAssignmentStrategyMutationGQLType, DeleteAssignmentStrategyMutationVariablesGQLType>;

/**
 * __useDeleteAssignmentStrategyMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentStrategyMutation, { data, loading, error }] = useDeleteAssignmentStrategyMutation({
 *   variables: {
 *      assignmentStrategyId: // value for 'assignmentStrategyId'
 *   },
 * });
 */
export function useDeleteAssignmentStrategyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentStrategyMutationGQLType, DeleteAssignmentStrategyMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentStrategyMutationGQLType, DeleteAssignmentStrategyMutationVariablesGQLType>(DeleteAssignmentStrategyDocumentGQLType, options);
      }
export type DeleteAssignmentStrategyMutationHookResult = ReturnType<typeof useDeleteAssignmentStrategyMutation>;
export type DeleteAssignmentStrategyMutationResultGQLType = Apollo.MutationResult<DeleteAssignmentStrategyMutationGQLType>;
export type DeleteAssignmentStrategyMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteAssignmentStrategyMutationGQLType, DeleteAssignmentStrategyMutationVariablesGQLType>;
export const CreateOrUpdateAssignmentStrategyDocumentGQLType = gql`
    mutation CreateOrUpdateAssignmentStrategy($strategyName: String!, $description: String!, $implementationId: UUID!, $strategyId: UUID, $loanProductCriteria: [LoanProductCriteriaInput!]!, $loanProductCriteriaIdsToDelete: [String!]!, $eligibilityExclusions: [EligibilityExclusionInput!]!, $eligibilityExclusionIdsToDelete: [String!]!, $decisionHeuristicConfig: String!) {
  createOrUpdateAssignmentStrategy(
    strategyName: $strategyName
    description: $description
    implementationId: $implementationId
    strategyId: $strategyId
    loanProductCriteria: $loanProductCriteria
    loanProductCriteriaIdsToDelete: $loanProductCriteriaIdsToDelete
    eligibilityExclusions: $eligibilityExclusions
    eligibilityExclusionIdsToDelete: $eligibilityExclusionIdsToDelete
    decisionHeuristicConfig: $decisionHeuristicConfig
  ) {
    ...AssignmentStrategy
  }
}
    ${AssignmentStrategyFragmentDocGQLType}`;
export type CreateOrUpdateAssignmentStrategyMutationFnGQLType = Apollo.MutationFunction<CreateOrUpdateAssignmentStrategyMutationGQLType, CreateOrUpdateAssignmentStrategyMutationVariablesGQLType>;

/**
 * __useCreateOrUpdateAssignmentStrategyMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAssignmentStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAssignmentStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAssignmentStrategyMutation, { data, loading, error }] = useCreateOrUpdateAssignmentStrategyMutation({
 *   variables: {
 *      strategyName: // value for 'strategyName'
 *      description: // value for 'description'
 *      implementationId: // value for 'implementationId'
 *      strategyId: // value for 'strategyId'
 *      loanProductCriteria: // value for 'loanProductCriteria'
 *      loanProductCriteriaIdsToDelete: // value for 'loanProductCriteriaIdsToDelete'
 *      eligibilityExclusions: // value for 'eligibilityExclusions'
 *      eligibilityExclusionIdsToDelete: // value for 'eligibilityExclusionIdsToDelete'
 *      decisionHeuristicConfig: // value for 'decisionHeuristicConfig'
 *   },
 * });
 */
export function useCreateOrUpdateAssignmentStrategyMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAssignmentStrategyMutationGQLType, CreateOrUpdateAssignmentStrategyMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAssignmentStrategyMutationGQLType, CreateOrUpdateAssignmentStrategyMutationVariablesGQLType>(CreateOrUpdateAssignmentStrategyDocumentGQLType, options);
      }
export type CreateOrUpdateAssignmentStrategyMutationHookResult = ReturnType<typeof useCreateOrUpdateAssignmentStrategyMutation>;
export type CreateOrUpdateAssignmentStrategyMutationResultGQLType = Apollo.MutationResult<CreateOrUpdateAssignmentStrategyMutationGQLType>;
export type CreateOrUpdateAssignmentStrategyMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrUpdateAssignmentStrategyMutationGQLType, CreateOrUpdateAssignmentStrategyMutationVariablesGQLType>;
export const CreateReceivableResponseTapePreviewsFromAssignmentStrategyDocumentGQLType = gql`
    mutation CreateReceivableResponseTapePreviewsFromAssignmentStrategy($implementationId: UUID!, $strategyId: UUID!) {
  createReceivableResponseTapePreviewsFromAssignmentStrategy(
    implementationId: $implementationId
    strategyId: $strategyId
  )
}
    `;
export type CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationFnGQLType = Apollo.MutationFunction<CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationGQLType, CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationVariablesGQLType>;

/**
 * __useCreateReceivableResponseTapePreviewsFromAssignmentStrategyMutation__
 *
 * To run a mutation, you first call `useCreateReceivableResponseTapePreviewsFromAssignmentStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReceivableResponseTapePreviewsFromAssignmentStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReceivableResponseTapePreviewsFromAssignmentStrategyMutation, { data, loading, error }] = useCreateReceivableResponseTapePreviewsFromAssignmentStrategyMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      strategyId: // value for 'strategyId'
 *   },
 * });
 */
export function useCreateReceivableResponseTapePreviewsFromAssignmentStrategyMutation(baseOptions?: Apollo.MutationHookOptions<CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationGQLType, CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationGQLType, CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationVariablesGQLType>(CreateReceivableResponseTapePreviewsFromAssignmentStrategyDocumentGQLType, options);
      }
export type CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationHookResult = ReturnType<typeof useCreateReceivableResponseTapePreviewsFromAssignmentStrategyMutation>;
export type CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationResultGQLType = Apollo.MutationResult<CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationGQLType>;
export type CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationGQLType, CreateReceivableResponseTapePreviewsFromAssignmentStrategyMutationVariablesGQLType>;
export const GetParticipantValleyIbsApiRecordsForFundingRequestDocumentGQLType = gql`
    query getParticipantValleyIbsApiRecordsForFundingRequest($fundingRequestId: UUID!) {
  records: getParticipantValleyIbsApiRecordsForFundingRequest(
    fundingRequestId: $fundingRequestId
  ) {
    ...ValleyIbsApiRecord
  }
}
    ${ValleyIbsApiRecordFragmentDocGQLType}`;

/**
 * __useGetParticipantValleyIbsApiRecordsForFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetParticipantValleyIbsApiRecordsForFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantValleyIbsApiRecordsForFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantValleyIbsApiRecordsForFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetParticipantValleyIbsApiRecordsForFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantValleyIbsApiRecordsForFundingRequestQueryGQLType, GetParticipantValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantValleyIbsApiRecordsForFundingRequestQueryGQLType, GetParticipantValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>(GetParticipantValleyIbsApiRecordsForFundingRequestDocumentGQLType, options);
      }
export function useGetParticipantValleyIbsApiRecordsForFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantValleyIbsApiRecordsForFundingRequestQueryGQLType, GetParticipantValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantValleyIbsApiRecordsForFundingRequestQueryGQLType, GetParticipantValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>(GetParticipantValleyIbsApiRecordsForFundingRequestDocumentGQLType, options);
        }
export type GetParticipantValleyIbsApiRecordsForFundingRequestQueryHookResult = ReturnType<typeof useGetParticipantValleyIbsApiRecordsForFundingRequestQuery>;
export type GetParticipantValleyIbsApiRecordsForFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetParticipantValleyIbsApiRecordsForFundingRequestLazyQueryGQLType>;
export type GetParticipantValleyIbsApiRecordsForFundingRequestQueryResultGQLType = Apollo.QueryResult<GetParticipantValleyIbsApiRecordsForFundingRequestQueryGQLType, GetParticipantValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>;
export const GetNoteIncreaseValleyIbsApiRecordsForFundingRequestDocumentGQLType = gql`
    query getNoteIncreaseValleyIbsApiRecordsForFundingRequest($fundingRequestId: UUID!) {
  records: getNoteIncreaseValleyIbsApiRecordsForFundingRequest(
    fundingRequestId: $fundingRequestId
  ) {
    ...ValleyIbsApiRecord
  }
}
    ${ValleyIbsApiRecordFragmentDocGQLType}`;

/**
 * __useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryGQLType, GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryGQLType, GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>(GetNoteIncreaseValleyIbsApiRecordsForFundingRequestDocumentGQLType, options);
      }
export function useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryGQLType, GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryGQLType, GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>(GetNoteIncreaseValleyIbsApiRecordsForFundingRequestDocumentGQLType, options);
        }
export type GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryHookResult = ReturnType<typeof useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestQuery>;
export type GetNoteIncreaseValleyIbsApiRecordsForFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetNoteIncreaseValleyIbsApiRecordsForFundingRequestLazyQueryGQLType>;
export type GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryResultGQLType = Apollo.QueryResult<GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryGQLType, GetNoteIncreaseValleyIbsApiRecordsForFundingRequestQueryVariablesGQLType>;
export const ExecuteValleyIbsApiRecordDocumentGQLType = gql`
    mutation executeValleyIbsApiRecord($ibsApiRecordId: UUID!, $loanId: UUID) {
  record: executeValleyIbsApiRecord(
    ibsApiRecordId: $ibsApiRecordId
    loanId: $loanId
  ) {
    ...ValleyIbsApiRecord
  }
}
    ${ValleyIbsApiRecordFragmentDocGQLType}`;
export type ExecuteValleyIbsApiRecordMutationFnGQLType = Apollo.MutationFunction<ExecuteValleyIbsApiRecordMutationGQLType, ExecuteValleyIbsApiRecordMutationVariablesGQLType>;

/**
 * __useExecuteValleyIbsApiRecordMutation__
 *
 * To run a mutation, you first call `useExecuteValleyIbsApiRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteValleyIbsApiRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeValleyIbsApiRecordMutation, { data, loading, error }] = useExecuteValleyIbsApiRecordMutation({
 *   variables: {
 *      ibsApiRecordId: // value for 'ibsApiRecordId'
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useExecuteValleyIbsApiRecordMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteValleyIbsApiRecordMutationGQLType, ExecuteValleyIbsApiRecordMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteValleyIbsApiRecordMutationGQLType, ExecuteValleyIbsApiRecordMutationVariablesGQLType>(ExecuteValleyIbsApiRecordDocumentGQLType, options);
      }
export type ExecuteValleyIbsApiRecordMutationHookResult = ReturnType<typeof useExecuteValleyIbsApiRecordMutation>;
export type ExecuteValleyIbsApiRecordMutationResultGQLType = Apollo.MutationResult<ExecuteValleyIbsApiRecordMutationGQLType>;
export type ExecuteValleyIbsApiRecordMutationOptionsGQLType = Apollo.BaseMutationOptions<ExecuteValleyIbsApiRecordMutationGQLType, ExecuteValleyIbsApiRecordMutationVariablesGQLType>;
export const RetryValleyIbsApiRecordDocumentGQLType = gql`
    mutation retryValleyIbsApiRecord($existingIbsApiRecordId: UUID!, $loanId: UUID) {
  record: retryValleyIbsApiRecord(
    existingIbsApiRecordId: $existingIbsApiRecordId
    loanId: $loanId
  ) {
    ...ValleyIbsApiRecord
  }
}
    ${ValleyIbsApiRecordFragmentDocGQLType}`;
export type RetryValleyIbsApiRecordMutationFnGQLType = Apollo.MutationFunction<RetryValleyIbsApiRecordMutationGQLType, RetryValleyIbsApiRecordMutationVariablesGQLType>;

/**
 * __useRetryValleyIbsApiRecordMutation__
 *
 * To run a mutation, you first call `useRetryValleyIbsApiRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryValleyIbsApiRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryValleyIbsApiRecordMutation, { data, loading, error }] = useRetryValleyIbsApiRecordMutation({
 *   variables: {
 *      existingIbsApiRecordId: // value for 'existingIbsApiRecordId'
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useRetryValleyIbsApiRecordMutation(baseOptions?: Apollo.MutationHookOptions<RetryValleyIbsApiRecordMutationGQLType, RetryValleyIbsApiRecordMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryValleyIbsApiRecordMutationGQLType, RetryValleyIbsApiRecordMutationVariablesGQLType>(RetryValleyIbsApiRecordDocumentGQLType, options);
      }
export type RetryValleyIbsApiRecordMutationHookResult = ReturnType<typeof useRetryValleyIbsApiRecordMutation>;
export type RetryValleyIbsApiRecordMutationResultGQLType = Apollo.MutationResult<RetryValleyIbsApiRecordMutationGQLType>;
export type RetryValleyIbsApiRecordMutationOptionsGQLType = Apollo.BaseMutationOptions<RetryValleyIbsApiRecordMutationGQLType, RetryValleyIbsApiRecordMutationVariablesGQLType>;
export const GetCreditFacilitiesLoanRecordsDocumentGQLType = gql`
    query GetCreditFacilitiesLoanRecords($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    slug
    name
    loanRecords {
      id
      name
      externalLoanId
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesLoanRecordsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesLoanRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesLoanRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesLoanRecordsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesLoanRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>(GetCreditFacilitiesLoanRecordsDocumentGQLType, options);
      }
export function useGetCreditFacilitiesLoanRecordsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>(GetCreditFacilitiesLoanRecordsDocumentGQLType, options);
        }
export type GetCreditFacilitiesLoanRecordsQueryHookResult = ReturnType<typeof useGetCreditFacilitiesLoanRecordsQuery>;
export type GetCreditFacilitiesLoanRecordsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesLoanRecordsLazyQueryGQLType>;
export type GetCreditFacilitiesLoanRecordsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesLoanRecordsQueryGQLType, GetCreditFacilitiesLoanRecordsQueryVariablesGQLType>;
export const GetCreditFacilityFullLoansDocumentGQLType = gql`
    query GetCreditFacilityFullLoans($creditFacilityId: UUID!) {
  creditFacility(creditFacilityId: $creditFacilityId) {
    id
    slug
    name
    loans {
      ...ResolvedLoan
    }
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetCreditFacilityFullLoansQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityFullLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityFullLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityFullLoansQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCreditFacilityFullLoansQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>(GetCreditFacilityFullLoansDocumentGQLType, options);
      }
export function useGetCreditFacilityFullLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>(GetCreditFacilityFullLoansDocumentGQLType, options);
        }
export type GetCreditFacilityFullLoansQueryHookResult = ReturnType<typeof useGetCreditFacilityFullLoansQuery>;
export type GetCreditFacilityFullLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityFullLoansLazyQueryGQLType>;
export type GetCreditFacilityFullLoansQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityFullLoansQueryGQLType, GetCreditFacilityFullLoansQueryVariablesGQLType>;
export const GetCreditFacilitiesFullLoansDocumentGQLType = gql`
    query GetCreditFacilitiesFullLoans($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    slug
    name
    loans {
      ...ResolvedLoan
    }
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetCreditFacilitiesFullLoansQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesFullLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesFullLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesFullLoansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesFullLoansQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>(GetCreditFacilitiesFullLoansDocumentGQLType, options);
      }
export function useGetCreditFacilitiesFullLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>(GetCreditFacilitiesFullLoansDocumentGQLType, options);
        }
export type GetCreditFacilitiesFullLoansQueryHookResult = ReturnType<typeof useGetCreditFacilitiesFullLoansQuery>;
export type GetCreditFacilitiesFullLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesFullLoansLazyQueryGQLType>;
export type GetCreditFacilitiesFullLoansQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesFullLoansQueryGQLType, GetCreditFacilitiesFullLoansQueryVariablesGQLType>;
export const GetLoanRecordByIdDocumentGQLType = gql`
    query getLoanRecordById($loanId: UUID, $externalLoanId: UUID, $creditFacilityId: UUID) {
  loan: getLoanRecordById(
    loanId: $loanId
    externalLoanId: $externalLoanId
    creditFacilityId: $creditFacilityId
  ) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordByIdQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordByIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      externalLoanId: // value for 'externalLoanId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLoanRecordByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>(GetLoanRecordByIdDocumentGQLType, options);
      }
export function useGetLoanRecordByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>(GetLoanRecordByIdDocumentGQLType, options);
        }
export type GetLoanRecordByIdQueryHookResult = ReturnType<typeof useGetLoanRecordByIdQuery>;
export type GetLoanRecordByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordByIdLazyQueryGQLType>;
export type GetLoanRecordByIdQueryResultGQLType = Apollo.QueryResult<GetLoanRecordByIdQueryGQLType, GetLoanRecordByIdQueryVariablesGQLType>;
export const GetLoanRecordsByMetadataDocumentGQLType = gql`
    query getLoanRecordsByMetadata($filterParams: LoanMetadataFilterParams!) {
  loans: getLoanRecordsByMetadata(filterParams: $filterParams) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordsByMetadataQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordsByMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordsByMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordsByMetadataQuery({
 *   variables: {
 *      filterParams: // value for 'filterParams'
 *   },
 * });
 */
export function useGetLoanRecordsByMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>(GetLoanRecordsByMetadataDocumentGQLType, options);
      }
export function useGetLoanRecordsByMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>(GetLoanRecordsByMetadataDocumentGQLType, options);
        }
export type GetLoanRecordsByMetadataQueryHookResult = ReturnType<typeof useGetLoanRecordsByMetadataQuery>;
export type GetLoanRecordsByMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordsByMetadataLazyQueryGQLType>;
export type GetLoanRecordsByMetadataQueryResultGQLType = Apollo.QueryResult<GetLoanRecordsByMetadataQueryGQLType, GetLoanRecordsByMetadataQueryVariablesGQLType>;
export const GetResolvedLoanByIdDocumentGQLType = gql`
    query getResolvedLoanById($loanId: UUID!) {
  loan: getResolvedLoanById(loanId: $loanId) {
    ...ResolvedLoan
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetResolvedLoanByIdQuery__
 *
 * To run a query within a React component, call `useGetResolvedLoanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedLoanByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedLoanByIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetResolvedLoanByIdQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>(GetResolvedLoanByIdDocumentGQLType, options);
      }
export function useGetResolvedLoanByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>(GetResolvedLoanByIdDocumentGQLType, options);
        }
export type GetResolvedLoanByIdQueryHookResult = ReturnType<typeof useGetResolvedLoanByIdQuery>;
export type GetResolvedLoanByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedLoanByIdLazyQueryGQLType>;
export type GetResolvedLoanByIdQueryResultGQLType = Apollo.QueryResult<GetResolvedLoanByIdQueryGQLType, GetResolvedLoanByIdQueryVariablesGQLType>;
export const GetLoanRecordsByFundingRequestDocumentGQLType = gql`
    query getLoanRecordsByFundingRequest($fundingRequestId: UUID!) {
  loans: getLoanRecordsByFundingRequest(fundingRequestId: $fundingRequestId) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordsByFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordsByFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordsByFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordsByFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetLoanRecordsByFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>(GetLoanRecordsByFundingRequestDocumentGQLType, options);
      }
export function useGetLoanRecordsByFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>(GetLoanRecordsByFundingRequestDocumentGQLType, options);
        }
export type GetLoanRecordsByFundingRequestQueryHookResult = ReturnType<typeof useGetLoanRecordsByFundingRequestQuery>;
export type GetLoanRecordsByFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordsByFundingRequestLazyQueryGQLType>;
export type GetLoanRecordsByFundingRequestQueryResultGQLType = Apollo.QueryResult<GetLoanRecordsByFundingRequestQueryGQLType, GetLoanRecordsByFundingRequestQueryVariablesGQLType>;
export const GetResolvedLoansByFundingRequestDocumentGQLType = gql`
    query getResolvedLoansByFundingRequest($fundingRequestId: UUID!) {
  loans: getResolvedLoansByFundingRequest(fundingRequestId: $fundingRequestId) {
    ...ResolvedLoan
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetResolvedLoansByFundingRequestQuery__
 *
 * To run a query within a React component, call `useGetResolvedLoansByFundingRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedLoansByFundingRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedLoansByFundingRequestQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetResolvedLoansByFundingRequestQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>(GetResolvedLoansByFundingRequestDocumentGQLType, options);
      }
export function useGetResolvedLoansByFundingRequestLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>(GetResolvedLoansByFundingRequestDocumentGQLType, options);
        }
export type GetResolvedLoansByFundingRequestQueryHookResult = ReturnType<typeof useGetResolvedLoansByFundingRequestQuery>;
export type GetResolvedLoansByFundingRequestLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedLoansByFundingRequestLazyQueryGQLType>;
export type GetResolvedLoansByFundingRequestQueryResultGQLType = Apollo.QueryResult<GetResolvedLoansByFundingRequestQueryGQLType, GetResolvedLoansByFundingRequestQueryVariablesGQLType>;
export const GetLoanRecordByFundingRequestAndCommitmentKeyDocumentGQLType = gql`
    query getLoanRecordByFundingRequestAndCommitmentKey($fundingRequestId: UUID!, $commitmentKey: String!) {
  loan: getLoanRecordByFundingRequestAndCommitmentKey(
    fundingRequestId: $fundingRequestId
    commitmentKey: $commitmentKey
  ) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;

/**
 * __useGetLoanRecordByFundingRequestAndCommitmentKeyQuery__
 *
 * To run a query within a React component, call `useGetLoanRecordByFundingRequestAndCommitmentKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanRecordByFundingRequestAndCommitmentKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanRecordByFundingRequestAndCommitmentKeyQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      commitmentKey: // value for 'commitmentKey'
 *   },
 * });
 */
export function useGetLoanRecordByFundingRequestAndCommitmentKeyQuery(baseOptions: Apollo.QueryHookOptions<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetLoanRecordByFundingRequestAndCommitmentKeyDocumentGQLType, options);
      }
export function useGetLoanRecordByFundingRequestAndCommitmentKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetLoanRecordByFundingRequestAndCommitmentKeyDocumentGQLType, options);
        }
export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryHookResult = ReturnType<typeof useGetLoanRecordByFundingRequestAndCommitmentKeyQuery>;
export type GetLoanRecordByFundingRequestAndCommitmentKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanRecordByFundingRequestAndCommitmentKeyLazyQueryGQLType>;
export type GetLoanRecordByFundingRequestAndCommitmentKeyQueryResultGQLType = Apollo.QueryResult<GetLoanRecordByFundingRequestAndCommitmentKeyQueryGQLType, GetLoanRecordByFundingRequestAndCommitmentKeyQueryVariablesGQLType>;
export const GetResolvedLoanByFundingRequestAndCommitmentKeyDocumentGQLType = gql`
    query getResolvedLoanByFundingRequestAndCommitmentKey($fundingRequestId: UUID!, $commitmentKey: String!) {
  loan: getResolvedLoanByFundingRequestAndCommitmentKey(
    fundingRequestId: $fundingRequestId
    commitmentKey: $commitmentKey
  ) {
    ...ResolvedLoan
  }
}
    ${ResolvedLoanFragmentDocGQLType}`;

/**
 * __useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery__
 *
 * To run a query within a React component, call `useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      commitmentKey: // value for 'commitmentKey'
 *   },
 * });
 */
export function useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetResolvedLoanByFundingRequestAndCommitmentKeyDocumentGQLType, options);
      }
export function useGetResolvedLoanByFundingRequestAndCommitmentKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>(GetResolvedLoanByFundingRequestAndCommitmentKeyDocumentGQLType, options);
        }
export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryHookResult = ReturnType<typeof useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery>;
export type GetResolvedLoanByFundingRequestAndCommitmentKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedLoanByFundingRequestAndCommitmentKeyLazyQueryGQLType>;
export type GetResolvedLoanByFundingRequestAndCommitmentKeyQueryResultGQLType = Apollo.QueryResult<GetResolvedLoanByFundingRequestAndCommitmentKeyQueryGQLType, GetResolvedLoanByFundingRequestAndCommitmentKeyQueryVariablesGQLType>;
export const GetAggregateLoansMetadataDocumentGQLType = gql`
    query getAggregateLoansMetadata($filterParams: LoanMetadataFilterParams!) {
  results: getAggregateLoansMetadata(filterParams: $filterParams) {
    totalOutstandingBalance
    totalAccruedInterest
    totalAccruedServiceFees
  }
}
    `;

/**
 * __useGetAggregateLoansMetadataQuery__
 *
 * To run a query within a React component, call `useGetAggregateLoansMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateLoansMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateLoansMetadataQuery({
 *   variables: {
 *      filterParams: // value for 'filterParams'
 *   },
 * });
 */
export function useGetAggregateLoansMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>(GetAggregateLoansMetadataDocumentGQLType, options);
      }
export function useGetAggregateLoansMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>(GetAggregateLoansMetadataDocumentGQLType, options);
        }
export type GetAggregateLoansMetadataQueryHookResult = ReturnType<typeof useGetAggregateLoansMetadataQuery>;
export type GetAggregateLoansMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAggregateLoansMetadataLazyQueryGQLType>;
export type GetAggregateLoansMetadataQueryResultGQLType = Apollo.QueryResult<GetAggregateLoansMetadataQueryGQLType, GetAggregateLoansMetadataQueryVariablesGQLType>;
export const GetSummarizedLoansDocumentGQLType = gql`
    query getSummarizedLoans($filterParams: LoanMetadataFilterParams!) {
  loans: getSummarizedLoans(filterParams: $filterParams) {
    ...SummarizedLoan
  }
}
    ${SummarizedLoanFragmentDocGQLType}`;

/**
 * __useGetSummarizedLoansQuery__
 *
 * To run a query within a React component, call `useGetSummarizedLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummarizedLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummarizedLoansQuery({
 *   variables: {
 *      filterParams: // value for 'filterParams'
 *   },
 * });
 */
export function useGetSummarizedLoansQuery(baseOptions: Apollo.QueryHookOptions<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>(GetSummarizedLoansDocumentGQLType, options);
      }
export function useGetSummarizedLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>(GetSummarizedLoansDocumentGQLType, options);
        }
export type GetSummarizedLoansQueryHookResult = ReturnType<typeof useGetSummarizedLoansQuery>;
export type GetSummarizedLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetSummarizedLoansLazyQueryGQLType>;
export type GetSummarizedLoansQueryResultGQLType = Apollo.QueryResult<GetSummarizedLoansQueryGQLType, GetSummarizedLoansQueryVariablesGQLType>;
export const GetCurrentLiabilityAccountsAndAccrualsForLoanDocumentGQLType = gql`
    query GetCurrentLiabilityAccountsAndAccrualsForLoan($loanId: UUID!, $accrualStartDate: FullDateStr!, $accrualEndDate: FullDateStr!, $inclusiveOfAccrualEndDate: Boolean!) {
  accounts: getCurrentLiabilityAccountsAndAccrualsForLoan(
    loanId: $loanId
    accrualStartDate: $accrualStartDate
    accrualEndDate: $accrualEndDate
    inclusiveOfAccrualEndDate: $inclusiveOfAccrualEndDate
  ) {
    tAccount {
      id
      tAccount
      creditFacilityId
      organizationId
    }
    actualAccruedAmount
    projectedAccruedAmount
    totalAccruedAmount
  }
}
    `;

/**
 * __useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery__
 *
 * To run a query within a React component, call `useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      accrualStartDate: // value for 'accrualStartDate'
 *      accrualEndDate: // value for 'accrualEndDate'
 *      inclusiveOfAccrualEndDate: // value for 'inclusiveOfAccrualEndDate'
 *   },
 * });
 */
export function useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>(GetCurrentLiabilityAccountsAndAccrualsForLoanDocumentGQLType, options);
      }
export function useGetCurrentLiabilityAccountsAndAccrualsForLoanLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>(GetCurrentLiabilityAccountsAndAccrualsForLoanDocumentGQLType, options);
        }
export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryHookResult = ReturnType<typeof useGetCurrentLiabilityAccountsAndAccrualsForLoanQuery>;
export type GetCurrentLiabilityAccountsAndAccrualsForLoanLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCurrentLiabilityAccountsAndAccrualsForLoanLazyQueryGQLType>;
export type GetCurrentLiabilityAccountsAndAccrualsForLoanQueryResultGQLType = Apollo.QueryResult<GetCurrentLiabilityAccountsAndAccrualsForLoanQueryGQLType, GetCurrentLiabilityAccountsAndAccrualsForLoanQueryVariablesGQLType>;
export const GetLenderShareReportsDocumentGQLType = gql`
    query GetLenderShareReports($lenderShareId: UUID!, $fundingRequestComponentId: UUID!) {
  reports: getLenderShareReports(
    lenderShareId: $lenderShareId
    fundingRequestComponentId: $fundingRequestComponentId
  ) {
    ...LenderShareReport
  }
}
    ${LenderShareReportFragmentDocGQLType}`;

/**
 * __useGetLenderShareReportsQuery__
 *
 * To run a query within a React component, call `useGetLenderShareReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderShareReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderShareReportsQuery({
 *   variables: {
 *      lenderShareId: // value for 'lenderShareId'
 *      fundingRequestComponentId: // value for 'fundingRequestComponentId'
 *   },
 * });
 */
export function useGetLenderShareReportsQuery(baseOptions: Apollo.QueryHookOptions<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>(GetLenderShareReportsDocumentGQLType, options);
      }
export function useGetLenderShareReportsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>(GetLenderShareReportsDocumentGQLType, options);
        }
export type GetLenderShareReportsQueryHookResult = ReturnType<typeof useGetLenderShareReportsQuery>;
export type GetLenderShareReportsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLenderShareReportsLazyQueryGQLType>;
export type GetLenderShareReportsQueryResultGQLType = Apollo.QueryResult<GetLenderShareReportsQueryGQLType, GetLenderShareReportsQueryVariablesGQLType>;
export const GetLenderShareReportsForLoanDocumentGQLType = gql`
    query GetLenderShareReportsForLoan($loanId: UUID!, $fundingRequestId: UUID!) {
  reports: getLenderShareReportsForLoan(
    loanId: $loanId
    fundingRequestId: $fundingRequestId
  ) {
    ...LenderShareReport
  }
}
    ${LenderShareReportFragmentDocGQLType}`;

/**
 * __useGetLenderShareReportsForLoanQuery__
 *
 * To run a query within a React component, call `useGetLenderShareReportsForLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderShareReportsForLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderShareReportsForLoanQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      fundingRequestId: // value for 'fundingRequestId'
 *   },
 * });
 */
export function useGetLenderShareReportsForLoanQuery(baseOptions: Apollo.QueryHookOptions<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>(GetLenderShareReportsForLoanDocumentGQLType, options);
      }
export function useGetLenderShareReportsForLoanLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>(GetLenderShareReportsForLoanDocumentGQLType, options);
        }
export type GetLenderShareReportsForLoanQueryHookResult = ReturnType<typeof useGetLenderShareReportsForLoanQuery>;
export type GetLenderShareReportsForLoanLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLenderShareReportsForLoanLazyQueryGQLType>;
export type GetLenderShareReportsForLoanQueryResultGQLType = Apollo.QueryResult<GetLenderShareReportsForLoanQueryGQLType, GetLenderShareReportsForLoanQueryVariablesGQLType>;
export const GetActiveEditLoanEntitiesForLoanDocumentGQLType = gql`
    query getActiveEditLoanEntitiesForLoan($loanId: UUID!) {
  loanEditData: getActiveEditLoanEntitiesForLoan(loanId: $loanId) {
    ...LoanEditData
  }
}
    ${LoanEditDataFragmentDocGQLType}`;

/**
 * __useGetActiveEditLoanEntitiesForLoanQuery__
 *
 * To run a query within a React component, call `useGetActiveEditLoanEntitiesForLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveEditLoanEntitiesForLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveEditLoanEntitiesForLoanQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetActiveEditLoanEntitiesForLoanQuery(baseOptions: Apollo.QueryHookOptions<GetActiveEditLoanEntitiesForLoanQueryGQLType, GetActiveEditLoanEntitiesForLoanQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveEditLoanEntitiesForLoanQueryGQLType, GetActiveEditLoanEntitiesForLoanQueryVariablesGQLType>(GetActiveEditLoanEntitiesForLoanDocumentGQLType, options);
      }
export function useGetActiveEditLoanEntitiesForLoanLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveEditLoanEntitiesForLoanQueryGQLType, GetActiveEditLoanEntitiesForLoanQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveEditLoanEntitiesForLoanQueryGQLType, GetActiveEditLoanEntitiesForLoanQueryVariablesGQLType>(GetActiveEditLoanEntitiesForLoanDocumentGQLType, options);
        }
export type GetActiveEditLoanEntitiesForLoanQueryHookResult = ReturnType<typeof useGetActiveEditLoanEntitiesForLoanQuery>;
export type GetActiveEditLoanEntitiesForLoanLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActiveEditLoanEntitiesForLoanLazyQueryGQLType>;
export type GetActiveEditLoanEntitiesForLoanQueryResultGQLType = Apollo.QueryResult<GetActiveEditLoanEntitiesForLoanQueryGQLType, GetActiveEditLoanEntitiesForLoanQueryVariablesGQLType>;
export const GetEarliestOriginationDateForLoansDocumentGQLType = gql`
    query getEarliestOriginationDateForLoans($creditFacilityId: UUID!, $loanIds: [UUID!]!) {
  earliestOriginationDate: getEarliestOriginationDateForLoans(
    creditFacilityId: $creditFacilityId
    loanIds: $loanIds
  )
}
    `;

/**
 * __useGetEarliestOriginationDateForLoansQuery__
 *
 * To run a query within a React component, call `useGetEarliestOriginationDateForLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestOriginationDateForLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestOriginationDateForLoansQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      loanIds: // value for 'loanIds'
 *   },
 * });
 */
export function useGetEarliestOriginationDateForLoansQuery(baseOptions: Apollo.QueryHookOptions<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>(GetEarliestOriginationDateForLoansDocumentGQLType, options);
      }
export function useGetEarliestOriginationDateForLoansLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>(GetEarliestOriginationDateForLoansDocumentGQLType, options);
        }
export type GetEarliestOriginationDateForLoansQueryHookResult = ReturnType<typeof useGetEarliestOriginationDateForLoansQuery>;
export type GetEarliestOriginationDateForLoansLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEarliestOriginationDateForLoansLazyQueryGQLType>;
export type GetEarliestOriginationDateForLoansQueryResultGQLType = Apollo.QueryResult<GetEarliestOriginationDateForLoansQueryGQLType, GetEarliestOriginationDateForLoansQueryVariablesGQLType>;
export const GetBatchSettlementsForCreditFacilityDocumentGQLType = gql`
    query getBatchSettlementsForCreditFacility($creditFacilityId: UUID!, $lenderIds: [UUID!], $loanIds: [UUID!]) {
  settlements: getBatchSettlementsForCreditFacility(
    creditFacilityId: $creditFacilityId
    lenderIds: $lenderIds
    loanIds: $loanIds
  ) {
    ...BatchSettlement
  }
}
    ${BatchSettlementFragmentDocGQLType}`;

/**
 * __useGetBatchSettlementsForCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetBatchSettlementsForCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchSettlementsForCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchSettlementsForCreditFacilityQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      lenderIds: // value for 'lenderIds'
 *      loanIds: // value for 'loanIds'
 *   },
 * });
 */
export function useGetBatchSettlementsForCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>(GetBatchSettlementsForCreditFacilityDocumentGQLType, options);
      }
export function useGetBatchSettlementsForCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>(GetBatchSettlementsForCreditFacilityDocumentGQLType, options);
        }
export type GetBatchSettlementsForCreditFacilityQueryHookResult = ReturnType<typeof useGetBatchSettlementsForCreditFacilityQuery>;
export type GetBatchSettlementsForCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBatchSettlementsForCreditFacilityLazyQueryGQLType>;
export type GetBatchSettlementsForCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetBatchSettlementsForCreditFacilityQueryGQLType, GetBatchSettlementsForCreditFacilityQueryVariablesGQLType>;
export const MarkLenderShareComponentFundTransferDateDocumentGQLType = gql`
    mutation MarkLenderShareComponentFundTransferDate($lenderShareId: UUID!, $fundingRequestComponentId: UUID!, $fundTransferDate: FullDateStr) {
  markLenderShareComponentFundTransferDate(
    lenderShareId: $lenderShareId
    fundingRequestComponentId: $fundingRequestComponentId
    fundTransferDate: $fundTransferDate
  )
}
    `;
export type MarkLenderShareComponentFundTransferDateMutationFnGQLType = Apollo.MutationFunction<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>;

/**
 * __useMarkLenderShareComponentFundTransferDateMutation__
 *
 * To run a mutation, you first call `useMarkLenderShareComponentFundTransferDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkLenderShareComponentFundTransferDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markLenderShareComponentFundTransferDateMutation, { data, loading, error }] = useMarkLenderShareComponentFundTransferDateMutation({
 *   variables: {
 *      lenderShareId: // value for 'lenderShareId'
 *      fundingRequestComponentId: // value for 'fundingRequestComponentId'
 *      fundTransferDate: // value for 'fundTransferDate'
 *   },
 * });
 */
export function useMarkLenderShareComponentFundTransferDateMutation(baseOptions?: Apollo.MutationHookOptions<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>(MarkLenderShareComponentFundTransferDateDocumentGQLType, options);
      }
export type MarkLenderShareComponentFundTransferDateMutationHookResult = ReturnType<typeof useMarkLenderShareComponentFundTransferDateMutation>;
export type MarkLenderShareComponentFundTransferDateMutationResultGQLType = Apollo.MutationResult<MarkLenderShareComponentFundTransferDateMutationGQLType>;
export type MarkLenderShareComponentFundTransferDateMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkLenderShareComponentFundTransferDateMutationGQLType, MarkLenderShareComponentFundTransferDateMutationVariablesGQLType>;
export const SubmitLoanEditRequestDocumentGQLType = gql`
    mutation submitLoanEditRequest($creditFacilityId: UUID!, $originalLoanId: UUID!, $proposedUserId: UUID!, $loanAttributes: EditLoanAttributes!, $fundingRequestChangesets: [EditFundingRequestChangeset!]!) {
  submitLoanEditRequest(
    creditFacilityId: $creditFacilityId
    originalLoanId: $originalLoanId
    proposedUserId: $proposedUserId
    loanAttributes: $loanAttributes
    fundingRequestChangesets: $fundingRequestChangesets
  )
}
    `;
export type SubmitLoanEditRequestMutationFnGQLType = Apollo.MutationFunction<SubmitLoanEditRequestMutationGQLType, SubmitLoanEditRequestMutationVariablesGQLType>;

/**
 * __useSubmitLoanEditRequestMutation__
 *
 * To run a mutation, you first call `useSubmitLoanEditRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLoanEditRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLoanEditRequestMutation, { data, loading, error }] = useSubmitLoanEditRequestMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      originalLoanId: // value for 'originalLoanId'
 *      proposedUserId: // value for 'proposedUserId'
 *      loanAttributes: // value for 'loanAttributes'
 *      fundingRequestChangesets: // value for 'fundingRequestChangesets'
 *   },
 * });
 */
export function useSubmitLoanEditRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLoanEditRequestMutationGQLType, SubmitLoanEditRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLoanEditRequestMutationGQLType, SubmitLoanEditRequestMutationVariablesGQLType>(SubmitLoanEditRequestDocumentGQLType, options);
      }
export type SubmitLoanEditRequestMutationHookResult = ReturnType<typeof useSubmitLoanEditRequestMutation>;
export type SubmitLoanEditRequestMutationResultGQLType = Apollo.MutationResult<SubmitLoanEditRequestMutationGQLType>;
export type SubmitLoanEditRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<SubmitLoanEditRequestMutationGQLType, SubmitLoanEditRequestMutationVariablesGQLType>;
export const CancelLoanEditDocumentGQLType = gql`
    mutation cancelLoanEdit($loanActionId: UUID!) {
  cancelLoanEdit(loanActionId: $loanActionId)
}
    `;
export type CancelLoanEditMutationFnGQLType = Apollo.MutationFunction<CancelLoanEditMutationGQLType, CancelLoanEditMutationVariablesGQLType>;

/**
 * __useCancelLoanEditMutation__
 *
 * To run a mutation, you first call `useCancelLoanEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLoanEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLoanEditMutation, { data, loading, error }] = useCancelLoanEditMutation({
 *   variables: {
 *      loanActionId: // value for 'loanActionId'
 *   },
 * });
 */
export function useCancelLoanEditMutation(baseOptions?: Apollo.MutationHookOptions<CancelLoanEditMutationGQLType, CancelLoanEditMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLoanEditMutationGQLType, CancelLoanEditMutationVariablesGQLType>(CancelLoanEditDocumentGQLType, options);
      }
export type CancelLoanEditMutationHookResult = ReturnType<typeof useCancelLoanEditMutation>;
export type CancelLoanEditMutationResultGQLType = Apollo.MutationResult<CancelLoanEditMutationGQLType>;
export type CancelLoanEditMutationOptionsGQLType = Apollo.BaseMutationOptions<CancelLoanEditMutationGQLType, CancelLoanEditMutationVariablesGQLType>;
export const ApproveAndExecuteLoanEditDocumentGQLType = gql`
    mutation approveAndExecuteLoanEdit($originalLoanId: UUID!, $newLoanId: UUID!, $loanActionId: UUID!, $approvedUserId: UUID!) {
  approveAndExecuteLoanEdit(
    originalLoanId: $originalLoanId
    newLoanId: $newLoanId
    loanActionId: $loanActionId
    approvedUserId: $approvedUserId
  )
}
    `;
export type ApproveAndExecuteLoanEditMutationFnGQLType = Apollo.MutationFunction<ApproveAndExecuteLoanEditMutationGQLType, ApproveAndExecuteLoanEditMutationVariablesGQLType>;

/**
 * __useApproveAndExecuteLoanEditMutation__
 *
 * To run a mutation, you first call `useApproveAndExecuteLoanEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAndExecuteLoanEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAndExecuteLoanEditMutation, { data, loading, error }] = useApproveAndExecuteLoanEditMutation({
 *   variables: {
 *      originalLoanId: // value for 'originalLoanId'
 *      newLoanId: // value for 'newLoanId'
 *      loanActionId: // value for 'loanActionId'
 *      approvedUserId: // value for 'approvedUserId'
 *   },
 * });
 */
export function useApproveAndExecuteLoanEditMutation(baseOptions?: Apollo.MutationHookOptions<ApproveAndExecuteLoanEditMutationGQLType, ApproveAndExecuteLoanEditMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveAndExecuteLoanEditMutationGQLType, ApproveAndExecuteLoanEditMutationVariablesGQLType>(ApproveAndExecuteLoanEditDocumentGQLType, options);
      }
export type ApproveAndExecuteLoanEditMutationHookResult = ReturnType<typeof useApproveAndExecuteLoanEditMutation>;
export type ApproveAndExecuteLoanEditMutationResultGQLType = Apollo.MutationResult<ApproveAndExecuteLoanEditMutationGQLType>;
export type ApproveAndExecuteLoanEditMutationOptionsGQLType = Apollo.BaseMutationOptions<ApproveAndExecuteLoanEditMutationGQLType, ApproveAndExecuteLoanEditMutationVariablesGQLType>;
export const UpdateLoanExternalLoanIdDocumentGQLType = gql`
    mutation updateLoanExternalLoanId($loanId: UUID!, $newExternalLoanId: String) {
  updateLoanExternalLoanId(loanId: $loanId, newExternalLoanId: $newExternalLoanId) {
    ...LoanRecord
  }
}
    ${LoanRecordFragmentDocGQLType}`;
export type UpdateLoanExternalLoanIdMutationFnGQLType = Apollo.MutationFunction<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>;

/**
 * __useUpdateLoanExternalLoanIdMutation__
 *
 * To run a mutation, you first call `useUpdateLoanExternalLoanIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanExternalLoanIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanExternalLoanIdMutation, { data, loading, error }] = useUpdateLoanExternalLoanIdMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      newExternalLoanId: // value for 'newExternalLoanId'
 *   },
 * });
 */
export function useUpdateLoanExternalLoanIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>(UpdateLoanExternalLoanIdDocumentGQLType, options);
      }
export type UpdateLoanExternalLoanIdMutationHookResult = ReturnType<typeof useUpdateLoanExternalLoanIdMutation>;
export type UpdateLoanExternalLoanIdMutationResultGQLType = Apollo.MutationResult<UpdateLoanExternalLoanIdMutationGQLType>;
export type UpdateLoanExternalLoanIdMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateLoanExternalLoanIdMutationGQLType, UpdateLoanExternalLoanIdMutationVariablesGQLType>;
export const CreateBatchSettlementDocumentGQLType = gql`
    mutation createBatchSettlement($creditFacilityId: UUID!, $lenderIds: [UUID!]!, $loanIds: [UUID!]!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  createBatchSettlement(
    creditFacilityId: $creditFacilityId
    lenderIds: $lenderIds
    loanIds: $loanIds
    startDate: $startDate
    endDate: $endDate
  ) {
    batchSettlementId
    workleaseId
  }
}
    `;
export type CreateBatchSettlementMutationFnGQLType = Apollo.MutationFunction<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>;

/**
 * __useCreateBatchSettlementMutation__
 *
 * To run a mutation, you first call `useCreateBatchSettlementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchSettlementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBatchSettlementMutation, { data, loading, error }] = useCreateBatchSettlementMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      lenderIds: // value for 'lenderIds'
 *      loanIds: // value for 'loanIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateBatchSettlementMutation(baseOptions?: Apollo.MutationHookOptions<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>(CreateBatchSettlementDocumentGQLType, options);
      }
export type CreateBatchSettlementMutationHookResult = ReturnType<typeof useCreateBatchSettlementMutation>;
export type CreateBatchSettlementMutationResultGQLType = Apollo.MutationResult<CreateBatchSettlementMutationGQLType>;
export type CreateBatchSettlementMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateBatchSettlementMutationGQLType, CreateBatchSettlementMutationVariablesGQLType>;
export const GetLocalizedLabelsDocumentGQLType = gql`
    query GetLocalizedLabels($scope: String!) {
  getLocalizedLabels(scope: $scope) {
    scope
    labels {
      labelKey
      localizedValue
    }
  }
}
    `;

/**
 * __useGetLocalizedLabelsQuery__
 *
 * To run a query within a React component, call `useGetLocalizedLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizedLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizedLabelsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetLocalizedLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>(GetLocalizedLabelsDocumentGQLType, options);
      }
export function useGetLocalizedLabelsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>(GetLocalizedLabelsDocumentGQLType, options);
        }
export type GetLocalizedLabelsQueryHookResult = ReturnType<typeof useGetLocalizedLabelsQuery>;
export type GetLocalizedLabelsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLocalizedLabelsLazyQueryGQLType>;
export type GetLocalizedLabelsQueryResultGQLType = Apollo.QueryResult<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>;
export const GetRequiredDataTapesDocumentGQLType = gql`
    query getRequiredDataTapes($organizationId: UUID!, $omitOrgProvidedInputGraphs: Boolean!, $reportingDate: FullDateStr) {
  getRequiredDataTapes(
    organizationId: $organizationId
    reportingDate: $reportingDate
    omitOrgProvidedInputGraphs: $omitOrgProvidedInputGraphs
  ) {
    requiredDataTapesGroupings {
      latestReportingDate
      requiredDataTapes {
        ...RequiredDataTape
      }
      requiredXlsxTapes {
        ...RequiredXlsxTape
      }
      requiredCashBalances {
        externalFilename
        creditFacilityId
        artifactType
        artifactSlug
        artifactId
        currentFileVersion
        currentReportingDate
        columns {
          name
          required
          type
          description
          examples
          defaultValue
        }
        accountTypesWithConnectionProvider
      }
    }
  }
}
    ${RequiredDataTapeFragmentDocGQLType}
${RequiredXlsxTapeFragmentDocGQLType}`;

/**
 * __useGetRequiredDataTapesQuery__
 *
 * To run a query within a React component, call `useGetRequiredDataTapesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredDataTapesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredDataTapesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      omitOrgProvidedInputGraphs: // value for 'omitOrgProvidedInputGraphs'
 *      reportingDate: // value for 'reportingDate'
 *   },
 * });
 */
export function useGetRequiredDataTapesQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>(GetRequiredDataTapesDocumentGQLType, options);
      }
export function useGetRequiredDataTapesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>(GetRequiredDataTapesDocumentGQLType, options);
        }
export type GetRequiredDataTapesQueryHookResult = ReturnType<typeof useGetRequiredDataTapesQuery>;
export type GetRequiredDataTapesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRequiredDataTapesLazyQueryGQLType>;
export type GetRequiredDataTapesQueryResultGQLType = Apollo.QueryResult<GetRequiredDataTapesQueryGQLType, GetRequiredDataTapesQueryVariablesGQLType>;
export const GetRequiredDataTapesForVerificationDocumentGQLType = gql`
    query getRequiredDataTapesForVerification($creditFacilityId: UUID!) {
  getRequiredDataTapesForVerification(creditFacilityId: $creditFacilityId) {
    requiredDataTapesGroupings {
      latestReportingDate
      requiredDataTapes {
        ...RequiredDataTape
      }
      requiredXlsxTapes {
        ...RequiredXlsxTape
      }
    }
  }
}
    ${RequiredDataTapeFragmentDocGQLType}
${RequiredXlsxTapeFragmentDocGQLType}`;

/**
 * __useGetRequiredDataTapesForVerificationQuery__
 *
 * To run a query within a React component, call `useGetRequiredDataTapesForVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredDataTapesForVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredDataTapesForVerificationQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetRequiredDataTapesForVerificationQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>(GetRequiredDataTapesForVerificationDocumentGQLType, options);
      }
export function useGetRequiredDataTapesForVerificationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>(GetRequiredDataTapesForVerificationDocumentGQLType, options);
        }
export type GetRequiredDataTapesForVerificationQueryHookResult = ReturnType<typeof useGetRequiredDataTapesForVerificationQuery>;
export type GetRequiredDataTapesForVerificationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRequiredDataTapesForVerificationLazyQueryGQLType>;
export type GetRequiredDataTapesForVerificationQueryResultGQLType = Apollo.QueryResult<GetRequiredDataTapesForVerificationQueryGQLType, GetRequiredDataTapesForVerificationQueryVariablesGQLType>;
export const GetUserWithEmailSubscriptionsDocumentGQLType = gql`
    query GetUserWithEmailSubscriptions {
  user {
    ...UserWithEmailSubscriptions
  }
}
    ${UserWithEmailSubscriptionsFragmentDocGQLType}`;

/**
 * __useGetUserWithEmailSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetUserWithEmailSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithEmailSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithEmailSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWithEmailSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWithEmailSubscriptionsQueryGQLType, GetUserWithEmailSubscriptionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithEmailSubscriptionsQueryGQLType, GetUserWithEmailSubscriptionsQueryVariablesGQLType>(GetUserWithEmailSubscriptionsDocumentGQLType, options);
      }
export function useGetUserWithEmailSubscriptionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithEmailSubscriptionsQueryGQLType, GetUserWithEmailSubscriptionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithEmailSubscriptionsQueryGQLType, GetUserWithEmailSubscriptionsQueryVariablesGQLType>(GetUserWithEmailSubscriptionsDocumentGQLType, options);
        }
export type GetUserWithEmailSubscriptionsQueryHookResult = ReturnType<typeof useGetUserWithEmailSubscriptionsQuery>;
export type GetUserWithEmailSubscriptionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUserWithEmailSubscriptionsLazyQueryGQLType>;
export type GetUserWithEmailSubscriptionsQueryResultGQLType = Apollo.QueryResult<GetUserWithEmailSubscriptionsQueryGQLType, GetUserWithEmailSubscriptionsQueryVariablesGQLType>;
export const GetOrgProvidedInputsByOrgIdDocumentGQLType = gql`
    query GetOrgProvidedInputsByOrgId($organizationId: UUID!) {
  getOrgProvidedInputsByOrgId(organizationId: $organizationId) {
    ...OrgProvidedInputFrag
  }
}
    ${OrgProvidedInputFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedInputsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedInputsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedInputsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedInputsByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrgProvidedInputsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedInputsByOrgIdQueryGQLType, GetOrgProvidedInputsByOrgIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedInputsByOrgIdQueryGQLType, GetOrgProvidedInputsByOrgIdQueryVariablesGQLType>(GetOrgProvidedInputsByOrgIdDocumentGQLType, options);
      }
export function useGetOrgProvidedInputsByOrgIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedInputsByOrgIdQueryGQLType, GetOrgProvidedInputsByOrgIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedInputsByOrgIdQueryGQLType, GetOrgProvidedInputsByOrgIdQueryVariablesGQLType>(GetOrgProvidedInputsByOrgIdDocumentGQLType, options);
        }
export type GetOrgProvidedInputsByOrgIdQueryHookResult = ReturnType<typeof useGetOrgProvidedInputsByOrgIdQuery>;
export type GetOrgProvidedInputsByOrgIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedInputsByOrgIdLazyQueryGQLType>;
export type GetOrgProvidedInputsByOrgIdQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedInputsByOrgIdQueryGQLType, GetOrgProvidedInputsByOrgIdQueryVariablesGQLType>;
export const GetOrgProvidedInputByIdDocumentGQLType = gql`
    query GetOrgProvidedInputById($orgProvidedInputId: UUID!) {
  getOrgProvidedInputById(orgProvidedInputId: $orgProvidedInputId) {
    ...OrgProvidedInputFrag
  }
}
    ${OrgProvidedInputFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedInputByIdQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedInputByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedInputByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedInputByIdQuery({
 *   variables: {
 *      orgProvidedInputId: // value for 'orgProvidedInputId'
 *   },
 * });
 */
export function useGetOrgProvidedInputByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedInputByIdQueryGQLType, GetOrgProvidedInputByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedInputByIdQueryGQLType, GetOrgProvidedInputByIdQueryVariablesGQLType>(GetOrgProvidedInputByIdDocumentGQLType, options);
      }
export function useGetOrgProvidedInputByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedInputByIdQueryGQLType, GetOrgProvidedInputByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedInputByIdQueryGQLType, GetOrgProvidedInputByIdQueryVariablesGQLType>(GetOrgProvidedInputByIdDocumentGQLType, options);
        }
export type GetOrgProvidedInputByIdQueryHookResult = ReturnType<typeof useGetOrgProvidedInputByIdQuery>;
export type GetOrgProvidedInputByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedInputByIdLazyQueryGQLType>;
export type GetOrgProvidedInputByIdQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedInputByIdQueryGQLType, GetOrgProvidedInputByIdQueryVariablesGQLType>;
export const GetOrgProvidedInputByKeyDocumentGQLType = gql`
    query GetOrgProvidedInputByKey($organizationId: UUID!, $key: String!) {
  getOrgProvidedInputByKey(organizationId: $organizationId, key: $key) {
    ...OrgProvidedInputFrag
  }
}
    ${OrgProvidedInputFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedInputByKeyQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedInputByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedInputByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedInputByKeyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetOrgProvidedInputByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedInputByKeyQueryGQLType, GetOrgProvidedInputByKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedInputByKeyQueryGQLType, GetOrgProvidedInputByKeyQueryVariablesGQLType>(GetOrgProvidedInputByKeyDocumentGQLType, options);
      }
export function useGetOrgProvidedInputByKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedInputByKeyQueryGQLType, GetOrgProvidedInputByKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedInputByKeyQueryGQLType, GetOrgProvidedInputByKeyQueryVariablesGQLType>(GetOrgProvidedInputByKeyDocumentGQLType, options);
        }
export type GetOrgProvidedInputByKeyQueryHookResult = ReturnType<typeof useGetOrgProvidedInputByKeyQuery>;
export type GetOrgProvidedInputByKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedInputByKeyLazyQueryGQLType>;
export type GetOrgProvidedInputByKeyQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedInputByKeyQueryGQLType, GetOrgProvidedInputByKeyQueryVariablesGQLType>;
export const GetOrgProvidedValueByIdDocumentGQLType = gql`
    query GetOrgProvidedValueById($orgProvidedValueId: UUID!) {
  getOrgProvidedValueById(orgProvidedValueId: $orgProvidedValueId) {
    ...OrgProvidedValueFrag
  }
}
    ${OrgProvidedValueFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedValueByIdQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedValueByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedValueByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedValueByIdQuery({
 *   variables: {
 *      orgProvidedValueId: // value for 'orgProvidedValueId'
 *   },
 * });
 */
export function useGetOrgProvidedValueByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedValueByIdQueryGQLType, GetOrgProvidedValueByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedValueByIdQueryGQLType, GetOrgProvidedValueByIdQueryVariablesGQLType>(GetOrgProvidedValueByIdDocumentGQLType, options);
      }
export function useGetOrgProvidedValueByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedValueByIdQueryGQLType, GetOrgProvidedValueByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedValueByIdQueryGQLType, GetOrgProvidedValueByIdQueryVariablesGQLType>(GetOrgProvidedValueByIdDocumentGQLType, options);
        }
export type GetOrgProvidedValueByIdQueryHookResult = ReturnType<typeof useGetOrgProvidedValueByIdQuery>;
export type GetOrgProvidedValueByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedValueByIdLazyQueryGQLType>;
export type GetOrgProvidedValueByIdQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedValueByIdQueryGQLType, GetOrgProvidedValueByIdQueryVariablesGQLType>;
export const GetOrgProvidedValuesByKeyDocumentGQLType = gql`
    query GetOrgProvidedValuesByKey($organizationId: UUID!, $key: String!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  getOrgProvidedValuesByKey(
    organizationId: $organizationId
    key: $key
    startDate: $startDate
    endDate: $endDate
  ) {
    ...OrgProvidedValueFrag
  }
}
    ${OrgProvidedValueFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedValuesByKeyQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedValuesByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedValuesByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedValuesByKeyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOrgProvidedValuesByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedValuesByKeyQueryGQLType, GetOrgProvidedValuesByKeyQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedValuesByKeyQueryGQLType, GetOrgProvidedValuesByKeyQueryVariablesGQLType>(GetOrgProvidedValuesByKeyDocumentGQLType, options);
      }
export function useGetOrgProvidedValuesByKeyLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedValuesByKeyQueryGQLType, GetOrgProvidedValuesByKeyQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedValuesByKeyQueryGQLType, GetOrgProvidedValuesByKeyQueryVariablesGQLType>(GetOrgProvidedValuesByKeyDocumentGQLType, options);
        }
export type GetOrgProvidedValuesByKeyQueryHookResult = ReturnType<typeof useGetOrgProvidedValuesByKeyQuery>;
export type GetOrgProvidedValuesByKeyLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedValuesByKeyLazyQueryGQLType>;
export type GetOrgProvidedValuesByKeyQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedValuesByKeyQueryGQLType, GetOrgProvidedValuesByKeyQueryVariablesGQLType>;
export const GetOrgProvidedValuesByKeysDocumentGQLType = gql`
    query GetOrgProvidedValuesByKeys($organizationId: UUID!, $keys: [String!]!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  getOrgProvidedValuesByKeys(
    organizationId: $organizationId
    keys: $keys
    startDate: $startDate
    endDate: $endDate
  ) {
    ...OrgProvidedValueFrag
  }
}
    ${OrgProvidedValueFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedValuesByKeysQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedValuesByKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedValuesByKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedValuesByKeysQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      keys: // value for 'keys'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetOrgProvidedValuesByKeysQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedValuesByKeysQueryGQLType, GetOrgProvidedValuesByKeysQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedValuesByKeysQueryGQLType, GetOrgProvidedValuesByKeysQueryVariablesGQLType>(GetOrgProvidedValuesByKeysDocumentGQLType, options);
      }
export function useGetOrgProvidedValuesByKeysLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedValuesByKeysQueryGQLType, GetOrgProvidedValuesByKeysQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedValuesByKeysQueryGQLType, GetOrgProvidedValuesByKeysQueryVariablesGQLType>(GetOrgProvidedValuesByKeysDocumentGQLType, options);
        }
export type GetOrgProvidedValuesByKeysQueryHookResult = ReturnType<typeof useGetOrgProvidedValuesByKeysQuery>;
export type GetOrgProvidedValuesByKeysLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedValuesByKeysLazyQueryGQLType>;
export type GetOrgProvidedValuesByKeysQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedValuesByKeysQueryGQLType, GetOrgProvidedValuesByKeysQueryVariablesGQLType>;
export const GetOrgProvidedValueByReportingPeriodDocumentGQLType = gql`
    query GetOrgProvidedValueByReportingPeriod($organizationId: UUID!, $key: String!, $reportingDate: FullDateStr!, $reportingPeriod: String!) {
  getOrgProvidedValueByReportingPeriod(
    organizationId: $organizationId
    key: $key
    reportingDate: $reportingDate
    reportingPeriod: $reportingPeriod
  ) {
    ...OrgProvidedValueFrag
  }
}
    ${OrgProvidedValueFragFragmentDocGQLType}`;

/**
 * __useGetOrgProvidedValueByReportingPeriodQuery__
 *
 * To run a query within a React component, call `useGetOrgProvidedValueByReportingPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgProvidedValueByReportingPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgProvidedValueByReportingPeriodQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *      reportingDate: // value for 'reportingDate'
 *      reportingPeriod: // value for 'reportingPeriod'
 *   },
 * });
 */
export function useGetOrgProvidedValueByReportingPeriodQuery(baseOptions: Apollo.QueryHookOptions<GetOrgProvidedValueByReportingPeriodQueryGQLType, GetOrgProvidedValueByReportingPeriodQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgProvidedValueByReportingPeriodQueryGQLType, GetOrgProvidedValueByReportingPeriodQueryVariablesGQLType>(GetOrgProvidedValueByReportingPeriodDocumentGQLType, options);
      }
export function useGetOrgProvidedValueByReportingPeriodLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgProvidedValueByReportingPeriodQueryGQLType, GetOrgProvidedValueByReportingPeriodQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgProvidedValueByReportingPeriodQueryGQLType, GetOrgProvidedValueByReportingPeriodQueryVariablesGQLType>(GetOrgProvidedValueByReportingPeriodDocumentGQLType, options);
        }
export type GetOrgProvidedValueByReportingPeriodQueryHookResult = ReturnType<typeof useGetOrgProvidedValueByReportingPeriodQuery>;
export type GetOrgProvidedValueByReportingPeriodLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrgProvidedValueByReportingPeriodLazyQueryGQLType>;
export type GetOrgProvidedValueByReportingPeriodQueryResultGQLType = Apollo.QueryResult<GetOrgProvidedValueByReportingPeriodQueryGQLType, GetOrgProvidedValueByReportingPeriodQueryVariablesGQLType>;
export const CreateOrgProvidedInputDocumentGQLType = gql`
    mutation CreateOrgProvidedInput($organizationId: UUID!, $key: String!, $type: OrgProvidedInputType!, $nullable: Boolean!) {
  createOrgProvidedInput(
    organizationId: $organizationId
    key: $key
    type: $type
    nullable: $nullable
  ) {
    ...OrgProvidedInputFrag
  }
}
    ${OrgProvidedInputFragFragmentDocGQLType}`;
export type CreateOrgProvidedInputMutationFnGQLType = Apollo.MutationFunction<CreateOrgProvidedInputMutationGQLType, CreateOrgProvidedInputMutationVariablesGQLType>;

/**
 * __useCreateOrgProvidedInputMutation__
 *
 * To run a mutation, you first call `useCreateOrgProvidedInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgProvidedInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgProvidedInputMutation, { data, loading, error }] = useCreateOrgProvidedInputMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *      type: // value for 'type'
 *      nullable: // value for 'nullable'
 *   },
 * });
 */
export function useCreateOrgProvidedInputMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrgProvidedInputMutationGQLType, CreateOrgProvidedInputMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrgProvidedInputMutationGQLType, CreateOrgProvidedInputMutationVariablesGQLType>(CreateOrgProvidedInputDocumentGQLType, options);
      }
export type CreateOrgProvidedInputMutationHookResult = ReturnType<typeof useCreateOrgProvidedInputMutation>;
export type CreateOrgProvidedInputMutationResultGQLType = Apollo.MutationResult<CreateOrgProvidedInputMutationGQLType>;
export type CreateOrgProvidedInputMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrgProvidedInputMutationGQLType, CreateOrgProvidedInputMutationVariablesGQLType>;
export const CreateOrgProvidedValueDocumentGQLType = gql`
    mutation CreateOrgProvidedValue($orgProvidedInputId: UUID!, $value: Primitive, $reportingDate: FullDateStr!, $supplementalS3Path: String) {
  createOrgProvidedValue(
    orgProvidedInputId: $orgProvidedInputId
    value: $value
    reportingDate: $reportingDate
    supplementalS3Path: $supplementalS3Path
  ) {
    ...OrgProvidedValueFrag
  }
}
    ${OrgProvidedValueFragFragmentDocGQLType}`;
export type CreateOrgProvidedValueMutationFnGQLType = Apollo.MutationFunction<CreateOrgProvidedValueMutationGQLType, CreateOrgProvidedValueMutationVariablesGQLType>;

/**
 * __useCreateOrgProvidedValueMutation__
 *
 * To run a mutation, you first call `useCreateOrgProvidedValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgProvidedValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgProvidedValueMutation, { data, loading, error }] = useCreateOrgProvidedValueMutation({
 *   variables: {
 *      orgProvidedInputId: // value for 'orgProvidedInputId'
 *      value: // value for 'value'
 *      reportingDate: // value for 'reportingDate'
 *      supplementalS3Path: // value for 'supplementalS3Path'
 *   },
 * });
 */
export function useCreateOrgProvidedValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrgProvidedValueMutationGQLType, CreateOrgProvidedValueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrgProvidedValueMutationGQLType, CreateOrgProvidedValueMutationVariablesGQLType>(CreateOrgProvidedValueDocumentGQLType, options);
      }
export type CreateOrgProvidedValueMutationHookResult = ReturnType<typeof useCreateOrgProvidedValueMutation>;
export type CreateOrgProvidedValueMutationResultGQLType = Apollo.MutationResult<CreateOrgProvidedValueMutationGQLType>;
export type CreateOrgProvidedValueMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrgProvidedValueMutationGQLType, CreateOrgProvidedValueMutationVariablesGQLType>;
export const GetOrganizationDocumentGQLType = gql`
    query getOrganization($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    name
    type
    users {
      id
      firstName
      lastName
      email
      roleType
    }
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>(GetOrganizationDocumentGQLType, options);
      }
export function useGetOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>(GetOrganizationDocumentGQLType, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLazyQueryGQLType>;
export type GetOrganizationQueryResultGQLType = Apollo.QueryResult<GetOrganizationQueryGQLType, GetOrganizationQueryVariablesGQLType>;
export const GetOrganizationActiveCreditFacilitiesDocumentGQLType = gql`
    query getOrganizationActiveCreditFacilities($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    name
    type
    creditFacilities {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationActiveCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationActiveCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationActiveCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationActiveCreditFacilitiesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationActiveCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>(GetOrganizationActiveCreditFacilitiesDocumentGQLType, options);
      }
export function useGetOrganizationActiveCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>(GetOrganizationActiveCreditFacilitiesDocumentGQLType, options);
        }
export type GetOrganizationActiveCreditFacilitiesQueryHookResult = ReturnType<typeof useGetOrganizationActiveCreditFacilitiesQuery>;
export type GetOrganizationActiveCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationActiveCreditFacilitiesLazyQueryGQLType>;
export type GetOrganizationActiveCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetOrganizationActiveCreditFacilitiesQueryGQLType, GetOrganizationActiveCreditFacilitiesQueryVariablesGQLType>;
export const GetOrganizationsByIdsDocumentGQLType = gql`
    query getOrganizationsByIds($organizationIds: [UUID!]!) {
  organizationsByIds(organizationIds: $organizationIds) {
    id
    slug
    name
    type
  }
}
    `;

/**
 * __useGetOrganizationsByIdsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsByIdsQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useGetOrganizationsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>(GetOrganizationsByIdsDocumentGQLType, options);
      }
export function useGetOrganizationsByIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>(GetOrganizationsByIdsDocumentGQLType, options);
        }
export type GetOrganizationsByIdsQueryHookResult = ReturnType<typeof useGetOrganizationsByIdsQuery>;
export type GetOrganizationsByIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationsByIdsLazyQueryGQLType>;
export type GetOrganizationsByIdsQueryResultGQLType = Apollo.QueryResult<GetOrganizationsByIdsQueryGQLType, GetOrganizationsByIdsQueryVariablesGQLType>;
export const GetOrganizationsByIdsWithUsersDocumentGQLType = gql`
    query getOrganizationsByIdsWithUsers($organizationIds: [UUID!]!) {
  organizationsByIds(organizationIds: $organizationIds) {
    id
    slug
    name
    type
    users {
      id
      firstName
      lastName
      email
      roleType
    }
  }
}
    `;

/**
 * __useGetOrganizationsByIdsWithUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsByIdsWithUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsByIdsWithUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsByIdsWithUsersQuery({
 *   variables: {
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useGetOrganizationsByIdsWithUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>(GetOrganizationsByIdsWithUsersDocumentGQLType, options);
      }
export function useGetOrganizationsByIdsWithUsersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>(GetOrganizationsByIdsWithUsersDocumentGQLType, options);
        }
export type GetOrganizationsByIdsWithUsersQueryHookResult = ReturnType<typeof useGetOrganizationsByIdsWithUsersQuery>;
export type GetOrganizationsByIdsWithUsersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationsByIdsWithUsersLazyQueryGQLType>;
export type GetOrganizationsByIdsWithUsersQueryResultGQLType = Apollo.QueryResult<GetOrganizationsByIdsWithUsersQueryGQLType, GetOrganizationsByIdsWithUsersQueryVariablesGQLType>;
export const GetCapitalProvidersDocumentGQLType = gql`
    query GetCapitalProviders($creditFacilityId: UUID!) {
  capitalProviders(creditFacilityId: $creditFacilityId) {
    id
    name
    type
    slug
  }
}
    `;

/**
 * __useGetCapitalProvidersQuery__
 *
 * To run a query within a React component, call `useGetCapitalProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCapitalProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCapitalProvidersQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCapitalProvidersQuery(baseOptions: Apollo.QueryHookOptions<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>(GetCapitalProvidersDocumentGQLType, options);
      }
export function useGetCapitalProvidersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>(GetCapitalProvidersDocumentGQLType, options);
        }
export type GetCapitalProvidersQueryHookResult = ReturnType<typeof useGetCapitalProvidersQuery>;
export type GetCapitalProvidersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCapitalProvidersLazyQueryGQLType>;
export type GetCapitalProvidersQueryResultGQLType = Apollo.QueryResult<GetCapitalProvidersQueryGQLType, GetCapitalProvidersQueryVariablesGQLType>;
export const GetPartiesByTypeAndCreditFacilityIdsDocumentGQLType = gql`
    query GetPartiesByTypeAndCreditFacilityIds($creditFacilityIds: [UUID!]!, $partyType: PartyType!) {
  partiesByTypeAndCreditFacilityIds(
    creditFacilityIds: $creditFacilityIds
    partyType: $partyType
  ) {
    id
    name
    type
    slug
  }
}
    `;

/**
 * __useGetPartiesByTypeAndCreditFacilityIdsQuery__
 *
 * To run a query within a React component, call `useGetPartiesByTypeAndCreditFacilityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartiesByTypeAndCreditFacilityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartiesByTypeAndCreditFacilityIdsQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      partyType: // value for 'partyType'
 *   },
 * });
 */
export function useGetPartiesByTypeAndCreditFacilityIdsQuery(baseOptions: Apollo.QueryHookOptions<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>(GetPartiesByTypeAndCreditFacilityIdsDocumentGQLType, options);
      }
export function useGetPartiesByTypeAndCreditFacilityIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>(GetPartiesByTypeAndCreditFacilityIdsDocumentGQLType, options);
        }
export type GetPartiesByTypeAndCreditFacilityIdsQueryHookResult = ReturnType<typeof useGetPartiesByTypeAndCreditFacilityIdsQuery>;
export type GetPartiesByTypeAndCreditFacilityIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPartiesByTypeAndCreditFacilityIdsLazyQueryGQLType>;
export type GetPartiesByTypeAndCreditFacilityIdsQueryResultGQLType = Apollo.QueryResult<GetPartiesByTypeAndCreditFacilityIdsQueryGQLType, GetPartiesByTypeAndCreditFacilityIdsQueryVariablesGQLType>;
export const GetOrganizationLoanProductsDocumentGQLType = gql`
    query GetOrganizationLoanProducts($organizationId: UUID!) {
  organization(organizationId: $organizationId) {
    id
    slug
    loanProducts {
      id
      name
      slug
      implementationId
      currentMasterLoanTape {
        id
        fileVersion
        reportingDate
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationLoanProductsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLoanProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLoanProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLoanProductsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationLoanProductsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>(GetOrganizationLoanProductsDocumentGQLType, options);
      }
export function useGetOrganizationLoanProductsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>(GetOrganizationLoanProductsDocumentGQLType, options);
        }
export type GetOrganizationLoanProductsQueryHookResult = ReturnType<typeof useGetOrganizationLoanProductsQuery>;
export type GetOrganizationLoanProductsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLoanProductsLazyQueryGQLType>;
export type GetOrganizationLoanProductsQueryResultGQLType = Apollo.QueryResult<GetOrganizationLoanProductsQueryGQLType, GetOrganizationLoanProductsQueryVariablesGQLType>;
export const GetOrganizationLoanProductsByCreditFacilityDocumentGQLType = gql`
    query GetOrganizationLoanProductsByCreditFacility($organizationId: UUID!) {
  result: organization(organizationId: $organizationId) {
    creditFacilities {
      id
      slug
      name
      loanProducts {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationLoanProductsByCreditFacilityQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLoanProductsByCreditFacilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLoanProductsByCreditFacilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLoanProductsByCreditFacilityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationLoanProductsByCreditFacilityQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>(GetOrganizationLoanProductsByCreditFacilityDocumentGQLType, options);
      }
export function useGetOrganizationLoanProductsByCreditFacilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>(GetOrganizationLoanProductsByCreditFacilityDocumentGQLType, options);
        }
export type GetOrganizationLoanProductsByCreditFacilityQueryHookResult = ReturnType<typeof useGetOrganizationLoanProductsByCreditFacilityQuery>;
export type GetOrganizationLoanProductsByCreditFacilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetOrganizationLoanProductsByCreditFacilityLazyQueryGQLType>;
export type GetOrganizationLoanProductsByCreditFacilityQueryResultGQLType = Apollo.QueryResult<GetOrganizationLoanProductsByCreditFacilityQueryGQLType, GetOrganizationLoanProductsByCreditFacilityQueryVariablesGQLType>;
export const GetAthenaSchemaForOrganizationDocumentGQLType = gql`
    query GetAthenaSchemaForOrganization($organizationId: String!) {
  athenaTables: getAthenaTablesForOrganization(
    organizationId: $organizationId
    tablePrefixes: ["receivable_response_tapes"]
  ) {
    tableName
    properties {
      name
      type
    }
  }
}
    `;

/**
 * __useGetAthenaSchemaForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAthenaSchemaForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAthenaSchemaForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAthenaSchemaForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAthenaSchemaForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>(GetAthenaSchemaForOrganizationDocumentGQLType, options);
      }
export function useGetAthenaSchemaForOrganizationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>(GetAthenaSchemaForOrganizationDocumentGQLType, options);
        }
export type GetAthenaSchemaForOrganizationQueryHookResult = ReturnType<typeof useGetAthenaSchemaForOrganizationQuery>;
export type GetAthenaSchemaForOrganizationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAthenaSchemaForOrganizationLazyQueryGQLType>;
export type GetAthenaSchemaForOrganizationQueryResultGQLType = Apollo.QueryResult<GetAthenaSchemaForOrganizationQueryGQLType, GetAthenaSchemaForOrganizationQueryVariablesGQLType>;
export const CreateUserDocumentGQLType = gql`
    mutation createUser($userData: CreateUser!) {
  createUser(userData: $userData) {
    id
    firstName
    lastName
    email
    roleType
  }
}
    `;
export type CreateUserMutationFnGQLType = Apollo.MutationFunction<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      userData: // value for 'userData'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>(CreateUserDocumentGQLType, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResultGQLType = Apollo.MutationResult<CreateUserMutationGQLType>;
export type CreateUserMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateUserMutationGQLType, CreateUserMutationVariablesGQLType>;
export const RemoveUserDocumentGQLType = gql`
    mutation removeUser($userId: UUID!, $organizationId: UUID!) {
  removeUser(userId: $userId, organizationId: $organizationId)
}
    `;
export type RemoveUserMutationFnGQLType = Apollo.MutationFunction<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>(RemoveUserDocumentGQLType, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResultGQLType = Apollo.MutationResult<RemoveUserMutationGQLType>;
export type RemoveUserMutationOptionsGQLType = Apollo.BaseMutationOptions<RemoveUserMutationGQLType, RemoveUserMutationVariablesGQLType>;
export const UpdateUserDocumentGQLType = gql`
    mutation updateUser($settings: UpdateUserSettings!) {
  updateUserSettingsWithRole(settings: $settings) {
    id
    email
    firstName
    lastName
    roleType
  }
}
    `;
export type UpdateUserMutationFnGQLType = Apollo.MutationFunction<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>(UpdateUserDocumentGQLType, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResultGQLType = Apollo.MutationResult<UpdateUserMutationGQLType>;
export type UpdateUserMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateUserMutationGQLType, UpdateUserMutationVariablesGQLType>;
export const UpdateLoanProductNameDocumentGQLType = gql`
    mutation UpdateLoanProductName($id: UUID!, $newName: String!) {
  updateLoanProductName(id: $id, newName: $newName) {
    name
  }
}
    `;
export type UpdateLoanProductNameMutationFnGQLType = Apollo.MutationFunction<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>;

/**
 * __useUpdateLoanProductNameMutation__
 *
 * To run a mutation, you first call `useUpdateLoanProductNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanProductNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanProductNameMutation, { data, loading, error }] = useUpdateLoanProductNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useUpdateLoanProductNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>(UpdateLoanProductNameDocumentGQLType, options);
      }
export type UpdateLoanProductNameMutationHookResult = ReturnType<typeof useUpdateLoanProductNameMutation>;
export type UpdateLoanProductNameMutationResultGQLType = Apollo.MutationResult<UpdateLoanProductNameMutationGQLType>;
export type UpdateLoanProductNameMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateLoanProductNameMutationGQLType, UpdateLoanProductNameMutationVariablesGQLType>;
export const GetDailyCoreBorrowingBaseInsightsDocumentGQLType = gql`
    query GetDailyCoreBorrowingBaseInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyCoreBorrowingBaseInsights(creditFacilityParams: $creditFacilityParams) {
    ...CoreBorrowingBaseInsights
  }
}
    ${CoreBorrowingBaseInsightsFragmentDocGQLType}`;

/**
 * __useGetDailyCoreBorrowingBaseInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyCoreBorrowingBaseInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyCoreBorrowingBaseInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyCoreBorrowingBaseInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyCoreBorrowingBaseInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>(GetDailyCoreBorrowingBaseInsightsDocumentGQLType, options);
      }
export function useGetDailyCoreBorrowingBaseInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>(GetDailyCoreBorrowingBaseInsightsDocumentGQLType, options);
        }
export type GetDailyCoreBorrowingBaseInsightsQueryHookResult = ReturnType<typeof useGetDailyCoreBorrowingBaseInsightsQuery>;
export type GetDailyCoreBorrowingBaseInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyCoreBorrowingBaseInsightsLazyQueryGQLType>;
export type GetDailyCoreBorrowingBaseInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyCoreBorrowingBaseInsightsQueryGQLType, GetDailyCoreBorrowingBaseInsightsQueryVariablesGQLType>;
export const GetDailyEligibilityInsightsDocumentGQLType = gql`
    query GetDailyEligibilityInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyEligibilityInsights(creditFacilityParams: $creditFacilityParams) {
    reportingDate
    totalEligibleExposure
    totalNetEligibilityKickout
    totalGrossEligibilityKickout
    eligibilityPropertiesData {
      propertyKey
      totalEligibilityKickout
    }
  }
}
    `;

/**
 * __useGetDailyEligibilityInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyEligibilityInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyEligibilityInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyEligibilityInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyEligibilityInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>(GetDailyEligibilityInsightsDocumentGQLType, options);
      }
export function useGetDailyEligibilityInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>(GetDailyEligibilityInsightsDocumentGQLType, options);
        }
export type GetDailyEligibilityInsightsQueryHookResult = ReturnType<typeof useGetDailyEligibilityInsightsQuery>;
export type GetDailyEligibilityInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyEligibilityInsightsLazyQueryGQLType>;
export type GetDailyEligibilityInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyEligibilityInsightsQueryGQLType, GetDailyEligibilityInsightsQueryVariablesGQLType>;
export const GetDailyConcentrationInsightsDocumentGQLType = gql`
    query GetDailyConcentrationInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyConcentrationInsights(creditFacilityParams: $creditFacilityParams) {
    reportingDate
    totalConcentrationLimitKickout
    concentrationLimitsData {
      reportingDate
      propertyKey
      valueType
      concentrationAmount
      concentrationLimit
      concentration
      totalConcentrationLimitKickout
    }
  }
}
    `;

/**
 * __useGetDailyConcentrationInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyConcentrationInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyConcentrationInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyConcentrationInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyConcentrationInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>(GetDailyConcentrationInsightsDocumentGQLType, options);
      }
export function useGetDailyConcentrationInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>(GetDailyConcentrationInsightsDocumentGQLType, options);
        }
export type GetDailyConcentrationInsightsQueryHookResult = ReturnType<typeof useGetDailyConcentrationInsightsQuery>;
export type GetDailyConcentrationInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyConcentrationInsightsLazyQueryGQLType>;
export type GetDailyConcentrationInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyConcentrationInsightsQueryGQLType, GetDailyConcentrationInsightsQueryVariablesGQLType>;
export const GetDailyPreadvanceCollectionsCashBalanceDocumentGQLType = gql`
    query GetDailyPreadvanceCollectionsCashBalance($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getDailyCoreBorrowingBaseInsights(creditFacilityParams: $creditFacilityParams) {
    reportingDate
    totalCollectionsAccountCash
  }
}
    `;

/**
 * __useGetDailyPreadvanceCollectionsCashBalanceQuery__
 *
 * To run a query within a React component, call `useGetDailyPreadvanceCollectionsCashBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyPreadvanceCollectionsCashBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyPreadvanceCollectionsCashBalanceQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetDailyPreadvanceCollectionsCashBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>(GetDailyPreadvanceCollectionsCashBalanceDocumentGQLType, options);
      }
export function useGetDailyPreadvanceCollectionsCashBalanceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>(GetDailyPreadvanceCollectionsCashBalanceDocumentGQLType, options);
        }
export type GetDailyPreadvanceCollectionsCashBalanceQueryHookResult = ReturnType<typeof useGetDailyPreadvanceCollectionsCashBalanceQuery>;
export type GetDailyPreadvanceCollectionsCashBalanceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyPreadvanceCollectionsCashBalanceLazyQueryGQLType>;
export type GetDailyPreadvanceCollectionsCashBalanceQueryResultGQLType = Apollo.QueryResult<GetDailyPreadvanceCollectionsCashBalanceQueryGQLType, GetDailyPreadvanceCollectionsCashBalanceQueryVariablesGQLType>;
export const GetDailyTotalRiskInsightsDocumentGQLType = gql`
    query GetDailyTotalRiskInsights($organizationParams: OrganizationInsightsParamInput!) {
  riskData: getDailyTotalRiskInsights(organizationParams: $organizationParams) {
    borrowingBaseRisk {
      reportingDate
      totalPerformingExposure
      totalEligibleExposureLessConcentrationKickouts
      totalCollectionsAccountCash
      currentPrincipalBalance
      collateralCovenantLtv
      netOutstandingLtv
      performingLtv
      creditFacilityData {
        creditFacilityId
        creditFacilitySlug
        reportingDate
        totalPerformingExposure
        totalEligibleExposureLessConcentrationKickouts
        totalCollectionsAccountCash
        currentPrincipalBalance
        collateralCovenantLtv
        netOutstandingLtv
        performingLtv
      }
    }
    receivableRisk {
      reportingDate
      totalExposure
      totalNormalizedIsChargedOffExposure
      totalNormalizedIsDelinquentExposure
      chargedOffPercentageOfTotalExposure
      delinquentPercentageOfTotalExposure
      creditFacilityData {
        reportingDate
        creditFacilityId
        creditFacilitySlug
        totalExposure
        totalNormalizedIsChargedOffExposure
        totalNormalizedIsDelinquentExposure
        chargedOffPercentageOfTotalExposure
        delinquentPercentageOfTotalExposure
      }
    }
  }
}
    `;

/**
 * __useGetDailyTotalRiskInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyTotalRiskInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyTotalRiskInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyTotalRiskInsightsQuery({
 *   variables: {
 *      organizationParams: // value for 'organizationParams'
 *   },
 * });
 */
export function useGetDailyTotalRiskInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>(GetDailyTotalRiskInsightsDocumentGQLType, options);
      }
export function useGetDailyTotalRiskInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>(GetDailyTotalRiskInsightsDocumentGQLType, options);
        }
export type GetDailyTotalRiskInsightsQueryHookResult = ReturnType<typeof useGetDailyTotalRiskInsightsQuery>;
export type GetDailyTotalRiskInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyTotalRiskInsightsLazyQueryGQLType>;
export type GetDailyTotalRiskInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyTotalRiskInsightsQueryGQLType, GetDailyTotalRiskInsightsQueryVariablesGQLType>;
export const GetDailyReceivableExposureInsightsDocumentGQLType = gql`
    query GetDailyReceivableExposureInsights($organizationParams: OrganizationInsightsParamInput!) {
  getDailyReceivableExposureInsights(organizationParams: $organizationParams) {
    reportingDate
    totalExposure
    totalPerformingExposure
    totalEligibleExposureLessConcentrationKickouts
    totalReceivableBorrowingBase
    creditFacilityData {
      reportingDate
      creditFacilityId
      creditFacilitySlug
      totalExposure
      totalPerformingExposure
      totalEligibleExposureLessConcentrationKickouts
      totalReceivableBorrowingBase
    }
  }
}
    `;

/**
 * __useGetDailyReceivableExposureInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyReceivableExposureInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReceivableExposureInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReceivableExposureInsightsQuery({
 *   variables: {
 *      organizationParams: // value for 'organizationParams'
 *   },
 * });
 */
export function useGetDailyReceivableExposureInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>(GetDailyReceivableExposureInsightsDocumentGQLType, options);
      }
export function useGetDailyReceivableExposureInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>(GetDailyReceivableExposureInsightsDocumentGQLType, options);
        }
export type GetDailyReceivableExposureInsightsQueryHookResult = ReturnType<typeof useGetDailyReceivableExposureInsightsQuery>;
export type GetDailyReceivableExposureInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyReceivableExposureInsightsLazyQueryGQLType>;
export type GetDailyReceivableExposureInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyReceivableExposureInsightsQueryGQLType, GetDailyReceivableExposureInsightsQueryVariablesGQLType>;
export const GetDailyPrincipalInsightsDocumentGQLType = gql`
    query GetDailyPrincipalInsights($organizationParams: OrganizationInsightsParamInput!) {
  getDailyPrincipalInsights(organizationParams: $organizationParams) {
    reportingDate
    currentPrincipalBalance
    commitmentAmount
    totalFacilityUtilization
    creditFacilityData {
      reportingDate
      creditFacilityId
      creditFacilitySlug
      currentPrincipalBalance
      commitmentAmount
      totalFacilityUtilization
    }
  }
}
    `;

/**
 * __useGetDailyPrincipalInsightsQuery__
 *
 * To run a query within a React component, call `useGetDailyPrincipalInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyPrincipalInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyPrincipalInsightsQuery({
 *   variables: {
 *      organizationParams: // value for 'organizationParams'
 *   },
 * });
 */
export function useGetDailyPrincipalInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>(GetDailyPrincipalInsightsDocumentGQLType, options);
      }
export function useGetDailyPrincipalInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>(GetDailyPrincipalInsightsDocumentGQLType, options);
        }
export type GetDailyPrincipalInsightsQueryHookResult = ReturnType<typeof useGetDailyPrincipalInsightsQuery>;
export type GetDailyPrincipalInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyPrincipalInsightsLazyQueryGQLType>;
export type GetDailyPrincipalInsightsQueryResultGQLType = Apollo.QueryResult<GetDailyPrincipalInsightsQueryGQLType, GetDailyPrincipalInsightsQueryVariablesGQLType>;
export const GetProfitOverviewInsightsDocumentGQLType = gql`
    query GetProfitOverviewInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getProfitOverviewInsights(creditFacilityParams: $creditFacilityParams) {
    creditFacilityId
    creditFacilitySlug
    reportingDate
    totalExposure
    totalNormalizedIsChargedOffExposure
    totalNormalizedIsDelinquentExposure
    totalExposureDaysPastDue0
    totalExposureDaysPastDue1to30
    totalExposureDaysPastDue31to60
    totalExposureDaysPastDue61to90
    totalExposureDaysPastDue91to120
    totalExposureDaysPastDue121plus
    chargedOffPercentageOfTotalExposure
    delinquentPercentageOfTotalExposure
    percentExposureDaysPastDue0
    percentExposureDaysPastDue1to30
    percentExposureDaysPastDue31to60
    percentExposureDaysPastDue61to90
    percentExposureDaysPastDue91to120
    percentExposureDaysPastDue121plus
  }
}
    `;

/**
 * __useGetProfitOverviewInsightsQuery__
 *
 * To run a query within a React component, call `useGetProfitOverviewInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfitOverviewInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfitOverviewInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetProfitOverviewInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>(GetProfitOverviewInsightsDocumentGQLType, options);
      }
export function useGetProfitOverviewInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>(GetProfitOverviewInsightsDocumentGQLType, options);
        }
export type GetProfitOverviewInsightsQueryHookResult = ReturnType<typeof useGetProfitOverviewInsightsQuery>;
export type GetProfitOverviewInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetProfitOverviewInsightsLazyQueryGQLType>;
export type GetProfitOverviewInsightsQueryResultGQLType = Apollo.QueryResult<GetProfitOverviewInsightsQueryGQLType, GetProfitOverviewInsightsQueryVariablesGQLType>;
export const GetProfitVintageInsightsDocumentGQLType = gql`
    query GetProfitVintageInsights($creditFacilityParams: CreditFacilityInsightsParamInput!) {
  getProfitVintageInsights(creditFacilityParams: $creditFacilityParams) {
    profitVintageInputData {
      cohortBaseDate
      cohortSeriesDate
      totalVintageCalcValue
      totalNormalizedIsChargedOffVintageCalcValue
      totalNormalizedIsDelinquentVintageCalcValue
    }
  }
}
    `;

/**
 * __useGetProfitVintageInsightsQuery__
 *
 * To run a query within a React component, call `useGetProfitVintageInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfitVintageInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfitVintageInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetProfitVintageInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>(GetProfitVintageInsightsDocumentGQLType, options);
      }
export function useGetProfitVintageInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>(GetProfitVintageInsightsDocumentGQLType, options);
        }
export type GetProfitVintageInsightsQueryHookResult = ReturnType<typeof useGetProfitVintageInsightsQuery>;
export type GetProfitVintageInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetProfitVintageInsightsLazyQueryGQLType>;
export type GetProfitVintageInsightsQueryResultGQLType = Apollo.QueryResult<GetProfitVintageInsightsQueryGQLType, GetProfitVintageInsightsQueryVariablesGQLType>;
export const GetRepaymentVintageInsightsDocumentGQLType = gql`
    query GetRepaymentVintageInsights($creditFacilityParams: CreditFacilityRepaymentInsightsParamInput!) {
  getRepaymentVintageInsights(creditFacilityParams: $creditFacilityParams) {
    repaymentVintageInputData {
      cohortBaseDate
      cohortSeriesDate
      cumulativeRepayments
    }
    receivableOriginationSummaryInfo {
      originationDate
      originatedReceivablesCount
      totalInitialBalanceOfOriginatedReceivables
    }
  }
}
    `;

/**
 * __useGetRepaymentVintageInsightsQuery__
 *
 * To run a query within a React component, call `useGetRepaymentVintageInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepaymentVintageInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepaymentVintageInsightsQuery({
 *   variables: {
 *      creditFacilityParams: // value for 'creditFacilityParams'
 *   },
 * });
 */
export function useGetRepaymentVintageInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>(GetRepaymentVintageInsightsDocumentGQLType, options);
      }
export function useGetRepaymentVintageInsightsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>(GetRepaymentVintageInsightsDocumentGQLType, options);
        }
export type GetRepaymentVintageInsightsQueryHookResult = ReturnType<typeof useGetRepaymentVintageInsightsQuery>;
export type GetRepaymentVintageInsightsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRepaymentVintageInsightsLazyQueryGQLType>;
export type GetRepaymentVintageInsightsQueryResultGQLType = Apollo.QueryResult<GetRepaymentVintageInsightsQueryGQLType, GetRepaymentVintageInsightsQueryVariablesGQLType>;
export const GetCustomerProvidedVariablesAndValuesDocumentGQLType = gql`
    query GetCustomerProvidedVariablesAndValues($creditFacilityId: UUID!) {
  attributes: getCustomerProvidedVariablesAndValues(
    creditFacilityId: $creditFacilityId
  ) {
    ...AttributeFragment
  }
}
    ${AttributeFragmentFragmentDocGQLType}`;

/**
 * __useGetCustomerProvidedVariablesAndValuesQuery__
 *
 * To run a query within a React component, call `useGetCustomerProvidedVariablesAndValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerProvidedVariablesAndValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerProvidedVariablesAndValuesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetCustomerProvidedVariablesAndValuesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>(GetCustomerProvidedVariablesAndValuesDocumentGQLType, options);
      }
export function useGetCustomerProvidedVariablesAndValuesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>(GetCustomerProvidedVariablesAndValuesDocumentGQLType, options);
        }
export type GetCustomerProvidedVariablesAndValuesQueryHookResult = ReturnType<typeof useGetCustomerProvidedVariablesAndValuesQuery>;
export type GetCustomerProvidedVariablesAndValuesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCustomerProvidedVariablesAndValuesLazyQueryGQLType>;
export type GetCustomerProvidedVariablesAndValuesQueryResultGQLType = Apollo.QueryResult<GetCustomerProvidedVariablesAndValuesQueryGQLType, GetCustomerProvidedVariablesAndValuesQueryVariablesGQLType>;
export const CreateOrUpdateCustomerProvidedValueDocumentGQLType = gql`
    mutation CreateOrUpdateCustomerProvidedValue($attributeId: UUID!, $creditFacilityId: UUID!, $effectiveFromReportingDate: FullDateStr!, $value: AttributeValueInput!) {
  createOrUpdateCustomerProvidedValue(
    attributeId: $attributeId
    creditFacilityId: $creditFacilityId
    effectiveFromReportingDate: $effectiveFromReportingDate
    value: $value
  ) {
    response
  }
}
    `;
export type CreateOrUpdateCustomerProvidedValueMutationFnGQLType = Apollo.MutationFunction<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>;

/**
 * __useCreateOrUpdateCustomerProvidedValueMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCustomerProvidedValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCustomerProvidedValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCustomerProvidedValueMutation, { data, loading, error }] = useCreateOrUpdateCustomerProvidedValueMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      effectiveFromReportingDate: // value for 'effectiveFromReportingDate'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateOrUpdateCustomerProvidedValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>(CreateOrUpdateCustomerProvidedValueDocumentGQLType, options);
      }
export type CreateOrUpdateCustomerProvidedValueMutationHookResult = ReturnType<typeof useCreateOrUpdateCustomerProvidedValueMutation>;
export type CreateOrUpdateCustomerProvidedValueMutationResultGQLType = Apollo.MutationResult<CreateOrUpdateCustomerProvidedValueMutationGQLType>;
export type CreateOrUpdateCustomerProvidedValueMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateOrUpdateCustomerProvidedValueMutationGQLType, CreateOrUpdateCustomerProvidedValueMutationVariablesGQLType>;
export const GetEvaluatedReportInputConfigResultByCreditAgreementIdDocumentGQLType = gql`
    query GetEvaluatedReportInputConfigResultByCreditAgreementId($worklease: ReportingGenerateWorklease!) {
  inputConfig: getEvaluatedReportingInputConfigByCreditAgreementId(
    worklease: $worklease
  ) {
    variables {
      name
      value
    }
    errors
  }
}
    `;

/**
 * __useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery__
 *
 * To run a query within a React component, call `useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery({
 *   variables: {
 *      worklease: // value for 'worklease'
 *   },
 * });
 */
export function useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery(baseOptions: Apollo.QueryHookOptions<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>(GetEvaluatedReportInputConfigResultByCreditAgreementIdDocumentGQLType, options);
      }
export function useGetEvaluatedReportInputConfigResultByCreditAgreementIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>(GetEvaluatedReportInputConfigResultByCreditAgreementIdDocumentGQLType, options);
        }
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryHookResult = ReturnType<typeof useGetEvaluatedReportInputConfigResultByCreditAgreementIdQuery>;
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEvaluatedReportInputConfigResultByCreditAgreementIdLazyQueryGQLType>;
export type GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryResultGQLType = Apollo.QueryResult<GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryGQLType, GetEvaluatedReportInputConfigResultByCreditAgreementIdQueryVariablesGQLType>;
export const GetReportsByCreditFacilityIdDocumentGQLType = gql`
    query GetReportsByCreditFacilityId($creditFacilityId: UUID!) {
  reports: getReportsByCreditFacilityId(creditFacilityId: $creditFacilityId) {
    id
    reportName
    reportType
    isPreview
    reportingDate
    version
  }
}
    `;

/**
 * __useGetReportsByCreditFacilityIdQuery__
 *
 * To run a query within a React component, call `useGetReportsByCreditFacilityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsByCreditFacilityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsByCreditFacilityIdQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetReportsByCreditFacilityIdQuery(baseOptions: Apollo.QueryHookOptions<GetReportsByCreditFacilityIdQueryGQLType, GetReportsByCreditFacilityIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsByCreditFacilityIdQueryGQLType, GetReportsByCreditFacilityIdQueryVariablesGQLType>(GetReportsByCreditFacilityIdDocumentGQLType, options);
      }
export function useGetReportsByCreditFacilityIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsByCreditFacilityIdQueryGQLType, GetReportsByCreditFacilityIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsByCreditFacilityIdQueryGQLType, GetReportsByCreditFacilityIdQueryVariablesGQLType>(GetReportsByCreditFacilityIdDocumentGQLType, options);
        }
export type GetReportsByCreditFacilityIdQueryHookResult = ReturnType<typeof useGetReportsByCreditFacilityIdQuery>;
export type GetReportsByCreditFacilityIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportsByCreditFacilityIdLazyQueryGQLType>;
export type GetReportsByCreditFacilityIdQueryResultGQLType = Apollo.QueryResult<GetReportsByCreditFacilityIdQueryGQLType, GetReportsByCreditFacilityIdQueryVariablesGQLType>;
export const GetReportS3DownloadUrlDocumentGQLType = gql`
    query GetReportS3DownloadUrl($reportId: UUID!, $reportConfigType: ReportConfigType!) {
  downloadUrl: getReportS3DownloadUrl(
    reportId: $reportId
    reportConfigType: $reportConfigType
  )
}
    `;

/**
 * __useGetReportS3DownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReportS3DownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportS3DownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportS3DownloadUrlQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      reportConfigType: // value for 'reportConfigType'
 *   },
 * });
 */
export function useGetReportS3DownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReportS3DownloadUrlQueryGQLType, GetReportS3DownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportS3DownloadUrlQueryGQLType, GetReportS3DownloadUrlQueryVariablesGQLType>(GetReportS3DownloadUrlDocumentGQLType, options);
      }
export function useGetReportS3DownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportS3DownloadUrlQueryGQLType, GetReportS3DownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportS3DownloadUrlQueryGQLType, GetReportS3DownloadUrlQueryVariablesGQLType>(GetReportS3DownloadUrlDocumentGQLType, options);
        }
export type GetReportS3DownloadUrlQueryHookResult = ReturnType<typeof useGetReportS3DownloadUrlQuery>;
export type GetReportS3DownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportS3DownloadUrlLazyQueryGQLType>;
export type GetReportS3DownloadUrlQueryResultGQLType = Apollo.QueryResult<GetReportS3DownloadUrlQueryGQLType, GetReportS3DownloadUrlQueryVariablesGQLType>;
export const GetReportS3DownloadUrlByReportingWorkleaseRecordIdDocumentGQLType = gql`
    query GetReportS3DownloadUrlByReportingWorkleaseRecordId($reportingWorkleaseRecordId: UUID!, $reportConfigType: ReportConfigType!) {
  getReportS3DownloadUrlByReportingWorkleaseRecordId(
    reportingWorkleaseRecordId: $reportingWorkleaseRecordId
    reportConfigType: $reportConfigType
  ) {
    workleaseStatus
    s3DownloadUrl
    error
  }
}
    `;

/**
 * __useGetReportS3DownloadUrlByReportingWorkleaseRecordIdQuery__
 *
 * To run a query within a React component, call `useGetReportS3DownloadUrlByReportingWorkleaseRecordIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportS3DownloadUrlByReportingWorkleaseRecordIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportS3DownloadUrlByReportingWorkleaseRecordIdQuery({
 *   variables: {
 *      reportingWorkleaseRecordId: // value for 'reportingWorkleaseRecordId'
 *      reportConfigType: // value for 'reportConfigType'
 *   },
 * });
 */
export function useGetReportS3DownloadUrlByReportingWorkleaseRecordIdQuery(baseOptions: Apollo.QueryHookOptions<GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryGQLType, GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryGQLType, GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryVariablesGQLType>(GetReportS3DownloadUrlByReportingWorkleaseRecordIdDocumentGQLType, options);
      }
export function useGetReportS3DownloadUrlByReportingWorkleaseRecordIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryGQLType, GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryGQLType, GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryVariablesGQLType>(GetReportS3DownloadUrlByReportingWorkleaseRecordIdDocumentGQLType, options);
        }
export type GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryHookResult = ReturnType<typeof useGetReportS3DownloadUrlByReportingWorkleaseRecordIdQuery>;
export type GetReportS3DownloadUrlByReportingWorkleaseRecordIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportS3DownloadUrlByReportingWorkleaseRecordIdLazyQueryGQLType>;
export type GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryResultGQLType = Apollo.QueryResult<GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryGQLType, GetReportS3DownloadUrlByReportingWorkleaseRecordIdQueryVariablesGQLType>;
export const GetReportsS3DownloadUrlsDocumentGQLType = gql`
    query GetReportsS3DownloadUrls($reportIdsWithFilename: [ReportIdWithFilenameInput!]!, $reportConfigType: ReportConfigType!) {
  getReportsS3DownloadUrls(
    reportIdsWithFilename: $reportIdsWithFilename
    reportConfigType: $reportConfigType
  ) {
    s3DownloadUrl
    filename
  }
}
    `;

/**
 * __useGetReportsS3DownloadUrlsQuery__
 *
 * To run a query within a React component, call `useGetReportsS3DownloadUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsS3DownloadUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsS3DownloadUrlsQuery({
 *   variables: {
 *      reportIdsWithFilename: // value for 'reportIdsWithFilename'
 *      reportConfigType: // value for 'reportConfigType'
 *   },
 * });
 */
export function useGetReportsS3DownloadUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsS3DownloadUrlsQueryGQLType, GetReportsS3DownloadUrlsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsS3DownloadUrlsQueryGQLType, GetReportsS3DownloadUrlsQueryVariablesGQLType>(GetReportsS3DownloadUrlsDocumentGQLType, options);
      }
export function useGetReportsS3DownloadUrlsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsS3DownloadUrlsQueryGQLType, GetReportsS3DownloadUrlsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsS3DownloadUrlsQueryGQLType, GetReportsS3DownloadUrlsQueryVariablesGQLType>(GetReportsS3DownloadUrlsDocumentGQLType, options);
        }
export type GetReportsS3DownloadUrlsQueryHookResult = ReturnType<typeof useGetReportsS3DownloadUrlsQuery>;
export type GetReportsS3DownloadUrlsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportsS3DownloadUrlsLazyQueryGQLType>;
export type GetReportsS3DownloadUrlsQueryResultGQLType = Apollo.QueryResult<GetReportsS3DownloadUrlsQueryGQLType, GetReportsS3DownloadUrlsQueryVariablesGQLType>;
export const GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsDocumentGQLType = gql`
    query GetReportS3DownloadUrlsByReportingWorkleaseRecordIds($reportingWorkleaseRecordIds: [UUID!]!, $reportConfigType: ReportConfigType!) {
  getReportS3DownloadUrlsByReportingWorkleaseRecordIds(
    reportingWorkleaseRecordIds: $reportingWorkleaseRecordIds
    reportConfigType: $reportConfigType
  ) {
    workleaseStatus
    s3DownloadUrl
    error
  }
}
    `;

/**
 * __useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQuery__
 *
 * To run a query within a React component, call `useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQuery({
 *   variables: {
 *      reportingWorkleaseRecordIds: // value for 'reportingWorkleaseRecordIds'
 *      reportConfigType: // value for 'reportConfigType'
 *   },
 * });
 */
export function useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQuery(baseOptions: Apollo.QueryHookOptions<GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryGQLType, GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryGQLType, GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryVariablesGQLType>(GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsDocumentGQLType, options);
      }
export function useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryGQLType, GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryGQLType, GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryVariablesGQLType>(GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsDocumentGQLType, options);
        }
export type GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryHookResult = ReturnType<typeof useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQuery>;
export type GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportS3DownloadUrlsByReportingWorkleaseRecordIdsLazyQueryGQLType>;
export type GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryResultGQLType = Apollo.QueryResult<GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryGQLType, GetReportS3DownloadUrlsByReportingWorkleaseRecordIdsQueryVariablesGQLType>;
export const GetReportingTemplateDownloadUrlDocumentGQLType = gql`
    query GetReportingTemplateDownloadUrl($creditFacilityId: UUID!, $creditAgreementId: UUID!, $reportName: String!) {
  downloadUrl: getReportingTemplateDownloadUrl(
    creditFacilityId: $creditFacilityId
    creditAgreementId: $creditAgreementId
    reportName: $reportName
  )
}
    `;

/**
 * __useGetReportingTemplateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReportingTemplateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingTemplateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingTemplateDownloadUrlQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      creditAgreementId: // value for 'creditAgreementId'
 *      reportName: // value for 'reportName'
 *   },
 * });
 */
export function useGetReportingTemplateDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>(GetReportingTemplateDownloadUrlDocumentGQLType, options);
      }
export function useGetReportingTemplateDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>(GetReportingTemplateDownloadUrlDocumentGQLType, options);
        }
export type GetReportingTemplateDownloadUrlQueryHookResult = ReturnType<typeof useGetReportingTemplateDownloadUrlQuery>;
export type GetReportingTemplateDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportingTemplateDownloadUrlLazyQueryGQLType>;
export type GetReportingTemplateDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetReportingTemplateDownloadUrlQueryGQLType, GetReportingTemplateDownloadUrlQueryVariablesGQLType>;
export const GetStatementDocumentGQLType = gql`
    query GetStatement($creditFacilityId: UUID!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  generateStatement(
    creditFacilityId: $creditFacilityId
    startDate: $startDate
    endDate: $endDate
  ) {
    creditFacilityId
    period {
      startDate
      endDate
      cutoffTime
    }
    paymentDate
    summary {
      balances {
        description
        accounts {
          organizationId
          account
          balance
        }
        balance
      }
      totalBalance
    }
    columns {
      name
      format {
        type
        currency
      }
    }
    rows
  }
}
    `;

/**
 * __useGetStatementQuery__
 *
 * To run a query within a React component, call `useGetStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatementQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetStatementQuery(baseOptions: Apollo.QueryHookOptions<GetStatementQueryGQLType, GetStatementQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatementQueryGQLType, GetStatementQueryVariablesGQLType>(GetStatementDocumentGQLType, options);
      }
export function useGetStatementLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetStatementQueryGQLType, GetStatementQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatementQueryGQLType, GetStatementQueryVariablesGQLType>(GetStatementDocumentGQLType, options);
        }
export type GetStatementQueryHookResult = ReturnType<typeof useGetStatementQuery>;
export type GetStatementLazyQueryGQLTypeHookResult = ReturnType<typeof useGetStatementLazyQueryGQLType>;
export type GetStatementQueryResultGQLType = Apollo.QueryResult<GetStatementQueryGQLType, GetStatementQueryVariablesGQLType>;
export const GenerateSummaryPeriodStatementDocumentGQLType = gql`
    query GenerateSummaryPeriodStatement($creditFacilityId: UUID!, $startDate: FullDateStr!, $endDate: FullDateStr!, $cadence: SummaryStatementCadence!, $cutoffCreatedDate: JSDate) {
  summary: generateSummaryPeriodStatement(
    creditFacilityId: $creditFacilityId
    startDate: $startDate
    endDate: $endDate
    cadence: $cadence
    cutoffCreatedDate: $cutoffCreatedDate
  ) {
    startDate
    endDate
    accountBalances {
      tAccount
      startingBalance
      endingBalance
    }
    totalStartingBalance
    totalEndingBalance
  }
}
    `;

/**
 * __useGenerateSummaryPeriodStatementQuery__
 *
 * To run a query within a React component, call `useGenerateSummaryPeriodStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateSummaryPeriodStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateSummaryPeriodStatementQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      cadence: // value for 'cadence'
 *      cutoffCreatedDate: // value for 'cutoffCreatedDate'
 *   },
 * });
 */
export function useGenerateSummaryPeriodStatementQuery(baseOptions: Apollo.QueryHookOptions<GenerateSummaryPeriodStatementQueryGQLType, GenerateSummaryPeriodStatementQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateSummaryPeriodStatementQueryGQLType, GenerateSummaryPeriodStatementQueryVariablesGQLType>(GenerateSummaryPeriodStatementDocumentGQLType, options);
      }
export function useGenerateSummaryPeriodStatementLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GenerateSummaryPeriodStatementQueryGQLType, GenerateSummaryPeriodStatementQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateSummaryPeriodStatementQueryGQLType, GenerateSummaryPeriodStatementQueryVariablesGQLType>(GenerateSummaryPeriodStatementDocumentGQLType, options);
        }
export type GenerateSummaryPeriodStatementQueryHookResult = ReturnType<typeof useGenerateSummaryPeriodStatementQuery>;
export type GenerateSummaryPeriodStatementLazyQueryGQLTypeHookResult = ReturnType<typeof useGenerateSummaryPeriodStatementLazyQueryGQLType>;
export type GenerateSummaryPeriodStatementQueryResultGQLType = Apollo.QueryResult<GenerateSummaryPeriodStatementQueryGQLType, GenerateSummaryPeriodStatementQueryVariablesGQLType>;
export const GetMultiFacilityStatementDocumentGQLType = gql`
    query GetMultiFacilityStatement($creditFacilityIds: [UUID!]!, $startDate: FullDateStr!, $endDate: FullDateStr!, $transactionAggregation: StatementTransactionAggregationLevel!) {
  generateMultiFacilityStatement(
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    endDate: $endDate
    transactionAggregation: $transactionAggregation
  ) {
    creditFacilityIds
    period {
      startDate
      endDate
      cutoffTime
    }
    paymentDate
    summary {
      balances {
        description
        accounts {
          organizationId
          account
          balance
        }
        balance
      }
      totalBalance
    }
    columns {
      name
      format {
        type
        currency
      }
    }
    rows
  }
}
    `;

/**
 * __useGetMultiFacilityStatementQuery__
 *
 * To run a query within a React component, call `useGetMultiFacilityStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiFacilityStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiFacilityStatementQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      transactionAggregation: // value for 'transactionAggregation'
 *   },
 * });
 */
export function useGetMultiFacilityStatementQuery(baseOptions: Apollo.QueryHookOptions<GetMultiFacilityStatementQueryGQLType, GetMultiFacilityStatementQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiFacilityStatementQueryGQLType, GetMultiFacilityStatementQueryVariablesGQLType>(GetMultiFacilityStatementDocumentGQLType, options);
      }
export function useGetMultiFacilityStatementLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiFacilityStatementQueryGQLType, GetMultiFacilityStatementQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiFacilityStatementQueryGQLType, GetMultiFacilityStatementQueryVariablesGQLType>(GetMultiFacilityStatementDocumentGQLType, options);
        }
export type GetMultiFacilityStatementQueryHookResult = ReturnType<typeof useGetMultiFacilityStatementQuery>;
export type GetMultiFacilityStatementLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMultiFacilityStatementLazyQueryGQLType>;
export type GetMultiFacilityStatementQueryResultGQLType = Apollo.QueryResult<GetMultiFacilityStatementQueryGQLType, GetMultiFacilityStatementQueryVariablesGQLType>;
export const ProduceReportingGenerateMessageDocumentGQLType = gql`
    mutation ProduceReportingGenerateMessage($worklease: ReportingGenerateWorklease!, $parameters: Object) {
  result: produceReportingGenerateMessage(
    worklease: $worklease
    parameters: $parameters
  ) {
    status
    recordId
  }
}
    `;
export type ProduceReportingGenerateMessageMutationFnGQLType = Apollo.MutationFunction<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>;

/**
 * __useProduceReportingGenerateMessageMutation__
 *
 * To run a mutation, you first call `useProduceReportingGenerateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProduceReportingGenerateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [produceReportingGenerateMessageMutation, { data, loading, error }] = useProduceReportingGenerateMessageMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useProduceReportingGenerateMessageMutation(baseOptions?: Apollo.MutationHookOptions<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>(ProduceReportingGenerateMessageDocumentGQLType, options);
      }
export type ProduceReportingGenerateMessageMutationHookResult = ReturnType<typeof useProduceReportingGenerateMessageMutation>;
export type ProduceReportingGenerateMessageMutationResultGQLType = Apollo.MutationResult<ProduceReportingGenerateMessageMutationGQLType>;
export type ProduceReportingGenerateMessageMutationOptionsGQLType = Apollo.BaseMutationOptions<ProduceReportingGenerateMessageMutationGQLType, ProduceReportingGenerateMessageMutationVariablesGQLType>;
export const ProduceReportingGenerateMessagesDocumentGQLType = gql`
    mutation ProduceReportingGenerateMessages($workleases: [ReportingGenerateWorklease!]!) {
  result: produceReportingGenerateMessages(workleases: $workleases) {
    status
    recordId
  }
}
    `;
export type ProduceReportingGenerateMessagesMutationFnGQLType = Apollo.MutationFunction<ProduceReportingGenerateMessagesMutationGQLType, ProduceReportingGenerateMessagesMutationVariablesGQLType>;

/**
 * __useProduceReportingGenerateMessagesMutation__
 *
 * To run a mutation, you first call `useProduceReportingGenerateMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProduceReportingGenerateMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [produceReportingGenerateMessagesMutation, { data, loading, error }] = useProduceReportingGenerateMessagesMutation({
 *   variables: {
 *      workleases: // value for 'workleases'
 *   },
 * });
 */
export function useProduceReportingGenerateMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ProduceReportingGenerateMessagesMutationGQLType, ProduceReportingGenerateMessagesMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProduceReportingGenerateMessagesMutationGQLType, ProduceReportingGenerateMessagesMutationVariablesGQLType>(ProduceReportingGenerateMessagesDocumentGQLType, options);
      }
export type ProduceReportingGenerateMessagesMutationHookResult = ReturnType<typeof useProduceReportingGenerateMessagesMutation>;
export type ProduceReportingGenerateMessagesMutationResultGQLType = Apollo.MutationResult<ProduceReportingGenerateMessagesMutationGQLType>;
export type ProduceReportingGenerateMessagesMutationOptionsGQLType = Apollo.BaseMutationOptions<ProduceReportingGenerateMessagesMutationGQLType, ProduceReportingGenerateMessagesMutationVariablesGQLType>;
export const GenerateReportingOutputFileDevOnlyDocumentGQLType = gql`
    mutation GenerateReportingOutputFileDevOnly($worklease: ReportingGenerateWorklease!, $parameters: Object) {
  result: generateReportingOutputFileDevOnly(
    worklease: $worklease
    parameters: $parameters
  ) {
    status
  }
}
    `;
export type GenerateReportingOutputFileDevOnlyMutationFnGQLType = Apollo.MutationFunction<GenerateReportingOutputFileDevOnlyMutationGQLType, GenerateReportingOutputFileDevOnlyMutationVariablesGQLType>;

/**
 * __useGenerateReportingOutputFileDevOnlyMutation__
 *
 * To run a mutation, you first call `useGenerateReportingOutputFileDevOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportingOutputFileDevOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportingOutputFileDevOnlyMutation, { data, loading, error }] = useGenerateReportingOutputFileDevOnlyMutation({
 *   variables: {
 *      worklease: // value for 'worklease'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useGenerateReportingOutputFileDevOnlyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportingOutputFileDevOnlyMutationGQLType, GenerateReportingOutputFileDevOnlyMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportingOutputFileDevOnlyMutationGQLType, GenerateReportingOutputFileDevOnlyMutationVariablesGQLType>(GenerateReportingOutputFileDevOnlyDocumentGQLType, options);
      }
export type GenerateReportingOutputFileDevOnlyMutationHookResult = ReturnType<typeof useGenerateReportingOutputFileDevOnlyMutation>;
export type GenerateReportingOutputFileDevOnlyMutationResultGQLType = Apollo.MutationResult<GenerateReportingOutputFileDevOnlyMutationGQLType>;
export type GenerateReportingOutputFileDevOnlyMutationOptionsGQLType = Apollo.BaseMutationOptions<GenerateReportingOutputFileDevOnlyMutationGQLType, GenerateReportingOutputFileDevOnlyMutationVariablesGQLType>;
export const AdjustCurrentLiabilityDocumentGQLType = gql`
    mutation AdjustCurrentLiability($amount: Float!, $comment: String, $counterpartyOrganizationId: UUID!, $creditFacilityId: UUID!, $currentLiabilityAccount: String!, $date: FullDateStr!, $type: AdjustCurrentLiabilityTypes!) {
  adjustCurrentLiability(
    amount: $amount
    comment: $comment
    counterpartyOrganizationId: $counterpartyOrganizationId
    creditFacilityId: $creditFacilityId
    currentLiabilityAccount: $currentLiabilityAccount
    date: $date
    type: $type
  ) {
    success
    errors
  }
}
    `;
export type AdjustCurrentLiabilityMutationFnGQLType = Apollo.MutationFunction<AdjustCurrentLiabilityMutationGQLType, AdjustCurrentLiabilityMutationVariablesGQLType>;

/**
 * __useAdjustCurrentLiabilityMutation__
 *
 * To run a mutation, you first call `useAdjustCurrentLiabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustCurrentLiabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustCurrentLiabilityMutation, { data, loading, error }] = useAdjustCurrentLiabilityMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      comment: // value for 'comment'
 *      counterpartyOrganizationId: // value for 'counterpartyOrganizationId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      currentLiabilityAccount: // value for 'currentLiabilityAccount'
 *      date: // value for 'date'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdjustCurrentLiabilityMutation(baseOptions?: Apollo.MutationHookOptions<AdjustCurrentLiabilityMutationGQLType, AdjustCurrentLiabilityMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustCurrentLiabilityMutationGQLType, AdjustCurrentLiabilityMutationVariablesGQLType>(AdjustCurrentLiabilityDocumentGQLType, options);
      }
export type AdjustCurrentLiabilityMutationHookResult = ReturnType<typeof useAdjustCurrentLiabilityMutation>;
export type AdjustCurrentLiabilityMutationResultGQLType = Apollo.MutationResult<AdjustCurrentLiabilityMutationGQLType>;
export type AdjustCurrentLiabilityMutationOptionsGQLType = Apollo.BaseMutationOptions<AdjustCurrentLiabilityMutationGQLType, AdjustCurrentLiabilityMutationVariablesGQLType>;
export const GetReportsDocumentGQLType = gql`
    query GetReports($creditFacilityId: UUID!, $limit: Int, $reportTypes: [ReportType!], $after: String, $before: String, $startDate: JSDate, $endDate: JSDate, $isPreview: Boolean) {
  reports(
    creditFacilityId: $creditFacilityId
    limit: $limit
    reportTypes: $reportTypes
    after: $after
    before: $before
    startDate: $startDate
    endDate: $endDate
    isPreview: $isPreview
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      id
      borrowerId
      reportType
      s3Path
      isPreview
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      limit: // value for 'limit'
 *      reportTypes: // value for 'reportTypes'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isPreview: // value for 'isPreview'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsQueryGQLType, GetReportsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQueryGQLType, GetReportsQueryVariablesGQLType>(GetReportsDocumentGQLType, options);
      }
export function useGetReportsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQueryGQLType, GetReportsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQueryGQLType, GetReportsQueryVariablesGQLType>(GetReportsDocumentGQLType, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportsLazyQueryGQLType>;
export type GetReportsQueryResultGQLType = Apollo.QueryResult<GetReportsQueryGQLType, GetReportsQueryVariablesGQLType>;
export const GetReportDownloadUrlDocumentGQLType = gql`
    query GetReportDownloadUrl($reportId: UUID!, $isDomainReport: Boolean!) {
  reportDownloadUrl(reportId: $reportId, isDomainReport: $isDomainReport)
}
    `;

/**
 * __useGetReportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetReportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDownloadUrlQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      isDomainReport: // value for 'isDomainReport'
 *   },
 * });
 */
export function useGetReportDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetReportDownloadUrlQueryGQLType, GetReportDownloadUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportDownloadUrlQueryGQLType, GetReportDownloadUrlQueryVariablesGQLType>(GetReportDownloadUrlDocumentGQLType, options);
      }
export function useGetReportDownloadUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetReportDownloadUrlQueryGQLType, GetReportDownloadUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportDownloadUrlQueryGQLType, GetReportDownloadUrlQueryVariablesGQLType>(GetReportDownloadUrlDocumentGQLType, options);
        }
export type GetReportDownloadUrlQueryHookResult = ReturnType<typeof useGetReportDownloadUrlQuery>;
export type GetReportDownloadUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetReportDownloadUrlLazyQueryGQLType>;
export type GetReportDownloadUrlQueryResultGQLType = Apollo.QueryResult<GetReportDownloadUrlQueryGQLType, GetReportDownloadUrlQueryVariablesGQLType>;
export const GetTAccountsDocumentGQLType = gql`
    query GetTAccounts($creditFacilityId: UUID!) {
  getTAccounts(creditFacilityId: $creditFacilityId) {
    id
    creditFacilityId
    organizationId
    tAccount
  }
}
    `;

/**
 * __useGetTAccountsQuery__
 *
 * To run a query within a React component, call `useGetTAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTAccountsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetTAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetTAccountsQueryGQLType, GetTAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTAccountsQueryGQLType, GetTAccountsQueryVariablesGQLType>(GetTAccountsDocumentGQLType, options);
      }
export function useGetTAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTAccountsQueryGQLType, GetTAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTAccountsQueryGQLType, GetTAccountsQueryVariablesGQLType>(GetTAccountsDocumentGQLType, options);
        }
export type GetTAccountsQueryHookResult = ReturnType<typeof useGetTAccountsQuery>;
export type GetTAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTAccountsLazyQueryGQLType>;
export type GetTAccountsQueryResultGQLType = Apollo.QueryResult<GetTAccountsQueryGQLType, GetTAccountsQueryVariablesGQLType>;
export const GetLedgerAccountsDocumentGQLType = gql`
    query GetLedgerAccounts($creditFacilityId: UUID!, $ledgerAccountGroup: LedgerAccountGroup!) {
  ledgerAccounts(
    creditFacilityId: $creditFacilityId
    ledgerAccountGroup: $ledgerAccountGroup
  ) {
    id
    creditFacilityId
    organizationId
    tAccount
  }
}
    `;

/**
 * __useGetLedgerAccountsQuery__
 *
 * To run a query within a React component, call `useGetLedgerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerAccountsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      ledgerAccountGroup: // value for 'ledgerAccountGroup'
 *   },
 * });
 */
export function useGetLedgerAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetLedgerAccountsQueryGQLType, GetLedgerAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerAccountsQueryGQLType, GetLedgerAccountsQueryVariablesGQLType>(GetLedgerAccountsDocumentGQLType, options);
      }
export function useGetLedgerAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerAccountsQueryGQLType, GetLedgerAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerAccountsQueryGQLType, GetLedgerAccountsQueryVariablesGQLType>(GetLedgerAccountsDocumentGQLType, options);
        }
export type GetLedgerAccountsQueryHookResult = ReturnType<typeof useGetLedgerAccountsQuery>;
export type GetLedgerAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLedgerAccountsLazyQueryGQLType>;
export type GetLedgerAccountsQueryResultGQLType = Apollo.QueryResult<GetLedgerAccountsQueryGQLType, GetLedgerAccountsQueryVariablesGQLType>;
export const GetLedgerDocumentGQLType = gql`
    query GetLedger($creditFacilityId: UUID!, $organizationIds: [UUID!]!, $selectedTransactionTypes: [TransactionType!], $accountTypes: [TAccountType!]!, $startDate: LuxonDate, $endDate: LuxonDate) {
  ledger(
    creditFacilityId: $creditFacilityId
    organizationIds: $organizationIds
    accountTypes: $accountTypes
    selectedTransactionTypes: $selectedTransactionTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    ...LedgerTransaction
  }
}
    ${LedgerTransactionFragmentDocGQLType}`;

/**
 * __useGetLedgerQuery__
 *
 * To run a query within a React component, call `useGetLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      organizationIds: // value for 'organizationIds'
 *      selectedTransactionTypes: // value for 'selectedTransactionTypes'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetLedgerQuery(baseOptions: Apollo.QueryHookOptions<GetLedgerQueryGQLType, GetLedgerQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerQueryGQLType, GetLedgerQueryVariablesGQLType>(GetLedgerDocumentGQLType, options);
      }
export function useGetLedgerLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerQueryGQLType, GetLedgerQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerQueryGQLType, GetLedgerQueryVariablesGQLType>(GetLedgerDocumentGQLType, options);
        }
export type GetLedgerQueryHookResult = ReturnType<typeof useGetLedgerQuery>;
export type GetLedgerLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLedgerLazyQueryGQLType>;
export type GetLedgerQueryResultGQLType = Apollo.QueryResult<GetLedgerQueryGQLType, GetLedgerQueryVariablesGQLType>;
export const GetLatestLedgersForCreditFacilitiesDocumentGQLType = gql`
    query GetLatestLedgersForCreditFacilities($creditFacilityIds: [UUID!]!, $countersignerOrganizationIds: [UUID!], $ledgerAccountGroup: LedgerAccountGroup!) {
  latestLedgersForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    countersignerOrganizationIds: $countersignerOrganizationIds
    ledgerAccountGroup: $ledgerAccountGroup
  ) {
    creditFacilityId
    ledger {
      ...LedgerTransaction
    }
  }
}
    ${LedgerTransactionFragmentDocGQLType}`;

/**
 * __useGetLatestLedgersForCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetLatestLedgersForCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestLedgersForCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestLedgersForCreditFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      countersignerOrganizationIds: // value for 'countersignerOrganizationIds'
 *      ledgerAccountGroup: // value for 'ledgerAccountGroup'
 *   },
 * });
 */
export function useGetLatestLedgersForCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetLatestLedgersForCreditFacilitiesQueryGQLType, GetLatestLedgersForCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestLedgersForCreditFacilitiesQueryGQLType, GetLatestLedgersForCreditFacilitiesQueryVariablesGQLType>(GetLatestLedgersForCreditFacilitiesDocumentGQLType, options);
      }
export function useGetLatestLedgersForCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestLedgersForCreditFacilitiesQueryGQLType, GetLatestLedgersForCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestLedgersForCreditFacilitiesQueryGQLType, GetLatestLedgersForCreditFacilitiesQueryVariablesGQLType>(GetLatestLedgersForCreditFacilitiesDocumentGQLType, options);
        }
export type GetLatestLedgersForCreditFacilitiesQueryHookResult = ReturnType<typeof useGetLatestLedgersForCreditFacilitiesQuery>;
export type GetLatestLedgersForCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestLedgersForCreditFacilitiesLazyQueryGQLType>;
export type GetLatestLedgersForCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetLatestLedgersForCreditFacilitiesQueryGQLType, GetLatestLedgersForCreditFacilitiesQueryVariablesGQLType>;
export const GetImplementationDetailsDocumentGQLType = gql`
    query GetImplementationDetails($implementationId: UUID!) {
  getImplementationDetails(implementationId: $implementationId) {
    id
    slug
    name
    ownerOrganization {
      id
      name
      slug
    }
    borrowerOrganization {
      id
      name
      slug
      type
      industry
    }
    loanProducts {
      id
      slug
      name
    }
    creditFacilities(includeInactive: false) {
      id
      slug
      name
      borrower {
        id
        name
        slug
      }
    }
    borrowerPipelineDefinitionId
  }
}
    `;

/**
 * __useGetImplementationDetailsQuery__
 *
 * To run a query within a React component, call `useGetImplementationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImplementationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImplementationDetailsQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetImplementationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetImplementationDetailsQueryGQLType, GetImplementationDetailsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImplementationDetailsQueryGQLType, GetImplementationDetailsQueryVariablesGQLType>(GetImplementationDetailsDocumentGQLType, options);
      }
export function useGetImplementationDetailsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetImplementationDetailsQueryGQLType, GetImplementationDetailsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImplementationDetailsQueryGQLType, GetImplementationDetailsQueryVariablesGQLType>(GetImplementationDetailsDocumentGQLType, options);
        }
export type GetImplementationDetailsQueryHookResult = ReturnType<typeof useGetImplementationDetailsQuery>;
export type GetImplementationDetailsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetImplementationDetailsLazyQueryGQLType>;
export type GetImplementationDetailsQueryResultGQLType = Apollo.QueryResult<GetImplementationDetailsQueryGQLType, GetImplementationDetailsQueryVariablesGQLType>;
export const GetBorrowingBasePipelineArtifactDocumentsDocumentGQLType = gql`
    query getBorrowingBasePipelineArtifactDocuments($pipelineDefinitionId: UUID!) {
  borrowingBasePipelineArtifactDocuments(
    pipelineDefinitionId: $pipelineDefinitionId
  ) {
    id
    version
    isWip
  }
}
    `;

/**
 * __useGetBorrowingBasePipelineArtifactDocumentsQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBasePipelineArtifactDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBasePipelineArtifactDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBasePipelineArtifactDocumentsQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *   },
 * });
 */
export function useGetBorrowingBasePipelineArtifactDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowingBasePipelineArtifactDocumentsQueryGQLType, GetBorrowingBasePipelineArtifactDocumentsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBasePipelineArtifactDocumentsQueryGQLType, GetBorrowingBasePipelineArtifactDocumentsQueryVariablesGQLType>(GetBorrowingBasePipelineArtifactDocumentsDocumentGQLType, options);
      }
export function useGetBorrowingBasePipelineArtifactDocumentsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBasePipelineArtifactDocumentsQueryGQLType, GetBorrowingBasePipelineArtifactDocumentsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBasePipelineArtifactDocumentsQueryGQLType, GetBorrowingBasePipelineArtifactDocumentsQueryVariablesGQLType>(GetBorrowingBasePipelineArtifactDocumentsDocumentGQLType, options);
        }
export type GetBorrowingBasePipelineArtifactDocumentsQueryHookResult = ReturnType<typeof useGetBorrowingBasePipelineArtifactDocumentsQuery>;
export type GetBorrowingBasePipelineArtifactDocumentsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBasePipelineArtifactDocumentsLazyQueryGQLType>;
export type GetBorrowingBasePipelineArtifactDocumentsQueryResultGQLType = Apollo.QueryResult<GetBorrowingBasePipelineArtifactDocumentsQueryGQLType, GetBorrowingBasePipelineArtifactDocumentsQueryVariablesGQLType>;
export const GetBorrowingBasePipelineStatusDocumentGQLType = gql`
    query getBorrowingBasePipelineStatus($pipelineDefinitionId: UUID!) {
  implementation: implementationByPipelineDefinitionId(
    pipelineDefinitionId: $pipelineDefinitionId
  ) {
    borrowerOrganization {
      id
      slug
    }
    creditFacilities {
      id
      slug
    }
    loanProducts {
      id
      slug
    }
  }
  borrowingBasePipelineStatus(pipelineDefinitionId: $pipelineDefinitionId) {
    latestArtifactDocumentId
    wipNeedsCommit
    creditAgreementsNeedLink
    latestArtifactDocumentVersion
    artifactDocumentWipId
  }
}
    `;

/**
 * __useGetBorrowingBasePipelineStatusQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBasePipelineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBasePipelineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBasePipelineStatusQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *   },
 * });
 */
export function useGetBorrowingBasePipelineStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowingBasePipelineStatusQueryGQLType, GetBorrowingBasePipelineStatusQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBasePipelineStatusQueryGQLType, GetBorrowingBasePipelineStatusQueryVariablesGQLType>(GetBorrowingBasePipelineStatusDocumentGQLType, options);
      }
export function useGetBorrowingBasePipelineStatusLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBasePipelineStatusQueryGQLType, GetBorrowingBasePipelineStatusQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBasePipelineStatusQueryGQLType, GetBorrowingBasePipelineStatusQueryVariablesGQLType>(GetBorrowingBasePipelineStatusDocumentGQLType, options);
        }
export type GetBorrowingBasePipelineStatusQueryHookResult = ReturnType<typeof useGetBorrowingBasePipelineStatusQuery>;
export type GetBorrowingBasePipelineStatusLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBasePipelineStatusLazyQueryGQLType>;
export type GetBorrowingBasePipelineStatusQueryResultGQLType = Apollo.QueryResult<GetBorrowingBasePipelineStatusQueryGQLType, GetBorrowingBasePipelineStatusQueryVariablesGQLType>;
export const GetLoanTapeMetadataDocumentGQLType = gql`
    query getLoanTapeMetadata($creditFacilityId: UUID!, $loanProductId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!) {
  loanTapeMetadata(
    creditFacilityId: $creditFacilityId
    loanProductId: $loanProductId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    commitmentAmount
    principalBalance
    drawRequestAmountForCalendarMonth
    lastApprovedOrSubmittedFundingRequestDate
    reportingDate
    fileVersion
    portfolioCovenants
    customerProvidedValues
  }
}
    `;

/**
 * __useGetLoanTapeMetadataQuery__
 *
 * To run a query within a React component, call `useGetLoanTapeMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanTapeMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanTapeMetadataQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      loanProductId: // value for 'loanProductId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetLoanTapeMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLoanTapeMetadataQueryGQLType, GetLoanTapeMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanTapeMetadataQueryGQLType, GetLoanTapeMetadataQueryVariablesGQLType>(GetLoanTapeMetadataDocumentGQLType, options);
      }
export function useGetLoanTapeMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanTapeMetadataQueryGQLType, GetLoanTapeMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanTapeMetadataQueryGQLType, GetLoanTapeMetadataQueryVariablesGQLType>(GetLoanTapeMetadataDocumentGQLType, options);
        }
export type GetLoanTapeMetadataQueryHookResult = ReturnType<typeof useGetLoanTapeMetadataQuery>;
export type GetLoanTapeMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanTapeMetadataLazyQueryGQLType>;
export type GetLoanTapeMetadataQueryResultGQLType = Apollo.QueryResult<GetLoanTapeMetadataQueryGQLType, GetLoanTapeMetadataQueryVariablesGQLType>;
export const GetPdfAnalysisDocumentGQLType = gql`
    query getPdfAnalysis($input: PdfAnalysisParams!) {
  pdfAnalysis(input: $input) {
    answers {
      value
      error
      confidence
      pageNumber
    }
    rawResponse
  }
}
    `;

/**
 * __useGetPdfAnalysisQuery__
 *
 * To run a query within a React component, call `useGetPdfAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdfAnalysisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPdfAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetPdfAnalysisQueryGQLType, GetPdfAnalysisQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPdfAnalysisQueryGQLType, GetPdfAnalysisQueryVariablesGQLType>(GetPdfAnalysisDocumentGQLType, options);
      }
export function useGetPdfAnalysisLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPdfAnalysisQueryGQLType, GetPdfAnalysisQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPdfAnalysisQueryGQLType, GetPdfAnalysisQueryVariablesGQLType>(GetPdfAnalysisDocumentGQLType, options);
        }
export type GetPdfAnalysisQueryHookResult = ReturnType<typeof useGetPdfAnalysisQuery>;
export type GetPdfAnalysisLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPdfAnalysisLazyQueryGQLType>;
export type GetPdfAnalysisQueryResultGQLType = Apollo.QueryResult<GetPdfAnalysisQueryGQLType, GetPdfAnalysisQueryVariablesGQLType>;
export const GetExtractPyXlsx2Csv2DocumentGQLType = gql`
    query getExtractPyXlsx2Csv2($pipelineDefinitionId: String!, $xlsxS3Bucket: String!, $xlsxS3Key: String!, $extractionParams: PyXlxs2CsvExtractionParams!) {
  extractPyXlsx2Csv2(
    pipelineDefinitionId: $pipelineDefinitionId
    xlsxS3Bucket: $xlsxS3Bucket
    xlsxS3Key: $xlsxS3Key
    extractionParams: $extractionParams
  )
}
    `;

/**
 * __useGetExtractPyXlsx2Csv2Query__
 *
 * To run a query within a React component, call `useGetExtractPyXlsx2Csv2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractPyXlsx2Csv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractPyXlsx2Csv2Query({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      xlsxS3Bucket: // value for 'xlsxS3Bucket'
 *      xlsxS3Key: // value for 'xlsxS3Key'
 *      extractionParams: // value for 'extractionParams'
 *   },
 * });
 */
export function useGetExtractPyXlsx2Csv2Query(baseOptions: Apollo.QueryHookOptions<GetExtractPyXlsx2Csv2QueryGQLType, GetExtractPyXlsx2Csv2QueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtractPyXlsx2Csv2QueryGQLType, GetExtractPyXlsx2Csv2QueryVariablesGQLType>(GetExtractPyXlsx2Csv2DocumentGQLType, options);
      }
export function useGetExtractPyXlsx2Csv2LazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetExtractPyXlsx2Csv2QueryGQLType, GetExtractPyXlsx2Csv2QueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtractPyXlsx2Csv2QueryGQLType, GetExtractPyXlsx2Csv2QueryVariablesGQLType>(GetExtractPyXlsx2Csv2DocumentGQLType, options);
        }
export type GetExtractPyXlsx2Csv2QueryHookResult = ReturnType<typeof useGetExtractPyXlsx2Csv2Query>;
export type GetExtractPyXlsx2Csv2LazyQueryGQLTypeHookResult = ReturnType<typeof useGetExtractPyXlsx2Csv2LazyQueryGQLType>;
export type GetExtractPyXlsx2Csv2QueryResultGQLType = Apollo.QueryResult<GetExtractPyXlsx2Csv2QueryGQLType, GetExtractPyXlsx2Csv2QueryVariablesGQLType>;
export const GetPyXslx2Csv2UploadSignedUrlDocumentGQLType = gql`
    query getPyXslx2Csv2UploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "pyXlsx2Csv2ExtractionQA"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetPyXslx2Csv2UploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetPyXslx2Csv2UploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPyXslx2Csv2UploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPyXslx2Csv2UploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetPyXslx2Csv2UploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPyXslx2Csv2UploadSignedUrlQueryGQLType, GetPyXslx2Csv2UploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPyXslx2Csv2UploadSignedUrlQueryGQLType, GetPyXslx2Csv2UploadSignedUrlQueryVariablesGQLType>(GetPyXslx2Csv2UploadSignedUrlDocumentGQLType, options);
      }
export function useGetPyXslx2Csv2UploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPyXslx2Csv2UploadSignedUrlQueryGQLType, GetPyXslx2Csv2UploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPyXslx2Csv2UploadSignedUrlQueryGQLType, GetPyXslx2Csv2UploadSignedUrlQueryVariablesGQLType>(GetPyXslx2Csv2UploadSignedUrlDocumentGQLType, options);
        }
export type GetPyXslx2Csv2UploadSignedUrlQueryHookResult = ReturnType<typeof useGetPyXslx2Csv2UploadSignedUrlQuery>;
export type GetPyXslx2Csv2UploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPyXslx2Csv2UploadSignedUrlLazyQueryGQLType>;
export type GetPyXslx2Csv2UploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetPyXslx2Csv2UploadSignedUrlQueryGQLType, GetPyXslx2Csv2UploadSignedUrlQueryVariablesGQLType>;
export const GetExtractPyXlsxVirtualSheet2CsvDocumentGQLType = gql`
    query getExtractPyXlsxVirtualSheet2Csv($pipelineDefinitionId: String!, $xlsxS3Bucket: String!, $xlsxS3Key: String!, $extractionParams: PyXlxsVirtualSheet2CsvExtractionParams!) {
  extractPyXlsxVirtualSheet2Csv(
    pipelineDefinitionId: $pipelineDefinitionId
    xlsxS3Bucket: $xlsxS3Bucket
    xlsxS3Key: $xlsxS3Key
    extractionParams: $extractionParams
  )
}
    `;

/**
 * __useGetExtractPyXlsxVirtualSheet2CsvQuery__
 *
 * To run a query within a React component, call `useGetExtractPyXlsxVirtualSheet2CsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractPyXlsxVirtualSheet2CsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractPyXlsxVirtualSheet2CsvQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      xlsxS3Bucket: // value for 'xlsxS3Bucket'
 *      xlsxS3Key: // value for 'xlsxS3Key'
 *      extractionParams: // value for 'extractionParams'
 *   },
 * });
 */
export function useGetExtractPyXlsxVirtualSheet2CsvQuery(baseOptions: Apollo.QueryHookOptions<GetExtractPyXlsxVirtualSheet2CsvQueryGQLType, GetExtractPyXlsxVirtualSheet2CsvQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtractPyXlsxVirtualSheet2CsvQueryGQLType, GetExtractPyXlsxVirtualSheet2CsvQueryVariablesGQLType>(GetExtractPyXlsxVirtualSheet2CsvDocumentGQLType, options);
      }
export function useGetExtractPyXlsxVirtualSheet2CsvLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetExtractPyXlsxVirtualSheet2CsvQueryGQLType, GetExtractPyXlsxVirtualSheet2CsvQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtractPyXlsxVirtualSheet2CsvQueryGQLType, GetExtractPyXlsxVirtualSheet2CsvQueryVariablesGQLType>(GetExtractPyXlsxVirtualSheet2CsvDocumentGQLType, options);
        }
export type GetExtractPyXlsxVirtualSheet2CsvQueryHookResult = ReturnType<typeof useGetExtractPyXlsxVirtualSheet2CsvQuery>;
export type GetExtractPyXlsxVirtualSheet2CsvLazyQueryGQLTypeHookResult = ReturnType<typeof useGetExtractPyXlsxVirtualSheet2CsvLazyQueryGQLType>;
export type GetExtractPyXlsxVirtualSheet2CsvQueryResultGQLType = Apollo.QueryResult<GetExtractPyXlsxVirtualSheet2CsvQueryGQLType, GetExtractPyXlsxVirtualSheet2CsvQueryVariablesGQLType>;
export const GetExtractAi2CsvDocumentGQLType = gql`
    query getExtractAi2Csv($pipelineDefinitionId: String!, $prompt: String!, $documentsStr: String!, $tool: Object!, $baseFieldsTemplate: BaseFieldsTemplate) {
  extractAi2Csv(
    pipelineDefinitionId: $pipelineDefinitionId
    prompt: $prompt
    documentsStr: $documentsStr
    tool: $tool
    baseFieldsTemplate: $baseFieldsTemplate
  )
}
    `;

/**
 * __useGetExtractAi2CsvQuery__
 *
 * To run a query within a React component, call `useGetExtractAi2CsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractAi2CsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractAi2CsvQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      prompt: // value for 'prompt'
 *      documentsStr: // value for 'documentsStr'
 *      tool: // value for 'tool'
 *      baseFieldsTemplate: // value for 'baseFieldsTemplate'
 *   },
 * });
 */
export function useGetExtractAi2CsvQuery(baseOptions: Apollo.QueryHookOptions<GetExtractAi2CsvQueryGQLType, GetExtractAi2CsvQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtractAi2CsvQueryGQLType, GetExtractAi2CsvQueryVariablesGQLType>(GetExtractAi2CsvDocumentGQLType, options);
      }
export function useGetExtractAi2CsvLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetExtractAi2CsvQueryGQLType, GetExtractAi2CsvQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtractAi2CsvQueryGQLType, GetExtractAi2CsvQueryVariablesGQLType>(GetExtractAi2CsvDocumentGQLType, options);
        }
export type GetExtractAi2CsvQueryHookResult = ReturnType<typeof useGetExtractAi2CsvQuery>;
export type GetExtractAi2CsvLazyQueryGQLTypeHookResult = ReturnType<typeof useGetExtractAi2CsvLazyQueryGQLType>;
export type GetExtractAi2CsvQueryResultGQLType = Apollo.QueryResult<GetExtractAi2CsvQueryGQLType, GetExtractAi2CsvQueryVariablesGQLType>;
export const GetExtractPyCSvVirtualSheetDocumentGQLType = gql`
    query getExtractPyCSvVirtualSheet($pipelineDefinitionId: String!, $extractionParams: PyCsvVirtualSheetExtractionParams!) {
  extractPyCsvVirtualSheet(
    pipelineDefinitionId: $pipelineDefinitionId
    extractionParams: $extractionParams
  )
}
    `;

/**
 * __useGetExtractPyCSvVirtualSheetQuery__
 *
 * To run a query within a React component, call `useGetExtractPyCSvVirtualSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtractPyCSvVirtualSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtractPyCSvVirtualSheetQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      extractionParams: // value for 'extractionParams'
 *   },
 * });
 */
export function useGetExtractPyCSvVirtualSheetQuery(baseOptions: Apollo.QueryHookOptions<GetExtractPyCSvVirtualSheetQueryGQLType, GetExtractPyCSvVirtualSheetQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtractPyCSvVirtualSheetQueryGQLType, GetExtractPyCSvVirtualSheetQueryVariablesGQLType>(GetExtractPyCSvVirtualSheetDocumentGQLType, options);
      }
export function useGetExtractPyCSvVirtualSheetLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetExtractPyCSvVirtualSheetQueryGQLType, GetExtractPyCSvVirtualSheetQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtractPyCSvVirtualSheetQueryGQLType, GetExtractPyCSvVirtualSheetQueryVariablesGQLType>(GetExtractPyCSvVirtualSheetDocumentGQLType, options);
        }
export type GetExtractPyCSvVirtualSheetQueryHookResult = ReturnType<typeof useGetExtractPyCSvVirtualSheetQuery>;
export type GetExtractPyCSvVirtualSheetLazyQueryGQLTypeHookResult = ReturnType<typeof useGetExtractPyCSvVirtualSheetLazyQueryGQLType>;
export type GetExtractPyCSvVirtualSheetQueryResultGQLType = Apollo.QueryResult<GetExtractPyCSvVirtualSheetQueryGQLType, GetExtractPyCSvVirtualSheetQueryVariablesGQLType>;
export const GetPyXslxVirtualSheet2CsvUploadSignedUrlDocumentGQLType = gql`
    query getPyXslxVirtualSheet2CsvUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "pyXlsxVirtualSheet2CsvExtractionQA"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetPyXslxVirtualSheet2CsvUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetPyXslxVirtualSheet2CsvUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPyXslxVirtualSheet2CsvUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPyXslxVirtualSheet2CsvUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetPyXslxVirtualSheet2CsvUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryGQLType, GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryGQLType, GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryVariablesGQLType>(GetPyXslxVirtualSheet2CsvUploadSignedUrlDocumentGQLType, options);
      }
export function useGetPyXslxVirtualSheet2CsvUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryGQLType, GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryGQLType, GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryVariablesGQLType>(GetPyXslxVirtualSheet2CsvUploadSignedUrlDocumentGQLType, options);
        }
export type GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryHookResult = ReturnType<typeof useGetPyXslxVirtualSheet2CsvUploadSignedUrlQuery>;
export type GetPyXslxVirtualSheet2CsvUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPyXslxVirtualSheet2CsvUploadSignedUrlLazyQueryGQLType>;
export type GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryGQLType, GetPyXslxVirtualSheet2CsvUploadSignedUrlQueryVariablesGQLType>;
export const GetPyCsvVirtualSheetUploadSignedUrlDocumentGQLType = gql`
    query getPyCsvVirtualSheetUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "pyCsvVirtualSheetExtractionQA"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetPyCsvVirtualSheetUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetPyCsvVirtualSheetUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPyCsvVirtualSheetUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPyCsvVirtualSheetUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetPyCsvVirtualSheetUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPyCsvVirtualSheetUploadSignedUrlQueryGQLType, GetPyCsvVirtualSheetUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPyCsvVirtualSheetUploadSignedUrlQueryGQLType, GetPyCsvVirtualSheetUploadSignedUrlQueryVariablesGQLType>(GetPyCsvVirtualSheetUploadSignedUrlDocumentGQLType, options);
      }
export function useGetPyCsvVirtualSheetUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPyCsvVirtualSheetUploadSignedUrlQueryGQLType, GetPyCsvVirtualSheetUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPyCsvVirtualSheetUploadSignedUrlQueryGQLType, GetPyCsvVirtualSheetUploadSignedUrlQueryVariablesGQLType>(GetPyCsvVirtualSheetUploadSignedUrlDocumentGQLType, options);
        }
export type GetPyCsvVirtualSheetUploadSignedUrlQueryHookResult = ReturnType<typeof useGetPyCsvVirtualSheetUploadSignedUrlQuery>;
export type GetPyCsvVirtualSheetUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPyCsvVirtualSheetUploadSignedUrlLazyQueryGQLType>;
export type GetPyCsvVirtualSheetUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetPyCsvVirtualSheetUploadSignedUrlQueryGQLType, GetPyCsvVirtualSheetUploadSignedUrlQueryVariablesGQLType>;
export const GetAi2CsvSignedUrlDocumentGQLType = gql`
    query getAi2CsvSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(feature: "ai2CsvQa", serializedParams: $serializedParams) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetAi2CsvSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetAi2CsvSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAi2CsvSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAi2CsvSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetAi2CsvSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetAi2CsvSignedUrlQueryGQLType, GetAi2CsvSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAi2CsvSignedUrlQueryGQLType, GetAi2CsvSignedUrlQueryVariablesGQLType>(GetAi2CsvSignedUrlDocumentGQLType, options);
      }
export function useGetAi2CsvSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAi2CsvSignedUrlQueryGQLType, GetAi2CsvSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAi2CsvSignedUrlQueryGQLType, GetAi2CsvSignedUrlQueryVariablesGQLType>(GetAi2CsvSignedUrlDocumentGQLType, options);
        }
export type GetAi2CsvSignedUrlQueryHookResult = ReturnType<typeof useGetAi2CsvSignedUrlQuery>;
export type GetAi2CsvSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAi2CsvSignedUrlLazyQueryGQLType>;
export type GetAi2CsvSignedUrlQueryResultGQLType = Apollo.QueryResult<GetAi2CsvSignedUrlQueryGQLType, GetAi2CsvSignedUrlQueryVariablesGQLType>;
export const GetAssetAnalysisDocumentGQLType = gql`
    query getAssetAnalysis($params: String!, $pipelineDefinitionId: UUID!) {
  result: extractAsset2Json(
    params: $params
    pipelineDefinitionId: $pipelineDefinitionId
  )
}
    `;

/**
 * __useGetAssetAnalysisQuery__
 *
 * To run a query within a React component, call `useGetAssetAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetAnalysisQuery({
 *   variables: {
 *      params: // value for 'params'
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *   },
 * });
 */
export function useGetAssetAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetAssetAnalysisQueryGQLType, GetAssetAnalysisQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetAnalysisQueryGQLType, GetAssetAnalysisQueryVariablesGQLType>(GetAssetAnalysisDocumentGQLType, options);
      }
export function useGetAssetAnalysisLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetAnalysisQueryGQLType, GetAssetAnalysisQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetAnalysisQueryGQLType, GetAssetAnalysisQueryVariablesGQLType>(GetAssetAnalysisDocumentGQLType, options);
        }
export type GetAssetAnalysisQueryHookResult = ReturnType<typeof useGetAssetAnalysisQuery>;
export type GetAssetAnalysisLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssetAnalysisLazyQueryGQLType>;
export type GetAssetAnalysisQueryResultGQLType = Apollo.QueryResult<GetAssetAnalysisQueryGQLType, GetAssetAnalysisQueryVariablesGQLType>;
export const GetBorrowingBasePipelineDocumentInfoDocumentGQLType = gql`
    query getBorrowingBasePipelineDocumentInfo($artifactDocumentId: UUID!, $dbView: Boolean!) {
  borrowingBasePipelineArtifactDocumentInfo(
    artifactDocumentId: $artifactDocumentId
    dbView: $dbView
  ) {
    artifactDocumentId
    artifactsDocumentString
  }
}
    `;

/**
 * __useGetBorrowingBasePipelineDocumentInfoQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBasePipelineDocumentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBasePipelineDocumentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBasePipelineDocumentInfoQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      dbView: // value for 'dbView'
 *   },
 * });
 */
export function useGetBorrowingBasePipelineDocumentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowingBasePipelineDocumentInfoQueryGQLType, GetBorrowingBasePipelineDocumentInfoQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBasePipelineDocumentInfoQueryGQLType, GetBorrowingBasePipelineDocumentInfoQueryVariablesGQLType>(GetBorrowingBasePipelineDocumentInfoDocumentGQLType, options);
      }
export function useGetBorrowingBasePipelineDocumentInfoLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBasePipelineDocumentInfoQueryGQLType, GetBorrowingBasePipelineDocumentInfoQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBasePipelineDocumentInfoQueryGQLType, GetBorrowingBasePipelineDocumentInfoQueryVariablesGQLType>(GetBorrowingBasePipelineDocumentInfoDocumentGQLType, options);
        }
export type GetBorrowingBasePipelineDocumentInfoQueryHookResult = ReturnType<typeof useGetBorrowingBasePipelineDocumentInfoQuery>;
export type GetBorrowingBasePipelineDocumentInfoLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBasePipelineDocumentInfoLazyQueryGQLType>;
export type GetBorrowingBasePipelineDocumentInfoQueryResultGQLType = Apollo.QueryResult<GetBorrowingBasePipelineDocumentInfoQueryGQLType, GetBorrowingBasePipelineDocumentInfoQueryVariablesGQLType>;
export const GetPipelineInstancesDocumentGQLType = gql`
    query GetPipelineInstances($pipelineRunId: UUID!) {
  getArtifactInstancesForPipelineRun(pipelineRunId: $pipelineRunId) {
    artifactDocumentId
    artifactInstances {
      status
      id
      artifactId
      instanceRecordString
      updated_at
      downloads {
        url
        filename
      }
      jsonRecords
    }
  }
}
    `;

/**
 * __useGetPipelineInstancesQuery__
 *
 * To run a query within a React component, call `useGetPipelineInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineInstancesQuery({
 *   variables: {
 *      pipelineRunId: // value for 'pipelineRunId'
 *   },
 * });
 */
export function useGetPipelineInstancesQuery(baseOptions: Apollo.QueryHookOptions<GetPipelineInstancesQueryGQLType, GetPipelineInstancesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelineInstancesQueryGQLType, GetPipelineInstancesQueryVariablesGQLType>(GetPipelineInstancesDocumentGQLType, options);
      }
export function useGetPipelineInstancesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineInstancesQueryGQLType, GetPipelineInstancesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelineInstancesQueryGQLType, GetPipelineInstancesQueryVariablesGQLType>(GetPipelineInstancesDocumentGQLType, options);
        }
export type GetPipelineInstancesQueryHookResult = ReturnType<typeof useGetPipelineInstancesQuery>;
export type GetPipelineInstancesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPipelineInstancesLazyQueryGQLType>;
export type GetPipelineInstancesQueryResultGQLType = Apollo.QueryResult<GetPipelineInstancesQueryGQLType, GetPipelineInstancesQueryVariablesGQLType>;
export const GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentDocumentGQLType = gql`
    query GetBorrowingBasePipelineArtifactSlugsFromArtifactDocument($artifactDocumentId: UUID) {
  artifactSlugs(artifactDocumentId: $artifactDocumentId)
}
    `;

/**
 * __useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQuery__
 *
 * To run a query within a React component, call `useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *   },
 * });
 */
export function useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQuery(baseOptions?: Apollo.QueryHookOptions<GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryGQLType, GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryGQLType, GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryVariablesGQLType>(GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentDocumentGQLType, options);
      }
export function useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryGQLType, GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryGQLType, GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryVariablesGQLType>(GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentDocumentGQLType, options);
        }
export type GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryHookResult = ReturnType<typeof useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQuery>;
export type GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentLazyQueryGQLType>;
export type GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryResultGQLType = Apollo.QueryResult<GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryGQLType, GetBorrowingBasePipelineArtifactSlugsFromArtifactDocumentQueryVariablesGQLType>;
export const GetPipelineRunsDocumentGQLType = gql`
    query GetPipelineRuns($pipelineDefinitionId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRuns(
    pipelineDefinitionId: $pipelineDefinitionId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
    artifactDocumentId
    pipelineRunId
  }
}
    `;

/**
 * __useGetPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineRunsQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetPipelineRunsQueryGQLType, GetPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelineRunsQueryGQLType, GetPipelineRunsQueryVariablesGQLType>(GetPipelineRunsDocumentGQLType, options);
      }
export function useGetPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineRunsQueryGQLType, GetPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelineRunsQueryGQLType, GetPipelineRunsQueryVariablesGQLType>(GetPipelineRunsDocumentGQLType, options);
        }
export type GetPipelineRunsQueryHookResult = ReturnType<typeof useGetPipelineRunsQuery>;
export type GetPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPipelineRunsLazyQueryGQLType>;
export type GetPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetPipelineRunsQueryGQLType, GetPipelineRunsQueryVariablesGQLType>;
export const SaveBorrowingBasePipelineArtifactDocumentWipDocumentGQLType = gql`
    mutation saveBorrowingBasePipelineArtifactDocumentWip($pipelineDefinitionId: UUID!, $artifactsDocumentString: String!) {
  saveBorrowingBasePipelineArtifactDocumentWip(
    pipelineDefinitionId: $pipelineDefinitionId
    artifactsDocumentString: $artifactsDocumentString
  ) {
    response
  }
}
    `;
export type SaveBorrowingBasePipelineArtifactDocumentWipMutationFnGQLType = Apollo.MutationFunction<SaveBorrowingBasePipelineArtifactDocumentWipMutationGQLType, SaveBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>;

/**
 * __useSaveBorrowingBasePipelineArtifactDocumentWipMutation__
 *
 * To run a mutation, you first call `useSaveBorrowingBasePipelineArtifactDocumentWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBorrowingBasePipelineArtifactDocumentWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBorrowingBasePipelineArtifactDocumentWipMutation, { data, loading, error }] = useSaveBorrowingBasePipelineArtifactDocumentWipMutation({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      artifactsDocumentString: // value for 'artifactsDocumentString'
 *   },
 * });
 */
export function useSaveBorrowingBasePipelineArtifactDocumentWipMutation(baseOptions?: Apollo.MutationHookOptions<SaveBorrowingBasePipelineArtifactDocumentWipMutationGQLType, SaveBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBorrowingBasePipelineArtifactDocumentWipMutationGQLType, SaveBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>(SaveBorrowingBasePipelineArtifactDocumentWipDocumentGQLType, options);
      }
export type SaveBorrowingBasePipelineArtifactDocumentWipMutationHookResult = ReturnType<typeof useSaveBorrowingBasePipelineArtifactDocumentWipMutation>;
export type SaveBorrowingBasePipelineArtifactDocumentWipMutationResultGQLType = Apollo.MutationResult<SaveBorrowingBasePipelineArtifactDocumentWipMutationGQLType>;
export type SaveBorrowingBasePipelineArtifactDocumentWipMutationOptionsGQLType = Apollo.BaseMutationOptions<SaveBorrowingBasePipelineArtifactDocumentWipMutationGQLType, SaveBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>;
export const DeleteBorrowingBasePipelineArtifactDocumentWipDocumentGQLType = gql`
    mutation deleteBorrowingBasePipelineArtifactDocumentWip($pipelineDefinitionId: UUID!, $artifactDocumentId: UUID!) {
  deleteBorrowingBasePipelineArtifactDocumentWip(
    pipelineDefinitionId: $pipelineDefinitionId
    artifactDocumentId: $artifactDocumentId
  ) {
    response
  }
}
    `;
export type DeleteBorrowingBasePipelineArtifactDocumentWipMutationFnGQLType = Apollo.MutationFunction<DeleteBorrowingBasePipelineArtifactDocumentWipMutationGQLType, DeleteBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>;

/**
 * __useDeleteBorrowingBasePipelineArtifactDocumentWipMutation__
 *
 * To run a mutation, you first call `useDeleteBorrowingBasePipelineArtifactDocumentWipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBorrowingBasePipelineArtifactDocumentWipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBorrowingBasePipelineArtifactDocumentWipMutation, { data, loading, error }] = useDeleteBorrowingBasePipelineArtifactDocumentWipMutation({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *   },
 * });
 */
export function useDeleteBorrowingBasePipelineArtifactDocumentWipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBorrowingBasePipelineArtifactDocumentWipMutationGQLType, DeleteBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBorrowingBasePipelineArtifactDocumentWipMutationGQLType, DeleteBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>(DeleteBorrowingBasePipelineArtifactDocumentWipDocumentGQLType, options);
      }
export type DeleteBorrowingBasePipelineArtifactDocumentWipMutationHookResult = ReturnType<typeof useDeleteBorrowingBasePipelineArtifactDocumentWipMutation>;
export type DeleteBorrowingBasePipelineArtifactDocumentWipMutationResultGQLType = Apollo.MutationResult<DeleteBorrowingBasePipelineArtifactDocumentWipMutationGQLType>;
export type DeleteBorrowingBasePipelineArtifactDocumentWipMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteBorrowingBasePipelineArtifactDocumentWipMutationGQLType, DeleteBorrowingBasePipelineArtifactDocumentWipMutationVariablesGQLType>;
export const GetTapeBuilderLatestPipelineRunDocumentGQLType = gql`
    query GetTapeBuilderLatestPipelineRun($pipelineDefinitionId: UUID!) {
  getPipelineRuns(pipelineDefinitionId: $pipelineDefinitionId, limit: 1) {
    reportingDate
    fileVersion
    artifactDocumentId
    pipelineRunId
  }
}
    `;

/**
 * __useGetTapeBuilderLatestPipelineRunQuery__
 *
 * To run a query within a React component, call `useGetTapeBuilderLatestPipelineRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTapeBuilderLatestPipelineRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTapeBuilderLatestPipelineRunQuery({
 *   variables: {
 *      pipelineDefinitionId: // value for 'pipelineDefinitionId'
 *   },
 * });
 */
export function useGetTapeBuilderLatestPipelineRunQuery(baseOptions: Apollo.QueryHookOptions<GetTapeBuilderLatestPipelineRunQueryGQLType, GetTapeBuilderLatestPipelineRunQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTapeBuilderLatestPipelineRunQueryGQLType, GetTapeBuilderLatestPipelineRunQueryVariablesGQLType>(GetTapeBuilderLatestPipelineRunDocumentGQLType, options);
      }
export function useGetTapeBuilderLatestPipelineRunLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTapeBuilderLatestPipelineRunQueryGQLType, GetTapeBuilderLatestPipelineRunQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTapeBuilderLatestPipelineRunQueryGQLType, GetTapeBuilderLatestPipelineRunQueryVariablesGQLType>(GetTapeBuilderLatestPipelineRunDocumentGQLType, options);
        }
export type GetTapeBuilderLatestPipelineRunQueryHookResult = ReturnType<typeof useGetTapeBuilderLatestPipelineRunQuery>;
export type GetTapeBuilderLatestPipelineRunLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTapeBuilderLatestPipelineRunLazyQueryGQLType>;
export type GetTapeBuilderLatestPipelineRunQueryResultGQLType = Apollo.QueryResult<GetTapeBuilderLatestPipelineRunQueryGQLType, GetTapeBuilderLatestPipelineRunQueryVariablesGQLType>;
export const GetTapeBuilderPipelineRunDocumentGQLType = gql`
    query GetTapeBuilderPipelineRun($pipelineRunId: UUID!) {
  getPipelineRunById(pipelineRunId: $pipelineRunId) {
    reportingDate
    fileVersion
    artifactDocumentId
  }
}
    `;

/**
 * __useGetTapeBuilderPipelineRunQuery__
 *
 * To run a query within a React component, call `useGetTapeBuilderPipelineRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTapeBuilderPipelineRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTapeBuilderPipelineRunQuery({
 *   variables: {
 *      pipelineRunId: // value for 'pipelineRunId'
 *   },
 * });
 */
export function useGetTapeBuilderPipelineRunQuery(baseOptions: Apollo.QueryHookOptions<GetTapeBuilderPipelineRunQueryGQLType, GetTapeBuilderPipelineRunQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTapeBuilderPipelineRunQueryGQLType, GetTapeBuilderPipelineRunQueryVariablesGQLType>(GetTapeBuilderPipelineRunDocumentGQLType, options);
      }
export function useGetTapeBuilderPipelineRunLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTapeBuilderPipelineRunQueryGQLType, GetTapeBuilderPipelineRunQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTapeBuilderPipelineRunQueryGQLType, GetTapeBuilderPipelineRunQueryVariablesGQLType>(GetTapeBuilderPipelineRunDocumentGQLType, options);
        }
export type GetTapeBuilderPipelineRunQueryHookResult = ReturnType<typeof useGetTapeBuilderPipelineRunQuery>;
export type GetTapeBuilderPipelineRunLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTapeBuilderPipelineRunLazyQueryGQLType>;
export type GetTapeBuilderPipelineRunQueryResultGQLType = Apollo.QueryResult<GetTapeBuilderPipelineRunQueryGQLType, GetTapeBuilderPipelineRunQueryVariablesGQLType>;
export const GetTapeBuilderNodePositionsDocumentGQLType = gql`
    query GetTapeBuilderNodePositions($artifactDocumentId: UUID!, $purpose: NodePositionPurpose!) {
  nodePositions: getNodePositions(
    artifactDocumentId: $artifactDocumentId
    purpose: $purpose
  ) {
    artifactIdentifier
    x
    y
  }
}
    `;

/**
 * __useGetTapeBuilderNodePositionsQuery__
 *
 * To run a query within a React component, call `useGetTapeBuilderNodePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTapeBuilderNodePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTapeBuilderNodePositionsQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useGetTapeBuilderNodePositionsQuery(baseOptions: Apollo.QueryHookOptions<GetTapeBuilderNodePositionsQueryGQLType, GetTapeBuilderNodePositionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTapeBuilderNodePositionsQueryGQLType, GetTapeBuilderNodePositionsQueryVariablesGQLType>(GetTapeBuilderNodePositionsDocumentGQLType, options);
      }
export function useGetTapeBuilderNodePositionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTapeBuilderNodePositionsQueryGQLType, GetTapeBuilderNodePositionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTapeBuilderNodePositionsQueryGQLType, GetTapeBuilderNodePositionsQueryVariablesGQLType>(GetTapeBuilderNodePositionsDocumentGQLType, options);
        }
export type GetTapeBuilderNodePositionsQueryHookResult = ReturnType<typeof useGetTapeBuilderNodePositionsQuery>;
export type GetTapeBuilderNodePositionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTapeBuilderNodePositionsLazyQueryGQLType>;
export type GetTapeBuilderNodePositionsQueryResultGQLType = Apollo.QueryResult<GetTapeBuilderNodePositionsQueryGQLType, GetTapeBuilderNodePositionsQueryVariablesGQLType>;
export const GetGraphWithPositionsDocumentGQLType = gql`
    query GetGraphWithPositions($artifactDocumentId: UUID!, $dbView: Boolean!, $purpose: NodePositionPurpose!) {
  borrowingBasePipelineArtifactDocumentInfo(
    artifactDocumentId: $artifactDocumentId
    dbView: $dbView
  ) {
    artifactDocumentId
    artifactsDocumentString
  }
  nodePositions: getNodePositions(
    artifactDocumentId: $artifactDocumentId
    purpose: $purpose
  ) {
    artifactIdentifier
    x
    y
  }
}
    `;

/**
 * __useGetGraphWithPositionsQuery__
 *
 * To run a query within a React component, call `useGetGraphWithPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphWithPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphWithPositionsQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      dbView: // value for 'dbView'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useGetGraphWithPositionsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphWithPositionsQueryGQLType, GetGraphWithPositionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphWithPositionsQueryGQLType, GetGraphWithPositionsQueryVariablesGQLType>(GetGraphWithPositionsDocumentGQLType, options);
      }
export function useGetGraphWithPositionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphWithPositionsQueryGQLType, GetGraphWithPositionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphWithPositionsQueryGQLType, GetGraphWithPositionsQueryVariablesGQLType>(GetGraphWithPositionsDocumentGQLType, options);
        }
export type GetGraphWithPositionsQueryHookResult = ReturnType<typeof useGetGraphWithPositionsQuery>;
export type GetGraphWithPositionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetGraphWithPositionsLazyQueryGQLType>;
export type GetGraphWithPositionsQueryResultGQLType = Apollo.QueryResult<GetGraphWithPositionsQueryGQLType, GetGraphWithPositionsQueryVariablesGQLType>;
export const SetNodePositionsDocumentGQLType = gql`
    mutation setNodePositions($artifactDocumentId: UUID!, $purpose: NodePositionPurpose!, $positions: [NodePositionInput!]!) {
  setNodePositions(
    artifactDocumentId: $artifactDocumentId
    purpose: $purpose
    positions: $positions
  )
}
    `;
export type SetNodePositionsMutationFnGQLType = Apollo.MutationFunction<SetNodePositionsMutationGQLType, SetNodePositionsMutationVariablesGQLType>;

/**
 * __useSetNodePositionsMutation__
 *
 * To run a mutation, you first call `useSetNodePositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNodePositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNodePositionsMutation, { data, loading, error }] = useSetNodePositionsMutation({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      purpose: // value for 'purpose'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useSetNodePositionsMutation(baseOptions?: Apollo.MutationHookOptions<SetNodePositionsMutationGQLType, SetNodePositionsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNodePositionsMutationGQLType, SetNodePositionsMutationVariablesGQLType>(SetNodePositionsDocumentGQLType, options);
      }
export type SetNodePositionsMutationHookResult = ReturnType<typeof useSetNodePositionsMutation>;
export type SetNodePositionsMutationResultGQLType = Apollo.MutationResult<SetNodePositionsMutationGQLType>;
export type SetNodePositionsMutationOptionsGQLType = Apollo.BaseMutationOptions<SetNodePositionsMutationGQLType, SetNodePositionsMutationVariablesGQLType>;
export const GetTasksDocumentGQLType = gql`
    query GetTasks($filters: TaskFilterInput) {
  getTasks(filters: $filters) {
    tasks {
      ...Task
    }
    filterState {
      currentFilters {
        creditFacilityIds
        loanIds
        categories
        statuses
        dateRange {
          startDate
          endDate
        }
      }
      allLoanIds
    }
  }
}
    ${TaskFragmentDocGQLType}`;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksQueryGQLType, GetTasksQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQueryGQLType, GetTasksQueryVariablesGQLType>(GetTasksDocumentGQLType, options);
      }
export function useGetTasksLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQueryGQLType, GetTasksQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQueryGQLType, GetTasksQueryVariablesGQLType>(GetTasksDocumentGQLType, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTasksLazyQueryGQLType>;
export type GetTasksQueryResultGQLType = Apollo.QueryResult<GetTasksQueryGQLType, GetTasksQueryVariablesGQLType>;
export const GetTasksBySectionDocumentGQLType = gql`
    query GetTasksBySection($section: TaskSectionParamInput!, $filters: TaskFilterInput) {
  getTasksBySection(section: $section, filters: $filters) {
    ...Task
  }
}
    ${TaskFragmentDocGQLType}`;

/**
 * __useGetTasksBySectionQuery__
 *
 * To run a query within a React component, call `useGetTasksBySectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksBySectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksBySectionQuery({
 *   variables: {
 *      section: // value for 'section'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTasksBySectionQuery(baseOptions: Apollo.QueryHookOptions<GetTasksBySectionQueryGQLType, GetTasksBySectionQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksBySectionQueryGQLType, GetTasksBySectionQueryVariablesGQLType>(GetTasksBySectionDocumentGQLType, options);
      }
export function useGetTasksBySectionLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksBySectionQueryGQLType, GetTasksBySectionQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksBySectionQueryGQLType, GetTasksBySectionQueryVariablesGQLType>(GetTasksBySectionDocumentGQLType, options);
        }
export type GetTasksBySectionQueryHookResult = ReturnType<typeof useGetTasksBySectionQuery>;
export type GetTasksBySectionLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTasksBySectionLazyQueryGQLType>;
export type GetTasksBySectionQueryResultGQLType = Apollo.QueryResult<GetTasksBySectionQueryGQLType, GetTasksBySectionQueryVariablesGQLType>;
export const GetTaskByIdDocumentGQLType = gql`
    query GetTaskById($taskId: UUID!) {
  getTaskById(taskId: $taskId) {
    ...Task
  }
}
    ${TaskFragmentDocGQLType}`;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByIdQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTaskByIdQueryGQLType, GetTaskByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskByIdQueryGQLType, GetTaskByIdQueryVariablesGQLType>(GetTaskByIdDocumentGQLType, options);
      }
export function useGetTaskByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskByIdQueryGQLType, GetTaskByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskByIdQueryGQLType, GetTaskByIdQueryVariablesGQLType>(GetTaskByIdDocumentGQLType, options);
        }
export type GetTaskByIdQueryHookResult = ReturnType<typeof useGetTaskByIdQuery>;
export type GetTaskByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTaskByIdLazyQueryGQLType>;
export type GetTaskByIdQueryResultGQLType = Apollo.QueryResult<GetTaskByIdQueryGQLType, GetTaskByIdQueryVariablesGQLType>;
export const GetTasksInitialFiltersDocumentGQLType = gql`
    query GetTasksInitialFilters {
  getTasksInitialFilters {
    currentFilters {
      creditFacilityIds
      loanIds
      categories
      statuses
      dateRange {
        startDate
        endDate
      }
    }
    allLoanIds
  }
}
    `;

/**
 * __useGetTasksInitialFiltersQuery__
 *
 * To run a query within a React component, call `useGetTasksInitialFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksInitialFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksInitialFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTasksInitialFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksInitialFiltersQueryGQLType, GetTasksInitialFiltersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksInitialFiltersQueryGQLType, GetTasksInitialFiltersQueryVariablesGQLType>(GetTasksInitialFiltersDocumentGQLType, options);
      }
export function useGetTasksInitialFiltersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksInitialFiltersQueryGQLType, GetTasksInitialFiltersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksInitialFiltersQueryGQLType, GetTasksInitialFiltersQueryVariablesGQLType>(GetTasksInitialFiltersDocumentGQLType, options);
        }
export type GetTasksInitialFiltersQueryHookResult = ReturnType<typeof useGetTasksInitialFiltersQuery>;
export type GetTasksInitialFiltersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetTasksInitialFiltersLazyQueryGQLType>;
export type GetTasksInitialFiltersQueryResultGQLType = Apollo.QueryResult<GetTasksInitialFiltersQueryGQLType, GetTasksInitialFiltersQueryVariablesGQLType>;
export const UpdateTaskPropertiesDocumentGQLType = gql`
    mutation UpdateTaskProperties($taskId: UUID!, $newDueDate: FullDateStr, $newAssignedUserId: UUID) {
  updateTaskProperties(
    taskId: $taskId
    newDueDate: $newDueDate
    newAssignedUserId: $newAssignedUserId
  ) {
    ...TaskEntity
  }
}
    ${TaskEntityFragmentDocGQLType}`;
export type UpdateTaskPropertiesMutationFnGQLType = Apollo.MutationFunction<UpdateTaskPropertiesMutationGQLType, UpdateTaskPropertiesMutationVariablesGQLType>;

/**
 * __useUpdateTaskPropertiesMutation__
 *
 * To run a mutation, you first call `useUpdateTaskPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskPropertiesMutation, { data, loading, error }] = useUpdateTaskPropertiesMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      newDueDate: // value for 'newDueDate'
 *      newAssignedUserId: // value for 'newAssignedUserId'
 *   },
 * });
 */
export function useUpdateTaskPropertiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskPropertiesMutationGQLType, UpdateTaskPropertiesMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskPropertiesMutationGQLType, UpdateTaskPropertiesMutationVariablesGQLType>(UpdateTaskPropertiesDocumentGQLType, options);
      }
export type UpdateTaskPropertiesMutationHookResult = ReturnType<typeof useUpdateTaskPropertiesMutation>;
export type UpdateTaskPropertiesMutationResultGQLType = Apollo.MutationResult<UpdateTaskPropertiesMutationGQLType>;
export type UpdateTaskPropertiesMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateTaskPropertiesMutationGQLType, UpdateTaskPropertiesMutationVariablesGQLType>;
export const BulkReassignTasksDocumentGQLType = gql`
    mutation BulkReassignTasks($taskIds: [UUID!]!, $newAssignedUserId: UUID!) {
  bulkReassignTasks(taskIds: $taskIds, newAssignedUserId: $newAssignedUserId) {
    ...TaskEntity
  }
}
    ${TaskEntityFragmentDocGQLType}`;
export type BulkReassignTasksMutationFnGQLType = Apollo.MutationFunction<BulkReassignTasksMutationGQLType, BulkReassignTasksMutationVariablesGQLType>;

/**
 * __useBulkReassignTasksMutation__
 *
 * To run a mutation, you first call `useBulkReassignTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkReassignTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkReassignTasksMutation, { data, loading, error }] = useBulkReassignTasksMutation({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *      newAssignedUserId: // value for 'newAssignedUserId'
 *   },
 * });
 */
export function useBulkReassignTasksMutation(baseOptions?: Apollo.MutationHookOptions<BulkReassignTasksMutationGQLType, BulkReassignTasksMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkReassignTasksMutationGQLType, BulkReassignTasksMutationVariablesGQLType>(BulkReassignTasksDocumentGQLType, options);
      }
export type BulkReassignTasksMutationHookResult = ReturnType<typeof useBulkReassignTasksMutation>;
export type BulkReassignTasksMutationResultGQLType = Apollo.MutationResult<BulkReassignTasksMutationGQLType>;
export type BulkReassignTasksMutationOptionsGQLType = Apollo.BaseMutationOptions<BulkReassignTasksMutationGQLType, BulkReassignTasksMutationVariablesGQLType>;
export const GetIncompleteTasksCountDocumentGQLType = gql`
    query GetIncompleteTasksCount {
  getIncompleteTasksCount
}
    `;

/**
 * __useGetIncompleteTasksCountQuery__
 *
 * To run a query within a React component, call `useGetIncompleteTasksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncompleteTasksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncompleteTasksCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIncompleteTasksCountQuery(baseOptions?: Apollo.QueryHookOptions<GetIncompleteTasksCountQueryGQLType, GetIncompleteTasksCountQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncompleteTasksCountQueryGQLType, GetIncompleteTasksCountQueryVariablesGQLType>(GetIncompleteTasksCountDocumentGQLType, options);
      }
export function useGetIncompleteTasksCountLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetIncompleteTasksCountQueryGQLType, GetIncompleteTasksCountQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncompleteTasksCountQueryGQLType, GetIncompleteTasksCountQueryVariablesGQLType>(GetIncompleteTasksCountDocumentGQLType, options);
        }
export type GetIncompleteTasksCountQueryHookResult = ReturnType<typeof useGetIncompleteTasksCountQuery>;
export type GetIncompleteTasksCountLazyQueryGQLTypeHookResult = ReturnType<typeof useGetIncompleteTasksCountLazyQueryGQLType>;
export type GetIncompleteTasksCountQueryResultGQLType = Apollo.QueryResult<GetIncompleteTasksCountQueryGQLType, GetIncompleteTasksCountQueryVariablesGQLType>;
export const GetCreditFacilitiesWithLiabilityAccountsDocumentGQLType = gql`
    query GetCreditFacilitiesWithLiabilityAccounts($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    name
    liabilityAccounts {
      tAccount
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesWithLiabilityAccountsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesWithLiabilityAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesWithLiabilityAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesWithLiabilityAccountsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesWithLiabilityAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilitiesWithLiabilityAccountsDocumentGQLType, options);
      }
export function useGetCreditFacilitiesWithLiabilityAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilitiesWithLiabilityAccountsDocumentGQLType, options);
        }
export type GetCreditFacilitiesWithLiabilityAccountsQueryHookResult = ReturnType<typeof useGetCreditFacilitiesWithLiabilityAccountsQuery>;
export type GetCreditFacilitiesWithLiabilityAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesWithLiabilityAccountsLazyQueryGQLType>;
export type GetCreditFacilitiesWithLiabilityAccountsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>;
export const GetEarliestAndLatestTransactionDatesDocumentGQLType = gql`
    query GetEarliestAndLatestTransactionDates($creditFacilityId: UUID!) {
  dates: getEarliestAndLatestTransactionDates(creditFacilityId: $creditFacilityId) {
    earliestDate
    latestDate
  }
}
    `;

/**
 * __useGetEarliestAndLatestTransactionDatesQuery__
 *
 * To run a query within a React component, call `useGetEarliestAndLatestTransactionDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEarliestAndLatestTransactionDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEarliestAndLatestTransactionDatesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetEarliestAndLatestTransactionDatesQuery(baseOptions: Apollo.QueryHookOptions<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>(GetEarliestAndLatestTransactionDatesDocumentGQLType, options);
      }
export function useGetEarliestAndLatestTransactionDatesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>(GetEarliestAndLatestTransactionDatesDocumentGQLType, options);
        }
export type GetEarliestAndLatestTransactionDatesQueryHookResult = ReturnType<typeof useGetEarliestAndLatestTransactionDatesQuery>;
export type GetEarliestAndLatestTransactionDatesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEarliestAndLatestTransactionDatesLazyQueryGQLType>;
export type GetEarliestAndLatestTransactionDatesQueryResultGQLType = Apollo.QueryResult<GetEarliestAndLatestTransactionDatesQueryGQLType, GetEarliestAndLatestTransactionDatesQueryVariablesGQLType>;
export const GetDatesForCurrentLiabilityTransactionsDocumentGQLType = gql`
    query GetDatesForCurrentLiabilityTransactions($creditFacilityId: UUID!) {
  dates: getDatesForCurrentLiabilityTransactions(
    creditFacilityId: $creditFacilityId
  ) {
    earliestDate
    latestDate
  }
}
    `;

/**
 * __useGetDatesForCurrentLiabilityTransactionsQuery__
 *
 * To run a query within a React component, call `useGetDatesForCurrentLiabilityTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatesForCurrentLiabilityTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatesForCurrentLiabilityTransactionsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetDatesForCurrentLiabilityTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>(GetDatesForCurrentLiabilityTransactionsDocumentGQLType, options);
      }
export function useGetDatesForCurrentLiabilityTransactionsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>(GetDatesForCurrentLiabilityTransactionsDocumentGQLType, options);
        }
export type GetDatesForCurrentLiabilityTransactionsQueryHookResult = ReturnType<typeof useGetDatesForCurrentLiabilityTransactionsQuery>;
export type GetDatesForCurrentLiabilityTransactionsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDatesForCurrentLiabilityTransactionsLazyQueryGQLType>;
export type GetDatesForCurrentLiabilityTransactionsQueryResultGQLType = Apollo.QueryResult<GetDatesForCurrentLiabilityTransactionsQueryGQLType, GetDatesForCurrentLiabilityTransactionsQueryVariablesGQLType>;
export const GetResolvedDetailedEntriesForFacilitiesDocumentGQLType = gql`
    query getResolvedDetailedEntriesForFacilities($creditFacilityIds: [UUID!]!, $loanIds: [UUID!], $accountTypes: [TAccountType!], $startDate: FullDateStr!, $endDate: FullDateStr!) {
  entries: getResolvedDetailedEntriesForFacilities(
    creditFacilityIds: $creditFacilityIds
    loanIds: $loanIds
    accountTypes: $accountTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    postingDate
    transactionType
    transactionCreatedAt
    comment
    amount
    tAccount
    creditFacilityId
    creditFacilitySlug
    creditFacilityName
    organizationId
    organizationSlug
    organizationName
    loanId
    loanName
    externalLoanId
    invoiceId
  }
}
    `;

/**
 * __useGetResolvedDetailedEntriesForFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetResolvedDetailedEntriesForFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResolvedDetailedEntriesForFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResolvedDetailedEntriesForFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      loanIds: // value for 'loanIds'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetResolvedDetailedEntriesForFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>(GetResolvedDetailedEntriesForFacilitiesDocumentGQLType, options);
      }
export function useGetResolvedDetailedEntriesForFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>(GetResolvedDetailedEntriesForFacilitiesDocumentGQLType, options);
        }
export type GetResolvedDetailedEntriesForFacilitiesQueryHookResult = ReturnType<typeof useGetResolvedDetailedEntriesForFacilitiesQuery>;
export type GetResolvedDetailedEntriesForFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetResolvedDetailedEntriesForFacilitiesLazyQueryGQLType>;
export type GetResolvedDetailedEntriesForFacilitiesQueryResultGQLType = Apollo.QueryResult<GetResolvedDetailedEntriesForFacilitiesQueryGQLType, GetResolvedDetailedEntriesForFacilitiesQueryVariablesGQLType>;
export const GetDailyResolvedAggregateLineItemEntriesDocumentGQLType = gql`
    query GetDailyResolvedAggregateLineItemEntries($creditFacilityIds: [UUID!]!, $loanIds: [UUID!], $accountTypes: [TAccountType!], $startDate: FullDateStr!, $endDate: FullDateStr!) {
  entries: getDailyResolvedAggregateLineItemEntries(
    creditFacilityIds: $creditFacilityIds
    loanIds: $loanIds
    accountTypes: $accountTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    postingDate
    tAccount
    creditFacilityId
    organizationId
    aggregateAmount
    loanId
    loanName
    externalLoanId
    invoiceId
    creditFacilitySlug
    creditFacilityName
    organizationSlug
    organizationName
  }
}
    `;

/**
 * __useGetDailyResolvedAggregateLineItemEntriesQuery__
 *
 * To run a query within a React component, call `useGetDailyResolvedAggregateLineItemEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyResolvedAggregateLineItemEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyResolvedAggregateLineItemEntriesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      loanIds: // value for 'loanIds'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyResolvedAggregateLineItemEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>(GetDailyResolvedAggregateLineItemEntriesDocumentGQLType, options);
      }
export function useGetDailyResolvedAggregateLineItemEntriesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>(GetDailyResolvedAggregateLineItemEntriesDocumentGQLType, options);
        }
export type GetDailyResolvedAggregateLineItemEntriesQueryHookResult = ReturnType<typeof useGetDailyResolvedAggregateLineItemEntriesQuery>;
export type GetDailyResolvedAggregateLineItemEntriesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyResolvedAggregateLineItemEntriesLazyQueryGQLType>;
export type GetDailyResolvedAggregateLineItemEntriesQueryResultGQLType = Apollo.QueryResult<GetDailyResolvedAggregateLineItemEntriesQueryGQLType, GetDailyResolvedAggregateLineItemEntriesQueryVariablesGQLType>;
export const GetDailyAccountActivityDocumentGQLType = gql`
    query GetDailyAccountActivity($creditFacilityIds: [UUID!]!, $loanIds: [UUID!], $accountTypes: [TAccountType!], $startDate: FullDateStr!, $endDate: FullDateStr!) {
  activity: getDailyAccountActivity(
    creditFacilityIds: $creditFacilityIds
    loanIds: $loanIds
    accountTypes: $accountTypes
    startDate: $startDate
    endDate: $endDate
  ) {
    accountData {
      postingDate
      tAccount
      aggregateAmount
    }
    metadata {
      minDate
      maxDate
      accountTypes
      accountTotals {
        tAccount
        totalAmount
      }
      totalCurrentLiabilities
    }
  }
}
    `;

/**
 * __useGetDailyAccountActivityQuery__
 *
 * To run a query within a React component, call `useGetDailyAccountActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyAccountActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyAccountActivityQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      loanIds: // value for 'loanIds'
 *      accountTypes: // value for 'accountTypes'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyAccountActivityQuery(baseOptions: Apollo.QueryHookOptions<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>(GetDailyAccountActivityDocumentGQLType, options);
      }
export function useGetDailyAccountActivityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>(GetDailyAccountActivityDocumentGQLType, options);
        }
export type GetDailyAccountActivityQueryHookResult = ReturnType<typeof useGetDailyAccountActivityQuery>;
export type GetDailyAccountActivityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDailyAccountActivityLazyQueryGQLType>;
export type GetDailyAccountActivityQueryResultGQLType = Apollo.QueryResult<GetDailyAccountActivityQueryGQLType, GetDailyAccountActivityQueryVariablesGQLType>;
export const GetCreditFacilityMetricsDocumentGQLType = gql`
    query GetCreditFacilityMetrics($creditFacilityId: UUID!, $postingDate: FullDateStr!) {
  metrics: getCreditFacilityMetrics(
    creditFacilityId: $creditFacilityId
    postingDate: $postingDate
  ) {
    borrower {
      id
      name
    }
    commitmentAmount
    externalFacilityId
    outstandingPrincipalBalance
    utilization
    totalAccruedInterest
    totalAccruedServiceFees
  }
}
    `;

/**
 * __useGetCreditFacilityMetricsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilityMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilityMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilityMetricsQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      postingDate: // value for 'postingDate'
 *   },
 * });
 */
export function useGetCreditFacilityMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>(GetCreditFacilityMetricsDocumentGQLType, options);
      }
export function useGetCreditFacilityMetricsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>(GetCreditFacilityMetricsDocumentGQLType, options);
        }
export type GetCreditFacilityMetricsQueryHookResult = ReturnType<typeof useGetCreditFacilityMetricsQuery>;
export type GetCreditFacilityMetricsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilityMetricsLazyQueryGQLType>;
export type GetCreditFacilityMetricsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilityMetricsQueryGQLType, GetCreditFacilityMetricsQueryVariablesGQLType>;
export const GetLenderVerificationProgressBreakdownDocumentGQLType = gql`
    query GetLenderVerificationProgressBreakdown($artifactDocumentId: UUID!, $creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!) {
  lenderVerificationProgressBreakdown(
    artifactDocumentId: $artifactDocumentId
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    isRunning
    status
    uploadProgressBreakdown {
      stepDescription
      status {
        status
        errors
      }
    }
    progressBreakdown {
      stepDescription
      status {
        status
        errors
      }
    }
    servicerReportDownload {
      url
      filename
    }
    extendedResponseTapeDownloads {
      download {
        url
        filename
      }
      loanProductId
      loanProduct {
        id
        name
        slug
        implementationId
      }
    }
    initiatorDetails {
      firstName
      lastName
      organizationName
    }
  }
}
    `;

/**
 * __useGetLenderVerificationProgressBreakdownQuery__
 *
 * To run a query within a React component, call `useGetLenderVerificationProgressBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderVerificationProgressBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderVerificationProgressBreakdownQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetLenderVerificationProgressBreakdownQuery(baseOptions: Apollo.QueryHookOptions<GetLenderVerificationProgressBreakdownQueryGQLType, GetLenderVerificationProgressBreakdownQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderVerificationProgressBreakdownQueryGQLType, GetLenderVerificationProgressBreakdownQueryVariablesGQLType>(GetLenderVerificationProgressBreakdownDocumentGQLType, options);
      }
export function useGetLenderVerificationProgressBreakdownLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderVerificationProgressBreakdownQueryGQLType, GetLenderVerificationProgressBreakdownQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderVerificationProgressBreakdownQueryGQLType, GetLenderVerificationProgressBreakdownQueryVariablesGQLType>(GetLenderVerificationProgressBreakdownDocumentGQLType, options);
        }
export type GetLenderVerificationProgressBreakdownQueryHookResult = ReturnType<typeof useGetLenderVerificationProgressBreakdownQuery>;
export type GetLenderVerificationProgressBreakdownLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLenderVerificationProgressBreakdownLazyQueryGQLType>;
export type GetLenderVerificationProgressBreakdownQueryResultGQLType = Apollo.QueryResult<GetLenderVerificationProgressBreakdownQueryGQLType, GetLenderVerificationProgressBreakdownQueryVariablesGQLType>;
export const GetFundingRequestVerificationReportByMetadataDocumentGQLType = gql`
    query GetFundingRequestVerificationReportByMetadata($artifactDocumentId: UUID!, $creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!) {
  fundingRequestVerificationReportByMetadata(
    artifactDocumentId: $artifactDocumentId
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
  ) {
    verificationReportId
    verificationReport
    borrowingBaseReportId
    remediationRequested
    remediationNote
    artifactDocumentId
  }
}
    `;

/**
 * __useGetFundingRequestVerificationReportByMetadataQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestVerificationReportByMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestVerificationReportByMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestVerificationReportByMetadataQuery({
 *   variables: {
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *   },
 * });
 */
export function useGetFundingRequestVerificationReportByMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestVerificationReportByMetadataQueryGQLType, GetFundingRequestVerificationReportByMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestVerificationReportByMetadataQueryGQLType, GetFundingRequestVerificationReportByMetadataQueryVariablesGQLType>(GetFundingRequestVerificationReportByMetadataDocumentGQLType, options);
      }
export function useGetFundingRequestVerificationReportByMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestVerificationReportByMetadataQueryGQLType, GetFundingRequestVerificationReportByMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestVerificationReportByMetadataQueryGQLType, GetFundingRequestVerificationReportByMetadataQueryVariablesGQLType>(GetFundingRequestVerificationReportByMetadataDocumentGQLType, options);
        }
export type GetFundingRequestVerificationReportByMetadataQueryHookResult = ReturnType<typeof useGetFundingRequestVerificationReportByMetadataQuery>;
export type GetFundingRequestVerificationReportByMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestVerificationReportByMetadataLazyQueryGQLType>;
export type GetFundingRequestVerificationReportByMetadataQueryResultGQLType = Apollo.QueryResult<GetFundingRequestVerificationReportByMetadataQueryGQLType, GetFundingRequestVerificationReportByMetadataQueryVariablesGQLType>;
export const GetLenderVerificationCreditFacilitiesDocumentGQLType = gql`
    query GetLenderVerificationCreditFacilities($organizationId: UUID!) {
  lenderVerificationCreditFacilities(organizationId: $organizationId) {
    id
    slug
    name
  }
}
    `;

/**
 * __useGetLenderVerificationCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetLenderVerificationCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderVerificationCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderVerificationCreditFacilitiesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetLenderVerificationCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetLenderVerificationCreditFacilitiesQueryGQLType, GetLenderVerificationCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderVerificationCreditFacilitiesQueryGQLType, GetLenderVerificationCreditFacilitiesQueryVariablesGQLType>(GetLenderVerificationCreditFacilitiesDocumentGQLType, options);
      }
export function useGetLenderVerificationCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderVerificationCreditFacilitiesQueryGQLType, GetLenderVerificationCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderVerificationCreditFacilitiesQueryGQLType, GetLenderVerificationCreditFacilitiesQueryVariablesGQLType>(GetLenderVerificationCreditFacilitiesDocumentGQLType, options);
        }
export type GetLenderVerificationCreditFacilitiesQueryHookResult = ReturnType<typeof useGetLenderVerificationCreditFacilitiesQuery>;
export type GetLenderVerificationCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLenderVerificationCreditFacilitiesLazyQueryGQLType>;
export type GetLenderVerificationCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetLenderVerificationCreditFacilitiesQueryGQLType, GetLenderVerificationCreditFacilitiesQueryVariablesGQLType>;
export const GetFundingVerificationPipelineRunsDocumentGQLType = gql`
    query GetFundingVerificationPipelineRuns($organizationId: UUID!) {
  fundingVerificationPipelineRuns(organizationId: $organizationId) {
    artifactDocumentId
    creditFacilityId
    reportingDate
    fileVersion
    goalArtifactIds
    status
    initiatorDetails {
      firstName
      lastName
      organizationName
    }
  }
}
    `;

/**
 * __useGetFundingVerificationPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetFundingVerificationPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingVerificationPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingVerificationPipelineRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetFundingVerificationPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetFundingVerificationPipelineRunsQueryGQLType, GetFundingVerificationPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingVerificationPipelineRunsQueryGQLType, GetFundingVerificationPipelineRunsQueryVariablesGQLType>(GetFundingVerificationPipelineRunsDocumentGQLType, options);
      }
export function useGetFundingVerificationPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingVerificationPipelineRunsQueryGQLType, GetFundingVerificationPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingVerificationPipelineRunsQueryGQLType, GetFundingVerificationPipelineRunsQueryVariablesGQLType>(GetFundingVerificationPipelineRunsDocumentGQLType, options);
        }
export type GetFundingVerificationPipelineRunsQueryHookResult = ReturnType<typeof useGetFundingVerificationPipelineRunsQuery>;
export type GetFundingVerificationPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingVerificationPipelineRunsLazyQueryGQLType>;
export type GetFundingVerificationPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetFundingVerificationPipelineRunsQueryGQLType, GetFundingVerificationPipelineRunsQueryVariablesGQLType>;
export const GetActionableFundingVerificationPipelineRunsDocumentGQLType = gql`
    query GetActionableFundingVerificationPipelineRuns($organizationId: UUID!) {
  actionableFundingVerificationPipelineRuns(organizationId: $organizationId) {
    artifactDocumentId
    creditFacilityId
    reportingDate
    fileVersion
    goalArtifactIds
    status
  }
}
    `;

/**
 * __useGetActionableFundingVerificationPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetActionableFundingVerificationPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionableFundingVerificationPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionableFundingVerificationPipelineRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetActionableFundingVerificationPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetActionableFundingVerificationPipelineRunsQueryGQLType, GetActionableFundingVerificationPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionableFundingVerificationPipelineRunsQueryGQLType, GetActionableFundingVerificationPipelineRunsQueryVariablesGQLType>(GetActionableFundingVerificationPipelineRunsDocumentGQLType, options);
      }
export function useGetActionableFundingVerificationPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActionableFundingVerificationPipelineRunsQueryGQLType, GetActionableFundingVerificationPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionableFundingVerificationPipelineRunsQueryGQLType, GetActionableFundingVerificationPipelineRunsQueryVariablesGQLType>(GetActionableFundingVerificationPipelineRunsDocumentGQLType, options);
        }
export type GetActionableFundingVerificationPipelineRunsQueryHookResult = ReturnType<typeof useGetActionableFundingVerificationPipelineRunsQuery>;
export type GetActionableFundingVerificationPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActionableFundingVerificationPipelineRunsLazyQueryGQLType>;
export type GetActionableFundingVerificationPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetActionableFundingVerificationPipelineRunsQueryGQLType, GetActionableFundingVerificationPipelineRunsQueryVariablesGQLType>;
export const GetFundingRequestVerificationReceivableEligibilityDocumentGQLType = gql`
    query GetFundingRequestVerificationReceivableEligibility($verificationReportId: UUID!, $creditFacilityId: UUID!) {
  fundingRequestVerificationReceivableEligibility(
    verificationReportId: $verificationReportId
    creditFacilityId: $creditFacilityId
  ) {
    reportingDate
    verificationEligibilityReceivables {
      id
      fundingVerificationReportId
      externalReceivableId
      finleyReceivableId
      eligibilityCriteriaKey
      exposure
      borrowerEligible
      finleyEligibilityStatus
      loanProductId
      note
      waived
      eligibleExposure
      borrowerFormula
      baseFields
    }
  }
}
    `;

/**
 * __useGetFundingRequestVerificationReceivableEligibilityQuery__
 *
 * To run a query within a React component, call `useGetFundingRequestVerificationReceivableEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingRequestVerificationReceivableEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingRequestVerificationReceivableEligibilityQuery({
 *   variables: {
 *      verificationReportId: // value for 'verificationReportId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetFundingRequestVerificationReceivableEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GetFundingRequestVerificationReceivableEligibilityQueryGQLType, GetFundingRequestVerificationReceivableEligibilityQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingRequestVerificationReceivableEligibilityQueryGQLType, GetFundingRequestVerificationReceivableEligibilityQueryVariablesGQLType>(GetFundingRequestVerificationReceivableEligibilityDocumentGQLType, options);
      }
export function useGetFundingRequestVerificationReceivableEligibilityLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingRequestVerificationReceivableEligibilityQueryGQLType, GetFundingRequestVerificationReceivableEligibilityQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingRequestVerificationReceivableEligibilityQueryGQLType, GetFundingRequestVerificationReceivableEligibilityQueryVariablesGQLType>(GetFundingRequestVerificationReceivableEligibilityDocumentGQLType, options);
        }
export type GetFundingRequestVerificationReceivableEligibilityQueryHookResult = ReturnType<typeof useGetFundingRequestVerificationReceivableEligibilityQuery>;
export type GetFundingRequestVerificationReceivableEligibilityLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFundingRequestVerificationReceivableEligibilityLazyQueryGQLType>;
export type GetFundingRequestVerificationReceivableEligibilityQueryResultGQLType = Apollo.QueryResult<GetFundingRequestVerificationReceivableEligibilityQueryGQLType, GetFundingRequestVerificationReceivableEligibilityQueryVariablesGQLType>;
export const NotifyVerificationReportReadyForReviewDocumentGQLType = gql`
    mutation NotifyVerificationReportReadyForReview($verificationReportId: UUID!) {
  notifyVerificationReportReadyForReview(
    verificationReportId: $verificationReportId
  ) {
    response
  }
}
    `;
export type NotifyVerificationReportReadyForReviewMutationFnGQLType = Apollo.MutationFunction<NotifyVerificationReportReadyForReviewMutationGQLType, NotifyVerificationReportReadyForReviewMutationVariablesGQLType>;

/**
 * __useNotifyVerificationReportReadyForReviewMutation__
 *
 * To run a mutation, you first call `useNotifyVerificationReportReadyForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyVerificationReportReadyForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyVerificationReportReadyForReviewMutation, { data, loading, error }] = useNotifyVerificationReportReadyForReviewMutation({
 *   variables: {
 *      verificationReportId: // value for 'verificationReportId'
 *   },
 * });
 */
export function useNotifyVerificationReportReadyForReviewMutation(baseOptions?: Apollo.MutationHookOptions<NotifyVerificationReportReadyForReviewMutationGQLType, NotifyVerificationReportReadyForReviewMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyVerificationReportReadyForReviewMutationGQLType, NotifyVerificationReportReadyForReviewMutationVariablesGQLType>(NotifyVerificationReportReadyForReviewDocumentGQLType, options);
      }
export type NotifyVerificationReportReadyForReviewMutationHookResult = ReturnType<typeof useNotifyVerificationReportReadyForReviewMutation>;
export type NotifyVerificationReportReadyForReviewMutationResultGQLType = Apollo.MutationResult<NotifyVerificationReportReadyForReviewMutationGQLType>;
export type NotifyVerificationReportReadyForReviewMutationOptionsGQLType = Apollo.BaseMutationOptions<NotifyVerificationReportReadyForReviewMutationGQLType, NotifyVerificationReportReadyForReviewMutationVariablesGQLType>;
export const AdjudicateFundingRequestVerificationReportDocumentGQLType = gql`
    mutation AdjudicateFundingRequestVerificationReport($verificationReportId: UUID!, $action: VerificationReportAdjudicationAction!, $note: String) {
  adjudicateFundingRequestVerificationReport(
    verificationReportId: $verificationReportId
    action: $action
    note: $note
  ) {
    response
  }
}
    `;
export type AdjudicateFundingRequestVerificationReportMutationFnGQLType = Apollo.MutationFunction<AdjudicateFundingRequestVerificationReportMutationGQLType, AdjudicateFundingRequestVerificationReportMutationVariablesGQLType>;

/**
 * __useAdjudicateFundingRequestVerificationReportMutation__
 *
 * To run a mutation, you first call `useAdjudicateFundingRequestVerificationReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjudicateFundingRequestVerificationReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjudicateFundingRequestVerificationReportMutation, { data, loading, error }] = useAdjudicateFundingRequestVerificationReportMutation({
 *   variables: {
 *      verificationReportId: // value for 'verificationReportId'
 *      action: // value for 'action'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAdjudicateFundingRequestVerificationReportMutation(baseOptions?: Apollo.MutationHookOptions<AdjudicateFundingRequestVerificationReportMutationGQLType, AdjudicateFundingRequestVerificationReportMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjudicateFundingRequestVerificationReportMutationGQLType, AdjudicateFundingRequestVerificationReportMutationVariablesGQLType>(AdjudicateFundingRequestVerificationReportDocumentGQLType, options);
      }
export type AdjudicateFundingRequestVerificationReportMutationHookResult = ReturnType<typeof useAdjudicateFundingRequestVerificationReportMutation>;
export type AdjudicateFundingRequestVerificationReportMutationResultGQLType = Apollo.MutationResult<AdjudicateFundingRequestVerificationReportMutationGQLType>;
export type AdjudicateFundingRequestVerificationReportMutationOptionsGQLType = Apollo.BaseMutationOptions<AdjudicateFundingRequestVerificationReportMutationGQLType, AdjudicateFundingRequestVerificationReportMutationVariablesGQLType>;
export const CreateAssetVerificationRecordDocumentGQLType = gql`
    mutation CreateAssetVerificationRecord($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!, $artifactDocumentId: UUID!, $finleyReceivableId: UUID!) {
  createAssetVerificationRecord(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    artifactDocumentId: $artifactDocumentId
    finleyReceivableId: $finleyReceivableId
  ) {
    response
  }
}
    `;
export type CreateAssetVerificationRecordMutationFnGQLType = Apollo.MutationFunction<CreateAssetVerificationRecordMutationGQLType, CreateAssetVerificationRecordMutationVariablesGQLType>;

/**
 * __useCreateAssetVerificationRecordMutation__
 *
 * To run a mutation, you first call `useCreateAssetVerificationRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetVerificationRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetVerificationRecordMutation, { data, loading, error }] = useCreateAssetVerificationRecordMutation({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      finleyReceivableId: // value for 'finleyReceivableId'
 *   },
 * });
 */
export function useCreateAssetVerificationRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetVerificationRecordMutationGQLType, CreateAssetVerificationRecordMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetVerificationRecordMutationGQLType, CreateAssetVerificationRecordMutationVariablesGQLType>(CreateAssetVerificationRecordDocumentGQLType, options);
      }
export type CreateAssetVerificationRecordMutationHookResult = ReturnType<typeof useCreateAssetVerificationRecordMutation>;
export type CreateAssetVerificationRecordMutationResultGQLType = Apollo.MutationResult<CreateAssetVerificationRecordMutationGQLType>;
export type CreateAssetVerificationRecordMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateAssetVerificationRecordMutationGQLType, CreateAssetVerificationRecordMutationVariablesGQLType>;
export const UpdateFundingVerificationReceivableEligibilityDocumentGQLType = gql`
    mutation UpdateFundingVerificationReceivableEligibility($receivableEligibility: [UpdateFundingVerificationReceivableEligibilityChangeset!]!) {
  updateFundingVerificationReceivableEligibility(
    receivableEligibility: $receivableEligibility
  ) {
    response
  }
}
    `;
export type UpdateFundingVerificationReceivableEligibilityMutationFnGQLType = Apollo.MutationFunction<UpdateFundingVerificationReceivableEligibilityMutationGQLType, UpdateFundingVerificationReceivableEligibilityMutationVariablesGQLType>;

/**
 * __useUpdateFundingVerificationReceivableEligibilityMutation__
 *
 * To run a mutation, you first call `useUpdateFundingVerificationReceivableEligibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundingVerificationReceivableEligibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFundingVerificationReceivableEligibilityMutation, { data, loading, error }] = useUpdateFundingVerificationReceivableEligibilityMutation({
 *   variables: {
 *      receivableEligibility: // value for 'receivableEligibility'
 *   },
 * });
 */
export function useUpdateFundingVerificationReceivableEligibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFundingVerificationReceivableEligibilityMutationGQLType, UpdateFundingVerificationReceivableEligibilityMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFundingVerificationReceivableEligibilityMutationGQLType, UpdateFundingVerificationReceivableEligibilityMutationVariablesGQLType>(UpdateFundingVerificationReceivableEligibilityDocumentGQLType, options);
      }
export type UpdateFundingVerificationReceivableEligibilityMutationHookResult = ReturnType<typeof useUpdateFundingVerificationReceivableEligibilityMutation>;
export type UpdateFundingVerificationReceivableEligibilityMutationResultGQLType = Apollo.MutationResult<UpdateFundingVerificationReceivableEligibilityMutationGQLType>;
export type UpdateFundingVerificationReceivableEligibilityMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateFundingVerificationReceivableEligibilityMutationGQLType, UpdateFundingVerificationReceivableEligibilityMutationVariablesGQLType>;
export const GetIsAssetVerificationRequiredDocumentGQLType = gql`
    query GetIsAssetVerificationRequired($creditFacilityId: UUID!, $artifactDocumentId: UUID!) {
  isAssetVerificationRequired(
    creditFacilityId: $creditFacilityId
    artifactDocumentId: $artifactDocumentId
  )
}
    `;

/**
 * __useGetIsAssetVerificationRequiredQuery__
 *
 * To run a query within a React component, call `useGetIsAssetVerificationRequiredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsAssetVerificationRequiredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsAssetVerificationRequiredQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *   },
 * });
 */
export function useGetIsAssetVerificationRequiredQuery(baseOptions: Apollo.QueryHookOptions<GetIsAssetVerificationRequiredQueryGQLType, GetIsAssetVerificationRequiredQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsAssetVerificationRequiredQueryGQLType, GetIsAssetVerificationRequiredQueryVariablesGQLType>(GetIsAssetVerificationRequiredDocumentGQLType, options);
      }
export function useGetIsAssetVerificationRequiredLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetIsAssetVerificationRequiredQueryGQLType, GetIsAssetVerificationRequiredQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsAssetVerificationRequiredQueryGQLType, GetIsAssetVerificationRequiredQueryVariablesGQLType>(GetIsAssetVerificationRequiredDocumentGQLType, options);
        }
export type GetIsAssetVerificationRequiredQueryHookResult = ReturnType<typeof useGetIsAssetVerificationRequiredQuery>;
export type GetIsAssetVerificationRequiredLazyQueryGQLTypeHookResult = ReturnType<typeof useGetIsAssetVerificationRequiredLazyQueryGQLType>;
export type GetIsAssetVerificationRequiredQueryResultGQLType = Apollo.QueryResult<GetIsAssetVerificationRequiredQueryGQLType, GetIsAssetVerificationRequiredQueryVariablesGQLType>;
export const GetAssetVerificationReceivableHistoryDocumentGQLType = gql`
    query GetAssetVerificationReceivableHistory($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $artifactDocumentId: UUID!, $fileVersion: Int!, $loanProductId: UUID) {
  assetVerificationReceivableHistory(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    artifactDocumentId: $artifactDocumentId
    fileVersion: $fileVersion
    loanProductId: $loanProductId
  ) {
    assignedAtDate
    totalAssignedAtExposure
    totalUntestedAssignedAtExposure
    totalUnverifiedFailureAssignedAtExposure
    totalVerifiedFailureAssignedAtExposure
    totalVerifiedPassAssignedAtExposure
    totalReceivableCount
    verifiedPassReceivableCount
    verifiedFailureReceivableCount
    unverifiedFailureReceivableCount
    untestedReceivableCount
  }
}
    `;

/**
 * __useGetAssetVerificationReceivableHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssetVerificationReceivableHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetVerificationReceivableHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetVerificationReceivableHistoryQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      fileVersion: // value for 'fileVersion'
 *      loanProductId: // value for 'loanProductId'
 *   },
 * });
 */
export function useGetAssetVerificationReceivableHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAssetVerificationReceivableHistoryQueryGQLType, GetAssetVerificationReceivableHistoryQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetVerificationReceivableHistoryQueryGQLType, GetAssetVerificationReceivableHistoryQueryVariablesGQLType>(GetAssetVerificationReceivableHistoryDocumentGQLType, options);
      }
export function useGetAssetVerificationReceivableHistoryLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetVerificationReceivableHistoryQueryGQLType, GetAssetVerificationReceivableHistoryQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetVerificationReceivableHistoryQueryGQLType, GetAssetVerificationReceivableHistoryQueryVariablesGQLType>(GetAssetVerificationReceivableHistoryDocumentGQLType, options);
        }
export type GetAssetVerificationReceivableHistoryQueryHookResult = ReturnType<typeof useGetAssetVerificationReceivableHistoryQuery>;
export type GetAssetVerificationReceivableHistoryLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssetVerificationReceivableHistoryLazyQueryGQLType>;
export type GetAssetVerificationReceivableHistoryQueryResultGQLType = Apollo.QueryResult<GetAssetVerificationReceivableHistoryQueryGQLType, GetAssetVerificationReceivableHistoryQueryVariablesGQLType>;
export const GetAssetVerificationReceivablesByMetadataDocumentGQLType = gql`
    query GetAssetVerificationReceivablesByMetadata($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $artifactDocumentId: UUID!, $fileVersion: Int!, $loanProductId: UUID) {
  assetVerificationReportByMetadata(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    artifactDocumentId: $artifactDocumentId
    fileVersion: $fileVersion
    loanProductId: $loanProductId
  )
}
    `;

/**
 * __useGetAssetVerificationReceivablesByMetadataQuery__
 *
 * To run a query within a React component, call `useGetAssetVerificationReceivablesByMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetVerificationReceivablesByMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetVerificationReceivablesByMetadataQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      fileVersion: // value for 'fileVersion'
 *      loanProductId: // value for 'loanProductId'
 *   },
 * });
 */
export function useGetAssetVerificationReceivablesByMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetAssetVerificationReceivablesByMetadataQueryGQLType, GetAssetVerificationReceivablesByMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetVerificationReceivablesByMetadataQueryGQLType, GetAssetVerificationReceivablesByMetadataQueryVariablesGQLType>(GetAssetVerificationReceivablesByMetadataDocumentGQLType, options);
      }
export function useGetAssetVerificationReceivablesByMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetVerificationReceivablesByMetadataQueryGQLType, GetAssetVerificationReceivablesByMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetVerificationReceivablesByMetadataQueryGQLType, GetAssetVerificationReceivablesByMetadataQueryVariablesGQLType>(GetAssetVerificationReceivablesByMetadataDocumentGQLType, options);
        }
export type GetAssetVerificationReceivablesByMetadataQueryHookResult = ReturnType<typeof useGetAssetVerificationReceivablesByMetadataQuery>;
export type GetAssetVerificationReceivablesByMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssetVerificationReceivablesByMetadataLazyQueryGQLType>;
export type GetAssetVerificationReceivablesByMetadataQueryResultGQLType = Apollo.QueryResult<GetAssetVerificationReceivablesByMetadataQueryGQLType, GetAssetVerificationReceivablesByMetadataQueryVariablesGQLType>;
export const GetStoredAssetVerificationReceivablesByMetadataDocumentGQLType = gql`
    query GetStoredAssetVerificationReceivablesByMetadata($creditFacilityId: UUID!, $reportingDate: FullDateStr!, $artifactDocumentId: UUID!, $fileVersion: Int!, $loanProductId: UUID) {
  assetVerificationReportByMetadataStored(
    creditFacilityId: $creditFacilityId
    reportingDate: $reportingDate
    artifactDocumentId: $artifactDocumentId
    fileVersion: $fileVersion
    loanProductId: $loanProductId
  )
}
    `;

/**
 * __useGetStoredAssetVerificationReceivablesByMetadataQuery__
 *
 * To run a query within a React component, call `useGetStoredAssetVerificationReceivablesByMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoredAssetVerificationReceivablesByMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoredAssetVerificationReceivablesByMetadataQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      reportingDate: // value for 'reportingDate'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *      fileVersion: // value for 'fileVersion'
 *      loanProductId: // value for 'loanProductId'
 *   },
 * });
 */
export function useGetStoredAssetVerificationReceivablesByMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetStoredAssetVerificationReceivablesByMetadataQueryGQLType, GetStoredAssetVerificationReceivablesByMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoredAssetVerificationReceivablesByMetadataQueryGQLType, GetStoredAssetVerificationReceivablesByMetadataQueryVariablesGQLType>(GetStoredAssetVerificationReceivablesByMetadataDocumentGQLType, options);
      }
export function useGetStoredAssetVerificationReceivablesByMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetStoredAssetVerificationReceivablesByMetadataQueryGQLType, GetStoredAssetVerificationReceivablesByMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoredAssetVerificationReceivablesByMetadataQueryGQLType, GetStoredAssetVerificationReceivablesByMetadataQueryVariablesGQLType>(GetStoredAssetVerificationReceivablesByMetadataDocumentGQLType, options);
        }
export type GetStoredAssetVerificationReceivablesByMetadataQueryHookResult = ReturnType<typeof useGetStoredAssetVerificationReceivablesByMetadataQuery>;
export type GetStoredAssetVerificationReceivablesByMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetStoredAssetVerificationReceivablesByMetadataLazyQueryGQLType>;
export type GetStoredAssetVerificationReceivablesByMetadataQueryResultGQLType = Apollo.QueryResult<GetStoredAssetVerificationReceivablesByMetadataQueryGQLType, GetStoredAssetVerificationReceivablesByMetadataQueryVariablesGQLType>;
export const GetAssetVerificationDocumentByRawIdDocumentGQLType = gql`
    query GetAssetVerificationDocumentByRawId($receivableDocumentationRawId: UUID!) {
  assetVerificationDocumentByRawId(
    receivableDocumentationRawId: $receivableDocumentationRawId
  )
}
    `;

/**
 * __useGetAssetVerificationDocumentByRawIdQuery__
 *
 * To run a query within a React component, call `useGetAssetVerificationDocumentByRawIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetVerificationDocumentByRawIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetVerificationDocumentByRawIdQuery({
 *   variables: {
 *      receivableDocumentationRawId: // value for 'receivableDocumentationRawId'
 *   },
 * });
 */
export function useGetAssetVerificationDocumentByRawIdQuery(baseOptions: Apollo.QueryHookOptions<GetAssetVerificationDocumentByRawIdQueryGQLType, GetAssetVerificationDocumentByRawIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetVerificationDocumentByRawIdQueryGQLType, GetAssetVerificationDocumentByRawIdQueryVariablesGQLType>(GetAssetVerificationDocumentByRawIdDocumentGQLType, options);
      }
export function useGetAssetVerificationDocumentByRawIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetVerificationDocumentByRawIdQueryGQLType, GetAssetVerificationDocumentByRawIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetVerificationDocumentByRawIdQueryGQLType, GetAssetVerificationDocumentByRawIdQueryVariablesGQLType>(GetAssetVerificationDocumentByRawIdDocumentGQLType, options);
        }
export type GetAssetVerificationDocumentByRawIdQueryHookResult = ReturnType<typeof useGetAssetVerificationDocumentByRawIdQuery>;
export type GetAssetVerificationDocumentByRawIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssetVerificationDocumentByRawIdLazyQueryGQLType>;
export type GetAssetVerificationDocumentByRawIdQueryResultGQLType = Apollo.QueryResult<GetAssetVerificationDocumentByRawIdQueryGQLType, GetAssetVerificationDocumentByRawIdQueryVariablesGQLType>;
export const GetAssetVerificationDocumentSignedUrllDocumentGQLType = gql`
    query GetAssetVerificationDocumentSignedUrll($receivableDocumentationRawId: UUID!, $creditFacilityId: UUID!, $artifactDocumentId: UUID!) {
  assetVerificationDocumentSignedUrl(
    receivableDocumentationRawId: $receivableDocumentationRawId
    creditFacilityId: $creditFacilityId
    artifactDocumentId: $artifactDocumentId
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetAssetVerificationDocumentSignedUrllQuery__
 *
 * To run a query within a React component, call `useGetAssetVerificationDocumentSignedUrllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetVerificationDocumentSignedUrllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetVerificationDocumentSignedUrllQuery({
 *   variables: {
 *      receivableDocumentationRawId: // value for 'receivableDocumentationRawId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *      artifactDocumentId: // value for 'artifactDocumentId'
 *   },
 * });
 */
export function useGetAssetVerificationDocumentSignedUrllQuery(baseOptions: Apollo.QueryHookOptions<GetAssetVerificationDocumentSignedUrllQueryGQLType, GetAssetVerificationDocumentSignedUrllQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetVerificationDocumentSignedUrllQueryGQLType, GetAssetVerificationDocumentSignedUrllQueryVariablesGQLType>(GetAssetVerificationDocumentSignedUrllDocumentGQLType, options);
      }
export function useGetAssetVerificationDocumentSignedUrllLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetVerificationDocumentSignedUrllQueryGQLType, GetAssetVerificationDocumentSignedUrllQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetVerificationDocumentSignedUrllQueryGQLType, GetAssetVerificationDocumentSignedUrllQueryVariablesGQLType>(GetAssetVerificationDocumentSignedUrllDocumentGQLType, options);
        }
export type GetAssetVerificationDocumentSignedUrllQueryHookResult = ReturnType<typeof useGetAssetVerificationDocumentSignedUrllQuery>;
export type GetAssetVerificationDocumentSignedUrllLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAssetVerificationDocumentSignedUrllLazyQueryGQLType>;
export type GetAssetVerificationDocumentSignedUrllQueryResultGQLType = Apollo.QueryResult<GetAssetVerificationDocumentSignedUrllQueryGQLType, GetAssetVerificationDocumentSignedUrllQueryVariablesGQLType>;
export const GetVerificationBorrowingBaseWaiverImpactDocumentGQLType = gql`
    query GetVerificationBorrowingBaseWaiverImpact($verificationReportId: UUID!, $creditFacilityId: UUID!) {
  verificationBorrowingBaseWaiverImpact(
    verificationReportId: $verificationReportId
    creditFacilityId: $creditFacilityId
  )
}
    `;

/**
 * __useGetVerificationBorrowingBaseWaiverImpactQuery__
 *
 * To run a query within a React component, call `useGetVerificationBorrowingBaseWaiverImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerificationBorrowingBaseWaiverImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerificationBorrowingBaseWaiverImpactQuery({
 *   variables: {
 *      verificationReportId: // value for 'verificationReportId'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetVerificationBorrowingBaseWaiverImpactQuery(baseOptions: Apollo.QueryHookOptions<GetVerificationBorrowingBaseWaiverImpactQueryGQLType, GetVerificationBorrowingBaseWaiverImpactQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerificationBorrowingBaseWaiverImpactQueryGQLType, GetVerificationBorrowingBaseWaiverImpactQueryVariablesGQLType>(GetVerificationBorrowingBaseWaiverImpactDocumentGQLType, options);
      }
export function useGetVerificationBorrowingBaseWaiverImpactLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetVerificationBorrowingBaseWaiverImpactQueryGQLType, GetVerificationBorrowingBaseWaiverImpactQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerificationBorrowingBaseWaiverImpactQueryGQLType, GetVerificationBorrowingBaseWaiverImpactQueryVariablesGQLType>(GetVerificationBorrowingBaseWaiverImpactDocumentGQLType, options);
        }
export type GetVerificationBorrowingBaseWaiverImpactQueryHookResult = ReturnType<typeof useGetVerificationBorrowingBaseWaiverImpactQuery>;
export type GetVerificationBorrowingBaseWaiverImpactLazyQueryGQLTypeHookResult = ReturnType<typeof useGetVerificationBorrowingBaseWaiverImpactLazyQueryGQLType>;
export type GetVerificationBorrowingBaseWaiverImpactQueryResultGQLType = Apollo.QueryResult<GetVerificationBorrowingBaseWaiverImpactQueryGQLType, GetVerificationBorrowingBaseWaiverImpactQueryVariablesGQLType>;
export const GetWorkflowTemplateConstructorDocumentGQLType = gql`
    query GetWorkflowTemplateConstructor($workflowType: WorkflowType!, $organizationId: UUID!) {
  getWorkflowTemplateConstructor(
    workflowType: $workflowType
    organizationId: $organizationId
  ) {
    ...WorkflowTemplateConstructorFields
  }
}
    ${WorkflowTemplateConstructorFieldsFragmentDocGQLType}`;

/**
 * __useGetWorkflowTemplateConstructorQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTemplateConstructorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTemplateConstructorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTemplateConstructorQuery({
 *   variables: {
 *      workflowType: // value for 'workflowType'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkflowTemplateConstructorQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowTemplateConstructorQueryGQLType, GetWorkflowTemplateConstructorQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowTemplateConstructorQueryGQLType, GetWorkflowTemplateConstructorQueryVariablesGQLType>(GetWorkflowTemplateConstructorDocumentGQLType, options);
      }
export function useGetWorkflowTemplateConstructorLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowTemplateConstructorQueryGQLType, GetWorkflowTemplateConstructorQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowTemplateConstructorQueryGQLType, GetWorkflowTemplateConstructorQueryVariablesGQLType>(GetWorkflowTemplateConstructorDocumentGQLType, options);
        }
export type GetWorkflowTemplateConstructorQueryHookResult = ReturnType<typeof useGetWorkflowTemplateConstructorQuery>;
export type GetWorkflowTemplateConstructorLazyQueryGQLTypeHookResult = ReturnType<typeof useGetWorkflowTemplateConstructorLazyQueryGQLType>;
export type GetWorkflowTemplateConstructorQueryResultGQLType = Apollo.QueryResult<GetWorkflowTemplateConstructorQueryGQLType, GetWorkflowTemplateConstructorQueryVariablesGQLType>;
export const GetWorkflowTemplateDocumentGQLType = gql`
    query GetWorkflowTemplate($workflowTemplateId: UUID!) {
  getWorkflowTemplate(workflowTemplateId: $workflowTemplateId) {
    ...WorkflowTemplateFields
  }
}
    ${WorkflowTemplateFieldsFragmentDocGQLType}`;

/**
 * __useGetWorkflowTemplateQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTemplateQuery({
 *   variables: {
 *      workflowTemplateId: // value for 'workflowTemplateId'
 *   },
 * });
 */
export function useGetWorkflowTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowTemplateQueryGQLType, GetWorkflowTemplateQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowTemplateQueryGQLType, GetWorkflowTemplateQueryVariablesGQLType>(GetWorkflowTemplateDocumentGQLType, options);
      }
export function useGetWorkflowTemplateLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowTemplateQueryGQLType, GetWorkflowTemplateQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowTemplateQueryGQLType, GetWorkflowTemplateQueryVariablesGQLType>(GetWorkflowTemplateDocumentGQLType, options);
        }
export type GetWorkflowTemplateQueryHookResult = ReturnType<typeof useGetWorkflowTemplateQuery>;
export type GetWorkflowTemplateLazyQueryGQLTypeHookResult = ReturnType<typeof useGetWorkflowTemplateLazyQueryGQLType>;
export type GetWorkflowTemplateQueryResultGQLType = Apollo.QueryResult<GetWorkflowTemplateQueryGQLType, GetWorkflowTemplateQueryVariablesGQLType>;
export const GetWorkflowTemplatesDocumentGQLType = gql`
    query GetWorkflowTemplates($workflowType: WorkflowType!, $organizationId: UUID!) {
  getWorkflowTemplates(
    workflowType: $workflowType
    organizationId: $organizationId
  ) {
    ...WorkflowTemplateFields
  }
}
    ${WorkflowTemplateFieldsFragmentDocGQLType}`;

/**
 * __useGetWorkflowTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTemplatesQuery({
 *   variables: {
 *      workflowType: // value for 'workflowType'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkflowTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowTemplatesQueryGQLType, GetWorkflowTemplatesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowTemplatesQueryGQLType, GetWorkflowTemplatesQueryVariablesGQLType>(GetWorkflowTemplatesDocumentGQLType, options);
      }
export function useGetWorkflowTemplatesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowTemplatesQueryGQLType, GetWorkflowTemplatesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowTemplatesQueryGQLType, GetWorkflowTemplatesQueryVariablesGQLType>(GetWorkflowTemplatesDocumentGQLType, options);
        }
export type GetWorkflowTemplatesQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesQuery>;
export type GetWorkflowTemplatesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetWorkflowTemplatesLazyQueryGQLType>;
export type GetWorkflowTemplatesQueryResultGQLType = Apollo.QueryResult<GetWorkflowTemplatesQueryGQLType, GetWorkflowTemplatesQueryVariablesGQLType>;
export const CreateWorkflowTemplateDocumentGQLType = gql`
    mutation CreateWorkflowTemplate($workflowId: UUID!, $workflowType: WorkflowType!, $workflow: WorkflowGraphObjectInput!, $name: String!, $organizationId: UUID!, $authorUserId: UUID!) {
  createWorkflowTemplate(
    workflowId: $workflowId
    workflowType: $workflowType
    workflow: $workflow
    name: $name
    organizationId: $organizationId
    authorUserId: $authorUserId
  ) {
    ... on ErrorCreateWorkflowTemplateResponse {
      status
      errors
    }
    ... on SuccessCreateWorkflowTemplateResponse {
      status
      template {
        ...WorkflowTemplateFields
      }
    }
  }
}
    ${WorkflowTemplateFieldsFragmentDocGQLType}`;
export type CreateWorkflowTemplateMutationFnGQLType = Apollo.MutationFunction<CreateWorkflowTemplateMutationGQLType, CreateWorkflowTemplateMutationVariablesGQLType>;

/**
 * __useCreateWorkflowTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowTemplateMutation, { data, loading, error }] = useCreateWorkflowTemplateMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      workflowType: // value for 'workflowType'
 *      workflow: // value for 'workflow'
 *      name: // value for 'name'
 *      organizationId: // value for 'organizationId'
 *      authorUserId: // value for 'authorUserId'
 *   },
 * });
 */
export function useCreateWorkflowTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowTemplateMutationGQLType, CreateWorkflowTemplateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowTemplateMutationGQLType, CreateWorkflowTemplateMutationVariablesGQLType>(CreateWorkflowTemplateDocumentGQLType, options);
      }
export type CreateWorkflowTemplateMutationHookResult = ReturnType<typeof useCreateWorkflowTemplateMutation>;
export type CreateWorkflowTemplateMutationResultGQLType = Apollo.MutationResult<CreateWorkflowTemplateMutationGQLType>;
export type CreateWorkflowTemplateMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateWorkflowTemplateMutationGQLType, CreateWorkflowTemplateMutationVariablesGQLType>;
export const RequestApprovalForFundingRequestDocumentGQLType = gql`
    mutation RequestApprovalForFundingRequest($fundingRequestId: UUID!, $workflowInstanceId: UUID!, $approverUserId: UUID!) {
  requestApprovalForFundingRequest(
    fundingRequestId: $fundingRequestId
    workflowInstanceId: $workflowInstanceId
    approverUserId: $approverUserId
  ) {
    fundingRequestId
    response
  }
}
    `;
export type RequestApprovalForFundingRequestMutationFnGQLType = Apollo.MutationFunction<RequestApprovalForFundingRequestMutationGQLType, RequestApprovalForFundingRequestMutationVariablesGQLType>;

/**
 * __useRequestApprovalForFundingRequestMutation__
 *
 * To run a mutation, you first call `useRequestApprovalForFundingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApprovalForFundingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApprovalForFundingRequestMutation, { data, loading, error }] = useRequestApprovalForFundingRequestMutation({
 *   variables: {
 *      fundingRequestId: // value for 'fundingRequestId'
 *      workflowInstanceId: // value for 'workflowInstanceId'
 *      approverUserId: // value for 'approverUserId'
 *   },
 * });
 */
export function useRequestApprovalForFundingRequestMutation(baseOptions?: Apollo.MutationHookOptions<RequestApprovalForFundingRequestMutationGQLType, RequestApprovalForFundingRequestMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApprovalForFundingRequestMutationGQLType, RequestApprovalForFundingRequestMutationVariablesGQLType>(RequestApprovalForFundingRequestDocumentGQLType, options);
      }
export type RequestApprovalForFundingRequestMutationHookResult = ReturnType<typeof useRequestApprovalForFundingRequestMutation>;
export type RequestApprovalForFundingRequestMutationResultGQLType = Apollo.MutationResult<RequestApprovalForFundingRequestMutationGQLType>;
export type RequestApprovalForFundingRequestMutationOptionsGQLType = Apollo.BaseMutationOptions<RequestApprovalForFundingRequestMutationGQLType, RequestApprovalForFundingRequestMutationVariablesGQLType>;
export const GetUserTablePreferenceDocumentGQLType = gql`
    query GetUserTablePreference($tableKey: String!, $defaultTableColumnConfiguration: DefaultTableColumnConfigurationInput!) {
  getUserTablePreference(
    tableKey: $tableKey
    defaultTableColumnConfiguration: $defaultTableColumnConfiguration
  ) {
    id
    tableKey
    config {
      columns {
        columnKey
        isVisible
        isFixed
      }
    }
  }
}
    `;

/**
 * __useGetUserTablePreferenceQuery__
 *
 * To run a query within a React component, call `useGetUserTablePreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTablePreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTablePreferenceQuery({
 *   variables: {
 *      tableKey: // value for 'tableKey'
 *      defaultTableColumnConfiguration: // value for 'defaultTableColumnConfiguration'
 *   },
 * });
 */
export function useGetUserTablePreferenceQuery(baseOptions: Apollo.QueryHookOptions<GetUserTablePreferenceQueryGQLType, GetUserTablePreferenceQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTablePreferenceQueryGQLType, GetUserTablePreferenceQueryVariablesGQLType>(GetUserTablePreferenceDocumentGQLType, options);
      }
export function useGetUserTablePreferenceLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTablePreferenceQueryGQLType, GetUserTablePreferenceQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTablePreferenceQueryGQLType, GetUserTablePreferenceQueryVariablesGQLType>(GetUserTablePreferenceDocumentGQLType, options);
        }
export type GetUserTablePreferenceQueryHookResult = ReturnType<typeof useGetUserTablePreferenceQuery>;
export type GetUserTablePreferenceLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUserTablePreferenceLazyQueryGQLType>;
export type GetUserTablePreferenceQueryResultGQLType = Apollo.QueryResult<GetUserTablePreferenceQueryGQLType, GetUserTablePreferenceQueryVariablesGQLType>;
export const UpsertUserTablePreferenceDocumentGQLType = gql`
    mutation UpsertUserTablePreference($tablePreference: TablePreferenceInput!, $defaultTableColumnConfiguration: DefaultTableColumnConfigurationInput!) {
  upsertUserTablePreference(
    tablePreference: $tablePreference
    defaultTableColumnConfiguration: $defaultTableColumnConfiguration
  ) {
    id
    tableKey
    config {
      columns {
        columnKey
        isVisible
        isFixed
      }
    }
  }
}
    `;
export type UpsertUserTablePreferenceMutationFnGQLType = Apollo.MutationFunction<UpsertUserTablePreferenceMutationGQLType, UpsertUserTablePreferenceMutationVariablesGQLType>;

/**
 * __useUpsertUserTablePreferenceMutation__
 *
 * To run a mutation, you first call `useUpsertUserTablePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserTablePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserTablePreferenceMutation, { data, loading, error }] = useUpsertUserTablePreferenceMutation({
 *   variables: {
 *      tablePreference: // value for 'tablePreference'
 *      defaultTableColumnConfiguration: // value for 'defaultTableColumnConfiguration'
 *   },
 * });
 */
export function useUpsertUserTablePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserTablePreferenceMutationGQLType, UpsertUserTablePreferenceMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserTablePreferenceMutationGQLType, UpsertUserTablePreferenceMutationVariablesGQLType>(UpsertUserTablePreferenceDocumentGQLType, options);
      }
export type UpsertUserTablePreferenceMutationHookResult = ReturnType<typeof useUpsertUserTablePreferenceMutation>;
export type UpsertUserTablePreferenceMutationResultGQLType = Apollo.MutationResult<UpsertUserTablePreferenceMutationGQLType>;
export type UpsertUserTablePreferenceMutationOptionsGQLType = Apollo.BaseMutationOptions<UpsertUserTablePreferenceMutationGQLType, UpsertUserTablePreferenceMutationVariablesGQLType>;
export const GetUserActiveCreditFacilitiesDocumentGQLType = gql`
    query GetUserActiveCreditFacilities($creditFacilitySlugsToHide: [String!]!) {
  user(creditFacilitySlugsToHide: $creditFacilitySlugsToHide) {
    id
    email
    userType
    isActive
    organizationId
    roleType
    firstName
    lastName
    organization {
      id
      name
      slug
      creditFacilities {
        id
        slug
        name
        latestCreditAgreementId
        implementationId
      }
    }
  }
}
    `;

/**
 * __useGetUserActiveCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetUserActiveCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActiveCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActiveCreditFacilitiesQuery({
 *   variables: {
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetUserActiveCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetUserActiveCreditFacilitiesQueryGQLType, GetUserActiveCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActiveCreditFacilitiesQueryGQLType, GetUserActiveCreditFacilitiesQueryVariablesGQLType>(GetUserActiveCreditFacilitiesDocumentGQLType, options);
      }
export function useGetUserActiveCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActiveCreditFacilitiesQueryGQLType, GetUserActiveCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActiveCreditFacilitiesQueryGQLType, GetUserActiveCreditFacilitiesQueryVariablesGQLType>(GetUserActiveCreditFacilitiesDocumentGQLType, options);
        }
export type GetUserActiveCreditFacilitiesQueryHookResult = ReturnType<typeof useGetUserActiveCreditFacilitiesQuery>;
export type GetUserActiveCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetUserActiveCreditFacilitiesLazyQueryGQLType>;
export type GetUserActiveCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetUserActiveCreditFacilitiesQueryGQLType, GetUserActiveCreditFacilitiesQueryVariablesGQLType>;
export const GetValleyBankArrangementGroupDocumentGQLType = gql`
    query GetValleyBankArrangementGroup($reportingDate: FullDateStr!, $isPreview: Boolean!, $arrangementGroupNumber: String!) {
  valleyBankArrangementGroup(
    reportingDate: $reportingDate
    isPreview: $isPreview
    arrangementGroupNumber: $arrangementGroupNumber
  )
}
    `;

/**
 * __useGetValleyBankArrangementGroupQuery__
 *
 * To run a query within a React component, call `useGetValleyBankArrangementGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankArrangementGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankArrangementGroupQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      arrangementGroupNumber: // value for 'arrangementGroupNumber'
 *   },
 * });
 */
export function useGetValleyBankArrangementGroupQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankArrangementGroupQueryGQLType, GetValleyBankArrangementGroupQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankArrangementGroupQueryGQLType, GetValleyBankArrangementGroupQueryVariablesGQLType>(GetValleyBankArrangementGroupDocumentGQLType, options);
      }
export function useGetValleyBankArrangementGroupLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankArrangementGroupQueryGQLType, GetValleyBankArrangementGroupQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankArrangementGroupQueryGQLType, GetValleyBankArrangementGroupQueryVariablesGQLType>(GetValleyBankArrangementGroupDocumentGQLType, options);
        }
export type GetValleyBankArrangementGroupQueryHookResult = ReturnType<typeof useGetValleyBankArrangementGroupQuery>;
export type GetValleyBankArrangementGroupLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankArrangementGroupLazyQueryGQLType>;
export type GetValleyBankArrangementGroupQueryResultGQLType = Apollo.QueryResult<GetValleyBankArrangementGroupQueryGQLType, GetValleyBankArrangementGroupQueryVariablesGQLType>;
export const GetValleyBankAssignmentDeviationDocumentGQLType = gql`
    query GetValleyBankAssignmentDeviation {
  valleyBankAssignmentDeviations {
    collateralAccountsNoLongerPledged {
      loanAccountNum
      collateralAccountNum
      collateralAccountType
      reportingDate
    }
    collateralAccountsAssignedToNonExistentLoanAccountNum {
      loanAccountNum
      collateralAccountNum
      collateralAccountType
      reportingDate
    }
    collateralAccounts {
      collateralAccountNum
      collateralAccountType
      cifNum
      fullName
      arrangmentGroup
      assignedLoanAccountNums
    }
    reportingDate
  }
}
    `;

/**
 * __useGetValleyBankAssignmentDeviationQuery__
 *
 * To run a query within a React component, call `useGetValleyBankAssignmentDeviationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankAssignmentDeviationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankAssignmentDeviationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetValleyBankAssignmentDeviationQuery(baseOptions?: Apollo.QueryHookOptions<GetValleyBankAssignmentDeviationQueryGQLType, GetValleyBankAssignmentDeviationQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankAssignmentDeviationQueryGQLType, GetValleyBankAssignmentDeviationQueryVariablesGQLType>(GetValleyBankAssignmentDeviationDocumentGQLType, options);
      }
export function useGetValleyBankAssignmentDeviationLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankAssignmentDeviationQueryGQLType, GetValleyBankAssignmentDeviationQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankAssignmentDeviationQueryGQLType, GetValleyBankAssignmentDeviationQueryVariablesGQLType>(GetValleyBankAssignmentDeviationDocumentGQLType, options);
        }
export type GetValleyBankAssignmentDeviationQueryHookResult = ReturnType<typeof useGetValleyBankAssignmentDeviationQuery>;
export type GetValleyBankAssignmentDeviationLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankAssignmentDeviationLazyQueryGQLType>;
export type GetValleyBankAssignmentDeviationQueryResultGQLType = Apollo.QueryResult<GetValleyBankAssignmentDeviationQueryGQLType, GetValleyBankAssignmentDeviationQueryVariablesGQLType>;
export const GetValleyBankAssignmentPreviewRrtDocumentGQLType = gql`
    query GetValleyBankAssignmentPreviewRRT($reportingDate: FullDateStr!, $previewLoanAccountNum: String!, $assignmentsToPreview: [ValleyBankSubmitAssignmentInput!]!) {
  valleyBankAssignmentPreviewRRT(
    reportingDate: $reportingDate
    previewLoanAccountNum: $previewLoanAccountNum
    assignmentsToPreview: $assignmentsToPreview
  )
}
    `;

/**
 * __useGetValleyBankAssignmentPreviewRrtQuery__
 *
 * To run a query within a React component, call `useGetValleyBankAssignmentPreviewRrtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankAssignmentPreviewRrtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankAssignmentPreviewRrtQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      previewLoanAccountNum: // value for 'previewLoanAccountNum'
 *      assignmentsToPreview: // value for 'assignmentsToPreview'
 *   },
 * });
 */
export function useGetValleyBankAssignmentPreviewRrtQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankAssignmentPreviewRrtQueryGQLType, GetValleyBankAssignmentPreviewRrtQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankAssignmentPreviewRrtQueryGQLType, GetValleyBankAssignmentPreviewRrtQueryVariablesGQLType>(GetValleyBankAssignmentPreviewRrtDocumentGQLType, options);
      }
export function useGetValleyBankAssignmentPreviewRrtLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankAssignmentPreviewRrtQueryGQLType, GetValleyBankAssignmentPreviewRrtQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankAssignmentPreviewRrtQueryGQLType, GetValleyBankAssignmentPreviewRrtQueryVariablesGQLType>(GetValleyBankAssignmentPreviewRrtDocumentGQLType, options);
        }
export type GetValleyBankAssignmentPreviewRrtQueryHookResult = ReturnType<typeof useGetValleyBankAssignmentPreviewRrtQuery>;
export type GetValleyBankAssignmentPreviewRrtLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankAssignmentPreviewRrtLazyQueryGQLType>;
export type GetValleyBankAssignmentPreviewRrtQueryResultGQLType = Apollo.QueryResult<GetValleyBankAssignmentPreviewRrtQueryGQLType, GetValleyBankAssignmentPreviewRrtQueryVariablesGQLType>;
export const GetValleyBankAssignmentQueueDocumentGQLType = gql`
    query GetValleyBankAssignmentQueue {
  valleyBankAssignmentQueue {
    id
    created_at
    updated_at
    collateralAccountNumber
    loanAccountNumber
    collateralAccountType
    action
    userId
    userFirstName
    userLastName
  }
}
    `;

/**
 * __useGetValleyBankAssignmentQueueQuery__
 *
 * To run a query within a React component, call `useGetValleyBankAssignmentQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankAssignmentQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankAssignmentQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetValleyBankAssignmentQueueQuery(baseOptions?: Apollo.QueryHookOptions<GetValleyBankAssignmentQueueQueryGQLType, GetValleyBankAssignmentQueueQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankAssignmentQueueQueryGQLType, GetValleyBankAssignmentQueueQueryVariablesGQLType>(GetValleyBankAssignmentQueueDocumentGQLType, options);
      }
export function useGetValleyBankAssignmentQueueLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankAssignmentQueueQueryGQLType, GetValleyBankAssignmentQueueQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankAssignmentQueueQueryGQLType, GetValleyBankAssignmentQueueQueryVariablesGQLType>(GetValleyBankAssignmentQueueDocumentGQLType, options);
        }
export type GetValleyBankAssignmentQueueQueryHookResult = ReturnType<typeof useGetValleyBankAssignmentQueueQuery>;
export type GetValleyBankAssignmentQueueLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankAssignmentQueueLazyQueryGQLType>;
export type GetValleyBankAssignmentQueueQueryResultGQLType = Apollo.QueryResult<GetValleyBankAssignmentQueueQueryGQLType, GetValleyBankAssignmentQueueQueryVariablesGQLType>;
export const GetValleyBankAssignmentEventLogDocumentGQLType = gql`
    query GetValleyBankAssignmentEventLog {
  valleyBankAssignmentEventLog {
    id
    created_at
    updated_at
    collateralAccountNumber
    loanAccountNumber
    collateralAccountType
    action
    userId
    userFirstName
    userLastName
    reportingDate
  }
}
    `;

/**
 * __useGetValleyBankAssignmentEventLogQuery__
 *
 * To run a query within a React component, call `useGetValleyBankAssignmentEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankAssignmentEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankAssignmentEventLogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetValleyBankAssignmentEventLogQuery(baseOptions?: Apollo.QueryHookOptions<GetValleyBankAssignmentEventLogQueryGQLType, GetValleyBankAssignmentEventLogQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankAssignmentEventLogQueryGQLType, GetValleyBankAssignmentEventLogQueryVariablesGQLType>(GetValleyBankAssignmentEventLogDocumentGQLType, options);
      }
export function useGetValleyBankAssignmentEventLogLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankAssignmentEventLogQueryGQLType, GetValleyBankAssignmentEventLogQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankAssignmentEventLogQueryGQLType, GetValleyBankAssignmentEventLogQueryVariablesGQLType>(GetValleyBankAssignmentEventLogDocumentGQLType, options);
        }
export type GetValleyBankAssignmentEventLogQueryHookResult = ReturnType<typeof useGetValleyBankAssignmentEventLogQuery>;
export type GetValleyBankAssignmentEventLogLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankAssignmentEventLogLazyQueryGQLType>;
export type GetValleyBankAssignmentEventLogQueryResultGQLType = Apollo.QueryResult<GetValleyBankAssignmentEventLogQueryGQLType, GetValleyBankAssignmentEventLogQueryVariablesGQLType>;
export const AddToValleyBankAssignmentQueueDocumentGQLType = gql`
    mutation AddToValleyBankAssignmentQueue($records: [ValleyBankAddToAssignmentQueue!]!) {
  valleyBankAddToAssignmentsQueue(records: $records)
}
    `;
export type AddToValleyBankAssignmentQueueMutationFnGQLType = Apollo.MutationFunction<AddToValleyBankAssignmentQueueMutationGQLType, AddToValleyBankAssignmentQueueMutationVariablesGQLType>;

/**
 * __useAddToValleyBankAssignmentQueueMutation__
 *
 * To run a mutation, you first call `useAddToValleyBankAssignmentQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToValleyBankAssignmentQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToValleyBankAssignmentQueueMutation, { data, loading, error }] = useAddToValleyBankAssignmentQueueMutation({
 *   variables: {
 *      records: // value for 'records'
 *   },
 * });
 */
export function useAddToValleyBankAssignmentQueueMutation(baseOptions?: Apollo.MutationHookOptions<AddToValleyBankAssignmentQueueMutationGQLType, AddToValleyBankAssignmentQueueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToValleyBankAssignmentQueueMutationGQLType, AddToValleyBankAssignmentQueueMutationVariablesGQLType>(AddToValleyBankAssignmentQueueDocumentGQLType, options);
      }
export type AddToValleyBankAssignmentQueueMutationHookResult = ReturnType<typeof useAddToValleyBankAssignmentQueueMutation>;
export type AddToValleyBankAssignmentQueueMutationResultGQLType = Apollo.MutationResult<AddToValleyBankAssignmentQueueMutationGQLType>;
export type AddToValleyBankAssignmentQueueMutationOptionsGQLType = Apollo.BaseMutationOptions<AddToValleyBankAssignmentQueueMutationGQLType, AddToValleyBankAssignmentQueueMutationVariablesGQLType>;
export const DeleteFromValleyBankAssignmentQueueDocumentGQLType = gql`
    mutation DeleteFromValleyBankAssignmentQueue($assignmentQueueId: String!) {
  valleyBankDeleteFromAssignmentQueue(assignmentQueueId: $assignmentQueueId)
}
    `;
export type DeleteFromValleyBankAssignmentQueueMutationFnGQLType = Apollo.MutationFunction<DeleteFromValleyBankAssignmentQueueMutationGQLType, DeleteFromValleyBankAssignmentQueueMutationVariablesGQLType>;

/**
 * __useDeleteFromValleyBankAssignmentQueueMutation__
 *
 * To run a mutation, you first call `useDeleteFromValleyBankAssignmentQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromValleyBankAssignmentQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromValleyBankAssignmentQueueMutation, { data, loading, error }] = useDeleteFromValleyBankAssignmentQueueMutation({
 *   variables: {
 *      assignmentQueueId: // value for 'assignmentQueueId'
 *   },
 * });
 */
export function useDeleteFromValleyBankAssignmentQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFromValleyBankAssignmentQueueMutationGQLType, DeleteFromValleyBankAssignmentQueueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFromValleyBankAssignmentQueueMutationGQLType, DeleteFromValleyBankAssignmentQueueMutationVariablesGQLType>(DeleteFromValleyBankAssignmentQueueDocumentGQLType, options);
      }
export type DeleteFromValleyBankAssignmentQueueMutationHookResult = ReturnType<typeof useDeleteFromValleyBankAssignmentQueueMutation>;
export type DeleteFromValleyBankAssignmentQueueMutationResultGQLType = Apollo.MutationResult<DeleteFromValleyBankAssignmentQueueMutationGQLType>;
export type DeleteFromValleyBankAssignmentQueueMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteFromValleyBankAssignmentQueueMutationGQLType, DeleteFromValleyBankAssignmentQueueMutationVariablesGQLType>;
export const SubmitValleyBankAssignmentQueueDocumentGQLType = gql`
    mutation SubmitValleyBankAssignmentQueue {
  submitValleyBankAssignmentQueue
}
    `;
export type SubmitValleyBankAssignmentQueueMutationFnGQLType = Apollo.MutationFunction<SubmitValleyBankAssignmentQueueMutationGQLType, SubmitValleyBankAssignmentQueueMutationVariablesGQLType>;

/**
 * __useSubmitValleyBankAssignmentQueueMutation__
 *
 * To run a mutation, you first call `useSubmitValleyBankAssignmentQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitValleyBankAssignmentQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitValleyBankAssignmentQueueMutation, { data, loading, error }] = useSubmitValleyBankAssignmentQueueMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitValleyBankAssignmentQueueMutation(baseOptions?: Apollo.MutationHookOptions<SubmitValleyBankAssignmentQueueMutationGQLType, SubmitValleyBankAssignmentQueueMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitValleyBankAssignmentQueueMutationGQLType, SubmitValleyBankAssignmentQueueMutationVariablesGQLType>(SubmitValleyBankAssignmentQueueDocumentGQLType, options);
      }
export type SubmitValleyBankAssignmentQueueMutationHookResult = ReturnType<typeof useSubmitValleyBankAssignmentQueueMutation>;
export type SubmitValleyBankAssignmentQueueMutationResultGQLType = Apollo.MutationResult<SubmitValleyBankAssignmentQueueMutationGQLType>;
export type SubmitValleyBankAssignmentQueueMutationOptionsGQLType = Apollo.BaseMutationOptions<SubmitValleyBankAssignmentQueueMutationGQLType, SubmitValleyBankAssignmentQueueMutationVariablesGQLType>;
export const GetValleyBankCreditFacilityLoanProductMechanicsDocumentGQLType = gql`
    query GetValleyBankCreditFacilityLoanProductMechanics($isWip: Boolean) {
  user {
    id
    organization {
      id
      creditFacilities {
        id
        slug
        borrowingBaseMechanicsForLoanProducts(isWip: $isWip) {
          loanProductId
          loanProductName
          baseFields
          intermediateFields
        }
      }
    }
  }
}
    `;

/**
 * __useGetValleyBankCreditFacilityLoanProductMechanicsQuery__
 *
 * To run a query within a React component, call `useGetValleyBankCreditFacilityLoanProductMechanicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankCreditFacilityLoanProductMechanicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankCreditFacilityLoanProductMechanicsQuery({
 *   variables: {
 *      isWip: // value for 'isWip'
 *   },
 * });
 */
export function useGetValleyBankCreditFacilityLoanProductMechanicsQuery(baseOptions?: Apollo.QueryHookOptions<GetValleyBankCreditFacilityLoanProductMechanicsQueryGQLType, GetValleyBankCreditFacilityLoanProductMechanicsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankCreditFacilityLoanProductMechanicsQueryGQLType, GetValleyBankCreditFacilityLoanProductMechanicsQueryVariablesGQLType>(GetValleyBankCreditFacilityLoanProductMechanicsDocumentGQLType, options);
      }
export function useGetValleyBankCreditFacilityLoanProductMechanicsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankCreditFacilityLoanProductMechanicsQueryGQLType, GetValleyBankCreditFacilityLoanProductMechanicsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankCreditFacilityLoanProductMechanicsQueryGQLType, GetValleyBankCreditFacilityLoanProductMechanicsQueryVariablesGQLType>(GetValleyBankCreditFacilityLoanProductMechanicsDocumentGQLType, options);
        }
export type GetValleyBankCreditFacilityLoanProductMechanicsQueryHookResult = ReturnType<typeof useGetValleyBankCreditFacilityLoanProductMechanicsQuery>;
export type GetValleyBankCreditFacilityLoanProductMechanicsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankCreditFacilityLoanProductMechanicsLazyQueryGQLType>;
export type GetValleyBankCreditFacilityLoanProductMechanicsQueryResultGQLType = Apollo.QueryResult<GetValleyBankCreditFacilityLoanProductMechanicsQueryGQLType, GetValleyBankCreditFacilityLoanProductMechanicsQueryVariablesGQLType>;
export const GetValleyBankCustomersDocumentGQLType = gql`
    query GetValleyBankCustomers($reportingDate: FullDateStr!, $isPreview: Boolean!, $paginationOptions: PaginationOptions!, $queryParams: ValleyBankCustomerQueryParams) {
  valleyBankCustomers(
    reportingDate: $reportingDate
    isPreview: $isPreview
    paginationOptions: $paginationOptions
    queryParams: $queryParams
  ) {
    customers
    paginationInfo {
      totalCount
      limit
      offset
    }
  }
}
    `;

/**
 * __useGetValleyBankCustomersQuery__
 *
 * To run a query within a React component, call `useGetValleyBankCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankCustomersQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      paginationOptions: // value for 'paginationOptions'
 *      queryParams: // value for 'queryParams'
 *   },
 * });
 */
export function useGetValleyBankCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankCustomersQueryGQLType, GetValleyBankCustomersQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankCustomersQueryGQLType, GetValleyBankCustomersQueryVariablesGQLType>(GetValleyBankCustomersDocumentGQLType, options);
      }
export function useGetValleyBankCustomersLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankCustomersQueryGQLType, GetValleyBankCustomersQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankCustomersQueryGQLType, GetValleyBankCustomersQueryVariablesGQLType>(GetValleyBankCustomersDocumentGQLType, options);
        }
export type GetValleyBankCustomersQueryHookResult = ReturnType<typeof useGetValleyBankCustomersQuery>;
export type GetValleyBankCustomersLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankCustomersLazyQueryGQLType>;
export type GetValleyBankCustomersQueryResultGQLType = Apollo.QueryResult<GetValleyBankCustomersQueryGQLType, GetValleyBankCustomersQueryVariablesGQLType>;
export const GetValleyBankCustomerDocumentGQLType = gql`
    query GetValleyBankCustomer($reportingDate: FullDateStr!, $isPreview: Boolean!, $cifNumber: String!) {
  valleyBankCustomer(
    reportingDate: $reportingDate
    cifNumber: $cifNumber
    isPreview: $isPreview
  ) {
    customer
  }
}
    `;

/**
 * __useGetValleyBankCustomerQuery__
 *
 * To run a query within a React component, call `useGetValleyBankCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankCustomerQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      cifNumber: // value for 'cifNumber'
 *   },
 * });
 */
export function useGetValleyBankCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankCustomerQueryGQLType, GetValleyBankCustomerQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankCustomerQueryGQLType, GetValleyBankCustomerQueryVariablesGQLType>(GetValleyBankCustomerDocumentGQLType, options);
      }
export function useGetValleyBankCustomerLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankCustomerQueryGQLType, GetValleyBankCustomerQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankCustomerQueryGQLType, GetValleyBankCustomerQueryVariablesGQLType>(GetValleyBankCustomerDocumentGQLType, options);
        }
export type GetValleyBankCustomerQueryHookResult = ReturnType<typeof useGetValleyBankCustomerQuery>;
export type GetValleyBankCustomerLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankCustomerLazyQueryGQLType>;
export type GetValleyBankCustomerQueryResultGQLType = Apollo.QueryResult<GetValleyBankCustomerQueryGQLType, GetValleyBankCustomerQueryVariablesGQLType>;
export const GetAllValleyBankLoanAccountsDocumentGQLType = gql`
    query GetAllValleyBankLoanAccounts($reportingDate: FullDateStr!, $isPreview: Boolean!, $paginationOptions: PaginationOptions!, $queryParams: ValleyBankLoanAccountQueryParams, $orderByParam: ValleyBankLoanAccountOrderByParam) {
  allValleyBankLoanAccounts(
    reportingDate: $reportingDate
    isPreview: $isPreview
    paginationOptions: $paginationOptions
    queryParams: $queryParams
    orderByParam: $orderByParam
  ) {
    loanAccounts
    paginationInfo {
      totalCount
      limit
      offset
    }
  }
}
    `;

/**
 * __useGetAllValleyBankLoanAccountsQuery__
 *
 * To run a query within a React component, call `useGetAllValleyBankLoanAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllValleyBankLoanAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllValleyBankLoanAccountsQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      paginationOptions: // value for 'paginationOptions'
 *      queryParams: // value for 'queryParams'
 *      orderByParam: // value for 'orderByParam'
 *   },
 * });
 */
export function useGetAllValleyBankLoanAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetAllValleyBankLoanAccountsQueryGQLType, GetAllValleyBankLoanAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllValleyBankLoanAccountsQueryGQLType, GetAllValleyBankLoanAccountsQueryVariablesGQLType>(GetAllValleyBankLoanAccountsDocumentGQLType, options);
      }
export function useGetAllValleyBankLoanAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllValleyBankLoanAccountsQueryGQLType, GetAllValleyBankLoanAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllValleyBankLoanAccountsQueryGQLType, GetAllValleyBankLoanAccountsQueryVariablesGQLType>(GetAllValleyBankLoanAccountsDocumentGQLType, options);
        }
export type GetAllValleyBankLoanAccountsQueryHookResult = ReturnType<typeof useGetAllValleyBankLoanAccountsQuery>;
export type GetAllValleyBankLoanAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllValleyBankLoanAccountsLazyQueryGQLType>;
export type GetAllValleyBankLoanAccountsQueryResultGQLType = Apollo.QueryResult<GetAllValleyBankLoanAccountsQueryGQLType, GetAllValleyBankLoanAccountsQueryVariablesGQLType>;
export const GetValleyBankLoanAccountDocumentGQLType = gql`
    query GetValleyBankLoanAccount($reportingDate: FullDateStr!, $isPreview: Boolean!, $loanAccountNumber: String!, $selectedFinleyReceivableIds: [String!]) {
  valleyBankLoanAccount(
    reportingDate: $reportingDate
    isPreview: $isPreview
    loanAccountNumber: $loanAccountNumber
    selectedFinleyReceivableIds: $selectedFinleyReceivableIds
  ) {
    loanAccount
  }
}
    `;

/**
 * __useGetValleyBankLoanAccountQuery__
 *
 * To run a query within a React component, call `useGetValleyBankLoanAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankLoanAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankLoanAccountQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      loanAccountNumber: // value for 'loanAccountNumber'
 *      selectedFinleyReceivableIds: // value for 'selectedFinleyReceivableIds'
 *   },
 * });
 */
export function useGetValleyBankLoanAccountQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankLoanAccountQueryGQLType, GetValleyBankLoanAccountQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankLoanAccountQueryGQLType, GetValleyBankLoanAccountQueryVariablesGQLType>(GetValleyBankLoanAccountDocumentGQLType, options);
      }
export function useGetValleyBankLoanAccountLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankLoanAccountQueryGQLType, GetValleyBankLoanAccountQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankLoanAccountQueryGQLType, GetValleyBankLoanAccountQueryVariablesGQLType>(GetValleyBankLoanAccountDocumentGQLType, options);
        }
export type GetValleyBankLoanAccountQueryHookResult = ReturnType<typeof useGetValleyBankLoanAccountQuery>;
export type GetValleyBankLoanAccountLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankLoanAccountLazyQueryGQLType>;
export type GetValleyBankLoanAccountQueryResultGQLType = Apollo.QueryResult<GetValleyBankLoanAccountQueryGQLType, GetValleyBankLoanAccountQueryVariablesGQLType>;
export const GetValleyBankLatestPinnedCommentForLoanAccountsDocumentGQLType = gql`
    query GetValleyBankLatestPinnedCommentForLoanAccounts($loanAccountNums: [String!]!, $reportingDate: FullDateStr!, $isHistorical: Boolean!) {
  valleyBankLatestPinnedCommentForLoanAccounts(
    loanAccountNums: $loanAccountNums
    reportingDate: $reportingDate
    isHistorical: $isHistorical
  ) {
    loanAccountNum
    pinnedComment {
      ...CommentFragment
    }
  }
}
    ${CommentFragmentFragmentDocGQLType}`;

/**
 * __useGetValleyBankLatestPinnedCommentForLoanAccountsQuery__
 *
 * To run a query within a React component, call `useGetValleyBankLatestPinnedCommentForLoanAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankLatestPinnedCommentForLoanAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankLatestPinnedCommentForLoanAccountsQuery({
 *   variables: {
 *      loanAccountNums: // value for 'loanAccountNums'
 *      reportingDate: // value for 'reportingDate'
 *      isHistorical: // value for 'isHistorical'
 *   },
 * });
 */
export function useGetValleyBankLatestPinnedCommentForLoanAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankLatestPinnedCommentForLoanAccountsQueryGQLType, GetValleyBankLatestPinnedCommentForLoanAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankLatestPinnedCommentForLoanAccountsQueryGQLType, GetValleyBankLatestPinnedCommentForLoanAccountsQueryVariablesGQLType>(GetValleyBankLatestPinnedCommentForLoanAccountsDocumentGQLType, options);
      }
export function useGetValleyBankLatestPinnedCommentForLoanAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankLatestPinnedCommentForLoanAccountsQueryGQLType, GetValleyBankLatestPinnedCommentForLoanAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankLatestPinnedCommentForLoanAccountsQueryGQLType, GetValleyBankLatestPinnedCommentForLoanAccountsQueryVariablesGQLType>(GetValleyBankLatestPinnedCommentForLoanAccountsDocumentGQLType, options);
        }
export type GetValleyBankLatestPinnedCommentForLoanAccountsQueryHookResult = ReturnType<typeof useGetValleyBankLatestPinnedCommentForLoanAccountsQuery>;
export type GetValleyBankLatestPinnedCommentForLoanAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankLatestPinnedCommentForLoanAccountsLazyQueryGQLType>;
export type GetValleyBankLatestPinnedCommentForLoanAccountsQueryResultGQLType = Apollo.QueryResult<GetValleyBankLatestPinnedCommentForLoanAccountsQueryGQLType, GetValleyBankLatestPinnedCommentForLoanAccountsQueryVariablesGQLType>;
export const GetValleyBankLoanAccountsByCifNumsDocumentGQLType = gql`
    query GetValleyBankLoanAccountsByCifNums($reportingDate: FullDateStr!, $isPreview: Boolean!, $cifNums: [String!]!) {
  valleyBankLoanAccountsByCifNums(
    reportingDate: $reportingDate
    isPreview: $isPreview
    cifNums: $cifNums
  )
}
    `;

/**
 * __useGetValleyBankLoanAccountsByCifNumsQuery__
 *
 * To run a query within a React component, call `useGetValleyBankLoanAccountsByCifNumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankLoanAccountsByCifNumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankLoanAccountsByCifNumsQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      cifNums: // value for 'cifNums'
 *   },
 * });
 */
export function useGetValleyBankLoanAccountsByCifNumsQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankLoanAccountsByCifNumsQueryGQLType, GetValleyBankLoanAccountsByCifNumsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankLoanAccountsByCifNumsQueryGQLType, GetValleyBankLoanAccountsByCifNumsQueryVariablesGQLType>(GetValleyBankLoanAccountsByCifNumsDocumentGQLType, options);
      }
export function useGetValleyBankLoanAccountsByCifNumsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankLoanAccountsByCifNumsQueryGQLType, GetValleyBankLoanAccountsByCifNumsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankLoanAccountsByCifNumsQueryGQLType, GetValleyBankLoanAccountsByCifNumsQueryVariablesGQLType>(GetValleyBankLoanAccountsByCifNumsDocumentGQLType, options);
        }
export type GetValleyBankLoanAccountsByCifNumsQueryHookResult = ReturnType<typeof useGetValleyBankLoanAccountsByCifNumsQuery>;
export type GetValleyBankLoanAccountsByCifNumsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankLoanAccountsByCifNumsLazyQueryGQLType>;
export type GetValleyBankLoanAccountsByCifNumsQueryResultGQLType = Apollo.QueryResult<GetValleyBankLoanAccountsByCifNumsQueryGQLType, GetValleyBankLoanAccountsByCifNumsQueryVariablesGQLType>;
export const GetValleyBankAssociatedLoanAccountsByCifNumsDocumentGQLType = gql`
    query GetValleyBankAssociatedLoanAccountsByCifNums($reportingDate: FullDateStr!, $isPreview: Boolean!, $cifNums: [String!]!) {
  valleyBankAssociatedLoanAccountsByCifNums(
    reportingDate: $reportingDate
    isPreview: $isPreview
    cifNums: $cifNums
  )
}
    `;

/**
 * __useGetValleyBankAssociatedLoanAccountsByCifNumsQuery__
 *
 * To run a query within a React component, call `useGetValleyBankAssociatedLoanAccountsByCifNumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankAssociatedLoanAccountsByCifNumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankAssociatedLoanAccountsByCifNumsQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      cifNums: // value for 'cifNums'
 *   },
 * });
 */
export function useGetValleyBankAssociatedLoanAccountsByCifNumsQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankAssociatedLoanAccountsByCifNumsQueryGQLType, GetValleyBankAssociatedLoanAccountsByCifNumsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankAssociatedLoanAccountsByCifNumsQueryGQLType, GetValleyBankAssociatedLoanAccountsByCifNumsQueryVariablesGQLType>(GetValleyBankAssociatedLoanAccountsByCifNumsDocumentGQLType, options);
      }
export function useGetValleyBankAssociatedLoanAccountsByCifNumsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankAssociatedLoanAccountsByCifNumsQueryGQLType, GetValleyBankAssociatedLoanAccountsByCifNumsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankAssociatedLoanAccountsByCifNumsQueryGQLType, GetValleyBankAssociatedLoanAccountsByCifNumsQueryVariablesGQLType>(GetValleyBankAssociatedLoanAccountsByCifNumsDocumentGQLType, options);
        }
export type GetValleyBankAssociatedLoanAccountsByCifNumsQueryHookResult = ReturnType<typeof useGetValleyBankAssociatedLoanAccountsByCifNumsQuery>;
export type GetValleyBankAssociatedLoanAccountsByCifNumsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankAssociatedLoanAccountsByCifNumsLazyQueryGQLType>;
export type GetValleyBankAssociatedLoanAccountsByCifNumsQueryResultGQLType = Apollo.QueryResult<GetValleyBankAssociatedLoanAccountsByCifNumsQueryGQLType, GetValleyBankAssociatedLoanAccountsByCifNumsQueryVariablesGQLType>;
export const GetValleyBankLoanAccountsByAccountNumsDocumentGQLType = gql`
    query GetValleyBankLoanAccountsByAccountNums($reportingDate: FullDateStr!, $isPreview: Boolean!, $loanAccountNumbers: [String!]!) {
  valleyBankLoanAccountByAccountNums(
    reportingDate: $reportingDate
    isPreview: $isPreview
    loanAccountNumbers: $loanAccountNumbers
  )
}
    `;

/**
 * __useGetValleyBankLoanAccountsByAccountNumsQuery__
 *
 * To run a query within a React component, call `useGetValleyBankLoanAccountsByAccountNumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankLoanAccountsByAccountNumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankLoanAccountsByAccountNumsQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *      loanAccountNumbers: // value for 'loanAccountNumbers'
 *   },
 * });
 */
export function useGetValleyBankLoanAccountsByAccountNumsQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankLoanAccountsByAccountNumsQueryGQLType, GetValleyBankLoanAccountsByAccountNumsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankLoanAccountsByAccountNumsQueryGQLType, GetValleyBankLoanAccountsByAccountNumsQueryVariablesGQLType>(GetValleyBankLoanAccountsByAccountNumsDocumentGQLType, options);
      }
export function useGetValleyBankLoanAccountsByAccountNumsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankLoanAccountsByAccountNumsQueryGQLType, GetValleyBankLoanAccountsByAccountNumsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankLoanAccountsByAccountNumsQueryGQLType, GetValleyBankLoanAccountsByAccountNumsQueryVariablesGQLType>(GetValleyBankLoanAccountsByAccountNumsDocumentGQLType, options);
        }
export type GetValleyBankLoanAccountsByAccountNumsQueryHookResult = ReturnType<typeof useGetValleyBankLoanAccountsByAccountNumsQuery>;
export type GetValleyBankLoanAccountsByAccountNumsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankLoanAccountsByAccountNumsLazyQueryGQLType>;
export type GetValleyBankLoanAccountsByAccountNumsQueryResultGQLType = Apollo.QueryResult<GetValleyBankLoanAccountsByAccountNumsQueryGQLType, GetValleyBankLoanAccountsByAccountNumsQueryVariablesGQLType>;
export const GetValleyBankUnderMarginLoanAccountsDocumentGQLType = gql`
    query GetValleyBankUnderMarginLoanAccounts($reportingDate: FullDateStr!, $isPreview: Boolean!) {
  valleyBankUnderMarginLoanAccounts(
    reportingDate: $reportingDate
    isPreview: $isPreview
  )
}
    `;

/**
 * __useGetValleyBankUnderMarginLoanAccountsQuery__
 *
 * To run a query within a React component, call `useGetValleyBankUnderMarginLoanAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankUnderMarginLoanAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankUnderMarginLoanAccountsQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *   },
 * });
 */
export function useGetValleyBankUnderMarginLoanAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankUnderMarginLoanAccountsQueryGQLType, GetValleyBankUnderMarginLoanAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankUnderMarginLoanAccountsQueryGQLType, GetValleyBankUnderMarginLoanAccountsQueryVariablesGQLType>(GetValleyBankUnderMarginLoanAccountsDocumentGQLType, options);
      }
export function useGetValleyBankUnderMarginLoanAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankUnderMarginLoanAccountsQueryGQLType, GetValleyBankUnderMarginLoanAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankUnderMarginLoanAccountsQueryGQLType, GetValleyBankUnderMarginLoanAccountsQueryVariablesGQLType>(GetValleyBankUnderMarginLoanAccountsDocumentGQLType, options);
        }
export type GetValleyBankUnderMarginLoanAccountsQueryHookResult = ReturnType<typeof useGetValleyBankUnderMarginLoanAccountsQuery>;
export type GetValleyBankUnderMarginLoanAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankUnderMarginLoanAccountsLazyQueryGQLType>;
export type GetValleyBankUnderMarginLoanAccountsQueryResultGQLType = Apollo.QueryResult<GetValleyBankUnderMarginLoanAccountsQueryGQLType, GetValleyBankUnderMarginLoanAccountsQueryVariablesGQLType>;
export const GetValleyBankPipelineStatusMetadataDocumentGQLType = gql`
    query GetValleyBankPipelineStatusMetadata($reportingDate: FullDateStr!, $isPreview: Boolean!) {
  valleyBankPipelineStatusMetadata(
    reportingDate: $reportingDate
    isPreview: $isPreview
  )
}
    `;

/**
 * __useGetValleyBankPipelineStatusMetadataQuery__
 *
 * To run a query within a React component, call `useGetValleyBankPipelineStatusMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankPipelineStatusMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankPipelineStatusMetadataQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *   },
 * });
 */
export function useGetValleyBankPipelineStatusMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankPipelineStatusMetadataQueryGQLType, GetValleyBankPipelineStatusMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankPipelineStatusMetadataQueryGQLType, GetValleyBankPipelineStatusMetadataQueryVariablesGQLType>(GetValleyBankPipelineStatusMetadataDocumentGQLType, options);
      }
export function useGetValleyBankPipelineStatusMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankPipelineStatusMetadataQueryGQLType, GetValleyBankPipelineStatusMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankPipelineStatusMetadataQueryGQLType, GetValleyBankPipelineStatusMetadataQueryVariablesGQLType>(GetValleyBankPipelineStatusMetadataDocumentGQLType, options);
        }
export type GetValleyBankPipelineStatusMetadataQueryHookResult = ReturnType<typeof useGetValleyBankPipelineStatusMetadataQuery>;
export type GetValleyBankPipelineStatusMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankPipelineStatusMetadataLazyQueryGQLType>;
export type GetValleyBankPipelineStatusMetadataQueryResultGQLType = Apollo.QueryResult<GetValleyBankPipelineStatusMetadataQueryGQLType, GetValleyBankPipelineStatusMetadataQueryVariablesGQLType>;
export const GetValleyBankDownloadLinksDocumentGQLType = gql`
    query GetValleyBankDownloadLinks($reportingDate: FullDateStr!, $isPreview: Boolean!) {
  valleyBankDownloadLinks(reportingDate: $reportingDate, isPreview: $isPreview) {
    ingestionLogs {
      url
      filename
    }
    collateralAssignments {
      url
      filename
    }
    securitiesExtendedResponseTape {
      url
      filename
    }
    depositsExtendedResponseTape {
      url
      filename
    }
    loanAccountDetails {
      url
      filename
    }
  }
}
    `;

/**
 * __useGetValleyBankDownloadLinksQuery__
 *
 * To run a query within a React component, call `useGetValleyBankDownloadLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValleyBankDownloadLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValleyBankDownloadLinksQuery({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *      isPreview: // value for 'isPreview'
 *   },
 * });
 */
export function useGetValleyBankDownloadLinksQuery(baseOptions: Apollo.QueryHookOptions<GetValleyBankDownloadLinksQueryGQLType, GetValleyBankDownloadLinksQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValleyBankDownloadLinksQueryGQLType, GetValleyBankDownloadLinksQueryVariablesGQLType>(GetValleyBankDownloadLinksDocumentGQLType, options);
      }
export function useGetValleyBankDownloadLinksLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetValleyBankDownloadLinksQueryGQLType, GetValleyBankDownloadLinksQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValleyBankDownloadLinksQueryGQLType, GetValleyBankDownloadLinksQueryVariablesGQLType>(GetValleyBankDownloadLinksDocumentGQLType, options);
        }
export type GetValleyBankDownloadLinksQueryHookResult = ReturnType<typeof useGetValleyBankDownloadLinksQuery>;
export type GetValleyBankDownloadLinksLazyQueryGQLTypeHookResult = ReturnType<typeof useGetValleyBankDownloadLinksLazyQueryGQLType>;
export type GetValleyBankDownloadLinksQueryResultGQLType = Apollo.QueryResult<GetValleyBankDownloadLinksQueryGQLType, GetValleyBankDownloadLinksQueryVariablesGQLType>;
export const RestoreValleyBankReportingDateDocumentGQLType = gql`
    mutation RestoreValleyBankReportingDate($reportingDate: FullDateStr!) {
  restoreValleyBankReportingDate(reportingDate: $reportingDate)
}
    `;
export type RestoreValleyBankReportingDateMutationFnGQLType = Apollo.MutationFunction<RestoreValleyBankReportingDateMutationGQLType, RestoreValleyBankReportingDateMutationVariablesGQLType>;

/**
 * __useRestoreValleyBankReportingDateMutation__
 *
 * To run a mutation, you first call `useRestoreValleyBankReportingDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreValleyBankReportingDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreValleyBankReportingDateMutation, { data, loading, error }] = useRestoreValleyBankReportingDateMutation({
 *   variables: {
 *      reportingDate: // value for 'reportingDate'
 *   },
 * });
 */
export function useRestoreValleyBankReportingDateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreValleyBankReportingDateMutationGQLType, RestoreValleyBankReportingDateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreValleyBankReportingDateMutationGQLType, RestoreValleyBankReportingDateMutationVariablesGQLType>(RestoreValleyBankReportingDateDocumentGQLType, options);
      }
export type RestoreValleyBankReportingDateMutationHookResult = ReturnType<typeof useRestoreValleyBankReportingDateMutation>;
export type RestoreValleyBankReportingDateMutationResultGQLType = Apollo.MutationResult<RestoreValleyBankReportingDateMutationGQLType>;
export type RestoreValleyBankReportingDateMutationOptionsGQLType = Apollo.BaseMutationOptions<RestoreValleyBankReportingDateMutationGQLType, RestoreValleyBankReportingDateMutationVariablesGQLType>;